var OA = Object.defineProperty;
var wA = (e, t, r) => t in e ? OA(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var $ = (e, t, r) => wA(e, typeof t != "symbol" ? t + "" : t, r);
import { useFlags as NA } from "launchdarkly-react-client-sdk";
const Jz = {
  request: {
    status: 400,
    error: {
      name: "Request Error",
      message: "There was something wrong with the request that you made."
    }
  },
  notFound: {
    status: 404,
    error: {
      name: "Not Found Error",
      message: "The resource you requested was not found."
    }
  },
  data: {
    status: 500,
    error: {
      name: "Data Error",
      message: "Our apologies, there was a problem with retrieving the data."
    }
  },
  config: {
    status: 500,
    error: {
      name: "Config Error",
      message: "The system is not configured as expected."
    }
  },
  root: {
    status: 400,
    error: {
      name: "Root User Error",
      message: "You are logged in as a root user, but are trying to use a feature that does not work for root accounts."
    }
  },
  general: {
    status: 500,
    error: {
      name: "General Error",
      message: "Our apologies, we encountered an error when trying to fulfill your request."
    }
  }
};
function Ru(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, i]) => t.indexOf(+n) === -1).map(([n, i]) => i);
}
function cf(e, t = "|") {
  return e.map((r) => sg(r)).join(t);
}
function Ou(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
class CA {
  constructor(t) {
    this._getter = t, this._value = void 0;
  }
  get value() {
    const t = this._getter;
    return t !== void 0 && (this._value = t(), this._getter = void 0), this._value;
  }
}
function Js(e) {
  return new CA(e);
}
function tg(e) {
  return e == null;
}
function bl(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function rg(e, t) {
  const r = e / t, n = Math.round(r), i = 4 * Number.EPSILON * Math.max(Math.abs(r), 1);
  return Math.abs(r - n) < i ? 0 : r - n;
}
function kr(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Al(e) {
  const t = Object.getOwnPropertyDescriptor(e, "shape");
  return t != null && t.get ? t.get.raw : t == null ? void 0 : t.value;
}
function Dr(e) {
  return Al(e._zod.def) ?? e._zod.def.shape;
}
function ng(e, t, r) {
  Object.defineProperty(e, t, {
    get() {
      const n = r();
      return kr(this, t, n), n;
    },
    enumerable: !0,
    configurable: !0
  });
}
function ig(e, t, r) {
  t in e ? kr(e, t, r) : e[t] = r;
}
function xn(e, t, r, n) {
  const i = Dr(t);
  for (const o of r) {
    const s = Object.getOwnPropertyDescriptor(i, o);
    s.enumerable && (s.get ? ng(e, o, () => {
      const a = t._zod.def.shape[o];
      return n ? n(a, o) : a;
    }) : ig(e, o, n ? n(s.value, o) : s.value));
  }
}
function PA(e, t) {
  for (const r of Reflect.ownKeys(t)) {
    const n = Object.getOwnPropertyDescriptor(t, r);
    n.enumerable && (n.get ? ng(e, r, () => t[r]) : ig(e, r, n.value));
  }
}
function Mt(...e) {
  const t = {};
  for (const r of e) {
    const n = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, n);
  }
  return Object.defineProperties({}, t);
}
function Ut(e) {
  return JSON.stringify(e);
}
function DA(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const og = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Lo(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const MA = /* @__PURE__ */ Js(() => {
  var e;
  if (vt.jitless || typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function kn(e) {
  if (Lo(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const r = t.prototype;
  return !(Lo(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function vl(e) {
  return kn(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
const wu = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function hi(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function jr(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r != null && r.parent) && (n._zod.parent = e), n;
}
function se(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function sg(e) {
  return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function LA(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin !== void 0 && e[t]._zod.optout === "optional");
}
const ag = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
}, xA = {
  int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
  uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
};
function kA(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const o = {};
  return xn(o, e, Ks(e, t)), jr(e, Mt(r, { shape: o, checks: [] }));
}
function Ks(e, t) {
  var i;
  const r = Dr(e), n = [];
  for (const o of Reflect.ownKeys(t)) {
    if (!((i = Object.getOwnPropertyDescriptor(r, o)) != null && i.enumerable))
      throw new Error(`Unrecognized key: "${String(o)}"`);
    t[o] && n.push(o);
  }
  return n;
}
function jA(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const o = new Set(Ks(e, t)), s = {};
  return xn(s, e, Reflect.ownKeys(Dr(e)).filter((a) => !o.has(a))), jr(e, Mt(r, { shape: s, checks: [] }));
}
function UA(e, t) {
  if (!kn(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0) {
    const i = Dr(e);
    for (const o of Reflect.ownKeys(t))
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  return jr(e, Mt(e._zod.def, { shape: ug(e, t) }));
}
function ug(e, t) {
  const r = {};
  return xn(r, e, Reflect.ownKeys(Dr(e))), PA(r, t), r;
}
function $A(e, t) {
  if (!kn(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  return jr(e, Mt(e._zod.def, { shape: ug(e, t) }));
}
function FA(e, t) {
  var i, o;
  if (!((i = t == null ? void 0 : t._zod) != null && i.def))
    throw new Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
  if ((o = e._zod.def.checks) != null && o.length)
    throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
  const r = {};
  xn(r, e, Reflect.ownKeys(Dr(e))), xn(r, t, Reflect.ownKeys(Dr(t)));
  const n = Mt(e._zod.def, {
    shape: r,
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: t._zod.def.checks ?? []
  });
  return jr(e, n);
}
function ff(e, t, r, n = "partial") {
  const o = t._zod.def.checks;
  if (o && o.length > 0)
    throw new Error(`.${n}() cannot be used on object schemas containing refinements`);
  const a = r ? new Set(Ks(t, r)) : void 0, l = {};
  return xn(l, t, Reflect.ownKeys(Dr(t)), e && ((f, u) => a && !a.has(u) ? f : new e({ type: "optional", innerType: f }))), jr(t, Mt(t._zod.def, { shape: l, checks: [] }));
}
function zA(e, t, r) {
  const n = r ? new Set(Ks(t, r)) : void 0, i = {};
  return xn(i, t, Reflect.ownKeys(Dr(t)), (o, s) => (
    // overwrite with non-optional
    n && !n.has(s) ? o : new e({ type: "nonoptional", innerType: o })
  )), jr(t, Mt(t._zod.def, { shape: i }));
}
function jt(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function GA(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) === !1)
      return !0;
  return !1;
}
function ir(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function Di(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function Nu(e) {
  const t = [];
  for (const r of e ?? []) {
    const n = r._zod.def;
    if (!/_(length|size)$|_equals$/.test(n.check))
      break;
    const i = n.maximum ?? n.length ?? n.size;
    i >= 0 && t.push([i, r]);
  }
  return t;
}
function Cu(e, t, r) {
  var n;
  for (let i = t; i < e.length; i++)
    (n = e[i]).schema ?? (n.schema = r);
}
function sr(e, t, r) {
  var l, f, u, h, E, d, g, y, b, I;
  var n;
  const i = (f = (l = e.inst) == null ? void 0 : l._zod) == null ? void 0 : f.traits;
  i != null && i.has("$ZodType") && (i.has("$ZodCheck") ? (n = e).schema ?? (n.schema = e.inst) : e.schema = e.inst);
  const o = e.schema !== e.inst ? (h = (u = e.schema) == null ? void 0 : u._zod.def) == null ? void 0 : h.error : void 0, s = e.message ? e.message : Di((g = (d = (E = e.inst) == null ? void 0 : E._zod.def) == null ? void 0 : d.error) == null ? void 0 : g.call(d, e)) ?? Di(o == null ? void 0 : o(e)) ?? Di((y = t == null ? void 0 : t.error) == null ? void 0 : y.call(t, e)) ?? Di((b = r.customError) == null ? void 0 : b.call(r, e)) ?? Di((I = r.localeError) == null ? void 0 : I.call(r, e)) ?? "Invalid input", a = {};
  for (const S of Object.keys(e))
    S === "inst" || S === "schema" || S === "continue" || S === "input" || S === "__proto__" || (a[S] = e[S]);
  return a.path ?? (a.path = []), a.message = s, t != null && t.reportInput && (a.input = e.input), a;
}
function Sl(e) {
  return e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof File ? "file" : "unknown";
}
const BA = /[\uD800-\uDBFF]/;
function Xs(e) {
  const t = e.length;
  if (!BA.test(e))
    return t;
  let r = t;
  for (let n = 0; n < t - 1; n++)
    (e.charCodeAt(n) & 64512) === 55296 && (e.charCodeAt(n + 1) & 64512) === 56320 && (r--, n++);
  return r;
}
function Il(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function VA(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "nan" : "number";
    case "object": {
      if (e === null)
        return "null";
      if (Array.isArray(e))
        return "array";
      const r = e;
      if (r && Object.getPrototypeOf(r) !== Object.prototype && "constructor" in r && r.constructor)
        return r.constructor.name;
    }
  }
  return t;
}
function xo(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
function WA(e, t) {
  for (const r in t) {
    const n = Object.getOwnPropertyDescriptor(t, r);
    n.get ? Object.defineProperty(e, r, { ...n, enumerable: !1 }) : qA(e, r, n.value);
  }
}
function Zr(e, t, r, n = !0) {
  return Object.defineProperty(e, t, { configurable: !0, writable: !0, enumerable: n, value: r }), r;
}
function lg(e, t, r) {
  return Zr(e, t, r, !1);
}
function _l(e, t) {
  for (const r in e) {
    const n = e[r];
    Object.defineProperty(t, r, {
      configurable: !0,
      enumerable: !0,
      get() {
        return Zr(this, r, n(this));
      },
      set(i) {
        Zr(this, r, i);
      }
    });
  }
  return t;
}
function qA(e, t, r) {
  Object.defineProperty(e, t, {
    configurable: !0,
    get() {
      return this == null ? r : Zr(this, t, r.bind(this));
    },
    set(n) {
      Zr(this, t, n);
    }
  });
}
function HA(e, t) {
  const r = Object.getPrototypeOf(e);
  return t in r ? void 0 : r;
}
let wa, Vr = !1;
const YA = {
  configurable: !0,
  get() {
    Vr = !0;
  }
};
function De(e, t, r) {
  const n = Object.getPrototypeOf(e._zod);
  if (t in n && wa !== e._zod) {
    wa = void 0;
    return;
  }
  wa = e._zod, Object.defineProperty(n, t, {
    configurable: !0,
    get() {
      Object.defineProperty(this, t, YA);
      const i = Vr;
      Vr = !1;
      try {
        const o = r(this);
        return Vr ? delete this[t] : Object.defineProperty(this, t, { configurable: !0, writable: !0, value: o }), Vr = Vr || i, o;
      } catch (o) {
        throw delete this[t], Vr = Vr || i, o;
      }
    },
    set(i) {
      Object.defineProperty(this, t, { configurable: !0, writable: !0, value: i });
    }
  });
}
function ZA(e, t, r, n) {
  const i = HA(e, t);
  i && Object.defineProperty(i, t, {
    configurable: !0,
    get() {
      const o = { configurable: !0, writable: !0, enumerable: n, value: void 0 };
      return Object.defineProperty(this, t, o), o.value = r(this), Object.defineProperty(this, t, o), o.value;
    },
    set(o) {
      Object.defineProperty(this, t, { configurable: !0, writable: !0, enumerable: n, value: o });
    }
  });
}
const cg = "~constantCatch";
function JA(e) {
  const t = () => e;
  return t[cg] = !0, t;
}
var df;
const Na = { value: void 0, enumerable: !1 };
let pf = "captureStackTrace" in Error ? Error : null;
function KA(e) {
  const t = pf;
  if (t) {
    const r = t.stackTraceLimit;
    if (typeof r == "number") {
      try {
        t.stackTraceLimit = 0;
      } catch {
        return pf = null, new e();
      }
      try {
        return new e();
      } finally {
        t.stackTraceLimit = r;
      }
    }
  }
  return new e();
}
function Y(e, t, r, n) {
  const i = {};
  function o(E) {
    this.def = E, this.constr = h, this.traits = /* @__PURE__ */ new Set();
  }
  o.prototype = i;
  const s = r, a = s && /* @__PURE__ */ new WeakSet();
  function l(E, d) {
    if (E._zod) {
      if (E._zod.traits.has(e))
        return;
    } else {
      Na.value = new o(d);
      try {
        Object.defineProperty(E, "_zod", Na);
      } finally {
        Na.value = void 0;
      }
    }
    if (E._zod.traits.add(e), t(E, d), a) {
      const y = Object.getPrototypeOf(E), b = E._zod.constr.prototype;
      let I = y;
      for (; I && I !== b; )
        I = Object.getPrototypeOf(I);
      const S = I ?? y;
      a.has(S) || (a.add(S), WA(S, s));
    }
    const g = h.prototype;
    for (const y in g)
      Object.prototype.hasOwnProperty.call(g, y) && (y in E || (E[y] = g[y].bind(E)));
  }
  const f = (n == null ? void 0 : n.Parent) ?? Object;
  class u extends f {
  }
  Object.defineProperty(u, "name", { value: e });
  function h(E) {
    var b;
    const d = n != null && n.Parent ? KA(u) : this;
    l(d, E);
    const g = d._zod.deferred;
    if (g) {
      for (const I of g)
        I();
      d._zod.deferred = void 0;
    }
    const y = (b = globalThis.__zod_globalConfig) == null ? void 0 : b.postProcessor;
    return y && y(d), d;
  }
  return Object.defineProperty(h, "init", { value: l }), Object.defineProperty(h, Symbol.hasInstance, {
    value: (E) => {
      var d, g;
      return n != null && n.Parent && E instanceof n.Parent ? !0 : (g = (d = E == null ? void 0 : E._zod) == null ? void 0 : d.traits) == null ? void 0 : g.has(e);
    }
  }), Object.defineProperty(h, "name", { value: e }), h;
}
class Hr extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class fg extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
(df = globalThis).__zod_globalConfig ?? (df.__zod_globalConfig = {});
const vt = globalThis.__zod_globalConfig;
function Gt(e) {
  return e && Object.assign(vt, e), vt;
}
class dg {
  constructor(t = [], r = {}) {
    this.content = [], this.indent = 0, this.args = t, this.closed = r;
  }
  // the compiler catches a child's throw and keeps writing into this doc, so the indent has to unwind with it
  indented(t) {
    this.indent += 1;
    try {
      t(this);
    } finally {
      this.indent -= 1;
    }
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((s) => s), i = Math.min(...n.map((s) => s.length - s.trimStart().length)), o = n.map((s) => s.slice(i)).map((s) => " ".repeat(this.indent * 2) + s);
    for (const s of o)
      this.content.push(s);
  }
  compile() {
    const t = Function, r = (this == null ? void 0 : this.content) ?? [""];
    return new t(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {
${r.join(`
`)}
};`)(...Object.values(this.closed));
  }
}
class XA extends Error {
  constructor() {
    super("Cannot parse a reference cycle that closes through a transform"), this.name = "ZodCyclicError";
  }
}
const Pu = "~memo", hf = [];
function pg(e) {
  return e !== null && typeof e == "object";
}
function Ca(e) {
  return e.map((t) => t.path ? { ...t, path: t.path.slice() } : { ...t });
}
const hg = /* @__PURE__ */ new WeakMap(), li = 0, ys = 1, Co = 2;
function Po(e, t, r) {
  const n = hg.get(e);
  if (n !== void 0)
    return n ? Co : li;
  if (t.has(e))
    return Co;
  t.add(e);
  let i = li;
  const o = (u) => {
    if (i !== Co && (u != null && u._zod)) {
      const h = Po(u, t, r);
      h > i && (i = h);
    }
  }, s = (u, h) => {
    var d;
    let E = li;
    for (const g of Reflect.ownKeys(u)) {
      const y = Object.getOwnPropertyDescriptor(u, g);
      if (!y.enumerable)
        continue;
      const b = y.get ? ys : (d = y.value) != null && d._zod ? Po(y.value, t, r) : li;
      b > E && (E = b);
    }
    return E;
  }, a = (u) => {
    u > i && (i = u);
  }, l = e._zod.def;
  switch (l.type) {
    case "object": {
      const u = Al(l);
      a(u ? s(u) : ys), o(l.catchall);
      break;
    }
    case "array":
      o(l.element);
      break;
    case "tuple":
      for (const u of l.items)
        o(u);
      o(l.rest);
      break;
    case "record":
    case "map":
      o(l.keyType), o(l.valueType);
      break;
    case "set":
      o(l.valueType);
      break;
    case "union":
      for (const u of l.options)
        o(u);
      break;
    case "intersection":
      o(l.left), o(l.right);
      break;
    case "optional":
    case "nullable":
    case "default":
    case "prefault":
    case "catch":
    case "readonly":
    case "nonoptional":
    case "promise":
    case "success":
      o(l.innerType);
      break;
    case "pipe":
      o(l.in), o(l.out);
      break;
    case "function":
      o(l.input), o(l.output);
      break;
    // `$ZodLazy` caches its inner on the def, so a resolved edge is followed exactly
    case "lazy": {
      const u = l._cachedInner ?? (r ? e._zod.innerType : void 0);
      a(u ? Po(u, t, !1) : ys);
      break;
    }
    // a leaf by choice: `parts` are regex fragments, not data positions
    case "template_literal":
    // leaves
    case "string":
    case "number":
    case "int":
    case "boolean":
    case "bigint":
    case "symbol":
    case "undefined":
    case "null":
    case "void":
    case "never":
    case "any":
    case "unknown":
    case "date":
    case "nan":
    case "enum":
    case "literal":
    case "file":
    case "transform":
    case "custom":
      break;
    default:
      for (const u in l) {
        const h = Object.getOwnPropertyDescriptor(l, u);
        if (!h || h.get)
          continue;
        const E = h.value;
        if (!(!E || typeof E != "object")) {
          if (E._zod)
            o(E);
          else if (Array.isArray(E))
            for (const d of E)
              o(d);
        }
      }
  }
  return t.delete(e), QA(e, i);
}
function QA(e, t) {
  return t !== ys && hg.set(e, t === Co), t;
}
function mg(e) {
  return Po(e, /* @__PURE__ */ new Set(), !0) !== li;
}
function ev(e, t) {
  let r = e.buckets.get(t);
  return r || (r = /* @__PURE__ */ new WeakMap(), e.buckets.set(t, r)), r;
}
let es;
const ts = [], tv = {
  alloc(e, t, r) {
    const n = es;
    if (!n)
      return r;
    es = void 0;
    const i = { value: r, issues: null };
    return n.set(t.value, i), ts.push(i), r;
  },
  guard(e) {
    var t;
    (t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
      const r = e._zod.parse, n = (i, o) => {
        if (o.direction !== "backward" && Eg(o, i.value))
          throw new XA();
        return r(i, o);
      };
      e._zod.parse = n, e._zod.run === r && (e._zod.run = n);
    });
  },
  attach(e) {
    var t;
    let r, n = !1, i, o;
    (t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
      const s = e._zod.parse, a = (l, f) => {
        if (r === void 0) {
          const I = Po(e, /* @__PURE__ */ new Set(), !1);
          if (I === li)
            return e._zod.parse = s, e._zod.run === a && (e._zod.run = s), s(l, f);
          I === Co || n ? r = !0 : n = !0;
        }
        const u = l.value;
        if (!pg(u))
          return s(l, f);
        let h = f[Pu];
        h || (h = { buckets: /* @__PURE__ */ new WeakMap(), backEdges: void 0 }, f[Pu] = h);
        let E;
        i === f ? E = o : (E = ev(h, e), i = f, o = E);
        const d = E.get(u);
        if (d)
          return l.value = d.value, d.issues ? d.issues.length && l.issues.push(...Ca(d.issues)) : (l.memo = !0, h.backEdges ?? (h.backEdges = /* @__PURE__ */ new WeakSet()), h.backEdges.add(d.value)), l;
        es = E;
        const g = ts.length, y = s(l, f);
        es = void 0;
        const b = ts.length > g ? ts.pop() : void 0;
        return y instanceof Promise ? y.then((I) => (b && (b.issues = I.issues.length ? Ca(I.issues) : hf), I)) : (b && (b.issues = y.issues.length ? Ca(y.issues) : hf), y);
      };
      e._zod.parse = a, e._zod.run === s && (e._zod.run = a);
    });
  }
};
function rv() {
  return tv;
}
function Eg(e, t) {
  var n;
  const r = (n = e[Pu]) == null ? void 0 : n.backEdges;
  return r !== void 0 && pg(t) && r.has(t);
}
const nv = /^[cC][0-9a-z]{6,}$/, iv = /^[0-9a-z]+$/, ov = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/, sv = /^[0-9a-vA-V]{20}$/, av = /^[A-Za-z0-9]{27}$/, uv = /^[a-zA-Z0-9_-]{21}$/;
function lv(e) {
  return new RegExp(`^[a-zA-Z0-9_-]{${e}}$`);
}
const cv = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, fv = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, mf = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, dv = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, pv = "^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$";
function hv() {
  return new RegExp(pv, "u");
}
const mv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ev = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, gv = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, yv = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Tv = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, bv = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/, Av = /^https?$/, vv = /^\+[1-9]\d{6,14}$/, Sv = /^\d(?:[ -]?\d){11,18}$/, Iv = /^[A-Z]{2}(?!00|01|99)\d{2}[A-Z0-9]{11,30}$/, gg = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
function _v(e) {
  return new RegExp(`^${e}$`);
}
const Rv = /* @__PURE__ */ _v(gg);
function Du(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : e.seconds ? `${t}:[0-5]\\d(?:\\.\\d+)?` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Ov(e) {
  return new RegExp(`^${Du(e)}$`);
}
function wv(e) {
  const t = ["Z"];
  e.offset && t.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${Du({ precision: e.precision, seconds: !0 })}(?:${t.join("|")})`, n = e.local ? `${r}|${Du({ precision: e.precision })}` : r;
  return new RegExp(`^${gg}T(?:${n})$`);
}
const Nv = /^[\s\S]{0,}$/, Cv = /^-?\d+$/, Qs = /^-?\d+(?:\.\d+)?$/, Pv = /^(?:true|false)$/i, Dv = /^undefined$/i, Mv = /^[^A-Z]*$/, Lv = /^[^a-z]*$/, ht = /* @__PURE__ */ Y("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), Rl = (e) => {
  const t = e.value;
  return !tg(t) && t.size !== void 0;
}, Ol = (e) => {
  const t = e.value;
  return !tg(t) && t.length !== void 0;
}, Rs = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, yg = /* @__PURE__ */ Y("$ZodCheckLessThan", (e, t) => {
  ht.init(e, t);
  const r = Rs[typeof t.value];
  e._zod.check = (n) => {
    (t.inclusive ? n.value <= t.value : n.value < t.value) || n.issues.push({
      origin: Rs[typeof n.value] ?? r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Tg = /* @__PURE__ */ Y("$ZodCheckGreaterThan", (e, t) => {
  ht.init(e, t);
  const r = Rs[typeof t.value];
  e._zod.check = (n) => {
    (t.inclusive ? n.value >= t.value : n.value > t.value) || n.issues.push({
      origin: Rs[typeof n.value] ?? r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), xv = /* @__PURE__ */ Y("$ZodCheckMultipleOf", (e, t) => {
  ht.init(e, t), e._zod.check = (r) => {
    if (typeof r.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? (
      // `value % 0n` throws, and nothing is a multiple of zero — the number branch already fails this way via NaN
      t.value !== BigInt(0) && r.value % t.value === BigInt(0)
    ) : rg(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), kv = /* @__PURE__ */ Y("$ZodCheckNumberFormat", (e, t) => {
  var s;
  ht.init(e, t), t.format = t.format || "float64";
  const r = (s = t.format) == null ? void 0 : s.includes("int"), n = r ? "int" : "number", [i, o] = ag[t.format];
  e._zod.check = (a) => {
    const l = a.value;
    if (r) {
      if (!Number.isInteger(l)) {
        a.issues.push({
          expected: n,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? a.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        }) : a.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < i && a.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > o && a.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), jv = /* @__PURE__ */ Y("$ZodCheckMaxSize", (e, t) => {
  var r;
  ht.init(e, t), (r = e._zod.def).when ?? (r.when = Rl), e._zod.check = (n) => {
    const i = n.value;
    i.size <= t.maximum || n.issues.push({
      origin: Sl(i),
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Uv = /* @__PURE__ */ Y("$ZodCheckMinSize", (e, t) => {
  var r;
  ht.init(e, t), (r = e._zod.def).when ?? (r.when = Rl), e._zod.check = (n) => {
    const i = n.value;
    i.size >= t.minimum || n.issues.push({
      origin: Sl(i),
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), $v = /* @__PURE__ */ Y("$ZodCheckSizeEquals", (e, t) => {
  var r;
  ht.init(e, t), (r = e._zod.def).when ?? (r.when = Rl), e._zod.check = (n) => {
    const i = n.value, o = i.size;
    if (o === t.size)
      return;
    const s = o > t.size;
    n.issues.push({
      origin: Sl(i),
      ...s ? { code: "too_big", maximum: t.size } : { code: "too_small", minimum: t.size },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Fv = /* @__PURE__ */ Y("$ZodCheckMaxLength", (e, t) => {
  var r;
  ht.init(e, t), (r = e._zod.def).when ?? (r.when = Ol), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if ((typeof i == "string" && o > t.maximum ? Xs(i) : o) <= t.maximum)
      return;
    const a = Il(i);
    n.issues.push({
      origin: a,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), zv = /* @__PURE__ */ Y("$ZodCheckMinLength", (e, t) => {
  var r;
  ht.init(e, t), (r = e._zod.def).when ?? (r.when = Ol), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if ((typeof i == "string" && o >= t.minimum && o < t.minimum * 2 ? Xs(i) : o) >= t.minimum)
      return;
    const a = Il(i);
    n.issues.push({
      origin: a,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Gv = /* @__PURE__ */ Y("$ZodCheckLengthEquals", (e, t) => {
  var r;
  ht.init(e, t), (r = e._zod.def).when ?? (r.when = Ol), e._zod.check = (n) => {
    const i = n.value, o = i.length, s = typeof i == "string" && o >= t.length && o <= t.length * 2 ? Xs(i) : o;
    if (s === t.length)
      return;
    const a = Il(i), l = s > t.length;
    n.issues.push({
      origin: a,
      ...l ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ea = /* @__PURE__ */ Y("$ZodCheckStringFormat", (e, t) => {
  var r, n;
  ht.init(e, t), t.pattern ? (r = e._zod).check ?? (r.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (n = e._zod).check ?? (n.check = () => {
  });
}), Bv = /* @__PURE__ */ Y("$ZodCheckRegex", (e, t) => {
  ea.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Vv = /* @__PURE__ */ Y("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Mv), ea.init(e, t);
}), Wv = /* @__PURE__ */ Y("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Lv), ea.init(e, t);
}), qv = /* @__PURE__ */ Y("$ZodCheckIncludes", (e, t) => {
  ht.init(e, t);
  const r = hi(t.includes), n = new RegExp(typeof t.position == "number" ? `^.{${t.position},}${r}` : r);
  t.pattern = n, e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Hv = /* @__PURE__ */ Y("$ZodCheckStartsWith", (e, t) => {
  ht.init(e, t);
  const r = new RegExp(`^${hi(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.check = (n) => {
    n.value.startsWith(t.prefix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Yv = /* @__PURE__ */ Y("$ZodCheckEndsWith", (e, t) => {
  ht.init(e, t);
  const r = new RegExp(`.*${hi(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.check = (n) => {
    n.value.endsWith(t.suffix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Zv = /* @__PURE__ */ Y("$ZodCheckOverwrite", (e, t) => {
  ht.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
function Jv() {
  const e = this._zod;
  return e.message ?? (e.message = JSON.stringify(e.def, Ou, 2)), e.message;
}
function Kv(e) {
  this._zod.message = e;
}
const Xv = {
  get: Jv,
  set: Kv,
  enumerable: !0,
  configurable: !0
}, Pa = { value: void 0, enumerable: !1 }, Ef = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]), Qv = (e, t) => {
  e.name = "$ZodError", Pa.value = t, Object.defineProperty(e, "issues", Pa), Pa.value = void 0, Object.defineProperty(e, "message", Xv);
  const r = Object.getPrototypeOf(e);
  Ef.has(r) || (Ef.add(r), Object.defineProperty(r, "toString", {
    configurable: !0,
    enumerable: !1,
    get() {
      const n = () => this.message;
      return Object.defineProperty(this, "toString", { value: n, configurable: !0, writable: !0 }), n;
    },
    set(n) {
      Object.defineProperty(this, "toString", { value: n, configurable: !0, writable: !0 });
    }
  }));
}, eS = Y("$ZodError", Qv);
function tS(e, t, r) {
  return Object.prototype.hasOwnProperty.call(e, t) || (t === "__proto__" ? Object.defineProperty(e, t, { value: r(), writable: !0, enumerable: !0, configurable: !0 }) : e[t] = r()), e[t];
}
function rS(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const i of e.issues)
    i.path.length > 0 ? tS(r, i.path[0], () => []).push(t(i)) : n.push(t(i));
  return { formErrors: n, fieldErrors: r };
}
function nS(e, t = (r) => r.message) {
  const r = { _errors: [] }, n = (i, o = []) => {
    for (const s of i.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((a) => n({ issues: a }, [...o, ...s.path]));
      else if (s.code === "invalid_key")
        n({ issues: s.issues }, [...o, ...s.path]);
      else if (s.code === "invalid_element")
        n({ issues: s.issues }, [...o, ...s.path]);
      else {
        const a = [...o, ...s.path];
        if (a.length === 0)
          r._errors.push(t(s));
        else {
          let l = r, f = 0;
          for (; f < a.length; ) {
            const u = a[f], h = f === a.length - 1;
            if (u === "_errors") {
              h && l._errors.push(t(s)), f++;
              continue;
            }
            Object.prototype.hasOwnProperty.call(l, u) || Object.defineProperty(l, u, {
              value: { _errors: [] },
              enumerable: !0,
              writable: !0,
              configurable: !0
            });
            const E = l[u];
            h && E._errors.push(t(s)), l = E, f++;
          }
        }
      }
  };
  return n(e), r;
}
function ta(e, t) {
  return { callee: (t == null ? void 0 : t.callee) ?? e, Err: t == null ? void 0 : t.Err };
}
const wl = (e) => {
  const t = (r, n, i, o) => {
    const s = i ? { ...i, async: !1 } : { async: !1 }, a = r._zod.run({ value: n, issues: [] }, s);
    if (a instanceof Promise)
      throw new Hr();
    if (a.issues.length) {
      const l = new ((o == null ? void 0 : o.Err) ?? e)(a.issues.map((f) => sr(f, s, Gt())));
      throw og(l, (o == null ? void 0 : o.callee) ?? t), l;
    }
    return a.value;
  };
  return t;
}, Nl = (e) => {
  const t = async (r, n, i, o) => {
    const s = i ? { ...i, async: !0 } : { async: !0 };
    let a = r._zod.run({ value: n, issues: [] }, s);
    if (a instanceof Promise && (a = await a), a.issues.length) {
      const l = new ((o == null ? void 0 : o.Err) ?? e)(a.issues.map((f) => sr(f, s, Gt())));
      throw og(l, (o == null ? void 0 : o.callee) ?? t), l;
    }
    return a.value;
  };
  return t;
}, Cl = (e) => (t, r, n) => {
  const i = n ? { ...n, async: !1 } : { async: !1 }, o = t._zod.run({ value: r, issues: [] }, i);
  if (o instanceof Promise)
    throw new Hr();
  return o.issues.length ? bg(e, o.issues, i) : { success: !0, data: o.value };
};
function bg(e, t, r) {
  let n;
  return {
    success: !1,
    get error() {
      return n || (n = new e(t.map((i) => sr(i, r, Gt()))), t = void 0, r = void 0), n;
    },
    set error(i) {
      n = i, t = void 0, r = void 0;
    }
  };
}
const Pl = (e) => async (t, r, n) => {
  const i = n ? { ...n, async: !0 } : { async: !0 };
  let o = t._zod.run({ value: r, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? bg(e, o.issues, i) : { success: !0, data: o.value };
}, iS = /* @__PURE__ */ Symbol.for("zod.compile.invalid"), oS = /* @__PURE__ */ Symbol.for("zod.compile.fallback"), sS = ((e, t, r) => {
  const n = e._zod.bag.validator;
  if (n !== void 0) {
    if (n(t) !== iS)
      return !0;
    if (n.definite === !0 && r === void 0)
      return !1;
  }
  return aS(e, t, r);
});
function aS(e, t, r) {
  const n = r ? { ...r, async: !1, abortEarly: !0 } : { async: !1, abortEarly: !0 }, i = e._zod.bag.fallbackRun;
  let o;
  if (i ? (n[oS] = !0, o = i({ value: t, issues: [] }, n)) : o = e._zod.run({ value: t, issues: [] }, n), o instanceof Promise)
    throw new Hr();
  return o.issues.length === 0;
}
const uS = async (e, t, r) => {
  const n = r ? { ...r, async: !0, abortEarly: !0 } : { async: !0, abortEarly: !0 };
  let i = e._zod.run({ value: t, issues: [] }, n);
  return i instanceof Promise && (i = await i), i.issues.length === 0;
}, lS = (e) => {
  const t = wl(e), r = (n, i, o, s) => {
    const a = o ? { ...o, direction: "backward" } : { direction: "backward" };
    return t(n, i, a, ta(r, s));
  };
  return r;
}, cS = (e) => {
  const t = wl(e), r = (n, i, o, s) => t(n, i, o, ta(r, s));
  return r;
}, fS = (e) => {
  const t = Nl(e), r = async (n, i, o, s) => {
    const a = o ? { ...o, direction: "backward" } : { direction: "backward" };
    return await t(n, i, a, ta(r, s));
  };
  return r;
}, dS = (e) => {
  const t = Nl(e), r = async (n, i, o, s) => await t(n, i, o, ta(r, s));
  return r;
}, pS = (e) => (t, r, n) => {
  const i = n ? { ...n, direction: "backward" } : { direction: "backward" };
  return Cl(e)(t, r, i);
}, hS = (e) => (t, r, n) => Cl(e)(t, r, n), mS = (e) => async (t, r, n) => {
  const i = n ? { ...n, direction: "backward" } : { direction: "backward" };
  return Pl(e)(t, r, i);
}, ES = (e) => async (t, r, n) => Pl(e)(t, r, n), gS = {
  major: 4,
  minor: 6,
  patch: 6
}, ze = /* @__PURE__ */ Y("$ZodType", (e, t) => {
  var o;
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = gS;
  const n = e._zod.def.checks, i = e._zod.traits.has("$ZodCheck") ? [e, ...n ?? []] : n != null && n.length ? [...n] : [];
  for (const s of i)
    for (const a of s._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (o = e._zod.deferred) == null || o.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const s = (l, f, u) => {
      if (l.memo)
        return l;
      let h = jt(l), E;
      for (const d of f) {
        if (d._zod.def.when) {
          if (GA(l) || !d._zod.def.when(l))
            continue;
        } else if (h)
          continue;
        const g = l.issues.length, y = d._zod.check(l);
        if (y instanceof Promise && (u == null ? void 0 : u.async) === !1)
          throw new Hr();
        if (E || y instanceof Promise)
          E = (E ?? Promise.resolve()).then(async () => {
            await y, l.issues.length !== g && (Cu(l.issues, g, e), h || (h = jt(l, g)));
          });
        else {
          if (l.issues.length === g)
            continue;
          Cu(l.issues, g, e), h || (h = jt(l, g));
        }
      }
      return E ? E.then(() => l) : l;
    }, a = (l, f, u) => {
      if (jt(l))
        return l.aborted = !0, l;
      const h = s(f, i, u);
      if (h instanceof Promise) {
        if (u.async === !1)
          throw new Hr();
        return h.then((E) => e._zod.parse(E, u));
      }
      return e._zod.parse(h, u);
    };
    e._zod.run = (l, f) => {
      if (f.skipChecks)
        return e._zod.parse(l, f);
      if (f.direction === "backward") {
        const h = e._zod.parse({ value: l.value, issues: [] }, { ...f, skipChecks: !0 });
        return h instanceof Promise ? h.then((E) => a(E, l, f)) : a(h, l, f);
      }
      const u = e._zod.parse(l, f);
      if (u instanceof Promise) {
        if (f.async === !1)
          throw new Hr();
        return u.then((h) => s(h, i, f));
      }
      return s(u, i, f);
    };
  }
}, {
  // Wrappers extend this by installing a richer factory over it; reading it eagerly would defeat the laziness.
  get "~standard"() {
    return lg(this, "~standard", vg(this));
  },
  set "~standard"(e) {
    Zr(this, "~standard", e);
  }
}), Ag = (e, t) => e.issues.length ? { issues: e.issues.map((r) => sr(r, t, Gt())) } : { value: e.value };
async function yS(e, t) {
  const r = { async: !0 };
  return Ag(await e._zod.run({ value: t, issues: [] }, r), r);
}
function vg(e) {
  return {
    validate: (t) => {
      const r = { async: !1 };
      try {
        const n = e._zod.run({ value: t, issues: [] }, r);
        if (!(n instanceof Promise))
          return Ag(n, r);
      } catch {
      }
      return yS(e, t);
    },
    vendor: "zod",
    version: 1
  };
}
const Dl = /* @__PURE__ */ Y("$ZodString", (e, t) => {
  ze.init(e, t), e._zod.pattern = t.pattern ?? Nv, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Ke = /* @__PURE__ */ Y("$ZodStringFormat", (e, t) => {
  ea.init(e, t), Dl.init(e, t);
}), TS = /* @__PURE__ */ Y("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = fv), Ke.init(e, t);
}), bS = /* @__PURE__ */ Y("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = mf(n));
  } else
    t.pattern ?? (t.pattern = mf());
  Ke.init(e, t);
}), AS = /* @__PURE__ */ Y("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = dv), Ke.init(e, t);
}), Sg = 1, Os = 2;
function Ig(e) {
  try {
    return typeof URL < "u" && typeof URL.canParse == "function" ? URL.canParse(e) : (new URL(e), !0);
  } catch {
    return !1;
  }
}
function _g(e, t) {
  return !("normalize" in t) && !("hostname" in t) && !("protocol" in t) ? Ig(e) || Os : vS(e, t);
}
function vS(e, t) {
  var r;
  if (!t.normalize && ((r = t.protocol) == null ? void 0 : r.source) === Av.source && !/^https?:\/\//i.test(e))
    return Sg;
  try {
    if (typeof URL < "u") {
      const n = URL;
      if (typeof n.parse == "function")
        return n.parse(e) ?? Os;
    }
    return new URL(e);
  } catch {
    return Os;
  }
}
const SS = /[\t\n\r]/g;
function Mu(e) {
  return e.replace(SS, "");
}
function Rg(e, t) {
  return t.lastIndex = 0, t.test(e.hostname);
}
function Og(e, t) {
  return t.lastIndex = 0, t.test(e.protocol.endsWith(":") ? e.protocol.slice(0, -1) : e.protocol);
}
const IS = /* @__PURE__ */ Y("$ZodURL", (e, t) => {
  Ke.init(e, t), e._zod.check = (r) => {
    try {
      const n = r.value.trim(), i = _g(n, t);
      if (i === Sg) {
        r.issues.push({
          code: "invalid_format",
          format: "url",
          note: "Invalid URL format",
          input: r.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      if (i === Os) {
        r.issues.push({
          code: "invalid_format",
          format: "url",
          input: r.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      if (i === !0) {
        r.value = Mu(n);
        return;
      }
      t.hostname && !Rg(i, t.hostname) && r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      }), t.protocol && !Og(i, t.protocol) && r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      }), r.value = t.normalize ? i.href : Mu(n);
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), _S = /* @__PURE__ */ Y("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = hv()), Ke.init(e, t);
}), RS = /* @__PURE__ */ Y("$ZodNanoID", (e, t) => {
  if (t.length !== void 0 && (!Number.isInteger(t.length) || t.length < 1))
    throw new Error(`Invalid nanoid length: ${t.length}`);
  t.pattern ?? (t.pattern = t.length === void 0 ? uv : lv(t.length)), Ke.init(e, t);
}), OS = /* @__PURE__ */ Y("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = nv), Ke.init(e, t);
}), wS = /* @__PURE__ */ Y("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = iv), Ke.init(e, t);
}), NS = /* @__PURE__ */ Y("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = ov), Ke.init(e, t);
}), CS = /* @__PURE__ */ Y("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = sv), Ke.init(e, t);
}), PS = /* @__PURE__ */ Y("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = av), Ke.init(e, t);
}), DS = /* @__PURE__ */ Y("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = wv(t)), Ke.init(e, t);
}), MS = /* @__PURE__ */ Y("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Rv), Ke.init(e, t);
}), LS = /* @__PURE__ */ Y("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Ov(t)), Ke.init(e, t);
}), xS = /* @__PURE__ */ Y("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = cv), Ke.init(e, t);
}), kS = /* @__PURE__ */ Y("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = mv), Ke.init(e, t);
}), jS = /^[0-9a-fA-F:.]+$/;
function Ml(e) {
  return jS.test(e) ? Ig(`http://[${e}]`) : !1;
}
const US = /* @__PURE__ */ Y("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Ev), Ke.init(e, t), e._zod.check = (r) => {
    Ml(r.value) || r.issues.push({
      code: "invalid_format",
      format: "ipv6",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), $S = /* @__PURE__ */ Y("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = gv), Ke.init(e, t);
});
function wg(e) {
  const t = e.split("/");
  if (t.length !== 2)
    return !1;
  const [r, n] = t;
  if (!n)
    return !1;
  const i = Number(n);
  return `${i}` !== n || i < 0 || i > 128 ? !1 : Ml(r);
}
const FS = /* @__PURE__ */ Y("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = yv), Ke.init(e, t), e._zod.check = (r) => {
    wg(r.value) || r.issues.push({
      code: "invalid_format",
      format: "cidrv6",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Ll(e) {
  if (e === "")
    return !0;
  if (/\s/.test(e) || e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Ng = /^[0-9a-zA-Z+/]*={0,2}$/, zS = /* @__PURE__ */ Y("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Ng), Ke.init(e, t), e._zod.check = (r) => {
    Ll(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), xl = /^[A-Za-z0-9_-]*$/;
function Cg(e) {
  if (!xl.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (n) => n === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Ll(r);
}
const GS = /* @__PURE__ */ Y("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = xl), Ke.init(e, t), e._zod.check = (r) => {
    Cg(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), BS = /* @__PURE__ */ Y("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = vv), Ke.init(e, t);
}), VS = /[- ]/g;
function WS(e) {
  let t = e.length, r = 1, n = 0;
  for (; t; ) {
    const i = e.charCodeAt(--t) - 48;
    r ^= 1, n += r ? [0, 2, 4, 6, 8, 1, 3, 5, 7, 9][i] : i;
  }
  return n % 10 === 0;
}
function qS(e) {
  return Sv.test(e) ? WS(e.replace(VS, "")) : !1;
}
function HS(e) {
  let t = 0;
  const r = e.length;
  for (let n = 4; n < r; n++) {
    const i = e.charCodeAt(n);
    t = (i >= 65 ? t * 100 + (i - 55) : t * 10 + (i - 48)) % 97;
  }
  for (let n = 0; n < 4; n++) {
    const i = e.charCodeAt(n);
    t = (i >= 65 ? t * 100 + (i - 55) : t * 10 + (i - 48)) % 97;
  }
  return t === 1;
}
function YS(e) {
  return Iv.test(e) ? HS(e) : !1;
}
function Pg(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [n] = r;
    if (!n)
      return !1;
    const i = JSON.parse(atob(n));
    return !("typ" in i && (i == null ? void 0 : i.typ) !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const ZS = /* @__PURE__ */ Y("$ZodJWT", (e, t) => {
  Ke.init(e, t), e._zod.check = (r) => {
    Pg(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Dg = /* @__PURE__ */ Y("$ZodNumber", (e, t) => {
  ze.init(e, t), e._zod.pattern = Qs, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const i = r.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return r;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : String(i) : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), r;
  };
}), JS = /* @__PURE__ */ Y("$ZodNumberFormat", (e, t) => {
  kv.init(e, t), Dg.init(e, t);
}), KS = /* @__PURE__ */ Y("$ZodBoolean", (e, t) => {
  ze.init(e, t), e._zod.pattern = Pv, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const i = r.value;
    return typeof i == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), XS = /* @__PURE__ */ Y("$ZodUndefined", (e, t) => {
  ze.init(e, t), e._zod.pattern = Dv, e._zod.values = /* @__PURE__ */ new Set([void 0]), e._zod.parse = (r, n) => {
    const i = r.value;
    return typeof i > "u" || r.issues.push({
      expected: "undefined",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), QS = /* @__PURE__ */ Y("$ZodUnknown", (e, t) => {
  ze.init(e, t), e._zod.parse = (r) => r;
}), e0 = /* @__PURE__ */ Y("$ZodNever", (e, t) => {
  ze.init(e, t), e._zod.parse = (r, n) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
}), t0 = /* @__PURE__ */ Y("$ZodDate", (e, t) => {
  ze.init(e, t), e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = new Date(r.value);
      } catch {
      }
    const i = r.value, o = i instanceof Date;
    return o && !Number.isNaN(i.getTime()) || r.issues.push({
      expected: "date",
      code: "invalid_type",
      input: i,
      ...o ? { received: "Invalid Date" } : {},
      inst: e
    }), r;
  };
});
function Mg(e, t) {
  const r = Nu(e._zod.def.checks);
  if (!r.length)
    return;
  const n = Math.min(...r.map((o) => o[0])), i = e._zod.parse;
  e._zod.parse = (o, s) => {
    const a = t(o.value);
    if (a > n && !(s != null && s.skipChecks) && (s == null ? void 0 : s.direction) !== "backward") {
      for (const [l, f] of Nu(e._zod.def.checks))
        if (a > l && f._zod.def.when(o)) {
          const u = o.issues.length;
          return f._zod.check(o), o.issues[u].continue = !1, Cu(o.issues, u, e), o;
        }
    }
    return i(o, s);
  };
}
const r0 = (e) => Array.isArray(e) ? e.length : -1, n0 = (e) => e instanceof Map ? e.size : -1;
function gf(e, t, r) {
  e.issues.length && t.issues.push(...ir(r, e.issues)), t.value[r] = e.value;
}
const i0 = /* @__PURE__ */ Y("$ZodArray", (e, t) => {
  ze.init(e, t);
  const r = vt.memoizer;
  r == null || r.attach(e), e._zod.parse = (n, i) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = r ? r.alloc(e, n, Array(o.length), i) : Array(o.length);
    const s = [], a = i == null ? void 0 : i.abortEarly;
    for (let l = 0; l < o.length; l++) {
      const f = o[l], u = t.element._zod.run({
        value: f,
        issues: []
      }, i);
      if (u instanceof Promise)
        s.push(u.then((h) => gf(h, n, l)));
      else if (gf(u, n, l), a && u.issues.length !== 0 && jt(u))
        break;
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  }, Mg(e, r0);
});
function ws(e, t, r, n, i, o) {
  const s = r in n, a = o === "optional";
  if (!(!s && a && i === "optional")) {
    if (e.issues.length) {
      if (i !== void 0 && a && !s)
        return;
      t.issues.push(...ir(r, e.issues));
    }
    if (!s && i === void 0) {
      e.issues.length || t.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: void 0,
        path: [r]
      });
      return;
    }
    e.value === void 0 ? (s || i === "defaulted" && !a) && (t.value[r] = void 0) : t.value[r] = e.value;
  }
}
const o0 = [];
function Lg(e) {
  var s, a, l, f;
  const t = Object.keys(e.shape), r = Object.getOwnPropertySymbols(e.shape), n = r.length ? r : o0, i = n.length ? [...t, ...n] : t;
  for (const u of i)
    if (!((f = (l = (a = (s = e.shape) == null ? void 0 : s[u]) == null ? void 0 : a._zod) == null ? void 0 : l.traits) != null && f.has("$ZodType")))
      throw new Error(`Invalid element at key "${String(u)}": expected a Zod schema`);
  const o = LA(e.shape);
  return {
    ...e,
    allKeys: i,
    symbolKeys: n,
    // string-only: handleCatchall matches it against `for...in`, which never yields a symbol
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(o)
  };
}
function xg(e, t, r, n, i, o, s) {
  const a = [], l = i.keySet, f = i.catchall._zod, u = f.def.type, h = f.optin, E = f.optout;
  let d = 0;
  for (const g in t) {
    if (s && r.issues.length !== d) {
      if (jt(r, d))
        break;
      d = r.issues.length;
    }
    if (l.has(g))
      continue;
    if (g === "__proto__") {
      u === "never" && a.push(g);
      continue;
    }
    if (u === "never") {
      a.push(g);
      continue;
    }
    const y = f.run({ value: t[g], issues: [] }, n);
    y instanceof Promise ? e.push(y.then((b) => ws(b, r, g, t, h, E))) : ws(y, r, g, t, h, E);
  }
  return a.length && r.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o,
    // Describes the shape of the input, not the validity of the parsed value, so it never aborts. The parse still fails; the schema's own checks just get to run first, and an enclosing intersection can reconcile the key against a sibling operand.
    continue: !0
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const s0 = /* @__PURE__ */ Y("$ZodObject", (e, t) => {
  ze.init(e, t);
  const r = Object.getOwnPropertyDescriptor(t, "shape"), n = r != null && r.get ? r.get.raw : t.shape ?? {};
  if (n) {
    const f = () => {
      const u = { ...n };
      return Object.defineProperty(t, "shape", { value: u }), f.raw = u, u;
    };
    f.raw = n, Object.defineProperty(t, "shape", { get: f });
  }
  const i = Js(() => Lg(t));
  De(e, "propValues", (f) => {
    const u = f.def.shape, h = {};
    for (const E in u) {
      const d = u[E]._zod;
      if (d.values) {
        Object.prototype.hasOwnProperty.call(h, E) || kr(h, E, /* @__PURE__ */ new Set());
        for (const g of d.values)
          h[E].add(g);
        d.optin !== void 0 && h[E].add(void 0);
      }
    }
    return h;
  });
  const o = Lo, s = t.catchall;
  let a;
  const l = vt.memoizer;
  l == null || l.attach(e), e._zod.parse = (f, u) => {
    a ?? (a = i.value);
    const h = f.value;
    if (!o(h))
      return f.issues.push({
        expected: "object",
        code: "invalid_type",
        input: h,
        inst: e
      }), f;
    f.value = l ? l.alloc(e, f, {}, u) : {};
    const E = [], d = a.shape, g = u == null ? void 0 : u.abortEarly;
    let y = f.issues.length;
    for (const b of a.allKeys) {
      if (g && f.issues.length !== y) {
        if (jt(f, y))
          break;
        y = f.issues.length;
      }
      if (b === "__proto__")
        continue;
      const I = d[b], S = I._zod.optin, w = I._zod.optout, P = I._zod.run({ value: h[b], issues: [] }, u);
      P instanceof Promise ? E.push(P.then((_) => ws(_, f, b, h, S, w))) : ws(P, f, b, h, S, w);
    }
    return s ? xg(E, h, f, u, i.value, e, g === !0) : E.length ? Promise.all(E).then(() => f) : f;
  };
}), a0 = /* @__PURE__ */ Y("$ZodObjectJIT", (e, t) => {
  s0.init(e, t);
  const r = e._zod.parse, n = Js(() => Lg(t)), i = vt.memoizer, o = (d) => {
    var _, v;
    const g = n.value, y = g.symbolKeys, b = new dg(["payload", "ctx"], { shape: d, inst: e, memo: i, syms: y }), I = (M) => `shape[${M}]._zod.run({ value: input[${M}], issues: [] }, ctx)`, S = (M, x) => `
          let ${M}_ab = false;
          for (let i = 0; i < ${M}.issues.length; i++) {
            const iss = ${M}.issues[i];
            iss.path = iss.path ? [${x}, ...iss.path] : [${x}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${M}_ab = true;
          }
          if (${M}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
    b.write("const input = payload.value;");
    const w = /* @__PURE__ */ Object.create(null);
    let P = 0;
    for (const M of g.allKeys)
      w[M] = `key_${P++}`;
    b.write(i ? "const newResult = memo.alloc(inst, payload, {}, ctx);" : "const newResult = {};");
    for (const M of g.allKeys) {
      if (M === "__proto__")
        continue;
      const x = w[M], z = typeof M == "symbol" ? `syms[${y.indexOf(M)}]` : Ut(M), F = `${z} in input`, W = d[M], X = (_ = W == null ? void 0 : W._zod) == null ? void 0 : _.optin, de = X !== void 0, B = ((v = W == null ? void 0 : W._zod) == null ? void 0 : v.optout) === "optional";
      if (b.write(`const ${x} = ${I(z)};`), de && B) {
        const L = X === "optional" ? `${x}_present` : `${x}.value !== undefined || ${x}_present`;
        b.write(`
        const ${x}_present = ${F};
        if (!${x}.issues.length || ${x}_present) {
          if (${x}.issues.length) {${S(x, z)}
          }

          if (${L}) {
            newResult[${z}] = ${x}.value;
          }
        }

      `);
      } else de ? (b.write(`
        if (${x}.issues.length) {${S(x, z)}
        }
      `), X === "defaulted" ? b.write(`newResult[${z}] = ${x}.value;`) : b.write(`
        if (${x}.value !== undefined || ${F}) {
          newResult[${z}] = ${x}.value;
        }
      `)) : b.write(`
        const ${x}_present = ${F};
        if (${x}.issues.length) {${S(x, z)}
        }
        if (!${x}_present && !${x}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${z}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${x}_present) {
          newResult[${z}] = ${x}.value;
        }

      `);
    }
    return b.write("payload.value = newResult;"), b.write("return payload;"), b.compile();
  };
  let s;
  const a = Lo, l = !vt.jitless, u = l && MA.value, h = t.catchall;
  let E;
  e._zod.parse = (d, g) => {
    E ?? (E = n.value);
    const y = d.value;
    return a(y) ? l && u && (g == null ? void 0 : g.async) === !1 && g.jitless !== !0 ? (s || (s = o(t.shape)), d = s(d, g), h ? xg([], y, d, g, E, e, (g == null ? void 0 : g.abortEarly) === !0) : d) : r(d, g) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: y,
      inst: e
    }), d);
  };
});
function yf(e, t, r, n) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !jt(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((o) => o.issues.map((s) => sr(s, n, Gt())))
  }), t);
}
const kg = /* @__PURE__ */ Y("$ZodUnion", (e, t) => {
  ze.init(e, t), De(e, "optin", (n) => n.def.options.some((i) => i._zod.optin === "defaulted") ? "defaulted" : n.def.options.some((i) => i._zod.optin !== void 0) ? "optional" : void 0), De(e, "optout", (n) => n.def.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), De(e, "values", (n) => {
    if (n.def.options.every((i) => i._zod.values))
      return new Set(n.def.options.flatMap((i) => Array.from(i._zod.values)));
  }), De(e, "pattern", (n) => {
    if (n.def.options.every((i) => i._zod.pattern)) {
      const i = n.def.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => bl(o.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1 ? t.options[0]._zod.run : null;
  e._zod.parse = (n, i) => {
    if (r)
      return r(n, i);
    let o = !1;
    const s = [];
    for (const a of t.options) {
      const l = a._zod.run({
        value: n.value,
        issues: []
      }, i);
      if (l instanceof Promise)
        s.push(l), o = !0;
      else {
        if (l.issues.length === 0)
          return l;
        s.push(l);
      }
    }
    return o ? Promise.all(s).then((a) => yf(a, n, e, i)) : yf(s, n, e, i);
  };
});
function u0(e) {
  var r;
  const t = /* @__PURE__ */ new Map();
  for (const n of e.options) {
    const i = (r = n._zod.propValues) == null ? void 0 : r[e.discriminator];
    if (!i || i.size === 0)
      throw new Error(`Invalid discriminated union option at index "${e.options.indexOf(n)}"`);
    for (const o of i)
      if (t.has(o)) {
        if (o !== void 0)
          throw new Error(`Duplicate discriminator value "${String(o)}"`);
        t.set(o, null);
      } else
        t.set(o, n);
  }
  return t;
}
const l0 = /* @__PURE__ */ Y("$ZodDiscriminatedUnion", (e, t) => {
  t.inclusive = !1, kg.init(e, t);
  const r = e._zod.parse;
  De(e, "propValues", (i) => {
    var a, l;
    const o = {};
    let s = 0;
    for (const f of i.def.options) {
      const u = f._zod.propValues;
      if (!u || Object.keys(u).length === 0)
        throw new Error(`Invalid discriminated union option at index "${i.def.options.indexOf(f)}"`);
      (a = u[i.def.discriminator]) != null && a.has(void 0) && s++;
      for (const [h, E] of Object.entries(u)) {
        Object.prototype.hasOwnProperty.call(o, h) || kr(o, h, /* @__PURE__ */ new Set());
        for (const d of E)
          o[h].add(d);
      }
    }
    return !i.def.unionFallback && s > 1 && ((l = o[i.def.discriminator]) == null || l.delete(void 0)), o;
  }), t.options.forEach((i, o) => {
    const s = Al(i._zod.def);
    if (s && !Object.prototype.hasOwnProperty.call(s, t.discriminator))
      throw new Error(`Invalid discriminated union option at index "${o}"`);
  });
  const n = Js(() => u0(t));
  e._zod.parse = (i, o) => {
    const s = i.value;
    if (!Lo(s))
      return i.issues.push({
        code: "invalid_type",
        expected: "object",
        input: s,
        inst: e
      }), i;
    const a = s == null ? void 0 : s[t.discriminator], l = n.value.get(a);
    return l && (a !== void 0 || o.direction !== "backward") ? l._zod.run(i, o) : t.unionFallback || o.direction === "backward" ? r(i, o) : (i.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: t.discriminator,
      options: Array.from(n.value.keys()).filter((f) => n.value.get(f) !== null),
      input: s,
      path: [t.discriminator],
      inst: e
    }), i);
  };
}), c0 = /* @__PURE__ */ Y("$ZodIntersection", (e, t) => {
  ze.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value, o = t.left._zod.run({ value: i, issues: [] }, n), s = t.right._zod.run({ value: i, issues: [] }, n);
    return o instanceof Promise || s instanceof Promise ? Promise.all([o, s]).then(([l, f]) => Tf(r, l, f)) : Tf(r, o, s);
  };
});
function Ns(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (kn(e) && kn(t)) {
    const r = Object.keys(t), n = Object.keys(e).filter((o) => r.indexOf(o) !== -1), i = { ...e, ...t };
    Object.prototype.hasOwnProperty.call(i, "__proto__") && delete i.__proto__;
    for (const o of n) {
      if (o === "__proto__")
        continue;
      const s = Ns(e[o], t[o]);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...s.mergeErrorPath]
        };
      i[o] = s.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], o = t[n], s = Ns(i, o);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [n, ...s.mergeErrorPath]
        };
      r.push(s.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Tf(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  let i;
  const o = /* @__PURE__ */ new Map(), s = (f, u) => {
    var E, d;
    let h;
    if (f.code === "unrecognized_keys" && !((E = f.path) != null && E.length))
      i ?? (i = f), h = f.keys;
    else if (f.code === "invalid_key" && f.origin === "record" && ((d = f.path) == null ? void 0 : d.length) === 1) {
      const g = String(f.path[0]);
      o.has(g) || o.set(g, f), h = [g];
    } else
      return !1;
    for (const g of h)
      n.has(g) || n.set(g, {}), n.get(g)[u] = !0;
    return !0;
  };
  for (const f of t.issues)
    s(f, "l") || e.issues.push(f);
  for (const f of r.issues)
    s(f, "r") || e.issues.push(f);
  const a = [...n].filter(([, f]) => f.l && f.r).map(([f]) => f);
  if (a.length) {
    const f = i ? a.filter((u) => i.keys.includes(u)) : [];
    f.length && e.issues.push({ ...i, keys: f });
    for (const u of a)
      !f.includes(u) && o.has(u) && e.issues.push(o.get(u));
  }
  const l = Ns(t.value, r.value);
  if (!l.valid) {
    if (jt(e))
      return e;
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(l.mergeErrorPath)}`);
  }
  return e.value = l.data, e;
}
const f0 = /* @__PURE__ */ Y("$ZodTuple", (e, t) => {
  ze.init(e, t);
  const r = t.items, n = vt.memoizer;
  n == null || n.attach(e), e._zod.parse = (i, o) => {
    const s = i.value;
    if (!Array.isArray(s))
      return i.issues.push({
        input: s,
        inst: e,
        expected: "tuple",
        code: "invalid_type"
      }), i;
    i.value = n ? n.alloc(e, i, [], o) : [];
    const a = [], l = bf(r, "optin"), f = bf(r, "optout");
    if (!t.rest) {
      if (s.length < l)
        return i.issues.push({
          code: "too_small",
          minimum: l,
          inclusive: !0,
          input: s,
          inst: e,
          origin: "array"
        }), i;
      s.length > r.length && i.issues.push({
        code: "too_big",
        maximum: r.length,
        inclusive: !0,
        input: s,
        inst: e,
        origin: "array"
      });
    }
    const u = new Array(r.length), h = t.rest ? o == null ? void 0 : o.abortEarly : void 0;
    let E = !1;
    for (let d = 0; d < r.length; d++) {
      const g = r[d]._zod.run({ value: s[d], issues: [] }, o);
      g instanceof Promise ? a.push(g.then((y) => {
        u[d] = y;
      })) : (u[d] = g, h && !E && g.issues.length && (E = jt(g)));
    }
    if (t.rest && !E) {
      let d = r.length - 1;
      const g = s.slice(r.length);
      let y = i.issues.length;
      for (const b of g) {
        if (h && i.issues.length !== y) {
          if (jt(i, y))
            break;
          y = i.issues.length;
        }
        d++;
        const I = t.rest._zod.run({ value: b, issues: [] }, o);
        I instanceof Promise ? a.push(I.then((S) => Af(S, i, d))) : Af(I, i, d);
      }
    }
    return a.length ? Promise.all(a).then(() => vf(u, i, r, s, f)) : vf(u, i, r, s, f);
  };
});
function bf(e, t) {
  for (let r = e.length - 1; r >= 0; r--)
    if (!(t === "optin" ? e[r]._zod.optin !== void 0 : e[r]._zod.optout === "optional"))
      return r + 1;
  return 0;
}
function Af(e, t, r) {
  e.issues.length && t.issues.push(...ir(r, e.issues)), t.value[r] = e.value;
}
function vf(e, t, r, n, i) {
  for (let o = 0; o < r.length; o++) {
    const s = e[o], a = o < n.length;
    if (!a && o >= i && r[o]._zod.optin === "optional") {
      t.value.length = o;
      break;
    }
    if (s.issues.length) {
      if (!a && o >= i) {
        t.value.length = o;
        break;
      }
      t.issues.push(...ir(o, s.issues));
    }
    t.value[o] = s.value;
  }
  for (let o = t.value.length - 1; o >= n.length && (r[o]._zod.optout === "optional" && t.value[o] === void 0); o--)
    t.value.length = o;
  return t;
}
const d0 = /* @__PURE__ */ Y("$ZodRecord", (e, t) => {
  ze.init(e, t);
  const r = vt.memoizer;
  r == null || r.attach(e), e._zod.parse = (n, i) => {
    const o = n.value;
    if (!kn(o))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    const s = [], a = t.keyType._zod.values;
    if (a && !t.partial) {
      n.value = r ? r.alloc(e, n, {}, i) : {};
      const l = /* @__PURE__ */ new Set();
      for (const u of a)
        if (typeof u == "string" || typeof u == "number" || typeof u == "symbol") {
          if (l.add(typeof u == "number" ? u.toString() : u), u === "__proto__")
            continue;
          const h = t.keyType._zod.run({ value: u, issues: [] }, i);
          if (h instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          if (h.issues.length) {
            n.issues.push({
              code: "invalid_key",
              origin: "record",
              issues: h.issues.map((g) => sr(g, i, Gt())),
              input: u,
              path: [u],
              inst: e
            });
            continue;
          }
          const E = h.value;
          if (E === "__proto__")
            continue;
          const d = t.valueType._zod.run({ value: o[u], issues: [] }, i);
          d instanceof Promise ? s.push(d.then((g) => {
            g.issues.length && n.issues.push(...ir(u, g.issues)), n.value[E] = g.value;
          })) : (d.issues.length && n.issues.push(...ir(u, d.issues)), n.value[E] = d.value);
        }
      let f;
      for (const u in o)
        if (!l.has(u))
          if (t.mode === "loose") {
            if (u === "__proto__")
              continue;
            n.value[u] = o[u];
          } else
            f = f ?? [], f.push(u);
      f && f.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: o,
        inst: e,
        keys: f,
        continue: !0
      });
    } else {
      n.value = r ? r.alloc(e, n, {}, i) : {};
      let l;
      for (const f of Reflect.ownKeys(o)) {
        if (f === "__proto__" || !Object.prototype.propertyIsEnumerable.call(o, f))
          continue;
        let u = t.keyType._zod.run({ value: f, issues: [] }, i);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof f == "string" && Qs.test(f) && u.issues.length) {
          const g = t.keyType._zod.run({ value: Number(f), issues: [] }, i);
          if (g instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          g.issues.length === 0 && (u = g);
        }
        if (u.issues.length) {
          t.mode === "loose" ? n.value[f] = o[f] : a ? (l = l ?? [], l.push(f)) : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((g) => sr(g, i, Gt())),
            input: f,
            path: [f],
            inst: e
          });
          continue;
        }
        const E = u.value;
        if (E === "__proto__")
          continue;
        const d = t.valueType._zod.run({ value: o[f], issues: [] }, i);
        d instanceof Promise ? s.push(d.then((g) => {
          g.issues.length && n.issues.push(...ir(f, g.issues)), n.value[E] = g.value;
        })) : (d.issues.length && n.issues.push(...ir(f, d.issues)), n.value[E] = d.value);
      }
      l && l.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: o,
        inst: e,
        keys: l,
        continue: !0
      });
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  };
}), p0 = /* @__PURE__ */ Y("$ZodMap", (e, t) => {
  ze.init(e, t);
  const r = vt.memoizer;
  r == null || r.attach(e), e._zod.parse = (n, i) => {
    const o = n.value;
    if (!(o instanceof Map))
      return n.issues.push({
        expected: "map",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    const s = [];
    n.value = r ? r.alloc(e, n, /* @__PURE__ */ new Map(), i) : /* @__PURE__ */ new Map();
    const a = i == null ? void 0 : i.abortEarly;
    let l = n.issues.length;
    for (const [f, u] of o) {
      if (a && n.issues.length !== l) {
        if (jt(n, l))
          break;
        l = n.issues.length;
      }
      const h = t.keyType._zod.run({ value: f, issues: [] }, i), E = t.valueType._zod.run({ value: u, issues: [] }, i);
      h instanceof Promise || E instanceof Promise ? s.push(Promise.all([h, E]).then(([d, g]) => {
        Sf(d, g, n, f, o, e, i);
      })) : Sf(h, E, n, f, o, e, i);
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  }, Mg(e, n0);
});
function Sf(e, t, r, n, i, o, s) {
  e.issues.length && (wu.has(typeof n) ? r.issues.push(...ir(n, e.issues)) : r.issues.push({
    code: "invalid_key",
    origin: "map",
    input: i,
    inst: o,
    issues: e.issues.map((a) => sr(a, s, Gt()))
  })), t.issues.length && (wu.has(typeof n) ? r.issues.push(...ir(n, t.issues)) : r.issues.push({
    origin: "map",
    code: "invalid_element",
    input: i,
    inst: o,
    key: n,
    issues: t.issues.map((a) => sr(a, s, Gt()))
  })), r.value.set(e.value, t.value);
}
const h0 = /* @__PURE__ */ Y("$ZodEnum", (e, t) => {
  ze.init(e, t);
  const r = Ru(t.entries), n = new Set(r);
  e._zod.values = n, De(e, "pattern", (i) => {
    const o = Ru(i.def.entries).filter((s) => wu.has(typeof s));
    return new RegExp(o.length ? `^(${o.map((s) => hi(s.toString())).join("|")})$` : "^[^\\s\\S]$");
  }), e._zod.parse = (i, o) => {
    const s = i.value;
    return n.has(s) || i.issues.push({
      code: "invalid_value",
      values: r,
      input: s,
      inst: e
    }), i;
  };
}), m0 = /* @__PURE__ */ Y("$ZodLiteral", (e, t) => {
  ze.init(e, t);
  const r = new Set(t.values);
  e._zod.values = r, De(e, "pattern", (n) => {
    const i = n.def.values;
    return new RegExp(i.length ? `^(${i.map((o) => typeof o == "string" ? hi(o) : o ? hi(o.toString()) : String(o)).join("|")})$` : "^[^\\s\\S]$");
  }), e._zod.parse = (n, i) => {
    const o = n.value;
    return r.has(o) || n.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), n;
  };
}), E0 = /* @__PURE__ */ Y("$ZodTransform", (e, t) => {
  var r;
  ze.init(e, t), e._zod.optin = "optional", (r = vt.memoizer) == null || r.guard(e), e._zod.parse = (n, i) => {
    if (i.direction === "backward")
      throw new fg(e.constructor.name);
    const o = t.transform(n.value, n);
    if (i.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((a) => (n.value = a, n));
    if (o instanceof Promise)
      throw new Hr();
    return n.value = o, n;
  };
});
function If(e, t) {
  return e.value = t.issues.length ? void 0 : t.value, e;
}
const jg = /* @__PURE__ */ Y("$ZodOptional", (e, t) => {
  ze.init(e, t), De(e, "optin", (r) => r.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), e._zod.optout = "optional", De(e, "values", (r) => {
    const n = r.def.innerType._zod.values;
    return n ? /* @__PURE__ */ new Set([...n, void 0]) : void 0;
  }), De(e, "pattern", (r) => {
    const n = r.def.innerType._zod.pattern;
    return n ? new RegExp(`^(${bl(n.source)})?$`) : void 0;
  }), e._zod.parse = (r, n) => {
    if (r.value === void 0) {
      if (t.innerType._zod.optin !== "defaulted")
        return r;
      const i = t.innerType._zod.run({ value: r.value, issues: [] }, n);
      return i instanceof Promise ? i.then((o) => If(r, o)) : If(r, i);
    }
    return t.innerType._zod.run(r, n);
  };
}), g0 = /* @__PURE__ */ Y("$ZodExactOptional", (e, t) => {
  jg.init(e, t), De(e, "values", (r) => r.def.innerType._zod.values), De(e, "pattern", (r) => r.def.innerType._zod.pattern), e._zod.parse = (r, n) => t.innerType._zod.run(r, n);
}), y0 = /* @__PURE__ */ Y("$ZodNullable", (e, t) => {
  ze.init(e, t), De(e, "optin", (r) => r.def.innerType._zod.optin), De(e, "optout", (r) => r.def.innerType._zod.optout), De(e, "pattern", (r) => {
    const n = r.def.innerType._zod.pattern;
    return n ? new RegExp(`^(${bl(n.source)}|null)$`) : void 0;
  }), De(e, "values", (r) => r.def.innerType._zod.values ? /* @__PURE__ */ new Set([...r.def.innerType._zod.values, null]) : void 0), e._zod.parse = (r, n) => r.value === null ? r : t.innerType._zod.run(r, n);
}), T0 = /* @__PURE__ */ Y("$ZodDefault", (e, t) => {
  ze.init(e, t), e._zod.optin = "defaulted", De(e, "values", (r) => r.def.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => _f(o, t)) : _f(i, t);
  };
});
function _f(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const b0 = /* @__PURE__ */ Y("$ZodPrefault", (e, t) => {
  ze.init(e, t), e._zod.optin = "defaulted", De(e, "values", (r) => r.def.innerType._zod.values), e._zod.parse = (r, n) => (n.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, n));
}), A0 = /* @__PURE__ */ Y("$ZodNonOptional", (e, t) => {
  ze.init(e, t), De(e, "values", (r) => {
    const n = r.def.innerType._zod.values;
    return n ? new Set([...n].filter((i) => i !== void 0)) : void 0;
  }), e._zod.parse = (r, n) => {
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => Rf(o, e)) : Rf(i, e);
  };
});
function Rf(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
function Of(e, t, r, n) {
  return t.issues.length ? (e.value = r.catchValue({
    ...t,
    value: e.value,
    error: {
      issues: t.issues.map((i) => sr(i, n, Gt()))
    },
    input: e.value
  }), e) : (e.value = t.value, t.memo && (e.memo = !0), e);
}
const v0 = /* @__PURE__ */ Y("$ZodCatch", (e, t) => {
  ze.init(e, t), De(e, "optin", (r) => r.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), De(e, "optout", (r) => r.def.innerType._zod.optout), De(e, "values", (r) => r.def.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run({ value: r.value, issues: [] }, n);
    return i instanceof Promise ? i.then((o) => Of(r, o, t, n)) : Of(r, i, t, n);
  };
}), Ug = /* @__PURE__ */ Y("$ZodPipe", (e, t) => {
  ze.init(e, t), De(e, "values", (r) => r.def.in._zod.values), De(e, "optin", (r) => r.def.in._zod.optin), De(e, "optout", (r) => r.def.out._zod.optout), De(e, "propValues", (r) => r.def.in._zod.propValues), e._zod.parse = (r, n) => {
    if (n.direction === "backward") {
      const o = t.out._zod.run(r, n);
      return o instanceof Promise ? o.then((s) => rs(s, t.in, n)) : rs(o, t.in, n);
    }
    const i = t.in._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => rs(o, t.out, n)) : rs(i, t.out, n);
  };
});
function rs(e, t, r) {
  return e.issues.some((n) => n.code !== "unrecognized_keys") ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, r);
}
const S0 = /* @__PURE__ */ Y("$ZodPreprocess", (e, t) => {
  Ug.init(e, t);
}), I0 = /* @__PURE__ */ Y("$ZodReadonly", (e, t) => {
  ze.init(e, t), De(e, "propValues", (r) => r.def.innerType._zod.propValues), De(e, "values", (r) => r.def.innerType._zod.values), De(e, "optin", (r) => {
    var n, i;
    return (i = (n = r.def.innerType) == null ? void 0 : n._zod) == null ? void 0 : i.optin;
  }), De(e, "optout", (r) => {
    var n, i;
    return (i = (n = r.def.innerType) == null ? void 0 : n._zod) == null ? void 0 : i.optout;
  }), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then(wf) : wf(i);
  };
});
function wf(e) {
  return e.memo || (e.value = Object.freeze(e.value)), e;
}
const _0 = /* @__PURE__ */ Y("$ZodCustom", (e, t) => {
  ht.init(e, t), ze.init(e, t), e._zod.parse = (r, n) => r, e._zod.check = (r) => {
    const n = r.value, i = t.fn(n);
    if (i instanceof Promise)
      return i.then((o) => Nf(o, r, n, e));
    Nf(i, r, n, e);
  };
});
function Nf(e, t, r, n) {
  if (!e) {
    const i = {
      code: "custom",
      input: r,
      inst: n,
      // incorporates params.error into issue reporting
      path: [...n._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !n._zod.def.abort
      // params: inst._zod.def.params,
    };
    n._zod.def.params && (i.params = n._zod.def.params), t.issues.push(xo(i));
  }
}
const Bt = Symbol.for("zod.compile.invalid"), Cf = Symbol.for("zod.compile.fallback");
class mi extends Error {
  constructor(t = "z.compile does not support async refinements, transforms, or checks") {
    super(t), this.name = "ZodCompileAsyncError";
  }
}
class we extends Error {
  constructor(t, r = !0) {
    super(`z.compile does not support ${t}; this schema must use the runtime parser`), this.name = "ZodCompileUnsupportedError", this.islandable = r;
  }
}
function R0(e, t) {
  try {
    return kl(e, { assertOnly: !0 });
  } catch {
    return t;
  }
}
function O0(e, t) {
  try {
    const r = kl(e), n = w0(e, r);
    return n._zod.bag.validator = R0(e, r), n;
  } catch (r) {
    throw r;
  }
}
function w0(e, t) {
  if (mg(e))
    throw new we("a schema whose subtree contains a reference cycle");
  const r = jr(e), n = e._zod.run, i = n.__originalRun ?? n, o = (s, a) => {
    if (a != null && a.async || (a == null ? void 0 : a.direction) === "backward" || a != null && a.skipChecks || a != null && a[Cf] || a && Eg(a, s.value))
      return i(s, a);
    const l = t(s.value);
    return l !== Bt ? (s.value = l, s) : (a && (a[Cf] = !0), i(s, a));
  };
  return o.__originalRun = i, r._zod.bag.fallbackRun = i, r._zod.bag.validator = t, r._zod.run = o, n.__originalRun || N0(r, e, t), r;
}
function N0(e, t, r) {
  const n = e, i = t;
  if (typeof i.safeParse == "function") {
    const o = i.safeParse;
    n.safeParse = (s, a) => {
      const l = r(s);
      return l !== Bt ? { success: !0, data: l } : o(s, a);
    };
  }
  if (typeof i.parse == "function") {
    const o = i.parse;
    n.parse = (s, a) => {
      const l = r(s);
      return l !== Bt ? l : o(s, a);
    };
  }
}
function kl(e, t) {
  let r = !0;
  try {
    r = mg(e);
  } catch {
  }
  if (r)
    throw new we("a schema whose subtree contains a reference cycle");
  const n = {
    constants: /* @__PURE__ */ new Map(),
    constantCounter: 0,
    varCounter: 0,
    definite: !0
  }, i = new dg(["input"]), o = Ze(i, n, e, "input", !(t != null && t.assertOnly));
  i.write(o === null ? "return true;" : `return ${o};`);
  const s = ["INVALID", ...n.constants.keys()], a = [Bt, ...n.constants.values()], l = i.content.join(`
`), f = t != null && t.debug ? s.length > 0 ? `// Constants: ${s.join(", ")}
${l}` : l : "", u = Function, h = `return (input) => {
${l}
}`;
  let E;
  try {
    E = new u(...s, h)(...a);
  } catch (d) {
    throw new we(`this schema (generated code failed to evaluate: ${d.message})`);
  }
  return t != null && t.debug && (E.code = f), E.definite = n.definite, E;
}
function ge(e, t) {
  for (const [n, i] of e.constants)
    if (i === t)
      return n;
  const r = `c${e.constantCounter++}`;
  return e.constants.set(r, t), r;
}
function jn(e, t) {
  return e.definite = !1, ge(e, t);
}
function he(e) {
  return `v${e.varCounter++}`;
}
function C0(e, t) {
  const r = e._zod.run({ value: t, issues: [] }, {});
  if (r && typeof r.then == "function")
    return Bt;
  const n = r;
  return n.issues.length === 0 ? n.value : Bt;
}
function Tt(e, t, r, n, i = !0) {
  const o = e.content.length, s = t.constants.size, a = t.constantCounter, l = t.varCounter;
  try {
    return Ze(e, t, r, n, i);
  } catch (f) {
    if (!(f instanceof we) || !f.islandable)
      throw f;
    if (e.content.length = o, t.constants.size > s) {
      const u = Array.from(t.constants.keys()).slice(s);
      for (const h of u)
        t.constants.delete(h);
    }
    return t.constantCounter = a, t.varCounter = l, P0(e, t, r, n);
  }
}
function P0(e, t, r, n) {
  t.definite = !1;
  const i = ge(t, r), o = ge(t, C0), s = he(t);
  return e.write(`const ${s} = ${o}(${i}, ${n});`), e.write(`if (${s} === INVALID) return INVALID;`), s;
}
const D0 = /* @__PURE__ */ new Set([
  "max_size",
  "min_size",
  "size_equals",
  "max_length",
  "min_length",
  "length_equals"
]);
function M0(e, t, r, n) {
  const i = r._zod.def.checks;
  if (!i || i.length === 0)
    return n;
  let o = n;
  for (const s of i) {
    const a = s._zod.def;
    if (a.when && !D0.has(a.check))
      throw new we('check with a custom "when" condition');
    switch (a.check) {
      case "greater_than":
        L0(e, t, a, o);
        break;
      case "less_than":
        x0(e, t, a, o);
        break;
      case "multiple_of":
        k0(e, t, a, o);
        break;
      case "number_format":
        Fg(e, a, o);
        break;
      case "min_length": {
        const l = Wr(a.minimum, "min_length"), f = Da(e, t, o, `${o}.length >= ${l} && ${o}.length < ${a.minimum * 2}`);
        e.write(`if (${f} < ${l}) return INVALID;`);
        break;
      }
      case "max_length": {
        const l = Wr(a.maximum, "max_length"), f = Da(e, t, o, `${o}.length > ${l}`);
        e.write(`if (${f} > ${l}) return INVALID;`);
        break;
      }
      case "length_equals": {
        const l = Wr(a.length, "length_equals"), f = Da(e, t, o, `${o}.length >= ${l} && ${o}.length <= ${a.length * 2}`);
        e.write(`if (${f} !== ${l}) return INVALID;`);
        break;
      }
      case "min_size":
        e.write(`if (${o}.size < ${Wr(a.minimum, "min_size")}) return INVALID;`);
        break;
      case "max_size":
        e.write(`if (${o}.size > ${Wr(a.maximum, "max_size")}) return INVALID;`);
        break;
      case "size_equals":
        e.write(`if (${o}.size !== ${Wr(a.size, "size_equals")}) return INVALID;`);
        break;
      case "string_format":
        o = zg(e, t, a, o);
        break;
      case "custom":
        o = G0(e, t, s, o);
        break;
      case "bigint_format":
        j0(e, a, o);
        break;
      case "mime_type":
        U0(e, t, a, o);
        break;
      case "property":
        F0(e, t, a, o);
        break;
      case "properties":
        $0(e, t, a, o);
        break;
      case "overwrite": {
        const l = he(t);
        z0(e, t, s, o, l), o = l;
        break;
      }
      default:
        throw new we(`check type ${a.check}`);
    }
  }
  return o;
}
function Da(e, t, r, n) {
  const i = ge(t, Xs), o = he(t);
  return e.write(`const ${o} = typeof ${r} === "string" && ${n} ? ${i}(${r}) : ${r}.length;`), o;
}
function Wr(e, t) {
  if (typeof e != "number" || !Number.isFinite(e))
    throw new we(`${t} bound of type ${typeof e}`);
  return `${e}`;
}
function $g(e, t) {
  if (typeof t == "bigint")
    return `${t}n`;
  if (typeof t == "number") {
    if (Number.isNaN(t))
      throw new we("comparison check with NaN bound");
    return `${t}`;
  }
  if (t instanceof Date) {
    if (Number.isNaN(t.getTime()))
      throw new we("comparison check with Invalid Date bound");
    return ge(e, t);
  }
  throw new we(`comparison check bound of type ${typeof t}`);
}
function L0(e, t, r, n) {
  const i = r.inclusive ? "<" : "<=";
  e.write(`if (${n} ${i} ${$g(t, r.value)}) return INVALID;`);
}
function x0(e, t, r, n) {
  const i = r.inclusive ? ">" : ">=";
  e.write(`if (${n} ${i} ${$g(t, r.value)}) return INVALID;`);
}
function k0(e, t, r, n) {
  if (typeof r.value == "bigint") {
    if (r.value === BigInt(0))
      throw new we("multiple_of check with a zero divisor");
    e.write(`if (${n} % ${r.value}n !== 0n) return INVALID;`);
  } else {
    const i = ge(t, rg);
    e.write(`if (${i}(${n}, ${Wr(r.value, "multiple_of")}) !== 0) return INVALID;`);
  }
}
function Fg(e, t, r) {
  const n = t.format;
  switch (n) {
    case "safeint":
      e.write(`if (!Number.isSafeInteger(${r})) return INVALID;`);
      break;
    case "int32":
      e.write(`if (!Number.isInteger(${r}) || ${r} < -2147483648 || ${r} > 2147483647) return INVALID;`);
      break;
    case "uint32":
      e.write(`if (!Number.isInteger(${r}) || ${r} < 0 || ${r} > 4294967295) return INVALID;`);
      break;
    case "float32":
      e.write(`if (!Number.isFinite(${r}) || ${r} < -3.4028234663852886e38 || ${r} > 3.4028234663852886e38) return INVALID;`);
      break;
    case "float64":
      e.write(`if (!Number.isFinite(${r})) return INVALID;`);
      break;
    default:
      throw new we(`number format ${n}`);
  }
}
function j0(e, t, r) {
  const n = t.format;
  if (n)
    switch (n) {
      case "int64":
        e.write(`if (${r} < -9223372036854775808n || ${r} > 9223372036854775807n) return INVALID;`);
        break;
      case "uint64":
        e.write(`if (${r} < 0n || ${r} > 18446744073709551615n) return INVALID;`);
        break;
      default:
        throw new we(`bigint format ${n}`);
    }
}
function U0(e, t, r, n) {
  const i = r.mime;
  if (i && i.length > 0) {
    const o = ge(t, new Set(i));
    e.write(`if (!${o}.has(${n}.type)) return INVALID;`);
  }
}
function $0(e, t, r, n) {
  if (r.when)
    throw new we('check with a custom "when" condition');
  e.write(`if (${n} == null) return INVALID;`);
  const i = r.shape;
  for (const o of Reflect.ownKeys(i)) {
    const s = typeof o == "symbol" ? ge(t, o) : Ut(o), a = he(t);
    e.write(`const ${a} = ${n}[${s}];`), Tt(e, t, i[o], a, !1);
  }
}
function F0(e, t, r, n) {
  const i = `${n}[${JSON.stringify(r.property)}]`;
  Ze(e, t, r.schema, i);
}
function z0(e, t, r, n, i) {
  const o = r._zod.def.tx;
  if (!o)
    throw new we("overwrite check without a transform function");
  if (Un(o))
    throw new mi("z.compile: async overwrite transforms are not supported");
  const s = ge(t, o);
  e.write(`const ${i} = ${s}(${n});`);
}
function Lu() {
  throw new Hr();
}
function jl(e) {
  this.issues.push(e);
}
function G0(e, t, r, n) {
  const i = r._zod.def;
  if (i.fn) {
    if (Un(i.fn))
      throw new mi("z.compile: async .refine() predicates are not supported");
    const o = jn(t, i.fn), s = ge(t, Lu), a = he(t);
    return e.write(`const ${a} = ${o}(${n});`), e.write(`if (${a} instanceof Promise) ${s}();`), e.write(`if (!${a}) return INVALID;`), n;
  }
  if (r._zod.check) {
    if (Un(r._zod.check))
      throw new mi("z.compile: async .superRefine() / check functions are not supported");
    const o = r._zod.check, a = jn(t, (f) => {
      const u = { value: f, issues: [], addIssue: jl };
      return o(u) instanceof Promise && Lu(), u.issues.length === 0 ? u.value : Bt;
    }), l = he(t);
    return e.write(`const ${l} = ${a}(${n});`), e.write(`if (${l} === INVALID) return INVALID;`), l;
  }
  throw new we("custom check without a predicate or check function");
}
const B0 = /* @__PURE__ */ new Set([
  "cidrv4",
  "cuid",
  "cuid2",
  "date",
  "datetime",
  "duration",
  "e164",
  "email",
  "emoji",
  "ends_with",
  "guid",
  "includes",
  "ipv4",
  "ksuid",
  "lowercase",
  "mac",
  "nanoid",
  "regex",
  "starts_with",
  "time",
  "ulid",
  "uppercase",
  "uuid",
  "xid"
]);
function zg(e, t, r, n, i = !0) {
  const o = r.format;
  if (o === "base64") {
    const f = ge(t, Ll);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "base64url") {
    const f = ge(t, Cg);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "jwt") {
    const f = ge(t, Pg), u = ge(t, r.alg ?? null);
    return e.write(`if (!${f}(${n}, ${u})) return INVALID;`), n;
  }
  if (o === "ipv6") {
    const f = ge(t, Ml);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "cidrv6") {
    const f = ge(t, wg);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "credit_card") {
    const f = ge(t, qS);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (o === "iban") {
    const f = ge(t, YS);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  const s = r;
  if (o === "url" || o === "httpurl" || s.normalize || s.hostname !== void 0 || s.protocol !== void 0) {
    const f = ge(t, _g), u = ge(t, r), h = he(t), E = he(t);
    if (e.write(`const ${h} = ${n}.trim();`), e.write(`const ${E} = ${f}(${h}, ${u});`), e.write(`if (typeof ${E} === "number") return INVALID;`), s.hostname !== void 0) {
      const y = ge(t, Rg);
      e.write(`if (!${y}(${E}, ${u}.hostname)) return INVALID;`);
    }
    if (s.protocol !== void 0) {
      const y = ge(t, Og);
      e.write(`if (!${y}(${E}, ${u}.protocol)) return INVALID;`);
    }
    if (!i)
      return null;
    const d = he(t), g = s.normalize ? `${E}.href` : `${ge(t, Mu)}(${h})`;
    return e.write(`const ${d} = ${g};`), d;
  }
  const a = r.fn;
  if (a) {
    if (Un(a))
      throw new we(`async string format ${o}`);
    const f = ge(t, a);
    return e.write(`if (!${f}(${n})) return INVALID;`), n;
  }
  if (B0.has(o) && r.pattern) {
    const f = ge(t, r.pattern);
    return e.write(`${f}.lastIndex = 0;`), e.write(`if (!${f}.test(${n})) return INVALID;`), n;
  }
  const l = r.format;
  switch (l) {
    case "regex":
      throw new we("regex format without a pattern");
    case "lowercase":
      e.write(`if (${n} !== ${n}.toLowerCase()) return INVALID;`);
      break;
    case "uppercase":
      e.write(`if (${n} !== ${n}.toUpperCase()) return INVALID;`);
      break;
    case "includes":
      e.write(`if (!${n}.includes(${Ut(r.includes)})) return INVALID;`);
      break;
    case "starts_with": {
      const f = r.prefix;
      e.write(`if (${n}.slice(0, ${f.length}) !== ${Ut(f)}) return INVALID;`);
      break;
    }
    case "ends_with": {
      const f = r.suffix;
      e.write(`if (${n}.slice(-${f.length}) !== ${Ut(f)}) return INVALID;`);
      break;
    }
    default:
      throw new we(`string format ${l}`);
  }
  return n;
}
function Ze(e, t, r, n, i = !0) {
  var f;
  const o = r._zod.def, s = o.type;
  if (o.coerce)
    throw new we(`coercion (z.coerce.${s}())`);
  const a = i || !!((f = o.checks) != null && f.length);
  let l;
  switch (s) {
    case "string":
      l = V0(e, t, r, n, a);
      break;
    case "number":
      l = W0(e, r, n);
      break;
    case "boolean":
      l = q0(e, n);
      break;
    case "bigint":
      l = H0(e, r, n);
      break;
    case "symbol":
      l = Y0(e, n);
      break;
    case "undefined":
      l = Z0(e, n);
      break;
    case "null":
      l = J0(e, n);
      break;
    case "any":
    case "unknown":
      l = n;
      break;
    case "never":
      e.write("return INVALID;"), l = n;
      break;
    case "void":
      l = K0(e, n);
      break;
    case "nan":
      l = X0(e, n);
      break;
    case "date":
      l = Q0(e, n);
      break;
    case "object":
      l = eI(e, t, r, n, a);
      break;
    case "optional":
      l = tI(e, t, r, n, a);
      break;
    case "nullable":
      l = iI(e, t, r, n, a);
      break;
    case "array":
      l = oI(e, t, r, n, a);
      break;
    case "literal":
      l = sI(e, t, r, n);
      break;
    case "enum":
      l = aI(e, t, r, n);
      break;
    case "readonly": {
      const u = Df(e, t, r, n), h = he(t);
      e.write(`const ${h} = Object.freeze(${u});`), l = h;
      break;
    }
    case "success":
      Df(e, t, r, n), l = "true";
      break;
    case "default":
    case "prefault":
      l = uI(e, t, r, n);
      break;
    case "nonoptional":
      l = lI(e, t, r, n);
      break;
    case "tuple":
      l = cI(e, t, r, n);
      break;
    case "union":
      l = fI(e, t, r, n);
      break;
    case "intersection":
      l = hI(e, t, r, n);
      break;
    case "record":
      l = mI(e, t, r, n);
      break;
    case "map":
      l = gI(e, t, r, n);
      break;
    case "set":
      l = yI(e, t, r, n);
      break;
    case "file":
      l = TI(e, n);
      break;
    case "template_literal":
      l = bI(e, t, r, n);
      break;
    case "lazy":
      l = AI(e, t, r, n);
      break;
    case "pipe":
      l = vI(e, t, r, n);
      break;
    case "custom":
      l = SI(e, t, r, n);
      break;
    case "transform":
      l = RI(e, t, r, n);
      break;
    case "catch":
      l = _I(e, t, r, n);
      break;
    default:
      throw new we(`schema type ${s}`);
  }
  return l === null ? null : M0(e, t, r, l);
}
function V0(e, t, r, n, i = !0) {
  e.write(`if (typeof ${n} !== "string") return INVALID;`);
  const o = r._zod.def;
  return o.format === void 0 ? n : zg(e, t, o, n, i);
}
function W0(e, t, r) {
  e.write(`if (typeof ${r} !== "number" || !Number.isFinite(${r})) return INVALID;`);
  const n = t._zod.def;
  return n.check === "number_format" && n.format && Fg(e, { format: n.format }, r), r;
}
function q0(e, t) {
  return e.write(`if (typeof ${t} !== "boolean") return INVALID;`), t;
}
function H0(e, t, r) {
  e.write(`if (typeof ${r} !== "bigint") return INVALID;`);
  const n = t._zod.def;
  if (n.format)
    switch (n.format) {
      case "int64":
        e.write(`if (${r} < -9223372036854775808n || ${r} > 9223372036854775807n) return INVALID;`);
        break;
      case "uint64":
        e.write(`if (${r} < 0n || ${r} > 18446744073709551615n) return INVALID;`);
        break;
    }
  return r;
}
function Y0(e, t) {
  return e.write(`if (typeof ${t} !== "symbol") return INVALID;`), t;
}
function Z0(e, t) {
  return e.write(`if (${t} !== undefined) return INVALID;`), t;
}
function J0(e, t) {
  return e.write(`if (${t} !== null) return INVALID;`), t;
}
function K0(e, t) {
  return e.write(`if (${t} !== undefined) return INVALID;`), t;
}
function X0(e, t) {
  return e.write(`if (typeof ${t} !== "number" || !Number.isNaN(${t})) return INVALID;`), t;
}
function Q0(e, t) {
  return e.write(`if (!(${t} instanceof Date) || Number.isNaN(${t}.getTime())) return INVALID;`), t;
}
function eI(e, t, r, n, i = !0) {
  var S;
  const o = r._zod.def;
  e.write(`if (typeof ${n} !== "object" || ${n} === null || Array.isArray(${n})) return INVALID;`);
  const s = o.shape, a = Object.keys(s), l = Object.getOwnPropertySymbols(s), f = l.length ? [...a, ...l] : a, u = (w) => typeof w == "symbol" ? ge(t, w) : Ut(w), h = (w) => typeof w == "symbol" ? `[${u(w)}]` : Ut(w), E = s;
  if (a.includes("__proto__"))
    throw new we('object shape key "__proto__"');
  const d = /* @__PURE__ */ new Map();
  for (const w of f) {
    const P = E[w], _ = u(w), v = he(t);
    if (e.write(`const ${v} = ${n}[${_}];`), P._zod.optin !== void 0) {
      const M = he(t);
      e.write(`let ${M} = (() => {`), e.indented((x) => {
        const z = Tt(x, t, P, v);
        x.write(`return ${z};`);
      }), e.write("})();"), P._zod.optout === "optional" ? (e.write(`if (${M} === INVALID) {`), e.indented((x) => {
        x.write(`if (${_} in ${n}) return INVALID;`), x.write(`${M} = undefined;`);
      }), e.write("}")) : e.write(`if (${M} === INVALID) return INVALID;`), d.set(w, M);
    } else {
      nI(P) && e.write(`if (!(${_} in ${n})) return INVALID;`);
      const M = Tt(e, t, P, v, i);
      M !== null && d.set(w, M);
    }
  }
  const g = o.catchall;
  let y = "none";
  if (g) {
    const w = g._zod.def.type;
    if (w === "never") {
      const P = a.map((_) => `k !== ${Ut(_)}`).join(" && ") || "true";
      e.write(`for (const k in ${n}) {`), e.indented((_) => {
        _.write(`if (${P}) return INVALID;`);
      }), e.write("}");
    } else (w === "unknown" || w === "any") && !((S = g._zod.def.checks) != null && S.length) ? y = "passthrough" : y = "schema";
  }
  const b = he(t), I = f.some((w) => Pf(E[w]) || xu(E[w]));
  if (!i) {
    if (y === "schema") {
      const w = a.length > 0 ? ge(t, new Set(a)) : null;
      e.write(`for (const k in ${n}) {`), e.indented((P) => {
        P.write('if (k === "__proto__") continue;'), w && P.write(`if (${w}.has(k)) continue;`);
        const _ = he(t);
        P.write(`const ${_} = ${n}[k];`), Tt(P, t, g, _, !1);
      }), e.write("}");
    }
    return null;
  }
  if (I) {
    e.write(`const ${b} = {};`);
    for (const w of f) {
      const P = u(w), _ = d.get(w);
      xu(E[w]) ? e.write(`if (${P} in ${n}) ${b}[${P}] = ${_};`) : Pf(E[w]) ? e.write(`if (${_} !== undefined || ${P} in ${n}) ${b}[${P}] = ${_};`) : e.write(`${b}[${P}] = ${_};`);
    }
  } else {
    const w = f.map((P) => `${h(P)}: ${d.get(P)}`).join(", ");
    e.write(`const ${b} = { ${w} };`);
  }
  if (y !== "none") {
    const w = a.length > 0 ? ge(t, new Set(a)) : null;
    e.write(`for (const k in ${n}) {`), e.indented((P) => {
      if (P.write('if (k === "__proto__") continue;'), w && P.write(`if (${w}.has(k)) continue;`), y === "passthrough")
        P.write(`${b}[k] = ${n}[k];`);
      else {
        const _ = he(t);
        P.write(`const ${_} = ${n}[k];`);
        const v = Tt(P, t, g, _);
        P.write(`${b}[k] = ${v};`);
      }
    }), e.write("}");
  }
  return b;
}
function tI(e, t, r, n, i = !0) {
  const o = r._zod.def;
  if (rI(r))
    return Ze(e, t, o.innerType, n, i);
  if (o.innerType._zod.optin === "defaulted") {
    const a = he(t), l = he(t);
    return e.write(`let ${a};`), e.write(`if (${n} === undefined) {`), e.indented((f) => {
      f.write(`const ${l} = (() => {`), f.indented((u) => {
        const h = Ze(u, t, o.innerType, n);
        u.write(`return ${h};`);
      }), f.write("})();"), f.write(`if (${l} !== INVALID) ${a} = ${l};`);
    }), e.write("} else {"), e.indented((f) => {
      const u = Ze(f, t, o.innerType, n);
      f.write(`${a} = ${u};`);
    }), e.write("}"), a;
  }
  const s = i ? he(t) : null;
  return s && e.write(`let ${s};`), e.write(`if (${n} !== undefined) {`), e.indented((a) => {
    const l = Ze(a, t, o.innerType, n, i);
    s && l !== null && a.write(`${s} = ${l};`);
  }), e.write("}"), s;
}
function rI(e) {
  var t;
  return ((t = e._zod.traits) == null ? void 0 : t.has("$ZodExactOptional")) === !0;
}
function nI(e) {
  return e._zod.optin === void 0 && Cn(e);
}
function Cn(e) {
  var r, n;
  if (e._zod.def.coerce)
    return !0;
  const t = e._zod.def;
  switch (t.type) {
    case "any":
    case "unknown":
    case "undefined":
    case "void":
    case "default":
    case "prefault":
    case "transform":
    case "custom":
    case "lazy":
      return !0;
    case "string":
    case "number":
    case "boolean":
    case "bigint":
    case "symbol":
    case "null":
    case "never":
    case "nan":
    case "date":
    case "object":
    case "array":
    case "tuple":
    case "record":
    case "map":
    case "set":
    case "file":
    case "template_literal":
      return !1;
    case "nonoptional":
      return t.innerType ? Cn(t.innerType) : !1;
    case "literal":
      return !!((r = t.values) != null && r.includes(void 0));
    case "enum":
      return !!((n = e._zod.values) != null && n.has(void 0));
    case "optional":
    case "nullable":
    case "readonly":
    case "success":
      return t.innerType ? Cn(t.innerType) : !0;
    case "catch":
      return !0;
    case "union":
      return t.options ? t.options.some(Cn) : !0;
    case "intersection":
      return !t.left || !t.right ? !0 : Cn(t.left) && Cn(t.right);
    case "pipe":
      return t.in ? Cn(t.in) : !0;
    default:
      return !0;
  }
}
function xu(e) {
  return e._zod.optin === "optional" && e._zod.optout === "optional";
}
function Pf(e) {
  return (e._zod.optin !== "defaulted" || e._zod.optout === "optional") && ai(e);
}
function ai(e) {
  var r, n;
  const t = e._zod.def;
  switch (t.type) {
    case "string":
    case "number":
    case "boolean":
    case "bigint":
    case "symbol":
    case "null":
    case "nan":
    case "date":
    case "object":
    case "array":
    case "tuple":
    case "record":
    case "map":
    case "set":
    case "file":
    case "template_literal":
    case "never":
    case "success":
      return !1;
    case "literal":
      return !!((r = t.values) != null && r.includes(void 0));
    case "enum":
      return !!((n = e._zod.values) != null && n.has(void 0));
    case "optional":
      return !0;
    case "nullable":
    case "readonly":
    case "nonoptional":
      return t.innerType ? ai(t.innerType) : !0;
    case "union":
      return t.options ? t.options.some(ai) : !0;
    case "intersection":
      return !t.left || !t.right || ai(t.left) || ai(t.right);
    case "pipe":
      return t.out ? ai(t.out) : !0;
    default:
      return !0;
  }
}
function iI(e, t, r, n, i = !0) {
  const o = r._zod.def, s = i ? he(t) : null;
  return s && e.write(`let ${s} = null;`), e.write(`if (${n} !== null) {`), e.indented((a) => {
    const l = Ze(a, t, o.innerType, n, i);
    s && l !== null && a.write(`${s} = ${l};`);
  }), e.write("}"), s;
}
function Ul(e, t, r) {
  for (const [n, i] of Nu(t._zod.def.checks))
    e.write(`if (${r} > ${Wr(n, i._zod.def.check)}) return INVALID;`);
}
function oI(e, t, r, n, i = !0) {
  const o = r._zod.def;
  e.write(`if (!Array.isArray(${n})) return INVALID;`), Ul(e, r, `${n}.length`);
  const s = i ? he(t) : null, a = he(t), l = he(t);
  return s && e.write(`const ${s} = new Array(${n}.length);`), e.write(`for (let ${a} = 0; ${a} < ${n}.length; ${a}++) {`), e.indented((f) => {
    f.write(`const ${l} = ${n}[${a}];`);
    const u = Tt(f, t, o.element, l, i);
    s && u !== null && f.write(`${s}[${a}] = ${u};`);
  }), e.write("}"), s;
}
function sI(e, t, r, n) {
  const o = r._zod.def.values;
  if (o.length !== 1) {
    const a = ge(t, new Set(o));
    return e.write(`if (!${a}.has(${n})) return INVALID;`), n;
  }
  const s = o[0];
  if (typeof s == "number" && Number.isNaN(s)) {
    const a = ge(t, new Set(o));
    return e.write(`if (!${a}.has(${n})) return INVALID;`), n;
  }
  if (typeof s == "string")
    e.write(`if (${n} !== ${Ut(s)}) return INVALID;`);
  else if (typeof s == "number" || typeof s == "boolean")
    e.write(`if (${n} !== ${s}) return INVALID;`);
  else if (s === null)
    e.write(`if (${n} !== null) return INVALID;`);
  else if (s === void 0)
    e.write(`if (${n} !== undefined) return INVALID;`);
  else if (typeof s == "bigint")
    e.write(`if (${n} !== ${s}n) return INVALID;`);
  else
    throw new we(`literal type ${typeof s}`);
  return n;
}
function aI(e, t, r, n) {
  const i = r._zod.values;
  if (!i)
    throw new we("enum schema without enumerated values");
  const o = ge(t, i);
  return e.write(`if (!${o}.has(${n})) return INVALID;`), n;
}
function Df(e, t, r, n) {
  const i = r._zod.def;
  return Ze(e, t, i.innerType, n);
}
function uI(e, t, r, n) {
  const i = r._zod.def, s = Object.getOwnPropertyDescriptor(r._zod.def, "defaultValue") ? () => r._zod.def.defaultValue : void 0;
  if (r._zod.def.type === "prefault") {
    if (!s)
      return Ze(e, t, i.innerType, n);
    const l = ge(t, s), f = he(t);
    return e.write(`let ${f} = ${n};`), e.write(`if (${n} === undefined) ${f} = ${l}();`), Ze(e, t, i.innerType, f);
  }
  const a = he(t);
  if (s) {
    const l = ge(t, s), f = ge(t, vl);
    e.write(`let ${a};`), e.write(`if (${n} === undefined) {`), e.indented((u) => {
      u.write(`${a} = ${f}(${l}());`);
    }), e.write("} else {"), e.indented((u) => {
      const h = Ze(u, t, i.innerType, n);
      u.write(`${a} = ${h} === undefined ? ${f}(${l}()) : ${h};`);
    }), e.write("}");
  } else
    e.write(`let ${a};`), e.write(`if (${n} !== undefined) {`), e.indented((l) => {
      const f = Ze(l, t, i.innerType, n);
      l.write(`${a} = ${f};`);
    }), e.write("}");
  return a;
}
function lI(e, t, r, n) {
  const i = r._zod.def, o = Ze(e, t, i.innerType, n), s = he(t);
  return e.write(`const ${s} = ${o};`), e.write(`if (${s} === undefined) return INVALID;`), s;
}
function cI(e, t, r, n) {
  const i = r._zod.def, o = i.items, s = i.rest;
  e.write(`if (!Array.isArray(${n})) return INVALID;`);
  const a = Mf(o, "optin"), l = Mf(o, "optout");
  s ? e.write(`if (${n}.length < ${a}) return INVALID;`) : e.write(`if (${n}.length < ${a} || ${n}.length > ${o.length}) return INVALID;`);
  const f = he(t);
  e.write(`const ${f} = [];`);
  for (let u = 0; u < o.length; u++) {
    const h = o[u];
    if (u >= l)
      e.write(`if (${f}.length === ${u}) {`), e.indented((E) => {
        E.write(`if (${u} < ${n}.length) {`), E.indented((d) => {
          const g = he(t);
          d.write(`const ${g} = ${n}[${u}];`);
          const y = Tt(d, t, h, g);
          d.write(`${f}[${u}] = ${y};`);
        }), E.write("} else {"), E.indented((d) => {
          if (xu(h)) {
            d.write(`${f}.length = ${u};`);
            return;
          }
          const g = he(t), y = he(t);
          d.write(`const ${g} = undefined;`), d.write(`const ${y} = (() => {`), d.indented((b) => {
            const I = Tt(b, t, h, g);
            b.write(`return ${I};`);
          }), d.write("})();"), d.write(`if (${y} === INVALID || ${y} === undefined) ${f}.length = ${u};`), d.write(`else ${f}[${u}] = ${y};`);
        }), E.write("}");
      }), e.write("}");
    else {
      const E = he(t);
      e.write(`const ${E} = ${n}[${u}];`);
      const d = Tt(e, t, h, E);
      e.write(`${f}[${u}] = ${d};`);
    }
  }
  if (s) {
    const u = he(t), h = he(t);
    e.write(`for (let ${u} = ${o.length}; ${u} < ${n}.length; ${u}++) {`), e.indented((E) => {
      E.write(`const ${h} = ${n}[${u}];`);
      const d = Tt(E, t, s, h);
      E.write(`${f}[${u}] = ${d};`);
    }), e.write("}");
  }
  return f;
}
function Mf(e, t) {
  for (let r = e.length - 1; r >= 0; r--)
    if (!(t === "optin" ? e[r]._zod.optin !== void 0 : e[r]._zod.optout === "optional"))
      return r + 1;
  return 0;
}
function fI(e, t, r, n) {
  const i = r._zod.def, o = i.options;
  if (i.discriminator)
    return dI(e, t, i, n);
  if (i.inclusive === !1)
    throw new we("exclusive unions (z.xor)");
  if (o.length === 0)
    return e.write("return INVALID;"), n;
  if (o.length === 1)
    return Ze(e, t, o[0], n);
  if (o.every((l) => {
    var f;
    return l._zod.def.type === "literal" && !((f = l._zod.def.checks) != null && f.length);
  })) {
    const l = new Set(o.flatMap((u) => u._zod.def.values)), f = ge(t, l);
    return e.write(`if (!${f}.has(${n})) return INVALID;`), n;
  }
  const a = he(t);
  e.write(`let ${a};`);
  for (let l = 0; l < o.length; l++) {
    const f = o[l];
    l === 0 ? e.write(`${a} = (() => {`) : e.write(`if (${a} === INVALID) ${a} = (() => {`), e.indented((u) => {
      const h = Ze(u, t, f, n);
      u.write(`return ${h};`);
    }), e.write("})();");
  }
  return e.write(`if (${a} === INVALID) return INVALID;`), a;
}
function dI(e, t, r, n) {
  var l;
  if (r.unionFallback)
    throw new we("discriminated union with unionFallback");
  if (r.options.length === 0)
    return e.write("return INVALID;"), n;
  const i = he(t), o = he(t);
  e.write(`const ${i} = ${n}?.[${Ut(r.discriminator)}];`), e.write(`let ${o};`);
  let s = !0;
  const a = /* @__PURE__ */ new Set();
  for (const f of r.options) {
    const u = (l = f._zod.propValues) == null ? void 0 : l[r.discriminator];
    if (!u || u.size === 0)
      throw new we("discriminated union option without static discriminator values");
    for (const d of u) {
      if (a.has(d))
        throw new we(`duplicate discriminator value ${String(d)}`);
      a.add(d);
    }
    const h = Array.from(u, (d) => pI(t, i, d)), E = s ? "if" : "else if";
    e.write(`${E} (${h.join(" || ")}) {`), e.indented((d) => {
      const g = Ze(d, t, f, n);
      d.write(`${o} = ${g};`);
    }), e.write("}"), s = !1;
  }
  return e.write("else { return INVALID; }"), o;
}
function pI(e, t, r) {
  if (typeof r == "string")
    return `${t} === ${Ut(r)}`;
  if (typeof r == "number")
    return Number.isNaN(r) ? `Number.isNaN(${t})` : `${t} === ${r}`;
  if (typeof r == "boolean")
    return `${t} === ${r}`;
  if (r === null)
    return `${t} === null`;
  if (r === void 0)
    return `${t} === undefined`;
  if (typeof r == "bigint")
    return `${t} === ${r}n`;
  if (typeof r == "symbol") {
    const n = ge(e, r);
    return `${t} === ${n}`;
  }
  throw new we(`literal discriminator value ${String(r)}`);
}
function hI(e, t, r, n) {
  const i = r._zod.def;
  t.definite = !1;
  const o = Tt(e, t, i.left, n), s = Tt(e, t, i.right, n), a = ge(t, Ns), l = he(t);
  return e.write(`const ${l} = ${a}(${o}, ${s});`), e.write(`if (!${l}.valid) return INVALID;`), `${l}.data`;
}
function mI(e, t, r, n) {
  var d;
  const i = r._zod.def, o = ge(t, kn);
  e.write(`if (!${o}(${n})) return INVALID;`);
  const s = he(t), a = he(t), l = he(t);
  e.write(`const ${s} = {};`);
  const f = i, u = f.partial ? void 0 : i.keyType._zod.values;
  if (u) {
    const g = [];
    for (const b of u) {
      if (!(typeof b == "string" || typeof b == "number" || typeof b == "symbol"))
        throw new we(`record key value ${String(b)}`);
      const I = typeof b == "number" ? b.toString() : b;
      if (I === "__proto__")
        throw new we('record key "__proto__"');
      g.push(I);
      const S = ge(t, b), w = Ze(e, t, i.keyType, S), P = he(t);
      e.write(`const ${P} = ${n}[${EI(t, I)}];`);
      const _ = Tt(e, t, i.valueType, P);
      e.write(`${s}[${w}] = ${_};`);
    }
    const y = ge(t, new Set(g));
    return e.write(`for (const ${a} in ${n}) {`), e.indented((b) => {
      b.write(`if (${y}.has(${a})) continue;`), f.mode === "loose" ? b.write(`if (${a} !== "__proto__") ${s}[${a}] = ${n}[${a}];`) : b.write("return INVALID;");
    }), e.write("}"), s;
  }
  const h = i.keyType._zod.def;
  if (!(h.type === "string" && h.format === void 0 && !h.coerce && (((d = h.checks) == null ? void 0 : d.length) ?? 0) === 0)) {
    const g = i.mode === "loose", y = kl(i.keyType);
    y.definite === !1 && (t.definite = !1);
    const b = ge(t, y), I = ge(t, Qs), S = he(t);
    return Lf(e, t, n, a, (w) => {
      w.write(`let ${S} = ${b}(${a});`), w.write(`if (${S} === INVALID && typeof ${a} === "string" && ${I}.test(${a})) ${S} = ${b}(Number(${a}));`), g ? w.write(`if (${S} === INVALID) { ${s}[${a}] = ${n}[${a}]; continue; }`) : w.write(`if (${S} === INVALID) return INVALID;`), w.write(`if (${S} === "__proto__") continue;`);
      const P = he(t);
      w.write(`const ${P} = ${n}[${a}];`);
      const _ = Tt(w, t, i.valueType, P);
      w.write(`${s}[${S}] = ${_};`);
    }), s;
  }
  return Lf(e, t, n, a, (g) => {
    g.write(`const ${l} = ${n}[${a}];`);
    const y = Tt(g, t, i.valueType, l);
    g.write(`${s}[${a}] = ${y};`);
  }, "return INVALID;"), s;
}
function Lf(e, t, r, n, i, o) {
  const s = ge(t, Object.prototype.propertyIsEnumerable), a = he(t), l = he(t), f = he(t);
  e.write(`const ${a} = Object.getOwnPropertySymbols(${r});`), e.write(`const ${l} = Object.getOwnPropertyNames(${r});`), e.write(`for (let ${f} = 0; ${f} < ${l}.length; ${f}++) {`), e.indented((u) => {
    u.write(`const ${n} = ${l}[${f}];`), u.write(`if (${n} === "__proto__" || !${s}.call(${r}, ${n})) continue;`), i(u);
  }), e.write("}"), e.write(`for (let ${f} = 0; ${f} < ${a}.length; ${f}++) {`), e.indented((u) => {
    u.write(`const ${n} = ${a}[${f}];`), u.write(`if (!${s}.call(${r}, ${n})) continue;`), o ? u.write(o) : i(u);
  }), e.write("}");
}
function EI(e, t) {
  return typeof t == "string" ? Ut(t) : ge(e, t);
}
function gI(e, t, r, n) {
  const i = r._zod.def;
  e.write(`if (!(${n} instanceof Map)) return INVALID;`), Ul(e, r, `${n}.size`);
  const o = he(t), s = he(t), a = he(t);
  return e.write(`const ${o} = new Map();`), e.write(`for (const [${s}, ${a}] of ${n}) {`), e.indented((l) => {
    const f = Ze(l, t, i.keyType, s), u = Ze(l, t, i.valueType, a);
    l.write(`${o}.set(${f}, ${u});`);
  }), e.write("}"), o;
}
function yI(e, t, r, n) {
  const i = r._zod.def;
  e.write(`if (!(${n} instanceof Set)) return INVALID;`), Ul(e, r, `${n}.size`);
  const o = he(t), s = he(t);
  return e.write(`const ${o} = new Set();`), e.write(`for (const ${s} of ${n}) {`), e.indented((a) => {
    const l = Ze(a, t, i.valueType, s);
    a.write(`${o}.add(${l});`);
  }), e.write("}"), o;
}
function TI(e, t) {
  return e.write(`if (!(${t} instanceof File)) return INVALID;`), t;
}
function bI(e, t, r, n) {
  e.write(`if (typeof ${n} !== "string") return INVALID;`);
  const i = r._zod.pattern;
  if (i) {
    const o = ge(t, i);
    e.write(`${o}.lastIndex = 0;`), e.write(`if (!${o}.test(${n})) return INVALID;`);
  }
  return n;
}
function AI(e, t, r, n) {
  const i = r._zod.def, o = jn(t, i.getter), s = ge(t, { parser: null });
  e.write(`if (!${s}.parser) {`), e.indented((l) => {
    l.write(`const inner = ${o}();`), l.write(`${s}.parser = function(input) {`), l.indented((f) => {
      f.write("const result = inner._zod.run({ value: input, issues: [] }, {});"), f.write("return result.issues.length === 0 ? result.value : INVALID;");
    }), l.write("};");
  }), e.write("}");
  const a = he(t);
  return e.write(`const ${a} = ${s}.parser(${n});`), e.write(`if (${a} === INVALID) return INVALID;`), a;
}
function vI(e, t, r, n) {
  const i = r._zod.def, o = Ze(e, t, i.in, n);
  if (i.transform) {
    if (Un(i.transform))
      throw new mi("z.compile: async transforms in pipes are not supported");
    const s = i.transform, l = jn(t, (u) => {
      const h = { value: u, issues: [], addIssue: jl }, E = s(u, h);
      return E instanceof Promise ? Bt : h.issues.length === 0 ? E : Bt;
    }), f = he(t);
    return e.write(`const ${f} = ${l}(${o});`), e.write(`if (${f} === INVALID) return INVALID;`), Ze(e, t, i.out, f);
  } else
    return Ze(e, t, i.out, o);
}
function Un(e) {
  return typeof e == "function" && (e.constructor.name === "AsyncFunction" || e[Symbol.toStringTag] === "AsyncFunction");
}
function SI(e, t, r, n) {
  const i = r._zod.def;
  if (i.fn) {
    if (Un(i.fn))
      throw new mi("z.compile: async custom predicates are not supported");
    const o = jn(t, i.fn), s = ge(t, Lu), a = he(t);
    e.write(`const ${a} = ${o}(${n});`), e.write(`if (${a} instanceof Promise) ${s}();`), e.write(`if (!${a}) return INVALID;`);
  } else
    throw new we("custom schema without a predicate function");
  return n;
}
function II(e, t, r) {
  const n = e._zod.run({ value: r, issues: [] }, {});
  if (n && typeof n.then == "function")
    return Bt;
  const i = n;
  return i.issues.length === 0 ? i.value : t();
}
function _I(e, t, r, n) {
  const i = r._zod.def;
  if (!i.catchValue[cg])
    throw new we("catch with a callback (only a constant catch value compiles)", !1);
  const o = he(t);
  e.write(`let ${o} = (() => {`), e.indented((f) => {
    const u = Tt(f, t, i.innerType, n);
    f.write(`return ${u};`);
  }), e.write("})();");
  const s = ge(t, i.innerType), a = jn(t, i.catchValue), l = ge(t, II);
  return e.write(`if (${o} === INVALID) {`), e.indented((f) => {
    f.write(`${o} = ${l}(${s}, ${a}, ${n});`), f.write(`if (${o} === INVALID) return INVALID;`);
  }), e.write("}"), o;
}
function RI(e, t, r, n) {
  const i = r._zod.def;
  if (i.transform) {
    if (Un(i.transform))
      throw new mi("z.compile: async transforms are not supported");
    const o = i.transform, a = jn(t, (f) => {
      const u = { value: f, issues: [], addIssue: jl }, h = o(f, u);
      return h instanceof Promise ? Bt : u.issues.length === 0 ? h : Bt;
    }), l = he(t);
    return e.write(`const ${l} = ${a}(${n});`), e.write(`if (${l} === INVALID) return INVALID;`), l;
  }
  return n;
}
const OI = () => {
  const e = {
    string: { unit: "characters", verb: "to have" },
    file: { unit: "bytes", verb: "to have" },
    array: { unit: "items", verb: "to have" },
    set: { unit: "items", verb: "to have" },
    map: { unit: "entries", verb: "to have" }
  };
  function t(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    mac: "MAC address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    currency_code: "currency code",
    credit_card: "credit card number",
    iban: "IBAN",
    jwt: "JWT",
    template_literal: "input"
  }, n = {
    // Compatibility: "nan" -> "NaN" for display
    nan: "NaN"
    // All other type names omitted - they fall back to raw values via ?? operator
  };
  function i(o, s) {
    return o === "number" && typeof s == "number" && !Number.isFinite(s) ? String(s) : n[o] ?? o;
  }
  return (o) => {
    switch (o.code) {
      case "invalid_type": {
        const s = i(o.expected), a = VA(o.input), l = i(a, o.input);
        return `Invalid input: expected ${s}, received ${l}`;
      }
      case "invalid_value":
        return o.values.length === 1 ? `Invalid input: expected ${sg(o.values[0])}` : `Invalid option: expected one of ${cf(o.values, "|")}`;
      case "too_big": {
        const s = o.exact ? "exactly " : o.inclusive ? "<=" : "<", a = t(o.origin);
        return a ? `Too big: expected ${o.origin ?? "value"} to have ${s}${o.maximum.toString()} ${a.unit ?? "elements"}` : `Too big: expected ${o.origin ?? "value"} to be ${s}${o.maximum.toString()}`;
      }
      case "too_small": {
        const s = o.exact ? "exactly " : o.inclusive ? ">=" : ">", a = t(o.origin);
        return a ? `Too small: expected ${o.origin} to have ${s}${o.minimum.toString()} ${a.unit}` : `Too small: expected ${o.origin} to be ${s}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const s = o;
        return s.format === "starts_with" ? `Invalid string: must start with "${s.prefix}"` : s.format === "ends_with" ? `Invalid string: must end with "${s.suffix}"` : s.format === "includes" ? `Invalid string: must include "${s.includes}"` : s.format === "regex" ? `Invalid string: must match pattern ${s.pattern}` : `Invalid ${r[s.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Invalid number: must be a multiple of ${o.divisor}`;
      case "unrecognized_keys":
        return `Unrecognized key${o.keys.length > 1 ? "s" : ""}: ${cf(o.keys, ", ")}`;
      case "invalid_key":
        return `Invalid key in ${o.origin}`;
      case "invalid_union":
        return o.options && Array.isArray(o.options) && o.options.length > 0 ? `Invalid discriminator value. Expected ${o.options.map((a) => `'${a}'`).join(" | ")}` : o.inclusive === !1 ? "Invalid input: more than one option matched" : "Invalid input";
      case "invalid_element":
        return `Invalid value in ${o.origin}`;
      default:
        return "Invalid input";
    }
  };
};
function wI() {
  return {
    localeError: OI()
  };
}
var xf;
class NI {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const n = r[0];
    return this._map.set(t, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const r = this._map.get(t);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const n = { ...this.get(r) ?? {} };
      delete n.id;
      const i = { ...n, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function CI() {
  return new NI();
}
(xf = globalThis).__zod_globalRegistry ?? (xf.__zod_globalRegistry = CI());
const Oo = globalThis.__zod_globalRegistry;
function $l(e) {
  return e.checks && (e.checks = [...e.checks]), e;
}
// @__NO_SIDE_EFFECTS__
function PI(e, t) {
  return new e($l({ type: "string", ...se(t) }));
}
// @__NO_SIDE_EFFECTS__
function DI(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function MI(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function LI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function UI(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $I(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function FI(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zI(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function GI(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function BI(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VI(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WI(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qI(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HI(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YI(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZI(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JI(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KI(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function XI(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gg(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bg(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function QI(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function e_(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function t_(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function r_(e, t) {
  return new e($l({ type: "number", checks: [], ...se(t) }));
}
// @__NO_SIDE_EFFECTS__
function n_(e, t) {
  return new e($l({ type: "number", coerce: !0, checks: [], ...se(t) }));
}
// @__NO_SIDE_EFFECTS__
function i_(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function o_(e, t) {
  return new e({
    type: "boolean",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function s_(e, t) {
  return new e({
    type: "undefined",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function a_(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function u_(e, t) {
  return new e({
    type: "never",
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function l_(e, t) {
  return new e({
    type: "date",
    coerce: !0,
    ...se(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kf(e, t) {
  return new yg({
    check: "less_than",
    ...se(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Ts(e, t) {
  return new yg({
    check: "less_than",
    ...se(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function jf(e, t) {
  return new Tg({
    check: "greater_than",
    ...se(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function bs(e, t) {
  return new Tg({
    check: "greater_than",
    ...se(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Uf(e, t) {
  return new xv({
    check: "multiple_of",
    ...se(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function c_(e, t) {
  return new jv({
    check: "max_size",
    ...se(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function $f(e, t) {
  return new Uv({
    check: "min_size",
    ...se(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function f_(e, t) {
  return new $v({
    check: "size_equals",
    ...se(t),
    size: e
  });
}
// @__NO_SIDE_EFFECTS__
function Vg(e, t) {
  return new Fv({
    check: "max_length",
    ...se(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Cs(e, t) {
  return new zv({
    check: "min_length",
    ...se(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Wg(e, t) {
  return new Gv({
    check: "length_equals",
    ...se(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function d_(e, t) {
  return new Bv({
    check: "string_format",
    format: "regex",
    ...se(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function p_(e) {
  return new Vv({
    check: "string_format",
    format: "lowercase",
    ...se(e)
  });
}
// @__NO_SIDE_EFFECTS__
function h_(e) {
  return new Wv({
    check: "string_format",
    format: "uppercase",
    ...se(e)
  });
}
// @__NO_SIDE_EFFECTS__
function m_(e, t) {
  return new qv({
    check: "string_format",
    format: "includes",
    ...se(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function E_(e, t) {
  return new Hv({
    check: "string_format",
    format: "starts_with",
    ...se(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function g_(e, t) {
  return new Yv({
    check: "string_format",
    format: "ends_with",
    ...se(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ri(e) {
  return new Zv({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function y_(e) {
  return /* @__PURE__ */ Ri((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function T_() {
  return /* @__PURE__ */ Ri((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function b_() {
  return /* @__PURE__ */ Ri((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function A_() {
  return /* @__PURE__ */ Ri((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function v_() {
  return /* @__PURE__ */ Ri((e) => DA(e));
}
// @__NO_SIDE_EFFECTS__
function S_(e, t, r) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...se(r)
  });
}
// @__NO_SIDE_EFFECTS__
function I_(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...se(r)
  });
}
// @__NO_SIDE_EFFECTS__
function __(e, t) {
  const r = /* @__PURE__ */ R_((n) => (n.addIssue = (i) => {
    if (typeof i == "string")
      n.issues.push(xo(i, n.value, r._zod.def));
    else {
      const o = i;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), "input" in o || (o.input = n.value), o.inst ?? (o.inst = r), o.continue ?? (o.continue = !r._zod.def.abort), n.issues.push(xo(o));
    }
  }, e(n.value, n)), t);
  return r;
}
// @__NO_SIDE_EFFECTS__
function R_(e, t) {
  const r = new ht({
    check: "custom",
    ...se(t)
  });
  return r._zod.check = e, r;
}
function Do(e, ...t) {
  for (const r of t)
    for (const n of Reflect.ownKeys(r))
      Object.prototype.propertyIsEnumerable.call(r, n) && kr(e, n, r[n]);
  return e;
}
function qg(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? Oo,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    sharedDefsExtractedFor: void 0,
    sharedEmitDoneFor: void 0,
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    intersections: [],
    deferred: [],
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function er(e, t, r, n, i) {
  const o = typeof t.unrepresentable == "function" ? t.unrepresentable({ zodSchema: e, path: n.path, message: i }) : t.unrepresentable;
  if (o === "any")
    return !1;
  if (o === void 0 || o === "throw")
    throw new Error(i);
  return Object.assign(r, o), !0;
}
function rt(e, t, r = { path: [], schemaPath: [] }) {
  var u, h;
  var n;
  const i = e._zod.def, o = t.seen.get(e);
  if (o)
    return o.count++, r.schemaPath.includes(e) && (o.cycle = r.path), o.schema;
  const s = { schema: {}, count: 1, cycle: void 0, path: r.path };
  t.seen.set(e, s), t.sharedDefsExtractedFor = void 0, t.sharedEmitDoneFor = void 0;
  const a = (h = (u = e._zod).toJSONSchema) == null ? void 0 : h.call(u);
  if (a)
    s.schema = a;
  else {
    const E = {
      ...r,
      schemaPath: [...r.schemaPath, e],
      path: r.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, s.schema, E);
    else {
      const g = s.schema, y = t.processors[i.type];
      if (!y)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      y(e, t, g, E);
    }
    const d = e._zod.parent;
    d && (s.ref || (s.ref = d), rt(d, t, E), t.seen.get(d).isParent = !0);
  }
  const l = t.metadataRegistry.get(e);
  return l && Do(s.schema, l), t.io === "input" && At(e) && (delete s.schema.examples, delete s.schema.default), t.io === "input" && "_prefault" in s.schema && ((n = s.schema).default ?? (n.default = s.schema._prefault)), delete s.schema._prefault, t.seen.get(e).schema;
}
function Ff(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Hg(e, t) {
  var s, a, l, f;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  if (e.external && e.sharedDefsExtractedFor === e.external)
    return;
  const n = /* @__PURE__ */ new Map();
  for (const u of e.seen.entries()) {
    const h = (s = e.metadataRegistry.get(u[0])) == null ? void 0 : s.id;
    if (h) {
      const E = n.get(h);
      if (E && E !== u[0])
        throw new Error(`Duplicate schema id "${h}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      n.set(h, u[0]);
    }
  }
  const i = (u) => {
    var y;
    const h = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const b = (y = e.external.registry.get(u[0])) == null ? void 0 : y.id, I = e.external.uri ?? ((w) => w);
      if (b)
        return { ref: I(b) };
      const S = u[1].defId ?? u[1].schema.id ?? `schema${e.counter++}`;
      return u[1].defId = S, { defId: S, ref: `${I("__shared")}#/${h}/${Ff(S)}` };
    }
    const E = "#", d = `${E}/${h}/`;
    if (u[1] === r && !u[1].schema.id)
      return { ref: E };
    const g = u[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: g, ref: d + Ff(g) };
  }, o = (u) => {
    if (u[1].schema.$ref)
      return;
    const h = u[1], { ref: E, defId: d } = i(u);
    h.def = { ...h.schema }, d && (h.defId = d);
    const g = h.schema;
    for (const y in g)
      delete g[y];
    g.$ref = E;
  };
  if (e.cycles === "throw")
    for (const u of e.seen.entries()) {
      const h = u[1];
      if (h.cycle)
        throw new Error(`Cycle detected: #/${(a = h.cycle) == null ? void 0 : a.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const u of e.seen.entries()) {
    const h = u[1];
    if (t === u[0]) {
      o(u);
      continue;
    }
    if (e.external) {
      const d = (l = e.external.registry.get(u[0])) == null ? void 0 : l.id;
      if (t !== u[0] && d) {
        o(u);
        continue;
      }
    }
    if ((f = e.metadataRegistry.get(u[0])) == null ? void 0 : f.id) {
      o(u);
      continue;
    }
    if (h.cycle) {
      o(u);
      continue;
    }
    h.count > 1 && e.reused === "ref" && o(u);
  }
  e.external && (e.sharedDefsExtractedFor = e.external);
}
function Yg(e) {
  const t = e.anyOf;
  if (!Array.isArray(t) || t.length === 0 || e.type !== void 0)
    return;
  const r = [];
  for (const n of t) {
    if (!n || typeof n != "object")
      return;
    Yg(n);
    const i = Object.keys(n);
    if (i.length !== 1 || i[0] !== "type")
      return;
    const o = n.type;
    for (const s of Array.isArray(o) ? o : [o]) {
      if (typeof s != "string")
        return;
      r.includes(s) || r.push(s);
    }
  }
  delete e.anyOf, e.type = r.length === 1 ? r[0] : r;
}
const Zg = /* @__PURE__ */ new Set(["type", "properties", "required", "additionalProperties"]), zf = ["oneOf", "anyOf"];
function Gf(e) {
  const t = e.additionalProperties;
  return t === void 0 || t === !1 || typeof t != "object" || t === null ? null : Object.keys(t).length ? t : null;
}
function ku(e) {
  var o;
  const t = [];
  for (const s of e) {
    if (typeof s != "object" || s.type !== "object")
      return null;
    for (const a in s)
      if (!Zg.has(a))
        return null;
    t.push(s);
  }
  const r = {}, n = /* @__PURE__ */ new Set();
  for (const s of t) {
    for (const a in s.properties) {
      if (Object.prototype.hasOwnProperty.call(r, a))
        continue;
      const l = [];
      for (const u of t) {
        const h = ((o = u.properties) == null ? void 0 : o[a]) ?? Gf(u);
        h != null && (l.some((E) => JSON.stringify(E) === JSON.stringify(h)) || l.push(h));
      }
      const f = l.length === 1 ? l[0] : ku(l) ?? { allOf: l };
      kr(r, a, f);
    }
    for (const a of s.required ?? [])
      n.add(a);
  }
  const i = { type: "object", properties: r };
  if (n.size && (i.required = [...n]), t.every((s) => s.additionalProperties === !1))
    i.additionalProperties = !1;
  else {
    const s = [];
    for (const a of t) {
      const l = Gf(a);
      l && !s.some((f) => JSON.stringify(f) === JSON.stringify(l)) && s.push(l);
    }
    s.length === 1 ? i.additionalProperties = s[0] : s.length > 1 && (i.additionalProperties = { allOf: s });
  }
  return i;
}
function O_(e) {
  const t = e.allOf;
  if (!Array.isArray(t) || t.length < 2)
    return;
  for (const i of Zg)
    if (i in e)
      return;
  const r = t.filter((i) => zf.some((o) => Array.isArray(i[o])));
  let n = null;
  if (!r.length)
    n = ku(t);
  else {
    const i = r[0], o = zf.find((l) => Array.isArray(i[l]));
    if (Object.keys(i).length !== 1)
      return;
    const s = t.filter((l) => l !== i), a = i[o].map((l) => ku([...s, l]));
    if (a.some((l) => !l))
      return;
    n = { [o]: a };
  }
  n && (delete e.allOf, Do(e, n));
}
function Jg(e, t) {
  var a, l, f, u;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = (h) => {
    const E = e.seen.get(h);
    if (E.ref === null)
      return;
    const d = E.def ?? E.schema, g = { ...d }, y = E.ref;
    if (E.ref = null, y) {
      n(y);
      const I = e.seen.get(y), S = I.schema;
      if (S.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (d.allOf = d.allOf ?? [], d.allOf.push(S)) : Do(d, S), Do(d, g), h._zod.parent === y)
        for (const P in d)
          P === "$ref" || P === "allOf" || P in g || delete d[P];
      if (S.$ref && I.def)
        for (const P in d)
          P === "$ref" || P === "allOf" || P in I.def && JSON.stringify(d[P]) === JSON.stringify(I.def[P]) && delete d[P];
    }
    const b = h._zod.parent;
    if (b && b !== y) {
      n(b);
      const I = e.seen.get(b);
      if (I != null && I.schema.$ref && (d.$ref = I.schema.$ref, I.def))
        for (const S in d)
          S === "$ref" || S === "allOf" || S in I.def && JSON.stringify(d[S]) === JSON.stringify(I.def[S]) && delete d[S];
    }
    e.override({
      zodSchema: h,
      jsonSchema: d,
      path: E.path ?? []
    });
  };
  if (!e.external || e.sharedEmitDoneFor !== e.external) {
    for (const h of [...e.seen.entries()].reverse())
      n(h[0]);
    if (e.target !== "openapi-3.0")
      for (const h of e.seen.entries())
        Yg(h[1].def ?? h[1].schema);
    for (const h of e.deferred)
      h();
    if (e.intersections.length) {
      const h = /* @__PURE__ */ new Map();
      for (const E of e.seen.values())
        for (const d of [E.schema, E.def]) {
          const g = d == null ? void 0 : d.allOf;
          if (!Array.isArray(g))
            continue;
          const y = h.get(g);
          y ? y.push(d) : h.set(g, [d]);
        }
      for (const E of e.intersections)
        for (const d of h.get(E) ?? [])
          O_(d);
    }
  }
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (a = e.external) != null && a.uri) {
    const h = (l = e.external.registry.get(t)) == null ? void 0 : l.id;
    if (!h)
      throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(h);
  }
  Do(i, r.defId ? r.schema : r.def ?? r.schema);
  const o = (f = e.metadataRegistry.get(t)) == null ? void 0 : f.id;
  o !== void 0 && i.id === o && delete i.id;
  const s = ((u = e.external) == null ? void 0 : u.defs) ?? {};
  if (!e.external || e.sharedEmitDoneFor !== e.external)
    for (const h of e.seen.entries()) {
      const E = h[1];
      E.def && E.defId && (E.def.id === E.defId && delete E.def.id, kr(s, E.defId, E.def));
    }
  e.external && (e.sharedEmitDoneFor = e.external), e.external || Object.keys(s).length > 0 && (e.target === "draft-2020-12" ? i.$defs = s : i.definitions = s);
  try {
    const h = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(h, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Ps(t, "input", e.processors),
          output: Ps(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), h;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function At(e, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const n = e._zod.def;
  if (n.type === "transform")
    return !0;
  if (n.type === "array")
    return At(n.element, r);
  if (n.type === "set")
    return At(n.valueType, r);
  if (n.type === "lazy")
    return At(n.getter(), r);
  if (n.type === "promise" || n.type === "optional" || n.type === "nonoptional" || n.type === "nullable" || n.type === "readonly" || n.type === "default" || n.type === "prefault" || n.type === "catch")
    return At(n.innerType, r);
  if (n.type === "intersection")
    return At(n.left, r) || At(n.right, r);
  if (n.type === "record" || n.type === "map")
    return At(n.keyType, r) || At(n.valueType, r);
  if (n.type === "pipe")
    return e._zod.traits.has("$ZodCodec") ? !0 : At(n.in, r) || At(n.out, r);
  if (n.type === "object") {
    for (const i in n.shape)
      if (At(n.shape[i], r))
        return !0;
    return !1;
  }
  if (n.type === "union") {
    for (const i of n.options)
      if (At(i, r))
        return !0;
    return !1;
  }
  if (n.type === "tuple") {
    for (const i of n.items)
      if (At(i, r))
        return !0;
    return !!(n.rest && At(n.rest, r));
  }
  return !1;
}
const w_ = (e, t = {}) => (r) => {
  const n = qg({ ...r, processors: t });
  return rt(e, n), Hg(n, e), Jg(n, e);
}, Ps = (e, t, r = {}) => (n) => {
  const { libraryOptions: i, target: o } = n ?? {}, s = qg({ ...i ?? {}, target: o, io: t, processors: r });
  return rt(e, s), Hg(s, e), Jg(s, e);
}, Ei = (e, t, r) => {
  (e[t] === void 0 || r > e[t]) && (e[t] = r);
}, gi = (e, t, r) => {
  (e[t] === void 0 || r < e[t]) && (e[t] = r);
}, Bf = (e, t) => {
  Ei(e, "minimum", t), gi(e, "maximum", t);
}, Kg = (e, t) => {
  e.multipleOf ?? (e.multipleOf = []), e.multipleOf.includes(t) || e.multipleOf.push(t);
}, Xg = (e, t) => {
  e.patterns ?? (e.patterns = /* @__PURE__ */ new Set()), e.patterns.add(t);
}, Qg = (e, t) => {
  e.mime = e.mime ? e.mime.filter((r) => t.includes(r)) : [...t];
}, ey = (e, t) => {
  e.format = t, t.includes("int") && (e.isInt = !0);
}, Vf = (e, t) => Ei(e, "minimum", t.minimum), Wf = (e, t) => gi(e, "maximum", t.maximum), qf = (e) => (t, r) => {
  ey(t, r.format);
  const [n, i] = e[r.format];
  Ei(t, "minimum", n), gi(t, "maximum", i);
}, Ma = {
  greater_than: (e, t) => Ei(e, t.inclusive ? "minimum" : "exclusiveMinimum", t.value),
  less_than: (e, t) => gi(e, t.inclusive ? "maximum" : "exclusiveMaximum", t.value),
  multiple_of: (e, t) => Kg(e, t.value),
  number_format: qf(ag),
  bigint_format: qf(xA),
  min_length: Vf,
  max_length: Wf,
  length_equals: (e, t) => Bf(e, t.length),
  min_size: Vf,
  max_size: Wf,
  size_equals: (e, t) => Bf(e, t.size),
  string_format: (e, t) => {
    ey(e, t.format), t.pattern && Xg(e, t.pattern), (t.format === "base64" || t.format === "base64url") && (e.contentEncoding = t.format), (t.local || t.precision === -1) && (e.laxFormat = !0);
  },
  mime_type: (e, t) => Qg(e, t.mime)
};
function Ot(e) {
  var o;
  const t = {}, r = e._zod.def, n = e._zod.traits.has("$ZodCheck") ? [e, ...r.checks ?? []] : r.checks ?? [];
  for (const s of n)
    (o = Ma[s._zod.def.check]) == null || o.call(Ma, t, s._zod.def);
  const i = e._zod.bag;
  i.minimum !== void 0 && Ei(t, "minimum", i.minimum), i.exclusiveMinimum !== void 0 && Ei(t, "exclusiveMinimum", i.exclusiveMinimum), i.maximum !== void 0 && gi(t, "maximum", i.maximum), i.exclusiveMaximum !== void 0 && gi(t, "exclusiveMaximum", i.exclusiveMaximum), i.multipleOf !== void 0 && Kg(t, i.multipleOf), i.format !== void 0 && (t.format ?? (t.format = i.format), i.format.includes("int") && (t.isInt = !0)), i.mime && Qg(t, i.mime);
  for (const s of i.patterns ?? [])
    Xg(t, s);
  return t;
}
const N_ = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, C_ = /* @__PURE__ */ new Map([
  [Ng, Tv],
  [xl, bv]
]), ty = (e) => C_.get(e) ?? e, P_ = (e, t, r, n) => {
  const i = r;
  i.type = "string";
  const { minimum: o, maximum: s, format: a, patterns: l, contentEncoding: f, laxFormat: u } = Ot(e);
  if (typeof o == "number" && (i.minLength = o), typeof s == "number" && (i.maxLength = s), a && (i.format = N_[a] ?? a, i.format === "" && delete i.format, (a === "time" || u) && delete i.format), f && (i.contentEncoding = f), l && l.size > 0) {
    const h = [...l].map(ty);
    h.length === 1 ? i.pattern = h[0].source : h.length > 1 && (i.allOf = [
      ...h.map((E) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: E.source
      }))
    ]);
  }
}, D_ = (e, t, r, n) => {
  const i = r, { minimum: o, maximum: s, multipleOf: a, exclusiveMaximum: l, exclusiveMinimum: f, isInt: u } = Ot(e);
  i.type = u ? "integer" : "number";
  const h = typeof f == "number" && f >= (o ?? Number.NEGATIVE_INFINITY), E = typeof l == "number" && l <= (s ?? Number.POSITIVE_INFINITY), d = t.target === "draft-04" || t.target === "openapi-3.0";
  if (h ? d ? (i.minimum = f, i.exclusiveMinimum = !0) : i.exclusiveMinimum = f : typeof o == "number" && (i.minimum = o), E ? d ? (i.maximum = l, i.exclusiveMaximum = !0) : i.exclusiveMaximum = l : typeof s == "number" && (i.maximum = s), a) {
    const g = /* @__PURE__ */ new Set();
    for (const I of a)
      Number.isFinite(I) && I !== 0 ? g.add(Math.abs(I)) : er(e, t, i, n, `A multipleOf divisor of ${I} cannot be represented in JSON Schema`);
    const [y, ...b] = g;
    y !== void 0 && (i.multipleOf = y), b.length && (i.allOf = [...i.allOf ?? [], ...b.map((I) => ({ multipleOf: I }))]);
  }
}, M_ = (e, t, r, n) => {
  r.type = "boolean";
}, L_ = (e, t, r, n) => {
  er(e, t, r, n, "Undefined cannot be represented in JSON Schema");
}, x_ = (e, t, r, n) => {
  r.not = {};
}, k_ = (e, t, r, n) => {
}, j_ = (e, t, r, n) => {
  er(e, t, r, n, "Date cannot be represented in JSON Schema");
}, U_ = (e, t, r, n) => {
  const i = e._zod.def, o = Ru(i.entries);
  if (o.length === 0) {
    r.not = {};
    return;
  }
  o.every((s) => typeof s == "number") && (r.type = "number"), o.every((s) => typeof s == "string") && (r.type = "string"), r.enum = o;
}, $_ = (e, t, r, n) => {
  const i = e._zod.def;
  if (i.values.length === 0) {
    r.not = {};
    return;
  }
  const o = [];
  for (const s of i.values)
    if (s === void 0) {
      if (er(e, t, r, n, "Literal `undefined` cannot be represented in JSON Schema"))
        return;
    } else if (typeof s == "bigint") {
      if (er(e, t, r, n, "BigInt literals cannot be represented in JSON Schema"))
        return;
      o.push(Number(s));
    } else
      o.push(s);
  if (o.length !== 0) if (o.length === 1) {
    const s = o[0];
    r.type = s === null ? "null" : typeof s, t.target === "draft-04" || t.target === "openapi-3.0" ? r.enum = [s] : r.const = s;
  } else
    o.every((s) => typeof s == "number") && (r.type = "number"), o.every((s) => typeof s == "string") && (r.type = "string"), o.every((s) => typeof s == "boolean") && (r.type = "boolean"), o.every((s) => s === null) && (r.type = "null"), r.enum = o;
}, F_ = (e, t, r, n) => {
  er(e, t, r, n, "Custom types cannot be represented in JSON Schema");
}, z_ = (e, t, r, n) => {
  er(e, t, r, n, "Transforms cannot be represented in JSON Schema");
}, G_ = (e, t, r, n) => {
  er(e, t, r, n, "Map cannot be represented in JSON Schema");
}, B_ = (e, t, r, n) => {
  const i = r, o = e._zod.def, { minimum: s, maximum: a } = Ot(e);
  typeof s == "number" && (i.minItems = s), typeof a == "number" && (i.maxItems = a), i.type = "array", i.items = rt(o.element, t, {
    ...n,
    path: [...n.path, "items"]
  });
};
function ko(e) {
  const t = e._zod.def;
  return t.type === "pipe" && t.in._zod.traits.has("$ZodTransform") ? ko(t.out) : t.type === "catch" ? ko(t.innerType) : e._zod.optin;
}
const V_ = (e, t, r, n) => {
  var f;
  const i = r, o = e._zod.def, s = o.shape;
  if (Object.getOwnPropertySymbols(s).length && er(e, t, i, n, "Symbol keys cannot be represented in JSON Schema"))
    return;
  i.type = "object", i.properties = {};
  for (const u in s)
    kr(i.properties, u, rt(s[u], t, {
      ...n,
      path: [...n.path, "properties", u]
    }));
  const l = [];
  for (const u of Object.keys(s)) {
    const h = o.shape[u];
    (t.io === "input" ? ko(h) === void 0 : h._zod.optout === void 0) && l.push(u);
  }
  l.length > 0 && (i.required = l), ((f = o.catchall) == null ? void 0 : f._zod.def.type) === "never" ? i.additionalProperties = !1 : o.catchall ? o.catchall && (i.additionalProperties = rt(o.catchall, t, {
    ...n,
    path: [...n.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, W_ = (e, t, r, n) => {
  const i = e._zod.def, o = i.inclusive === !1, s = i.options.map((a, l) => rt(a, t, {
    ...n,
    path: [...n.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? r.oneOf = s : r.anyOf = s;
}, q_ = (e, t, r, n) => {
  const i = e._zod.def, o = rt(i.left, t, {
    ...n,
    path: [...n.path, "allOf", 0]
  }), s = rt(i.right, t, {
    ...n,
    path: [...n.path, "allOf", 1]
  }), a = (f) => "allOf" in f && Object.keys(f).length === 1, l = [
    ...a(o) ? o.allOf : [o],
    ...a(s) ? s.allOf : [s]
  ];
  r.allOf = l, t.intersections.push(l);
}, H_ = (e, t, r, n) => {
  const i = r, o = e._zod.def;
  i.type = "array";
  const s = t.target === "draft-2020-12" ? "prefixItems" : "items", a = t.target === "draft-2020-12" || t.target === "openapi-3.0" ? "items" : "additionalItems", l = o.items.map((y, b) => rt(y, t, {
    ...n,
    path: [...n.path, s, b]
  })), f = o.rest ? rt(o.rest, t, {
    ...n,
    path: [...n.path, a, ...t.target === "openapi-3.0" ? [o.items.length] : []]
  }) : null;
  let u = o.items.length;
  for (; u > 0; ) {
    const y = o.items[u - 1];
    if (!(t.io === "input" ? ko(y) !== void 0 : y._zod.optout === "optional"))
      break;
    u--;
  }
  const h = o.items.length, E = !o.rest;
  t.target === "draft-2020-12" ? (i.prefixItems = l, E ? i.items = !1 : f && (i.items = f), u > 0 && (i.minItems = u), E && (i.maxItems = h)) : t.target === "openapi-3.0" ? (i.items = {
    anyOf: l
  }, f && i.items.anyOf.push(f), u > 0 && (i.minItems = u), E && (i.maxItems = h)) : (i.items = l, E ? i.additionalItems = !1 : f && (i.additionalItems = f), u > 0 && (i.minItems = u), E && (i.maxItems = h));
  const { minimum: d, maximum: g } = Ot(e);
  typeof d == "number" && (i.minItems = d), typeof g == "number" && (i.maxItems = g);
};
function ju(e, t, r) {
  var g;
  if (t.$ref) {
    if (r.has(t))
      return t;
    r.add(t);
    const y = (g = e.get(t)) == null ? void 0 : g.def;
    if (!y)
      return t;
    const b = ju(e, y, r);
    return b === y ? t : b;
  }
  for (const y of ["anyOf", "oneOf"]) {
    const b = t[y];
    if (!Array.isArray(b))
      continue;
    const I = b.map((S) => ju(e, S, r));
    I.some((S, w) => S !== b[w]) && (t = { ...t, [y]: I });
  }
  const n = Array.isArray(t.type) ? t.type : [t.type], i = !n.includes("string") && n.some((y) => y === "number" || y === "integer"), o = t.enum ?? (t.const !== void 0 ? [t.const] : void 0);
  if (!i && !(o != null && o.some((y) => typeof y == "number")))
    return t;
  const { minimum: s, maximum: a, exclusiveMinimum: l, exclusiveMaximum: f, multipleOf: u, format: h, id: E, ...d } = t;
  return d.enum ? d.enum = d.enum.map((y) => typeof y == "number" ? String(y) : y) : typeof d.const == "number" && (d.const = String(d.const)), i && (d.type = "string", o || (d.pattern = (n.includes("number") ? Qs : Cv).source)), d;
}
const Uu = /* @__PURE__ */ new WeakMap();
function Y_(e) {
  var n;
  const t = /* @__PURE__ */ new Map();
  for (const i of e.seen.values())
    i.def && !t.has(i.schema) && t.set(i.schema, i);
  const r = /* @__PURE__ */ new Map();
  for (const i of Uu.get(e) ?? []) {
    const o = e.seen.get(i), s = (n = (o == null ? void 0 : o.def) ?? (o == null ? void 0 : o.schema)) == null ? void 0 : n.propertyNames;
    if (!s || s === !0 || r.has(s))
      continue;
    const a = ju(t, s, /* @__PURE__ */ new Set());
    a !== s && r.set(s, a);
  }
  if (r.size)
    for (const i of e.seen.values())
      for (const o of [i.schema, i.def]) {
        const s = o && r.get(o.propertyNames);
        s && (o.propertyNames = s);
      }
}
const Z_ = (e, t, r, n) => {
  const i = r, o = e._zod.def;
  i.type = "object";
  const s = o.keyType, a = Ot(s).patterns;
  if (o.mode === "loose" && a && a.size > 0) {
    const u = rt(o.valueType, t, {
      ...n,
      path: [...n.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const h of a)
      kr(i.patternProperties, ty(h).source, u);
  } else {
    if (t.target === "draft-07" || t.target === "draft-2020-12") {
      i.propertyNames = rt(o.keyType, t, {
        ...n,
        path: [...n.path, "propertyNames"]
      });
      let u = Uu.get(t);
      u || (u = [], Uu.set(t, u), t.deferred.push(() => Y_(t))), u.push(e);
    }
    i.additionalProperties = rt(o.valueType, t, {
      ...n,
      path: [...n.path, "additionalProperties"]
    });
  }
  const l = s._zod.values, f = t.io === "input" && ko(o.valueType) !== void 0;
  if (l && !o.partial && !f) {
    const u = [...l].filter((h) => typeof h == "string" || typeof h == "number");
    u.length > 0 && (i.required = u.map(String));
  }
}, J_ = (e, t, r, n) => {
  const i = e._zod.def, o = rt(i.innerType, t, n), s = t.seen.get(e);
  t.target === "openapi-3.0" ? (s.ref = i.innerType, r.nullable = !0) : r.anyOf = [o, { type: "null" }];
}, K_ = (e, t, r, n) => {
  const i = e._zod.def;
  rt(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Fl = Symbol();
function ry(e, t, r, n, i) {
  let o = !1;
  const s = JSON.stringify(e, (a, l) => typeof l != "bigint" ? l : (o = !0, null));
  return o ? (er(t, r, n, i, "BigInt defaults cannot be represented in JSON Schema"), Fl) : JSON.parse(s);
}
const X_ = (e, t, r, n) => {
  const i = e._zod.def;
  rt(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  const s = ry(i.defaultValue, e, t, r, n);
  s !== Fl && (r.default = s);
}, Q_ = (e, t, r, n) => {
  const i = e._zod.def;
  rt(i.innerType, t, n);
  const o = t.seen.get(e);
  if (o.ref = i.innerType, t.io !== "input")
    return;
  const s = ry(i.defaultValue, e, t, r, n);
  s !== Fl && (r._prefault = s);
}, eR = (e, t, r, n) => {
  const i = e._zod.def;
  rt(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let s;
  try {
    s = i.catchValue(void 0);
  } catch {
    er(e, t, r, n, "Dynamic catch values are not supported in JSON Schema");
    return;
  }
  r.default = s;
}, tR = (e, t, r, n) => {
  const i = e._zod.def, o = i.in._zod.traits.has("$ZodTransform"), s = t.io === "input" ? o ? i.out : i.in : i.out;
  rt(s, t, n);
  const a = t.seen.get(e);
  a.ref = s;
}, rR = (e, t, r, n) => {
  const i = e._zod.def;
  rt(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.readOnly = !0;
}, ny = (e, t, r, n) => {
  const i = e._zod.def;
  rt(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
};
let La = !1;
vt.postProcessor = (e) => {
  var n;
  if (La)
    return;
  const t = (n = e._zod) == null ? void 0 : n.run;
  if (typeof t != "function")
    return;
  const r = (i, o) => {
    if (o != null && o.async || (o == null ? void 0 : o.direction) === "backward" || o != null && o.skipChecks)
      return t(i, o);
    La = !0;
    try {
      if (vt.jitless)
        return e._zod.run = t, t(i, o);
      const s = O0(e, { strict: !0 });
      e._zod.run = s._zod.run, e._zod.bag.fallbackRun = s._zod.bag.fallbackRun, e._zod.bag.validator = s._zod.bag.validator;
    } catch {
      e._zod.run = t;
    } finally {
      La = !1;
    }
    return e._zod.run(i, o);
  };
  r.__originalRun = t, e._zod.run = r;
};
const Hf = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]);
function ns(e, t, r) {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    get() {
      const n = r(this);
      return Object.defineProperty(this, t, { value: n, configurable: !0, writable: !0 }), n;
    },
    set(n) {
      Object.defineProperty(this, t, { value: n, configurable: !0, writable: !0 });
    }
  });
}
const nR = (e, t) => {
  eS.init(e, t), e.name = "ZodError";
  const r = Object.getPrototypeOf(e);
  Hf.has(r) || (Hf.add(r), ns(r, "format", (n) => (i) => nS(n, i)), ns(r, "flatten", (n) => (i) => rS(n, i)), ns(r, "addIssue", (n) => (i) => {
    n.issues.push(i), n.message = JSON.stringify(n.issues, Ou, 2);
  }), ns(r, "addIssues", (n) => (i) => {
    n.issues.push(...i), n.message = JSON.stringify(n.issues, Ou, 2);
  }), Object.defineProperty(r, "isEmpty", {
    configurable: !0,
    enumerable: !1,
    get() {
      return this.issues.length === 0;
    }
  }));
}, Wt = /* @__PURE__ */ Y("ZodError", nR, void 0, {
  Parent: Error
}), iR = /* @__PURE__ */ wl(Wt), oR = /* @__PURE__ */ Nl(Wt), sR = /* @__PURE__ */ Cl(Wt), aR = /* @__PURE__ */ Pl(Wt), uR = /* @__PURE__ */ lS(Wt), lR = /* @__PURE__ */ cS(Wt), cR = /* @__PURE__ */ fS(Wt), fR = /* @__PURE__ */ dS(Wt), dR = /* @__PURE__ */ pS(Wt), pR = /* @__PURE__ */ hS(Wt), hR = /* @__PURE__ */ mS(Wt), mR = /* @__PURE__ */ ES(Wt);
function ER() {
  vt.localeError || Gt(wI());
}
function Oi() {
  vt.memoizer || Gt({ memoizer: rv() });
}
const Ge = /* @__PURE__ */ Y("ZodType", (e, t) => (ER(), ze.init(e, t), e.def = t, e.type = t.type, e), {
  check(...e) {
    const t = this.def;
    return this.clone(Mt(t, {
      checks: [
        ...t.checks ?? [],
        ...e.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
      ]
    }), { parent: !0 });
  },
  with(...e) {
    return this.check(...e);
  },
  clone(e, t) {
    return jr(this, e, t);
  },
  brand() {
    return this;
  },
  register(e, t) {
    return e.add(this, t), this;
  },
  refine(e, t) {
    return this.check(pO(e, t));
  },
  superRefine(e, t) {
    return this.check(hO(e, t));
  },
  overwrite(e) {
    return this.check(/* @__PURE__ */ Ri(e));
  },
  optional() {
    return Yf(this);
  },
  exactOptional() {
    return eO(this);
  },
  nullable() {
    return Zf(this);
  },
  nullish() {
    return Yf(Zf(this));
  },
  nonoptional(e) {
    return sO(this, e);
  },
  array() {
    return k(this);
  },
  or(e) {
    return bt([this, e]);
  },
  and(e) {
    return ZR(this, e);
  },
  transform(e) {
    return Jf(this, ly(e));
  },
  default(e) {
    return nO(this, e);
  },
  prefault(e) {
    return oO(this, e);
  },
  catch(e) {
    return uO(this, e);
  },
  pipe(e) {
    return Jf(this, e);
  },
  readonly() {
    return fO(this);
  },
  describe(e) {
    const t = this.clone();
    return Oo.add(t, { description: e }), t;
  },
  meta(...e) {
    if (e.length === 0)
      return Oo.get(this);
    const t = this.clone();
    return Oo.add(t, e[0]), t;
  },
  isOptional() {
    return this.safeParse(void 0).success;
  },
  isNullable() {
    return this.safeParse(null).success;
  },
  apply(e, ...t) {
    return t.length === 0 ? e(this) : e(this, ...t);
  },
  // Overrides core's `~standard` to add `jsonSchema`. Must stay a prototype entry: redefining it per instance demotes instances to dictionary mode.
  get "~standard"() {
    return lg(this, "~standard", {
      ...vg(this),
      jsonSchema: {
        input: Ps(this, "input"),
        output: Ps(this, "output")
      }
    });
  },
  set "~standard"(e) {
    Zr(this, "~standard", e);
  },
  parse: function e(t, r) {
    return iR(this, t, r, { callee: e });
  },
  parseAsync: async function e(t, r) {
    return await oR(this, t, r, { callee: e });
  },
  safeParse(e, t) {
    return sR(this, e, t);
  },
  async safeParseAsync(e, t) {
    return aR(this, e, t);
  },
  // `spa` is an alias: same function object as `safeParseAsync`, as before.
  get spa() {
    return this == null ? void 0 : this.safeParseAsync;
  },
  set spa(e) {
    Zr(this, "spa", e);
  },
  validate(e, t) {
    return sS(this, e, t);
  },
  validateAsync(e, t) {
    return uS(this, e, t);
  },
  encode: function e(t, r) {
    return uR(this, t, r, { callee: e });
  },
  decode: function e(t, r) {
    return lR(this, t, r, { callee: e });
  },
  encodeAsync: async function e(t, r) {
    return await cR(this, t, r, { callee: e });
  },
  decodeAsync: async function e(t, r) {
    return await fR(this, t, r, { callee: e });
  },
  safeEncode(e, t) {
    return dR(this, e, t);
  },
  safeDecode(e, t) {
    return pR(this, e, t);
  },
  async safeEncodeAsync(e, t) {
    return hR(this, e, t);
  },
  async safeDecodeAsync(e, t) {
    return mR(this, e, t);
  },
  toJSONSchema(e) {
    return w_(this, {})(e);
  },
  // Reads through to the registry on every access, so it must not cache.
  get description() {
    var e;
    return (e = Oo.get(this)) == null ? void 0 : e.description;
  },
  // No setter: `schema._def = x` throws, as it did when `_def` was a non-writable own property.
  get _def() {
    return this._zod.def;
  }
}), iy = /* @__PURE__ */ Y(
  "_ZodString",
  (e, t) => {
    Dl.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => P_(e, r, n);
  },
  /* @__PURE__ */ _l({
    format: (e) => Ot(e).format ?? null,
    minLength: (e) => Ot(e).minimum ?? null,
    maxLength: (e) => Ot(e).maximum ?? null
  }, {
    regex(...e) {
      return this.check(/* @__PURE__ */ d_(...e));
    },
    includes(...e) {
      return this.check(/* @__PURE__ */ m_(...e));
    },
    startsWith(...e) {
      return this.check(/* @__PURE__ */ E_(...e));
    },
    endsWith(...e) {
      return this.check(/* @__PURE__ */ g_(...e));
    },
    min(...e) {
      return this.check(/* @__PURE__ */ Cs(...e));
    },
    max(...e) {
      return this.check(/* @__PURE__ */ Vg(...e));
    },
    length(...e) {
      return this.check(/* @__PURE__ */ Wg(...e));
    },
    nonempty(...e) {
      return this.check(/* @__PURE__ */ Cs(1, ...e));
    },
    lowercase(e) {
      return this.check(/* @__PURE__ */ p_(e));
    },
    uppercase(e) {
      return this.check(/* @__PURE__ */ h_(e));
    },
    trim() {
      return this.check(/* @__PURE__ */ T_());
    },
    normalize(...e) {
      return this.check(/* @__PURE__ */ y_(...e));
    },
    toLowerCase() {
      return this.check(/* @__PURE__ */ b_());
    },
    toUpperCase() {
      return this.check(/* @__PURE__ */ A_());
    },
    slugify() {
      return this.check(/* @__PURE__ */ v_());
    }
  })
), gR = /* @__PURE__ */ Y("ZodString", (e, t) => {
  Dl.init(e, t), iy.init(e, t);
}, {
  email(e) {
    return this.check(/* @__PURE__ */ DI(AR, e));
  },
  url(e) {
    return this.check(/* @__PURE__ */ UI(SR, e));
  },
  jwt(e) {
    return this.check(/* @__PURE__ */ Gg(sy, e));
  },
  emoji(e) {
    return this.check(/* @__PURE__ */ $I(IR, e));
  },
  guid(e) {
    return this.check(/* @__PURE__ */ MI(vR, e));
  },
  uuid(e) {
    return this.check(/* @__PURE__ */ LI(is, e));
  },
  uuidv4(e) {
    return this.check(/* @__PURE__ */ xI(is, e));
  },
  uuidv6(e) {
    return this.check(/* @__PURE__ */ kI(is, e));
  },
  uuidv7(e) {
    return this.check(/* @__PURE__ */ jI(is, e));
  },
  nanoid(e) {
    return this.check(/* @__PURE__ */ FI(_R, e));
  },
  cuid(e) {
    return this.check(/* @__PURE__ */ zI(RR, e));
  },
  cuid2(e) {
    return this.check(/* @__PURE__ */ GI(OR, e));
  },
  ulid(e) {
    return this.check(/* @__PURE__ */ BI(wR, e));
  },
  base64(e) {
    return this.check(/* @__PURE__ */ JI(xR, e));
  },
  base64url(e) {
    return this.check(/* @__PURE__ */ KI(kR, e));
  },
  xid(e) {
    return this.check(/* @__PURE__ */ VI(NR, e));
  },
  ksuid(e) {
    return this.check(/* @__PURE__ */ WI(CR, e));
  },
  ipv4(e) {
    return this.check(/* @__PURE__ */ qI(PR, e));
  },
  ipv6(e) {
    return this.check(/* @__PURE__ */ HI(DR, e));
  },
  cidrv4(e) {
    return this.check(/* @__PURE__ */ YI(MR, e));
  },
  cidrv6(e) {
    return this.check(/* @__PURE__ */ ZI(LR, e));
  },
  e164(e) {
    return this.check(/* @__PURE__ */ XI(jR, e));
  },
  datetime(e) {
    return this.check(/* @__PURE__ */ Bg(oy, e));
  },
  date(e) {
    return this.check(/* @__PURE__ */ QI(yR, e));
  },
  time(e) {
    return this.check(/* @__PURE__ */ e_(TR, e));
  },
  duration(e) {
    return this.check(/* @__PURE__ */ t_(bR, e));
  }
});
function A(e) {
  return /* @__PURE__ */ PI(gR, e);
}
const Qe = /* @__PURE__ */ Y("ZodStringFormat", (e, t) => {
  Ke.init(e, t), iy.init(e, t);
}), oy = /* @__PURE__ */ Y("ZodISODateTime", (e, t) => {
  DS.init(e, t), Qe.init(e, t);
}), yR = /* @__PURE__ */ Y("ZodISODate", (e, t) => {
  MS.init(e, t), Qe.init(e, t);
}), TR = /* @__PURE__ */ Y("ZodISOTime", (e, t) => {
  LS.init(e, t), Qe.init(e, t);
}), bR = /* @__PURE__ */ Y("ZodISODuration", (e, t) => {
  xS.init(e, t), Qe.init(e, t);
}), AR = /* @__PURE__ */ Y("ZodEmail", (e, t) => {
  AS.init(e, t), Qe.init(e, t);
}), vR = /* @__PURE__ */ Y("ZodGUID", (e, t) => {
  TS.init(e, t), Qe.init(e, t);
}), is = /* @__PURE__ */ Y("ZodUUID", (e, t) => {
  bS.init(e, t), Qe.init(e, t);
}), SR = /* @__PURE__ */ Y("ZodURL", (e, t) => {
  IS.init(e, t), Qe.init(e, t);
}), IR = /* @__PURE__ */ Y("ZodEmoji", (e, t) => {
  _S.init(e, t), Qe.init(e, t);
}), _R = /* @__PURE__ */ Y("ZodNanoID", (e, t) => {
  RS.init(e, t), Qe.init(e, t);
}), RR = /* @__PURE__ */ Y("ZodCUID", (e, t) => {
  OS.init(e, t), Qe.init(e, t);
}), OR = /* @__PURE__ */ Y("ZodCUID2", (e, t) => {
  wS.init(e, t), Qe.init(e, t);
}), wR = /* @__PURE__ */ Y("ZodULID", (e, t) => {
  NS.init(e, t), Qe.init(e, t);
}), NR = /* @__PURE__ */ Y("ZodXID", (e, t) => {
  CS.init(e, t), Qe.init(e, t);
}), CR = /* @__PURE__ */ Y("ZodKSUID", (e, t) => {
  PS.init(e, t), Qe.init(e, t);
}), PR = /* @__PURE__ */ Y("ZodIPv4", (e, t) => {
  kS.init(e, t), Qe.init(e, t);
}), DR = /* @__PURE__ */ Y("ZodIPv6", (e, t) => {
  US.init(e, t), Qe.init(e, t);
}), MR = /* @__PURE__ */ Y("ZodCIDRv4", (e, t) => {
  $S.init(e, t), Qe.init(e, t);
}), LR = /* @__PURE__ */ Y("ZodCIDRv6", (e, t) => {
  FS.init(e, t), Qe.init(e, t);
}), xR = /* @__PURE__ */ Y("ZodBase64", (e, t) => {
  zS.init(e, t), Qe.init(e, t);
}), kR = /* @__PURE__ */ Y("ZodBase64URL", (e, t) => {
  GS.init(e, t), Qe.init(e, t);
}), jR = /* @__PURE__ */ Y("ZodE164", (e, t) => {
  BS.init(e, t), Qe.init(e, t);
}), sy = /* @__PURE__ */ Y("ZodJWT", (e, t) => {
  ZS.init(e, t), Qe.init(e, t);
});
function UR(e) {
  return /* @__PURE__ */ Gg(sy, e);
}
const zl = /* @__PURE__ */ Y(
  "ZodNumber",
  (e, t) => {
    Dg.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => D_(e, r, n, i), e.isFinite = !0;
  },
  /* @__PURE__ */ _l({
    minValue: (e) => {
      const { minimum: t, exclusiveMinimum: r } = Ot(e);
      return Math.max(t ?? Number.NEGATIVE_INFINITY, r ?? Number.NEGATIVE_INFINITY);
    },
    maxValue: (e) => {
      const { maximum: t, exclusiveMaximum: r } = Ot(e);
      return Math.min(t ?? Number.POSITIVE_INFINITY, r ?? Number.POSITIVE_INFINITY);
    },
    isInt: (e) => {
      const { isInt: t, multipleOf: r } = Ot(e);
      return !!t || !!(r != null && r.some(Number.isSafeInteger));
    },
    format: (e) => Ot(e).format ?? null
  }, {
    gt(e, t) {
      return this.check(/* @__PURE__ */ jf(e, t));
    },
    gte(e, t) {
      return this.check(/* @__PURE__ */ bs(e, t));
    },
    min(e, t) {
      return this.check(/* @__PURE__ */ bs(e, t));
    },
    lt(e, t) {
      return this.check(/* @__PURE__ */ kf(e, t));
    },
    lte(e, t) {
      return this.check(/* @__PURE__ */ Ts(e, t));
    },
    max(e, t) {
      return this.check(/* @__PURE__ */ Ts(e, t));
    },
    int(e) {
      return this.check($u(e));
    },
    safe(e) {
      return this.check($u(e));
    },
    positive(e) {
      return this.check(/* @__PURE__ */ jf(0, e));
    },
    nonnegative(e) {
      return this.check(/* @__PURE__ */ bs(0, e));
    },
    negative(e) {
      return this.check(/* @__PURE__ */ kf(0, e));
    },
    nonpositive(e) {
      return this.check(/* @__PURE__ */ Ts(0, e));
    },
    multipleOf(e, t) {
      return this.check(/* @__PURE__ */ Uf(e, t));
    },
    step(e, t) {
      return this.check(/* @__PURE__ */ Uf(e, t));
    },
    finite() {
      return this;
    }
  })
);
function R(e) {
  return /* @__PURE__ */ r_(zl, e);
}
const $R = /* @__PURE__ */ Y("ZodNumberFormat", (e, t) => {
  JS.init(e, t), zl.init(e, t);
});
function $u(e) {
  return /* @__PURE__ */ i_($R, e);
}
const FR = /* @__PURE__ */ Y("ZodBoolean", (e, t) => {
  KS.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => M_(e, r, n);
});
function oe(e) {
  return /* @__PURE__ */ o_(FR, e);
}
const zR = /* @__PURE__ */ Y("ZodUndefined", (e, t) => {
  XS.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => L_(e, r, n, i);
});
function Yr(e) {
  return /* @__PURE__ */ s_(zR, e);
}
const GR = /* @__PURE__ */ Y("ZodUnknown", (e, t) => {
  QS.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => k_();
});
function at() {
  return /* @__PURE__ */ a_(GR);
}
const BR = /* @__PURE__ */ Y("ZodNever", (e, t) => {
  e0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => x_(e, r, n);
});
function VR(e) {
  return /* @__PURE__ */ u_(BR, e);
}
const WR = /* @__PURE__ */ Y(
  "ZodDate",
  (e, t) => {
    t0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => j_(e, r, n, i), e.min = (r, n) => e.check(/* @__PURE__ */ bs(r, n)), e.max = (r, n) => e.check(/* @__PURE__ */ Ts(r, n));
  },
  /* @__PURE__ */ _l({
    minDate: (e) => {
      const { minimum: t } = Ot(e);
      return t ? new Date(t) : null;
    },
    maxDate: (e) => {
      const { maximum: t } = Ot(e);
      return t ? new Date(t) : null;
    }
  }, {})
), qR = /* @__PURE__ */ Y("ZodArray", (e, t) => {
  Oi(), i0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => B_(e, r, n, i), e.element = t.element;
}, {
  min(e, t) {
    return this.check(/* @__PURE__ */ Cs(e, t));
  },
  nonempty(e) {
    return this.check(/* @__PURE__ */ Cs(1, e));
  },
  max(e, t) {
    return this.check(/* @__PURE__ */ Vg(e, t));
  },
  length(e, t) {
    return this.check(/* @__PURE__ */ Wg(e, t));
  },
  unwrap() {
    return this.element;
  }
});
function k(e, t) {
  return /* @__PURE__ */ S_(qR, e, t);
}
const ay = /* @__PURE__ */ Y("ZodObject", (e, t) => {
  Oi(), a0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => V_(e, r, n, i), ZA(e, "shape", (r) => r._zod.def.shape, !1);
}, {
  keyof() {
    return pe(Object.keys(this._zod.def.shape));
  },
  catchall(e) {
    return this.clone(Mt(this._zod.def, { catchall: e }));
  },
  passthrough() {
    return this.clone(Mt(this._zod.def, { catchall: at() }));
  },
  loose() {
    return this.clone(Mt(this._zod.def, { catchall: at() }));
  },
  strict() {
    return this.clone(Mt(this._zod.def, { catchall: VR() }));
  },
  strip() {
    return this.clone(Mt(this._zod.def, { catchall: void 0 }));
  },
  extend(e) {
    return UA(this, e);
  },
  safeExtend(e) {
    return $A(this, e);
  },
  merge(e) {
    return FA(this, e);
  },
  pick(e) {
    return kA(this, e);
  },
  omit(e) {
    return jA(this, e);
  },
  partial(...e) {
    return ff(Bl, this, e[0]);
  },
  exactPartial(...e) {
    return ff(cy, this, e[0], "exactPartial");
  },
  required(...e) {
    return zA(fy, this, e[0]);
  }
});
function N(e, t) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...se(t)
  };
  return new ay(r);
}
function Xr(e, t) {
  return new ay({
    type: "object",
    shape: e,
    catchall: at(),
    ...se(t)
  });
}
const uy = /* @__PURE__ */ Y("ZodUnion", (e, t) => {
  kg.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => W_(e, r, n, i), e.options = t.options;
});
function bt(e, t) {
  return new uy({
    type: "union",
    options: e,
    ...se(t)
  });
}
const HR = /* @__PURE__ */ Y("ZodDiscriminatedUnion", (e, t) => {
  uy.init(e, t), l0.init(e, t);
});
function cr(e, t, r) {
  return new HR({
    type: "union",
    options: t,
    discriminator: e,
    ...se(r)
  });
}
const YR = /* @__PURE__ */ Y("ZodIntersection", (e, t) => {
  c0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => q_(e, r, n, i);
});
function ZR(e, t) {
  return new YR({
    type: "intersection",
    left: e,
    right: t
  });
}
const JR = /* @__PURE__ */ Y("ZodTuple", (e, t) => {
  Oi(), f0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => H_(e, r, n, i);
}, {
  rest(e) {
    return this.clone({
      ...this._zod.def,
      rest: e
    });
  },
  partial() {
    var t;
    const e = this._zod.def;
    if ((t = e.checks) != null && t.length)
      throw new Error(".partial() cannot be used on tuple schemas containing refinements");
    return this.clone({
      ...e,
      items: e.items.map((r) => new Bl({ type: "optional", innerType: r }))
    });
  }
});
function Gl(e, t, r) {
  const n = t instanceof ze, i = n ? r : t, o = n ? t : null;
  return new JR({
    type: "tuple",
    items: e,
    rest: o,
    ...se(i)
  });
}
const Fu = /* @__PURE__ */ Y("ZodRecord", (e, t) => {
  Oi(), d0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => Z_(e, r, n, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function Lt(e, t, r) {
  return !t || !t._zod ? new Fu({
    type: "record",
    keyType: A(),
    valueType: e,
    ...se(t)
  }) : new Fu({
    type: "record",
    keyType: e,
    valueType: t,
    ...se(r)
  });
}
function dt(e, t, r) {
  return new Fu({
    type: "record",
    keyType: e,
    valueType: t,
    ...se(r),
    partial: !0
  });
}
const KR = /* @__PURE__ */ Y("ZodMap", (e, t) => {
  Oi(), p0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => G_(e, r, n, i), e.keyType = t.keyType, e.valueType = t.valueType, e.min = (...r) => e.check(/* @__PURE__ */ $f(...r)), e.nonempty = (r) => e.check(/* @__PURE__ */ $f(1, r)), e.max = (...r) => e.check(/* @__PURE__ */ c_(...r)), e.size = (...r) => e.check(/* @__PURE__ */ f_(...r));
});
function xa(e, t, r) {
  return new KR({
    type: "map",
    keyType: e,
    valueType: t,
    ...se(r)
  });
}
const zu = /* @__PURE__ */ Y("ZodEnum", (e, t) => {
  h0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (n, i, o) => U_(e, n, i), e.enum = t.entries, e.options = [...e._zod.values];
  const r = new Set(Object.keys(t.entries));
  e.extract = (n, i) => {
    const o = {};
    for (const s of n)
      if (r.has(s))
        o[s] = t.entries[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new zu({
      ...t,
      checks: [],
      ...se(i),
      entries: o
    });
  }, e.exclude = (n, i) => {
    const o = { ...t.entries };
    for (const s of n)
      if (r.has(s))
        delete o[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new zu({
      ...t,
      checks: [],
      ...se(i),
      entries: o
    });
  };
});
function pe(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((n) => [n, n])) : e;
  return new zu({
    type: "enum",
    entries: r,
    ...se(t)
  });
}
const XR = /* @__PURE__ */ Y("ZodLiteral", (e, t) => {
  m0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => $_(e, r, n, i), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function ce(e, t) {
  return new XR({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...se(t)
  });
}
const QR = /* @__PURE__ */ Y("ZodTransform", (e, t) => {
  Oi(), E0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => z_(e, r, n, i), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new fg(e.constructor.name);
    r.addIssue = (o) => {
      if (typeof o == "string")
        r.issues.push(xo(o, r.value, t));
      else {
        const s = o;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), "input" in s || (s.input = r.value), s.inst ?? (s.inst = e), r.issues.push(xo(s));
      }
    };
    const i = t.transform(r.value, r);
    return i instanceof Promise ? i.then((o) => (r.value = o, r)) : (r.value = i, r);
  };
});
function ly(e) {
  return new QR({
    type: "transform",
    transform: e
  });
}
const Bl = /* @__PURE__ */ Y("ZodOptional", (e, t) => {
  jg.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => ny(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function Yf(e) {
  return new Bl({
    type: "optional",
    innerType: e
  });
}
const cy = /* @__PURE__ */ Y("ZodExactOptional", (e, t) => {
  g0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => ny(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function eO(e) {
  return new cy({
    type: "optional",
    innerType: e
  });
}
const tO = /* @__PURE__ */ Y("ZodNullable", (e, t) => {
  y0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => J_(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function Zf(e) {
  return new tO({
    type: "nullable",
    innerType: e
  });
}
const rO = /* @__PURE__ */ Y("ZodDefault", (e, t) => {
  T0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => X_(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function nO(e, t) {
  return new rO({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : vl(t);
    }
  });
}
const iO = /* @__PURE__ */ Y("ZodPrefault", (e, t) => {
  b0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => Q_(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function oO(e, t) {
  return new iO({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : vl(t);
    }
  });
}
const fy = /* @__PURE__ */ Y("ZodNonOptional", (e, t) => {
  A0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => K_(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function sO(e, t) {
  return new fy({
    type: "nonoptional",
    innerType: e,
    ...se(t)
  });
}
const aO = /* @__PURE__ */ Y("ZodCatch", (e, t) => {
  v0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => eR(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function uO(e, t) {
  return new aO({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : JA(t)
  });
}
const dy = /* @__PURE__ */ Y("ZodPipe", (e, t) => {
  Ug.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => tR(e, r, n, i), e.in = t.in, e.out = t.out;
});
function Jf(e, t) {
  return new dy({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const lO = /* @__PURE__ */ Y("ZodPreprocess", (e, t) => {
  dy.init(e, t), S0.init(e, t);
}), cO = /* @__PURE__ */ Y("ZodReadonly", (e, t) => {
  I0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => rR(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function fO(e) {
  return new cO({
    type: "readonly",
    innerType: e
  });
}
const dO = /* @__PURE__ */ Y("ZodCustom", (e, t) => {
  _0.init(e, t), Ge.init(e, t), e._zod.processJSONSchema = (r, n, i) => F_(e, r, n, i);
});
function pO(e, t = {}) {
  return /* @__PURE__ */ I_(dO, e, t);
}
function hO(e, t) {
  return /* @__PURE__ */ __(e, t);
}
function Vl(e, t) {
  return new lO({
    type: "pipe",
    in: ly(e),
    out: t
  });
}
function Wl(e) {
  return /* @__PURE__ */ Bg(oy, e);
}
function Kf(e) {
  return /* @__PURE__ */ n_(zl, e);
}
function mO(e) {
  return /* @__PURE__ */ l_(WR, e);
}
function ql(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xn = {}, Qn = {}, Mi = {}, sn = {}, Xf;
function Hl() {
  if (Xf) return sn;
  Xf = 1, Object.defineProperty(sn, "__esModule", { value: !0 }), sn.APP_ID_TO_NAME_MAP = sn.EAppId = void 0;
  var e;
  return (function(t) {
    t.TE_ACTIVITIES = "TE_ACTIVITIES", t.TE_ADMIN = "TE_ADMIN", t.TE_ALLOCATE = "TE_ALLOCATE", t.TE_ALLOCATE_PREFERENTIAL = "TE_ALLOCATE_PREFERENTIAL", t.TE_ATTENDANCE = "TE_ATTENDANCE", t.TE_AUTOPILOT = "TE_AUTOPILOT", t.TE_CALENDAR_INTEGRATION = "TE_CALENDAR_INTEGRATION", t.TE_CORE = "TE_CORE", t.TE_CURRICULUM = "TE_CURRICULUM", t.TE_DATA_MANAGER = "TE_DATA_MANAGER", t.TE_DEBIT = "TE_DEBIT", t.TE_EVALUATION = "TE_EVALUATION", t.TE_EVENT_BROKER = "TE_EVENT_BROKER", t.TE_EXAM = "TE_EXAM", t.TE_EXAM_V3 = "TE_EXAM_V3", t.TE_FLOW = "TE_FLOW", t.TE_HUB = "TE_HUB", t.TE_INSIGHT = "TE_INSIGHT", t.TE_PLAN = "TE_PLAN", t.TE_PREFERENCES = "TE_PREFERENCES", t.TE_REGISTRATION = "TE_REGISTRATION", t.TE_REPORTING = "TE_REPORTING", t.TE_RESERVE = "TE_RESERVE", t.TE_SEAT_MANAGEMENT = "TE_SEAT_MANAGEMENT", t.TE_STATISTICS = "TE_STATISTICS", t.TE_STUDY_GUIDE = "TE_STUDY_GUIDE", t.TE_STUDY_PLANNER = "TE_STUDY_PLANNER", t.TE_VIEWER = "TE_VIEWER", t.TE_WORKLOAD = "TE_WORKLOAD", t.JAVA_CLIENT = "JAVA_CLIENT", t.TE_AM = "TE_AM", t.TE_PORTAL = "TE_PORTAL", t.TE_MCP = "TE_MCP", t.TE_REST = "TE_REST", t.TE_SERVER_THREAD = "TE_SERVER_THREAD", t.TE_SOAP = "TE_SOAP";
  })(e || (sn.EAppId = e = {})), sn.APP_ID_TO_NAME_MAP = {
    // Products
    [e.TE_ACTIVITIES]: "Activities",
    [e.TE_ADMIN]: "Admin",
    [e.TE_ALLOCATE]: "Allocate",
    [e.TE_ALLOCATE_PREFERENTIAL]: "Allocate Preferential",
    [e.TE_ATTENDANCE]: "Attendance",
    [e.TE_AUTOPILOT]: "Autopilot",
    [e.TE_CALENDAR_INTEGRATION]: "Calendar Integration",
    [e.TE_CORE]: "Core",
    [e.TE_CURRICULUM]: "Curriculum",
    [e.TE_DATA_MANAGER]: "Data Manager",
    [e.TE_DEBIT]: "Debit",
    [e.TE_EVALUATION]: "Evaluation",
    [e.TE_EVENT_BROKER]: "Event Broker",
    [e.TE_EXAM]: "Exam",
    [e.TE_EXAM_V3]: "Assessment",
    [e.TE_FLOW]: "Flow",
    [e.TE_HUB]: "Hub",
    [e.TE_INSIGHT]: "Insight",
    [e.TE_PLAN]: "Plan",
    [e.TE_PREFERENCES]: "Preferences",
    [e.TE_REGISTRATION]: "Registration",
    [e.TE_REPORTING]: "Reporting",
    [e.TE_RESERVE]: "Reserve",
    [e.TE_SEAT_MANAGEMENT]: "Seat Management",
    [e.TE_STATISTICS]: "Statistics",
    [e.TE_STUDY_GUIDE]: "Study Guide",
    [e.TE_STUDY_PLANNER]: "Study Planner",
    [e.TE_VIEWER]: "Viewer",
    [e.TE_WORKLOAD]: "Workload",
    // Supporting apps
    [e.JAVA_CLIENT]: "Java Client",
    [e.TE_AM]: "Activity Manager",
    [e.TE_PORTAL]: "Portal",
    [e.TE_MCP]: "MCP",
    [e.TE_REST]: "REST",
    [e.TE_SERVER_THREAD]: "Server Thread",
    [e.TE_SOAP]: "SOAP"
  }, sn;
}
var Qf;
function EO() {
  if (Qf) return Mi;
  Qf = 1, Object.defineProperty(Mi, "__esModule", { value: !0 }), Mi.AppIdsArr = void 0;
  const e = Hl();
  return Mi.AppIdsArr = Object.values(e.EAppId), Mi;
}
var it = {}, an = {}, ed;
function Yl() {
  if (ed) return an;
  ed = 1, Object.defineProperty(an, "__esModule", { value: !0 }), an.EScopeLevel = an.EPermissionTypes = void 0;
  var e;
  (function(r) {
    r.SCOPE = "SCOPE", r.APP_PERMISSION = "APP_PERMISSION";
  })(e || (an.EPermissionTypes = e = {}));
  var t;
  return (function(r) {
    r.ADMIN = "ADMIN", r.SUPER = "SUPER";
  })(t || (an.EScopeLevel = t = {})), an;
}
var td;
function py() {
  if (td) return it;
  td = 1, Object.defineProperty(it, "__esModule", { value: !0 }), it.adminLevelAppPermissions = it.ScopeLevelArr = it.SCOPE_LEVEL_ADMIN = it.SCOPE_LEVEL_SUPER = it.TE_SOAP_SCOPE = it.TE_SERVER_THREAD_SCOPE = it.TE_ROOT_USER = it.SERVICE_ACCOUNT = void 0;
  const e = Yl();
  return it.SERVICE_ACCOUNT = "SERVICE_ACCOUNT", it.TE_ROOT_USER = "TE_ROOT_USER", it.TE_SERVER_THREAD_SCOPE = "TE_SERVER_THREAD::user", it.TE_SOAP_SCOPE = "TE_SOAP::user", it.SCOPE_LEVEL_SUPER = e.EScopeLevel.SUPER, it.SCOPE_LEVEL_ADMIN = e.EScopeLevel.ADMIN, it.ScopeLevelArr = [e.EScopeLevel.ADMIN, e.EScopeLevel.SUPER], it.adminLevelAppPermissions = [
    "TE_ADMIN::manageUsers",
    "TE_ADMIN::viewCullingReport",
    "TE_ADMIN::manageObjects",
    "TE_ADMIN::exportObjects",
    "TE_ADMIN::importObjects",
    "TE_ADMIN::manageTimeRules",
    "TE_CORE::activityManager",
    "TE_CORE::noTimeRules",
    "TE_CORE::setOrganizationsOnReservations",
    "TE_CORE::managePeriods",
    "TE_CORE::teExam",
    "TE_CORE::manageViews",
    "TE_RESERVE::noTimeRules",
    "TE_EXAM::supervisor",
    "TE_EXAM::supervisorCoordinator",
    "TE_EXAM::dec",
    "TE_EXAM::decCoordinator",
    "TE_EXAM::cea",
    "TE_EXAM_V3::invigilator",
    "TE_EXAM_V3::manager",
    "TE_PREFERENCES::recipient",
    "TE_HUB::student",
    "TE_HUB::invigilator",
    "TE_ACTIVITIES::readReservationTemplates"
  ], it;
}
var Li = {}, ei = {}, ut = {}, rd;
function Zl() {
  if (rd) return ut;
  rd = 1, Object.defineProperty(ut, "__esModule", { value: !0 }), ut.SAMLIdentifierFormat = ut.EUserObjectMatching = ut.EApplySSOPermissions = ut.EAuthSaml2SigantureAlgorithm = ut.EAuthSaml2Signing = ut.EAuthLogLevel = ut.EAuthStrategy = void 0;
  var e;
  (function(s) {
    s.TE_IDP = "TE_IDP", s.SAML2 = "SAML2", s.CAS = "CAS";
  })(e || (ut.EAuthStrategy = e = {}));
  var t;
  (function(s) {
    s.NONE = "NONE", s.LOW = "LOW", s.HIGH = "HIGH", s.DEBUG = "DEBUG";
  })(t || (ut.EAuthLogLevel = t = {}));
  var r;
  (function(s) {
    s.NONE = "NONE", s.SIGN = "SIGN", s.REQUIRED = "REQUIRED";
  })(r || (ut.EAuthSaml2Signing = r = {}));
  var n;
  (function(s) {
    s.SHA1 = "sha1", s.SHA256 = "sha256", s.SHA512 = "sha512";
  })(n || (ut.EAuthSaml2SigantureAlgorithm = n = {}));
  var i;
  (function(s) {
    s.ALWAYS = "ALWAYS", s.NEW_USERS = "NEW_USERS", s.NEVER = "NEVER";
  })(i || (ut.EApplySSOPermissions = i = {}));
  var o;
  return (function(s) {
    s.OBJECT_EXTID = "OBJECT_EXTID", s.OBJECT_FIELD = "OBJECT_FIELD";
  })(o || (ut.EUserObjectMatching = o = {})), ut.SAMLIdentifierFormat = {
    Unspecified: "urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified",
    Email: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress",
    Persistent: "urn:oasis:names:tc:SAML:2.0:nameid-format:persistent",
    Transient: "urn:oasis:names:tc:SAML:2.0:nameid-format:transient"
  }, ut;
}
var xi = {}, nd;
function gO() {
  if (nd) return xi;
  nd = 1, Object.defineProperty(xi, "__esModule", { value: !0 }), xi.ESuiteId = void 0;
  var e;
  return (function(t) {
    t.CURRICULUM = "CURRICULUM", t.WORKLOAD = "WORKLOAD", t.SCHEDULING = "SCHEDULING", t.ENGAGEMENT = "ENGAGEMENT";
  })(e || (xi.ESuiteId = e = {})), xi;
}
var ki = {}, id;
function hy() {
  if (id) return ki;
  id = 1, Object.defineProperty(ki, "__esModule", { value: !0 }), ki.EAuth = void 0;
  var e;
  return (function(t) {
    t.NOT_AUTHENTICATED = "NOT_AUTHENTICATED", t.AUTHENTICATED = "AUTHENTICATED", t.PENDING = "PENDING";
  })(e || (ki.EAuth = e = {})), ki;
}
var un = {}, od;
function my() {
  if (od) return un;
  od = 1, Object.defineProperty(un, "__esModule", { value: !0 }), un.EExternalServiceMethods = un.EExternalServices = void 0;
  var e;
  (function(r) {
    r.AUTH_SERVICE = "AUTH_SERVICE", r.USER_SERVICE = "USER_SERVICE", r.ORGANIZATION_SERVICE = "ORGANIZATION_SERVICE", r.APP_SERVICE = "APP_SERVICE", r.BACKUP_SERVICE = "BACKUP_SERVICE", r.TE_SERVER = "TE_SERVER", r.INTEGRATION_SERVICE = "INTEGRATION_SERVICE", r.PATHWAY_SERVICE = "PATHWAY_SERVICE", r.TE_PREFERENCES = "TE_PREFERENCES", r.ACTIVITY_MANAGER = "ACTIVITY_MANAGER", r.ACTIVITY_IMPORTER = "ACTIVITY_IMPORTER", r.REPORTING = "REPORTING", r.NOTIFICATION = "NOTIFICATION_SERVICE", r.EXAM_V3 = "EXAM_V3", r.HUB_SERVICE = "HUB_SERVICE", r.OBJECTS_BATCH_SERVICE = "OBJECTS_BATCH_SERVICE";
  })(e || (un.EExternalServices = e = {}));
  var t;
  return (function(r) {
    r.GET = "get", r.POST = "post", r.PUT = "put", r.PATCH = "patch", r.DELETE = "delete";
  })(t || (un.EExternalServiceMethods = t = {})), un;
}
var ji = {}, sd;
function yO() {
  if (sd) return ji;
  sd = 1, Object.defineProperty(ji, "__esModule", { value: !0 }), ji.EPaddingRuleType = void 0;
  var e;
  return (function(t) {
    t.DIRECT = "DIRECT", t.TRAVEL_TIME = "TRAVEL_TIME";
  })(e || (ji.EPaddingRuleType = e = {})), ji;
}
var Ui = {}, ad;
function Jl() {
  if (ad) return Ui;
  ad = 1, Object.defineProperty(Ui, "__esModule", { value: !0 }), Ui.ERegion = void 0;
  var e;
  return (function(t) {
    t.ANZ = "ANZ", t.EU_EES = "EU_EES", t.SGP = "SGP", t.UK = "UK";
  })(e || (Ui.ERegion = e = {})), Ui;
}
var Ht = {}, ud;
function Ey() {
  if (ud) return Ht;
  ud = 1, Object.defineProperty(Ht, "__esModule", { value: !0 }), Ht.ERelativeTimeTypes = Ht.EReservationPeriodType = Ht.EWeekdaySelection = Ht.EWeekdays = void 0;
  var e;
  (function(i) {
    i.MON = "MON", i.TUE = "TUE", i.WED = "WED", i.THU = "THU", i.FRI = "FRI", i.SAT = "SAT", i.SUN = "SUN";
  })(e || (Ht.EWeekdays = e = {}));
  var t;
  (function(i) {
    i.noWeekDaySelection = "no_weekday_selection";
  })(t || (Ht.EWeekdaySelection = t = {}));
  var r;
  (function(i) {
    i.NONE = "NONE", i.RESERVATION_PERIOD = "RESERVATION_PERIOD", i.DAY = "DAY", i.WEEK = "WEEK", i.MONTH = "MONTH", i.YEAR = "YEAR";
  })(r || (Ht.EReservationPeriodType = r = {}));
  var n;
  return (function(i) {
    i.DAYS = "DAYS", i.HOURS = "HOURS", i.MINUTES = "MINUTES";
  })(n || (Ht.ERelativeTimeTypes = n = {})), Ht;
}
var $i = {}, ld;
function gy() {
  if (ld) return $i;
  ld = 1, Object.defineProperty($i, "__esModule", { value: !0 }), $i.ETokenType = void 0;
  var e;
  return (function(t) {
    t.M2M = "M2M", t.USER = "USER";
  })(e || ($i.ETokenType = e = {})), $i;
}
var ln = {}, cd;
function TO() {
  if (cd) return ln;
  cd = 1, Object.defineProperty(ln, "__esModule", { value: !0 }), ln.EUserAllowJavaClientAccess = ln.EUserVisibility = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.READ_ONLY = "READ_ONLY", r.HIDDEN = "HIDDEN";
  })(e || (ln.EUserVisibility = e = {}));
  var t;
  return (function(r) {
    r.STANDARD = "STANDARD", r.YES = "YES", r.NO = "NO";
  })(t || (ln.EUserAllowJavaClientAccess = t = {})), ln;
}
var Fi = {}, fd;
function bO() {
  if (fd) return Fi;
  fd = 1, Object.defineProperty(Fi, "__esModule", { value: !0 }), Fi.EOrganizationType = void 0;
  var e;
  return (function(t) {
    t.CUSTOMER_PRODUCTION = "CUSTOMER_PRODUCTION", t.CUSTOMER_TESTING = "CUSTOMER_TESTING", t.INTERNAL_PRODUCTION = "INTERNAL_PRODUCTION", t.INTERNAL_OTHER = "INTERNAL_OTHER";
  })(e || (Fi.EOrganizationType = e = {})), Fi;
}
var hr = {}, dd;
function yy() {
  if (dd) return hr;
  dd = 1, Object.defineProperty(hr, "__esModule", { value: !0 }), hr.EPreferencesFilter = hr.EPersonalDataCheck = hr.EFieldType = void 0;
  var e;
  (function(n) {
    n.TEXT = "TEXT", n.SIGNATURE = "SIGNATURE", n.EMAIL = "EMAIL", n.URL = "URL", n.TELEPHONE = "TELEPHONE", n.CATEGORY = "CATEGORY", n.COMMENT = "COMMENT", n.INTEGER = "INTEGER", n.LENGTH = "LENGTH", n.CHECKBOX = "CHECKBOX", n.REFERENCE = "REFERENCE", n.NON_SEARCHABLE_TEXT = "NON_SEARCHABLE_TEXT", n.NON_SEARCHABLE_REFERENCE = "NON_SEARCHABLE_REFERENCE";
  })(e || (hr.EFieldType = e = {}));
  var t;
  (function(n) {
    n.STANDARD = "STANDARD", n.YES = "YES", n.NO = "NO";
  })(t || (hr.EPersonalDataCheck = t = {}));
  var r;
  return (function(n) {
    n.CHOICE1 = "[0-9]", n.CHOICE2 = "[0-9\\- +]", n.CHOICE3 = "[0-9a-z]", n.CHOICE4 = "[0-9a-zA-ZåäöÅÄÖ_-]", n.CHOICE5 = "[@_\\-\\.0-9a-zA-Z]", n.CHOICE6 = "[@_\\-\\.0-9a-zA-ZåäöÅÄÖ]";
  })(r || (hr.EPreferencesFilter = r = {})), hr;
}
var cn = {}, pd;
function AO() {
  if (pd) return cn;
  pd = 1, Object.defineProperty(cn, "__esModule", { value: !0 }), cn.EMatchMode = cn.EOperator = void 0;
  var e;
  (function(r) {
    r.E = "=", r.GTE = ">=", r.GT = ">", r.LTE = "<=", r.LT = "<";
  })(e || (cn.EOperator = e = {}));
  var t;
  return (function(r) {
    r.MATCH_ONE = "MATCH_ONE", r.MATCH_ALL = "MATCH_ALL";
  })(t || (cn.EMatchMode = t = {})), cn;
}
var mr = {}, hd;
function vO() {
  if (hd) return mr;
  hd = 1, Object.defineProperty(mr, "__esModule", { value: !0 }), mr.ELoggedEventType = mr.ELoggedEventItemDataType = mr.ELoggedEventLevel = void 0;
  var e;
  (function(n) {
    n.LOW = "LOW", n.MEDIUM = "MEDIUM", n.HIGH = "HIGH", n.CRITICAL = "CRITICAL";
  })(e || (mr.ELoggedEventLevel = e = {}));
  var t;
  (function(n) {
    n.TEXT = "text/plain", n.JSON = "application/json";
  })(t || (mr.ELoggedEventItemDataType = t = {}));
  var r;
  return (function(n) {
    n.MIGRATION = "MIGRATION", n.IMPORT = "IMPORT", n.SSO = "SSO";
  })(r || (mr.ELoggedEventType = r = {})), mr;
}
var fn = {}, md;
function SO() {
  if (md) return fn;
  md = 1, Object.defineProperty(fn, "__esModule", { value: !0 }), fn.EPersonalInformation = fn.EProperty = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.ABSTRACT = "ABSTRACT", r.VIRTUAL_STANDARD = "VIRTUAL_STANDARD", r.VIRTUAL_ABSTRACT = "VIRTUAL_ABSTRACT", r.TEMPLATE_OBJECT = "TEMPLATE_OBJECT";
  })(e || (fn.EProperty = e = {}));
  var t;
  return (function(r) {
    r.YES = "YES", r.NO = "NO", r.STANDARD = "STANDARD";
  })(t || (fn.EPersonalInformation = t = {})), fn;
}
var dn = {}, Ed;
function Ty() {
  if (Ed) return dn;
  Ed = 1, Object.defineProperty(dn, "__esModule", { value: !0 }), dn.EPeriodAccess = dn.ETimeIntervals = void 0;
  var e;
  (function(r) {
    r.DATE = "DATE", r.YEAR = "YEAR", r.WEEK = "WEEK", r.WEEK_NUMBER = "WEEK_NUMBER", r.MONTH = "MONTH", r.DAY = "DAY", r.WEEKDAY = "WEEKDAY", r.TIME = "TIME", r.NONE = "-";
  })(e || (dn.ETimeIntervals = e = {}));
  var t;
  return (function(r) {
    r.PUBLIC = "PUBLIC", r.LIMITED = "LIMITED", r.HIDDEN = "HIDDEN";
  })(t || (dn.EPeriodAccess = t = {})), dn;
}
var zi = {}, gd;
function by() {
  if (gd) return zi;
  gd = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.ERelationType = void 0;
  var e;
  return (function(t) {
    t.USE_ONLY = "USE_ONLY", t.STRICT = "STRICT", t.DYNAMIC = "DYNAMIC";
  })(e || (zi.ERelationType = e = {})), zi;
}
var ot = {}, yd;
function Ay() {
  if (yd) return ot;
  yd = 1, Object.defineProperty(ot, "__esModule", { value: !0 }), ot.EReservationStatuses = ot.ETemplateType = ot.ETemplateTypesText = ot.EOptionalRelation = ot.EObjectProperty = ot.EMandatoryProperty = ot.EReservationKind = ot.EDefaultStatus = void 0;
  var e;
  (function(l) {
    l.CONFIRMED = "CONFIRMED", l.PLANNED = "PLANNED", l.PRELIMINARY = "PRELIMINARY";
  })(e || (ot.EDefaultStatus = e = {}));
  var t;
  (function(l) {
    l.PHYSICAL = "PHYSICAL", l.PHYSICAL_DOUBLE = "PHYSICAL_DOUBLE", l.ABSTRACT = "ABSTRACT", l.ABSTRACT_DISPLAY = "ABSTRACT_DISPLAY";
  })(t || (ot.EReservationKind = t = {}));
  var r;
  (function(l) {
    l.MANDATORY = "MANDATORY", l.COMBINATION = "COMBINATION", l.OPTIONAL = "OPTIONAL";
  })(r || (ot.EMandatoryProperty = r = {}));
  var n;
  (function(l) {
    l.OBJECT = "OBJECT", l.VIRTUAL = "VIRTUAL", l.INCOMPLETE = "INCOMPLETE";
  })(n || (ot.EObjectProperty = n = {}));
  var i;
  (function(l) {
    l.NONE = "NONE", l.OPTIONAL = "OPTIONAL", l.ABSTRACT = "ABSTRACT";
  })(i || (ot.EOptionalRelation = i = {}));
  var o;
  (function(l) {
    l.STANDARD = "STANDARD", l.NEVER = "NEVER", l.ALWAYS = "ALWAYS";
  })(o || (ot.ETemplateTypesText = o = {}));
  var s;
  (function(l) {
    l.RESERVATION = "RESERVATION", l.AVAILABILITY = "AVAILABILITY", l.INFO_RESERVATION = "INFO_RESERVATION";
  })(s || (ot.ETemplateType = s = {}));
  var a;
  return (function(l) {
    l.UNKNOWN = "UNKNOWN", l.Reservation = "A_RESERVATION", l.Availability = "A_AVAILABILITY", l.Info = "A_INFO", l.Complete = "B_COMPLETE", l.Incomplete = "B_INCOMPLETE", l.Confirmed = "C_CONFIRMED", l.Preliminary = "C_PRELIMINARY", l.Planned = "C_PLANNED", l.Requested = "C_REQUESTED", l.Rejected = "C_REJECTED", l.Time = "D_TIME", l.WaitingList = "D_WAITING_LIST";
  })(a || (ot.EReservationStatuses = a = {})), ot;
}
var Gi = {}, Td;
function IO() {
  if (Td) return Gi;
  Td = 1, Object.defineProperty(Gi, "__esModule", { value: !0 }), Gi.EAcceptJavaClient = void 0;
  var e;
  return (function(t) {
    t.YES = "YES", t.NO = "NO", t.DEFAULT = "DEFAULT";
  })(e || (Gi.EAcceptJavaClient = e = {})), Gi;
}
var Bi = {}, bd;
function _O() {
  if (bd) return Bi;
  bd = 1, Object.defineProperty(Bi, "__esModule", { value: !0 }), Bi.EFieldMappingModes = void 0;
  var e;
  return (function(t) {
    t.RAW = "RAW", t.FREE_MAPPING = "FREE_MAPPING", t.MAPPED = "MAPPED";
  })(e || (Bi.EFieldMappingModes = e = {})), Bi;
}
var Vi = {}, Ad;
function RO() {
  if (Ad) return Vi;
  Ad = 1, Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.ETEReportingDataSource = void 0;
  var e;
  return (function(t) {
    t.SCHEDULE_GENERATOR = "SCHEDULE_GENERATOR", t.RESERVATIONS = "RESERVATIONS", t.ORDERS = "ORDERS", t.EXAMS = "EXAMS", t.FORMS = "FORMS", t.ACTIVITIES = "ACTIVITIES";
  })(e || (Vi.ETEReportingDataSource = e = {})), Vi;
}
var Er = {}, vd;
function OO() {
  if (vd) return Er;
  vd = 1, Object.defineProperty(Er, "__esModule", { value: !0 }), Er.EAppProperties = Er.EObjectTypeMappingStatuses = Er.EApplicationObjectTypeGroup = void 0;
  var e;
  (function(n) {
    n.NONE = "NONE", n.ROOM = "ROOM", n.PROFESSOR = "PROFESSOR", n.COURSE = "COURSE", n.COURSE_INFORMATION = "COURSE_INFORMATION", n.INVOICING = "INVOICING", n.STUDENT_SET = "STUDENT_SET", n.STUDENT_SET_GROUP = "STUDENT_SET_GROUP", n.PROGRAM = "PROGRAM", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.STUDENT = "STUDENT", n.STAFF = "STAFF", n.CHANGE_REQUEST = "CHANGE_REQUEST", n.INVIGILATOR = "INVIGILATOR";
  })(e || (Er.EApplicationObjectTypeGroup = e = {}));
  var t;
  (function(n) {
    n.NOT_TESTED = "NOT_TESTED", n.NOT_MAPPED = "NOT_MAPPED", n.MAPPED = "MAPPED", n.TESTED = "TESTED", n.FAILED = "FAILED";
  })(t || (Er.EObjectTypeMappingStatuses = t = {}));
  var r;
  return (function(n) {
    n.NONE = "NONE", n.NAME = "NAME", n.LABEL = "LABEL", n.EMAIL = "EMAIL", n.FIRST_NAME = "FIRST_NAME", n.LAST_NAME = "LAST_NAME", n.TITLE = "TITLE", n.ID = "ID", n.SEMESTER = "SEMESTER", n.MAX_STUDENTS = "MAX_STUDENTS", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.START_DATE = "START_DATE", n.END_DATE = "END_DATE", n.BUFFER = "BUFFER", n.HIDETRACK = "HIDETRACK", n.DEDICATETRACK = "DEDICATETRACK", n.TRACK = "TRACK", n.SEATS = "SEATS", n.COURSE_OCCURENCE = "COURSE_OCCURENCE", n.PLANNED_SIZE = "PLANNED_SIZE", n.PROGRAM = "PROGRAM", n.ROOM_NAME = "ROOM_NAME", n.ROOM_TYPE = "ROOM_TYPE", n.BUILDING = "BUILDING", n.CAMPUS = "CAMPUS", n.REASONABLE_ADJUSTMENT = "REASONABLE_ADJUSTMENT";
  })(r || (Er.EAppProperties = r = {})), Er;
}
var Ct = {}, Sd;
function wO() {
  if (Sd) return Ct;
  Sd = 1, Object.defineProperty(Ct, "__esModule", { value: !0 }), Ct.CalculatedValueProps = Ct.ECalculatedValueKey = Ct.EReportTemplateType = Ct.EReportingCapacitySource = Ct.EReportingTimeType = void 0;
  var e;
  (function(i) {
    i.FIXED_HOUR = "FIXED_HOUR", i.TIME_RANGE = "TIME_RANGE", i.MAX_HOURS = "MAX_HOURS";
  })(e || (Ct.EReportingTimeType = e = {}));
  var t;
  (function(i) {
    i.FROM_FIELD = "FROM_FIELD", i.FROM_MEMBERSHIP = "FROM_MEMBERSHIP";
  })(t || (Ct.EReportingCapacitySource = t = {}));
  var r;
  (function(i) {
    i.UTILIZATION = "UTILIZATION", i.LOAD = "LOAD", i.DEMAND_ANALYTIC = "DEMAND_ANALYTIC", i.HEATMAP = "HEATMAP";
  })(r || (Ct.EReportTemplateType = r = {}));
  var n;
  return (function(i) {
    i.FREQUENCY = "frequency", i.OCCUPANCY = "occupancy", i.UTILIZATION = "utilization", i.BOOKED_HOURS = "bookedHours", i.AVAILABLE_HOUR = "availableHour", i.LOAD_PERCENTAGE = "loadPercentage", i.WEEKS_ABOVE_TARGET = "weeksAboveTarget", i.DEMAND_PERCENTAGE = "demandPercentage";
  })(n || (Ct.ECalculatedValueKey = n = {})), Ct.CalculatedValueProps = {
    [n.FREQUENCY]: { label: "Frequency", templateType: r.UTILIZATION },
    [n.OCCUPANCY]: { label: "Occupancy", templateType: r.UTILIZATION },
    [n.UTILIZATION]: { label: "Utilization", templateType: r.UTILIZATION },
    [n.BOOKED_HOURS]: { label: "Booked Hours", templateType: r.LOAD },
    [n.AVAILABLE_HOUR]: { label: "Available Hours", templateType: r.LOAD },
    [n.LOAD_PERCENTAGE]: { label: "Load", templateType: r.LOAD },
    [n.WEEKS_ABOVE_TARGET]: {
      label: "Weeks Above Target",
      templateType: r.DEMAND_ANALYTIC
    },
    [n.DEMAND_PERCENTAGE]: {
      label: "Average Weekly Demand",
      templateType: r.DEMAND_ANALYTIC
    }
  }, Ct;
}
var Id;
function St() {
  return Id || (Id = 1, (function(e) {
    var t = ei && ei.__createBinding || (Object.create ? (function(F, W, X, de) {
      de === void 0 && (de = X);
      var B = Object.getOwnPropertyDescriptor(W, X);
      (!B || ("get" in B ? !W.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return W[X];
      } }), Object.defineProperty(F, de, B);
    }) : (function(F, W, X, de) {
      de === void 0 && (de = X), F[de] = W[X];
    })), r = ei && ei.__exportStar || function(F, W) {
      for (var X in F) X !== "default" && !Object.prototype.hasOwnProperty.call(W, X) && t(W, F, X);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.EReportTemplateType = e.EReportingCapacitySource = e.EReportingTimeType = e.EAppProperties = e.EObjectTypeMappingStatuses = e.EApplicationObjectTypeGroup = e.ETEReportingDataSource = e.EFieldMappingModes = e.EAcceptJavaClient = e.EReservationStatuses = e.ETemplateType = e.ETemplateTypesText = e.EOptionalRelation = e.EObjectProperty = e.EMandatoryProperty = e.EReservationKind = e.EDefaultStatus = e.ERelationType = e.EPeriodAccess = e.ETimeIntervals = e.EPersonalInformation = e.EProperty = e.EOperator = e.EMatchMode = e.EPreferencesFilter = e.EPersonalDataCheck = e.EFieldType = e.EOrganizationType = e.EUserVisibility = e.EUserAllowJavaClientAccess = e.ETokenType = e.EWeekdaySelection = e.EWeekdays = e.EReservationPeriodType = e.ERelativeTimeTypes = e.ERegion = e.EScopeLevel = e.EPermissionTypes = e.EPaddingRuleType = e.EExternalServices = e.EExternalServiceMethods = e.EAuth = e.ESuiteId = e.EAppId = e.EUserObjectMatching = e.EAuthStrategy = e.EAuthSaml2Signing = e.EAuthSaml2SigantureAlgorithm = e.EAuthLogLevel = e.EApplySSOPermissions = void 0, e.CalculatedValueProps = e.ECalculatedValueKey = void 0;
    var n = Zl();
    Object.defineProperty(e, "EApplySSOPermissions", { enumerable: !0, get: function() {
      return n.EApplySSOPermissions;
    } }), Object.defineProperty(e, "EAuthLogLevel", { enumerable: !0, get: function() {
      return n.EAuthLogLevel;
    } }), Object.defineProperty(e, "EAuthSaml2SigantureAlgorithm", { enumerable: !0, get: function() {
      return n.EAuthSaml2SigantureAlgorithm;
    } }), Object.defineProperty(e, "EAuthSaml2Signing", { enumerable: !0, get: function() {
      return n.EAuthSaml2Signing;
    } }), Object.defineProperty(e, "EAuthStrategy", { enumerable: !0, get: function() {
      return n.EAuthStrategy;
    } }), Object.defineProperty(e, "EUserObjectMatching", { enumerable: !0, get: function() {
      return n.EUserObjectMatching;
    } });
    var i = Hl();
    Object.defineProperty(e, "EAppId", { enumerable: !0, get: function() {
      return i.EAppId;
    } });
    var o = gO();
    Object.defineProperty(e, "ESuiteId", { enumerable: !0, get: function() {
      return o.ESuiteId;
    } });
    var s = hy();
    Object.defineProperty(e, "EAuth", { enumerable: !0, get: function() {
      return s.EAuth;
    } });
    var a = my();
    Object.defineProperty(e, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return a.EExternalServiceMethods;
    } }), Object.defineProperty(e, "EExternalServices", { enumerable: !0, get: function() {
      return a.EExternalServices;
    } });
    var l = yO();
    Object.defineProperty(e, "EPaddingRuleType", { enumerable: !0, get: function() {
      return l.EPaddingRuleType;
    } });
    var f = Yl();
    Object.defineProperty(e, "EPermissionTypes", { enumerable: !0, get: function() {
      return f.EPermissionTypes;
    } }), Object.defineProperty(e, "EScopeLevel", { enumerable: !0, get: function() {
      return f.EScopeLevel;
    } });
    var u = Jl();
    Object.defineProperty(e, "ERegion", { enumerable: !0, get: function() {
      return u.ERegion;
    } });
    var h = Ey();
    Object.defineProperty(e, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return h.ERelativeTimeTypes;
    } }), Object.defineProperty(e, "EReservationPeriodType", { enumerable: !0, get: function() {
      return h.EReservationPeriodType;
    } }), Object.defineProperty(e, "EWeekdays", { enumerable: !0, get: function() {
      return h.EWeekdays;
    } }), Object.defineProperty(e, "EWeekdaySelection", { enumerable: !0, get: function() {
      return h.EWeekdaySelection;
    } });
    var E = gy();
    Object.defineProperty(e, "ETokenType", { enumerable: !0, get: function() {
      return E.ETokenType;
    } });
    var d = TO();
    Object.defineProperty(e, "EUserAllowJavaClientAccess", { enumerable: !0, get: function() {
      return d.EUserAllowJavaClientAccess;
    } }), Object.defineProperty(e, "EUserVisibility", { enumerable: !0, get: function() {
      return d.EUserVisibility;
    } });
    var g = bO();
    Object.defineProperty(e, "EOrganizationType", { enumerable: !0, get: function() {
      return g.EOrganizationType;
    } });
    var y = yy();
    Object.defineProperty(e, "EFieldType", { enumerable: !0, get: function() {
      return y.EFieldType;
    } }), Object.defineProperty(e, "EPersonalDataCheck", { enumerable: !0, get: function() {
      return y.EPersonalDataCheck;
    } }), Object.defineProperty(e, "EPreferencesFilter", { enumerable: !0, get: function() {
      return y.EPreferencesFilter;
    } });
    var b = AO();
    Object.defineProperty(e, "EMatchMode", { enumerable: !0, get: function() {
      return b.EMatchMode;
    } }), Object.defineProperty(e, "EOperator", { enumerable: !0, get: function() {
      return b.EOperator;
    } }), r(vO(), e);
    var I = SO();
    Object.defineProperty(e, "EProperty", { enumerable: !0, get: function() {
      return I.EProperty;
    } }), Object.defineProperty(e, "EPersonalInformation", { enumerable: !0, get: function() {
      return I.EPersonalInformation;
    } });
    var S = Ty();
    Object.defineProperty(e, "ETimeIntervals", { enumerable: !0, get: function() {
      return S.ETimeIntervals;
    } }), Object.defineProperty(e, "EPeriodAccess", { enumerable: !0, get: function() {
      return S.EPeriodAccess;
    } });
    var w = by();
    Object.defineProperty(e, "ERelationType", { enumerable: !0, get: function() {
      return w.ERelationType;
    } });
    var P = Ay();
    Object.defineProperty(e, "EDefaultStatus", { enumerable: !0, get: function() {
      return P.EDefaultStatus;
    } }), Object.defineProperty(e, "EReservationKind", { enumerable: !0, get: function() {
      return P.EReservationKind;
    } }), Object.defineProperty(e, "EMandatoryProperty", { enumerable: !0, get: function() {
      return P.EMandatoryProperty;
    } }), Object.defineProperty(e, "EObjectProperty", { enumerable: !0, get: function() {
      return P.EObjectProperty;
    } }), Object.defineProperty(e, "EOptionalRelation", { enumerable: !0, get: function() {
      return P.EOptionalRelation;
    } }), Object.defineProperty(e, "ETemplateTypesText", { enumerable: !0, get: function() {
      return P.ETemplateTypesText;
    } }), Object.defineProperty(e, "ETemplateType", { enumerable: !0, get: function() {
      return P.ETemplateType;
    } }), Object.defineProperty(e, "EReservationStatuses", { enumerable: !0, get: function() {
      return P.EReservationStatuses;
    } });
    var _ = IO();
    Object.defineProperty(e, "EAcceptJavaClient", { enumerable: !0, get: function() {
      return _.EAcceptJavaClient;
    } });
    var v = _O();
    Object.defineProperty(e, "EFieldMappingModes", { enumerable: !0, get: function() {
      return v.EFieldMappingModes;
    } });
    var M = RO();
    Object.defineProperty(e, "ETEReportingDataSource", { enumerable: !0, get: function() {
      return M.ETEReportingDataSource;
    } });
    var x = OO();
    Object.defineProperty(e, "EApplicationObjectTypeGroup", { enumerable: !0, get: function() {
      return x.EApplicationObjectTypeGroup;
    } }), Object.defineProperty(e, "EObjectTypeMappingStatuses", { enumerable: !0, get: function() {
      return x.EObjectTypeMappingStatuses;
    } }), Object.defineProperty(e, "EAppProperties", { enumerable: !0, get: function() {
      return x.EAppProperties;
    } });
    var z = wO();
    Object.defineProperty(e, "EReportingTimeType", { enumerable: !0, get: function() {
      return z.EReportingTimeType;
    } }), Object.defineProperty(e, "EReportingCapacitySource", { enumerable: !0, get: function() {
      return z.EReportingCapacitySource;
    } }), Object.defineProperty(e, "EReportTemplateType", { enumerable: !0, get: function() {
      return z.EReportTemplateType;
    } }), Object.defineProperty(e, "ECalculatedValueKey", { enumerable: !0, get: function() {
      return z.ECalculatedValueKey;
    } }), Object.defineProperty(e, "CalculatedValueProps", { enumerable: !0, get: function() {
      return z.CalculatedValueProps;
    } });
  })(ei)), ei;
}
var _d;
function NO() {
  if (_d) return Li;
  _d = 1, Object.defineProperty(Li, "__esModule", { value: !0 }), Li.FieldMappingModeProps = void 0;
  const e = St();
  return Li.FieldMappingModeProps = {
    [e.EFieldMappingModes.RAW]: {
      label: "Only first primary field"
    },
    [e.EFieldMappingModes.FREE_MAPPING]: {
      label: "Free field selection"
    },
    [e.EFieldMappingModes.MAPPED]: {
      label: "Predetermined fields"
    }
  }, Li;
}
var gr = {}, Rd;
function CO() {
  if (Rd) return gr;
  Rd = 1, Object.defineProperty(gr, "__esModule", { value: !0 }), gr.AppPropertyProps = gr.ObjectTypeGroupProps = gr.ObjectTypeMappingStatusProps = void 0;
  const e = St();
  return gr.ObjectTypeMappingStatusProps = {
    [e.EObjectTypeMappingStatuses.NOT_TESTED]: {
      label: "Not mapped",
      color: "#ffdd5c"
    },
    [e.EObjectTypeMappingStatuses.NOT_MAPPED]: {
      label: "Not mapped",
      color: "#ffdd5c"
    },
    [e.EObjectTypeMappingStatuses.MAPPED]: {
      label: "Mapped",
      color: "#3fa5b3"
    },
    [e.EObjectTypeMappingStatuses.TESTED]: {
      label: "Tested",
      color: "#29b68f"
    },
    [e.EObjectTypeMappingStatuses.FAILED]: {
      label: "Failed",
      color: "#ff6357"
    }
  }, gr.ObjectTypeGroupProps = {
    [e.EApplicationObjectTypeGroup.NONE]: {
      label: "None"
    },
    [e.EApplicationObjectTypeGroup.ROOM]: {
      label: "Room"
    },
    [e.EApplicationObjectTypeGroup.PROFESSOR]: {
      label: "Professor"
    },
    [e.EApplicationObjectTypeGroup.COURSE]: {
      label: "Course"
    },
    [e.EApplicationObjectTypeGroup.COURSE_INFORMATION]: {
      label: "Course Information"
    },
    [e.EApplicationObjectTypeGroup.INVOICING]: {
      label: "Invoicing"
    },
    [e.EApplicationObjectTypeGroup.STUDENT_SET]: {
      label: "Student set"
    },
    [e.EApplicationObjectTypeGroup.STUDENT_SET_GROUP]: {
      label: "Student set group"
    },
    [e.EApplicationObjectTypeGroup.PROGRAM]: {
      label: "Program"
    },
    [e.EApplicationObjectTypeGroup.ACTIVITY_TYPE]: {
      label: "Activity type"
    },
    [e.EApplicationObjectTypeGroup.STUDENT]: {
      label: "Student"
    },
    [e.EApplicationObjectTypeGroup.STAFF]: {
      label: "Staff"
    },
    [e.EApplicationObjectTypeGroup.CHANGE_REQUEST]: {
      label: "Change request"
    },
    [e.EApplicationObjectTypeGroup.INVIGILATOR]: {
      label: "Invigilator"
    }
  }, gr.AppPropertyProps = {
    [e.EAppProperties.NONE]: {
      label: "None"
    },
    [e.EAppProperties.EMAIL]: {
      label: "Email"
    },
    [e.EAppProperties.LABEL]: {
      label: "Label"
    },
    [e.EAppProperties.TITLE]: {
      label: "Title"
    },
    [e.EAppProperties.SEMESTER]: {
      label: "Semester"
    },
    [e.EAppProperties.MAX_STUDENTS]: {
      label: "Max class size"
    },
    [e.EAppProperties.ACTIVITY_TYPE]: {
      label: "Activity type"
    },
    [e.EAppProperties.START_DATE]: {
      label: "Start date"
    },
    [e.EAppProperties.END_DATE]: {
      label: "End date"
    },
    [e.EAppProperties.TRACK]: {
      label: "Group number"
    },
    [e.EAppProperties.SEATS]: {
      label: "Capacity"
    },
    [e.EAppProperties.BUFFER]: {
      label: "Buffer"
    },
    [e.EAppProperties.HIDETRACK]: {
      label: "Hide track"
    },
    [e.EAppProperties.DEDICATETRACK]: {
      label: "Dedicate track"
    },
    [e.EAppProperties.FIRST_NAME]: {
      label: "First name"
    },
    [e.EAppProperties.LAST_NAME]: {
      label: "Last name"
    },
    [e.EAppProperties.NAME]: {
      label: "Study combination: id"
    },
    [e.EAppProperties.COURSE_OCCURENCE]: {
      label: "Course occurence"
    },
    [e.EAppProperties.PLANNED_SIZE]: {
      label: "Planned size"
    },
    [e.EAppProperties.ID]: {
      label: "Id"
    },
    [e.EAppProperties.PROGRAM]: {
      label: "Program"
    },
    [e.EAppProperties.ROOM_NAME]: {
      label: "Room name"
    },
    [e.EAppProperties.ROOM_TYPE]: {
      label: "Room type"
    },
    [e.EAppProperties.BUILDING]: {
      label: "Building"
    },
    [e.EAppProperties.CAMPUS]: {
      label: "Campus"
    },
    [e.EAppProperties.REASONABLE_ADJUSTMENT]: {
      label: "Reasonable adjustment"
    }
  }, gr;
}
var Wi = {}, Od;
function PO() {
  if (Od) return Wi;
  Od = 1, Object.defineProperty(Wi, "__esModule", { value: !0 }), Wi.DefaultTEExamObjectTypesMapping = void 0;
  const e = St();
  return Wi.DefaultTEExamObjectTypesMapping = [
    {
      applicationObjectTypeName: "room",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.ROOM,
      applicationObjectTypeLabel: "Room",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "description",
          fieldLabel: "Description"
          // User can override but we provide default
        },
        {
          appFieldName: "capacity",
          fieldLabel: "Capacity"
          // User can override but we provide default
        },
        {
          appFieldName: "building",
          fieldLabel: "Building"
          // User can override but we provide default
        },
        {
          appFieldName: "campus",
          fieldLabel: "Campus"
          // User can override but we provide default
        },
        {
          appFieldName: "floor",
          fieldLabel: "Floor"
          // User can override but we provide default
        },
        {
          appFieldName: "address",
          fieldLabel: "Address"
          // User can override but we provide default
        },
        {
          appFieldName: "pricePerSeatPerHour",
          fieldLabel: "Price per seat per hour"
          // User can override but we provide default
        },
        {
          appFieldName: "roomType",
          fieldLabel: "Room type"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "professor",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.PROFESSOR,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Professor",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "email",
          fieldLabel: "Email"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "coordinator",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.PROFESSOR,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Coordinator",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "email",
          fieldLabel: "Email"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "course",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          fieldLabel: "Code"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course Code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "courseEvent",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course Event",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "courseName",
          fieldLabel: "Course name"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "module",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Module",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "moduleId",
          fieldLabel: "Module Id"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "coursePart",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course Part",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "program",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Program",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "credits",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Credits"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "studentGroup",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Student Group",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "courseName",
          fieldLabel: "Course name"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "costCenter",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Cost center",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "department",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Department",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          fieldLabel: "code"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "externalCustomer",
      applicationObjectTypeGroup: e.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "External Customer",
      // User is free to override, but we provide a default
      status: e.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        }
      ]
    }
  ], Wi;
}
var Et = {}, wd;
function DO() {
  return wd || (wd = 1, Object.defineProperty(Et, "__esModule", { value: !0 }), Et.mongoReactSortOrderMapping = Et.mongoSortOrders = Et.studentSetGenerationStatusStringValues = Et.dataManagerObjectReviewStatusses = Et.generateStudentSetsSortableFields = Et.reviewByCourseSortableFields = Et.reviewByStudyCombinationSortableFields = void 0, Et.reviewByStudyCombinationSortableFields = [
    "inputObject.inputContent.expectedEnrollment",
    "inputObject.inputContent.status",
    "reviewStatus",
    "metadata.courses",
    "metadata.totalCredits",
    "inputObject.inputContent.historicalEnrollmentCopyForSortingAndFiltering"
  ], Et.reviewByCourseSortableFields = [
    "name",
    "combinationIds",
    "expectedEnrollmentOfCourse",
    "expectedEnrollmentOfStudyCombinations",
    "expectedEnrollmentDiff",
    "numberOfStudyCombinations"
  ], Et.generateStudentSetsSortableFields = [
    "studentSetGenerationStatusString",
    "metadata.courses",
    "inputObject.inputContent.historicalEnrollmentCopyForSortingAndFiltering"
  ], Et.dataManagerObjectReviewStatusses = ["NOT_REVIEWED", "KEEP", "REJECTED", "DELETED"], Et.studentSetGenerationStatusStringValues = [
    "ACTIVITY_DATA_ERROR",
    "GENERATION_ERROR",
    "ALLOCATION_ERROR",
    "DEALLOCATION_ERROR",
    "COMPLETE",
    "GENERATING",
    "STUDENT_SETS_GENERATED",
    "STUDENT_SETS_ALLOCATED"
  ], Et.mongoSortOrders = [-1, 1], Et.mongoReactSortOrderMapping = {
    asc: 1,
    desc: -1
  }), Et;
}
var It = {}, Nd;
function MO() {
  return Nd || (Nd = 1, Object.defineProperty(It, "__esModule", { value: !0 }), It.CALENDAR_WEEK_MODE = It.FORM_SOURCE = It.AUTO_CALCULATION = It.EVENT_OUTSIDE_ENUM = It.FORM_TYPE = It.FORM_STATUS_TYPE = void 0, It.FORM_STATUS_TYPE = {
    FORM_STATUS_DRAFT: "FORM_STATUS_DRAFT",
    FORM_STATUS_ACTIVE: "FORM_STATUS_ACTIVE",
    FORM_STATUS_ARCHIVED: "FORM_STATUS_ARCHIVED",
    FORM_STATUS_PUBLISHED: "FORM_STATUS_PUBLISHED"
  }, It.FORM_TYPE = {
    REGULAR: "REGULAR",
    AVAILABILITY: "AVAILABILITY",
    UNAVAILABILITY: "UNAVAILABILITY",
    PATHWAYS: "PATHWAYS"
  }, It.EVENT_OUTSIDE_ENUM = {
    MANUAL: "MANUAL",
    MODIFY: "MODIFY",
    REMOVE: "REMOVE"
  }, It.AUTO_CALCULATION = {
    TRACKS: "TRACKS",
    MAX_CLASS_SIZE: "MAX_CLASS_SIZE",
    OFF: "OFF"
  }, It.FORM_SOURCE = {
    ACTIVITY_CREATE_TEMPLATE: "ACTIVITY_CREATE_TEMPLATE"
  }, It.CALENDAR_WEEK_MODE = {
    INDIVIDUAL: "individual",
    RECURRING: "recurring"
  }), It;
}
var os = {}, Cd;
function LO() {
  return Cd || (Cd = 1, Object.defineProperty(os, "__esModule", { value: !0 }), os.FORM_INSTANCE_STATUS_TYPE = void 0, os.FORM_INSTANCE_STATUS_TYPE = {
    NOT_SENT: "NOT_SENT",
    SENT: "SENT",
    OPENED: "OPENED",
    DRAFT: "DRAFT",
    SUBMITTED: "SUBMITTED",
    OVERDUE: "OVERDUE",
    INVALIDATE: "INVALIDATE",
    DECLINED: "DECLINED",
    COLLABORATED: "COLLABORATED"
  }), os;
}
var ti = {}, Pd;
function xO() {
  return Pd || (Pd = 1, Object.defineProperty(ti, "__esModule", { value: !0 }), ti.TE_CORE_SCHEDULING_PROGRESS = ti.TE_CORE_ACCEPTANCE_STATUS = void 0, ti.TE_CORE_ACCEPTANCE_STATUS = {
    NOT_SET: "NOT_SET",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
  }, ti.TE_CORE_SCHEDULING_PROGRESS = {
    NOT_SCHEDULED: "NOT_SCHEDULED",
    IN_PROGRESS: "IN_PROGRESS",
    SCHEDULING_FINISHED: "SCHEDULING_FINISHED"
  }), ti;
}
var ri = {}, Dd;
function kO() {
  return Dd || (Dd = 1, Object.defineProperty(ri, "__esModule", { value: !0 }), ri.pathwayStatuses = ri.pathwaysNameSuffixTypes = void 0, ri.pathwaysNameSuffixTypes = {
    ALPHA: "ALPHA",
    DECIMAL: "DECIMAL",
    ROMAN: "ROMAN"
  }, ri.pathwayStatuses = {
    NEW: "NEW",
    ACCEPTED: "ACCEPTED",
    EDITED: "EDITED",
    REJECTED: "REJECTED"
  }), ri;
}
var zr = {}, Md;
function jO() {
  return Md || (Md = 1, Object.defineProperty(zr, "__esModule", { value: !0 }), zr.exportedUserColumns = zr.TEUserImportPropertiesArr = zr.userProfilePropertiesArr = void 0, zr.userProfilePropertiesArr = [
    "id",
    "legacyId",
    "profileName",
    "description",
    "contactEmail",
    "standardOrganization",
    "organizationsAndRoles",
    "scopes",
    "appPermissions",
    "userObjects",
    "inactiveSince"
  ], zr.TEUserImportPropertiesArr = [
    "inactiveSince",
    "username",
    "email",
    "firstName",
    "lastName",
    "language",
    "dateFormat",
    "timezone",
    "displayTimezones",
    "visibility",
    "personalData",
    "description",
    "recoveryEmail",
    "contactEmail",
    "standardOrganization",
    "organizationsAndRoles",
    "scopes",
    "appPermissions",
    "userObjects",
    "lockedForExternalAuthentication"
  ], zr.exportedUserColumns = {
    id: "Profile ID",
    profileName: "Profile Name",
    email: "Email",
    username: "User Name",
    firstName: "First Name",
    lastName: "Last Name",
    contactEmail: "Contact Email",
    userObjects: "User Objects",
    standardOrganization: "Standard Organization",
    organizationsAndRoles: "Org Nodes & Roles",
    scopes: "Scopes",
    appPermissions: "App Permissions",
    language: "Language",
    inactiveSince: "Inactive Since",
    logins: "Last Login",
    visibility: "Visibility",
    description: "Description",
    lockedForExternalAuthentication: "Locked for External Authentication"
  }), zr;
}
var ss = {}, Ld;
function UO() {
  return Ld || (Ld = 1, Object.defineProperty(ss, "__esModule", { value: !0 }), ss.TERootUserInfoPropertiesArr = void 0, ss.TERootUserInfoPropertiesArr = ["id", "firstName", "lastName", "email"]), ss;
}
var as = {}, xd;
function $O() {
  return xd || (xd = 1, Object.defineProperty(as, "__esModule", { value: !0 }), as.FINGERPRINT_COOKIE_NAME = void 0, as.FINGERPRINT_COOKIE_NAME = "te_fingerprint"), as;
}
var qi = {}, kd;
function vy() {
  if (kd) return qi;
  kd = 1, Object.defineProperty(qi, "__esModule", { value: !0 }), qi.REGION_LOCATIONS = void 0;
  const e = Jl();
  return qi.REGION_LOCATIONS = {
    [e.ERegion.ANZ]: "anz",
    [e.ERegion.EU_EES]: "eu",
    [e.ERegion.SGP]: "sgp",
    [e.ERegion.UK]: "uk"
  }, qi;
}
var jd;
function Sy() {
  return jd || (jd = 1, (function(e) {
    var t = Qn && Qn.__createBinding || (Object.create ? (function(l, f, u, h) {
      h === void 0 && (h = u);
      var E = Object.getOwnPropertyDescriptor(f, u);
      (!E || ("get" in E ? !f.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
        return f[u];
      } }), Object.defineProperty(l, h, E);
    }) : (function(l, f, u, h) {
      h === void 0 && (h = u), l[h] = f[u];
    })), r = Qn && Qn.__exportStar || function(l, f) {
      for (var u in l) u !== "default" && !Object.prototype.hasOwnProperty.call(f, u) && t(f, l, u);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DefaultTEExamObjectTypesMapping = e.ObjectTypeGroupProps = e.AppPropertyProps = e.ObjectTypeMappingStatusProps = e.FieldMappingModeProps = e.SERVICE_ACCOUNT = e.TE_ROOT_USER = e.SCOPE_LEVEL_SUPER = e.SCOPE_LEVEL_ADMIN = e.ScopeLevelArr = e.AppIdsArr = void 0;
    const n = EO();
    Object.defineProperty(e, "AppIdsArr", { enumerable: !0, get: function() {
      return n.AppIdsArr;
    } });
    const i = py();
    Object.defineProperty(e, "ScopeLevelArr", { enumerable: !0, get: function() {
      return i.ScopeLevelArr;
    } }), Object.defineProperty(e, "SCOPE_LEVEL_ADMIN", { enumerable: !0, get: function() {
      return i.SCOPE_LEVEL_ADMIN;
    } }), Object.defineProperty(e, "SCOPE_LEVEL_SUPER", { enumerable: !0, get: function() {
      return i.SCOPE_LEVEL_SUPER;
    } }), Object.defineProperty(e, "TE_ROOT_USER", { enumerable: !0, get: function() {
      return i.TE_ROOT_USER;
    } }), Object.defineProperty(e, "SERVICE_ACCOUNT", { enumerable: !0, get: function() {
      return i.SERVICE_ACCOUNT;
    } });
    const o = NO();
    Object.defineProperty(e, "FieldMappingModeProps", { enumerable: !0, get: function() {
      return o.FieldMappingModeProps;
    } });
    const s = CO();
    Object.defineProperty(e, "AppPropertyProps", { enumerable: !0, get: function() {
      return s.AppPropertyProps;
    } }), Object.defineProperty(e, "ObjectTypeMappingStatusProps", { enumerable: !0, get: function() {
      return s.ObjectTypeMappingStatusProps;
    } }), Object.defineProperty(e, "ObjectTypeGroupProps", { enumerable: !0, get: function() {
      return s.ObjectTypeGroupProps;
    } });
    const a = PO();
    Object.defineProperty(e, "DefaultTEExamObjectTypesMapping", { enumerable: !0, get: function() {
      return a.DefaultTEExamObjectTypesMapping;
    } }), e.default = {
      AppIdsArr: n.AppIdsArr,
      ScopeLevelArr: i.ScopeLevelArr,
      SCOPE_LEVEL_ADMIN: i.SCOPE_LEVEL_ADMIN,
      SCOPE_LEVEL_SUPER: i.SCOPE_LEVEL_SUPER,
      TE_ROOT_USER: i.TE_ROOT_USER,
      SERVICE_ACCOUNT: i.SERVICE_ACCOUNT,
      FieldMappingModeProps: o.FieldMappingModeProps,
      ObjectTypeMappingStatusProps: s.ObjectTypeMappingStatusProps,
      AppPropertyProps: s.AppPropertyProps,
      ObjectTypeGroupProps: s.ObjectTypeGroupProps,
      DefaultTEExamObjectTypesMapping: a.DefaultTEExamObjectTypesMapping
    }, r(DO(), e), r(MO(), e), r(LO(), e), r(xO(), e), r(kO(), e), r(jO(), e), r(UO(), e), r($O(), e), r(vy(), e);
  })(Qn)), Qn;
}
var ni = {}, Ud = {}, $d;
function FO() {
  return $d || ($d = 1, Object.defineProperty(Ud, "__esModule", { value: !0 })), Ud;
}
var Fd = {}, zd;
function zO() {
  return zd || (zd = 1, Object.defineProperty(Fd, "__esModule", { value: !0 })), Fd;
}
var us = {}, Gd;
function GO() {
  return Gd || (Gd = 1, Object.defineProperty(us, "__esModule", { value: !0 }), us.SERVICE_ACCOUNT_USE_WITH_CAUTION = void 0, us.SERVICE_ACCOUNT_USE_WITH_CAUTION = "SERVICE_ACCOUNT_USE_WITH_CAUTION"), us;
}
var Bd = {}, Vd;
function BO() {
  return Vd || (Vd = 1, Object.defineProperty(Bd, "__esModule", { value: !0 })), Bd;
}
var Wd = {}, qd;
function VO() {
  return qd || (qd = 1, Object.defineProperty(Wd, "__esModule", { value: !0 })), Wd;
}
var Hd = {}, Yd;
function WO() {
  return Yd || (Yd = 1, Object.defineProperty(Hd, "__esModule", { value: !0 })), Hd;
}
var Zd = {}, Jd;
function qO() {
  return Jd || (Jd = 1, Object.defineProperty(Zd, "__esModule", { value: !0 })), Zd;
}
var Kd = {}, Xd;
function HO() {
  return Xd || (Xd = 1, Object.defineProperty(Kd, "__esModule", { value: !0 })), Kd;
}
var Qd = {}, ep;
function YO() {
  return ep || (ep = 1, Object.defineProperty(Qd, "__esModule", { value: !0 })), Qd;
}
var tp = {}, rp;
function ZO() {
  return rp || (rp = 1, Object.defineProperty(tp, "__esModule", { value: !0 })), tp;
}
var np = {}, ip;
function JO() {
  return ip || (ip = 1, Object.defineProperty(np, "__esModule", { value: !0 })), np;
}
var op = {}, sp;
function KO() {
  return sp || (sp = 1, Object.defineProperty(op, "__esModule", { value: !0 })), op;
}
var ap = {}, up;
function XO() {
  return up || (up = 1, Object.defineProperty(ap, "__esModule", { value: !0 })), ap;
}
var yr = {}, lp;
function QO() {
  if (lp) return yr;
  lp = 1, Object.defineProperty(yr, "__esModule", { value: !0 }), yr.EFullWeekDays = yr.ETimeScope = yr.EDynamicAvailabilityType = void 0;
  var e;
  (function(n) {
    n.TOTAL_HOURS = "TOTAL_HOURS", n.CONSECUTIVE_HOURS = "CONSECUTIVE_HOURS", n.FREE_TIME = "FREE_TIME", n.TOTAL_RESERVATIONS = "TOTAL_RESERVATIONS";
  })(e || (yr.EDynamicAvailabilityType = e = {}));
  var t;
  (function(n) {
    n.DAILY = "DAILY", n.WEEKLY = "WEEKLY";
  })(t || (yr.ETimeScope = t = {}));
  var r;
  return (function(n) {
    n.SUNDAY = "SUNDAY", n.MONDAY = "MONDAY", n.TUESDAY = "TUESDAY", n.WEDNESDAY = "WEDNESDAY", n.THURSDAY = "THURSDAY", n.FRIDAY = "FRIDAY", n.SATURDAY = "SATURDAY";
  })(r || (yr.EFullWeekDays = r = {})), yr;
}
var cp = {}, fp;
function ew() {
  return fp || (fp = 1, Object.defineProperty(cp, "__esModule", { value: !0 })), cp;
}
var dp = {}, pp;
function tw() {
  return pp || (pp = 1, Object.defineProperty(dp, "__esModule", { value: !0 })), dp;
}
var hp = {}, mp;
function rw() {
  return mp || (mp = 1, Object.defineProperty(hp, "__esModule", { value: !0 })), hp;
}
var Ep;
function nw() {
  return Ep || (Ep = 1, (function(e) {
    var t = ni && ni.__createBinding || (Object.create ? (function(u, h, E, d) {
      d === void 0 && (d = E);
      var g = Object.getOwnPropertyDescriptor(h, E);
      (!g || ("get" in g ? !h.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
        return h[E];
      } }), Object.defineProperty(u, d, g);
    }) : (function(u, h, E, d) {
      d === void 0 && (d = E), u[d] = h[E];
    })), r = ni && ni.__exportStar || function(u, h) {
      for (var E in u) E !== "default" && !Object.prototype.hasOwnProperty.call(h, E) && t(h, u, E);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SERVICE_ACCOUNT_USE_WITH_CAUTION = e.ETokenType = e.EWeekdaySelection = e.EWeekdays = e.EReservationPeriodType = e.ERelativeTimeTypes = e.EPermissionTypes = e.EExternalServices = e.EExternalServiceMethods = e.EAuth = e.EAppId = void 0;
    var n = Hl();
    Object.defineProperty(e, "EAppId", { enumerable: !0, get: function() {
      return n.EAppId;
    } });
    var i = hy();
    Object.defineProperty(e, "EAuth", { enumerable: !0, get: function() {
      return i.EAuth;
    } });
    var o = my();
    Object.defineProperty(e, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return o.EExternalServiceMethods;
    } }), Object.defineProperty(e, "EExternalServices", { enumerable: !0, get: function() {
      return o.EExternalServices;
    } });
    var s = Yl();
    Object.defineProperty(e, "EPermissionTypes", { enumerable: !0, get: function() {
      return s.EPermissionTypes;
    } });
    var a = Ey();
    Object.defineProperty(e, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return a.ERelativeTimeTypes;
    } }), Object.defineProperty(e, "EReservationPeriodType", { enumerable: !0, get: function() {
      return a.EReservationPeriodType;
    } }), Object.defineProperty(e, "EWeekdays", { enumerable: !0, get: function() {
      return a.EWeekdays;
    } }), Object.defineProperty(e, "EWeekdaySelection", { enumerable: !0, get: function() {
      return a.EWeekdaySelection;
    } });
    var l = gy();
    Object.defineProperty(e, "ETokenType", { enumerable: !0, get: function() {
      return l.ETokenType;
    } }), r(FO(), e), r(zO(), e);
    var f = GO();
    Object.defineProperty(e, "SERVICE_ACCOUNT_USE_WITH_CAUTION", { enumerable: !0, get: function() {
      return f.SERVICE_ACCOUNT_USE_WITH_CAUTION;
    } }), r(Zl(), e), r(BO(), e), r(VO(), e), r(WO(), e), r(qO(), e), r(HO(), e), r(YO(), e), r(ZO(), e), r(JO(), e), r(KO(), e), r(XO(), e), r(QO(), e), r(ew(), e), r(tw(), e), r(rw(), e);
  })(ni)), ni;
}
var gp = {}, Hi = {}, Yi = {}, yp;
function iw() {
  if (yp) return Yi;
  yp = 1, Object.defineProperty(Yi, "__esModule", { value: !0 }), Yi.ESAMLParameterType = void 0;
  var e;
  return (function(t) {
    t.CUSTOM_PARAMETERS = "CUSTOM_PARAMETERS", t.RELAY_STATE = "RELAY_STATE";
  })(e || (Yi.ESAMLParameterType = e = {})), Yi;
}
var Tp;
function ow() {
  if (Tp) return Hi;
  Tp = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.createAuthConfig = void 0;
  const e = St(), t = iw(), r = Zl(), n = (i) => {
    var o, s, a, l;
    return {
      id: i.id,
      name: i.name,
      description: i.description,
      strategy: i.strategy || e.EAuthStrategy.TE_IDP,
      config: i.strategy === e.EAuthStrategy.SAML2 ? Object.assign(Object.assign({}, i.config), { parameterType: ((o = i.config) === null || o === void 0 ? void 0 : o.parameterType) || t.ESAMLParameterType.CUSTOM_PARAMETERS, signAuthnRequest: (a = (s = i.config) === null || s === void 0 ? void 0 : s.signAuthnRequest) !== null && a !== void 0 ? a : !0, identifierFormat: ((l = i.config) === null || l === void 0 ? void 0 : l.identifierFormat) || r.SAMLIdentifierFormat.Email }) : Object.assign(Object.assign({}, i.config), { useMFA: i.config.useMFA || !1 }),
      active: i.active || !1,
      default: i.default || !1,
      enabledForAppIds: i.enabledForAppIds || []
    };
  };
  return Hi.createAuthConfig = n, Hi;
}
var Zi = {}, pn = {}, bp;
function sw() {
  if (bp) return pn;
  bp = 1, Object.defineProperty(pn, "__esModule", { value: !0 }), pn.EImportStatus = pn.EImportType = void 0;
  var e;
  (function(r) {
    r.ORGANIZATION_HIERARCHY = "ORGANIZATION_HIERARCHY", r.USERS = "USERS", r.AUTH_CONFIGS = "AUTH_CONFIGS";
  })(e || (pn.EImportType = e = {}));
  var t;
  return (function(r) {
    r.SUCCESS = "SUCCESS", r.FAILURE = "FAILURE";
  })(t || (pn.EImportStatus = t = {})), pn;
}
var Ap;
function aw() {
  if (Ap) return Zi;
  Ap = 1, Object.defineProperty(Zi, "__esModule", { value: !0 }), Zi.createImport = void 0;
  const e = sw(), t = (r) => ({
    id: r.id,
    type: r.type || e.EImportType.ORGANIZATION_HIERARCHY,
    settings: r.settings || { fromCustomerSignature: "" },
    status: r.status || e.EImportStatus.FAILURE,
    log: r.log || [],
    timestamp: r.timestamp
  });
  return Zi.createImport = t, Zi;
}
var Ji = {}, vp;
function uw() {
  if (vp) return Ji;
  vp = 1, Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.createAltDesignation = void 0;
  const e = (t) => ({
    language: t,
    name: "",
    description: ""
  });
  return Ji.createAltDesignation = e, Ji;
}
var Ki = {}, Xi = {}, Sp;
function Iy() {
  if (Sp) return Xi;
  Sp = 1, Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.EOrganizationVisibility = void 0;
  var e;
  return (function(t) {
    t.PUBLIC = "PUBLIC", t.HIDDEN = "HIDDEN", t.PRIVATE = "PRIVATE";
  })(e || (Xi.EOrganizationVisibility = e = {})), Xi;
}
var Ip;
function lw() {
  if (Ip) return Ki;
  Ip = 1, Object.defineProperty(Ki, "__esModule", { value: !0 }), Ki.createOrganization = void 0;
  const e = St(), t = Iy(), r = (n) => ({
    id: n.id,
    name: n.name,
    customerSignature: n.customerSignature,
    customerLogo: n.customerLogo,
    customerColor: n.customerColor,
    teServerUrl: n.teServerUrl,
    public: n.public,
    inactive: !1,
    inactiveSince: null,
    enabledProducts: n.enabledProducts || [],
    type: n.type || e.EOrganizationType.CUSTOMER_PRODUCTION,
    visibility: n.visibility || t.EOrganizationVisibility.PUBLIC,
    rootUserPermissions: n.rootUserPermissions || [],
    rootUserStandardOrganizationNode: n.rootUserStandardOrganizationNode,
    region: n.region,
    cluster: n.cluster,
    database: n.database,
    language: n.language,
    dateFormat: n.dateFormat
  });
  return Ki.createOrganization = r, Ki;
}
var Qi = {}, _p;
function cw() {
  if (_p) return Qi;
  _p = 1, Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.createOrganizationNode = void 0;
  const e = (t) => ({
    id: t.id,
    extId: t.extId || void 0,
    legacyId: t.legacyId || void 0,
    name: t.name,
    description: t.description || void 0,
    parentNodeIds: t.parentNodeIds || []
  });
  return Qi.createOrganizationNode = e, Qi;
}
var Rp = {}, Op;
function fw() {
  return Op || (Op = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createOrganizationTreeNode = void 0;
    const t = (r) => ({
      id: r.id,
      children: (r.children || []).map((n) => (0, e.createOrganizationTreeNode)(n)),
      name: r.name,
      virtualId: r.virtualId
    });
    e.createOrganizationTreeNode = t;
  })(Rp)), Rp;
}
var eo = {}, wp;
function dw() {
  if (wp) return eo;
  wp = 1, Object.defineProperty(eo, "__esModule", { value: !0 }), eo.createPaddingRule = void 0;
  const e = St(), t = (r) => ({
    id: r.id,
    paddingType: r.paddingType || e.EPaddingRuleType.DIRECT,
    name: r.name || "",
    description: r.description || "",
    includeAbstractObjects: r.includeAbstractObjects || !1,
    rule: r.rule || {
      objectsOnReservation: [],
      impactedObjects: [],
      paddingBefore: 0,
      paddingAfter: 0
    },
    history: r.history
  });
  return eo.createPaddingRule = t, eo;
}
var to = {}, Np;
function pw() {
  if (Np) return to;
  Np = 1, Object.defineProperty(to, "__esModule", { value: !0 }), to.createPermission = void 0;
  const e = St(), t = (r) => ({
    type: r.type || e.EPermissionTypes.SCOPE,
    value: r.value,
    name: r.name,
    description: r.description || void 0,
    requiredScopeLevel: r.requiredScopeLevel || void 0
  });
  return to.createPermission = t, to;
}
var Tr = {}, Cp;
function hw() {
  if (Cp) return Tr;
  Cp = 1, Object.defineProperty(Tr, "__esModule", { value: !0 }), Tr.createRolePermissionGroup = Tr.createRolePermission = Tr.createRole = void 0;
  const e = (n) => ({
    id: n.id,
    name: n.name,
    description: n.description || "",
    rolePermissions: n.rolePermissions || []
  });
  Tr.createRole = e;
  const t = (n) => ({
    id: n.id,
    name: n.name,
    rolePermissionGroup: n.rolePermissionGroup,
    groupActions: n.groupActions || []
  });
  Tr.createRolePermission = t;
  const r = (n) => ({
    id: n.id,
    groupActions: n.groupActions || []
  });
  return Tr.createRolePermissionGroup = r, Tr;
}
var ro = {}, Pp;
function mw() {
  if (Pp) return ro;
  Pp = 1, Object.defineProperty(ro, "__esModule", { value: !0 }), ro.createSOAPConnectionSettings = void 0;
  const e = (t) => ({
    username: t.username || "",
    password: t.password || "",
    certificateKey: t.certificateKey || "",
    baseUrl: t.baseUrl || ""
  });
  return ro.createSOAPConnectionSettings = e, ro;
}
var Yt = {}, Dp;
function Ew() {
  if (Dp) return Yt;
  Dp = 1, Object.defineProperty(Yt, "__esModule", { value: !0 }), Yt.createEmptyTWeekdaySelection = Yt.createTTime = Yt.createEmptyTTime = Yt.createEmptyTTimeRule = void 0;
  const e = St(), t = () => ({
    name: "",
    id: 0,
    description: "",
    history: [],
    weekdays: [e.EWeekdays.MON, e.EWeekdays.TUE, e.EWeekdays.WED, e.EWeekdays.THU, e.EWeekdays.FRI, e.EWeekdays.SAT, e.EWeekdays.SUN],
    clockTimeStart: 28800,
    clockTimeEnd: 64800,
    standardStep: 900,
    minimumStep: 900,
    beginStep: 900,
    importStep: 900,
    minimumLength: 1800,
    maximumLength: 86400,
    defaultLength: 3600,
    beginOffset: 0,
    relativeStartTime: -15552e3,
    relativeEndTime: 4752e4,
    useStartTimeToOpenNextDay: !1,
    useSeparateCancellationRules: !1,
    relativeCancellationStartTime: -15552e3,
    relativeCancellationEndTime: 4752e4,
    reservationPeriod1: e.EReservationPeriodType.NONE,
    reservationLength1: 0,
    reservationCount1: 0,
    reservationPeriod2: e.EReservationPeriodType.NONE,
    reservationLength2: 0,
    reservationCount2: 0,
    useModifiedByWhenCalculatingUserQuota: !1,
    templates: []
  });
  Yt.createEmptyTTimeRule = t;
  const r = () => ({
    clockTimeStart: 28800,
    clockTimeEnd: 36e3
  });
  Yt.createEmptyTTime = r;
  const n = (o, s) => ({
    clockTimeStart: o,
    clockTimeEnd: s
  });
  Yt.createTTime = n;
  const i = () => ({
    weekdays: [],
    times: []
  });
  return Yt.createEmptyTWeekdaySelection = i, Yt;
}
var Pt = {}, Mp;
function gw() {
  if (Mp) return Pt;
  Mp = 1, Object.defineProperty(Pt, "__esModule", { value: !0 }), Pt.createUnsignedFromM2MUser = Pt.createUnsignedReadOnlyFromTERootUser = Pt.createUnsignedFromTERootUser = Pt.createUnsignedReadOnlyFromTEUser = Pt.createUnsignedFromTEUser = void 0;
  const e = St(), t = py(), r = (a, l, f, u) => {
    var h;
    return {
      region: l,
      id: a.id || "",
      type: e.ETokenType.USER,
      username: a.username,
      email: a.email,
      organizationId: f,
      customerSignature: u,
      appPermissions: a.appPermissions,
      scopes: a.scopes,
      profile: { id: a.id, profileName: a.profileName },
      profiles: ((h = a.profiles) === null || h === void 0 ? void 0 : h.filter(({ inactiveSince: E }) => E === null).map(({ id: E, profileName: d }) => ({ id: E, profileName: d }))) || [],
      organizationsAndRoles: a.organizationsAndRoles
    };
  };
  Pt.createUnsignedFromTEUser = r;
  const n = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.USER,
    email: a.email,
    username: a.username,
    organizationId: f,
    customerSignature: u,
    appPermissions: [],
    scopes: ["TE_Viewer::readOnly"]
  });
  Pt.createUnsignedReadOnlyFromTEUser = n;
  const i = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.USER,
    email: a.email,
    organizationId: f,
    customerSignature: u,
    appPermissions: [],
    scopes: [t.TE_ROOT_USER]
  });
  Pt.createUnsignedFromTERootUser = i;
  const o = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.USER,
    email: a.email,
    organizationId: f,
    customerSignature: u,
    appPermissions: [],
    scopes: ["TE_Viewer::readOnly"]
  });
  Pt.createUnsignedReadOnlyFromTERootUser = o;
  const s = (a, l, f, u) => ({
    region: l,
    id: a.id || "",
    type: e.ETokenType.M2M,
    organizationId: f,
    customerSignature: u,
    appPermissions: a.appPermissions,
    scopes: a.scopes,
    organizationsAndRoles: a.organizationsAndRoles
  });
  return Pt.createUnsignedFromM2MUser = s, Pt;
}
var no = {}, Lp;
function yw() {
  if (Lp) return no;
  Lp = 1, Object.defineProperty(no, "__esModule", { value: !0 }), no.createTokenPermissions = void 0;
  const e = (t) => ({
    appPermissions: t.appPermissions || [],
    scopes: t.scopes || []
  });
  return no.createTokenPermissions = e, no;
}
var io = {}, xp;
function Tw() {
  if (xp) return io;
  xp = 1, Object.defineProperty(io, "__esModule", { value: !0 }), io.createEmptyType = void 0;
  const e = () => ({
    name: "",
    extId: "",
    id: 0,
    active: !0,
    personalData: !1,
    description: "",
    altDesignations: [],
    allowStandardObjects: !1,
    allowAbstractObjects: !1,
    allowVirtualObjects: !1,
    personType: !1,
    locationType: !1,
    aliasType: 0,
    externalOwner: "",
    subTypes: [],
    fields: [],
    parentFields: [],
    organizations: [],
    reservationTemplates: [],
    documentation: "",
    history: [],
    skipLastReserved: !1
  });
  return io.createEmptyType = e, io;
}
var kp = {}, jp;
function bw() {
  return jp || (jp = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createUserCSVMapper = e.mapUserCSVData = e.getLabelForUser = e.createFromTemplateWithNewUsernameAndAuthConfig = e.createUser = void 0;
    const t = Sy(), r = St(), n = (u) => ({
      inactiveSince: u.inactiveSince,
      id: u.id,
      /**
       * DESCRIPTIVES
       */
      username: u.username,
      email: u.email,
      firstName: u.firstName,
      lastName: u.lastName,
      recoveryEmail: u.recoveryEmail,
      contactEmail: u.contactEmail,
      /**
       * LEGACY INFORMATION
       */
      legacyId: u.legacyId || null,
      /**
       * CONFIG SETTINGS
       */
      language: u.language,
      dateFormat: u.dateFormat,
      displayTimezones: u.displayTimezones,
      timezone: u.timezone,
      visibility: u.visibility || r.EUserVisibility.STANDARD,
      personalData: u.personalData,
      description: u.description,
      /**
       * ORGANIZATIONS AND PERMISSIONS
       */
      standardOrganization: u.standardOrganization,
      organizationsAndRoles: u.organizationsAndRoles,
      scopes: u.scopes,
      appPermissions: u.appPermissions,
      profileName: u.profileName,
      profiles: u.profiles,
      /**
       * USER OBJECTS
       */
      userObjects: u.userObjects,
      /**
       * AUTH CONFIGS
       */
      authConfigId: u.authConfigId,
      logins: u.logins || [],
      createdBy: u.createdBy,
      history: u.history || [],
      lockedForExternalAuthentication: u.lockedForExternalAuthentication || !1,
      createdAt: u.createdAt,
      updatedAt: u.updatedAt
    });
    e.createUser = n;
    const i = (u, h, E) => ({
      inactiveSince: null,
      id: u.id,
      /**
       * DESCRIPTIVES
       */
      username: h,
      email: "",
      firstName: null,
      lastName: null,
      recoveryEmail: null,
      contactEmail: null,
      /**
       * LEGACY INFORMATION
       */
      legacyId: null,
      /**
       * CONFIG SETTINGS
       */
      language: u.language,
      dateFormat: u.dateFormat,
      displayTimezones: u.displayTimezones,
      timezone: u.timezone,
      visibility: r.EUserVisibility.STANDARD,
      personalData: !0,
      description: null,
      /**
       * ORGANIZATIONS AND PERMISSIONS
       */
      standardOrganization: u.standardOrganization,
      organizationsAndRoles: u.organizationsAndRoles,
      scopes: u.scopes,
      appPermissions: u.appPermissions,
      /**
       * USER OBJECTS
       */
      userObjects: u.userObjects,
      /**
       * AUTH CONFIGS
       */
      authConfigId: E,
      logins: [],
      createdBy: "External IdP",
      history: [],
      lockedForExternalAuthentication: !1
    });
    e.createFromTemplateWithNewUsernameAndAuthConfig = i;
    const o = (u) => u.firstName && u.lastName ? `${u.firstName} ${u.lastName}` : u.username ? u.username : u.email ? u.email : "";
    e.getLabelForUser = o;
    const s = {
      id: (u) => u.toString(),
      appPermissions: (u) => u.join(", "),
      lockedForExternalAuthentication: (u) => u ? "Yes" : "No",
      organizationsAndRoles: (u, h) => u.map(([E, d]) => [h[E], d].join("|")).join("; "),
      scopes: (u) => u.join(", "),
      standardOrganization: (u, h) => u && h[u] || u,
      userObjects: (u) => u.join(", "),
      inactiveSince: (u) => u ? new Date(u * 1e3).toISOString() : null,
      logins: (u) => u.length === 0 ? "never" : new Date(u[0].login * 1e3).toISOString()
    }, a = (u) => Object.entries(u), l = (u, h) => {
      const E = Object.keys(t.exportedUserColumns).reduce((d, g) => (d[g] = u[g], d), {});
      return a(E).forEach(([d, g]) => {
        var y;
        const b = s[d];
        E[d] = (y = b == null ? void 0 : b(g, h)) !== null && y !== void 0 ? y : g;
      }), E;
    };
    e.mapUserCSVData = l;
    const f = (u) => (h) => (0, e.mapUserCSVData)(h, u);
    e.createUserCSVMapper = f;
  })(kp)), kp;
}
var oo = {}, Up;
function Aw() {
  if (Up) return oo;
  Up = 1, Object.defineProperty(oo, "__esModule", { value: !0 }), oo.createM2MUser = void 0;
  const e = St(), t = (r) => ({
    inactiveSince: r.inactiveSince,
    id: r.id,
    /**
     * DESCRIPTIVES
     */
    name: r.name,
    contactEmail: r.contactEmail,
    /**
     * CONFIG SETTINGS
     */
    language: r.language,
    visibility: r.visibility || e.EUserVisibility.STANDARD,
    description: r.description,
    /**
     * ORGANIZATIONS AND PERMISSIONS
     */
    standardOrganization: r.standardOrganization,
    organizationsAndRoles: r.organizationsAndRoles,
    scopes: r.scopes,
    appPermissions: r.appPermissions,
    /**
     * AUTH CONFIGS
     */
    createdBy: r.createdBy,
    history: r.history || [],
    createdAt: r.createdAt,
    updatedAt: r.updatedAt
  });
  return oo.createM2MUser = t, oo;
}
var br = {}, $p;
function vw() {
  if ($p) return br;
  $p = 1, Object.defineProperty(br, "__esModule", { value: !0 }), br.createEmptyAPIProperty = br.createEmptyAPIPropertyGroup = br.createEmptyApi = void 0;
  const e = () => ({
    isActive: !0,
    id: 0,
    name: "",
    signature: "",
    validFrom: null,
    expires: null,
    certificateName: "",
    certificateRegistered: Date.now(),
    certificateExpires: 0,
    certificateIssuer: "-",
    propertyGroups: [],
    description: ""
  });
  br.createEmptyApi = e;
  const t = () => ({
    id: 0,
    signature: "",
    name: "",
    properties: []
  });
  br.createEmptyAPIPropertyGroup = t;
  const r = () => ({
    id: 0,
    signature: "",
    name: "",
    isActive: !0,
    description: "",
    organizations: [],
    properties: ""
  });
  return br.createEmptyAPIProperty = r, br;
}
var hn = {}, Fp;
function Sw() {
  if (Fp) return hn;
  Fp = 1, Object.defineProperty(hn, "__esModule", { value: !0 }), hn.createAvailabilityTypesItem = hn.createEmptyAvailabilityRelationType = void 0;
  const e = () => ({
    name: "",
    extId: "",
    id: 0,
    description: "",
    constitutesObstacles: !1,
    occupiedByDefault: !1,
    availabilityTypes: []
  });
  hn.createEmptyAvailabilityRelationType = e;
  const t = (r) => ({
    type: r,
    ownObject: !1,
    userObject: !1
  });
  return hn.createAvailabilityTypesItem = t, hn;
}
var mn = {}, zp;
function Iw() {
  if (zp) return mn;
  zp = 1, Object.defineProperty(mn, "__esModule", { value: !0 }), mn.createEmptyField = mn.createEmptyCategory = void 0;
  const e = yy(), t = () => ({
    label: ""
  });
  mn.createEmptyCategory = t;
  const r = () => ({
    fieldType: "",
    name: "",
    id: 0,
    extId: "",
    personalData: e.EPersonalDataCheck.NO,
    description: "",
    altDesignations: [],
    filter: e.EPreferencesFilter.CHOICE1,
    length: 0,
    min: 0,
    max: 100,
    sumType: 0,
    topLevelType: 0,
    titleType: 0,
    refSeparator: " ",
    searchableInReservationList: !1,
    reservationTextField: !1,
    mandatory: !1,
    unique: !1,
    multiple: !1,
    editable: !1,
    searchable: !1,
    listable: !1,
    primary: !1,
    sortable: !1,
    virtualCategory: "",
    abstractCategory: "",
    defaultValue: "",
    checkSum: 0,
    categories: [],
    referenceFields: [],
    types: [],
    reservationTemplates: [],
    organizations: [],
    documentation: "",
    history: [],
    memberMaxCount: !1,
    memberMaxType: 0
  });
  return mn.createEmptyField = r, mn;
}
var so = {}, Gp;
function _w() {
  if (Gp) return so;
  Gp = 1, Object.defineProperty(so, "__esModule", { value: !0 }), so.createEmptyFieldRelation = void 0;
  const e = () => ({
    name: "",
    id: 0,
    description: "",
    sourceField: null,
    matchField: null,
    operator: null,
    matchMode: null,
    reservationTemplates: [],
    documentation: "",
    history: []
  });
  return so.createEmptyFieldRelation = e, so;
}
var En = {}, ao = {}, Bp;
function Rw() {
  if (Bp) return ao;
  Bp = 1, Object.defineProperty(ao, "__esModule", { value: !0 }), ao.EReservationKindMemberType = void 0;
  var e;
  return (function(t) {
    t.ABSTRACT = "ABSTRACT", t.PHYSICAL = "PHYSICAL";
  })(e || (ao.EReservationKindMemberType = e = {})), ao;
}
var Vp;
function Ow() {
  if (Vp) return En;
  Vp = 1, Object.defineProperty(En, "__esModule", { value: !0 }), En.createEmptyMemberType = En.createMemberTypesItem = void 0;
  const e = Rw(), t = (n, i) => ({
    type: n,
    memberLevel: i
  });
  En.createMemberTypesItem = t;
  const r = () => ({
    name: "",
    id: 0,
    reservationKind: e.EReservationKindMemberType.PHYSICAL,
    description: "",
    memberTypes: []
  });
  return En.createEmptyMemberType = r, En;
}
var Zt = {}, Wp;
function ww() {
  if (Wp) return Zt;
  Wp = 1, Object.defineProperty(Zt, "__esModule", { value: !0 }), Zt.createEmptyTEObject = Zt.createAvailabilityRelations = Zt.createDateRangeRelations = Zt.createDateRange = void 0;
  const e = St(), t = 31556926, r = (s) => ({
    objectId: s,
    start: parseInt((Date.now() / 1e3).toFixed(), 10),
    end: parseInt((Date.now() / 1e3).toFixed(), 10) + t
  });
  Zt.createDateRange = r;
  const n = (s) => ({
    objectIds: [s],
    start: parseInt((Date.now() / 1e3).toFixed(), 10),
    end: parseInt((Date.now() / 1e3).toFixed(), 10) + t
  });
  Zt.createDateRangeRelations = n;
  const i = (s) => ({
    availabilityTypeId: s,
    objectIds: []
  });
  Zt.createAvailabilityRelations = i;
  const o = (s, a) => ({
    id: 0,
    extId: "",
    property: e.EProperty.STANDARD,
    personalInformation: e.EPersonalInformation.STANDARD,
    fields: a.map((l) => ({ fieldId: l, values: [] })),
    types: [s],
    created: parseInt((Date.now() / 1e3).toFixed(), 10),
    createdBy: "",
    active: !0,
    members: [],
    relations: [],
    availabilityRelations: [],
    optionalRelations: [],
    organizations: []
  });
  return Zt.createEmptyTEObject = o, Zt;
}
var gn = {}, qp;
function Nw() {
  if (qp) return gn;
  qp = 1, Object.defineProperty(gn, "__esModule", { value: !0 }), gn.createEmptyPeriod = gn.createPeriodInterval = void 0;
  const e = Ty(), t = (o) => o === e.ETimeIntervals.WEEK ? 1 : o === e.ETimeIntervals.YEAR ? 2021 : o === e.ETimeIntervals.MONTH ? 2 : o === e.ETimeIntervals.DATE ? 2021.01 : o === e.ETimeIntervals.DAY || o === e.ETimeIntervals.WEEKDAY ? 1 : o === e.ETimeIntervals.TIME ? 0 : o === e.ETimeIntervals.WEEK_NUMBER ? 1 : Date.now(), r = (o) => o === e.ETimeIntervals.WEEK ? 52 : o === e.ETimeIntervals.YEAR ? 2022 : o === e.ETimeIntervals.MONTH ? 12 : o === e.ETimeIntervals.DATE ? 2022.01 : o === e.ETimeIntervals.DAY ? 28 : o === e.ETimeIntervals.WEEKDAY ? 6 : o === e.ETimeIntervals.TIME ? 17 : o === e.ETimeIntervals.WEEK_NUMBER ? 52 : Date.now(), n = (o) => ({
    type: o,
    start: t(o),
    end: r(o)
  });
  gn.createPeriodInterval = n;
  const i = () => ({
    name: "",
    shortName: "",
    id: 0,
    description: "",
    userAccess: e.EPeriodAccess.PUBLIC,
    intervals: [],
    childPeriods: [],
    history: []
  });
  return gn.createEmptyPeriod = i, gn;
}
var yn = {}, Hp;
function Cw() {
  if (Hp) return yn;
  Hp = 1, Object.defineProperty(yn, "__esModule", { value: !0 }), yn.createEmptyRelationType = yn.createRelationTypesItem = void 0;
  const e = by(), t = (n) => ({
    type: n,
    helpType: !1
  });
  yn.createRelationTypesItem = t;
  const r = () => ({
    name: "",
    id: 0,
    description: "",
    relationType: e.ERelationType.USE_ONLY,
    relationTypes: [],
    reservationTemplates: []
  });
  return yn.createEmptyRelationType = r, yn;
}
var Ar = {}, Yp;
function Pw() {
  if (Yp) return Ar;
  Yp = 1, Object.defineProperty(Ar, "__esModule", { value: !0 }), Ar.createEmptyReservationTemplate = Ar.createTemplateType = Ar.createEmptyReservationMode = void 0;
  const e = Ay(), t = () => ({
    name: "",
    extId: "",
    id: 0,
    description: "",
    showInClient: !1,
    showInCulling: !1,
    altDesignations: [],
    reservationTemplates: [],
    documentation: "",
    history: []
  });
  Ar.createEmptyReservationMode = t;
  const r = (i) => ({
    type: i,
    min: 1,
    max: 5,
    reservationKind: e.EReservationKind.ABSTRACT,
    mandatoryProperty: e.EMandatoryProperty.OPTIONAL,
    objectProperty: e.EObjectProperty.OBJECT,
    memberType: 0,
    availabilityType: 0,
    requestType: !1,
    cancelNoPermisson: !1,
    optionalRelation: e.EOptionalRelation.NONE,
    automaticObjectSelection: !1,
    reservationText: e.ETemplateTypesText.STANDARD,
    obstacleText: e.ETemplateTypesText.STANDARD,
    padding: !1,
    sizeReservationType: !1
  });
  Ar.createTemplateType = r;
  const n = () => ({
    name: "",
    templateType: e.ETemplateType.RESERVATION,
    timeRule: 0,
    privateRole: 0,
    standardOrganization: 0,
    defaultStatus: e.EDefaultStatus.CONFIRMED,
    active: !0,
    affectOrders: !1,
    id: 0,
    deleteWhenCulling: !1,
    types: [],
    typeCombinations: [],
    relationTypes: [],
    fields: [],
    reservationModes: [],
    organizations: [],
    documentation: "This is some documentation",
    history: [],
    objectSizeFieldId: 0,
    objectSizeSecondFieldId: 0,
    objectCapacityFieldId: 0
  });
  return Ar.createEmptyReservationTemplate = n, Ar;
}
var Tn = {}, Zp;
function Dw() {
  if (Zp) return Tn;
  Zp = 1, Object.defineProperty(Tn, "__esModule", { value: !0 }), Tn.createTimeZone = Tn.createEmptyTimeZone = void 0;
  const e = () => ({
    id: 0,
    extId: "",
    name: "",
    timeZone: "",
    identifiers: [],
    daylightSavingsTime: "",
    isDefault: !1,
    offset: ""
  });
  Tn.createEmptyTimeZone = e;
  const t = (r) => ({
    id: r.id,
    extId: r.extId,
    name: r.name,
    identifiers: r.identifiers,
    timeZone: r.zoneId,
    daylightSavingsTime: r.daylightSavingsTime,
    isDefault: r.isDefault,
    offset: r.offset
  });
  return Tn.createTimeZone = t, Tn;
}
var Jp = {}, Kp;
function Mw() {
  return Kp || (Kp = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createReservationMapping = e.createReservationParamMapping = void 0;
    const t = (n) => ({
      appFieldId: n.appFieldId || "",
      fieldLabel: n.fieldLabel || "",
      fieldExt: n.fieldExt || ""
    });
    e.createReservationParamMapping = t;
    const r = (n) => ({
      appId: n.appId,
      paramMappings: (n.paramMappings || []).map(e.createReservationParamMapping)
    });
    e.createReservationMapping = r;
  })(Jp)), Jp;
}
var bn = {}, Xp;
function Lw() {
  if (Xp) return bn;
  Xp = 1, Object.defineProperty(bn, "__esModule", { value: !0 }), bn.createFieldMapping = bn.createObjectTypeMapping = void 0;
  const e = St(), t = (n) => ({
    applicationObjectTypeName: n.applicationObjectTypeName || "",
    applicationObjectTypeGroup: n.applicationObjectTypeGroup || "",
    objectTypeExtId: n.objectTypeExtId || null,
    objectTypeId: n.objectTypeId || null,
    applicationObjectTypeLabel: n.applicationObjectTypeLabel || "",
    status: n.status || e.EObjectTypeMappingStatuses.NOT_MAPPED,
    labelField: n.labelField || null,
    secondaryLabelField: n.secondaryLabelField || null,
    fields: n.fields || ""
  });
  bn.createObjectTypeMapping = t;
  const r = (n) => ({
    appFieldName: n.appFieldName || "",
    appProperty: n.appProperty || "",
    isSearchable: n.isSearchable || "",
    defaultSorting: n.defaultSorting,
    fieldExtId: n.fieldExtId || null,
    fieldId: n.fieldId || null,
    fieldLabel: n.fieldLabel || "",
    allocationFieldFromObject: n.allocationFieldFromObject || ""
  });
  return bn.createFieldMapping = r, bn;
}
var Qp = {}, eh;
function xw() {
  return eh || (eh = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getRedirectUri = e.getCustomerPrefix = e.removeCloudPrefix = e.transformCustomerSignature = e.transformCustomerSignatureDashed = e.redirectURIs = void 0;
    const t = vy(), r = "timeedit.dev", n = "timeedit.io", i = "test.timeedit.net", o = "timeedit.net";
    e.redirectURIs = {
      development: {
        TE_ADMIN: (u) => "http://localhost:3004",
        TE_ALLOCATE: (u) => "http://localhost:5174",
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.dev/${u}/client`,
        TE_CURRICULUM: (u) => "http://localhost:3000",
        TE_DATA_MANAGER: (u) => "http://localhost:3060",
        TE_EVALUATION: (u) => "http://localhost:3000",
        TE_EXAM: (u) => "http://localhost:3999",
        TE_EXAM_V3: (u) => `http://localhost:3000/${u}`,
        TE_HUB: (u) => `http://localhost:3008/${u}`,
        TE_PLAN: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_PORTAL: (u) => `http://localhost:1337/${u}`,
        TE_PREFERENCES: (u) => "http://localhost:3005",
        TE_REGISTRATION: (u) => "http://localhost:5173",
        TE_REPORTING: (u) => "http://localhost:3201",
        TE_RESERVE: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_STUDY_GUIDE: (u) => "http://localhost:3000",
        TE_STUDY_PLANNER: (u) => `http://localhost:3030/${u}`,
        TE_VIEWER: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_WORKLOAD: (u) => "http://localhost:3000"
      },
      beta: {
        TE_ADMIN: (u) => `https://admin.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.dev`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.dev`,
        TE_EXAM: (u) => `https://exam.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://new-preferences.timeedit.dev",
        TE_REGISTRATION: (u) => `https://registration.timeedit.dev/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.dev",
        TE_RESERVE: (u) => `https://cloud.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.dev`,
        TE_STUDY_PLANNER: (u, h) => l(r, u, h),
        TE_VIEWER: (u) => `https://cloud.timeedit.dev/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.dev`
      },
      staging: {
        TE_ADMIN: (u) => `https://admin.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.io/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.io`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.io`,
        TE_EXAM: (u) => `https://exam-v3.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.io/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://new-preferences.timeedit.io",
        TE_REGISTRATION: (u) => `https://registration.timeedit.io/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.io",
        TE_RESERVE: (u) => `https://cloud.timeedit.io/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.io`,
        TE_STUDY_PLANNER: (u, h) => l(n, u, h),
        TE_VIEWER: (u) => `https://cloud.timeedit.io/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.io`
      },
      test: {
        TE_ADMIN: (u) => `https://admin.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.test.timeedit.net`,
        TE_DATA_MANAGER: (u) => `https://data-manager.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.test.timeedit.net`,
        TE_EXAM: (u) => `https://exam.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `http://portal.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://preferences.test.timeedit.net",
        TE_REGISTRATION: (u) => `https://registration.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.test.timeedit.net",
        TE_RESERVE: (u) => `https://cloud.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.test.timeedit.net`,
        TE_STUDY_PLANNER: (u, h) => l(i, u, h),
        TE_VIEWER: (u) => `https://cloud.test.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.test.timeedit.net`
      },
      production: {
        TE_ADMIN: (u) => `https://admin.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.net/${(0, e.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.net`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.net`,
        TE_EXAM: (u) => `https://exam.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://preferences.timeedit.net",
        TE_REGISTRATION: (u) => `https://registration.timeedit.net/${(0, e.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.net",
        TE_RESERVE: (u) => `https://cloud.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.net`,
        TE_STUDY_PLANNER: (u, h) => l(o, u, h),
        TE_VIEWER: (u) => `https://cloud.timeedit.net/${(0, e.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, e.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.net`
      }
    };
    const s = (u) => u.replace(/_/g, "-").replace(/^cloud-/, "");
    e.transformCustomerSignatureDashed = s;
    const a = (u) => u.replace(/^cloud_/, "");
    e.transformCustomerSignature = a, e.removeCloudPrefix = e.transformCustomerSignature, e.getCustomerPrefix = e.transformCustomerSignatureDashed;
    const l = (u, h, E) => `https://${E ? `studyplanner.${t.REGION_LOCATIONS[E]}.${u}` : `studyplanner.${u}`}/${(0, e.transformCustomerSignature)(h)}`, f = (u, h, E, d) => {
      var g;
      const y = (g = e.redirectURIs[E]) === null || g === void 0 ? void 0 : g[u];
      if (typeof y == "function")
        return y(h, d);
    };
    e.getRedirectUri = f;
  })(Qp)), Qp;
}
var uo = {}, th;
function kw() {
  if (th) return uo;
  th = 1, Object.defineProperty(uo, "__esModule", { value: !0 }), uo.convertPartialAttributesRowToAffiliation = e, uo.convertPartialAttributesMatchingToAffiliations = t;
  function e(r, n, i) {
    const [o, s, a, l, f] = r, u = o.map(([E, d]) => ({
      attribute: E,
      value: d
    })), h = s.map(([E, d]) => ({
      organizationId: E,
      role: d
    }));
    return {
      authConfigId: n,
      label: f,
      priority: i,
      matchingCriteria: u,
      organizationsAndRoles: h,
      scopes: [],
      appPermissions: [],
      userObjects: l,
      standardOrganization: a
    };
  }
  function t(r, n) {
    return r.map((i, o) => e(i, n, o));
  }
  return uo;
}
var rh;
function jw() {
  return rh || (rh = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createReservationParamMapping = e.createReservationMapping = e.createTimeZone = e.createTemplateType = e.createEmptyReservationTemplate = e.createEmptyReservationMode = e.createEmptyRelationType = e.createRelationTypesItem = e.createPeriodInterval = e.createEmptyPeriod = e.createEmptyTEObject = e.createDateRangeRelations = e.createAvailabilityRelations = e.createDateRange = e.createMemberTypesItem = e.createEmptyMemberType = e.createEmptyFieldRelation = e.createEmptyCategory = e.createEmptyField = e.createAvailabilityTypesItem = e.createEmptyAvailabilityRelationType = e.createEmptyApi = e.createM2MUser = e.mapUserCSVData = e.getLabelForUser = e.createUser = e.createUserCSVMapper = e.createEmptyType = e.createTokenPermissions = e.createUnsignedReadOnlyFromTEUser = e.createUnsignedReadOnlyFromTERootUser = e.createUnsignedFromTERootUser = e.createUnsignedFromM2MUser = e.createUnsignedFromTEUser = e.createEmptyTTime = e.createEmptyTTimeRule = e.createEmptyTWeekdaySelection = e.createTTime = e.createSOAPConnectionSettings = e.createRolePermissionGroup = e.createRolePermission = e.createRole = e.createPermission = e.createPaddingRule = e.createOrganizationTreeNode = e.createOrganizationNode = e.createOrganization = e.createAltDesignation = e.createImport = e.createAuthConfig = void 0, e.convertPartialAttributesMatchingToAffiliations = e.convertPartialAttributesRowToAffiliation = e.redirectURIs = e.getRedirectUri = e.createFieldMapping = e.createObjectTypeMapping = void 0;
    var t = ow();
    Object.defineProperty(e, "createAuthConfig", { enumerable: !0, get: function() {
      return t.createAuthConfig;
    } });
    var r = aw();
    Object.defineProperty(e, "createImport", { enumerable: !0, get: function() {
      return r.createImport;
    } });
    var n = uw();
    Object.defineProperty(e, "createAltDesignation", { enumerable: !0, get: function() {
      return n.createAltDesignation;
    } });
    var i = lw();
    Object.defineProperty(e, "createOrganization", { enumerable: !0, get: function() {
      return i.createOrganization;
    } });
    var o = cw();
    Object.defineProperty(e, "createOrganizationNode", { enumerable: !0, get: function() {
      return o.createOrganizationNode;
    } });
    var s = fw();
    Object.defineProperty(e, "createOrganizationTreeNode", { enumerable: !0, get: function() {
      return s.createOrganizationTreeNode;
    } });
    var a = dw();
    Object.defineProperty(e, "createPaddingRule", { enumerable: !0, get: function() {
      return a.createPaddingRule;
    } });
    var l = pw();
    Object.defineProperty(e, "createPermission", { enumerable: !0, get: function() {
      return l.createPermission;
    } });
    var f = hw();
    Object.defineProperty(e, "createRole", { enumerable: !0, get: function() {
      return f.createRole;
    } }), Object.defineProperty(e, "createRolePermission", { enumerable: !0, get: function() {
      return f.createRolePermission;
    } }), Object.defineProperty(e, "createRolePermissionGroup", { enumerable: !0, get: function() {
      return f.createRolePermissionGroup;
    } });
    var u = mw();
    Object.defineProperty(e, "createSOAPConnectionSettings", { enumerable: !0, get: function() {
      return u.createSOAPConnectionSettings;
    } });
    var h = Ew();
    Object.defineProperty(e, "createTTime", { enumerable: !0, get: function() {
      return h.createTTime;
    } }), Object.defineProperty(e, "createEmptyTWeekdaySelection", { enumerable: !0, get: function() {
      return h.createEmptyTWeekdaySelection;
    } }), Object.defineProperty(e, "createEmptyTTimeRule", { enumerable: !0, get: function() {
      return h.createEmptyTTimeRule;
    } }), Object.defineProperty(e, "createEmptyTTime", { enumerable: !0, get: function() {
      return h.createEmptyTTime;
    } });
    var E = gw();
    Object.defineProperty(e, "createUnsignedFromTEUser", { enumerable: !0, get: function() {
      return E.createUnsignedFromTEUser;
    } }), Object.defineProperty(e, "createUnsignedFromM2MUser", { enumerable: !0, get: function() {
      return E.createUnsignedFromM2MUser;
    } }), Object.defineProperty(e, "createUnsignedFromTERootUser", { enumerable: !0, get: function() {
      return E.createUnsignedFromTERootUser;
    } }), Object.defineProperty(e, "createUnsignedReadOnlyFromTERootUser", { enumerable: !0, get: function() {
      return E.createUnsignedReadOnlyFromTERootUser;
    } }), Object.defineProperty(e, "createUnsignedReadOnlyFromTEUser", { enumerable: !0, get: function() {
      return E.createUnsignedReadOnlyFromTEUser;
    } });
    var d = yw();
    Object.defineProperty(e, "createTokenPermissions", { enumerable: !0, get: function() {
      return d.createTokenPermissions;
    } });
    var g = Tw();
    Object.defineProperty(e, "createEmptyType", { enumerable: !0, get: function() {
      return g.createEmptyType;
    } });
    var y = bw();
    Object.defineProperty(e, "createUserCSVMapper", { enumerable: !0, get: function() {
      return y.createUserCSVMapper;
    } }), Object.defineProperty(e, "createUser", { enumerable: !0, get: function() {
      return y.createUser;
    } }), Object.defineProperty(e, "getLabelForUser", { enumerable: !0, get: function() {
      return y.getLabelForUser;
    } }), Object.defineProperty(e, "mapUserCSVData", { enumerable: !0, get: function() {
      return y.mapUserCSVData;
    } });
    var b = Aw();
    Object.defineProperty(e, "createM2MUser", { enumerable: !0, get: function() {
      return b.createM2MUser;
    } });
    var I = vw();
    Object.defineProperty(e, "createEmptyApi", { enumerable: !0, get: function() {
      return I.createEmptyApi;
    } });
    var S = Sw();
    Object.defineProperty(e, "createEmptyAvailabilityRelationType", { enumerable: !0, get: function() {
      return S.createEmptyAvailabilityRelationType;
    } }), Object.defineProperty(e, "createAvailabilityTypesItem", { enumerable: !0, get: function() {
      return S.createAvailabilityTypesItem;
    } });
    var w = Iw();
    Object.defineProperty(e, "createEmptyField", { enumerable: !0, get: function() {
      return w.createEmptyField;
    } }), Object.defineProperty(e, "createEmptyCategory", { enumerable: !0, get: function() {
      return w.createEmptyCategory;
    } });
    var P = _w();
    Object.defineProperty(e, "createEmptyFieldRelation", { enumerable: !0, get: function() {
      return P.createEmptyFieldRelation;
    } });
    var _ = Ow();
    Object.defineProperty(e, "createEmptyMemberType", { enumerable: !0, get: function() {
      return _.createEmptyMemberType;
    } }), Object.defineProperty(e, "createMemberTypesItem", { enumerable: !0, get: function() {
      return _.createMemberTypesItem;
    } });
    var v = ww();
    Object.defineProperty(e, "createDateRange", { enumerable: !0, get: function() {
      return v.createDateRange;
    } }), Object.defineProperty(e, "createAvailabilityRelations", { enumerable: !0, get: function() {
      return v.createAvailabilityRelations;
    } }), Object.defineProperty(e, "createDateRangeRelations", { enumerable: !0, get: function() {
      return v.createDateRangeRelations;
    } }), Object.defineProperty(e, "createEmptyTEObject", { enumerable: !0, get: function() {
      return v.createEmptyTEObject;
    } });
    var M = Nw();
    Object.defineProperty(e, "createEmptyPeriod", { enumerable: !0, get: function() {
      return M.createEmptyPeriod;
    } }), Object.defineProperty(e, "createPeriodInterval", { enumerable: !0, get: function() {
      return M.createPeriodInterval;
    } });
    var x = Cw();
    Object.defineProperty(e, "createRelationTypesItem", { enumerable: !0, get: function() {
      return x.createRelationTypesItem;
    } }), Object.defineProperty(e, "createEmptyRelationType", { enumerable: !0, get: function() {
      return x.createEmptyRelationType;
    } });
    var z = Pw();
    Object.defineProperty(e, "createEmptyReservationMode", { enumerable: !0, get: function() {
      return z.createEmptyReservationMode;
    } }), Object.defineProperty(e, "createEmptyReservationTemplate", { enumerable: !0, get: function() {
      return z.createEmptyReservationTemplate;
    } }), Object.defineProperty(e, "createTemplateType", { enumerable: !0, get: function() {
      return z.createTemplateType;
    } });
    var F = Dw();
    Object.defineProperty(e, "createTimeZone", { enumerable: !0, get: function() {
      return F.createTimeZone;
    } });
    var W = Mw();
    Object.defineProperty(e, "createReservationMapping", { enumerable: !0, get: function() {
      return W.createReservationMapping;
    } }), Object.defineProperty(e, "createReservationParamMapping", { enumerable: !0, get: function() {
      return W.createReservationParamMapping;
    } });
    var X = Lw();
    Object.defineProperty(e, "createObjectTypeMapping", { enumerable: !0, get: function() {
      return X.createObjectTypeMapping;
    } }), Object.defineProperty(e, "createFieldMapping", { enumerable: !0, get: function() {
      return X.createFieldMapping;
    } });
    var de = xw();
    Object.defineProperty(e, "getRedirectUri", { enumerable: !0, get: function() {
      return de.getRedirectUri;
    } }), Object.defineProperty(e, "redirectURIs", { enumerable: !0, get: function() {
      return de.redirectURIs;
    } });
    var B = kw();
    Object.defineProperty(e, "convertPartialAttributesRowToAffiliation", { enumerable: !0, get: function() {
      return B.convertPartialAttributesRowToAffiliation;
    } }), Object.defineProperty(e, "convertPartialAttributesMatchingToAffiliations", { enumerable: !0, get: function() {
      return B.convertPartialAttributesMatchingToAffiliations;
    } });
  })(gp)), gp;
}
var nh;
function Uw() {
  return nh || (nh = 1, (function(e) {
    var t = Xn && Xn.__createBinding || (Object.create ? (function(n, i, o, s) {
      s === void 0 && (s = o);
      var a = Object.getOwnPropertyDescriptor(i, o);
      (!a || ("get" in a ? !i.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
        return i[o];
      } }), Object.defineProperty(n, s, a);
    }) : (function(n, i, o, s) {
      s === void 0 && (s = o), n[s] = i[o];
    })), r = Xn && Xn.__exportStar || function(n, i) {
      for (var o in n) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, n, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(Sy(), e), r(St(), e), r(nw(), e), r(jw(), e);
  })(Xn)), Xn;
}
var $w = Uw();
const Fw = {
  HUB: {
    STUDENT: "TE_HUB::student"
  }
}, or = {
  ALLOCATE: {
    USER: "TE_ALLOCATE::user",
    ADMIN: "TE_ALLOCATE::admin"
  },
  REGISTRATION: {
    USER: "TE_REGISTRATION::user"
  },
  ROOT: $w.TE_ROOT_USER
}, _y = [
  "ADJUST",
  "PREFERENCE",
  "SELECT",
  "INCONCLUSIVE",
  "UNKNOWN"
], zw = pe(_y), Gw = ["ISSUE", "OK", "PENDING"], Ry = pe(Gw), Bw = [
  "ALLOCATED_TO_THIS",
  "ALLOCATED_TO_OTHER",
  "NOT_ALLOCATED",
  "MULTIPLE_ALLOCATIONS"
], Vw = pe(Bw), Ww = ["NONE", "REQUESTED", "CONFIRMED"];
pe(Ww);
const qw = ["OK", "ERROR", "WARNING"];
pe(qw);
const Hw = [
  or.REGISTRATION.USER,
  or.ALLOCATE.USER,
  or.ALLOCATE.ADMIN,
  or.ROOT
];
pe(Hw);
const ih = 3e3, oh = 1e3, $t = N({
  local: A(),
  timezone: A().optional(),
  unix: R().int().nonnegative()
});
var Ae = St(), Oy = Jl(), wy = Iy();
function Bo(e, t) {
  return A().optional().nullable().transform(
    (r) => Object.values(e).includes(r ?? "") ? r : t
  ).pipe(pe(e));
}
function Qr(e) {
  return A().optional().nullable().transform(
    (t) => t !== void 0 && Object.values(e).includes(t ?? "") ? t : void 0
  ).pipe(pe(e).optional());
}
const Yw = Bo(
  Ae.EApplicationObjectTypeGroup,
  Ae.EApplicationObjectTypeGroup.NONE
), Zw = Bo(
  Ae.EAppProperties,
  Ae.EAppProperties.NONE
), Jw = Qr(Ae.EAppId), Ny = pe(Ae.EAppId), Cy = Qr(Oy.ERegion);
pe(Oy.ERegion);
Qr(
  Ae.EObjectTypeMappingStatuses
);
pe(
  Ae.EObjectTypeMappingStatuses
);
Qr(Ae.EOrganizationType);
pe(Ae.EOrganizationType);
pe(wy.EOrganizationVisibility);
const Kw = Qr(
  wy.EOrganizationVisibility
), Xw = Qr(Ae.ETokenType);
pe(Ae.ETokenType);
Bo(
  Ae.EUserVisibility,
  Ae.EUserVisibility.STANDARD
);
Bo(
  Ae.EPersonalDataCheck,
  Ae.EPersonalDataCheck.STANDARD
);
var Gu = ((e) => (e[e.YES = Ae.EPersonalInformation.YES] = "YES", e[e.NO = Ae.EPersonalInformation.NO] = "NO", e[e.STANDARD = Ae.EPersonalInformation.STANDARD] = "STANDARD", e))(Gu || {});
Bo(
  Gu,
  Gu.STANDARD
);
Qr(Ae.EPreferencesFilter);
pe(Ae.EPreferencesFilter);
Qr(Ae.EProperty);
pe(Ae.EProperty);
var ue = /* @__PURE__ */ ((e) => (e.Error = "Error", e.ValidationError = "ValidationError", e.BadRequestError = "BadRequestError", e.NotFoundError = "NotFoundError", e.AdminConfigurationError = "AdminConfigurationError", e.StudentSetGroupConfigurationError = "StudentSetGroupConfigurationError", e.PopulateCacheBusyError = "PopulateCacheBusyError", e.AutoAllocateBusyError = "AutoAllocateBusyError", e.CloudJobRunningError = "CloudJobRunningError", e.NoStudentObjectError = "NoStudentObjectError", e.SubscribeError = "SubscribeError", e.PacemakerFetchError = "PacemakerFetchError", e.PacemakerResponseError = "PacemakerResponseError", e.PermissionError = "PermissionError", e.ExternalServiceError = "ExternalServiceError", e.MultiError = "MultiError", e.RegistrationApiError = "RegistrationApiError", e.HeavyLoadError = "HeavyLoadError", e.NothingToAllocateError = "NothingToAllocateError", e.FrontendError = "FrontendError", e.RegistrationError = "RegistrationError", e.MyScheduleError = "MyScheduleError", e.MaximumMembershipReachedError = "MaximumMembershipReachedError", e.MaximumMembershipReachedByTypeError = "MaximumMembershipReachedByTypeError", e.TEServerFailedError = "TEServerFailedError", e.WorkerInlineFallbackError = "WorkerInlineFallbackError", e.WorkerTimeoutError = "WorkerTimeoutError", e.WorkerQueueSaturated = "WorkerQueueSaturated", e.InterruptAbortException = "InterruptAbortException", e.UnmountAbortException = "UnmountAbortException", e.AddWaitlistError = "AddWaitlistError", e.HistoryError = "HistoryError", e.IssueListCacheError = "IssueListCacheError", e.ReservationError = "ReservationError", e.EnvError = "EnvError", e))(ue || {});
const ra = pe(ue);
var ar = /* @__PURE__ */ ((e) => (e.ASCID = "ASCID", e.DESCID = "DESCID", e.ASCMOD = "ASCMOD", e.DESCMOD = "DESCMOD", e.ASCFIELD = "ASCFIELD", e.DESCFIELD = "DESCFIELD", e))(ar || {});
const Bu = pe(ar);
var Py = /* @__PURE__ */ ((e) => (e.ASCID = "ASCID", e.DESCID = "DESCID", e.ASCTIME = "ASCTIME", e.DESCTIME = "DESCTIME", e.ASCMOD = "ASCMOD", e.DESCMOD = "DESCMOD", e.ASCTAG = "ASCTAG", e.DESCTAG = "DESCTAG", e))(Py || {});
const Qw = pe(Py), eN = [
  Ae.EReservationStatuses.Complete,
  Ae.EReservationStatuses.Incomplete,
  Ae.EReservationStatuses.Confirmed,
  Ae.EReservationStatuses.Requested,
  Ae.EReservationStatuses.Rejected
];
Gl([k(A()), k(A())]).optional();
const Kl = Gl([A(), A()]);
N({
  language: A(),
  name: A(),
  description: A()
});
const tN = [
  Ae.EFieldType.TEXT,
  Ae.EFieldType.SIGNATURE,
  Ae.EFieldType.EMAIL,
  Ae.EFieldType.URL,
  Ae.EFieldType.TELEPHONE,
  Ae.EFieldType.CATEGORY,
  Ae.EFieldType.COMMENT,
  Ae.EFieldType.INTEGER,
  Ae.EFieldType.LENGTH,
  Ae.EFieldType.CHECKBOX,
  Ae.EFieldType.REFERENCE,
  Ae.EFieldType.NON_SEARCHABLE_TEXT,
  Ae.EFieldType.NON_SEARCHABLE_REFERENCE,
  ""
], rN = pe(tN), Xl = N({
  id: R(),
  extId: A(),
  name: A(),
  // description: z.string(),
  // altDesignations: z.array(TAltDesignations),
  // documentation: z.string(),
  // history: z.array(THistory),
  fieldType: rN.default("").optional(),
  // personalData: ZPersonalDataCheck,
  // filter: z.union([ZPreferencesFilterRequired, z.string()]).optional(),
  // length: z.number().optional(),
  // min: z.number().optional(),
  // max: z.number().optional(),
  // sumType: z.number().optional(),
  // topLevelType: z.number().optional(),
  // titleType: z.number().optional(),
  refSeparator: A().optional(),
  memberMaxType: R().optional(),
  memberMaxCount: oe().optional(),
  // searchableInReservationList: z.boolean().optional(),
  // reservationTextField: z.boolean().optional(),
  mandatory: oe().optional(),
  // unique: z.boolean().optional(),
  // multiple: z.boolean().optional(),
  // editable: z.boolean().optional(),
  searchable: oe(),
  // listable: z.boolean(),
  // primary: z.boolean(),
  // sortable: z.boolean(),
  // virtualCategory: z.string().optional(),
  // abstractCategory: z.string().optional(),
  defaultValue: A().optional(),
  checkSum: R().optional(),
  categories: k(A()).optional(),
  referenceFields: k(R()),
  types: k(R())
  // reservationTemplates: z.array(z.number()),
  // organizations: z.array(z.string()),
});
fr(Xl);
const nN = N({
  type: bt([A(), R()]).optional(),
  memberLevel: R()
}), Ql = N({
  id: R(),
  name: A(),
  memberTypes: k(nN).default([])
});
fr(Ql);
const Jr = R(), Vo = N({
  fieldId: Jr,
  values: k(A())
}), ec = N({
  objectId: Jr,
  start: R(),
  end: R()
}), Dy = N({
  start: R(),
  end: R(),
  objectIds: k(Jr)
});
N({
  availabilityTypeId: Jr,
  objectIds: k(Jr)
});
const iN = N({
  sort: A().optional(),
  objectStatus: A().optional(),
  // Type up the options
  page: R().optional(),
  limit: R().optional(),
  virtual: A().optional(),
  // Type up the options
  abstract: A().optional(),
  // Type up the options
  active: A().optional(),
  // Type up the options
  typeId: R().optional(),
  ids: k(R()).optional(),
  extIds: k(A()).optional(),
  excludeIds: k(R()).optional(),
  excludeExtIds: k(A()).optional(),
  modified: N({
    beginModified: R(),
    endModified: R()
  }).optional(),
  fields: N({
    exactSearchFieldIds: k(R()),
    generalSearchFieldIds: k(R()),
    searchText: A().optional()
  }).optional()
}).optional();
N({
  body: iN
});
const Ft = N({
  id: R(),
  extId: A(),
  created: R(),
  // createdBy: z.string(),
  // history: z.union([z.array(THistory), THistory]),
  // property: ZPropertyOptional,
  // personalInformation: ZPersonalInformation,
  fields: k(Vo),
  // organizations: z.array(z.union([z.string(), z.number()])),
  members: k(ec),
  types: k(Jr),
  relations: k(Dy),
  // availabilityRelations: z.array(TAvailabilityRelations),
  // optionalRelations: z.array(RelatedId),
  active: oe(),
  virtual: oe(),
  abstract: oe()
  // color: z.string(),
}), oN = Xr({
  id: R(),
  extId: A(),
  created: R(),
  fields: k(Vo),
  members: k(ec),
  types: k(Jr),
  relations: k(Dy),
  active: oe(),
  virtual: oe(),
  abstract: oe()
});
fr(Ft);
sN(oN);
function fr(e) {
  return N({
    limit: R().optional(),
    page: R().optional(),
    results: k(e).optional(),
    totalPages: R().optional(),
    totalResults: R().optional()
  });
}
function sN(e) {
  return Xr({
    limit: R().optional(),
    page: R().optional(),
    results: k(e).optional(),
    totalPages: R().optional(),
    totalResults: R().optional()
  });
}
const aN = Xr({
  id: R(),
  extId: A().optional(),
  status: R(),
  errorCode: R().optional(),
  message: A().optional(),
  localizedMessage: A().optional()
});
function uN(e) {
  return fr(e).extend({
    failed: R().optional().default(0),
    success: R().optional().default(0)
  });
}
uN(aN);
const My = N({
  id: A(),
  name: A().optional().default(""),
  customerSignature: A().optional().default(""),
  customerLogo: A().optional().nullable().default(""),
  // teServerUrl: z.string().optional().default(""),
  public: oe().optional().default(!1),
  enabledProducts: k(Jw).transform((e) => e.filter(Boolean)).optional().default([]),
  // Org type is not trustworthy.
  // type: ZOrganizationTypeRequired,
  rootUserPermissions: k(Kl.or(A())).optional().default([]),
  rootUserStandardOrganizationNode: A().optional().default(""),
  region: Cy,
  visibility: Kw,
  // createdAt: z.number().optional().default(0),
  // updatedAt: z.number().optional().default(0),
  // inactiveSince: z.number().optional().nullable().default(null),
  inactive: oe().optional().default(!1)
});
fr(My);
My.pick({
  id: !0,
  name: !0,
  customerSignature: !0,
  customerLogo: !0,
  enabledProducts: !0,
  region: !0,
  visibility: !0
}).extend({
  customerColor: A().nullable().optional(),
  database: A().optional()
});
const lN = N({
  objectId: R(),
  typeId: R()
}), cN = N({
  sort: Qw.optional(),
  page: R().optional(),
  limit: R().optional(),
  modified: N({
    beginModified: R().optional(),
    endModified: R().optional()
  }).optional(),
  date: N({
    startDate: R().optional(),
    endDate: R().optional()
  }).optional(),
  searchObjects: k(lN).optional(),
  types: k(R()).optional(),
  reservationMode: R().optional(),
  fields: N({
    exactSearchFieldIds: k(R()),
    generalSearchFieldIds: k(R()),
    searchText: A().optional()
  }).optional(),
  reservationStatus: k(A()).optional(),
  mineOnly: oe().optional(),
  includeReservationModes: oe().optional(),
  ids: k(R()).optional(),
  extIds: k(A()).optional(),
  typeId: R().optional()
});
N({
  body: cN
});
const Ly = N({
  id: R(),
  extId: A().optional(),
  // organizations: z.array(z.string()).optional(),
  history: N({
    modified: R().optional(),
    modifiedBy: A().optional()
  }),
  // .optional(),
  // created: z.number().optional(),
  // createdBy: z.string().optional(),
  begin: R().optional(),
  end: R().optional(),
  // originalReservation: z.number().optional(),
  // autoEngineId: z.string().optional(),
  // length: z.number().optional(),
  objects: k(
    N({
      objectId: R(),
      typeId: R()
    })
  ).optional(),
  fields: k(
    N({
      fieldId: R(),
      values: k(A())
    })
  ).optional(),
  status: k(pe(Ae.EReservationStatuses)).optional(),
  // Only present when the find request sets `includeReservationModes`.
  reservationModes: k(R()).optional()
  // tags: z.array(z.string()).optional(),
});
fr(Ly);
dt(A(), A());
const fN = N({
  id: A(),
  legacyId: A().nullable().optional(),
  profileName: A().optional(),
  standardOrganization: A().nullable().optional(),
  organizationsAndRoles: k(Kl),
  scopes: k(A()),
  appPermissions: k(A()),
  userObjects: k(A()),
  inactiveSince: R().nullable()
}), sh = N({
  id: A(),
  profileName: A().optional()
}), xy = N({
  region: Cy,
  // Mandatory identifiers
  id: A(),
  // User id
  type: Xw,
  customerSignature: A().nullable().optional(),
  organizationId: A().nullable().optional(),
  username: A().optional(),
  email: A().nullable().optional(),
  // Permissions
  appPermissions: k(A()).optional().default([]),
  scopes: k(A()),
  organizationsAndRoles: k(Kl).optional(),
  // Profiles
  profile: sh.optional(),
  profiles: k(sh).optional(),
  // Token stuff
  iat: R().optional(),
  exp: R().optional(),
  fingerprintHashed: A().optional()
}), tc = N({
  id: R(),
  extId: A(),
  name: A(),
  // description: z.string(),
  // documentation: z.string(),
  // history: z.array(THistory),
  // altDesignations: z.array(TAltDesignations),
  active: oe(),
  // personalData: z.boolean(),
  // allowStandardObjects: z.boolean(),
  // allowAbstractObjects: z.boolean(),
  // allowVirtualObjects: z.boolean(),
  // personType: z.boolean(),
  // locationType: z.boolean(),
  // aliasType: RelatedId,
  // externalOwner: z.string(),
  subTypes: k(Jr).optional()
  // fields: z.array(RelatedId).optional(),
  // parentFields: z.array(RelatedId).optional(),
  // reservationTemplates: z.array(z.number()).optional(),
  // organizations: z.array(z.union([z.string(), z.number()])).optional(),
});
fr(tc);
N({
  login: R().optional(),
  appId: Ny
});
const rc = N({
  id: A(),
  inactiveSince: R().nullable().optional(),
  // DESCRIPTIVES
  organizationId: A().nullable().optional(),
  username: A().optional(),
  email: A().nullable().optional(),
  firstName: A().nullable().optional(),
  lastName: A().nullable().optional(),
  // PROFILES
  profileName: A().optional(),
  profiles: k(fN).optional(),
  // LEGACY INFORMATION
  // legacyId: z.string().nullable().optional(),
  // CONFIG SETTINGS
  // language: z.string().nullable().optional(),
  // dateFormat: z.string().nullable().optional(),
  // displayTimezones: z.array(z.string()).optional(),
  timezone: A().nullable().optional(),
  // visibility: ZUserVisibility.optional(),
  // personalData: z.boolean().optional(),
  // description: z.string().nullable().optional(),
  // ORGANIZATIONS AND PERMISSIONS
  // standardOrganization: z.string().nullable().optional(), // Only leaves allowed
  // ** NOTE ** organizationAndRoles can fail validation how it looks below. It can have a tuple of value null
  // organizationsAndRoles: z.array(TAttributeValueArrayPair).optional(),
  scopes: k(A()),
  appPermissions: k(A()).optional(),
  // USER OBJECTS
  userObjects: k(A()).optional()
  // AUTH CONFIG
  // authConfigId: z.string().optional(),
  // USAGE STATISTICS
  // logins: z.array(TLogins).optional(),
  // createdBy: z.string().nullable().optional(),
  // history: z.array(THistory),
  // lockedForExternalAuthentication: z.boolean().optional(),
  // createdAt: z.number().optional(),
  // updatedAt: z.number().optional(),
});
fr(rc);
rc.pick({
  id: !0,
  email: !0,
  firstName: !0,
  lastName: !0,
  timezone: !0
});
rc.pick({
  email: !0,
  firstName: !0,
  lastName: !0,
  profiles: !0
});
N({
  id: A(),
  email: A().nullable().optional(),
  name: A()
});
const dN = N({
  isSearchable: oe().optional(),
  // appFieldName: z.string(),
  appProperty: Zw,
  fieldExtId: A().optional().nullable(),
  fieldId: R().optional().nullable()
  // fieldLabel: z.string(),
  // allocationFieldFromObject: z.string().optional().nullable(),
}), pN = N({
  // applicationObjectTypeName: z.string(),
  applicationObjectTypeGroup: Yw,
  // applicationObjectTypeLabel: z.string(),
  objectTypeExtId: A().optional().nullable(),
  objectTypeId: R().optional().nullable(),
  // labelField: z.string().optional().nullable(),
  // secondaryLabelField: z.string().optional().nullable(),
  fields: k(dN)
  // status: ZObjectTypeMappingStatusesRequired,
}), ky = N({
  appId: Ny,
  objectTypes: k(pN)
});
N({
  mappingData: ky,
  fields: xa(R(), Xl),
  types: xa(R(), tc),
  memberTypes: xa(R(), Ql)
});
N({
  mappingData: ky,
  fields: k(Xl),
  types: k(tc),
  memberTypes: k(Ql)
});
const hN = N({
  id: R(),
  extId: A(),
  name: A(),
  identifiers: k(A()).optional(),
  // daylightSavingsTime: z.string(),
  isDefault: oe(),
  offset: A().optional(),
  timeZone: A()
}), ah = N({
  extId: A(),
  name: A(),
  identifier: A(),
  offset: A()
});
N({
  server: ah,
  user: ah
});
fr(hN);
const mN = N({
  id: A().optional(),
  viewLinkSubmitter: A().optional(),
  viewerEntry: A().optional(),
  viewerPath: A().optional(),
  viewerPage: A().optional(),
  commentField: A().optional(),
  currentPeriod: A().optional(),
  reservationMode: R().optional()
}), jy = N({
  daily: oe().default(!1),
  hourly: oe().default(!1),
  everyMinute: oe().default(!1)
});
Object.keys(
  jy.shape
);
const EN = N({
  deAllocationEnabled: oe().default(!1),
  allocationEnabled: oe().default(!1),
  frequency: jy.default({
    daily: !1,
    hourly: !1,
    everyMinute: !1
  }),
  fromWaitlistEnabled: oe().default(!1)
}), gN = N({
  automaticAllocation: EN.optional(),
  blockStudentConflict: oe().default(!1),
  enableWaitlist: oe().default(!1),
  reservationStatuses: k(pe(Ae.EReservationStatuses)).default(eN)
}), yN = N({
  startDate: R().optional(),
  endDate: R().optional()
}), TN = N({
  start: R(),
  end: R()
}), bN = dt(A(), k(A())), AN = N({
  range: TN.optional(),
  fields: bN.optional()
});
N({ id: R(), name: A() });
const vN = mN.extend({
  current: AN,
  dateRange: yN.optional(),
  currentFieldIds: k(R()),
  reservationMode: R().optional()
});
N({
  viewLink: vN,
  allocateSettings: gN
});
const Xe = (e) => N({
  label: A(),
  value: e
}), As = N({
  id: R(),
  begin: $t,
  end: $t,
  isInfo: oe().optional(),
  title: A(),
  subtitle: A().optional(),
  examType: Xe(A()).optional(),
  module: k(
    N({
      name: Xe(A()),
      code: Xe(A())
    })
  ).optional(),
  activity: N({ name: Xe(A()) }).optional(),
  location: k(
    N({
      name: Xe(A()),
      building: Xe(A()).optional()
    })
  ).optional()
});
function Uy(e) {
  return (t) => bt([
    N({ value: t }),
    N({ availableAt: e }),
    N({ disabled: ce(!0) })
  ]);
}
const ls = Uy($t), $y = N({
  id: R(),
  lastModified: $t.optional(),
  begin: $t,
  end: $t,
  title: A(),
  subtitle: A(),
  breadcrumb: A()
}), SN = $y.extend({
  kind: ce("general"),
  module: k(
    N({
      name: Xe(A()),
      code: Xe(A())
    })
  ),
  location: k(
    N({
      name: Xe(A()),
      building: Xe(A()),
      campus: Xe(A()),
      type: Xe(A()),
      map: Xe(A()),
      image: Xe(A()),
      equipment: Xe(k(A())),
      extraFields: k(Xe(A()))
    })
  ),
  extraFields: k(Xe(A())),
  digitalResource: N({
    onlineUrl: k(Xe(A())),
    recording: k(Xe(A())),
    links: k(Xe(A()))
  }),
  staff: k(
    N({
      name: Xe(A())
    })
  ),
  activity: N({
    name: Xe(A())
  }),
  message: N({
    comment: Xe(A())
  })
}), IN = $y.extend({
  kind: ce("exam"),
  location: ls(A()),
  seatNo: ls(A().nullable()),
  fields: k(
    ls(A()).and(
      N({
        label: A(),
        type: A().optional()
      })
    )
  ),
  information: k(
    ls(
      N({
        title: A().optional(),
        type: pe(["error", "warning", "info"]).optional(),
        value: A()
      })
    )
  )
});
cr("kind", [
  SN,
  IN
]);
var _N = typeof global == "object" && global && global.Object === Object && global, RN = typeof self == "object" && self && self.Object === Object && self, Bn = _N || RN || Function("return this")(), yi = Bn.Symbol, Fy = Object.prototype, ON = Fy.hasOwnProperty, wN = Fy.toString, lo = yi ? yi.toStringTag : void 0;
function NN(e) {
  var t = ON.call(e, lo), r = e[lo];
  try {
    e[lo] = void 0;
    var n = !0;
  } catch {
  }
  var i = wN.call(e);
  return n && (t ? e[lo] = r : delete e[lo]), i;
}
var CN = Object.prototype, PN = CN.toString;
function DN(e) {
  return PN.call(e);
}
var MN = "[object Null]", LN = "[object Undefined]", uh = yi ? yi.toStringTag : void 0;
function na(e) {
  return e == null ? e === void 0 ? LN : MN : uh && uh in Object(e) ? NN(e) : DN(e);
}
function xN(e) {
  return e != null && typeof e == "object";
}
var kN = Array.isArray, lh = yi ? yi.prototype : void 0;
lh && lh.toString;
function zy(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var jN = "[object AsyncFunction]", UN = "[object Function]", $N = "[object GeneratorFunction]", FN = "[object Proxy]";
function Gy(e) {
  if (!zy(e))
    return !1;
  var t = na(e);
  return t == UN || t == $N || t == jN || t == FN;
}
var ka = Bn["__core-js_shared__"], ch = (function() {
  var e = /[^.]+$/.exec(ka && ka.keys && ka.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function zN(e) {
  return !!ch && ch in e;
}
var GN = Function.prototype, BN = GN.toString;
function Vn(e) {
  if (e != null) {
    try {
      return BN.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var VN = /[\\^$.*+?()[\]{}|]/g, WN = /^\[object .+?Constructor\]$/, qN = Function.prototype, HN = Object.prototype, YN = qN.toString, ZN = HN.hasOwnProperty, JN = RegExp(
  "^" + YN.call(ZN).replace(VN, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function KN(e) {
  if (!zy(e) || zN(e))
    return !1;
  var t = Gy(e) ? JN : WN;
  return t.test(Vn(e));
}
function XN(e, t) {
  return e == null ? void 0 : e[t];
}
function wi(e, t) {
  var r = XN(e, t);
  return KN(r) ? r : void 0;
}
var Vu = wi(Bn, "WeakMap");
function QN(e, t) {
  return e === t || e !== e && t !== t;
}
var eC = 9007199254740991;
function tC(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= eC;
}
function rC(e) {
  return e != null && tC(e.length) && !Gy(e);
}
var nC = Object.prototype;
function iC(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || nC;
  return e === r;
}
function oC(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var sC = oC(Object.keys, Object), aC = Object.prototype, uC = aC.hasOwnProperty;
function lC(e) {
  if (!iC(e))
    return sC(e);
  var t = [];
  for (var r in Object(e))
    uC.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var jo = wi(Object, "create");
function cC() {
  this.__data__ = jo ? jo(null) : {}, this.size = 0;
}
function fC(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var dC = "__lodash_hash_undefined__", pC = Object.prototype, hC = pC.hasOwnProperty;
function mC(e) {
  var t = this.__data__;
  if (jo) {
    var r = t[e];
    return r === dC ? void 0 : r;
  }
  return hC.call(t, e) ? t[e] : void 0;
}
var EC = Object.prototype, gC = EC.hasOwnProperty;
function yC(e) {
  var t = this.__data__;
  return jo ? t[e] !== void 0 : gC.call(t, e);
}
var TC = "__lodash_hash_undefined__";
function bC(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = jo && t === void 0 ? TC : t, this;
}
function $n(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
$n.prototype.clear = cC;
$n.prototype.delete = fC;
$n.prototype.get = mC;
$n.prototype.has = yC;
$n.prototype.set = bC;
function AC() {
  this.__data__ = [], this.size = 0;
}
function ia(e, t) {
  for (var r = e.length; r--; )
    if (QN(e[r][0], t))
      return r;
  return -1;
}
var vC = Array.prototype, SC = vC.splice;
function IC(e) {
  var t = this.__data__, r = ia(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : SC.call(t, r, 1), --this.size, !0;
}
function _C(e) {
  var t = this.__data__, r = ia(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function RC(e) {
  return ia(this.__data__, e) > -1;
}
function OC(e, t) {
  var r = this.__data__, n = ia(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Ni(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ni.prototype.clear = AC;
Ni.prototype.delete = IC;
Ni.prototype.get = _C;
Ni.prototype.has = RC;
Ni.prototype.set = OC;
var Ds = wi(Bn, "Map");
function wC() {
  this.size = 0, this.__data__ = {
    hash: new $n(),
    map: new (Ds || Ni)(),
    string: new $n()
  };
}
function NC(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function oa(e, t) {
  var r = e.__data__;
  return NC(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function CC(e) {
  var t = oa(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function PC(e) {
  return oa(this, e).get(e);
}
function DC(e) {
  return oa(this, e).has(e);
}
function MC(e, t) {
  var r = oa(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Wn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Wn.prototype.clear = wC;
Wn.prototype.delete = CC;
Wn.prototype.get = PC;
Wn.prototype.has = DC;
Wn.prototype.set = MC;
var LC = "Expected a function";
function nc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(LC);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, n);
    return r.cache = o.set(i, s) || o, s;
  };
  return r.cache = new (nc.Cache || Wn)(), r;
}
nc.Cache = Wn;
var xC = 500;
function kC(e) {
  var t = nc(e, function(n) {
    return r.size === xC && r.clear(), n;
  }), r = t.cache;
  return t;
}
var jC = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, UC = /\\(\\)?/g;
kC(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(jC, function(r, n, i, o) {
    t.push(i ? o.replace(UC, "$1") : n || r);
  }), t;
});
var $C = "\\ud800-\\udfff", FC = "\\u0300-\\u036f", zC = "\\ufe20-\\ufe2f", GC = "\\u20d0-\\u20ff", BC = FC + zC + GC, VC = "\\ufe0e\\ufe0f", WC = "\\u200d", qC = RegExp("[" + WC + $C + BC + VC + "]");
function HC(e) {
  return qC.test(e);
}
var Wu = wi(Bn, "DataView"), qu = wi(Bn, "Promise"), Hu = wi(Bn, "Set"), fh = "[object Map]", YC = "[object Object]", dh = "[object Promise]", ph = "[object Set]", hh = "[object WeakMap]", mh = "[object DataView]", ZC = Vn(Wu), JC = Vn(Ds), KC = Vn(qu), XC = Vn(Hu), QC = Vn(Vu), Pn = na;
(Wu && Pn(new Wu(new ArrayBuffer(1))) != mh || Ds && Pn(new Ds()) != fh || qu && Pn(qu.resolve()) != dh || Hu && Pn(new Hu()) != ph || Vu && Pn(new Vu()) != hh) && (Pn = function(e) {
  var t = na(e), r = t == YC ? e.constructor : void 0, n = r ? Vn(r) : "";
  if (n)
    switch (n) {
      case ZC:
        return mh;
      case JC:
        return fh;
      case KC:
        return dh;
      case XC:
        return ph;
      case QC:
        return hh;
    }
  return t;
});
function e1(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var t1 = "[object String]";
function r1(e) {
  return typeof e == "string" || !kN(e) && xN(e) && na(e) == t1;
}
function n1(e) {
  return e === void 0;
}
var i1 = e1("length"), By = "\\ud800-\\udfff", o1 = "\\u0300-\\u036f", s1 = "\\ufe20-\\ufe2f", a1 = "\\u20d0-\\u20ff", u1 = o1 + s1 + a1, l1 = "\\ufe0e\\ufe0f", c1 = "[" + By + "]", Yu = "[" + u1 + "]", Zu = "\\ud83c[\\udffb-\\udfff]", f1 = "(?:" + Yu + "|" + Zu + ")", Vy = "[^" + By + "]", Wy = "(?:\\ud83c[\\udde6-\\uddff]){2}", qy = "[\\ud800-\\udbff][\\udc00-\\udfff]", d1 = "\\u200d", Hy = f1 + "?", Yy = "[" + l1 + "]?", p1 = "(?:" + d1 + "(?:" + [Vy, Wy, qy].join("|") + ")" + Yy + Hy + ")*", h1 = Yy + Hy + p1, m1 = "(?:" + [Vy + Yu + "?", Yu, Wy, qy, c1].join("|") + ")", Eh = RegExp(Zu + "(?=" + Zu + ")|" + m1 + h1, "g");
function E1(e) {
  for (var t = Eh.lastIndex = 0; Eh.test(e); )
    ++t;
  return t;
}
function g1(e) {
  return HC(e) ? E1(e) : i1(e);
}
var y1 = "[object Map]", T1 = "[object Set]";
function b1(e) {
  if (e == null)
    return 0;
  if (rC(e))
    return r1(e) ? g1(e) : e.length;
  var t = Pn(e);
  return t == y1 || t == T1 ? e.size : lC(e).length;
}
var Ju = { exports: {} }, A1 = Ju.exports, gh;
function v1() {
  return gh || (gh = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(A1, (function() {
      var r = 1e3, n = 6e4, i = 36e5, o = "millisecond", s = "second", a = "minute", l = "hour", f = "day", u = "week", h = "month", E = "quarter", d = "year", g = "date", y = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(B) {
        var L = ["th", "st", "nd", "rd"], G = B % 100;
        return "[" + B + (L[(G - 20) % 10] || L[G] || L[0]) + "]";
      } }, w = function(B, L, G) {
        var Z = String(B);
        return !Z || Z.length >= L ? B : "" + Array(L + 1 - Z.length).join(G) + B;
      }, P = { s: w, z: function(B) {
        var L = -B.utcOffset(), G = Math.abs(L), Z = Math.floor(G / 60), V = G % 60;
        return (L <= 0 ? "+" : "-") + w(Z, 2, "0") + ":" + w(V, 2, "0");
      }, m: function B(L, G) {
        if (L.date() < G.date()) return -B(G, L);
        var Z = 12 * (G.year() - L.year()) + (G.month() - L.month()), V = L.clone().add(Z, h), te = G - V < 0, ee = L.clone().add(Z + (te ? -1 : 1), h);
        return +(-(Z + (G - V) / (te ? V - ee : ee - V)) || 0);
      }, a: function(B) {
        return B < 0 ? Math.ceil(B) || 0 : Math.floor(B);
      }, p: function(B) {
        return { M: h, y: d, w: u, d: f, D: g, h: l, m: a, s, ms: o, Q: E }[B] || String(B || "").toLowerCase().replace(/s$/, "");
      }, u: function(B) {
        return B === void 0;
      } }, _ = "en", v = {};
      v[_] = S;
      var M = "$isDayjsObject", x = function(B) {
        return B instanceof X || !(!B || !B[M]);
      }, z = function B(L, G, Z) {
        var V;
        if (!L) return _;
        if (typeof L == "string") {
          var te = L.toLowerCase();
          v[te] && (V = te), G && (v[te] = G, V = te);
          var ee = L.split("-");
          if (!V && ee.length > 1) return B(ee[0]);
        } else {
          var Q = L.name;
          v[Q] = L, V = Q;
        }
        return !Z && V && (_ = V), V || !Z && _;
      }, F = function(B, L) {
        if (x(B)) return B.clone();
        var G = typeof L == "object" ? L : {};
        return G.date = B, G.args = arguments, new X(G);
      }, W = P;
      W.l = z, W.i = x, W.w = function(B, L) {
        return F(B, { locale: L.$L, utc: L.$u, x: L.$x, $offset: L.$offset });
      };
      var X = (function() {
        function B(G) {
          this.$L = z(G.locale, null, !0), this.parse(G), this.$x = this.$x || G.x || {}, this[M] = !0;
        }
        var L = B.prototype;
        return L.parse = function(G) {
          this.$d = (function(Z) {
            var V = Z.date, te = Z.utc;
            if (V === null) return /* @__PURE__ */ new Date(NaN);
            if (W.u(V)) return /* @__PURE__ */ new Date();
            if (V instanceof Date) return new Date(V);
            if (typeof V == "string" && !/Z$/i.test(V)) {
              var ee = V.match(b);
              if (ee) {
                var Q = ee[2] - 1 || 0, re = (ee[7] || "0").substring(0, 3);
                return te ? new Date(Date.UTC(ee[1], Q, ee[3] || 1, ee[4] || 0, ee[5] || 0, ee[6] || 0, re)) : new Date(ee[1], Q, ee[3] || 1, ee[4] || 0, ee[5] || 0, ee[6] || 0, re);
              }
            }
            return new Date(V);
          })(G), this.init();
        }, L.init = function() {
          var G = this.$d;
          this.$y = G.getFullYear(), this.$M = G.getMonth(), this.$D = G.getDate(), this.$W = G.getDay(), this.$H = G.getHours(), this.$m = G.getMinutes(), this.$s = G.getSeconds(), this.$ms = G.getMilliseconds();
        }, L.$utils = function() {
          return W;
        }, L.isValid = function() {
          return this.$d.toString() !== y;
        }, L.isSame = function(G, Z) {
          var V = F(G);
          return this.startOf(Z) <= V && V <= this.endOf(Z);
        }, L.isAfter = function(G, Z) {
          return F(G) < this.startOf(Z);
        }, L.isBefore = function(G, Z) {
          return this.endOf(Z) < F(G);
        }, L.$g = function(G, Z, V) {
          return W.u(G) ? this[Z] : this.set(V, G);
        }, L.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, L.valueOf = function() {
          return this.$d.getTime();
        }, L.startOf = function(G, Z) {
          var V = this, te = !!W.u(Z) || Z, ee = W.p(G), Q = function(Ve, Ie) {
            var $e = W.w(V.$u ? Date.UTC(V.$y, Ie, Ve) : new Date(V.$y, Ie, Ve), V);
            return te ? $e : $e.endOf(f);
          }, re = function(Ve, Ie) {
            return W.w(V.toDate()[Ve].apply(V.toDate("s"), (te ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Ie)), V);
          }, ne = this.$W, Ee = this.$M, be = this.$D, Be = "set" + (this.$u ? "UTC" : "");
          switch (ee) {
            case d:
              return te ? Q(1, 0) : Q(31, 11);
            case h:
              return te ? Q(1, Ee) : Q(0, Ee + 1);
            case u:
              var Ue = this.$locale().weekStart || 0, Le = (ne < Ue ? ne + 7 : ne) - Ue;
              return Q(te ? be - Le : be + (6 - Le), Ee);
            case f:
            case g:
              return re(Be + "Hours", 0);
            case l:
              return re(Be + "Minutes", 1);
            case a:
              return re(Be + "Seconds", 2);
            case s:
              return re(Be + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, L.endOf = function(G) {
          return this.startOf(G, !1);
        }, L.$set = function(G, Z) {
          var V, te = W.p(G), ee = "set" + (this.$u ? "UTC" : ""), Q = (V = {}, V[f] = ee + "Date", V[g] = ee + "Date", V[h] = ee + "Month", V[d] = ee + "FullYear", V[l] = ee + "Hours", V[a] = ee + "Minutes", V[s] = ee + "Seconds", V[o] = ee + "Milliseconds", V)[te], re = te === f ? this.$D + (Z - this.$W) : Z;
          if (te === h || te === d) {
            var ne = this.clone().set(g, 1);
            ne.$d[Q](re), ne.init(), this.$d = ne.set(g, Math.min(this.$D, ne.daysInMonth())).$d;
          } else Q && this.$d[Q](re);
          return this.init(), this;
        }, L.set = function(G, Z) {
          return this.clone().$set(G, Z);
        }, L.get = function(G) {
          return this[W.p(G)]();
        }, L.add = function(G, Z) {
          var V, te = this;
          G = Number(G);
          var ee = W.p(Z), Q = function(Ee) {
            var be = F(te);
            return W.w(be.date(be.date() + Math.round(Ee * G)), te);
          };
          if (ee === h) return this.set(h, this.$M + G);
          if (ee === d) return this.set(d, this.$y + G);
          if (ee === f) return Q(1);
          if (ee === u) return Q(7);
          var re = (V = {}, V[a] = n, V[l] = i, V[s] = r, V)[ee] || 1, ne = this.$d.getTime() + G * re;
          return W.w(ne, this);
        }, L.subtract = function(G, Z) {
          return this.add(-1 * G, Z);
        }, L.format = function(G) {
          var Z = this, V = this.$locale();
          if (!this.isValid()) return V.invalidDate || y;
          var te = G || "YYYY-MM-DDTHH:mm:ssZ", ee = W.z(this), Q = this.$H, re = this.$m, ne = this.$M, Ee = V.weekdays, be = V.months, Be = V.meridiem, Ue = function(Ie, $e, Ne, Re) {
            return Ie && (Ie[$e] || Ie(Z, te)) || Ne[$e].slice(0, Re);
          }, Le = function(Ie) {
            return W.s(Q % 12 || 12, Ie, "0");
          }, Ve = Be || function(Ie, $e, Ne) {
            var Re = Ie < 12 ? "AM" : "PM";
            return Ne ? Re.toLowerCase() : Re;
          };
          return te.replace(I, (function(Ie, $e) {
            return $e || (function(Ne) {
              switch (Ne) {
                case "YY":
                  return String(Z.$y).slice(-2);
                case "YYYY":
                  return W.s(Z.$y, 4, "0");
                case "M":
                  return ne + 1;
                case "MM":
                  return W.s(ne + 1, 2, "0");
                case "MMM":
                  return Ue(V.monthsShort, ne, be, 3);
                case "MMMM":
                  return Ue(be, ne);
                case "D":
                  return Z.$D;
                case "DD":
                  return W.s(Z.$D, 2, "0");
                case "d":
                  return String(Z.$W);
                case "dd":
                  return Ue(V.weekdaysMin, Z.$W, Ee, 2);
                case "ddd":
                  return Ue(V.weekdaysShort, Z.$W, Ee, 3);
                case "dddd":
                  return Ee[Z.$W];
                case "H":
                  return String(Q);
                case "HH":
                  return W.s(Q, 2, "0");
                case "h":
                  return Le(1);
                case "hh":
                  return Le(2);
                case "a":
                  return Ve(Q, re, !0);
                case "A":
                  return Ve(Q, re, !1);
                case "m":
                  return String(re);
                case "mm":
                  return W.s(re, 2, "0");
                case "s":
                  return String(Z.$s);
                case "ss":
                  return W.s(Z.$s, 2, "0");
                case "SSS":
                  return W.s(Z.$ms, 3, "0");
                case "Z":
                  return ee;
              }
              return null;
            })(Ie) || ee.replace(":", "");
          }));
        }, L.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, L.diff = function(G, Z, V) {
          var te, ee = this, Q = W.p(Z), re = F(G), ne = (re.utcOffset() - this.utcOffset()) * n, Ee = this - re, be = function() {
            return W.m(ee, re);
          };
          switch (Q) {
            case d:
              te = be() / 12;
              break;
            case h:
              te = be();
              break;
            case E:
              te = be() / 3;
              break;
            case u:
              te = (Ee - ne) / 6048e5;
              break;
            case f:
              te = (Ee - ne) / 864e5;
              break;
            case l:
              te = Ee / i;
              break;
            case a:
              te = Ee / n;
              break;
            case s:
              te = Ee / r;
              break;
            default:
              te = Ee;
          }
          return V ? te : W.a(te);
        }, L.daysInMonth = function() {
          return this.endOf(h).$D;
        }, L.$locale = function() {
          return v[this.$L];
        }, L.locale = function(G, Z) {
          if (!G) return this.$L;
          var V = this.clone(), te = z(G, Z, !0);
          return te && (V.$L = te), V;
        }, L.clone = function() {
          return W.w(this.$d, this);
        }, L.toDate = function() {
          return new Date(this.valueOf());
        }, L.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, L.toISOString = function() {
          return this.$d.toISOString();
        }, L.toString = function() {
          return this.$d.toUTCString();
        }, B;
      })(), de = X.prototype;
      return F.prototype = de, [["$ms", o], ["$s", s], ["$m", a], ["$H", l], ["$W", f], ["$M", h], ["$y", d], ["$D", g]].forEach((function(B) {
        de[B[1]] = function(L) {
          return this.$g(L, B[0], B[1]);
        };
      })), F.extend = function(B, L) {
        return B.$i || (B(L, X, F), B.$i = !0), F;
      }, F.locale = z, F.isDayjs = x, F.unix = function(B) {
        return F(1e3 * B);
      }, F.en = v[_], F.Ls = v, F.p = {}, F;
    }));
  })(Ju)), Ju.exports;
}
var S1 = v1();
const Uo = /* @__PURE__ */ ql(S1);
var Ku = { exports: {} }, I1 = Ku.exports, yh;
function _1() {
  return yh || (yh = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(I1, (function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
      return function(i, o, s) {
        var a, l = function(E, d, g) {
          g === void 0 && (g = {});
          var y = new Date(E), b = (function(I, S) {
            S === void 0 && (S = {});
            var w = S.timeZoneName || "short", P = I + "|" + w, _ = n[P];
            return _ || (_ = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: I, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: w }), n[P] = _), _;
          })(d, g);
          return b.formatToParts(y);
        }, f = function(E, d) {
          for (var g = l(E, d), y = [], b = 0; b < g.length; b += 1) {
            var I = g[b], S = I.type, w = I.value, P = r[S];
            P >= 0 && (y[P] = parseInt(w, 10));
          }
          var _ = y[3], v = _ === 24 ? 0 : _, M = y[0] + "-" + y[1] + "-" + y[2] + " " + v + ":" + y[4] + ":" + y[5] + ":000", x = +E;
          return (s.utc(M).valueOf() - (x -= x % 1e3)) / 6e4;
        }, u = o.prototype;
        u.tz = function(E, d) {
          if (E === void 0 && (E = a), !this.isValid()) return this;
          var g, y = this.utcOffset(), b = this.toDate(), I = b.toLocaleString("en-US", { timeZone: E }), S = f(+b, E);
          if (!Number(S)) g = this.utcOffset(0, d);
          else if (g = s(I, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(S, !0), d) {
            var w = g.utcOffset();
            g = g.add(y - w, "minute");
          }
          return g.$x.$timezone = E, g;
        }, u.offsetName = function(E) {
          var d = this.$x.$timezone || s.tz.guess(), g = l(this.valueOf(), d, { timeZoneName: E }).find((function(y) {
            return y.type.toLowerCase() === "timezonename";
          }));
          return g && g.value;
        };
        var h = u.startOf;
        u.startOf = function(E, d) {
          if (!this.$x || !this.$x.$timezone) return h.call(this, E, d);
          var g = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return h.call(g, E, d).tz(this.$x.$timezone, !0);
        }, s.tz = function(E, d, g) {
          var y = g && d, b = g || d || a, I = f(+s(), b);
          if (typeof E != "string") return s(E).tz(b);
          var S = s.utc(E, y).valueOf();
          if (Number.isNaN(S)) {
            var w = s(NaN);
            return w.$x.$timezone = b, w;
          }
          var P = (function(x, z, F) {
            var W = x - 60 * z * 1e3, X = f(W, F);
            if (z === X) return [W, z];
            var de = f(W -= 60 * (X - z) * 1e3, F);
            return X === de ? [W, X] : [x - 60 * Math.min(X, de) * 1e3, Math.max(X, de)];
          })(S, I, b), _ = P[0], v = P[1], M = s(_).utcOffset(v);
          return M.$x.$timezone = b, M;
        }, s.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, s.tz.setDefault = function(E) {
          a = E;
        };
      };
    }));
  })(Ku)), Ku.exports;
}
var R1 = _1();
const O1 = /* @__PURE__ */ ql(R1);
var Xu = { exports: {} }, w1 = Xu.exports, Th;
function N1() {
  return Th || (Th = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(w1, (function() {
      var r = "minute", n = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
      return function(o, s, a) {
        var l = s.prototype;
        a.utc = function(y) {
          var b = { date: y, utc: !0, args: arguments };
          return new s(b);
        }, l.utc = function(y) {
          var b = a(this.toDate(), { locale: this.$L, utc: !0 });
          return y ? b.add(this.utcOffset(), r) : b;
        }, l.local = function() {
          return a(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var f = l.parse;
        l.parse = function(y) {
          y.utc && (this.$u = !0), this.$utils().u(y.$offset) || (this.$offset = y.$offset), f.call(this, y);
        };
        var u = l.init;
        l.init = function() {
          if (this.$u) {
            var y = this.$d;
            this.$y = y.getUTCFullYear(), this.$M = y.getUTCMonth(), this.$D = y.getUTCDate(), this.$W = y.getUTCDay(), this.$H = y.getUTCHours(), this.$m = y.getUTCMinutes(), this.$s = y.getUTCSeconds(), this.$ms = y.getUTCMilliseconds();
          } else u.call(this);
        };
        var h = l.utcOffset;
        l.utcOffset = function(y, b) {
          var I = this.$utils().u;
          if (I(y)) return this.$u ? 0 : I(this.$offset) ? h.call(this) : this.$offset;
          if (typeof y == "string" && (y = (function(_) {
            _ === void 0 && (_ = "");
            var v = _.match(n);
            if (!v) return null;
            var M = ("" + v[0]).match(i) || ["-", 0, 0], x = M[0], z = 60 * +M[1] + +M[2];
            return z === 0 ? 0 : x === "+" ? z : -z;
          })(y), y === null)) return this;
          var S = Math.abs(y) <= 16 ? 60 * y : y;
          if (S === 0) return this.utc(b);
          var w = this.clone();
          if (b) return w.$offset = S, w.$u = !1, w;
          var P = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (w = this.local().add(S + P, r)).$offset = S, w.$x.$localOffset = P, w;
        };
        var E = l.format;
        l.format = function(y) {
          var b = y || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return E.call(this, b);
        }, l.valueOf = function() {
          var y = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * y;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var d = l.toDate;
        l.toDate = function(y) {
          return y === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
        };
        var g = l.diff;
        l.diff = function(y, b, I) {
          if (y && this.$u === y.$u) return g.call(this, y, b, I);
          var S = this.local(), w = a(y).local();
          return g.call(S, w, b, I);
        };
      };
    }));
  })(Xu)), Xu.exports;
}
var C1 = N1();
const P1 = /* @__PURE__ */ ql(C1);
function Zy(e, t, r) {
  try {
    return t !== void 0 ? JSON.stringify(e, r, t) : JSON.stringify(e);
  } catch {
    return "";
  }
}
function ye(e) {
  return typeof e == "object" && e !== null && !xe(e);
}
function Kz(e) {
  return Je(e) ? e > 0 : !1;
}
function Je(e) {
  return typeof e == "number" && !isNaN(e);
}
function sa(e) {
  return typeof e == "boolean";
}
function pt(e) {
  return typeof e == "string";
}
function xe(e) {
  return Array.isArray(e);
}
function D(e) {
  return e != null;
}
function dr(e) {
  return typeof e == "number" && isNaN(e) || e === void 0 || e === null;
}
function Xz(e) {
  return Object.entries(e);
}
const Ms = [
  "data",
  "error",
  "cause",
  "response",
  "config",
  "signal",
  "reason"
];
function Wo({
  fallback: e,
  options: t
}) {
  return function r(n, i, o, s = ".") {
    if (D(t == null ? void 0 : t.limit) && b1(o) >= t.limit)
      return o;
    if (xe(n)) {
      let f = { ...o };
      for (let u = 0; u < n.length; u++) {
        const h = `${s}[${u}]`;
        f = r(n[u], i, f, h);
      }
      return f;
    }
    if (pt(n))
      try {
        const f = JSON.parse(n);
        return r(f, i, o, s);
      } catch {
      }
    const a = i(n);
    let l = { ...o };
    if (D(a)) {
      const f = l[a];
      D(f) ? l[a] = [...f, s] : l[a] = [s];
    }
    if (!ye(n))
      return Object.keys(l).length > 0 ? l : e();
    for (const f of Ms)
      if (D(n[f])) {
        const u = s === "." ? `.${f}` : `${s}.${f}`;
        l = r(n[f], i, l, u);
      }
    return Object.keys(l).length > 0 ? l : e();
  };
}
function D1({
  fallback: e,
  options: t
}) {
  return function r(n, i, o, s = ".") {
    if (D(t == null ? void 0 : t.limit) && o.length >= t.limit)
      return o;
    if (xe(n)) {
      let f = [...o];
      for (let u = 0; u < n.length; u++) {
        const h = `${s}[${u}]`;
        f = r(n[u], i, f, h);
      }
      return f;
    }
    if (pt(n))
      try {
        const f = JSON.parse(n);
        return r(f, i, o, s);
      } catch {
      }
    const a = i(n);
    let l = [...o];
    for (const f of a)
      l.push({ value: f, path: s });
    if (!ye(n))
      return l.length > 0 ? l : e();
    for (const f of Ms)
      if (D(n[f])) {
        const u = s === "." ? `.${f}` : `${s}.${f}`;
        l = r(n[f], i, l, u);
      }
    return l.length > 0 ? l : e();
  };
}
function bh(e, t) {
  return Wo({
    fallback: () => ({ [Zy(e)]: ["."] }),
    options: t
  })(e, (r) => {
    if (dr(r))
      return "";
    if (pt(r))
      return r;
    if (M1(r))
      return r.message;
  }, {});
}
function Nt(e) {
  if (ye(e) && "response" in e) {
    const n = bh(e), i = Object.entries(n).find(
      ([o, s]) => s == null ? void 0 : s.some((a) => a === ".response.data")
    );
    if (i)
      return i[0];
  }
  const t = bh(e, { limit: 1 }), r = qo(t);
  return r.length > 0 ? r[0] : "";
}
function M1(e) {
  return ye(e) && Object.prototype.hasOwnProperty.call(e, "message") && typeof e.message == "string";
}
function qo(e) {
  return Object.entries(e).map(([t, r]) => ({
    value: t,
    path: r.map(L1).sort(Ah)[0]
  })).sort((t, r) => D(t.path) ? D(r.path) ? Ah(t.path, r.path) : -1 : D(r.path) ? 1 : 0).map(({ value: t }) => t);
}
function L1(e) {
  return [...e.matchAll(/\.([^.[]+)|\[(\d+)\]/g)].map(
    ([, t, r]) => D(r) ? Number(r) : t
  );
}
function Ah(e, t) {
  if (e.length !== t.length) return e.length - t.length;
  for (let r = 0; r < e.length; r++) {
    const n = x1(e[r], t[r]);
    if (n !== 0) return n;
  }
  return 0;
}
function x1(e, t) {
  return typeof e == "number" && typeof t == "number" ? e - t : typeof e == "number" ? -1 : typeof t == "number" ? 1 : vh(e) - vh(t) || e.localeCompare(t);
}
function vh(e) {
  const t = Ms.indexOf(e);
  return t === -1 ? Ms.length : t;
}
const Sh = new RegExp(
  "^(?:0[1-9]|[1-2]\\d|3[0-1])[/-](?:0[1-9]|1[0-2])[/-]\\d{4}(?: (?:[0-1]\\d|2[0-4]):[0-5]\\d:[0-5]\\d)?$"
);
function Qz(e) {
  return ye(e) && "data" in e;
}
Uo.extend(P1);
Uo.extend(O1);
const Qu = Vl(
  (e) => e instanceof Date ? e.toISOString() : e,
  Wl()
), Ti = Vl(
  (e) => e instanceof Date ? e.toISOString() : e,
  Wl().optional()
);
function k1(e) {
  return Lt(A(), e).refine((t) => Object.keys(t).length <= ih, {
    message: `Record cannot exceed ${ih} entries`
  });
}
function j1(e) {
  return e.superRefine((t, r) => {
    if (ye(t))
      for (const [n, i] of Object.entries(t))
        n1(i) && i !== null && r.issues.push({
          input: [n, i],
          code: "custom",
          path: [n],
          message: `${n} can be omitted, but not undefined.`
        });
  });
}
function tr(e, t) {
  const r = t.reduce((n, i) => (i in e.shape && (n[i] = !0), n), {});
  return e.omit(r);
}
const Ih = /* @__PURE__ */ new Map();
function ic(e, t) {
  let r = Ih.get(t);
  return r || (r = new Intl.DateTimeFormat("sv-SE", {
    timeZone: t,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }), Ih.set(t, r)), r.format(new Date(e * 1e3));
}
function U1(e, t, r) {
  try {
    const [n, i = "00:00:00"] = e.split(" "), [o, s, a] = n.split(/[/-]/), l = `${a}-${s}-${o} ${i}`, f = new RegExp(/\b\d\b/, "g"), u = l.replace(
      f,
      "0$&"
    );
    if (Uo.utc(u).format("YYYY-MM-DD HH:mm:ss") !== u)
      return r ? (r.issues.push({
        input: e,
        code: "custom",
        message: `Invalid date value: ${e}`
      }), { local: "", timezone: "", unix: 0 }) : { local: "Invalid Date", timezone: t, unix: NaN };
    const h = Uo.tz(u, t).unix();
    return { local: ic(h, t), timezone: t, unix: h };
  } catch (n) {
    if (r)
      r.issues.push({
        input: e,
        code: "custom",
        message: Nt(n)
      });
    else
      throw n;
    return {
      local: "",
      timezone: "",
      unix: 0
    };
  }
}
function $1(e, t, r) {
  try {
    const n = Uo(e);
    if (!n.isValid())
      return { local: "Invalid Date", timezone: t, unix: NaN };
    const i = n.unix();
    return { local: ic(i, t), timezone: t, unix: i };
  } catch (n) {
    if (r)
      r.issues.push({
        input: e,
        code: "custom",
        message: Nt(n)
      });
    else
      throw n;
    return {
      local: "",
      timezone: "",
      unix: 0
    };
  }
}
function oc(e, t, r) {
  try {
    return { local: ic(e, t), timezone: t, unix: e };
  } catch (n) {
    if (r)
      r.issues.push({
        input: e,
        code: "custom",
        message: Nt(n)
      });
    else
      throw n;
    return {
      local: "",
      unix: 0,
      timezone: ""
    };
  }
}
const Jy = (e) => e.transform((t) => Number(t)).pipe(R()), Ky = (e) => e.transform((t) => isFinite(Number(t)) ? Math.round(Number(t)) : 0).pipe(R()), Xy = (e) => e.transform((t) => {
  const r = Number(t);
  return isFinite(r) && r >= 0 ? Math.round(r) : 0;
}).pipe(R()), Qy = Jy(at()), F1 = Jy(A()), sc = Ky(at());
Ky(A());
const An = Xy(
  at()
);
Xy(A());
at().transform((e) => e == null ? "" : ye(e) || Je(e) ? e.toString() : pt(e) ? e : "").pipe(A());
const _h = at().transform((e) => typeof e == "object" ? JSON.stringify(e) : D(e) ? `${e}` : "").pipe(A());
at().transform((e) => !!e).pipe(oe());
at().transform((e) => xe(e) ? !!e[0] : !!e).pipe(oe());
at().transform((e) => xe(e) ? e.length === 0 ? 0 : Number(e[0]) : Number(e)).pipe(R());
at().transform((e) => xe(e) ? e.join(", ") : e ?? "").pipe(A());
const Rh = bt([N({ id: A() }), A()]).transform((e) => ye(e) ? e.id : e).pipe(A()), z1 = at().transform((e) => e === void 0 ? [] : xe(e) ? e.map((t) => _h.parse(t)) : [_h.parse(e)]).pipe(k(A())), G1 = Wl({ offset: !0 }), Oh = (e) => A().superRefine((t, r) => {
  !Sh.test(t) && !G1.validate(t) && r.issues.push({
    input: t,
    message: `Wrong date format: ${t}`,
    code: "invalid_format",
    format: "date"
  });
}).transform((t, r) => Sh.test(t) ? U1(t, e, r) : $1(t, e, r)).pipe($t).or(
  R().int().nonnegative().transform((t, r) => oc(t, e, r)).pipe($t)
).or($t), wh = N({
  label: A(),
  title: A(),
  id: R()
}), B1 = bt([R(), wh]).transform((e) => Je(e) ? {
  label: "",
  title: "",
  id: e
} : e).pipe(wh), aa = dt(
  A(),
  k(R()).or(Yr())
), V1 = ["open", "closed", "not_set"], Nr = pe(V1), ac = N({
  invalidCourseIds: oe(),
  invalidActivityType: oe()
}).partial(), eT = N({
  multipleAllocations: oe()
}).partial(), Ls = ac.extend({
  noAllocation: oe()
}).partial(), tT = Ls.extend({
  overEnrollment: oe()
}).partial(), rT = tT.keyof(), W1 = pe([
  ...rT.exclude(ac.keyof().options).options,
  "groupDataIssues",
  "studentDataIssues"
]), nT = N({
  id: R(),
  incompleteStudents: k(R()).optional(),
  enrolledStudents: k(R()),
  activities: k(R()),
  object: Ft,
  capacity: R().int().nonnegative().optional(),
  inWaitlist: R().int().nonnegative().optional(),
  issues: tT,
  openStatuses: k(Nr)
}), iT = N({
  key: A(),
  id: R(),
  incompleteStudents: k(R()).optional(),
  groups: k(R()),
  activityType: A(),
  courseId: R(),
  students: k(R()),
  capacity: R().int().nonnegative().optional(),
  inWaitlist: R().int().nonnegative().optional()
}), q1 = N({
  id: R(),
  object: Ft,
  issues: eT
}), oT = N({
  id: R(),
  activityId: R(),
  courseId: R(),
  object: Ft,
  allocated: R().int().nonnegative(),
  capacity: R().int().nonnegative(),
  inWaitlist: k(R().int().nonnegative()).default([]),
  leaving: k(R().int().nonnegative()).default([]),
  issues: Ls,
  open: Nr
}), H1 = N({
  conflict: k(R()),
  size: k(R()),
  buffer: k(R()),
  doubleBooked: k(R()),
  dedicated: k(R()),
  hidden: k(R()),
  registrationPeriod: k(R())
}), Y1 = N({
  systemError: dt(
    A(),
    N({
      message: A(),
      code: R(),
      name: ra,
      presentableText: A().optional()
    }).or(Yr())
  )
}), sT = N({
  failsWithGroups: H1.partial().optional(),
  failsWithMessage: Y1.partial().optional(),
  linkedGroupIds: k(R())
});
dt(A(), sT);
const uc = N({
  courseId: R(),
  activity: A(),
  activityId: R().optional()
});
dt(
  A(),
  k(uc)
);
const Z1 = uc.extend({
  reasons: sT.partial().optional()
}), lc = N({
  buffer: oe().optional(),
  doubleBooked: oe().optional(),
  dedicated: oe().optional(),
  hidden: oe().optional(),
  registrationPeriod: oe().optional()
}), cc = dt(
  A(),
  k(Z1)
), J1 = uc.extend({
  group: R()
}), K1 = dt(
  A(),
  k(J1)
), fc = N({
  logId: A().optional(),
  failedGroups: cc,
  successGroups: K1,
  swapStudentInfo: aa.optional()
});
fc.omit({
  swapStudentInfo: !0
}).extend({
  swapStudentInfo: Yr().optional()
});
fc.omit({
  swapStudentInfo: !0
}).extend({
  swapStudentInfo: aa
});
N({
  missingLinks: k(R()),
  missingGroupsForActivities: k(R())
});
N({
  addResult: fc,
  removeResult: A()
});
N({
  size: R(),
  isPercent: oe()
});
const X1 = ["start", "end"];
pe(X1);
const Q1 = N({
  numberOfIssues: R()
}), eP = N({
  completed: oe()
});
N({
  list: Lt(W1, Q1),
  issueCount: R(),
  courses: Lt(A(), eP.optional())
});
const tP = N({
  courseId: R(),
  groupIds: k(R())
});
N({
  changeRequests: k(tP)
});
const rP = N({
  groupId: R(),
  groupLabel: A(),
  courseIds: k(R()),
  courseLabels: k(A()),
  activityTypes: k(A()),
  issueNames: k(ac.keyof().or(ce("unknownIssue")))
});
N({
  groups: k(rP),
  total: R().int().nonnegative()
});
const nP = N({
  issueId: R(),
  studentId: R(),
  studentLabel: A(),
  courseId: R(),
  courseLabel: A(),
  activityId: R(),
  activityType: A(),
  groupIds: k(R()),
  groupLabels: k(A()),
  issueName: eT.keyof().or(ce("unknownIssue"))
});
N({
  students: k(nP),
  total: R().int().nonnegative()
});
const iP = N({
  id: R(),
  value: A()
}), oP = N({
  id: R()
}), aT = bt([
  N({
    kind: ce("category"),
    data: k(iP)
  }),
  N({
    kind: ce("relation"),
    data: k(oP)
  }),
  N({
    kind: ce("none"),
    data: Yr().optional()
  })
]);
var uT = /* @__PURE__ */ ((e) => (e[e.SPREAD = 1] = "SPREAD", e))(uT || {});
const xs = pe(uT);
var Kr = /* @__PURE__ */ ((e) => (e.TYPE = "t", e.FIELD = "f", e.NONE = "none", e))(Kr || {});
const sP = (e) => e, ks = R(), aP = sP({
  t: N({
    r: xs,
    v: ks,
    k: ce(
      "t"
      /* TYPE */
    )
  }),
  f: N({
    r: xs,
    v: ks,
    k: ce(
      "f"
      /* FIELD */
    )
  }),
  none: N({
    k: ce(
      "none"
      /* NONE */
    )
  })
}), lT = cr(
  "k",
  Object.values(aP)
), uP = N({
  dedi: aT,
  dist: lT
}), lP = N({
  k: pe(Kr).optional(),
  r: xs.optional(),
  v: bt([ks, k(ks)]).optional()
});
N({
  groupIds: k(R()),
  distribution: lP,
  override: oe()
});
const cP = N({
  id: R(),
  name: A(),
  activityId: R()
}), fP = N({
  id: R(),
  name: A(),
  groups: k(R()),
  courseId: R()
}), dP = N({
  id: R(),
  activities: k(R()).optional()
}), pP = N({
  id: R(),
  fields: k(Vo),
  relations: k(R()),
  activities: k(R()),
  totalActivities: R(),
  groups: k(R())
}), cT = "ALLOCATED", fT = "NOT_ALLOCATED", el = "GROUP:", hP = bt([
  ce(cT),
  ce(fT),
  A().regex(/^GROUP:\d+$/)
]);
N({
  programs: k(Ft),
  students: k(pP),
  groupLookup: dt(A(), cP),
  courseLookup: dt(A(), dP),
  activitiesLookup: dt(A(), fP),
  totalStudents: R()
});
const dT = N({
  fieldId: sc,
  values: z1
}), pT = N({
  sort: pe(ar).extract(["ASCFIELD", "DESCFIELD"]).optional(),
  sortFieldId: R().nonnegative().int().optional()
}), mP = N({
  sort: pe(ar).extract(["ASCFIELD", "DESCFIELD"]).optional(),
  key: A()
});
bt([pT, mP]);
const EP = k(
  N({
    reservationId: R(),
    start: R(),
    end: R(),
    studentSetGroupId: R(),
    activityId: R(),
    courseId: R()
  })
), gP = N({
  reservations: EP,
  allocated: oe()
}), yP = Lt(
  A(),
  gP
);
Lt(
  A(),
  yP
);
dt(A(), R());
const TP = N({
  taken: An,
  available: An,
  total: An,
  raw: N({
    taken: An,
    available: An,
    total: An,
    buffer: An
  })
}), hT = Ft == null ? void 0 : Ft.partial().and(
  Ft.pick({
    id: !0,
    extId: !0,
    fields: !0,
    members: !0,
    types: !0,
    relations: !0
  })
), mT = Ft.pick({
  id: !0,
  fields: !0
}), bP = mT.extend(
  Ft.pick({ relations: !0 }).shape
);
Ft.pick({
  id: !0,
  extId: !0,
  fields: !0,
  types: !0,
  relations: !0
});
const dc = N({
  id: Qy,
  label: A()
}), ET = dc.extend({
  extId: A(),
  typeIds: k(R()),
  children: k(R()).optional().default([]),
  teObject: hT
}), gT = dc.extend({
  children: k(R()).optional().default([]),
  parentId: R().int().positive()
}), pc = dc.extend({
  extId: A(),
  typeIds: k(R()),
  parentId: R().int().positive(),
  teObject: hT,
  links: k(R())
});
N({
  courses: dt(A(), ET),
  activities: dt(A(), gT),
  groups: dt(A(), pc)
});
const AP = ET.extend({
  open: oe().optional(),
  showInRegistration: oe().optional().transform((e) => !!e)
});
AP.pick({
  id: !0,
  label: !0,
  children: !0,
  open: !0
}).extend({ teObject: mT });
gT.extend({
  state: zw.optional().default("SELECT"),
  allocationSignal: Ry.optional().default("ISSUE"),
  open: oe().optional(),
  showInRegistration: oe().optional().transform((e) => !!e),
  hasWaitlist: oe().default(!1),
  hasConflicts: oe().default(!1)
});
const vP = pc.extend({
  seats: TP.optional().default({
    taken: 0,
    available: 0,
    total: 0,
    raw: { taken: 0, available: 0, total: 0, buffer: 0 }
  }),
  allocationStatus: Vw.optional().default("NOT_ALLOCATED"),
  open: oe().optional(),
  dedicated: aT.optional().default({
    kind: "none",
    data: void 0
  }),
  hidden: oe().optional().transform((e) => !!e),
  showInRegistration: oe().optional().transform((e) => !!e),
  matchDedication: oe().optional().transform((e) => !!e),
  waitlistPosition: R().optional().default(0),
  hasStudentsInWaitlist: oe().optional().default(!1)
});
vP.pick({
  id: !0,
  label: !0,
  parentId: !0,
  links: !0,
  seats: !0,
  allocationStatus: !0,
  open: !0,
  dedicated: !0,
  hidden: !0,
  matchDedication: !0,
  waitlistPosition: !0,
  hasStudentsInWaitlist: !0
}).extend({ teObject: bP });
const SP = ["teacher", "student"];
pe(SP);
N({
  studentId: F1.pipe($u().nonnegative())
});
N({
  objectIds: k(R())
});
N({
  teachers: A().optional(),
  rooms: A().optional()
});
N({
  modified: R().optional(),
  modifiedBy: Rh == null ? void 0 : Rh.optional()
});
const tl = N({
  typeId: R().int().positive(),
  objectIds: k(R().int().positive()).min(1)
}), IP = N({
  sort: Bu.optional(),
  sortFieldId: R().nonnegative().int().optional()
}), yT = IP.superRefine((e, t) => {
  const r = e.sort === Bu.enum.ASCFIELD || e.sort === Bu.enum.DESCFIELD;
  r && e.sortFieldId === void 0 && t.issues.push({
    input: e,
    code: "custom",
    message: "sortFieldId is required when sort is ASCFIELD or DESCFIELD"
  }), !r && e.sortFieldId !== void 0 && t.issues.push({
    input: e,
    code: "custom",
    path: ["sortFieldId"],
    message: "sortFieldId must be omitted unless sort is ASCFIELD or DESCFIELD"
  });
});
var Nh = {}, co = {}, Ch;
function _P() {
  if (Ch) return co;
  Ch = 1, co.byteLength = a, co.toByteArray = f, co.fromByteArray = E;
  for (var e = [], t = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, o = n.length; i < o; ++i)
    e[i] = n[i], t[n.charCodeAt(i)] = i;
  t[45] = 62, t[95] = 63;
  function s(d) {
    var g = d.length;
    if (g % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var y = d.indexOf("=");
    y === -1 && (y = g);
    var b = y === g ? 0 : 4 - y % 4;
    return [y, b];
  }
  function a(d) {
    var g = s(d), y = g[0], b = g[1];
    return (y + b) * 3 / 4 - b;
  }
  function l(d, g, y) {
    return (g + y) * 3 / 4 - y;
  }
  function f(d) {
    var g, y = s(d), b = y[0], I = y[1], S = new r(l(d, b, I)), w = 0, P = I > 0 ? b - 4 : b, _;
    for (_ = 0; _ < P; _ += 4)
      g = t[d.charCodeAt(_)] << 18 | t[d.charCodeAt(_ + 1)] << 12 | t[d.charCodeAt(_ + 2)] << 6 | t[d.charCodeAt(_ + 3)], S[w++] = g >> 16 & 255, S[w++] = g >> 8 & 255, S[w++] = g & 255;
    return I === 2 && (g = t[d.charCodeAt(_)] << 2 | t[d.charCodeAt(_ + 1)] >> 4, S[w++] = g & 255), I === 1 && (g = t[d.charCodeAt(_)] << 10 | t[d.charCodeAt(_ + 1)] << 4 | t[d.charCodeAt(_ + 2)] >> 2, S[w++] = g >> 8 & 255, S[w++] = g & 255), S;
  }
  function u(d) {
    return e[d >> 18 & 63] + e[d >> 12 & 63] + e[d >> 6 & 63] + e[d & 63];
  }
  function h(d, g, y) {
    for (var b, I = [], S = g; S < y; S += 3)
      b = (d[S] << 16 & 16711680) + (d[S + 1] << 8 & 65280) + (d[S + 2] & 255), I.push(u(b));
    return I.join("");
  }
  function E(d) {
    for (var g, y = d.length, b = y % 3, I = [], S = 16383, w = 0, P = y - b; w < P; w += S)
      I.push(h(d, w, w + S > P ? P : w + S));
    return b === 1 ? (g = d[y - 1], I.push(
      e[g >> 2] + e[g << 4 & 63] + "=="
    )) : b === 2 && (g = (d[y - 2] << 8) + d[y - 1], I.push(
      e[g >> 10] + e[g >> 4 & 63] + e[g << 2 & 63] + "="
    )), I.join("");
  }
  return co;
}
var ja = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var Ph;
function RP() {
  return Ph || (Ph = 1, ja.read = function(e, t, r, n, i) {
    var o, s, a = i * 8 - n - 1, l = (1 << a) - 1, f = l >> 1, u = -7, h = r ? i - 1 : 0, E = r ? -1 : 1, d = e[t + h];
    for (h += E, o = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; o = o * 256 + e[t + h], h += E, u -= 8)
      ;
    for (s = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; s = s * 256 + e[t + h], h += E, u -= 8)
      ;
    if (o === 0)
      o = 1 - f;
    else {
      if (o === l)
        return s ? NaN : (d ? -1 : 1) * (1 / 0);
      s = s + Math.pow(2, n), o = o - f;
    }
    return (d ? -1 : 1) * s * Math.pow(2, o - n);
  }, ja.write = function(e, t, r, n, i, o) {
    var s, a, l, f = o * 8 - i - 1, u = (1 << f) - 1, h = u >> 1, E = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : o - 1, g = n ? 1 : -1, y = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = u) : (s = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), s + h >= 1 ? t += E / l : t += E * Math.pow(2, 1 - h), t * l >= 2 && (s++, l /= 2), s + h >= u ? (a = 0, s = u) : s + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), s = s + h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; e[r + d] = a & 255, d += g, a /= 256, i -= 8)
      ;
    for (s = s << i | a, f += i; f > 0; e[r + d] = s & 255, d += g, s /= 256, f -= 8)
      ;
    e[r + d - g] |= y * 128;
  }), ja;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Dh;
function OP() {
  return Dh || (Dh = 1, (function(e) {
    var t = _P(), r = RP(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = a, e.SlowBuffer = S, e.INSPECT_MAX_BYTES = 50;
    var i = 2147483647;
    e.kMaxLength = i, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function o() {
      try {
        var p = new Uint8Array(1), c = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(c, Uint8Array.prototype), Object.setPrototypeOf(p, c), p.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(a.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(a.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.byteOffset;
      }
    });
    function s(p) {
      if (p > i)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
      var c = new Uint8Array(p);
      return Object.setPrototypeOf(c, a.prototype), c;
    }
    function a(p, c, m) {
      if (typeof p == "number") {
        if (typeof c == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return h(p);
      }
      return l(p, c, m);
    }
    a.poolSize = 8192;
    function l(p, c, m) {
      if (typeof p == "string")
        return E(p, c);
      if (ArrayBuffer.isView(p))
        return g(p);
      if (p == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
        );
      if (Re(p, ArrayBuffer) || p && Re(p.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Re(p, SharedArrayBuffer) || p && Re(p.buffer, SharedArrayBuffer)))
        return y(p, c, m);
      if (typeof p == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var T = p.valueOf && p.valueOf();
      if (T != null && T !== p)
        return a.from(T, c, m);
      var O = b(p);
      if (O) return O;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function")
        return a.from(
          p[Symbol.toPrimitive]("string"),
          c,
          m
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
      );
    }
    a.from = function(p, c, m) {
      return l(p, c, m);
    }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
    function f(p) {
      if (typeof p != "number")
        throw new TypeError('"size" argument must be of type number');
      if (p < 0)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
    }
    function u(p, c, m) {
      return f(p), p <= 0 ? s(p) : c !== void 0 ? typeof m == "string" ? s(p).fill(c, m) : s(p).fill(c) : s(p);
    }
    a.alloc = function(p, c, m) {
      return u(p, c, m);
    };
    function h(p) {
      return f(p), s(p < 0 ? 0 : I(p) | 0);
    }
    a.allocUnsafe = function(p) {
      return h(p);
    }, a.allocUnsafeSlow = function(p) {
      return h(p);
    };
    function E(p, c) {
      if ((typeof c != "string" || c === "") && (c = "utf8"), !a.isEncoding(c))
        throw new TypeError("Unknown encoding: " + c);
      var m = w(p, c) | 0, T = s(m), O = T.write(p, c);
      return O !== m && (T = T.slice(0, O)), T;
    }
    function d(p) {
      for (var c = p.length < 0 ? 0 : I(p.length) | 0, m = s(c), T = 0; T < c; T += 1)
        m[T] = p[T] & 255;
      return m;
    }
    function g(p) {
      if (Re(p, Uint8Array)) {
        var c = new Uint8Array(p);
        return y(c.buffer, c.byteOffset, c.byteLength);
      }
      return d(p);
    }
    function y(p, c, m) {
      if (c < 0 || p.byteLength < c)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (p.byteLength < c + (m || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var T;
      return c === void 0 && m === void 0 ? T = new Uint8Array(p) : m === void 0 ? T = new Uint8Array(p, c) : T = new Uint8Array(p, c, m), Object.setPrototypeOf(T, a.prototype), T;
    }
    function b(p) {
      if (a.isBuffer(p)) {
        var c = I(p.length) | 0, m = s(c);
        return m.length === 0 || p.copy(m, 0, 0, c), m;
      }
      if (p.length !== void 0)
        return typeof p.length != "number" || nt(p.length) ? s(0) : d(p);
      if (p.type === "Buffer" && Array.isArray(p.data))
        return d(p.data);
    }
    function I(p) {
      if (p >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return p | 0;
    }
    function S(p) {
      return +p != p && (p = 0), a.alloc(+p);
    }
    a.isBuffer = function(p) {
      return p != null && p._isBuffer === !0 && p !== a.prototype;
    }, a.compare = function(p, c) {
      if (Re(p, Uint8Array) && (p = a.from(p, p.offset, p.byteLength)), Re(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), !a.isBuffer(p) || !a.isBuffer(c))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (p === c) return 0;
      for (var m = p.length, T = c.length, O = 0, j = Math.min(m, T); O < j; ++O)
        if (p[O] !== c[O]) {
          m = p[O], T = c[O];
          break;
        }
      return m < T ? -1 : T < m ? 1 : 0;
    }, a.isEncoding = function(p) {
      switch (String(p).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, a.concat = function(p, c) {
      if (!Array.isArray(p))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (p.length === 0)
        return a.alloc(0);
      var m;
      if (c === void 0)
        for (c = 0, m = 0; m < p.length; ++m)
          c += p[m].length;
      var T = a.allocUnsafe(c), O = 0;
      for (m = 0; m < p.length; ++m) {
        var j = p[m];
        if (Re(j, Uint8Array))
          O + j.length > T.length ? a.from(j).copy(T, O) : Uint8Array.prototype.set.call(
            T,
            j,
            O
          );
        else if (a.isBuffer(j))
          j.copy(T, O);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        O += j.length;
      }
      return T;
    };
    function w(p, c) {
      if (a.isBuffer(p))
        return p.length;
      if (ArrayBuffer.isView(p) || Re(p, ArrayBuffer))
        return p.byteLength;
      if (typeof p != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof p
        );
      var m = p.length, T = arguments.length > 2 && arguments[2] === !0;
      if (!T && m === 0) return 0;
      for (var O = !1; ; )
        switch (c) {
          case "ascii":
          case "latin1":
          case "binary":
            return m;
          case "utf8":
          case "utf-8":
            return Le(p).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return m * 2;
          case "hex":
            return m >>> 1;
          case "base64":
            return $e(p).length;
          default:
            if (O)
              return T ? -1 : Le(p).length;
            c = ("" + c).toLowerCase(), O = !0;
        }
    }
    a.byteLength = w;
    function P(p, c, m) {
      var T = !1;
      if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((m === void 0 || m > this.length) && (m = this.length), m <= 0) || (m >>>= 0, c >>>= 0, m <= c))
        return "";
      for (p || (p = "utf8"); ; )
        switch (p) {
          case "hex":
            return te(this, c, m);
          case "utf8":
          case "utf-8":
            return B(this, c, m);
          case "ascii":
            return Z(this, c, m);
          case "latin1":
          case "binary":
            return V(this, c, m);
          case "base64":
            return de(this, c, m);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ee(this, c, m);
          default:
            if (T) throw new TypeError("Unknown encoding: " + p);
            p = (p + "").toLowerCase(), T = !0;
        }
    }
    a.prototype._isBuffer = !0;
    function _(p, c, m) {
      var T = p[c];
      p[c] = p[m], p[m] = T;
    }
    a.prototype.swap16 = function() {
      var p = this.length;
      if (p % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var c = 0; c < p; c += 2)
        _(this, c, c + 1);
      return this;
    }, a.prototype.swap32 = function() {
      var p = this.length;
      if (p % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var c = 0; c < p; c += 4)
        _(this, c, c + 3), _(this, c + 1, c + 2);
      return this;
    }, a.prototype.swap64 = function() {
      var p = this.length;
      if (p % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var c = 0; c < p; c += 8)
        _(this, c, c + 7), _(this, c + 1, c + 6), _(this, c + 2, c + 5), _(this, c + 3, c + 4);
      return this;
    }, a.prototype.toString = function() {
      var p = this.length;
      return p === 0 ? "" : arguments.length === 0 ? B(this, 0, p) : P.apply(this, arguments);
    }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(p) {
      if (!a.isBuffer(p)) throw new TypeError("Argument must be a Buffer");
      return this === p ? !0 : a.compare(this, p) === 0;
    }, a.prototype.inspect = function() {
      var p = "", c = e.INSPECT_MAX_BYTES;
      return p = this.toString("hex", 0, c).replace(/(.{2})/g, "$1 ").trim(), this.length > c && (p += " ... "), "<Buffer " + p + ">";
    }, n && (a.prototype[n] = a.prototype.inspect), a.prototype.compare = function(p, c, m, T, O) {
      if (Re(p, Uint8Array) && (p = a.from(p, p.offset, p.byteLength)), !a.isBuffer(p))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof p
        );
      if (c === void 0 && (c = 0), m === void 0 && (m = p ? p.length : 0), T === void 0 && (T = 0), O === void 0 && (O = this.length), c < 0 || m > p.length || T < 0 || O > this.length)
        throw new RangeError("out of range index");
      if (T >= O && c >= m)
        return 0;
      if (T >= O)
        return -1;
      if (c >= m)
        return 1;
      if (c >>>= 0, m >>>= 0, T >>>= 0, O >>>= 0, this === p) return 0;
      for (var j = O - T, q = m - c, ae = Math.min(j, q), Te = this.slice(T, O), U = p.slice(c, m), J = 0; J < ae; ++J)
        if (Te[J] !== U[J]) {
          j = Te[J], q = U[J];
          break;
        }
      return j < q ? -1 : q < j ? 1 : 0;
    };
    function v(p, c, m, T, O) {
      if (p.length === 0) return -1;
      if (typeof m == "string" ? (T = m, m = 0) : m > 2147483647 ? m = 2147483647 : m < -2147483648 && (m = -2147483648), m = +m, nt(m) && (m = O ? 0 : p.length - 1), m < 0 && (m = p.length + m), m >= p.length) {
        if (O) return -1;
        m = p.length - 1;
      } else if (m < 0)
        if (O) m = 0;
        else return -1;
      if (typeof c == "string" && (c = a.from(c, T)), a.isBuffer(c))
        return c.length === 0 ? -1 : M(p, c, m, T, O);
      if (typeof c == "number")
        return c = c & 255, typeof Uint8Array.prototype.indexOf == "function" ? O ? Uint8Array.prototype.indexOf.call(p, c, m) : Uint8Array.prototype.lastIndexOf.call(p, c, m) : M(p, [c], m, T, O);
      throw new TypeError("val must be string, number or Buffer");
    }
    function M(p, c, m, T, O) {
      var j = 1, q = p.length, ae = c.length;
      if (T !== void 0 && (T = String(T).toLowerCase(), T === "ucs2" || T === "ucs-2" || T === "utf16le" || T === "utf-16le")) {
        if (p.length < 2 || c.length < 2)
          return -1;
        j = 2, q /= 2, ae /= 2, m /= 2;
      }
      function Te(Ce, We) {
        return j === 1 ? Ce[We] : Ce.readUInt16BE(We * j);
      }
      var U;
      if (O) {
        var J = -1;
        for (U = m; U < q; U++)
          if (Te(p, U) === Te(c, J === -1 ? 0 : U - J)) {
            if (J === -1 && (J = U), U - J + 1 === ae) return J * j;
          } else
            J !== -1 && (U -= U - J), J = -1;
      } else
        for (m + ae > q && (m = q - ae), U = m; U >= 0; U--) {
          for (var H = !0, ie = 0; ie < ae; ie++)
            if (Te(p, U + ie) !== Te(c, ie)) {
              H = !1;
              break;
            }
          if (H) return U;
        }
      return -1;
    }
    a.prototype.includes = function(p, c, m) {
      return this.indexOf(p, c, m) !== -1;
    }, a.prototype.indexOf = function(p, c, m) {
      return v(this, p, c, m, !0);
    }, a.prototype.lastIndexOf = function(p, c, m) {
      return v(this, p, c, m, !1);
    };
    function x(p, c, m, T) {
      m = Number(m) || 0;
      var O = p.length - m;
      T ? (T = Number(T), T > O && (T = O)) : T = O;
      var j = c.length;
      T > j / 2 && (T = j / 2);
      for (var q = 0; q < T; ++q) {
        var ae = parseInt(c.substr(q * 2, 2), 16);
        if (nt(ae)) return q;
        p[m + q] = ae;
      }
      return q;
    }
    function z(p, c, m, T) {
      return Ne(Le(c, p.length - m), p, m, T);
    }
    function F(p, c, m, T) {
      return Ne(Ve(c), p, m, T);
    }
    function W(p, c, m, T) {
      return Ne($e(c), p, m, T);
    }
    function X(p, c, m, T) {
      return Ne(Ie(c, p.length - m), p, m, T);
    }
    a.prototype.write = function(p, c, m, T) {
      if (c === void 0)
        T = "utf8", m = this.length, c = 0;
      else if (m === void 0 && typeof c == "string")
        T = c, m = this.length, c = 0;
      else if (isFinite(c))
        c = c >>> 0, isFinite(m) ? (m = m >>> 0, T === void 0 && (T = "utf8")) : (T = m, m = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var O = this.length - c;
      if ((m === void 0 || m > O) && (m = O), p.length > 0 && (m < 0 || c < 0) || c > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      T || (T = "utf8");
      for (var j = !1; ; )
        switch (T) {
          case "hex":
            return x(this, p, c, m);
          case "utf8":
          case "utf-8":
            return z(this, p, c, m);
          case "ascii":
          case "latin1":
          case "binary":
            return F(this, p, c, m);
          case "base64":
            return W(this, p, c, m);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return X(this, p, c, m);
          default:
            if (j) throw new TypeError("Unknown encoding: " + T);
            T = ("" + T).toLowerCase(), j = !0;
        }
    }, a.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function de(p, c, m) {
      return c === 0 && m === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(c, m));
    }
    function B(p, c, m) {
      m = Math.min(p.length, m);
      for (var T = [], O = c; O < m; ) {
        var j = p[O], q = null, ae = j > 239 ? 4 : j > 223 ? 3 : j > 191 ? 2 : 1;
        if (O + ae <= m) {
          var Te, U, J, H;
          switch (ae) {
            case 1:
              j < 128 && (q = j);
              break;
            case 2:
              Te = p[O + 1], (Te & 192) === 128 && (H = (j & 31) << 6 | Te & 63, H > 127 && (q = H));
              break;
            case 3:
              Te = p[O + 1], U = p[O + 2], (Te & 192) === 128 && (U & 192) === 128 && (H = (j & 15) << 12 | (Te & 63) << 6 | U & 63, H > 2047 && (H < 55296 || H > 57343) && (q = H));
              break;
            case 4:
              Te = p[O + 1], U = p[O + 2], J = p[O + 3], (Te & 192) === 128 && (U & 192) === 128 && (J & 192) === 128 && (H = (j & 15) << 18 | (Te & 63) << 12 | (U & 63) << 6 | J & 63, H > 65535 && H < 1114112 && (q = H));
          }
        }
        q === null ? (q = 65533, ae = 1) : q > 65535 && (q -= 65536, T.push(q >>> 10 & 1023 | 55296), q = 56320 | q & 1023), T.push(q), O += ae;
      }
      return G(T);
    }
    var L = 4096;
    function G(p) {
      var c = p.length;
      if (c <= L)
        return String.fromCharCode.apply(String, p);
      for (var m = "", T = 0; T < c; )
        m += String.fromCharCode.apply(
          String,
          p.slice(T, T += L)
        );
      return m;
    }
    function Z(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var O = c; O < m; ++O)
        T += String.fromCharCode(p[O] & 127);
      return T;
    }
    function V(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var O = c; O < m; ++O)
        T += String.fromCharCode(p[O]);
      return T;
    }
    function te(p, c, m) {
      var T = p.length;
      (!c || c < 0) && (c = 0), (!m || m < 0 || m > T) && (m = T);
      for (var O = "", j = c; j < m; ++j)
        O += nn[p[j]];
      return O;
    }
    function ee(p, c, m) {
      for (var T = p.slice(c, m), O = "", j = 0; j < T.length - 1; j += 2)
        O += String.fromCharCode(T[j] + T[j + 1] * 256);
      return O;
    }
    a.prototype.slice = function(p, c) {
      var m = this.length;
      p = ~~p, c = c === void 0 ? m : ~~c, p < 0 ? (p += m, p < 0 && (p = 0)) : p > m && (p = m), c < 0 ? (c += m, c < 0 && (c = 0)) : c > m && (c = m), c < p && (c = p);
      var T = this.subarray(p, c);
      return Object.setPrototypeOf(T, a.prototype), T;
    };
    function Q(p, c, m) {
      if (p % 1 !== 0 || p < 0) throw new RangeError("offset is not uint");
      if (p + c > m) throw new RangeError("Trying to access beyond buffer length");
    }
    a.prototype.readUintLE = a.prototype.readUIntLE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || Q(p, c, this.length);
      for (var T = this[p], O = 1, j = 0; ++j < c && (O *= 256); )
        T += this[p + j] * O;
      return T;
    }, a.prototype.readUintBE = a.prototype.readUIntBE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || Q(p, c, this.length);
      for (var T = this[p + --c], O = 1; c > 0 && (O *= 256); )
        T += this[p + --c] * O;
      return T;
    }, a.prototype.readUint8 = a.prototype.readUInt8 = function(p, c) {
      return p = p >>> 0, c || Q(p, 1, this.length), this[p];
    }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(p, c) {
      return p = p >>> 0, c || Q(p, 2, this.length), this[p] | this[p + 1] << 8;
    }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(p, c) {
      return p = p >>> 0, c || Q(p, 2, this.length), this[p] << 8 | this[p + 1];
    }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(p, c) {
      return p = p >>> 0, c || Q(p, 4, this.length), (this[p] | this[p + 1] << 8 | this[p + 2] << 16) + this[p + 3] * 16777216;
    }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(p, c) {
      return p = p >>> 0, c || Q(p, 4, this.length), this[p] * 16777216 + (this[p + 1] << 16 | this[p + 2] << 8 | this[p + 3]);
    }, a.prototype.readIntLE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || Q(p, c, this.length);
      for (var T = this[p], O = 1, j = 0; ++j < c && (O *= 256); )
        T += this[p + j] * O;
      return O *= 128, T >= O && (T -= Math.pow(2, 8 * c)), T;
    }, a.prototype.readIntBE = function(p, c, m) {
      p = p >>> 0, c = c >>> 0, m || Q(p, c, this.length);
      for (var T = c, O = 1, j = this[p + --T]; T > 0 && (O *= 256); )
        j += this[p + --T] * O;
      return O *= 128, j >= O && (j -= Math.pow(2, 8 * c)), j;
    }, a.prototype.readInt8 = function(p, c) {
      return p = p >>> 0, c || Q(p, 1, this.length), this[p] & 128 ? (255 - this[p] + 1) * -1 : this[p];
    }, a.prototype.readInt16LE = function(p, c) {
      p = p >>> 0, c || Q(p, 2, this.length);
      var m = this[p] | this[p + 1] << 8;
      return m & 32768 ? m | 4294901760 : m;
    }, a.prototype.readInt16BE = function(p, c) {
      p = p >>> 0, c || Q(p, 2, this.length);
      var m = this[p + 1] | this[p] << 8;
      return m & 32768 ? m | 4294901760 : m;
    }, a.prototype.readInt32LE = function(p, c) {
      return p = p >>> 0, c || Q(p, 4, this.length), this[p] | this[p + 1] << 8 | this[p + 2] << 16 | this[p + 3] << 24;
    }, a.prototype.readInt32BE = function(p, c) {
      return p = p >>> 0, c || Q(p, 4, this.length), this[p] << 24 | this[p + 1] << 16 | this[p + 2] << 8 | this[p + 3];
    }, a.prototype.readFloatLE = function(p, c) {
      return p = p >>> 0, c || Q(p, 4, this.length), r.read(this, p, !0, 23, 4);
    }, a.prototype.readFloatBE = function(p, c) {
      return p = p >>> 0, c || Q(p, 4, this.length), r.read(this, p, !1, 23, 4);
    }, a.prototype.readDoubleLE = function(p, c) {
      return p = p >>> 0, c || Q(p, 8, this.length), r.read(this, p, !0, 52, 8);
    }, a.prototype.readDoubleBE = function(p, c) {
      return p = p >>> 0, c || Q(p, 8, this.length), r.read(this, p, !1, 52, 8);
    };
    function re(p, c, m, T, O, j) {
      if (!a.isBuffer(p)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (c > O || c < j) throw new RangeError('"value" argument is out of bounds');
      if (m + T > p.length) throw new RangeError("Index out of range");
    }
    a.prototype.writeUintLE = a.prototype.writeUIntLE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, m = m >>> 0, !T) {
        var O = Math.pow(2, 8 * m) - 1;
        re(this, p, c, m, O, 0);
      }
      var j = 1, q = 0;
      for (this[c] = p & 255; ++q < m && (j *= 256); )
        this[c + q] = p / j & 255;
      return c + m;
    }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, m = m >>> 0, !T) {
        var O = Math.pow(2, 8 * m) - 1;
        re(this, p, c, m, O, 0);
      }
      var j = m - 1, q = 1;
      for (this[c + j] = p & 255; --j >= 0 && (q *= 256); )
        this[c + j] = p / q & 255;
      return c + m;
    }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 1, 255, 0), this[c] = p & 255, c + 1;
    }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 2, 65535, 0), this[c] = p & 255, this[c + 1] = p >>> 8, c + 2;
    }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 2, 65535, 0), this[c] = p >>> 8, this[c + 1] = p & 255, c + 2;
    }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 4, 4294967295, 0), this[c + 3] = p >>> 24, this[c + 2] = p >>> 16, this[c + 1] = p >>> 8, this[c] = p & 255, c + 4;
    }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 4, 4294967295, 0), this[c] = p >>> 24, this[c + 1] = p >>> 16, this[c + 2] = p >>> 8, this[c + 3] = p & 255, c + 4;
    }, a.prototype.writeIntLE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, !T) {
        var O = Math.pow(2, 8 * m - 1);
        re(this, p, c, m, O - 1, -O);
      }
      var j = 0, q = 1, ae = 0;
      for (this[c] = p & 255; ++j < m && (q *= 256); )
        p < 0 && ae === 0 && this[c + j - 1] !== 0 && (ae = 1), this[c + j] = (p / q >> 0) - ae & 255;
      return c + m;
    }, a.prototype.writeIntBE = function(p, c, m, T) {
      if (p = +p, c = c >>> 0, !T) {
        var O = Math.pow(2, 8 * m - 1);
        re(this, p, c, m, O - 1, -O);
      }
      var j = m - 1, q = 1, ae = 0;
      for (this[c + j] = p & 255; --j >= 0 && (q *= 256); )
        p < 0 && ae === 0 && this[c + j + 1] !== 0 && (ae = 1), this[c + j] = (p / q >> 0) - ae & 255;
      return c + m;
    }, a.prototype.writeInt8 = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 1, 127, -128), p < 0 && (p = 255 + p + 1), this[c] = p & 255, c + 1;
    }, a.prototype.writeInt16LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 2, 32767, -32768), this[c] = p & 255, this[c + 1] = p >>> 8, c + 2;
    }, a.prototype.writeInt16BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 2, 32767, -32768), this[c] = p >>> 8, this[c + 1] = p & 255, c + 2;
    }, a.prototype.writeInt32LE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 4, 2147483647, -2147483648), this[c] = p & 255, this[c + 1] = p >>> 8, this[c + 2] = p >>> 16, this[c + 3] = p >>> 24, c + 4;
    }, a.prototype.writeInt32BE = function(p, c, m) {
      return p = +p, c = c >>> 0, m || re(this, p, c, 4, 2147483647, -2147483648), p < 0 && (p = 4294967295 + p + 1), this[c] = p >>> 24, this[c + 1] = p >>> 16, this[c + 2] = p >>> 8, this[c + 3] = p & 255, c + 4;
    };
    function ne(p, c, m, T, O, j) {
      if (m + T > p.length) throw new RangeError("Index out of range");
      if (m < 0) throw new RangeError("Index out of range");
    }
    function Ee(p, c, m, T, O) {
      return c = +c, m = m >>> 0, O || ne(p, c, m, 4), r.write(p, c, m, T, 23, 4), m + 4;
    }
    a.prototype.writeFloatLE = function(p, c, m) {
      return Ee(this, p, c, !0, m);
    }, a.prototype.writeFloatBE = function(p, c, m) {
      return Ee(this, p, c, !1, m);
    };
    function be(p, c, m, T, O) {
      return c = +c, m = m >>> 0, O || ne(p, c, m, 8), r.write(p, c, m, T, 52, 8), m + 8;
    }
    a.prototype.writeDoubleLE = function(p, c, m) {
      return be(this, p, c, !0, m);
    }, a.prototype.writeDoubleBE = function(p, c, m) {
      return be(this, p, c, !1, m);
    }, a.prototype.copy = function(p, c, m, T) {
      if (!a.isBuffer(p)) throw new TypeError("argument should be a Buffer");
      if (m || (m = 0), !T && T !== 0 && (T = this.length), c >= p.length && (c = p.length), c || (c = 0), T > 0 && T < m && (T = m), T === m || p.length === 0 || this.length === 0) return 0;
      if (c < 0)
        throw new RangeError("targetStart out of bounds");
      if (m < 0 || m >= this.length) throw new RangeError("Index out of range");
      if (T < 0) throw new RangeError("sourceEnd out of bounds");
      T > this.length && (T = this.length), p.length - c < T - m && (T = p.length - c + m);
      var O = T - m;
      return this === p && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(c, m, T) : Uint8Array.prototype.set.call(
        p,
        this.subarray(m, T),
        c
      ), O;
    }, a.prototype.fill = function(p, c, m, T) {
      if (typeof p == "string") {
        if (typeof c == "string" ? (T = c, c = 0, m = this.length) : typeof m == "string" && (T = m, m = this.length), T !== void 0 && typeof T != "string")
          throw new TypeError("encoding must be a string");
        if (typeof T == "string" && !a.isEncoding(T))
          throw new TypeError("Unknown encoding: " + T);
        if (p.length === 1) {
          var O = p.charCodeAt(0);
          (T === "utf8" && O < 128 || T === "latin1") && (p = O);
        }
      } else typeof p == "number" ? p = p & 255 : typeof p == "boolean" && (p = Number(p));
      if (c < 0 || this.length < c || this.length < m)
        throw new RangeError("Out of range index");
      if (m <= c)
        return this;
      c = c >>> 0, m = m === void 0 ? this.length : m >>> 0, p || (p = 0);
      var j;
      if (typeof p == "number")
        for (j = c; j < m; ++j)
          this[j] = p;
      else {
        var q = a.isBuffer(p) ? p : a.from(p, T), ae = q.length;
        if (ae === 0)
          throw new TypeError('The value "' + p + '" is invalid for argument "value"');
        for (j = 0; j < m - c; ++j)
          this[j + c] = q[j % ae];
      }
      return this;
    };
    var Be = /[^+/0-9A-Za-z-_]/g;
    function Ue(p) {
      if (p = p.split("=")[0], p = p.trim().replace(Be, ""), p.length < 2) return "";
      for (; p.length % 4 !== 0; )
        p = p + "=";
      return p;
    }
    function Le(p, c) {
      c = c || 1 / 0;
      for (var m, T = p.length, O = null, j = [], q = 0; q < T; ++q) {
        if (m = p.charCodeAt(q), m > 55295 && m < 57344) {
          if (!O) {
            if (m > 56319) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            } else if (q + 1 === T) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            }
            O = m;
            continue;
          }
          if (m < 56320) {
            (c -= 3) > -1 && j.push(239, 191, 189), O = m;
            continue;
          }
          m = (O - 55296 << 10 | m - 56320) + 65536;
        } else O && (c -= 3) > -1 && j.push(239, 191, 189);
        if (O = null, m < 128) {
          if ((c -= 1) < 0) break;
          j.push(m);
        } else if (m < 2048) {
          if ((c -= 2) < 0) break;
          j.push(
            m >> 6 | 192,
            m & 63 | 128
          );
        } else if (m < 65536) {
          if ((c -= 3) < 0) break;
          j.push(
            m >> 12 | 224,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else if (m < 1114112) {
          if ((c -= 4) < 0) break;
          j.push(
            m >> 18 | 240,
            m >> 12 & 63 | 128,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return j;
    }
    function Ve(p) {
      for (var c = [], m = 0; m < p.length; ++m)
        c.push(p.charCodeAt(m) & 255);
      return c;
    }
    function Ie(p, c) {
      for (var m, T, O, j = [], q = 0; q < p.length && !((c -= 2) < 0); ++q)
        m = p.charCodeAt(q), T = m >> 8, O = m % 256, j.push(O), j.push(T);
      return j;
    }
    function $e(p) {
      return t.toByteArray(Ue(p));
    }
    function Ne(p, c, m, T) {
      for (var O = 0; O < T && !(O + m >= c.length || O >= p.length); ++O)
        c[O + m] = p[O];
      return O;
    }
    function Re(p, c) {
      return p instanceof c || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === c.name;
    }
    function nt(p) {
      return p !== p;
    }
    var nn = (function() {
      for (var p = "0123456789abcdef", c = new Array(256), m = 0; m < 16; ++m)
        for (var T = m * 16, O = 0; O < 16; ++O)
          c[T + O] = p[m] + p[O];
      return c;
    })();
  })(Nh)), Nh;
}
var wP = OP();
N({
  id: R(),
  fields: k(Vo),
  members: k(ec)
});
N({
  id: R(),
  begin: R().optional(),
  end: R().optional(),
  objects: k(
    N({
      objectId: R(),
      typeId: R()
    })
  ),
  fields: k(
    N({
      fieldId: R(),
      values: k(A())
    })
  )
});
const bi = N({
  id: A(),
  name: A(),
  value: R().optional(),
  cost: R().optional()
}), TT = N({
  impossible: R(),
  impossibleInCurrent: R(),
  notEnoughSpaceOnPossible: R()
}), NP = Object.keys(TT.shape), CP = pe(NP), PP = bi.extend({
  id: ce("nofFailedDecisions"),
  kpis: k(
    bi.extend({
      id: CP
    })
  )
}), bT = N({
  nofAssignedDecisions: R(),
  nofCompleteStudents: R(),
  nofIncompleteStudents: R(),
  nofFailedDecisions: R()
}), DP = Object.keys(bT.shape), MP = pe(DP), LP = bi.extend({
  id: ce("solutionAnalysis"),
  kpis: k(
    bt([
      PP,
      bi.extend({
        id: MP
      })
    ])
  )
}), AT = N({
  nofStudents: R(),
  nofStudentSetGroups: R(),
  nofLockedDecisions: R(),
  nofNonLockedDecisions: R(),
  nofLockedStudents: R()
}), xP = Object.keys(AT.shape), kP = pe(xP), jP = bi.extend({
  id: ce("problemAnalysis"),
  kpis: k(
    bi.extend({
      id: kP
    })
  )
}), UP = cr("id", [
  LP,
  jP
]), $P = N({
  userId: A(),
  timestamp: R()
});
N({
  outputPath: A(),
  jobId: A(),
  internalJobId: A(),
  jobType: A(),
  status: A()
});
var ci = /* @__PURE__ */ ((e) => (e[e.Success = 0] = "Success", e[e.Impossible = 1] = "Impossible", e[e.ImpossibleInCurrent = 2] = "ImpossibleInCurrent", e[e.NotEnoughSpaceOnPossible = 3] = "NotEnoughSpaceOnPossible", e))(ci || {});
const FP = pe(ci), zP = Xr({
  studentId: R(),
  statuses: k(FP)
}), GP = Xr({
  students: k(R()),
  studentSetGroupId: R()
}), BP = N({
  kpis: k(UP),
  studentStatuses: k(zP),
  solution: Xr({
    assignments: k(GP)
  })
}), vT = Xr({
  errorCode: R(),
  message: A()
});
cr("exit_status", [
  N({
    build: A(),
    dataVersion: R(),
    exit_status: ce("success"),
    id: A(),
    meta: $P,
    result: BP
  }),
  N({
    build: A(),
    dataVersion: R(),
    exit_status: ce("error"),
    id: A(),
    error: vT
  })
]);
const Ua = (e) => wP.Buffer.isBuffer(e) || globalThis.Buffer.isBuffer(e), ST = at().superRefine((e, t) => {
  Ua(e) || e && typeof e == "object" && "buffer" in e && Ua(e.buffer) || t.issues.push({
    code: "custom",
    message: "Invalid Buffer type",
    input: e
  });
}).transform((e) => e && typeof e == "object" && "buffer" in e && Ua(e.buffer) ? e.buffer : e), VP = [
  "corrupted",
  "init_failed",
  "initializing",
  "unreceived",
  "failed",
  "pending",
  "completed",
  "allocating",
  "allocation_failed",
  "allocated"
], le = pe(VP), WP = {
  [le.enum.corrupted]: ["corrupted"],
  [le.enum.init_failed]: [
    "init_failed",
    "initializing",
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [le.enum.initializing]: [
    "initializing",
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [le.enum.unreceived]: [
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [le.enum.failed]: [
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [le.enum.pending]: [
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [le.enum.completed]: [
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [le.enum.allocating]: [
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [le.enum.allocation_failed]: [
    "allocation_failed",
    "allocated"
  ],
  [le.enum.allocated]: ["allocated"]
}, qP = N({
  ...bT.shape,
  ...AT.shape,
  ...TT.shape
}), HP = N({
  time: A().optional(),
  allocationTime: Ti,
  userId: A(),
  logId: A().optional()
}), YP = N({
  time: A().optional(),
  allocationTime: Ti,
  userId: A(),
  logId: A().optional(),
  failedGroups: cc
}), wt = {
  conflicts: "noConflicts",
  fill: "fillGroupsEvenly",
  distribution: "useAllocationSettings",
  optimizeForStudentPreferences: !0
}, $a = {
  conflicts: [wt.conflicts],
  fill: [wt.fill],
  distribution: [wt.distribution]
}, js = N({
  conflicts: pe($a.conflicts).optional().default(wt.conflicts),
  fill: pe($a.fill).optional().default(wt.fill),
  distribution: pe($a.distribution).optional().default(wt.distribution),
  optimizeForStudentPreferences: oe().optional().default(wt.optimizeForStudentPreferences)
}), hc = N({
  userId: A(),
  startTime: A().optional(),
  jobId: A(),
  createdAt: Ti,
  updatedAt: Ti
}), ua = N({
  userId: A(),
  startTime: A().optional(),
  jobId: A(),
  inputUrl: A(),
  issues: R(),
  settings: js.optional().default(wt),
  selection: N({
    studentSetGroups: R(),
    totalStudents: R(),
    incompleteStudents: R(),
    courses: k(B1)
  }),
  inputData: ST,
  createdAt: Ti,
  updatedAt: Ti
}), mc = hc.extend({
  status: ce(le.enum.initializing)
}), Ec = hc.extend({
  status: ce(le.enum.init_failed),
  error: at().optional()
}), gc = ua.extend({
  status: ce(le.enum.pending)
}), Ci = ua.extend({
  status: ce(le.enum.completed),
  outputData: ST,
  proposalResult: qP,
  outputUrl: A()
}), yc = ua.extend({
  status: ce(le.enum.unreceived),
  error: at().optional()
}), Tc = ua.extend({
  status: ce(le.enum.failed),
  error: vT
}), bc = Ci.extend({
  status: ce(le.enum.allocating)
}), Ac = Ci.extend({
  status: ce(le.enum.allocation_failed),
  error: at().optional()
}), vc = Ci.extend({
  allocationResult: YP,
  status: ce(le.enum.allocated)
}), Sc = hc.extend({
  status: ce(le.enum.corrupted),
  error: at().optional()
}).loose(), Ic = (e) => e, rr = [
  "outputData",
  "inputData",
  "allocationResult"
], vr = {
  username: N({
    creator: A()
  })
}, ZP = Ic({
  [le.enum.corrupted]: tr(
    Sc,
    rr
  ).extend(vr).loose(),
  [le.enum.allocated]: tr(
    vc,
    rr
  ).extend({
    username: N({
      creator: A(),
      allocator: A()
    }),
    allocationResult: HP
  }),
  [le.enum.allocation_failed]: tr(
    Ac,
    rr
  ).extend(vr),
  [le.enum.allocating]: tr(
    bc,
    rr
  ).extend(vr),
  [le.enum.completed]: tr(
    Ci,
    rr
  ).extend(vr),
  [le.enum.pending]: tr(
    gc,
    rr
  ).extend(vr),
  [le.enum.unreceived]: tr(
    yc,
    rr
  ).extend(vr),
  [le.enum.failed]: tr(
    Tc,
    rr
  ).extend(vr),
  [le.enum.init_failed]: tr(
    Ec,
    rr
  ).extend(vr),
  [le.enum.initializing]: tr(
    mc,
    rr
  ).extend(vr)
}), JP = cr(
  "status",
  Object.values(ZP)
), KP = Ic({
  [le.enum.corrupted]: Sc,
  [le.enum.allocated]: vc,
  [le.enum.allocation_failed]: Ac,
  [le.enum.allocating]: bc,
  [le.enum.completed]: Ci,
  [le.enum.pending]: gc,
  [le.enum.unreceived]: yc,
  [le.enum.failed]: Tc,
  [le.enum.init_failed]: Ec,
  [le.enum.initializing]: mc
});
cr(
  "status",
  Object.values(KP)
);
const XP = Ic({
  [le.enum.corrupted]: Sc.partial().extend({
    jobId: A(),
    status: ce(le.enum.corrupted)
  }),
  [le.enum.allocated]: vc.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: ce(le.enum.allocated)
  }),
  [le.enum.allocation_failed]: Ac.omit({
    settings: !0
  }).partial().extend({
    jobId: A(),
    status: ce(le.enum.allocation_failed)
  }),
  [le.enum.allocating]: bc.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: ce(le.enum.allocating)
  }),
  [le.enum.completed]: Ci.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: ce(le.enum.completed)
  }),
  [le.enum.pending]: gc.omit({ settings: !0 }).partial().extend({
    jobId: A(),
    status: ce(le.enum.pending),
    settings: js.optional()
  }),
  [le.enum.unreceived]: yc.partial().extend({
    jobId: A(),
    status: ce(le.enum.unreceived)
  }),
  [le.enum.failed]: Tc.partial().extend({
    jobId: A(),
    status: ce(le.enum.failed)
  }),
  [le.enum.initializing]: mc.partial().extend({
    jobId: A(),
    status: ce(le.enum.initializing)
  }),
  [le.enum.init_failed]: Ec.partial().extend({
    jobId: A(),
    status: ce(le.enum.init_failed)
  })
});
j1(
  cr(
    "status",
    Object.values(XP)
  )
);
N({
  jobId: A(),
  allocationResults: k(cc)
});
N({
  jobId: A(),
  date: $t
});
N({
  jobs: k(JP),
  total: R()
});
const QP = N({
  id: R(),
  course: A(),
  courseTitle: A(),
  activity: A(),
  reason: A(),
  studentId: A(),
  activityId: A(),
  studentValues: k(A()),
  link: A()
}), eD = N({
  rows: k(QP),
  studentColumns: k(A())
});
N({
  content: eD,
  startTime: A()
});
const tD = N({
  key: A(),
  course: A(),
  activityType: A(),
  group: A(),
  student: A(),
  issueType: A(),
  manageStudentLink: A(),
  activityTypeId: R().optional(),
  logId: A().optional()
});
N({
  total: R(),
  data: k(tD)
});
const rD = (e) => N({
  data: e,
  status: R(),
  message: A()
});
rD(at());
N({
  objectIds: k(R().nonnegative().int()),
  useCache: oe()
});
const IT = N({
  ids: k(R().nonnegative().int()).optional(),
  typeId: R().nonnegative().int().optional().or(k(R().nonnegative().int())),
  useCache: oe().optional(),
  limit: R().nonnegative().int().optional(),
  pageSize: R().nonnegative().int().optional(),
  page: R().nonnegative().int().optional(),
  fields: k(A().or(R().nonnegative().int())).optional(),
  relations: tl.optional(),
  members: tl.optional(),
  text: A().optional(),
  category: k(dT).optional()
}), nD = IT.and(yT).superRefine(
  (e, t) => {
    var r;
    !((r = e.ids) != null && r.length) && !e.limit && !e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Limit or pageSize required when no ids are specified"
    }), e.limit && e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Do not set both limit and pageSize"
    });
  }
), iD = cr("filterMode", [
  N({
    filterMode: ce(
      "related"
      /* related */
    ),
    courseIds: k(R().int().positive()).min(1)
  }),
  N({
    filterMode: ce(
      "all"
      /* all */
    )
  })
]);
nD.and(iD);
const oD = N({
  exactSearchFields: k(dT).optional(),
  generalSearchFieldIds: k(sc).optional(),
  searchText: A().optional()
}), sD = [
  "only_selected",
  "include_linked",
  "all"
], rl = pe(sD), _T = N({
  fields: oD.optional(),
  idsToFilter: k(sc).optional(),
  relations: tl.optional(),
  filterCompleteStudents: oe().optional(),
  filterRegistrationPeriod: k(Nr).optional(),
  filterIssues: k(rT).optional(),
  filterSelectionMode: rl.optional(),
  limit: R().nonnegative().int().optional(),
  pageSize: R().nonnegative().int().optional(),
  page: R().nonnegative().int().optional()
}), aD = _T.pick({
  fields: !0,
  relations: !0,
  idsToFilter: !0,
  filterCompleteStudents: !0
}), la = _T.and(yT);
la.superRefine(
  (e, t) => {
    !e.limit && !e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Limit or pageSize required"
    }), e.limit && e.pageSize && t.issues.push({
      input: e,
      code: "custom",
      path: ["limit"],
      message: "Do not set both limit and pageSize"
    });
  }
);
N({
  objects: k(Ft),
  totalFilteredObjects: R()
});
k(
  N({ id: R(), fields: k(Vo) })
);
const uD = ["partial", "none"], _c = pe(uD);
N({
  studentInfo: aa,
  conflictControl: _c,
  overrides: lc.optional(),
  updateWaitlist: oe().optional()
});
N({
  jobId: A(),
  conflictControl: _c,
  overrides: lc.optional()
});
N({
  studentInfo: aa
});
N({ jobId: A() });
N({
  studentId: R(),
  newObjectId: R()
});
N({
  studentId: R(),
  newObjectId: R(),
  conflictControl: _c,
  overrides: lc.optional()
});
N({
  groups: dt(A(), pc)
});
N({
  summary: Lt(Ry, R())
});
Xr({
  results: k(
    N({
      status: R(),
      message: N({
        status: R(),
        message: A(),
        errorCode: R().optional()
      }).or(A()),
      memberObjectId: R().optional(),
      groupObjectId: R().optional(),
      operation: pe(["add", "remove"])
    })
  )
});
const lD = bt([ce("asc"), ce("desc")]), cD = k(Gl([A(), lD]));
N({
  skip: A().optional(),
  limit: A().optional(),
  jobId: A().optional(),
  sort: cD.optional()
});
N({
  force: oe().optional()
});
bt([
  N({
    loadCoursesProps: la,
    settings: js
  }).strict(),
  N({
    groupIds: k(R()),
    settings: js
  }).strict()
]);
N({
  jobId: A(),
  csv: oe().optional()
});
N({
  jobId: A(),
  page: R(),
  pageSize: R()
}).required();
const fD = N({
  reloadReservations: oe().optional(),
  groupIds: k(R()).optional(),
  loadCoursesProps: aD
}), dD = N({
  reloadReservations: oe().optional(),
  groupIds: k(R()).optional(),
  ids: k(R())
}), pD = N({
  reloadReservations: oe().optional(),
  groupIds: k(R())
});
bt([
  dD,
  fD,
  pD
]);
N({
  groups: Lt(A(), oT.optional()),
  coursesToUpdate: k1(nT.optional()),
  reservations: k(Ly),
  activities: Lt(A(), iT.optional()),
  studentIds: k(R())
});
bt([
  N({ loadCoursesProps: la }).strict(),
  N({
    groupIds: k(R()),
    filterSelectionMode: rl.optional()
  }).strict(),
  N({
    ids: k(R()),
    filterSelectionMode: rl.optional()
  }).strict()
]);
const hD = N({
  courses: Lt(A(), nT.optional()),
  totalFilteredCourses: R().nonnegative().int(),
  studentsRelated: Lt(A(), q1.optional()),
  groupsRelated: Lt(A(), oT.optional()),
  selectedIncompleteStudents: R().nonnegative().int(),
  activities: Lt(A(), iT.optional())
}), mD = hD.omit({
  studentsRelated: !0
}).extend({
  students: R()
});
mD.omit({
  selectedIncompleteStudents: !0
});
IT.omit({
  useCache: !0,
  typeId: !0
}).extend({
  ...pT.shape,
  groupIds: k(R()).optional(),
  numberOfStudents: R().int().nonnegative().optional(),
  filterCompleteStudents: oe().optional(),
  programIds: k(R()).optional(),
  allocationStatus: N({
    values: k(hP),
    selectedGroupId: R()
  }).optional()
});
var RT = /* @__PURE__ */ ((e) => (e.buttonClick = "button_click", e.pageView = "page_view", e))(RT || {});
N({
  event: pe(RT),
  properties: Lt(A(), bt([A(), R(), oe()])).optional()
});
const ED = N({
  groupId: R(),
  linkedIds: k(R())
});
N({
  linked: k(ED)
});
N({
  loadCoursesProps: la
});
const ca = R(), fa = R(), OT = A(), gD = A(), yD = N({
  sequence: R(),
  groupId: fa
}), TD = yD.extend({
  studentId: ca,
  trigger: OT,
  userId: gD
});
TD.extend({
  position: R()
});
N({
  studentId: ca,
  groupId: fa,
  trigger: OT
});
N({
  studentId: ca,
  groupId: fa
});
N({
  studentId: ca,
  groupId: fa
});
N({ studentId: A() });
const bD = N({
  evaluatedGroups: R(),
  allocations: R(),
  allocatedGroups: R(),
  allocatedStudents: R()
}), wT = {
  EVALUATE_WAITLIST: "eval-waitlist"
}, AD = pe(wT);
N({
  jobName: AD
});
const wo = {
  POPULATE_CACHE: "Registration - Populate Cache",
  AUTO_ALLOCATE: "Auto Allocate",
  AUTO_ALLOCATE_DAILY: "Auto Allocate Daily",
  ...wT
}, Ho = pe(
  Object.values(wo)
), vD = [
  "uninitialized",
  "pending",
  "completed",
  "failed"
], NT = pe(vD);
bt([
  NT,
  ce("timeout"),
  Yr()
]);
const en = N({
  name: Ho,
  jobId: A(),
  lastRunAt: R(),
  lastFinishedAt: R().nullable().optional(),
  status: NT
}), CT = N({
  status: R(),
  name: A(),
  message: A()
});
wo.EVALUATE_WAITLIST + "", N({
  stats: bD
}).optional().default({
  stats: {
    evaluatedGroups: 0,
    allocations: 0,
    allocatedGroups: 0,
    allocatedStudents: 0
  }
}), wo.POPULATE_CACHE + "", Yr().optional(), wo.AUTO_ALLOCATE + "", Yr().optional(), wo.AUTO_ALLOCATE_DAILY + "", Yr().optional();
en.extend({
  status: ce("uninitialized")
});
en.extend({
  status: ce("pending")
});
en.extend({
  status: ce("completed")
});
en.extend({
  status: ce("failed"),
  error: CT
});
en.partial().extend({
  name: Ho,
  jobId: A(),
  status: ce("uninitialized")
});
en.partial().extend({
  name: Ho,
  jobId: A(),
  status: ce("pending")
});
en.partial().extend({
  name: Ho,
  jobId: A(),
  status: ce("completed")
});
en.partial().extend({
  name: Ho,
  jobId: A(),
  status: ce("failed"),
  error: CT
});
const SD = UR().brand(), ID = Vl(
  (e) => typeof e == "string" ? e.replace(/^\s*bearer\s+/i, "") : e,
  SD
);
N({
  serverUrl: A().optional(),
  token: ID,
  user: xy,
  organizationId: A(),
  listOptions: N({
    limit: R(),
    page: A(),
    sortBy: A().optional()
  }).optional()
});
const _D = N({
  limitToAdminsOnly: A().default("")
});
N({
  failedLinks: k(A())
});
dt(
  A(),
  k(R())
);
const RD = ["en", "sv"], OD = pe(RD), wD = ["morning", "afternoon", "no_preference"], Yo = pe(wD), ND = N({
  studentId: R(),
  timeOfDay: Yo,
  modifiedBy: A(),
  createdAt: Qu,
  updatedAt: Qu
});
N({
  studentId: R(),
  timeOfDay: Yo
});
N({
  timeOfDay: Yo
});
const CD = N({
  key: A(),
  activityLabel: A(),
  groupName: A()
});
N({
  timeOfDay: Yo,
  updatedAtUserTime: A().optional(),
  preferredGroups: k(CD).optional()
});
N({
  studentId: A().regex(/^\d+$/, "studentId must be numeric")
});
const PD = ["create", "update", "delete"], DD = pe(PD), MD = (e) => N({
  operation: DD,
  snapshot: e,
  modifiedBy: A(),
  timestamp: Qu
});
function LD(e) {
  return MD(e);
}
LD(
  ND
).extend({
  studentId: R()
});
N({
  name: A(),
  timestamp: A(),
  timeOfDay: Yo
});
const xD = N({
  time: A(),
  operationType: A(),
  itemType: A(),
  username: A(),
  objectIds: k(R()),
  courses: k(A()),
  activities: k(A()),
  groups: k(A())
}), kD = k(xD);
N({
  history: kD,
  total: R().int().nonnegative(),
  page: R().int().positive()
});
const jD = 50;
N({
  objectId: A().regex(/^\d+$/, "objectId must be numeric")
});
N({
  current: Kf().int().positive().optional(),
  pageSize: Kf().int().positive().max(jD).optional()
});
const UD = N({
  // action
  itemType: A(),
  operationType: A(),
  // user
  changed: R().optional().nullable(),
  changedBy: A().optional().nullable(),
  // objects
  objectId: R().optional().nullable(),
  objectIds: k(R()).optional().nullable(),
  // fields and types
  typeId: R().optional().nullable(),
  fieldId: R().optional().nullable(),
  // dates
  begin: R().optional().nullable(),
  end: R().optional().nullable(),
  // props
  name: A().optional().nullable(),
  value: A().optional().nullable(),
  // availability
  availabilityTypeId: R().optional().nullable()
});
N({
  objectId: R(),
  idFormat: ce("INTERNAL"),
  sort: pe(["ASC", "DESC"]),
  page: R(),
  limit: R(),
  skipNoChanged: oe().optional(),
  itemTypes: k(
    pe([
      "MEMBER",
      "RELATION",
      "OPTIONAL_RELATION",
      "AVAILABILITY_RELATION",
      "FIELD",
      "TYPE",
      "PROPERTY",
      "NONE"
    ])
  ).optional()
});
fr(UD);
const cs = {
  displayName: A().optional()
}, ct = cr("type", [
  N({
    ...cs,
    type: ce("reservation"),
    // Single numerical string
    value: A().regex(/^\d+$/)
  }),
  N({
    ...cs,
    type: ce("object-field"),
    // Two numerical strings joined by a dash
    value: A().regex(/^\d+-\d+$/)
  }),
  N({
    ...cs,
    type: ce("text"),
    value: A()
  }),
  N({
    ...cs,
    type: ce("unmapped")
  })
]), Mh = ct.and(N({ label: A() })), $D = N({
  absoluteStartTime: R().optional(),
  absoluteEndTime: R().optional(),
  relativeStartTime: R().optional(),
  relativeEndTime: R().optional()
}), FD = N({
  datelimit: $D.optional(),
  module: N({
    name: ct.optional(),
    code: ct.optional()
  }).optional(),
  location: N({
    room: ct.optional(),
    building: ct.optional(),
    campus: ct.optional(),
    type: ct.optional(),
    map: ct.optional(),
    image: ct.optional(),
    equipment: ct.optional(),
    onlineMeetingLink: ct.optional(),
    extraFields: k(Mh).optional()
  }).optional(),
  digitalResources: N({
    recording: ct.optional(),
    lmsLink: ct.optional()
  }).optional(),
  staff: N({
    name: ct.optional()
  }).optional(),
  activity: N({
    displayName: ct.optional(),
    alternativeTitle: ct.optional()
  }).optional(),
  messageToStudent: ct.optional(),
  extraFields: k(Mh).optional(),
  updatedBy: A().optional(),
  updatedAt: mO().optional(),
  reservationStatuses: k(pe(Ae.EReservationStatuses)).optional(),
  reservationMode: R().optional()
}), zD = N({
  enabled: oe(),
  path: A().optional(),
  page: A().optional()
});
N({
  studentReservationDisplaySettings: FD.optional(),
  studentSubscribeSettings: zD.optional()
});
const GD = ["exam"], BD = pe(GD), VD = N({
  message: A(),
  errorName: ra.catch(ue.Error)
}), WD = N({
  source: BD,
  reason: A(),
  /**
   * Ids of the entities the degradation affected, in whatever terms are
   * natural to `source`. Empty `subjects` might mean the entities could
   * not be identified, and is not the same as none affected.
   */
  subjects: k(R()).optional(),
  /** The status the underlying error maps to; absent when nothing was thrown. */
  status: R().int().optional(),
  /** The underlying error, reduced to the fields safe to send to a client. */
  error: VD.optional()
}), PT = {
  failures: k(WD).optional(),
  logId: A().optional()
};
cr("direction", [
  N({
    direction: ce("initial")
  }),
  N({
    direction: ce("next"),
    from: R().int().positive()
  }),
  N({
    direction: ce("previous"),
    from: R().int().positive()
  }),
  N({
    direction: ce("full")
  })
]);
N({
  results: k(As.nullable()),
  /** Page number to pass as `from` on the next forward request, or null when the forward side is exhausted. */
  nextFrom: R().int().nullable(),
  /** Page number to pass as `from` on the next backward request, or null when the backward side is exhausted or the backward range is empty. */
  previousFrom: R().int().nullable(),
  userTodayLocal: A(),
  subscribeEnabled: oe(),
  datelimitText: N({
    before: $t,
    after: $t
  }).optional(),
  ...PT
});
const qD = N({
  key: R(),
  title: A().optional(),
  subtitle: A(),
  allDay: oe().optional(),
  start: As.shape.begin,
  end: As.shape.end,
  location: As.shape.location
});
N({
  results: k(qD.nullable()),
  ...PT
});
N({
  appleURL: A(),
  googleURL: A(),
  rawURL: A()
});
const HD = pe(["TE_HUB", "TE_EXAM_V3"]), YD = N({
  examReservationMode: R().optional()
});
N({
  reservationSettings: YD.optional()
});
N({
  date: N({
    startDate: R().int().optional(),
    // epoch seconds
    endDate: R().int().optional()
    // epoch seconds
  }).refine(
    (e) => e.startDate === void 0 || e.endDate === void 0 || e.endDate >= e.startDate,
    {
      message: "endDate must not be before startDate",
      path: ["endDate"]
    }
  ).optional(),
  ids: k(R().int().positive()).min(1).max(oh).optional(),
  settingsSource: HD,
  page: R().int().min(1).optional(),
  limit: R().int().min(1).max(oh).optional()
}).refine((e) => e.date !== void 0 != (e.ids !== void 0), {
  message: "Exactly one of date or ids must be given"
});
const fs = Uy(A()), ZD = N({
  id: R(),
  start: A(),
  end: A(),
  lastModified: A(),
  examName: A(),
  examType: A(),
  location: fs(A()),
  seatNo: fs(A().nullable()),
  fields: k(
    fs(A()).and(
      N({
        label: A(),
        type: A().optional()
      })
    )
  ),
  information: k(
    fs(
      N({
        title: A().optional(),
        type: pe(["error", "warning", "info"]).optional(),
        value: A()
      })
    )
  )
});
N({
  results: k(ZD),
  limit: R(),
  page: R(),
  totalPages: R(),
  totalResults: R(),
  examReservationMode: R().optional()
});
const e4 = {
  [ue.MaximumMembershipReachedError]: -2306,
  [ue.MaximumMembershipReachedByTypeError]: -2307,
  [ue.PermissionError]: [-2005, -2006, -2300, -2310, -2401]
};
var JD = /* @__PURE__ */ ((e) => (e[e.Courses = 0] = "Courses", e[e.Activities = 1] = "Activities", e[e.StudentSetGroups = 2] = "StudentSetGroups", e))(JD || {}), DT = typeof global == "object" && global && global.Object === Object && global, KD = typeof self == "object" && self && self.Object === Object && self, Ur = DT || KD || Function("return this")(), ur = Ur.Symbol, MT = Object.prototype, XD = MT.hasOwnProperty, QD = MT.toString, fo = ur ? ur.toStringTag : void 0;
function eM(e) {
  var t = XD.call(e, fo), r = e[fo];
  try {
    e[fo] = void 0;
    var n = !0;
  } catch {
  }
  var i = QD.call(e);
  return n && (t ? e[fo] = r : delete e[fo]), i;
}
var tM = Object.prototype, rM = tM.toString;
function nM(e) {
  return rM.call(e);
}
var iM = "[object Null]", oM = "[object Undefined]", Lh = ur ? ur.toStringTag : void 0;
function tn(e) {
  return e == null ? e === void 0 ? oM : iM : Lh && Lh in Object(e) ? eM(e) : nM(e);
}
function Mr(e) {
  return e != null && typeof e == "object";
}
var sM = "[object Symbol]";
function da(e) {
  return typeof e == "symbol" || Mr(e) && tn(e) == sM;
}
function LT(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var Vt = Array.isArray, xh = ur ? ur.prototype : void 0, kh = xh ? xh.toString : void 0;
function xT(e) {
  if (typeof e == "string")
    return e;
  if (Vt(e))
    return LT(e, xT) + "";
  if (da(e))
    return kh ? kh.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var aM = /\s/;
function uM(e) {
  for (var t = e.length; t-- && aM.test(e.charAt(t)); )
    ;
  return t;
}
var lM = /^\s+/;
function cM(e) {
  return e && e.slice(0, uM(e) + 1).replace(lM, "");
}
function Ai(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var jh = NaN, fM = /^[-+]0x[0-9a-f]+$/i, dM = /^0b[01]+$/i, pM = /^0o[0-7]+$/i, hM = parseInt;
function mM(e) {
  if (typeof e == "number")
    return e;
  if (da(e))
    return jh;
  if (Ai(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ai(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = cM(e);
  var r = dM.test(e);
  return r || pM.test(e) ? hM(e.slice(2), r ? 2 : 8) : fM.test(e) ? jh : +e;
}
var Uh = 1 / 0, EM = 17976931348623157e292;
function gM(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = mM(e), e === Uh || e === -Uh) {
    var t = e < 0 ? -1 : 1;
    return t * EM;
  }
  return e === e ? e : 0;
}
function yM(e) {
  var t = gM(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
function Rc(e) {
  return e;
}
var TM = "[object AsyncFunction]", bM = "[object Function]", AM = "[object GeneratorFunction]", vM = "[object Proxy]";
function kT(e) {
  if (!Ai(e))
    return !1;
  var t = tn(e);
  return t == bM || t == AM || t == TM || t == vM;
}
var Fa = Ur["__core-js_shared__"], $h = (function() {
  var e = /[^.]+$/.exec(Fa && Fa.keys && Fa.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function SM(e) {
  return !!$h && $h in e;
}
var IM = Function.prototype, _M = IM.toString;
function qn(e) {
  if (e != null) {
    try {
      return _M.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var RM = /[\\^$.*+?()[\]{}|]/g, OM = /^\[object .+?Constructor\]$/, wM = Function.prototype, NM = Object.prototype, CM = wM.toString, PM = NM.hasOwnProperty, DM = RegExp(
  "^" + CM.call(PM).replace(RM, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function MM(e) {
  if (!Ai(e) || SM(e))
    return !1;
  var t = kT(e) ? DM : OM;
  return t.test(qn(e));
}
function LM(e, t) {
  return e == null ? void 0 : e[t];
}
function Hn(e, t) {
  var r = LM(e, t);
  return MM(r) ? r : void 0;
}
var nl = Hn(Ur, "WeakMap");
function xM(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function kM() {
}
var jM = 800, UM = 16, $M = Date.now;
function FM(e) {
  var t = 0, r = 0;
  return function() {
    var n = $M(), i = UM - (n - r);
    if (r = n, i > 0) {
      if (++t >= jM)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function zM(e) {
  return function() {
    return e;
  };
}
var Us = (function() {
  try {
    var e = Hn(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), GM = Us ? function(e, t) {
  return Us(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: zM(t),
    writable: !0
  });
} : Rc, BM = FM(GM);
function VM(e, t, r, n) {
  for (var i = e.length, o = r + -1; ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function WM(e) {
  return e !== e;
}
function qM(e, t, r) {
  for (var n = r - 1, i = e.length; ++n < i; )
    if (e[n] === t)
      return n;
  return -1;
}
function HM(e, t, r) {
  return t === t ? qM(e, t, r) : VM(e, WM, r);
}
function jT(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && HM(e, t, 0) > -1;
}
var YM = 9007199254740991, ZM = /^(?:0|[1-9]\d*)$/;
function UT(e, t) {
  var r = typeof e;
  return t = t ?? YM, !!t && (r == "number" || r != "symbol" && ZM.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function JM(e, t, r) {
  t == "__proto__" && Us ? Us(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function $T(e, t) {
  return e === t || e !== e && t !== t;
}
var Fh = Math.max;
function KM(e, t, r) {
  return t = Fh(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, i = -1, o = Fh(n.length - t, 0), s = Array(o); ++i < o; )
      s[i] = n[t + i];
    i = -1;
    for (var a = Array(t + 1); ++i < t; )
      a[i] = n[i];
    return a[t] = r(s), xM(e, this, a);
  };
}
function Oc(e, t) {
  return BM(KM(e, t, Rc), e + "");
}
var XM = 9007199254740991;
function wc(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= XM;
}
function pa(e) {
  return e != null && wc(e.length) && !kT(e);
}
var QM = Object.prototype;
function eL(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || QM;
  return e === r;
}
function tL(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var rL = "[object Arguments]";
function zh(e) {
  return Mr(e) && tn(e) == rL;
}
var FT = Object.prototype, nL = FT.hasOwnProperty, iL = FT.propertyIsEnumerable, Nc = zh(/* @__PURE__ */ (function() {
  return arguments;
})()) ? zh : function(e) {
  return Mr(e) && nL.call(e, "callee") && !iL.call(e, "callee");
};
function oL() {
  return !1;
}
var zT = typeof exports == "object" && exports && !exports.nodeType && exports, Gh = zT && typeof module == "object" && module && !module.nodeType && module, sL = Gh && Gh.exports === zT, Bh = sL ? Ur.Buffer : void 0, aL = Bh ? Bh.isBuffer : void 0, il = aL || oL, uL = "[object Arguments]", lL = "[object Array]", cL = "[object Boolean]", fL = "[object Date]", dL = "[object Error]", pL = "[object Function]", hL = "[object Map]", mL = "[object Number]", EL = "[object Object]", gL = "[object RegExp]", yL = "[object Set]", TL = "[object String]", bL = "[object WeakMap]", AL = "[object ArrayBuffer]", vL = "[object DataView]", SL = "[object Float32Array]", IL = "[object Float64Array]", _L = "[object Int8Array]", RL = "[object Int16Array]", OL = "[object Int32Array]", wL = "[object Uint8Array]", NL = "[object Uint8ClampedArray]", CL = "[object Uint16Array]", PL = "[object Uint32Array]", qe = {};
qe[SL] = qe[IL] = qe[_L] = qe[RL] = qe[OL] = qe[wL] = qe[NL] = qe[CL] = qe[PL] = !0;
qe[uL] = qe[lL] = qe[AL] = qe[cL] = qe[vL] = qe[fL] = qe[dL] = qe[pL] = qe[hL] = qe[mL] = qe[EL] = qe[gL] = qe[yL] = qe[TL] = qe[bL] = !1;
function DL(e) {
  return Mr(e) && wc(e.length) && !!qe[tn(e)];
}
function ML(e) {
  return function(t) {
    return e(t);
  };
}
var GT = typeof exports == "object" && exports && !exports.nodeType && exports, Mo = GT && typeof module == "object" && module && !module.nodeType && module, LL = Mo && Mo.exports === GT, za = LL && DT.process, Vh = (function() {
  try {
    var e = Mo && Mo.require && Mo.require("util").types;
    return e || za && za.binding && za.binding("util");
  } catch {
  }
})(), Wh = Vh && Vh.isTypedArray, BT = Wh ? ML(Wh) : DL, xL = Object.prototype, kL = xL.hasOwnProperty;
function jL(e, t) {
  var r = Vt(e), n = !r && Nc(e), i = !r && !n && il(e), o = !r && !n && !i && BT(e), s = r || n || i || o, a = s ? tL(e.length, String) : [], l = a.length;
  for (var f in e)
    kL.call(e, f) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    UT(f, l))) && a.push(f);
  return a;
}
function UL(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var $L = UL(Object.keys, Object), FL = Object.prototype, zL = FL.hasOwnProperty;
function VT(e) {
  if (!eL(e))
    return $L(e);
  var t = [];
  for (var r in Object(e))
    zL.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Cc(e) {
  return pa(e) ? jL(e) : VT(e);
}
var GL = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, BL = /^\w*$/;
function Pc(e, t) {
  if (Vt(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || da(e) ? !0 : BL.test(e) || !GL.test(e) || t != null && e in Object(t);
}
var $o = Hn(Object, "create");
function VL() {
  this.__data__ = $o ? $o(null) : {}, this.size = 0;
}
function WL(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var qL = "__lodash_hash_undefined__", HL = Object.prototype, YL = HL.hasOwnProperty;
function ZL(e) {
  var t = this.__data__;
  if ($o) {
    var r = t[e];
    return r === qL ? void 0 : r;
  }
  return YL.call(t, e) ? t[e] : void 0;
}
var JL = Object.prototype, KL = JL.hasOwnProperty;
function XL(e) {
  var t = this.__data__;
  return $o ? t[e] !== void 0 : KL.call(t, e);
}
var QL = "__lodash_hash_undefined__";
function ex(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = $o && t === void 0 ? QL : t, this;
}
function Fn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Fn.prototype.clear = VL;
Fn.prototype.delete = WL;
Fn.prototype.get = ZL;
Fn.prototype.has = XL;
Fn.prototype.set = ex;
function tx() {
  this.__data__ = [], this.size = 0;
}
function ha(e, t) {
  for (var r = e.length; r--; )
    if ($T(e[r][0], t))
      return r;
  return -1;
}
var rx = Array.prototype, nx = rx.splice;
function ix(e) {
  var t = this.__data__, r = ha(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : nx.call(t, r, 1), --this.size, !0;
}
function ox(e) {
  var t = this.__data__, r = ha(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function sx(e) {
  return ha(this.__data__, e) > -1;
}
function ax(e, t) {
  var r = this.__data__, n = ha(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function $r(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
$r.prototype.clear = tx;
$r.prototype.delete = ix;
$r.prototype.get = ox;
$r.prototype.has = sx;
$r.prototype.set = ax;
var Fo = Hn(Ur, "Map");
function ux() {
  this.size = 0, this.__data__ = {
    hash: new Fn(),
    map: new (Fo || $r)(),
    string: new Fn()
  };
}
function lx(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ma(e, t) {
  var r = e.__data__;
  return lx(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function cx(e) {
  var t = ma(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function fx(e) {
  return ma(this, e).get(e);
}
function dx(e) {
  return ma(this, e).has(e);
}
function px(e, t) {
  var r = ma(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Fr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Fr.prototype.clear = ux;
Fr.prototype.delete = cx;
Fr.prototype.get = fx;
Fr.prototype.has = dx;
Fr.prototype.set = px;
var hx = "Expected a function";
function Dc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(hx);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, n);
    return r.cache = o.set(i, s) || o, s;
  };
  return r.cache = new (Dc.Cache || Fr)(), r;
}
Dc.Cache = Fr;
var mx = 500;
function Ex(e) {
  var t = Dc(e, function(n) {
    return r.size === mx && r.clear(), n;
  }), r = t.cache;
  return t;
}
var gx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, yx = /\\(\\)?/g, Tx = Ex(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(gx, function(r, n, i, o) {
    t.push(i ? o.replace(yx, "$1") : n || r);
  }), t;
});
function bx(e) {
  return e == null ? "" : xT(e);
}
function WT(e, t) {
  return Vt(e) ? e : Pc(e, t) ? [e] : Tx(bx(e));
}
function Ea(e) {
  if (typeof e == "string" || da(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function qT(e, t) {
  t = WT(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Ea(t[r++])];
  return r && r == n ? e : void 0;
}
function Ax(e, t, r) {
  var n = e == null ? void 0 : qT(e, t);
  return n === void 0 ? r : n;
}
function HT(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
var qh = ur ? ur.isConcatSpreadable : void 0;
function vx(e) {
  return Vt(e) || Nc(e) || !!(qh && e && e[qh]);
}
function YT(e, t, r, n, i) {
  var o = -1, s = e.length;
  for (r || (r = vx), i || (i = []); ++o < s; ) {
    var a = e[o];
    r(a) && HT(i, a);
  }
  return i;
}
var Sx = "\\ud800-\\udfff", Ix = "\\u0300-\\u036f", _x = "\\ufe20-\\ufe2f", Rx = "\\u20d0-\\u20ff", Ox = Ix + _x + Rx, wx = "\\ufe0e\\ufe0f", Nx = "\\u200d", Cx = RegExp("[" + Nx + Sx + Ox + wx + "]");
function Px(e) {
  return Cx.test(e);
}
function Dx() {
  this.__data__ = new $r(), this.size = 0;
}
function Mx(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Lx(e) {
  return this.__data__.get(e);
}
function xx(e) {
  return this.__data__.has(e);
}
var kx = 200;
function jx(e, t) {
  var r = this.__data__;
  if (r instanceof $r) {
    var n = r.__data__;
    if (!Fo || n.length < kx - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Fr(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Pr(e) {
  var t = this.__data__ = new $r(e);
  this.size = t.size;
}
Pr.prototype.clear = Dx;
Pr.prototype.delete = Mx;
Pr.prototype.get = Lx;
Pr.prototype.has = xx;
Pr.prototype.set = jx;
function Ux(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, o = []; ++r < n; ) {
    var s = e[r];
    t(s, r, e) && (o[i++] = s);
  }
  return o;
}
function $x() {
  return [];
}
var Fx = Object.prototype, zx = Fx.propertyIsEnumerable, Hh = Object.getOwnPropertySymbols, Gx = Hh ? function(e) {
  return e == null ? [] : (e = Object(e), Ux(Hh(e), function(t) {
    return zx.call(e, t);
  }));
} : $x;
function Bx(e, t, r) {
  var n = t(e);
  return Vt(e) ? n : HT(n, r(e));
}
function Yh(e) {
  return Bx(e, Cc, Gx);
}
var ol = Hn(Ur, "DataView"), sl = Hn(Ur, "Promise"), pi = Hn(Ur, "Set"), Zh = "[object Map]", Vx = "[object Object]", Jh = "[object Promise]", Kh = "[object Set]", Xh = "[object WeakMap]", Qh = "[object DataView]", Wx = qn(ol), qx = qn(Fo), Hx = qn(sl), Yx = qn(pi), Zx = qn(nl), wr = tn;
(ol && wr(new ol(new ArrayBuffer(1))) != Qh || Fo && wr(new Fo()) != Zh || sl && wr(sl.resolve()) != Jh || pi && wr(new pi()) != Kh || nl && wr(new nl()) != Xh) && (wr = function(e) {
  var t = tn(e), r = t == Vx ? e.constructor : void 0, n = r ? qn(r) : "";
  if (n)
    switch (n) {
      case Wx:
        return Qh;
      case qx:
        return Zh;
      case Hx:
        return Jh;
      case Yx:
        return Kh;
      case Zx:
        return Xh;
    }
  return t;
});
var em = Ur.Uint8Array, Jx = "__lodash_hash_undefined__";
function Kx(e) {
  return this.__data__.set(e, Jx), this;
}
function Xx(e) {
  return this.__data__.has(e);
}
function vi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Fr(); ++t < r; )
    this.add(e[t]);
}
vi.prototype.add = vi.prototype.push = Kx;
vi.prototype.has = Xx;
function Qx(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function $s(e, t) {
  return e.has(t);
}
var ek = 1, tk = 2;
function ZT(e, t, r, n, i, o) {
  var s = r & ek, a = e.length, l = t.length;
  if (a != l && !(s && l > a))
    return !1;
  var f = o.get(e), u = o.get(t);
  if (f && u)
    return f == t && u == e;
  var h = -1, E = !0, d = r & tk ? new vi() : void 0;
  for (o.set(e, t), o.set(t, e); ++h < a; ) {
    var g = e[h], y = t[h];
    if (n)
      var b = s ? n(y, g, h, t, e, o) : n(g, y, h, e, t, o);
    if (b !== void 0) {
      if (b)
        continue;
      E = !1;
      break;
    }
    if (d) {
      if (!Qx(t, function(I, S) {
        if (!$s(d, S) && (g === I || i(g, I, r, n, o)))
          return d.push(S);
      })) {
        E = !1;
        break;
      }
    } else if (!(g === y || i(g, y, r, n, o))) {
      E = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), E;
}
function rk(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
function Mc(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var nk = 1, ik = 2, ok = "[object Boolean]", sk = "[object Date]", ak = "[object Error]", uk = "[object Map]", lk = "[object Number]", ck = "[object RegExp]", fk = "[object Set]", dk = "[object String]", pk = "[object Symbol]", hk = "[object ArrayBuffer]", mk = "[object DataView]", tm = ur ? ur.prototype : void 0, Ga = tm ? tm.valueOf : void 0;
function Ek(e, t, r, n, i, o, s) {
  switch (r) {
    case mk:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case hk:
      return !(e.byteLength != t.byteLength || !o(new em(e), new em(t)));
    case ok:
    case sk:
    case lk:
      return $T(+e, +t);
    case ak:
      return e.name == t.name && e.message == t.message;
    case ck:
    case dk:
      return e == t + "";
    case uk:
      var a = rk;
    case fk:
      var l = n & nk;
      if (a || (a = Mc), e.size != t.size && !l)
        return !1;
      var f = s.get(e);
      if (f)
        return f == t;
      n |= ik, s.set(e, t);
      var u = ZT(a(e), a(t), n, i, o, s);
      return s.delete(e), u;
    case pk:
      if (Ga)
        return Ga.call(e) == Ga.call(t);
  }
  return !1;
}
var gk = 1, yk = Object.prototype, Tk = yk.hasOwnProperty;
function bk(e, t, r, n, i, o) {
  var s = r & gk, a = Yh(e), l = a.length, f = Yh(t), u = f.length;
  if (l != u && !s)
    return !1;
  for (var h = l; h--; ) {
    var E = a[h];
    if (!(s ? E in t : Tk.call(t, E)))
      return !1;
  }
  var d = o.get(e), g = o.get(t);
  if (d && g)
    return d == t && g == e;
  var y = !0;
  o.set(e, t), o.set(t, e);
  for (var b = s; ++h < l; ) {
    E = a[h];
    var I = e[E], S = t[E];
    if (n)
      var w = s ? n(S, I, E, t, e, o) : n(I, S, E, e, t, o);
    if (!(w === void 0 ? I === S || i(I, S, r, n, o) : w)) {
      y = !1;
      break;
    }
    b || (b = E == "constructor");
  }
  if (y && !b) {
    var P = e.constructor, _ = t.constructor;
    P != _ && "constructor" in e && "constructor" in t && !(typeof P == "function" && P instanceof P && typeof _ == "function" && _ instanceof _) && (y = !1);
  }
  return o.delete(e), o.delete(t), y;
}
var Ak = 1, rm = "[object Arguments]", nm = "[object Array]", ds = "[object Object]", vk = Object.prototype, im = vk.hasOwnProperty;
function Sk(e, t, r, n, i, o) {
  var s = Vt(e), a = Vt(t), l = s ? nm : wr(e), f = a ? nm : wr(t);
  l = l == rm ? ds : l, f = f == rm ? ds : f;
  var u = l == ds, h = f == ds, E = l == f;
  if (E && il(e)) {
    if (!il(t))
      return !1;
    s = !0, u = !1;
  }
  if (E && !u)
    return o || (o = new Pr()), s || BT(e) ? ZT(e, t, r, n, i, o) : Ek(e, t, l, r, n, i, o);
  if (!(r & Ak)) {
    var d = u && im.call(e, "__wrapped__"), g = h && im.call(t, "__wrapped__");
    if (d || g) {
      var y = d ? e.value() : e, b = g ? t.value() : t;
      return o || (o = new Pr()), i(y, b, r, n, o);
    }
  }
  return E ? (o || (o = new Pr()), bk(e, t, r, n, i, o)) : !1;
}
function ga(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !Mr(e) && !Mr(t) ? e !== e && t !== t : Sk(e, t, r, n, ga, i);
}
var Ik = 1, _k = 2;
function Rk(e, t, r, n) {
  var i = r.length, o = i;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = r[i];
    if (s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = r[i];
    var a = s[0], l = e[a], f = s[1];
    if (s[2]) {
      if (l === void 0 && !(a in e))
        return !1;
    } else {
      var u = new Pr(), h;
      if (!(h === void 0 ? ga(f, l, Ik | _k, n, u) : h))
        return !1;
    }
  }
  return !0;
}
function JT(e) {
  return e === e && !Ai(e);
}
function Ok(e) {
  for (var t = Cc(e), r = t.length; r--; ) {
    var n = t[r], i = e[n];
    t[r] = [n, i, JT(i)];
  }
  return t;
}
function KT(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function wk(e) {
  var t = Ok(e);
  return t.length == 1 && t[0][2] ? KT(t[0][0], t[0][1]) : function(r) {
    return r === e || Rk(r, e, t);
  };
}
function Nk(e, t) {
  return e != null && t in Object(e);
}
function Ck(e, t, r) {
  t = WT(t, e);
  for (var n = -1, i = t.length, o = !1; ++n < i; ) {
    var s = Ea(t[n]);
    if (!(o = e != null && r(e, s)))
      break;
    e = e[s];
  }
  return o || ++n != i ? o : (i = e == null ? 0 : e.length, !!i && wc(i) && UT(s, i) && (Vt(e) || Nc(e)));
}
function Pk(e, t) {
  return e != null && Ck(e, t, Nk);
}
var Dk = 1, Mk = 2;
function Lk(e, t) {
  return Pc(e) && JT(t) ? KT(Ea(e), t) : function(r) {
    var n = Ax(r, e);
    return n === void 0 && n === t ? Pk(r, e) : ga(t, n, Dk | Mk);
  };
}
function XT(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function xk(e) {
  return function(t) {
    return qT(t, e);
  };
}
function kk(e) {
  return Pc(e) ? XT(Ea(e)) : xk(e);
}
function Lc(e) {
  return typeof e == "function" ? e : e == null ? Rc : typeof e == "object" ? Vt(e) ? Lk(e[0], e[1]) : wk(e) : kk(e);
}
function jk(e, t, r, n) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; ) {
    var s = e[i];
    t(n, s, r(s), e);
  }
  return n;
}
function Uk(e) {
  return function(t, r, n) {
    for (var i = -1, o = Object(t), s = n(t), a = s.length; a--; ) {
      var l = s[++i];
      if (r(o[l], l, o) === !1)
        break;
    }
    return t;
  };
}
var $k = Uk();
function Fk(e, t) {
  return e && $k(e, t, Cc);
}
function zk(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!pa(r))
      return e(r, n);
    for (var i = r.length, o = -1, s = Object(r); ++o < i && n(s[o], o, s) !== !1; )
      ;
    return r;
  };
}
var Gk = zk(Fk);
function Bk(e, t, r, n) {
  return Gk(e, function(i, o, s) {
    t(n, i, r(i), s);
  }), n;
}
function Vk(e, t) {
  return function(r, n) {
    var i = Vt(r) ? jk : Bk, o = {};
    return i(r, e, Lc(n), o);
  };
}
function Fs(e) {
  return Mr(e) && pa(e);
}
function Wk(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var qk = "[object String]";
function Hk(e) {
  return typeof e == "string" || !Vt(e) && Mr(e) && tn(e) == qk;
}
var Yk = Math.min;
function Zk(e, t, r) {
  for (var n = jT, i = e[0].length, o = e.length, s = o, a = Array(o), l = 1 / 0, f = []; s--; ) {
    var u = e[s];
    l = Yk(u.length, l), a[s] = i >= 120 && u.length >= 120 ? new vi(s && u) : void 0;
  }
  u = e[0];
  var h = -1, E = a[0];
  e:
    for (; ++h < i && f.length < l; ) {
      var d = u[h], g = d;
      if (d = d !== 0 ? d : 0, !(E ? $s(E, g) : n(f, g))) {
        for (s = o; --s; ) {
          var y = a[s];
          if (!(y ? $s(y, g) : n(e[s], g)))
            continue e;
        }
        E && E.push(g), f.push(d);
      }
    }
  return f;
}
function Jk(e) {
  return Fs(e) ? e : [];
}
var Kk = Oc(function(e) {
  var t = LT(e, Jk);
  return t.length && t[0] === e[0] ? Zk(t) : [];
});
function Xk(e, t) {
  return ga(e, t);
}
function Qk(e) {
  return typeof e == "number" && e == yM(e);
}
var ej = "[object Number]";
function tj(e) {
  return typeof e == "number" || Mr(e) && tn(e) == ej;
}
var rj = Vk(function(e, t, r) {
  JM(e, r, t);
}), nj = XT("length"), QT = "\\ud800-\\udfff", ij = "\\u0300-\\u036f", oj = "\\ufe20-\\ufe2f", sj = "\\u20d0-\\u20ff", aj = ij + oj + sj, uj = "\\ufe0e\\ufe0f", lj = "[" + QT + "]", al = "[" + aj + "]", ul = "\\ud83c[\\udffb-\\udfff]", cj = "(?:" + al + "|" + ul + ")", eb = "[^" + QT + "]", tb = "(?:\\ud83c[\\udde6-\\uddff]){2}", rb = "[\\ud800-\\udbff][\\udc00-\\udfff]", fj = "\\u200d", nb = cj + "?", ib = "[" + uj + "]?", dj = "(?:" + fj + "(?:" + [eb, tb, rb].join("|") + ")" + ib + nb + ")*", pj = ib + nb + dj, hj = "(?:" + [eb + al + "?", al, tb, rb, lj].join("|") + ")", om = RegExp(ul + "(?=" + ul + ")|" + hj + pj, "g");
function mj(e) {
  for (var t = om.lastIndex = 0; om.test(e); )
    ++t;
  return t;
}
function Ej(e) {
  return Px(e) ? mj(e) : nj(e);
}
var gj = "[object Map]", yj = "[object Set]";
function Tj(e) {
  if (e == null)
    return 0;
  if (pa(e))
    return Hk(e) ? Ej(e) : e.length;
  var t = wr(e);
  return t == gj || t == yj ? e.size : VT(e).length;
}
var bj = 1 / 0, Aj = pi && 1 / Mc(new pi([, -0]))[1] == bj ? function(e) {
  return new pi(e);
} : kM, vj = 200;
function ya(e, t, r) {
  var n = -1, i = jT, o = e.length, s = !0, a = [], l = a;
  if (o >= vj) {
    var f = t ? null : Aj(e);
    if (f)
      return Mc(f);
    s = !1, i = $s, l = new vi();
  } else
    l = t ? [] : a;
  e:
    for (; ++n < o; ) {
      var u = e[n], h = t ? t(u) : u;
      if (u = u !== 0 ? u : 0, s && h === h) {
        for (var E = l.length; E--; )
          if (l[E] === h)
            continue e;
        t && l.push(h), a.push(u);
      } else i(l, h, r) || (l !== a && l.push(h), a.push(u));
    }
  return a;
}
var ob = Oc(function(e) {
  return ya(YT(e, 1, Fs));
}), sb = Oc(function(e) {
  var t = Wk(e);
  return Fs(t) && (t = void 0), ya(YT(e, 1, Fs), Lc(t));
});
function zn(e) {
  return e && e.length ? ya(e) : [];
}
function Sj(e, t) {
  return e && e.length ? ya(e, Lc(t)) : [];
}
function zs(e) {
  return ye(e) && "fields" in e && xe(e.fields) && e.fields.some((t) => ye(t) && "fieldId" in t);
}
function xc(e) {
  return ye(e) && "object" in e && ye(e.object);
}
function Ij(e) {
  return ye(e) && "teObject" in e && ye(e.teObject);
}
function sm(e) {
  return ye(e) && "types" in e && xe(e.types) && e.types.some((t) => Je(t));
}
function _j(e) {
  return ye(e) && "members" in e && xe(e.members) && e.members.some((t) => ye(t) && "objectId" in t);
}
function ab(e) {
  return ye(e) && "relations" in e && xe(e.relations) && e.relations.some((t) => ye(t) && "objectIds" in t);
}
function t4(e) {
  return pt(e) ? _y.includes(e) : !1;
}
function Rj(e) {
  const t = e;
  return typeof e != "object" || !D(e) ? !1 : "id" in t && "value" in t && Je(t.id) && pt(t.value);
}
function Oj(e) {
  const t = e;
  return typeof e != "object" || !D(e) ? !1 : "id" in t && !("value" in t) && Je(t.id);
}
function wj(...e) {
  const t = e.join("");
  let r = 0;
  for (let n = 0; n < t.length; n++) {
    const i = t.charCodeAt(n);
    r = (r << 5) + r + i, r = r >>> 0;
  }
  return r;
}
function Nj(e) {
  return ub(/* @__PURE__ */ new Set(), e);
}
function ub(e, t) {
  var n;
  const r = (i) => {
    var o;
    (o = i.relations) == null || o.forEach((s) => {
      s.objectIds.forEach((a) => e.add(a));
    });
  };
  if (xe(t))
    t.forEach((i) => r(i));
  else if (ye(t) && ab(t))
    r(t);
  else
    for (const i in t) {
      const o = (n = t[Number(i)]) == null ? void 0 : n.object;
      D(o) && r(o);
    }
  return e;
}
function r4(e) {
  return ub(lb(e), e);
}
function Cj(e) {
  return Array.from(Nj(e));
}
function lb(e) {
  var n;
  const t = /* @__PURE__ */ new Set(), r = (i) => {
    var o;
    (o = i.members) == null || o.forEach((s) => {
      t.add(s.objectId);
    });
  };
  if (xe(e))
    e.forEach((i) => r(i));
  else if (ye(e) && _j(e))
    r(e);
  else
    for (const i in e) {
      const o = (n = e[Number(i)]) == null ? void 0 : n.object;
      D(o) && r(o);
    }
  return t;
}
function n4(e) {
  return Array.from(lb(e));
}
function am(e, t) {
  return sb(e, t, (r) => r == null ? void 0 : r.id).filter(D);
}
const Pj = (e, t) => sb(t, e, (r) => r.fieldId), i4 = (e, t) => ({
  ...e,
  fields: Pj(e.fields, t)
});
function o4(e) {
  return Sj(e, "id");
}
function s4(e, t = (r) => r.id) {
  if (xe(e))
    return e.map(t);
  const r = [];
  for (const n in e) {
    const i = e[Number(n)];
    D(i) && r.push(t(i));
  }
  return r;
}
function a4(e, t) {
  var i;
  const r = new Set(t), n = (o) => o.relations.flatMap((s) => s.objectIds).some((s) => r.has(s));
  if (xe(e))
    return e.find(n);
  if (ye(e) && ab(e))
    return n(e) ? e : void 0;
  for (const o in e) {
    const s = (i = e[Number(o)]) == null ? void 0 : i.object;
    if (D(s) && n(s))
      return s;
  }
}
function um(e) {
  return isFinite(e) ? Math.round(e) : 0;
}
function u4(e) {
  return D(e) && Qk(e) && e > 0;
}
function l4(e, t) {
  const r = {};
  for (const n in e) {
    const i = e[n];
    t(i, n) && (r[n] = i);
  }
  return r;
}
function c4(e, t) {
  const r = [];
  for (const n in e) {
    const i = e[n];
    t(i, n) && r.push(i);
  }
  return r;
}
function f4(e) {
  return Object.values(e).reduce(
    (t, r) => (D(r) && t.push(r.id), t),
    []
  );
}
function Dj(e) {
  return e.reduce(
    (t, r) => (D(r) && (t[r.id] = r), t),
    {}
  );
}
function cb(e) {
  return Object.values(e);
}
function Mj(e) {
  let t = 0;
  for (const r in e)
    t++;
  return t;
}
function d4(e) {
  return cb(e).map((t) => t.object);
}
function mt(e) {
  throw new Error("Should never get here");
}
function p4({
  registration: e
}) {
  var n, i;
  const { activities: t } = e, r = {
    OK: 0,
    ISSUE: 0,
    PENDING: 0
  };
  for (const o in t) {
    const s = (n = t[o]) == null ? void 0 : n.allocationSignal;
    if (s && (i = t[o]) != null && i.showInRegistration)
      switch (s) {
        case "ISSUE": {
          r.ISSUE++;
          break;
        }
        case "PENDING": {
          r.PENDING++;
          break;
        }
        case "OK": {
          r.OK++;
          break;
        }
        default:
          mt();
      }
  }
  return r;
}
function h4(e, t = 500) {
  return Zy(e).replace(/\\n|["\\{}]/g, " ").substring(0, t);
}
function Lj(e) {
  try {
    if (pt(e)) {
      const t = JSON.parse(e);
      return ye(t) ? t : {};
    }
    return {};
  } catch {
    return {};
  }
}
function m4(e) {
  try {
    if (pt(e)) {
      const t = JSON.parse(e);
      return xe(t) ? t : [];
    }
    return [];
  } catch {
    return [];
  }
}
function xj(e) {
  return ye(e) && "logId" in e && D(e.logId);
}
function kj(e) {
  return ye(e) && "stack" in e;
}
function fb(e) {
  return ye(e) && "cause" in e && D(e.cause);
}
function jj(e) {
  return ye(e) && "errorName" in e && pt(e.errorName) && ra.validate(e.errorName);
}
function Uj(e) {
  return ye(e) && "name" in e && pt(e.name) && ra.validate(e.name);
}
function $j(e, t) {
  return Wo({
    fallback: () => ({ "": ["."] }),
    options: t
  })(e, (i) => {
    if (dr(i))
      return "";
    if (xj(i))
      return i.logId;
  }, {});
}
function Fj(e) {
  const t = $j(e), r = qo(t);
  return r.length === 1 ? r[0] : r;
}
function zj(e, t) {
  return Wo({
    fallback: () => ({ 500: ["."] }),
    options: t
  })(e, (i) => {
    if (dr(i))
      return 500;
    if (Je(i))
      return i;
    for (const o of ["statusCode", "status"])
      if (ye(i) && o in i) {
        const s = i[o];
        if (Je(s))
          return s;
        if (pt(s)) {
          const a = parseInt(s, 10);
          return isNaN(a) ? 500 : a;
        }
      }
  }, {});
}
function Zo(e) {
  const t = zj(e, { limit: 1 }), r = qo(t);
  return r.length > 0 ? Number(r[0]) : 500;
}
function db(e, t) {
  return Wo({
    fallback: () => ({ [ue.Error]: ["."] }),
    options: t
  })(e, (i) => {
    if (dr(i))
      return ue.Error;
    if (pt(i) && Object.values(ue).includes(i))
      return i;
    if (jj(i))
      return i.errorName;
    if (Uj(i))
      return i.name;
  }, {});
}
function Gn(e) {
  const t = db(e, { limit: 1 });
  return qo(t)[0] || ue.Error;
}
function Gj(e, t) {
  return D1({
    fallback: () => [],
    options: t
  })(e, (i) => dr(i) ? [] : fb(i) ? [i.cause] : [], []);
}
function lm(e) {
  const t = Gj(e, { limit: 1 });
  return t.length > 0 ? t[0].value : void 0;
}
function Bj(e, t) {
  const r = Wo({
    fallback: () => ({}),
    options: t
  }), n = (i) => {
    if (!dr(i)) {
      if (pt(i) && (i = parseInt(i, 10)), Je(i))
        return i;
      if (ye(i)) {
        if ("errorCode" in i)
          return n(i.errorCode);
        if ("message" in i) {
          const o = i.message;
          if (ye(o) && "errorCode" in o)
            return n(o.errorCode);
        }
      }
    }
  };
  return r(e, n, {});
}
function Vj(e) {
  const t = Bj(e, { limit: 1 }), r = qo(t);
  return r.length > 0 ? Number(r[0]) : void 0;
}
function E4(e) {
  return {
    status: Zo(e),
    message: Nt(e),
    errorName: Gn(e),
    stack: kj(e) ? e.stack : void 0
  };
}
function Wj(e) {
  if (!fb(e))
    return;
  const t = (r) => {
    const n = Gn(r);
    return {
      errorName: n,
      name: n,
      message: Nt(r),
      code: Zo(r),
      cause: Wj(r),
      errorCode: Vj(r)
    };
  };
  return xe(e.cause) ? e.cause.map((r) => t(r)) : t(e.cause);
}
function pb(e, t, r) {
  if (t === ue.MultiError && ye(e) && xe(e.cause) && e.cause.length > 0) {
    const n = Gn(e.cause[0]);
    if (e.cause.every(
      (o) => Gn(o) === n
    ))
      return {
        errorName: n,
        statusCode: Zo(e.cause[0])
      };
  }
  return { errorName: t, statusCode: r };
}
function qj(e) {
  const t = pb(
    e,
    Gn(e),
    Zo(e)
  );
  return {
    code: t.statusCode,
    message: Nt(e),
    errorName: t.errorName
  };
}
function kc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function hb(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var vn = {}, lt = {}, cm;
function Hj() {
  if (cm) return lt;
  cm = 1, Object.defineProperty(lt, "__esModule", { value: !0 }), lt.SAMLIdentifierFormat = lt.EUserObjectMatching = lt.EApplySSOPermissions = lt.EAuthSaml2SigantureAlgorithm = lt.EAuthSaml2Signing = lt.EAuthLogLevel = lt.EAuthStrategy = void 0;
  var e;
  (function(s) {
    s.TE_IDP = "TE_IDP", s.SAML2 = "SAML2", s.CAS = "CAS";
  })(e || (lt.EAuthStrategy = e = {}));
  var t;
  (function(s) {
    s.NONE = "NONE", s.LOW = "LOW", s.HIGH = "HIGH", s.DEBUG = "DEBUG";
  })(t || (lt.EAuthLogLevel = t = {}));
  var r;
  (function(s) {
    s.NONE = "NONE", s.SIGN = "SIGN", s.REQUIRED = "REQUIRED";
  })(r || (lt.EAuthSaml2Signing = r = {}));
  var n;
  (function(s) {
    s.SHA1 = "sha1", s.SHA256 = "sha256", s.SHA512 = "sha512";
  })(n || (lt.EAuthSaml2SigantureAlgorithm = n = {}));
  var i;
  (function(s) {
    s.ALWAYS = "ALWAYS", s.NEW_USERS = "NEW_USERS", s.NEVER = "NEVER";
  })(i || (lt.EApplySSOPermissions = i = {}));
  var o;
  return (function(s) {
    s.OBJECT_EXTID = "OBJECT_EXTID", s.OBJECT_FIELD = "OBJECT_FIELD";
  })(o || (lt.EUserObjectMatching = o = {})), lt.SAMLIdentifierFormat = {
    Unspecified: "urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified",
    Email: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress",
    Persistent: "urn:oasis:names:tc:SAML:2.0:nameid-format:persistent",
    Transient: "urn:oasis:names:tc:SAML:2.0:nameid-format:transient"
  }, lt;
}
var Sn = {}, fm;
function Yj() {
  if (fm) return Sn;
  fm = 1, Object.defineProperty(Sn, "__esModule", { value: !0 }), Sn.APP_ID_TO_NAME_MAP = Sn.EAppId = void 0;
  var e;
  return (function(t) {
    t.TE_ACTIVITIES = "TE_ACTIVITIES", t.TE_ADMIN = "TE_ADMIN", t.TE_ALLOCATE = "TE_ALLOCATE", t.TE_ALLOCATE_PREFERENTIAL = "TE_ALLOCATE_PREFERENTIAL", t.TE_ATTENDANCE = "TE_ATTENDANCE", t.TE_AUTOPILOT = "TE_AUTOPILOT", t.TE_CALENDAR_INTEGRATION = "TE_CALENDAR_INTEGRATION", t.TE_CORE = "TE_CORE", t.TE_CURRICULUM = "TE_CURRICULUM", t.TE_DATA_MANAGER = "TE_DATA_MANAGER", t.TE_DEBIT = "TE_DEBIT", t.TE_EVALUATION = "TE_EVALUATION", t.TE_EVENT_BROKER = "TE_EVENT_BROKER", t.TE_EXAM = "TE_EXAM", t.TE_EXAM_V3 = "TE_EXAM_V3", t.TE_FLOW = "TE_FLOW", t.TE_HUB = "TE_HUB", t.TE_INSIGHT = "TE_INSIGHT", t.TE_PLAN = "TE_PLAN", t.TE_PREFERENCES = "TE_PREFERENCES", t.TE_REGISTRATION = "TE_REGISTRATION", t.TE_REPORTING = "TE_REPORTING", t.TE_RESERVE = "TE_RESERVE", t.TE_SEAT_MANAGEMENT = "TE_SEAT_MANAGEMENT", t.TE_STATISTICS = "TE_STATISTICS", t.TE_STUDY_GUIDE = "TE_STUDY_GUIDE", t.TE_STUDY_PLANNER = "TE_STUDY_PLANNER", t.TE_VIEWER = "TE_VIEWER", t.TE_WORKLOAD = "TE_WORKLOAD", t.JAVA_CLIENT = "JAVA_CLIENT", t.TE_AM = "TE_AM", t.TE_PORTAL = "TE_PORTAL", t.TE_MCP = "TE_MCP", t.TE_REST = "TE_REST", t.TE_SERVER_THREAD = "TE_SERVER_THREAD", t.TE_SOAP = "TE_SOAP";
  })(e || (Sn.EAppId = e = {})), Sn.APP_ID_TO_NAME_MAP = {
    // Products
    [e.TE_ACTIVITIES]: "Activities",
    [e.TE_ADMIN]: "Admin",
    [e.TE_ALLOCATE]: "Allocate",
    [e.TE_ALLOCATE_PREFERENTIAL]: "Allocate Preferential",
    [e.TE_ATTENDANCE]: "Attendance",
    [e.TE_AUTOPILOT]: "Autopilot",
    [e.TE_CALENDAR_INTEGRATION]: "Calendar Integration",
    [e.TE_CORE]: "Core",
    [e.TE_CURRICULUM]: "Curriculum",
    [e.TE_DATA_MANAGER]: "Data Manager",
    [e.TE_DEBIT]: "Debit",
    [e.TE_EVALUATION]: "Evaluation",
    [e.TE_EVENT_BROKER]: "Event Broker",
    [e.TE_EXAM]: "Exam",
    [e.TE_EXAM_V3]: "Assessment",
    [e.TE_FLOW]: "Flow",
    [e.TE_HUB]: "Hub",
    [e.TE_INSIGHT]: "Insight",
    [e.TE_PLAN]: "Plan",
    [e.TE_PREFERENCES]: "Preferences",
    [e.TE_REGISTRATION]: "Registration",
    [e.TE_REPORTING]: "Reporting",
    [e.TE_RESERVE]: "Reserve",
    [e.TE_SEAT_MANAGEMENT]: "Seat Management",
    [e.TE_STATISTICS]: "Statistics",
    [e.TE_STUDY_GUIDE]: "Study Guide",
    [e.TE_STUDY_PLANNER]: "Study Planner",
    [e.TE_VIEWER]: "Viewer",
    [e.TE_WORKLOAD]: "Workload",
    // Supporting apps
    [e.JAVA_CLIENT]: "Java Client",
    [e.TE_AM]: "Activity Manager",
    [e.TE_PORTAL]: "Portal",
    [e.TE_MCP]: "MCP",
    [e.TE_REST]: "REST",
    [e.TE_SERVER_THREAD]: "Server Thread",
    [e.TE_SOAP]: "SOAP"
  }, Sn;
}
var po = {}, dm;
function Zj() {
  if (dm) return po;
  dm = 1, Object.defineProperty(po, "__esModule", { value: !0 }), po.ESuiteId = void 0;
  var e;
  return (function(t) {
    t.CURRICULUM = "CURRICULUM", t.WORKLOAD = "WORKLOAD", t.SCHEDULING = "SCHEDULING", t.ENGAGEMENT = "ENGAGEMENT";
  })(e || (po.ESuiteId = e = {})), po;
}
var ho = {}, pm;
function Jj() {
  if (pm) return ho;
  pm = 1, Object.defineProperty(ho, "__esModule", { value: !0 }), ho.EAuth = void 0;
  var e;
  return (function(t) {
    t.NOT_AUTHENTICATED = "NOT_AUTHENTICATED", t.AUTHENTICATED = "AUTHENTICATED", t.PENDING = "PENDING";
  })(e || (ho.EAuth = e = {})), ho;
}
var In = {}, hm;
function Kj() {
  if (hm) return In;
  hm = 1, Object.defineProperty(In, "__esModule", { value: !0 }), In.EExternalServiceMethods = In.EExternalServices = void 0;
  var e;
  (function(r) {
    r.AUTH_SERVICE = "AUTH_SERVICE", r.USER_SERVICE = "USER_SERVICE", r.ORGANIZATION_SERVICE = "ORGANIZATION_SERVICE", r.APP_SERVICE = "APP_SERVICE", r.BACKUP_SERVICE = "BACKUP_SERVICE", r.TE_SERVER = "TE_SERVER", r.INTEGRATION_SERVICE = "INTEGRATION_SERVICE", r.PATHWAY_SERVICE = "PATHWAY_SERVICE", r.TE_PREFERENCES = "TE_PREFERENCES", r.ACTIVITY_MANAGER = "ACTIVITY_MANAGER", r.ACTIVITY_IMPORTER = "ACTIVITY_IMPORTER", r.REPORTING = "REPORTING", r.NOTIFICATION = "NOTIFICATION_SERVICE", r.EXAM_V3 = "EXAM_V3", r.HUB_SERVICE = "HUB_SERVICE", r.OBJECTS_BATCH_SERVICE = "OBJECTS_BATCH_SERVICE";
  })(e || (In.EExternalServices = e = {}));
  var t;
  return (function(r) {
    r.GET = "get", r.POST = "post", r.PUT = "put", r.PATCH = "patch", r.DELETE = "delete";
  })(t || (In.EExternalServiceMethods = t = {})), In;
}
var mo = {}, mm;
function Xj() {
  if (mm) return mo;
  mm = 1, Object.defineProperty(mo, "__esModule", { value: !0 }), mo.EPaddingRuleType = void 0;
  var e;
  return (function(t) {
    t.DIRECT = "DIRECT", t.TRAVEL_TIME = "TRAVEL_TIME";
  })(e || (mo.EPaddingRuleType = e = {})), mo;
}
var _n = {}, Em;
function Qj() {
  if (Em) return _n;
  Em = 1, Object.defineProperty(_n, "__esModule", { value: !0 }), _n.EScopeLevel = _n.EPermissionTypes = void 0;
  var e;
  (function(r) {
    r.SCOPE = "SCOPE", r.APP_PERMISSION = "APP_PERMISSION";
  })(e || (_n.EPermissionTypes = e = {}));
  var t;
  return (function(r) {
    r.ADMIN = "ADMIN", r.SUPER = "SUPER";
  })(t || (_n.EScopeLevel = t = {})), _n;
}
var Eo = {}, gm;
function mb() {
  if (gm) return Eo;
  gm = 1, Object.defineProperty(Eo, "__esModule", { value: !0 }), Eo.ERegion = void 0;
  var e;
  return (function(t) {
    t.ANZ = "ANZ", t.EU_EES = "EU_EES", t.SGP = "SGP", t.UK = "UK";
  })(e || (Eo.ERegion = e = {})), Eo;
}
var Jt = {}, ym;
function eU() {
  if (ym) return Jt;
  ym = 1, Object.defineProperty(Jt, "__esModule", { value: !0 }), Jt.ERelativeTimeTypes = Jt.EReservationPeriodType = Jt.EWeekdaySelection = Jt.EWeekdays = void 0;
  var e;
  (function(i) {
    i.MON = "MON", i.TUE = "TUE", i.WED = "WED", i.THU = "THU", i.FRI = "FRI", i.SAT = "SAT", i.SUN = "SUN";
  })(e || (Jt.EWeekdays = e = {}));
  var t;
  (function(i) {
    i.noWeekDaySelection = "no_weekday_selection";
  })(t || (Jt.EWeekdaySelection = t = {}));
  var r;
  (function(i) {
    i.NONE = "NONE", i.RESERVATION_PERIOD = "RESERVATION_PERIOD", i.DAY = "DAY", i.WEEK = "WEEK", i.MONTH = "MONTH", i.YEAR = "YEAR";
  })(r || (Jt.EReservationPeriodType = r = {}));
  var n;
  return (function(i) {
    i.DAYS = "DAYS", i.HOURS = "HOURS", i.MINUTES = "MINUTES";
  })(n || (Jt.ERelativeTimeTypes = n = {})), Jt;
}
var go = {}, Tm;
function tU() {
  if (Tm) return go;
  Tm = 1, Object.defineProperty(go, "__esModule", { value: !0 }), go.ETokenType = void 0;
  var e;
  return (function(t) {
    t.M2M = "M2M", t.USER = "USER";
  })(e || (go.ETokenType = e = {})), go;
}
var Rn = {}, bm;
function rU() {
  if (bm) return Rn;
  bm = 1, Object.defineProperty(Rn, "__esModule", { value: !0 }), Rn.EUserAllowJavaClientAccess = Rn.EUserVisibility = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.READ_ONLY = "READ_ONLY", r.HIDDEN = "HIDDEN";
  })(e || (Rn.EUserVisibility = e = {}));
  var t;
  return (function(r) {
    r.STANDARD = "STANDARD", r.YES = "YES", r.NO = "NO";
  })(t || (Rn.EUserAllowJavaClientAccess = t = {})), Rn;
}
var yo = {}, Am;
function nU() {
  if (Am) return yo;
  Am = 1, Object.defineProperty(yo, "__esModule", { value: !0 }), yo.EOrganizationType = void 0;
  var e;
  return (function(t) {
    t.CUSTOMER_PRODUCTION = "CUSTOMER_PRODUCTION", t.CUSTOMER_TESTING = "CUSTOMER_TESTING", t.INTERNAL_PRODUCTION = "INTERNAL_PRODUCTION", t.INTERNAL_OTHER = "INTERNAL_OTHER";
  })(e || (yo.EOrganizationType = e = {})), yo;
}
var Sr = {}, vm;
function iU() {
  if (vm) return Sr;
  vm = 1, Object.defineProperty(Sr, "__esModule", { value: !0 }), Sr.EPreferencesFilter = Sr.EPersonalDataCheck = Sr.EFieldType = void 0;
  var e;
  (function(n) {
    n.TEXT = "TEXT", n.SIGNATURE = "SIGNATURE", n.EMAIL = "EMAIL", n.URL = "URL", n.TELEPHONE = "TELEPHONE", n.CATEGORY = "CATEGORY", n.COMMENT = "COMMENT", n.INTEGER = "INTEGER", n.LENGTH = "LENGTH", n.CHECKBOX = "CHECKBOX", n.REFERENCE = "REFERENCE", n.NON_SEARCHABLE_TEXT = "NON_SEARCHABLE_TEXT", n.NON_SEARCHABLE_REFERENCE = "NON_SEARCHABLE_REFERENCE";
  })(e || (Sr.EFieldType = e = {}));
  var t;
  (function(n) {
    n.STANDARD = "STANDARD", n.YES = "YES", n.NO = "NO";
  })(t || (Sr.EPersonalDataCheck = t = {}));
  var r;
  return (function(n) {
    n.CHOICE1 = "[0-9]", n.CHOICE2 = "[0-9\\- +]", n.CHOICE3 = "[0-9a-z]", n.CHOICE4 = "[0-9a-zA-ZåäöÅÄÖ_-]", n.CHOICE5 = "[@_\\-\\.0-9a-zA-Z]", n.CHOICE6 = "[@_\\-\\.0-9a-zA-ZåäöÅÄÖ]";
  })(r || (Sr.EPreferencesFilter = r = {})), Sr;
}
var On = {}, Sm;
function oU() {
  if (Sm) return On;
  Sm = 1, Object.defineProperty(On, "__esModule", { value: !0 }), On.EMatchMode = On.EOperator = void 0;
  var e;
  (function(r) {
    r.E = "=", r.GTE = ">=", r.GT = ">", r.LTE = "<=", r.LT = "<";
  })(e || (On.EOperator = e = {}));
  var t;
  return (function(r) {
    r.MATCH_ONE = "MATCH_ONE", r.MATCH_ALL = "MATCH_ALL";
  })(t || (On.EMatchMode = t = {})), On;
}
var Ir = {}, Im;
function sU() {
  if (Im) return Ir;
  Im = 1, Object.defineProperty(Ir, "__esModule", { value: !0 }), Ir.ELoggedEventType = Ir.ELoggedEventItemDataType = Ir.ELoggedEventLevel = void 0;
  var e;
  (function(n) {
    n.LOW = "LOW", n.MEDIUM = "MEDIUM", n.HIGH = "HIGH", n.CRITICAL = "CRITICAL";
  })(e || (Ir.ELoggedEventLevel = e = {}));
  var t;
  (function(n) {
    n.TEXT = "text/plain", n.JSON = "application/json";
  })(t || (Ir.ELoggedEventItemDataType = t = {}));
  var r;
  return (function(n) {
    n.MIGRATION = "MIGRATION", n.IMPORT = "IMPORT", n.SSO = "SSO";
  })(r || (Ir.ELoggedEventType = r = {})), Ir;
}
var wn = {}, _m;
function aU() {
  if (_m) return wn;
  _m = 1, Object.defineProperty(wn, "__esModule", { value: !0 }), wn.EPersonalInformation = wn.EProperty = void 0;
  var e;
  (function(r) {
    r.STANDARD = "STANDARD", r.ABSTRACT = "ABSTRACT", r.VIRTUAL_STANDARD = "VIRTUAL_STANDARD", r.VIRTUAL_ABSTRACT = "VIRTUAL_ABSTRACT", r.TEMPLATE_OBJECT = "TEMPLATE_OBJECT";
  })(e || (wn.EProperty = e = {}));
  var t;
  return (function(r) {
    r.YES = "YES", r.NO = "NO", r.STANDARD = "STANDARD";
  })(t || (wn.EPersonalInformation = t = {})), wn;
}
var Nn = {}, Rm;
function uU() {
  if (Rm) return Nn;
  Rm = 1, Object.defineProperty(Nn, "__esModule", { value: !0 }), Nn.EPeriodAccess = Nn.ETimeIntervals = void 0;
  var e;
  (function(r) {
    r.DATE = "DATE", r.YEAR = "YEAR", r.WEEK = "WEEK", r.WEEK_NUMBER = "WEEK_NUMBER", r.MONTH = "MONTH", r.DAY = "DAY", r.WEEKDAY = "WEEKDAY", r.TIME = "TIME", r.NONE = "-";
  })(e || (Nn.ETimeIntervals = e = {}));
  var t;
  return (function(r) {
    r.PUBLIC = "PUBLIC", r.LIMITED = "LIMITED", r.HIDDEN = "HIDDEN";
  })(t || (Nn.EPeriodAccess = t = {})), Nn;
}
var To = {}, Om;
function lU() {
  if (Om) return To;
  Om = 1, Object.defineProperty(To, "__esModule", { value: !0 }), To.ERelationType = void 0;
  var e;
  return (function(t) {
    t.USE_ONLY = "USE_ONLY", t.STRICT = "STRICT", t.DYNAMIC = "DYNAMIC";
  })(e || (To.ERelationType = e = {})), To;
}
var st = {}, wm;
function cU() {
  if (wm) return st;
  wm = 1, Object.defineProperty(st, "__esModule", { value: !0 }), st.EReservationStatuses = st.ETemplateType = st.ETemplateTypesText = st.EOptionalRelation = st.EObjectProperty = st.EMandatoryProperty = st.EReservationKind = st.EDefaultStatus = void 0;
  var e;
  (function(l) {
    l.CONFIRMED = "CONFIRMED", l.PLANNED = "PLANNED", l.PRELIMINARY = "PRELIMINARY";
  })(e || (st.EDefaultStatus = e = {}));
  var t;
  (function(l) {
    l.PHYSICAL = "PHYSICAL", l.PHYSICAL_DOUBLE = "PHYSICAL_DOUBLE", l.ABSTRACT = "ABSTRACT", l.ABSTRACT_DISPLAY = "ABSTRACT_DISPLAY";
  })(t || (st.EReservationKind = t = {}));
  var r;
  (function(l) {
    l.MANDATORY = "MANDATORY", l.COMBINATION = "COMBINATION", l.OPTIONAL = "OPTIONAL";
  })(r || (st.EMandatoryProperty = r = {}));
  var n;
  (function(l) {
    l.OBJECT = "OBJECT", l.VIRTUAL = "VIRTUAL", l.INCOMPLETE = "INCOMPLETE";
  })(n || (st.EObjectProperty = n = {}));
  var i;
  (function(l) {
    l.NONE = "NONE", l.OPTIONAL = "OPTIONAL", l.ABSTRACT = "ABSTRACT";
  })(i || (st.EOptionalRelation = i = {}));
  var o;
  (function(l) {
    l.STANDARD = "STANDARD", l.NEVER = "NEVER", l.ALWAYS = "ALWAYS";
  })(o || (st.ETemplateTypesText = o = {}));
  var s;
  (function(l) {
    l.RESERVATION = "RESERVATION", l.AVAILABILITY = "AVAILABILITY", l.INFO_RESERVATION = "INFO_RESERVATION";
  })(s || (st.ETemplateType = s = {}));
  var a;
  return (function(l) {
    l.UNKNOWN = "UNKNOWN", l.Reservation = "A_RESERVATION", l.Availability = "A_AVAILABILITY", l.Info = "A_INFO", l.Complete = "B_COMPLETE", l.Incomplete = "B_INCOMPLETE", l.Confirmed = "C_CONFIRMED", l.Preliminary = "C_PRELIMINARY", l.Planned = "C_PLANNED", l.Requested = "C_REQUESTED", l.Rejected = "C_REJECTED", l.Time = "D_TIME", l.WaitingList = "D_WAITING_LIST";
  })(a || (st.EReservationStatuses = a = {})), st;
}
var bo = {}, Nm;
function fU() {
  if (Nm) return bo;
  Nm = 1, Object.defineProperty(bo, "__esModule", { value: !0 }), bo.EAcceptJavaClient = void 0;
  var e;
  return (function(t) {
    t.YES = "YES", t.NO = "NO", t.DEFAULT = "DEFAULT";
  })(e || (bo.EAcceptJavaClient = e = {})), bo;
}
var Ao = {}, Cm;
function dU() {
  if (Cm) return Ao;
  Cm = 1, Object.defineProperty(Ao, "__esModule", { value: !0 }), Ao.EFieldMappingModes = void 0;
  var e;
  return (function(t) {
    t.RAW = "RAW", t.FREE_MAPPING = "FREE_MAPPING", t.MAPPED = "MAPPED";
  })(e || (Ao.EFieldMappingModes = e = {})), Ao;
}
var vo = {}, Pm;
function pU() {
  if (Pm) return vo;
  Pm = 1, Object.defineProperty(vo, "__esModule", { value: !0 }), vo.ETEReportingDataSource = void 0;
  var e;
  return (function(t) {
    t.SCHEDULE_GENERATOR = "SCHEDULE_GENERATOR", t.RESERVATIONS = "RESERVATIONS", t.ORDERS = "ORDERS", t.EXAMS = "EXAMS", t.FORMS = "FORMS", t.ACTIVITIES = "ACTIVITIES";
  })(e || (vo.ETEReportingDataSource = e = {})), vo;
}
var _r = {}, Dm;
function hU() {
  if (Dm) return _r;
  Dm = 1, Object.defineProperty(_r, "__esModule", { value: !0 }), _r.EAppProperties = _r.EObjectTypeMappingStatuses = _r.EApplicationObjectTypeGroup = void 0;
  var e;
  (function(n) {
    n.NONE = "NONE", n.ROOM = "ROOM", n.PROFESSOR = "PROFESSOR", n.COURSE = "COURSE", n.COURSE_INFORMATION = "COURSE_INFORMATION", n.INVOICING = "INVOICING", n.STUDENT_SET = "STUDENT_SET", n.STUDENT_SET_GROUP = "STUDENT_SET_GROUP", n.PROGRAM = "PROGRAM", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.STUDENT = "STUDENT", n.STAFF = "STAFF", n.CHANGE_REQUEST = "CHANGE_REQUEST", n.INVIGILATOR = "INVIGILATOR";
  })(e || (_r.EApplicationObjectTypeGroup = e = {}));
  var t;
  (function(n) {
    n.NOT_TESTED = "NOT_TESTED", n.NOT_MAPPED = "NOT_MAPPED", n.MAPPED = "MAPPED", n.TESTED = "TESTED", n.FAILED = "FAILED";
  })(t || (_r.EObjectTypeMappingStatuses = t = {}));
  var r;
  return (function(n) {
    n.NONE = "NONE", n.NAME = "NAME", n.LABEL = "LABEL", n.EMAIL = "EMAIL", n.FIRST_NAME = "FIRST_NAME", n.LAST_NAME = "LAST_NAME", n.TITLE = "TITLE", n.ID = "ID", n.SEMESTER = "SEMESTER", n.MAX_STUDENTS = "MAX_STUDENTS", n.ACTIVITY_TYPE = "ACTIVITY_TYPE", n.START_DATE = "START_DATE", n.END_DATE = "END_DATE", n.BUFFER = "BUFFER", n.HIDETRACK = "HIDETRACK", n.DEDICATETRACK = "DEDICATETRACK", n.TRACK = "TRACK", n.SEATS = "SEATS", n.COURSE_OCCURENCE = "COURSE_OCCURENCE", n.PLANNED_SIZE = "PLANNED_SIZE", n.PROGRAM = "PROGRAM", n.ROOM_NAME = "ROOM_NAME", n.ROOM_TYPE = "ROOM_TYPE", n.BUILDING = "BUILDING", n.CAMPUS = "CAMPUS", n.REASONABLE_ADJUSTMENT = "REASONABLE_ADJUSTMENT";
  })(r || (_r.EAppProperties = r = {})), _r;
}
var Dt = {}, Mm;
function mU() {
  if (Mm) return Dt;
  Mm = 1, Object.defineProperty(Dt, "__esModule", { value: !0 }), Dt.CalculatedValueProps = Dt.ECalculatedValueKey = Dt.EReportTemplateType = Dt.EReportingCapacitySource = Dt.EReportingTimeType = void 0;
  var e;
  (function(i) {
    i.FIXED_HOUR = "FIXED_HOUR", i.TIME_RANGE = "TIME_RANGE", i.MAX_HOURS = "MAX_HOURS";
  })(e || (Dt.EReportingTimeType = e = {}));
  var t;
  (function(i) {
    i.FROM_FIELD = "FROM_FIELD", i.FROM_MEMBERSHIP = "FROM_MEMBERSHIP";
  })(t || (Dt.EReportingCapacitySource = t = {}));
  var r;
  (function(i) {
    i.UTILIZATION = "UTILIZATION", i.LOAD = "LOAD", i.DEMAND_ANALYTIC = "DEMAND_ANALYTIC", i.HEATMAP = "HEATMAP";
  })(r || (Dt.EReportTemplateType = r = {}));
  var n;
  return (function(i) {
    i.FREQUENCY = "frequency", i.OCCUPANCY = "occupancy", i.UTILIZATION = "utilization", i.BOOKED_HOURS = "bookedHours", i.AVAILABLE_HOUR = "availableHour", i.LOAD_PERCENTAGE = "loadPercentage", i.WEEKS_ABOVE_TARGET = "weeksAboveTarget", i.DEMAND_PERCENTAGE = "demandPercentage";
  })(n || (Dt.ECalculatedValueKey = n = {})), Dt.CalculatedValueProps = {
    [n.FREQUENCY]: { label: "Frequency", templateType: r.UTILIZATION },
    [n.OCCUPANCY]: { label: "Occupancy", templateType: r.UTILIZATION },
    [n.UTILIZATION]: { label: "Utilization", templateType: r.UTILIZATION },
    [n.BOOKED_HOURS]: { label: "Booked Hours", templateType: r.LOAD },
    [n.AVAILABLE_HOUR]: { label: "Available Hours", templateType: r.LOAD },
    [n.LOAD_PERCENTAGE]: { label: "Load", templateType: r.LOAD },
    [n.WEEKS_ABOVE_TARGET]: {
      label: "Weeks Above Target",
      templateType: r.DEMAND_ANALYTIC
    },
    [n.DEMAND_PERCENTAGE]: {
      label: "Average Weekly Demand",
      templateType: r.DEMAND_ANALYTIC
    }
  }, Dt;
}
var Lm;
function EU() {
  return Lm || (Lm = 1, (function(e) {
    var t = vn && vn.__createBinding || (Object.create ? (function(F, W, X, de) {
      de === void 0 && (de = X);
      var B = Object.getOwnPropertyDescriptor(W, X);
      (!B || ("get" in B ? !W.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return W[X];
      } }), Object.defineProperty(F, de, B);
    }) : (function(F, W, X, de) {
      de === void 0 && (de = X), F[de] = W[X];
    })), r = vn && vn.__exportStar || function(F, W) {
      for (var X in F) X !== "default" && !Object.prototype.hasOwnProperty.call(W, X) && t(W, F, X);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.EReportTemplateType = e.EReportingCapacitySource = e.EReportingTimeType = e.EAppProperties = e.EObjectTypeMappingStatuses = e.EApplicationObjectTypeGroup = e.ETEReportingDataSource = e.EFieldMappingModes = e.EAcceptJavaClient = e.EReservationStatuses = e.ETemplateType = e.ETemplateTypesText = e.EOptionalRelation = e.EObjectProperty = e.EMandatoryProperty = e.EReservationKind = e.EDefaultStatus = e.ERelationType = e.EPeriodAccess = e.ETimeIntervals = e.EPersonalInformation = e.EProperty = e.EOperator = e.EMatchMode = e.EPreferencesFilter = e.EPersonalDataCheck = e.EFieldType = e.EOrganizationType = e.EUserVisibility = e.EUserAllowJavaClientAccess = e.ETokenType = e.EWeekdaySelection = e.EWeekdays = e.EReservationPeriodType = e.ERelativeTimeTypes = e.ERegion = e.EScopeLevel = e.EPermissionTypes = e.EPaddingRuleType = e.EExternalServices = e.EExternalServiceMethods = e.EAuth = e.ESuiteId = e.EAppId = e.EUserObjectMatching = e.EAuthStrategy = e.EAuthSaml2Signing = e.EAuthSaml2SigantureAlgorithm = e.EAuthLogLevel = e.EApplySSOPermissions = void 0, e.CalculatedValueProps = e.ECalculatedValueKey = void 0;
    var n = Hj();
    Object.defineProperty(e, "EApplySSOPermissions", { enumerable: !0, get: function() {
      return n.EApplySSOPermissions;
    } }), Object.defineProperty(e, "EAuthLogLevel", { enumerable: !0, get: function() {
      return n.EAuthLogLevel;
    } }), Object.defineProperty(e, "EAuthSaml2SigantureAlgorithm", { enumerable: !0, get: function() {
      return n.EAuthSaml2SigantureAlgorithm;
    } }), Object.defineProperty(e, "EAuthSaml2Signing", { enumerable: !0, get: function() {
      return n.EAuthSaml2Signing;
    } }), Object.defineProperty(e, "EAuthStrategy", { enumerable: !0, get: function() {
      return n.EAuthStrategy;
    } }), Object.defineProperty(e, "EUserObjectMatching", { enumerable: !0, get: function() {
      return n.EUserObjectMatching;
    } });
    var i = Yj();
    Object.defineProperty(e, "EAppId", { enumerable: !0, get: function() {
      return i.EAppId;
    } });
    var o = Zj();
    Object.defineProperty(e, "ESuiteId", { enumerable: !0, get: function() {
      return o.ESuiteId;
    } });
    var s = Jj();
    Object.defineProperty(e, "EAuth", { enumerable: !0, get: function() {
      return s.EAuth;
    } });
    var a = Kj();
    Object.defineProperty(e, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return a.EExternalServiceMethods;
    } }), Object.defineProperty(e, "EExternalServices", { enumerable: !0, get: function() {
      return a.EExternalServices;
    } });
    var l = Xj();
    Object.defineProperty(e, "EPaddingRuleType", { enumerable: !0, get: function() {
      return l.EPaddingRuleType;
    } });
    var f = Qj();
    Object.defineProperty(e, "EPermissionTypes", { enumerable: !0, get: function() {
      return f.EPermissionTypes;
    } }), Object.defineProperty(e, "EScopeLevel", { enumerable: !0, get: function() {
      return f.EScopeLevel;
    } });
    var u = mb();
    Object.defineProperty(e, "ERegion", { enumerable: !0, get: function() {
      return u.ERegion;
    } });
    var h = eU();
    Object.defineProperty(e, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return h.ERelativeTimeTypes;
    } }), Object.defineProperty(e, "EReservationPeriodType", { enumerable: !0, get: function() {
      return h.EReservationPeriodType;
    } }), Object.defineProperty(e, "EWeekdays", { enumerable: !0, get: function() {
      return h.EWeekdays;
    } }), Object.defineProperty(e, "EWeekdaySelection", { enumerable: !0, get: function() {
      return h.EWeekdaySelection;
    } });
    var E = tU();
    Object.defineProperty(e, "ETokenType", { enumerable: !0, get: function() {
      return E.ETokenType;
    } });
    var d = rU();
    Object.defineProperty(e, "EUserAllowJavaClientAccess", { enumerable: !0, get: function() {
      return d.EUserAllowJavaClientAccess;
    } }), Object.defineProperty(e, "EUserVisibility", { enumerable: !0, get: function() {
      return d.EUserVisibility;
    } });
    var g = nU();
    Object.defineProperty(e, "EOrganizationType", { enumerable: !0, get: function() {
      return g.EOrganizationType;
    } });
    var y = iU();
    Object.defineProperty(e, "EFieldType", { enumerable: !0, get: function() {
      return y.EFieldType;
    } }), Object.defineProperty(e, "EPersonalDataCheck", { enumerable: !0, get: function() {
      return y.EPersonalDataCheck;
    } }), Object.defineProperty(e, "EPreferencesFilter", { enumerable: !0, get: function() {
      return y.EPreferencesFilter;
    } });
    var b = oU();
    Object.defineProperty(e, "EMatchMode", { enumerable: !0, get: function() {
      return b.EMatchMode;
    } }), Object.defineProperty(e, "EOperator", { enumerable: !0, get: function() {
      return b.EOperator;
    } }), r(sU(), e);
    var I = aU();
    Object.defineProperty(e, "EProperty", { enumerable: !0, get: function() {
      return I.EProperty;
    } }), Object.defineProperty(e, "EPersonalInformation", { enumerable: !0, get: function() {
      return I.EPersonalInformation;
    } });
    var S = uU();
    Object.defineProperty(e, "ETimeIntervals", { enumerable: !0, get: function() {
      return S.ETimeIntervals;
    } }), Object.defineProperty(e, "EPeriodAccess", { enumerable: !0, get: function() {
      return S.EPeriodAccess;
    } });
    var w = lU();
    Object.defineProperty(e, "ERelationType", { enumerable: !0, get: function() {
      return w.ERelationType;
    } });
    var P = cU();
    Object.defineProperty(e, "EDefaultStatus", { enumerable: !0, get: function() {
      return P.EDefaultStatus;
    } }), Object.defineProperty(e, "EReservationKind", { enumerable: !0, get: function() {
      return P.EReservationKind;
    } }), Object.defineProperty(e, "EMandatoryProperty", { enumerable: !0, get: function() {
      return P.EMandatoryProperty;
    } }), Object.defineProperty(e, "EObjectProperty", { enumerable: !0, get: function() {
      return P.EObjectProperty;
    } }), Object.defineProperty(e, "EOptionalRelation", { enumerable: !0, get: function() {
      return P.EOptionalRelation;
    } }), Object.defineProperty(e, "ETemplateTypesText", { enumerable: !0, get: function() {
      return P.ETemplateTypesText;
    } }), Object.defineProperty(e, "ETemplateType", { enumerable: !0, get: function() {
      return P.ETemplateType;
    } }), Object.defineProperty(e, "EReservationStatuses", { enumerable: !0, get: function() {
      return P.EReservationStatuses;
    } });
    var _ = fU();
    Object.defineProperty(e, "EAcceptJavaClient", { enumerable: !0, get: function() {
      return _.EAcceptJavaClient;
    } });
    var v = dU();
    Object.defineProperty(e, "EFieldMappingModes", { enumerable: !0, get: function() {
      return v.EFieldMappingModes;
    } });
    var M = pU();
    Object.defineProperty(e, "ETEReportingDataSource", { enumerable: !0, get: function() {
      return M.ETEReportingDataSource;
    } });
    var x = hU();
    Object.defineProperty(e, "EApplicationObjectTypeGroup", { enumerable: !0, get: function() {
      return x.EApplicationObjectTypeGroup;
    } }), Object.defineProperty(e, "EObjectTypeMappingStatuses", { enumerable: !0, get: function() {
      return x.EObjectTypeMappingStatuses;
    } }), Object.defineProperty(e, "EAppProperties", { enumerable: !0, get: function() {
      return x.EAppProperties;
    } });
    var z = mU();
    Object.defineProperty(e, "EReportingTimeType", { enumerable: !0, get: function() {
      return z.EReportingTimeType;
    } }), Object.defineProperty(e, "EReportingCapacitySource", { enumerable: !0, get: function() {
      return z.EReportingCapacitySource;
    } }), Object.defineProperty(e, "EReportTemplateType", { enumerable: !0, get: function() {
      return z.EReportTemplateType;
    } }), Object.defineProperty(e, "ECalculatedValueKey", { enumerable: !0, get: function() {
      return z.ECalculatedValueKey;
    } }), Object.defineProperty(e, "CalculatedValueProps", { enumerable: !0, get: function() {
      return z.CalculatedValueProps;
    } });
  })(vn)), vn;
}
var C = EU();
const gU = {
  [C.EApplicationObjectTypeGroup.NONE]: "None",
  [C.EApplicationObjectTypeGroup.ROOM]: "Room",
  [C.EApplicationObjectTypeGroup.PROFESSOR]: "Professor",
  [C.EApplicationObjectTypeGroup.COURSE]: "Course",
  [C.EApplicationObjectTypeGroup.COURSE_INFORMATION]: "Course Information",
  [C.EApplicationObjectTypeGroup.INVOICING]: "Invoicing",
  [C.EApplicationObjectTypeGroup.STUDENT_SET]: "Student Set",
  [C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP]: "Student Set Group",
  [C.EApplicationObjectTypeGroup.PROGRAM]: "Program",
  [C.EApplicationObjectTypeGroup.ACTIVITY_TYPE]: "Activity Type",
  [C.EApplicationObjectTypeGroup.STUDENT]: "Student",
  [C.EApplicationObjectTypeGroup.INVIGILATOR]: "Invigilator",
  [C.EApplicationObjectTypeGroup.STAFF]: "Staff",
  [C.EApplicationObjectTypeGroup.CHANGE_REQUEST]: "Change Request"
}, yU = {
  [C.EAppProperties.NONE]: "None",
  [C.EAppProperties.NAME]: "Name",
  [C.EAppProperties.LABEL]: "Label",
  [C.EAppProperties.EMAIL]: "Email",
  [C.EAppProperties.FIRST_NAME]: "First Name",
  [C.EAppProperties.LAST_NAME]: "Last Name",
  [C.EAppProperties.ROOM_TYPE]: "Room Type",
  [C.EAppProperties.BUILDING]: "Building",
  [C.EAppProperties.CAMPUS]: "Campus",
  [C.EAppProperties.REASONABLE_ADJUSTMENT]: "Reasonable Adjustment",
  [C.EAppProperties.TITLE]: "Title",
  [C.EAppProperties.ID]: "Id",
  [C.EAppProperties.SEMESTER]: "Semester",
  [C.EAppProperties.MAX_STUDENTS]: "Max class size",
  [C.EAppProperties.ACTIVITY_TYPE]: "Activity Type",
  [C.EAppProperties.START_DATE]: "Start Date",
  [C.EAppProperties.END_DATE]: "End Date",
  [C.EAppProperties.BUFFER]: "Buffer",
  [C.EAppProperties.HIDETRACK]: "Hidden",
  [C.EAppProperties.DEDICATETRACK]: "Dedicated",
  [C.EAppProperties.TRACK]: "Group",
  [C.EAppProperties.SEATS]: "Capacity",
  [C.EAppProperties.ROOM_NAME]: "Room name",
  [C.EAppProperties.COURSE_OCCURENCE]: "Course Occurence",
  [C.EAppProperties.PLANNED_SIZE]: "Planned Size",
  [C.EAppProperties.PROGRAM]: "Program"
}, TU = {
  action: "Action",
  actionNeeded: "Action needed",
  activityWaitlistDescription: "Students in (at least one) waitlist",
  addRow: "Add Row",
  addToWaitlist: "Add to waitlist",
  addWaitlistErrorTitle: "Failed to join waitlist",
  admin: "Admin",
  afternoon: "Afternoon",
  agenda: "Agenda",
  allocated: "Allocated",
  allocating: "Allocating",
  allocation: "Allocation",
  availableAt: "Available {0}",
  chooseSettings: "Choose Settings",
  clash: "Schedule clash",
  clashMessage: "There is a conflict between the following registrations",
  classType: "Class Type",
  closed: "Closed",
  completed: "Completed",
  conflict: "Conflict",
  conflictErrorText: "Please select a conflict free option",
  conflictErrorTitle: "There is a conflict",
  copy: "Copy",
  copyURL: "Copy URL",
  create: "Create",
  dataIssueText: "{0} data",
  date: "Date",
  dates: "Dates",
  day: "Day",
  days: "Days",
  deallocate: "Deregister",
  deallocateConfirm: "Are you sure you want to deregister?",
  dedicateTo: "Dedicate to",
  dedicatedErrorText: "This option is dedicated to another student group. Please select another one",
  dedicatedErrorTitle: "Dedicated option",
  defaultServerErrorMessage: "There appears to be a problem connecting to the server. Please try again.",
  delete: "Delete",
  deleteSelected: "Delete Selected",
  distribution: "Distribution",
  done: "Done",
  doubleBookedErrorText: "Please deregister from this activity before selecting a different option",
  doubleBookedErrorTitle: "Already registered on this activity",
  duration: "Duration",
  building: "Building",
  equipment: "Equipment",
  location: "Location",
  staff: "Staff",
  link: "Link",
  meetingLink: "Meeting link",
  recording: "Recording",
  roomDetails: "Room details",
  details: "{0} details",
  detailsFor: "{0} details for {1}",
  viewOnMap: "View on map",
  editSchedulePreferences: "Edit schedule preferences",
  editSettings: "Edit Settings",
  errorInAllocate: "Error in Allocate",
  errorInRegistration: "Error in registration",
  errorInSchedulePreferences: "Error in schedule preferences",
  errorInSchedule: "Error in my schedule",
  failed: "Failed",
  failedAllocationProposals: "Failed allocation proposals",
  generalPreferences: "General preferences",
  generating: "Generating",
  getLinkingGroupsFailed: "Could not get linked groups",
  graphicalview: "Calendar",
  groups: "Groups",
  hiddenErrorText: "Please select another one",
  hiddenErrorTitle: "Option is hidden",
  highDemandErrorTitle: "High demand for registration",
  home: "Home",
  impossibleInCurrentProposal: "Impossible in proposal",
  impossibleProposal: "Impossible",
  inWaitlist: "In waitlist",
  inWaitlistTooltip: "In waitlist to this group",
  invalidActivityType: 'Invalid "{0}". Expected 1 "{0}", found {1}.',
  invalidCourseIds: 'Invalid "{0}" relations. Expected 1 "{0}" ID, found {1}.',
  issue: "Issue",
  issues: "Issues",
  lastRegistrationDate: "Last date for registration",
  lastUpdatedAt: "Last updated {0}",
  leaveWaitlist: "Leave waitlist",
  loadBookingsFailed: "Could not load bookings",
  loadEarlierBookings: "Load earlier bookings",
  leaveWaitlistConfirmText: "You will lose your place in the waitlist for {0}, {1}.",
  leaveWaitlistConfirmTitle: "Are you sure you want to leave waitlist?",
  leavingWaitlistDescription: "In waitlist to other groups",
  clickToLeaveWaitlist: "Click to leave waitlist.",
  clickToDeregister: "Click to deregister.",
  clickToPrefer: "Click to mark as preferred.",
  clickToUnprefer: "Click to remove preference.",
  registerTo: "Register to",
  linkedRulesFailed: "Linked groups does not match.",
  loading: "Loading...",
  logout: "Logout",
  month: "Month",
  moreInformation: "More information",
  moreInformationAvailableAt: "More information available {0}",
  morning: "Morning",
  multipleAllocations: "Multiple allocations",
  multipleMessage: "The following activity has multiple allocated groups",
  mySchedule: "Schedule",
  subscribe: "Subscribe",
  goBackToSchedule: "Go back to your schedule",
  subscribeDescription: "Subscribe to your schedule and get automatic updates in your calendar application",
  subscribeSelectCal: "Select your calendar",
  subscribeApple: "Calendar on iPhone or Mac",
  subscribeGoogle: "Google Calendar",
  subscribeOther: "Other calendar",
  subscribeGoogleInfo: "The refresh frequency of your calendar is determined by Google Calendar, typically once every 12-24 hours.",
  subscribeAppleInfo: "The refresh frequency of your calendar is determined by the Calendar app on iPhone or Mac, typically once per hour.",
  subscribeOtherInfo: "The refresh frequency of your calendar is determined by your calendar provider, typically every few hours.",
  subscribeStepClickSubscribe: 'Click on "Subscribe" button',
  subscribeHowTo: "How to add the subscription:",
  subscribeAppleDescription: "Subscribe to your schedule in Calendar on iOS or macOS",
  subscribeAppleStepComplete: "Complete the dialog when Calendar opens",
  subscribeGoogleDescription: "Subscribe to your schedule in Google Calendar",
  subscribeGoogleStepAdd: 'Click "Add" when the dialog in Google Calendar opens',
  subscribeOtherIntro: "Complete the steps to add the subscription",
  subscribeOtherStepCopyUrl: "Copy the calendar URL",
  subscribeOtherStepOpenApp: "Open your calendar application",
  subscribeOtherStepFindOption: "Find the option to add a calendar. It's usually labelled Add calendar, Subscribe or shown as a + icon",
  subscribeOtherStepChooseUrl: "Choose from the URL / Subscribe from web option",
  subscribeOtherStepPaste: "Paste the URL and confirm",
  subscribeOtherPasteLabel: "Copy and paste the URL into your calendar:",
  specificGroups: "Specific groups",
  specificGroupsPreferencesDescription: "Continue with your general preferences or mark one or more specific group(s) as preferred",
  specificGroupsPreferencesHappy: "I am happy with my general preferences",
  specificGroupsPreferencesSpecific: "I want to submit preferences for specific groups",
  navigate: "Navigate to",
  newChanges: "new changes",
  next: "Next",
  noActivities: "No Activities",
  noBookings: "You have no bookings",
  noData: "No data",
  noEnrolledCourses: "No Enrolled Courses",
  bookingsBefore: "Bookings before {0} are not available.",
  bookingsAfter: "Bookings after {0} are not available.",
  noNotifications: "No notifications",
  noPermission: "You don't have permission to perform this action",
  noPreference: "No preference",
  noSchedule: "No schedule",
  noSchedulePreferencesSaved: "No preferences submitted",
  noStudentObject: "There is no student object connected to your user.",
  noSeatsLeft: "No seats left",
  notAllocated: "Not Allocated",
  notEnoughSpaceOnPossibleProposal: "No seats in proposal",
  notRegistered: "Not Registered",
  noticeText: "Notices",
  optionsAvailable: "options available",
  optionsAvailableNone: "No options available",
  optionsAvailableOne: "1 option available",
  pleaseTryAgain: "Please try again",
  populateCache: "Populate Cache",
  preferencesSaved: "Preferences saved",
  preferredGroup: "Preferred",
  preferredGroupsCount: "{0} preferred",
  preferredGroups: "Preferred groups",
  preferThisGroup: "I prefer this",
  previous: "Previous",
  register: "Register",
  registerToClasses: "Register to the classes that fit your preferences",
  registered: "Registered",
  registration: "Registration",
  registrationClosed: "Registration closed",
  registrationInfo: "Registration",
  registrationOpen: "Registration is open for",
  registrationOpenUntil: "Registration open until",
  registrationOpens: "Registration opens",
  registrationPeriodErrorText: "The registration period for this group is closed",
  registrationPeriodErrorTitle: "Registration period closed",
  relation: "Relation",
  rename: "Rename",
  restoreNotifications: "Restore closed notifications",
  retry: "Retry",
  save: "Save",
  savePreferencesSummaryDescription: "You are about to save the following schedule preferences.",
  schedule: "Schedule",
  schedulePreferences: "Schedule preferences",
  schedulePreferencesDisclaimer: "While we cannot guarantee that your schedule will meet all of your preferences, we will make every effort to accommodate your requests.",
  seatNumber: "Seat number",
  seat: "Seat",
  select: "Select",
  selectPreferencesDescription: "Select from available options to let us know what you prefer.",
  setDefault: "Set as Default",
  setTypeWarning: "You have fields mapped on this type. Remove them before switching.",
  settings: "Settings",
  showMore: "+{0} more",
  sizeErrorText: "Please select another one",
  sizeErrorTitle: "Option is full",
  sortBy: "Sort by",
  submit: "Submit",
  summary: "Summary",
  swap: "Swap",
  teServerDown: "There appears to be a problem connecting to the server. Try again in a moment",
  textview: "List",
  time: "Time",
  timeOfDay: "Time of day",
  timeOfDayTooltip: "The time of day you prefer to be scheduled",
  today: "Today",
  typeList: "{0} list",
  unknownIssue: "Something went wrong when fetching details about this issue.",
  waitlist: "Waitlist",
  week: "Week",
  welcome: "Welcome",
  welcomeTo: "Welcome to",
  youHave: "You have",
  digitalResources: "Digital resources",
  generalInfo: "General information",
  ...gU,
  ...yU,
  examsUnavailableText: "Your assessments could not be loaded right now. The rest of your schedule is shown below.",
  examsUnavailableTitle: "Assessment information unavailable",
  configurationErrorText: "Your schedule is not fully set up. Please contact your administrator.",
  configurationErrorTitle: "Configuration problem",
  noStudentObjectTitle: "No schedule connected",
  somethingWentWrong: "Something went wrong"
}, bU = {
  [C.EApplicationObjectTypeGroup.NONE]: "Ingen",
  [C.EApplicationObjectTypeGroup.ROOM]: "Rum",
  [C.EApplicationObjectTypeGroup.PROFESSOR]: "Professor",
  [C.EApplicationObjectTypeGroup.COURSE]: "Kurs",
  [C.EApplicationObjectTypeGroup.COURSE_INFORMATION]: "Kursinformation",
  [C.EApplicationObjectTypeGroup.INVOICING]: "Fakturering",
  [C.EApplicationObjectTypeGroup.STUDENT_SET]: "Studentset",
  [C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP]: "Studentsetgrupp",
  [C.EApplicationObjectTypeGroup.PROGRAM]: "Program",
  [C.EApplicationObjectTypeGroup.ACTIVITY_TYPE]: "Activitetsgrupp",
  [C.EApplicationObjectTypeGroup.STUDENT]: "Student",
  [C.EApplicationObjectTypeGroup.INVIGILATOR]: "Tentamensvakt",
  [C.EApplicationObjectTypeGroup.STAFF]: "Personal",
  [C.EApplicationObjectTypeGroup.CHANGE_REQUEST]: "Förändringsförfrågning"
}, AU = {
  [C.EAppProperties.NONE]: "Inget",
  [C.EAppProperties.NAME]: "Namn",
  [C.EAppProperties.LABEL]: "Etikett",
  [C.EAppProperties.EMAIL]: "Epost",
  [C.EAppProperties.FIRST_NAME]: "Förnamn",
  [C.EAppProperties.LAST_NAME]: "Efternamn",
  [C.EAppProperties.ROOM_TYPE]: "Rumstyp",
  [C.EAppProperties.BUILDING]: "Byggnad",
  [C.EAppProperties.CAMPUS]: "Campus",
  [C.EAppProperties.REASONABLE_ADJUSTMENT]: "Rimlig justering",
  [C.EAppProperties.TITLE]: "Titel",
  [C.EAppProperties.ID]: "Id",
  [C.EAppProperties.SEMESTER]: "Termin",
  [C.EAppProperties.MAX_STUDENTS]: "Max antal studenter",
  [C.EAppProperties.ACTIVITY_TYPE]: "Aktivitetstyp",
  [C.EAppProperties.START_DATE]: "Startdatum",
  [C.EAppProperties.END_DATE]: "Slutdatum",
  [C.EAppProperties.BUFFER]: "Buffer",
  [C.EAppProperties.HIDETRACK]: "Gömt",
  [C.EAppProperties.DEDICATETRACK]: "Tilldelat",
  [C.EAppProperties.TRACK]: "Grupp",
  [C.EAppProperties.ROOM_NAME]: "Rumsnamn",
  [C.EAppProperties.SEATS]: "Kapacitet",
  [C.EAppProperties.COURSE_OCCURENCE]: "Kurstillfälle",
  [C.EAppProperties.PLANNED_SIZE]: "Planerad storlek",
  [C.EAppProperties.PROGRAM]: "Program"
}, vU = {
  action: "Handling",
  actionNeeded: "Handling erfordras",
  activityWaitlistDescription: "Studenter i (minst en) väntelista",
  addRow: "Lägg till rad",
  addToWaitlist: "Lägg till på väntelista",
  addWaitlistErrorTitle: "Kunde inte gå med i väntelistan",
  admin: "Admin",
  afternoon: "Eftermiddag",
  agenda: "Agenda",
  allocated: "Allokerad",
  allocating: "Allokerar",
  allocation: "Allokering",
  availableAt: "Tillgänglig {0}",
  chooseSettings: "Välj inställningar",
  clash: "Schemakonflikt",
  clashMessage: "Det finns en konflikt mellan följande registrationer",
  classType: "Kurstillfälle",
  closed: "Stängd",
  completed: "Completed",
  conflict: "Konflikt",
  conflictErrorText: "Vänligen välj ett annat alternativ",
  conflictErrorTitle: "Konflikt",
  copy: "Kopiera",
  copyURL: "Kopiera URL",
  create: "Skapa",
  dataIssueText: "{0} data",
  date: "Datum",
  dates: "Datum",
  day: "Dag",
  days: "Dagar",
  deallocate: "Avregistrera",
  deallocateConfirm: "Är du säker på att du vill avregistrera?",
  dedicateTo: "Dedikera till",
  dedicatedErrorText: "Detta alternativ är tilldelat för andra student grupper",
  dedicatedErrorTitle: "Tilldelat alternativ",
  defaultServerErrorMessage: "Det verkar vara ett problem med att ansluta till servern. Vänligen försök igen.",
  delete: "Radera",
  deleteSelected: "Rader markerade",
  distribution: "Fördelning",
  done: "Klar",
  doubleBookedErrorText: "Vänligen avregistrera från denna aktivitet innan du väljer ett annat alternativ",
  doubleBookedErrorTitle: "Redan registrerad på denna aktivitet",
  duration: "Varaktighet",
  building: "Byggnad",
  equipment: "Utrustning",
  location: "Plats",
  staff: "Personal",
  link: "Länk",
  meetingLink: "Möteslänk",
  recording: "Inspelning",
  roomDetails: "Rumsdetaljer",
  details: "Detaljer för {0}",
  detailsFor: "Detaljer för {0} {1}",
  viewOnMap: "Visa på karta",
  editSchedulePreferences: "Redigera schemapreferenser",
  editSettings: "Ändra inställningar",
  errorInAllocate: "Fel i Allocate",
  errorInRegistration: "Fel vid registrering",
  errorInSchedulePreferences: "Fel vid schemapreferenser",
  errorInSchedule: "Fel vid mitt schema",
  failed: "Misslyckad",
  failedAllocationProposals: "Misslyckade allokeringsförslag",
  generalPreferences: "Allmänna preferenser",
  generating: "Genererar",
  getLinkingGroupsFailed: "Hittade inga länkade grupper",
  graphicalview: "Kalender",
  groups: "Grupper",
  hiddenErrorText: "Vänligen välj ett annat alternativ",
  hiddenErrorTitle: "Dolt alternativ",
  highDemandErrorTitle: "Hög efterfrågan",
  home: "Hem",
  impossibleInCurrentProposal: "Omöjligt i förslaget",
  impossibleProposal: "Omöjligt",
  inWaitlist: "På väntelista",
  inWaitlistTooltip: "På väntelista för denna gruppen",
  invalidActivityType: "Ogiltig '{0}'. 1 förväntad '{0}', hittade {1}.",
  invalidCourseIds: "Ogiltiga '{0}'-relationer. 1 förväntat '{0}'-relationer, hittade {1}.",
  issue: "Problem",
  issues: "Problem",
  lastRegistrationDate: "Sista datum för registrering",
  lastUpdatedAt: "Senaste ändringen {0}",
  leaveWaitlist: "Lämna väntelista",
  loadBookingsFailed: "Kunde inte ladda bokningar",
  loadEarlierBookings: "Ladda tidigare bokningar",
  leaveWaitlistConfirmText: "Du kommer att förlora din plats i kön för {0}, {1}.",
  leaveWaitlistConfirmTitle: "Är du säker på att du vill lämna väntelistan?",
  leavingWaitlistDescription: "På väntelista till andra grupper",
  clickToLeaveWaitlist: "Klicka för att lämna lämna väntelistan.",
  clickToDeregister: "Klicka för att avregistrera.",
  clickToPrefer: "Klicka för att markera som föredragen.",
  clickToUnprefer: "Klicka för att ta bort önskemålet.",
  registerTo: "Registrera till",
  linkedRulesFailed: "Studenter kommer inte att allokeras till dessa grupper. Länkade grupper matchar inte.",
  loading: "Laddar...",
  logout: "Logga ut",
  month: "Månad",
  moreInformation: "Mer information",
  moreInformationAvailableAt: "Mer information tillgänglig {0}",
  morning: "Förmiddag",
  multipleAllocations: "Flertal registreringar",
  multipleMessage: "Följande aktiviteter har flera registrerade spår",
  mySchedule: "Schema",
  subscribe: "Prenumerera",
  goBackToSchedule: "Gå tillbaka till ditt schema",
  subscribeDescription: "Prenumerera på ditt schema och få automatiska uppdateringar i din kalenderapplikation",
  subscribeSelectCal: "Välj din kalender",
  subscribeApple: "Kalender på iPhone eller Mac",
  subscribeGoogle: "Google Calendar",
  subscribeOther: "Annan kalender",
  subscribeGoogleInfo: "Hur ofta din kalender uppdateras bestäms av Google Kalender, vanligtvis var 12–24:e timme.",
  subscribeAppleInfo: "Hur ofta din kalender uppdateras bestäms av appen Kalender på iPhone eller Mac, vanligtvis en gång i timmen.",
  subscribeOtherInfo: "Hur ofta din kalender uppdateras bestäms av din kalenderleverantör, vanligtvis med några timmars mellanrum.",
  subscribeStepClickSubscribe: 'Klicka på "Prenumerera"-knappen',
  subscribeHowTo: "Så här lägger du till prenumerationen:",
  subscribeAppleDescription: "Prenumerera på ditt schema i Kalender på iOS eller macOS",
  subscribeAppleStepComplete: "Slutför dialogen när Kalender öppnas",
  subscribeGoogleDescription: "Prenumerera på ditt schema i Google Calendar",
  subscribeGoogleStepAdd: 'Klicka på "Lägg till" när dialogen i Google Calendar öppnas',
  subscribeOtherIntro: "Slutför stegen för att lägga till prenumerationen",
  subscribeOtherStepCopyUrl: "Kopiera kalender-URL:en",
  subscribeOtherStepOpenApp: "Öppna din kalenderapplikation",
  subscribeOtherStepFindOption: "Hitta alternativet för att lägga till en kalender. Det är oftast märkt Lägg till kalender, Prenumerera eller visas som en +-ikon",
  subscribeOtherStepChooseUrl: "Välj alternativet URL / Prenumerera från webben",
  subscribeOtherStepPaste: "Klistra in URL:en och bekräfta",
  subscribeOtherPasteLabel: "Kopiera och klistra in URL:en i din kalender:",
  specificGroups: "Specifika grupper",
  specificGroupsPreferencesDescription: "Fortsätt med dina allmänna önskemål eller markera en eller flera specifika grupper som föredragna",
  specificGroupsPreferencesHappy: "Jag är nöjd med mina allmänna önskemål",
  specificGroupsPreferencesSpecific: "Jag vill lämna önskemål för specifika grupper",
  navigate: "Navigera till",
  newChanges: "new changes",
  next: "Nästa",
  noActivities: "Inga aktiviteter",
  noBookings: "Du har inga bokningar",
  noData: "Ingen data",
  noEnrolledCourses: "Inga registrerade kurser",
  bookingsBefore: "Bokningar före {0} är inte tillgängliga.",
  bookingsAfter: "Bokningar efter {0} är inte tillgängliga.",
  noNotifications: "Inga notiser",
  noPermission: "Du har inte behörighet att utföra denna åtgärd",
  noPreference: "Ingen preferens",
  noSchedule: "Inget schema",
  noSchedulePreferencesSaved: "Inga preferenser inlämnade",
  noStudentObject: "Inget studentobjekt är kopplat till din användare.",
  noSeatsLeft: "Inga platser kvar",
  notAllocated: "Inte allokerad",
  notEnoughSpaceOnPossibleProposal: "Inga platser i förslaget",
  notRegistered: "Inte Registrerad",
  noticeText: "Notiser",
  optionsAvailable: "Tillgängliga alternativ",
  optionsAvailableNone: "Inga alternativ",
  optionsAvailableOne: "1 tillgängligt alternativ",
  pleaseTryAgain: "Var god och försök igen",
  populateCache: "Populera cachen",
  preferencesSaved: "Preferenser sparade",
  preferredGroup: "Föredragen",
  preferredGroupsCount: "{0} föredragna",
  preferredGroups: "Föredragna grupper",
  preferThisGroup: "Jag föredrar denna",
  previous: "Föregående",
  register: "Registrera",
  registerToClasses: "Registrera till de kurser som passar dina preferenser",
  registered: "Registrerad",
  registration: "Registrering",
  registrationClosed: "Registrering stängd",
  registrationInfo: "Registreringsinfo",
  registrationOpen: "Registrering öppen för",
  registrationOpenUntil: "Registrering öppen till",
  registrationOpens: "Registrering öppnar",
  registrationPeriodErrorText: "Registreringsperioden för denna grupp är stängd",
  registrationPeriodErrorTitle: "Registreringsperioden är stängd",
  relation: "Relation",
  rename: "Döp om",
  restoreNotifications: "Återställ stängda notiser",
  retry: "Försök igen",
  save: "Spara",
  savePreferencesSummaryDescription: "Du är på väg att spara följande schemapreferenser.",
  schedule: "Schema",
  schedulePreferences: "Schemapreferenser",
  schedulePreferencesDisclaimer: "Vi kan inte garantera att ditt schema kommer att uppfylla alla dina preferenser, men vi kommer att göra vårt bästa för att tillgodose dina önskemål.",
  seatNumber: "Platsnummer",
  seat: "Plats",
  select: "Välj",
  selectPreferencesDescription: "Välj bland tillgängliga alternativ för att meddela oss vad du föredrar.",
  setDefault: "Sätt som förval",
  setTypeWarning: "Du har fält mappade för den här typen. Ta bort dem innan du byter typ.",
  settings: "Inställningar",
  showMore: "+{0} till",
  sizeErrorText: "Vänligen välj ett annat alternativ",
  sizeErrorTitle: "Alternativet är fullt",
  sortBy: "Sortera efter",
  submit: "Skicka",
  summary: "Sammanfattning",
  swap: "Byt",
  teServerDown: "Det verkar vara ett problem att ansluta till servern. Försök igen om en stund",
  textview: "Lista",
  time: "Tid",
  timeOfDay: "Tid på dagen",
  timeOfDayTooltip: "Vilken tid du föredrar att bli schemalagd",
  today: "Idag",
  typeList: "{0}-lista",
  unknownIssue: "Något gick fel med att hämta detaljer om problemet.",
  waitlist: "Väntelista",
  week: "Vecka",
  welcome: "Välkommen",
  welcomeTo: "Välkommen till",
  youHave: "Du har",
  digitalResources: "Digitala resurser",
  generalInfo: "Generell information",
  ...bU,
  ...AU,
  examsUnavailableText: "Dina tentamensbokningar kunde inte hämtas just nu. Resten av ditt schema visas nedan.",
  examsUnavailableTitle: "Tentamensinformation ej tillgänglig",
  configurationErrorText: "Ditt schema är inte färdigkonfigurerat. Kontakta din administratör.",
  configurationErrorTitle: "Konfigurationsproblem",
  noStudentObjectTitle: "Inget schema kopplat",
  somethingWentWrong: "Något gick fel"
}, ll = {
  en: TU,
  sv: vU
}, cl = "en";
let Se = ll[cl];
function g4() {
  return {
    no_preference: Se.noPreference,
    morning: Se.morning,
    afternoon: Se.afternoon
  };
}
function y4(e) {
  return OD.validate(e) ? (Se = ll[e], { translations: Se, currentLanguage: e }) : (Se = ll[cl], { translations: Se, currentLanguage: cl });
}
function SU(e, t) {
  return e instanceof t || e instanceof Error && e.name === t.errorName;
}
function Gr(e, t) {
  return !!db(e)[t];
}
function T4(e) {
  switch (Gn(e)) {
    case ue.NoStudentObjectError:
    case ue.PacemakerFetchError:
      return "warn";
    default:
      return "error";
  }
}
function b4(e) {
  switch (e.kind) {
    case "failedGroups": {
      const { failedGroups: t } = e;
      let r = ue.Error, n;
      return Object.keys(t).forEach((i) => {
        var l, f, u, h;
        const o = (l = t[i]) == null ? void 0 : l.find(
          (E) => D(E.reasons) && (D(E.reasons.failsWithMessage) || D(E.reasons.failsWithGroups))
        ), s = (u = (f = o == null ? void 0 : o.reasons) == null ? void 0 : f.failsWithMessage) == null ? void 0 : u.systemError;
        if (D(s)) {
          const E = Object.values(s)[0];
          D(E) && (n = E.message, r = E.name);
          return;
        }
        const a = (h = o == null ? void 0 : o.reasons) == null ? void 0 : h.failsWithGroups;
        D(a) && (n = Object.keys(a)[0]);
      }), xm(r, n, e.logId);
    }
    case "error": {
      const t = Gn(e.error), r = Zo(e.error), n = pb(e.error, t, r), i = Fj(e.error);
      return xm(
        // A MultiError only counts as a known error when all its causes agree
        t === ue.MultiError ? n.errorName : e.error,
        Nt(e.error),
        xe(i) ? i[0] : i
      );
    }
    case "sourceFailure":
      return OU(e.failure, e.logId);
    default:
      return mt();
  }
}
function xm(e, t, r) {
  return IU(e, r) ?? _U(t) ?? RU(t, r);
}
function IU(e, t) {
  if (Gr(e, ue.HeavyLoadError))
    return {
      title: Se.highDemandErrorTitle,
      text: Se.pleaseTryAgain,
      knownError: !0,
      logId: void 0
    };
  if (Gr(e, ue.PermissionError))
    return {
      title: "Permission Error",
      text: Se.noPermission,
      knownError: !0,
      logId: t
    };
  if (Gr(e, ue.AddWaitlistError))
    return {
      title: Se.addWaitlistErrorTitle,
      text: Se.pleaseTryAgain,
      knownError: !0,
      logId: t
    };
  if (Gr(e, ue.NoStudentObjectError))
    return {
      title: Se.noStudentObjectTitle,
      text: Se.noStudentObject,
      knownError: !0,
      logId: void 0
    };
  if (Gr(e, ue.AdminConfigurationError) || Gr(e, ue.StudentSetGroupConfigurationError))
    return {
      title: Se.configurationErrorTitle,
      text: Se.configurationErrorText,
      knownError: !0,
      logId: t
    };
  if (Gr(e, ue.MaximumMembershipReachedError) || Gr(e, ue.MaximumMembershipReachedByTypeError))
    return {
      title: Se.sizeErrorTitle,
      text: Se.sizeErrorText,
      knownError: !0,
      logId: void 0
    };
}
function _U(e) {
  return D(e) && wU(e) ? NU(e) : void 0;
}
function RU(e, t) {
  return {
    title: Se.somethingWentWrong,
    // Nothing was said about why, so there is no server problem to point at.
    text: D(e) ? Se.defaultServerErrorMessage : Se.pleaseTryAgain,
    knownError: !1,
    logId: t
  };
}
function OU(e, t) {
  switch (e.source) {
    case "exam":
      return {
        title: Se.examsUnavailableTitle,
        text: Se.examsUnavailableText,
        knownError: !0,
        logId: t
      };
    default:
      return mt(e.source);
  }
}
function wU(e) {
  return e === "buffer" || e === "conflict" || e === "dedicated" || e === "dedicatedSize" || e === "doubleBooked" || e === "size" || e === "hidden" || e === "registrationPeriod";
}
function NU(e) {
  switch (e) {
    case "buffer":
    case "size":
      return {
        title: Se.sizeErrorTitle,
        text: Se.sizeErrorText,
        knownError: !0,
        logId: void 0
      };
    case "dedicated":
      return {
        title: Se.dedicatedErrorTitle,
        text: Se.dedicatedErrorText,
        knownError: !0,
        logId: void 0
      };
    // Double booked should never be an issue, but should cover the case if it does.
    case "doubleBooked":
      return {
        title: Se.doubleBookedErrorTitle,
        text: Se.doubleBookedErrorText,
        knownError: !0,
        logId: void 0
      };
    // Conflict should never be an issue, but should cover the case if it does.
    case "conflict":
      return {
        title: Se.conflictErrorTitle,
        text: Se.conflictErrorText,
        knownError: !0,
        logId: void 0
      };
    // Hidden should never be an issue, but should cover the case if it does.
    case "hidden":
      return {
        title: Se.hiddenErrorTitle,
        text: Se.hiddenErrorText,
        knownError: !0,
        logId: void 0
      };
    case "registrationPeriod":
      return {
        title: Se.registrationPeriodErrorTitle,
        text: Se.registrationPeriodErrorText,
        knownError: !0,
        logId: void 0
      };
    default:
      return mt();
  }
}
function A4() {
  const e = /* @__PURE__ */ new Map(), t = (r, n) => `${r}\0${n}`;
  return {
    add({ source: r, reason: n, error: i, subject: o }) {
      const s = t(r, n);
      let a = e.get(s);
      if (!D(a)) {
        const l = D(i) ? qj(i) : void 0;
        a = {
          failure: {
            source: r,
            reason: n,
            status: l == null ? void 0 : l.code,
            error: D(l) ? { message: l.message, errorName: l.errorName } : void 0
          },
          subjects: /* @__PURE__ */ new Set()
        }, e.set(s, a);
      }
      D(o) && a.subjects.add(o);
    },
    get store() {
      const r = [...e.values()].map(
        ({ failure: i, subjects: o }) => o.size > 0 ? { ...i, subjects: [...o] } : i
      ), n = CU(r);
      return {
        hasFailures: r.length > 0,
        failures: r,
        // Left out rather than reported as empty. Claiming nothing was
        // affected is not the same as not knowing what was.
        subjects: n.length > 0 ? n : void 0,
        totalAffectedSubjects: n.length > 0 ? n.length : void 0
      };
    }
  };
}
function CU(e) {
  const t = /* @__PURE__ */ new Set();
  for (const r of e)
    for (const n of r.subjects ?? [])
      t.add(n);
  return [...t];
}
var vs = { exports: {} }, PU = vs.exports, km;
function Eb() {
  return km || (km = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(PU, (function() {
      var r = 1e3, n = 6e4, i = 36e5, o = "millisecond", s = "second", a = "minute", l = "hour", f = "day", u = "week", h = "month", E = "quarter", d = "year", g = "date", y = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(B) {
        var L = ["th", "st", "nd", "rd"], G = B % 100;
        return "[" + B + (L[(G - 20) % 10] || L[G] || L[0]) + "]";
      } }, w = function(B, L, G) {
        var Z = String(B);
        return !Z || Z.length >= L ? B : "" + Array(L + 1 - Z.length).join(G) + B;
      }, P = { s: w, z: function(B) {
        var L = -B.utcOffset(), G = Math.abs(L), Z = Math.floor(G / 60), V = G % 60;
        return (L <= 0 ? "+" : "-") + w(Z, 2, "0") + ":" + w(V, 2, "0");
      }, m: function B(L, G) {
        if (L.date() < G.date()) return -B(G, L);
        var Z = 12 * (G.year() - L.year()) + (G.month() - L.month()), V = L.clone().add(Z, h), te = G - V < 0, ee = L.clone().add(Z + (te ? -1 : 1), h);
        return +(-(Z + (G - V) / (te ? V - ee : ee - V)) || 0);
      }, a: function(B) {
        return B < 0 ? Math.ceil(B) || 0 : Math.floor(B);
      }, p: function(B) {
        return { M: h, y: d, w: u, d: f, D: g, h: l, m: a, s, ms: o, Q: E }[B] || String(B || "").toLowerCase().replace(/s$/, "");
      }, u: function(B) {
        return B === void 0;
      } }, _ = "en", v = {};
      v[_] = S;
      var M = "$isDayjsObject", x = function(B) {
        return B instanceof X || !(!B || !B[M]);
      }, z = function B(L, G, Z) {
        var V;
        if (!L) return _;
        if (typeof L == "string") {
          var te = L.toLowerCase();
          v[te] && (V = te), G && (v[te] = G, V = te);
          var ee = L.split("-");
          if (!V && ee.length > 1) return B(ee[0]);
        } else {
          var Q = L.name;
          v[Q] = L, V = Q;
        }
        return !Z && V && (_ = V), V || !Z && _;
      }, F = function(B, L) {
        if (x(B)) return B.clone();
        var G = typeof L == "object" ? L : {};
        return G.date = B, G.args = arguments, new X(G);
      }, W = P;
      W.l = z, W.i = x, W.w = function(B, L) {
        return F(B, { locale: L.$L, utc: L.$u, x: L.$x, $offset: L.$offset });
      };
      var X = (function() {
        function B(G) {
          this.$L = z(G.locale, null, !0), this.parse(G), this.$x = this.$x || G.x || {}, this[M] = !0;
        }
        var L = B.prototype;
        return L.parse = function(G) {
          this.$d = (function(Z) {
            var V = Z.date, te = Z.utc;
            if (V === null) return /* @__PURE__ */ new Date(NaN);
            if (W.u(V)) return /* @__PURE__ */ new Date();
            if (V instanceof Date) return new Date(V);
            if (typeof V == "string" && !/Z$/i.test(V)) {
              var ee = V.match(b);
              if (ee) {
                var Q = ee[2] - 1 || 0, re = (ee[7] || "0").substring(0, 3);
                return te ? new Date(Date.UTC(ee[1], Q, ee[3] || 1, ee[4] || 0, ee[5] || 0, ee[6] || 0, re)) : new Date(ee[1], Q, ee[3] || 1, ee[4] || 0, ee[5] || 0, ee[6] || 0, re);
              }
            }
            return new Date(V);
          })(G), this.init();
        }, L.init = function() {
          var G = this.$d;
          this.$y = G.getFullYear(), this.$M = G.getMonth(), this.$D = G.getDate(), this.$W = G.getDay(), this.$H = G.getHours(), this.$m = G.getMinutes(), this.$s = G.getSeconds(), this.$ms = G.getMilliseconds();
        }, L.$utils = function() {
          return W;
        }, L.isValid = function() {
          return this.$d.toString() !== y;
        }, L.isSame = function(G, Z) {
          var V = F(G);
          return this.startOf(Z) <= V && V <= this.endOf(Z);
        }, L.isAfter = function(G, Z) {
          return F(G) < this.startOf(Z);
        }, L.isBefore = function(G, Z) {
          return this.endOf(Z) < F(G);
        }, L.$g = function(G, Z, V) {
          return W.u(G) ? this[Z] : this.set(V, G);
        }, L.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, L.valueOf = function() {
          return this.$d.getTime();
        }, L.startOf = function(G, Z) {
          var V = this, te = !!W.u(Z) || Z, ee = W.p(G), Q = function(Ve, Ie) {
            var $e = W.w(V.$u ? Date.UTC(V.$y, Ie, Ve) : new Date(V.$y, Ie, Ve), V);
            return te ? $e : $e.endOf(f);
          }, re = function(Ve, Ie) {
            return W.w(V.toDate()[Ve].apply(V.toDate("s"), (te ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Ie)), V);
          }, ne = this.$W, Ee = this.$M, be = this.$D, Be = "set" + (this.$u ? "UTC" : "");
          switch (ee) {
            case d:
              return te ? Q(1, 0) : Q(31, 11);
            case h:
              return te ? Q(1, Ee) : Q(0, Ee + 1);
            case u:
              var Ue = this.$locale().weekStart || 0, Le = (ne < Ue ? ne + 7 : ne) - Ue;
              return Q(te ? be - Le : be + (6 - Le), Ee);
            case f:
            case g:
              return re(Be + "Hours", 0);
            case l:
              return re(Be + "Minutes", 1);
            case a:
              return re(Be + "Seconds", 2);
            case s:
              return re(Be + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, L.endOf = function(G) {
          return this.startOf(G, !1);
        }, L.$set = function(G, Z) {
          var V, te = W.p(G), ee = "set" + (this.$u ? "UTC" : ""), Q = (V = {}, V[f] = ee + "Date", V[g] = ee + "Date", V[h] = ee + "Month", V[d] = ee + "FullYear", V[l] = ee + "Hours", V[a] = ee + "Minutes", V[s] = ee + "Seconds", V[o] = ee + "Milliseconds", V)[te], re = te === f ? this.$D + (Z - this.$W) : Z;
          if (te === h || te === d) {
            var ne = this.clone().set(g, 1);
            ne.$d[Q](re), ne.init(), this.$d = ne.set(g, Math.min(this.$D, ne.daysInMonth())).$d;
          } else Q && this.$d[Q](re);
          return this.init(), this;
        }, L.set = function(G, Z) {
          return this.clone().$set(G, Z);
        }, L.get = function(G) {
          return this[W.p(G)]();
        }, L.add = function(G, Z) {
          var V, te = this;
          G = Number(G);
          var ee = W.p(Z), Q = function(Ee) {
            var be = F(te);
            return W.w(be.date(be.date() + Math.round(Ee * G)), te);
          };
          if (ee === h) return this.set(h, this.$M + G);
          if (ee === d) return this.set(d, this.$y + G);
          if (ee === f) return Q(1);
          if (ee === u) return Q(7);
          var re = (V = {}, V[a] = n, V[l] = i, V[s] = r, V)[ee] || 1, ne = this.$d.getTime() + G * re;
          return W.w(ne, this);
        }, L.subtract = function(G, Z) {
          return this.add(-1 * G, Z);
        }, L.format = function(G) {
          var Z = this, V = this.$locale();
          if (!this.isValid()) return V.invalidDate || y;
          var te = G || "YYYY-MM-DDTHH:mm:ssZ", ee = W.z(this), Q = this.$H, re = this.$m, ne = this.$M, Ee = V.weekdays, be = V.months, Be = V.meridiem, Ue = function(Ie, $e, Ne, Re) {
            return Ie && (Ie[$e] || Ie(Z, te)) || Ne[$e].slice(0, Re);
          }, Le = function(Ie) {
            return W.s(Q % 12 || 12, Ie, "0");
          }, Ve = Be || function(Ie, $e, Ne) {
            var Re = Ie < 12 ? "AM" : "PM";
            return Ne ? Re.toLowerCase() : Re;
          };
          return te.replace(I, (function(Ie, $e) {
            return $e || (function(Ne) {
              switch (Ne) {
                case "YY":
                  return String(Z.$y).slice(-2);
                case "YYYY":
                  return W.s(Z.$y, 4, "0");
                case "M":
                  return ne + 1;
                case "MM":
                  return W.s(ne + 1, 2, "0");
                case "MMM":
                  return Ue(V.monthsShort, ne, be, 3);
                case "MMMM":
                  return Ue(be, ne);
                case "D":
                  return Z.$D;
                case "DD":
                  return W.s(Z.$D, 2, "0");
                case "d":
                  return String(Z.$W);
                case "dd":
                  return Ue(V.weekdaysMin, Z.$W, Ee, 2);
                case "ddd":
                  return Ue(V.weekdaysShort, Z.$W, Ee, 3);
                case "dddd":
                  return Ee[Z.$W];
                case "H":
                  return String(Q);
                case "HH":
                  return W.s(Q, 2, "0");
                case "h":
                  return Le(1);
                case "hh":
                  return Le(2);
                case "a":
                  return Ve(Q, re, !0);
                case "A":
                  return Ve(Q, re, !1);
                case "m":
                  return String(re);
                case "mm":
                  return W.s(re, 2, "0");
                case "s":
                  return String(Z.$s);
                case "ss":
                  return W.s(Z.$s, 2, "0");
                case "SSS":
                  return W.s(Z.$ms, 3, "0");
                case "Z":
                  return ee;
              }
              return null;
            })(Ie) || ee.replace(":", "");
          }));
        }, L.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, L.diff = function(G, Z, V) {
          var te, ee = this, Q = W.p(Z), re = F(G), ne = (re.utcOffset() - this.utcOffset()) * n, Ee = this - re, be = function() {
            return W.m(ee, re);
          };
          switch (Q) {
            case d:
              te = be() / 12;
              break;
            case h:
              te = be();
              break;
            case E:
              te = be() / 3;
              break;
            case u:
              te = (Ee - ne) / 6048e5;
              break;
            case f:
              te = (Ee - ne) / 864e5;
              break;
            case l:
              te = Ee / i;
              break;
            case a:
              te = Ee / n;
              break;
            case s:
              te = Ee / r;
              break;
            default:
              te = Ee;
          }
          return V ? te : W.a(te);
        }, L.daysInMonth = function() {
          return this.endOf(h).$D;
        }, L.$locale = function() {
          return v[this.$L];
        }, L.locale = function(G, Z) {
          if (!G) return this.$L;
          var V = this.clone(), te = z(G, Z, !0);
          return te && (V.$L = te), V;
        }, L.clone = function() {
          return W.w(this.$d, this);
        }, L.toDate = function() {
          return new Date(this.valueOf());
        }, L.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, L.toISOString = function() {
          return this.$d.toISOString();
        }, L.toString = function() {
          return this.$d.toUTCString();
        }, B;
      })(), de = X.prototype;
      return F.prototype = de, [["$ms", o], ["$s", s], ["$m", a], ["$H", l], ["$W", f], ["$M", h], ["$y", d], ["$D", g]].forEach((function(B) {
        de[B[1]] = function(L) {
          return this.$g(L, B[0], B[1]);
        };
      })), F.extend = function(B, L) {
        return B.$i || (B(L, X, F), B.$i = !0), F;
      }, F.locale = z, F.isDayjs = x, F.unix = function(B) {
        return F(1e3 * B);
      }, F.en = v[_], F.Ls = v, F.p = {}, F;
    }));
  })(vs)), vs.exports;
}
var DU = Eb();
const Lr = /* @__PURE__ */ kc(DU);
function gb(e) {
  return D(e) ? `${e}` : "";
}
function v4(e) {
  return D(e) ? e.length : 0;
}
function xr(e) {
  return D(e) ? !Yn(e) : !1;
}
function Yn(e) {
  return D(e) ? e.length === 0 : !1;
}
function S4(e) {
  return `${e.charAt(0).toUpperCase()}${e.substring(1).toLowerCase()}`;
}
function jc(e, t) {
  return e.filter(xr).join(t);
}
function I4(e, t) {
  const r = D(t) ? t : 40;
  return e.length > r ? `${e.substring(0, r)}...` : e;
}
function _4(e) {
  return e.replace(/[\r\n]+/gm, " ");
}
const jm = (e) => Yn(e) ? 1 : 0;
function R4(e, t) {
  return jm(e) - jm(t);
}
function O4(e, ...t) {
  if (!D(e)) return "";
  if (t.length > 0) {
    const r = t.length;
    let n, i;
    for (n = 0; n < r; n++)
      i = t[n].toString(), e = e.replaceAll(`{${n}}`, i);
  }
  return e;
}
const MU = 1e4, w4 = 1440 * 60;
function N4(e = 0) {
  return Math.round(e / 1e3);
}
function C4(e) {
  return e.getHours() === 0 && e.getMinutes() === 0 || e.getHours() === 23 && e.getMinutes() === 59;
}
function Um(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function P4(e, t) {
  return Math.abs(e.startOf("day").diff(t.startOf("day"), "day"));
}
function D4(e, t) {
  return Fm(e) !== Fm(t);
}
function M4(e, t) {
  return Um(e, t.start) || Um(e, t.end) ? !0 : LU(e, t);
}
function LU(e, t) {
  return t.start.getTime() <= e.getTime() && e.getTime() <= t.end.getTime();
}
function L4(e) {
  return D(e) ? e.local.replace("00:00:00", "").trim() : "";
}
function $m(e, t) {
  return Lr(oc(e, t).local).format("HH:mm");
}
function x4(e, t) {
  return Lr(oc(e, t).local).format("ddd MMM D");
}
function Fm(e) {
  return Lr(e.local).format("YYYY-MM-DD");
}
function k4(e, t, r) {
  return `${$m(e, r)} - ${$m(t, r)}`;
}
function j4(e, t) {
  return `${zm(e)} - ${zm(t)}`;
}
function zm(e) {
  return Lr(e.local).format("MMM D, HH:mm");
}
function xU(e) {
  return Lr(e.local).format("D MMM YYYY");
}
function fl(e) {
  return Lr(e.local).format("HH:mm");
}
function U4(e, t) {
  return `${fl(e)} - ${fl(t)}`;
}
function $4(e) {
  return `${xU(e)}, ${fl(e)}`;
}
function F4(e) {
  return !D(e) || Yn(e) ? "" : kU(UU(e)) + " " + jU(e);
}
function kU(e) {
  if (!D(e) || Yn(e)) return "";
  const [t, r, n] = e.split(/[/-]/);
  return `${n}-${r}-${t}`;
}
function jU(e) {
  if (!D(e) || Yn(e)) return "";
  const t = e.split(" ")[1];
  return D(t) ? t.substring(0, 5) : "";
}
function UU(e) {
  return !D(e) || Yn(e) ? "" : e.split(" ")[0];
}
const $U = (e, t, r, n) => {
  if (!e || !t) return Nr.enum.not_set;
  const i = Gs(e, r);
  if (!i.success)
    return Nr.enum.not_set;
  const o = Gs(t, r);
  return o.success ? !!i.data.unix && !!o.data.unix && i.data.unix < n && n < o.data.unix ? Nr.enum.open : Nr.enum.closed : Nr.enum.not_set;
}, Si = {
  local: "1970-01-01 00:00:00",
  timezone: "Europe/Berlin",
  unix: 1
};
function Gm(e) {
  return Si.unix !== e;
}
function Bm(e, t) {
  const r = Gs(e, t);
  return r.success ? r.data : Si;
}
const Ln = /* @__PURE__ */ new Map();
function FU(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "object" && e !== null;
}
const Vm = /* @__PURE__ */ new WeakMap();
let zU = 0;
function GU(e) {
  let t = Vm.get(e);
  return D(t) || (t = zU++, Vm.set(e, t)), t;
}
function BU(e, t) {
  const r = typeof e == "object" ? GU(e) : e;
  return `${t}\0${typeof e}\0${r}`;
}
function Gs(e, t) {
  if (!FU(e))
    return Oh(t).safeParse(e);
  const r = BU(e, t), n = Ln.get(r);
  if (D(n))
    return n;
  const i = Oh(t).safeParse(e);
  if (Ln.size >= MU) {
    const o = Ln.keys().next().value;
    D(o) && Ln.delete(o);
  }
  return Ln.set(r, i), i;
}
function z4() {
  return Ln.size;
}
function G4() {
  Ln.clear();
}
function VU({
  event: e,
  currentStart: t,
  currentEnd: r
}) {
  let n = t, i = r;
  return e.start.unix < n.unix && (n = e.start), e.end.unix > i.unix && (i = e.end), {
    start: n,
    end: i
  };
}
function B4({
  date: e,
  timezone: t,
  timezoneLabel: r,
  legacyTimestamp: n = ""
}) {
  if (e) {
    const i = e instanceof Date ? e : new Date(e), o = Math.floor(i.getTime() / 1e3), s = Gs(o, t);
    if (s.success) {
      const a = s.data.local;
      return r ? `${a} (${r})` : a;
    }
    return n;
  }
  return n;
}
function V4(e, t) {
  return e && t ? `${Lr(e).format("HH:mm")} – ${Lr(t).format("HH:mm")}` : "";
}
const W4 = "2024-08-05";
function Wm({
  events: e
}) {
  let t = { unix: 1 / 0, local: "" }, r = { unix: -1 / 0, local: "" };
  for (const n in e) {
    const i = e[n];
    if (!D(i) || !Gm(i.start.unix) || !Gm(i.end.unix)) continue;
    const o = VU({
      event: i,
      currentStart: t,
      currentEnd: r
    });
    t = o.start, r = o.end;
  }
  return { start: t, end: r };
}
function WU({
  events: e,
  studentSetGroupSet: t
}) {
  return t.size === 0 ? e : e.filter((r) => t.has(r.groupId));
}
function q4({
  registration: e,
  studentSetGroupIds: t
}) {
  const r = new Set(t), n = WU({
    events: e.events,
    studentSetGroupSet: r
  });
  if (n.length === 0) {
    const o = Wm({
      events: e.events
    });
    if (qm(o))
      return {
        min: o.start,
        max: o.end
      };
  }
  const i = Wm({
    events: n
  });
  return qm(i) ? {
    min: i.start,
    max: i.end
  } : {
    min: Si,
    max: Si
  };
}
function qm(e) {
  return e.start.unix !== 1 / 0 && e.end.unix !== -1 / 0;
}
var So = {}, Hm;
function qU() {
  if (Hm) return So;
  Hm = 1, Object.defineProperty(So, "__esModule", { value: !0 }), So.EAppEnv = void 0;
  var e;
  return (function(t) {
    t.BETA = "beta", t.STAGING = "staging", t.TEST = "test", t.PRODUCTION = "production", t.DEVELOPMENT = "development";
  })(e || (So.EAppEnv = e = {})), So;
}
var He = qU();
class No extends Error {
}
No.prototype.name = "InvalidTokenError";
function HU(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, r) => {
    let n = r.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function YU(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return HU(t);
  } catch {
    return atob(t);
  }
}
function ZU(e, t) {
  if (typeof e != "string")
    throw new No("Invalid token specified: must be a string");
  t || (t = {});
  const r = t.header === !0 ? 0 : 1, n = e.split(".")[r];
  if (typeof n != "string")
    throw new No(`Invalid token specified: missing part #${r + 1}`);
  let i;
  try {
    i = YU(n);
  } catch (o) {
    throw new No(`Invalid token specified: invalid base64 for part #${r + 1} (${o.message})`);
  }
  try {
    return JSON.parse(i);
  } catch (o) {
    throw new No(`Invalid token specified: invalid json for part #${r + 1} (${o.message})`);
  }
}
var fi = mb();
const JU = {
  [fi.ERegion.EU_EES]: "eu",
  [fi.ERegion.ANZ]: "anz",
  [fi.ERegion.SGP]: "sgp",
  [fi.ERegion.UK]: "uk"
}, di = "|_REGION_|", KU = (e, t) => {
  let r = e;
  if (D(t) && (r = e.replace(di, JU[t])), r.includes(di))
    throw new Error(
      `The URL '${r}' still contains the region placeholder: review the inputs to 'replaceRegionPlaceholder'.`
    );
  return r;
}, H4 = (e, t = console) => {
  if (e)
    try {
      const r = ZU(e), { region: n } = xy.parse(r);
      return n;
    } catch (r) {
      t.error(r);
      return;
    }
}, XU = (e, t, r) => {
  switch (t) {
    case He.EAppEnv.BETA:
      return `${r ? "wss" : "https"}://${e}.${di}.timeedit.dev`;
    case He.EAppEnv.STAGING:
      return `${r ? "wss" : "https"}://${e}.${di}.timeedit.io`;
    case He.EAppEnv.TEST:
      return `${r ? "wss" : "https"}://${e}.${di}.test.timeedit.net`;
    case He.EAppEnv.PRODUCTION:
      return `${r ? "wss" : "https"}://${e}.${di}.timeedit.net`;
    default:
      throw new Error(
        `Can't get regional Url. Not a valid environment: ${t}`
      );
  }
}, Y4 = ({
  environment: e,
  region: t,
  subdomain: r,
  localPort: n = 5173,
  websocket: i
}) => {
  if (t && e !== He.EAppEnv.DEVELOPMENT) {
    const s = XU(
      r,
      e,
      i
    );
    return KU(s, t);
  }
  if (typeof window > "u")
    throw new Error(
      "window is undefined. getRegionalUrlForEnv is not usable in a non-browser environment"
    );
  const o = `http://${window.location.hostname || "localhost"}:${n}`;
  return i ? o.replace("http", "ws") : o;
};
function Cr(e) {
  return e.replace(/^cloud_/, "");
}
function QU(e) {
  return e.replace(/^\//, "");
}
function Z4(e, t) {
  const r = QU(t);
  return D(e) && !r.startsWith(
    `${Cr(e)}`
  ) ? `/${Cr(
    e
  )}/${r}` : t;
}
function J4(e) {
  return e.replace(/^\/?\w+[^/]*\//, "/");
}
function K4(e) {
  if (e === He.EAppEnv.BETA) return "https://allocate.timeedit.dev/";
  if (e === He.EAppEnv.STAGING) return "https://allocate.timeedit.io/";
  if (e === He.EAppEnv.TEST) return "https://allocate.test.timeedit.net/";
  if (e === He.EAppEnv.PRODUCTION) return "https://allocate.timeedit.net/";
  if (e === He.EAppEnv.DEVELOPMENT) return "http://localhost:5174/";
  throw new Error(`Invalid environment: ${e}`);
}
function X4(e, t) {
  switch (e) {
    case He.EAppEnv.BETA:
      return `https://cloud.timeedit.dev/${Cr(
        t
      )}/web`;
    case He.EAppEnv.STAGING:
      return `https://cloud.timeedit.io/${Cr(
        t
      )}/web`;
    case He.EAppEnv.TEST:
      return `https://cloud.test.timeedit.net/${Cr(
        t
      )}/web`;
    case He.EAppEnv.PRODUCTION:
      return `https://cloud.timeedit.net/${Cr(
        t
      )}/web`;
    case He.EAppEnv.DEVELOPMENT:
      return `https://cloud.timeedit.dev/${Cr(
        t
      )}/web`;
    default:
      mt();
  }
}
function e2(e) {
  switch (e) {
    case He.EAppEnv.BETA:
      return "timeedit.dev";
    case He.EAppEnv.STAGING:
      return "timeedit.io";
    case He.EAppEnv.TEST:
      return "test.timeedit.net";
    case He.EAppEnv.PRODUCTION:
      return "timeedit.net";
    case He.EAppEnv.DEVELOPMENT:
      return "localhost";
    default:
      mt();
  }
}
function Q4(e, t) {
  return t ? e === He.EAppEnv.DEVELOPMENT ? `http://localhost:3004/${Cr(
    t
  )}` : `https://admin.${e2(e)}/${Cr(
    t
  )}` : "";
}
const eG = (e) => {
  if (!e || Yn(e)) return !1;
  try {
    const t = new URL(e);
    return t.protocol === "http:" || t.protocol === "https:";
  } catch {
    return !1;
  }
}, t2 = [
  8364,
  0,
  8218,
  402,
  8222,
  8230,
  8224,
  8225,
  710,
  8240,
  352,
  8249,
  338,
  0,
  381,
  0,
  0,
  8216,
  8217,
  8220,
  8221,
  8226,
  8211,
  8212,
  732,
  8482,
  353,
  8250,
  339,
  0,
  382,
  376
];
function yb(e) {
  return e === 0 || e >= 55296 && e <= 57343 || e > 1114111;
}
function r2(e) {
  return yb(e) ? 65533 : e >= 128 && e <= 159 && t2[e - 128] || e;
}
function n2(e) {
  return yb(e) ? 65533 : e;
}
const Kt = /* @__PURE__ */ (() => {
  const e = new Uint8Array(127);
  let t = 0;
  for (let r = 33; r <= 126; r++)
    r !== 34 && r !== 36 && r !== 92 && (e[r] = t++);
  return e;
})();
function i2(e, t, r, n, i, o) {
  const a = e.length, l = o * 90;
  let f = 0;
  const u = () => {
    const z = Kt[e.charCodeAt(f++)];
    return z < o ? z : z * 91 - l + Kt[e.charCodeAt(f++)];
  }, h = r - n, E = r + i, d = new Int32Array(E);
  d.fill(-1, n, o), d.fill(-1, o + h, E);
  const g = new Int32Array(E), y = new Int32Array(E);
  function b(z, F) {
    let W = 0, X = F;
    const de = F + z;
    for (; X < de; ) {
      const B = Kt[e.charCodeAt(f++)];
      if (B < 89)
        W += B, d[X++] = W;
      else if (B === 89) {
        let L = Kt[e.charCodeAt(f++)] + 2;
        for (; L--; )
          d[X++] = ++W;
      } else {
        const L = Kt[e.charCodeAt(f++)];
        W += 89 + // eslint-disable-next-line unicorn/prefer-minimal-ternary -- branches read a different number of side-effecting input bytes
        (L < 90 ? L * 91 + Kt[e.charCodeAt(f++)] : Kt[e.charCodeAt(f++)] * 8281 + Kt[e.charCodeAt(f++)] * 91 + Kt[e.charCodeAt(f++)]), d[X++] = W;
      }
    }
  }
  b(n, 0), b(h, o);
  const I = new Int32Array(i * 2);
  let S = 0, w = 0;
  function P(z, F) {
    for (let W = 0; W < z; W++) {
      const X = F + W, de = u(), B = u();
      I[w * 2] = de, I[w * 2 + 1] = B, w += 1, g[X] = S;
      const L = (d[de] < 0 ? y[de] : 1) + (d[B] < 0 ? y[B] : 1);
      y[X] = L, S += L;
    }
  }
  P(i - o + n, o + h), P(o - n, n);
  const _ = new Uint16Array(S);
  let v = 0;
  for (let z = 0; z < w; z++)
    for (let F = 0; F < 2; F++) {
      const W = I[z * 2 + F], X = d[W];
      if (X < 0) {
        let de = g[W];
        const B = de + y[W];
        for (; de < B; )
          _[v++] = _[de++];
      } else
        _[v++] = X;
    }
  const M = new Uint16Array(t);
  let x = 0;
  for (; f < a; ) {
    let z = Kt[e.charCodeAt(f++)];
    z >= o && (z = z * 91 - l + Kt[e.charCodeAt(f++)]);
    const F = d[z];
    if (F < 0) {
      let W = g[z];
      const X = W + y[z];
      for (; W < X; )
        M[x++] = _[W++];
    } else
      M[x++] = F;
  }
  return M;
}
const o2 = /* @__PURE__ */ i2("!}.&u%}'&}*'~!6*)%&,~!J~!J~%L~y<~!R,~~%Lu~~#GD~~#|)1#%}^%}2%+#.##%##%}&%##%'#%##&%#%#'%#&#%#&#'#%%#&#%##%#)%''%&%#%#'%#%%#%%}%%%#%#&(23#%%#&-%0%('1#(##%#'##+%'*.:1}#%#6-+(%'%%#%%%}#L'2351&('%}&/N'(0(/*-%(%%}#'+&T%7.2}#&%&#%#36/5##%&%%#&#%%#))2%%##%&&'0~!#*+&'%1~!%).'3q?&%'1~!.##%6(~!+%%%(Gw'rT~!E#<nA%#jZ~!H%(~!42##~!*31&~!G%U~#)5~#`3~!J~!Z~%]~%Y~%C~!q~!u~#kz~%#~!6'~!D~!U~!?~#T~!c%~!G#'~%7|~!G~!J~!G&~#pb~(Df}#%}*&}#%##%##%##&#-}&'#'&%#.++}%mI,#,@&(}*%}*'%&##&#%##%}&0}#.},U},%}+%}&%}#%##&}B%(}(%}+%)})%##%#&}&%##%&}<%}>%#%&}*%}(%}9%}/%})%}*%}*%}?&}&%}3%}&*#%})%#%#)}#&#-#+*%E%%'%'#%}#*V##&##I}#&&##%&%#&&Qf%%))w/0+&%#(#.%-''''++++7}>%4'',##1,#%#&%##&#'##&#*#9)%&%}#*}%,#+P(%A&%#'&##wSD',9E00#y#@}(+}&%&>~!#~!X}#*}(&&}(&}(,%}%&#+&}#&}I%#%}%)#(},'%#*}4%%#%}(''}#/##(##),%-##%%)#&}(.}&%#&}%%}*&#%},&&}&%}#%*'#%})%}D&}&%}-&}6&#&}-,%}#%})-(~+`~,=?~I9'9%~!,#%})%})%}@%}?%}(~!?~#<~#pP~#BG~#=1#%K+~#?#~%;)~#A~#mF1~#A'~'X%'~#lR~#N~'N~#r~#m#-~#i'?%#'%~#B%##%,%#~#_%#0%~#]732~,w~2+#:&#%&'0%&>%}#>##F+)#%&&#(+_}4&}-%}(&}@&}O7Fdf0@+/v4}&WU##&/0#&'('B#%}.%}'+#%}#%%&#&%#%##+#&#)#6#'#.},%}c%},%#%##%&#&%#&~#>'*-.%##%##%}#%%}%'~#)D1}#%*&~#_%%'(~#S2%'.}#~#=##*'*-%}&'%'##&&~'E%.#&~#M4}%%##&'%#~#O1##%&#'+~#<B%##%%'%+~#;#@%}#&%#&&%#(~#H1}'%'##&&~#?A}&'~#D#%32}'&&&&~#[}'(#%}'~#;C})&}%%#%~#=&%,3}%'(#%%~#^'#&&)#%'~#Y%-~#d-%'~#^%%&#&&&}#~#b~2t*&'~&(~&@~0%~e~3}%*''0})&}+~!9##-}#%-hD*)1fC#%/&/fB#40~!+#)*4~!+~!K'&:~!/*7~!.#~!H~!L':~%x&~!H#~!*~%1~!I#~!+A~#p'~!F~~#-#~,,(~.Z~!V~%;'B'mq-W~!N~%I%#&&#&}#%},%%}'%}+X#%}#&}(%}'%}<%}#%}%%'}'%}:~![)9@~%>~#UA%-%##&~!C%~!-.9:~!1~!-^2/:a~!y,D*J#-5)/4~%23,~#G~!L1~!0X3`~!2+~!!0-~&E~!W~!o,>Y&]~%cZx_&~#O*9#A#'#+I'%#)~!0B*-5A+-((F&*M#)(-7-5+'-3a5Vi~!Y~!?+[)%3),ERHm~!+:D,VG.+)?fB%%*(%)'(#&80%1'8`K8?`+'Z#&O&'H5#*9)A%%5&3))0%39+.*7#()&&*=4@**L)<'_&*+..;(#*+)./&0#3)%')-8(4ixD(&.}%,('aI:,)%,k2231T)I'#/-W7,/'Q#.'Y24+h')37</31&83##&0#),H(?'&?/1##%#&&#%''-%&&&#(&''&#.-'%#%%(,')*'&#&#'##%(%(#%('#&##%%%%('%#%#%%#%#&%##h>w+v<ayvyvcg.uuhKr}g/v|g>u9i[~>g5uI~=RvdwEg;v/g;uk!!TTSx]@RT!U!#!@VBRUU!'UTe-d0c`e&gSdicedFcrdTaqb.kYcAohdYd@a3e+d}dMdtd.aJ#bqcK`dle/e.e'dwdPdodddjbEb}ogd^ofdpduc6j?l%d{drdqc)d7bacOdQ%T#Y)X.sR[yH>6Vyv3[xwLu>vo'!*.[yBacahoj>6Rew3[xqdZa#!a&#^(X-[yG>6Vyu3[xvg3sEr|g.u/Ri9db0T#^(Xa)!-[y;>6Vylg4wKs{JwNZt3@3r=c4Z([xlg;wKt!cpq's@v7A'*a(a+!-a#[y<3Dt?3Dt'>6Vym3[xmg9rxsNJwLZt4~?r?db1T#`-!(Xa,!0[yS>6Vz%NuQs.g4wKtnJwNZtS@3r>c4Z([y%g;wKtrdga8!a(!#&T*Y-Xa#!a0<or[yc3Dtq>6Vz43[y3JwNZtf@3s!Ju}!%Dti:pm3c_%X#tjB5pkd6q!r]u?voC'*-a.a2!0a&a+[yI3DtI3Ds~3DtH>6Vyw3[xx;:s#~<5pKJwNZtE@3r~d`a)!a2T#a.(!+U.X1[yT3Dt`3Dtv>6Vz&3[y&g9rxwzcxstPu.<rAJwLZtT~?r@dZa%!a.&^*Za(/Reu[ya>6Vz23[y1g3sEr}wkg{NuQRg{ci(U#5@b`~,cg#U(2WnH5wugcRh7dX#T(Y,a'Ta!!a,[yZ<]mj>6Vz,3[y+Pv#5ReZKu+=,%!H}7ABwkaS?Rh:BcW(X#<]mrj:ubv/ARekdg%!(!a.*Ta(Y.X1!#sP>Rl*Dt6[y>>6Vyo3Wf*jOvuumvuRgRJuq*!:9<B@bX~3jVv&v@s@5Re[d/rQt{uAvo&a&a*)a2!,0Wf!3Dt0=Bs'>6Re}3[xy~<5s%JwJZt1~Gs)c;&!#2sJkNuXvzq7rxu,Re8dka4!a8(aEZ+a@Y.X1Xa)[yd=Bs(3DtP>6Vz53[y4cX#X&Re:avRe9~<5s&JwJZtQ~Gs*i^rzvdRg+Jv{%!2sbB@bX}kdga,!Za?&^*T1/!a'Dt+[y6>6Vyf3Wf%g/u;s4hGu6?Rh-JvZ,!c%#&RoX54Rivj7uyvf8RgTKvZB%*!2sGh<vu5Rgq<=C::9bb~#dZ#T&Ta6Y.X*Dt>[y93Wf)coZ(T,6VyifluvRgC@95@B@bX~/hFu34cC#T,k/unq8w8Q5RkUklwQuzunq8w8Q5Rk8d/rJu?v8w9)-&!a0a;a&aIWejg3sEr/h1s<DtDJvyZqY5aws3Jvy!&Wei~Hr1:au5@Bag>23E~5c:Z&bX};kKv?w&unuVu5Rjc;>bs)#~@:Rh.=ay<a]C;b`}Vd6s/t{uAvoaxa()!a,a7%-a#a2Dt,[yF2Wo[>6Vyt3[xuNuPRi&NuPwpi#RoWh?vf8Ri%Jv]!%Ri:KvxD!.'2WeAjZu`q9rxu,Re7woeAg-unLq(qA_/*2Wg_g3u5q^9:4E}/jTrxrzv=Wkkd~0UX#^^Xa-a1a5T&a=U1a'*aEa]!a*aPaA-adok[y54Rn>;:p3~Dp5g9rpsFNvZqjg3uJp4~<5p0Pw;5qlJwNZt*@3p1Pw:5p/Ou!5p2JvG'!6Vye=<qnJvh_[xhg3v,Rh3kOwOw-sDuev/Re^dha[a%!%!a+#Ta7)-5TaCaO!aka!a)sf[yb2>Rl!9ARiq5E}Qg=ucRkBE|oJrJ_@Wk~@Wk{JrJ_@Wk|@WkyJrJ_@Wk}@WkzJvO_[y2g-vMRmiKuYC!)&>Ri;>Ri<@3RkNc](X#@9Rk=g5vuRmhKvDB!+'=]meg3u4Rmgd)#Y'Vz3CARmfd`a+!%T'!+#Ta1Ta6TaM-sTDt9[yA9sYd'%Y#s[[xpj:ueunaXRgEjRq,v-vuqdd2'`#6Rev<32@5>:2<E}5xIo9a*X#Y(;5RePJvD_g>vyRgNj8w)v8<wggs:RgXiZt|vjx,hSq3ah!-(~@:Ro/Ou!5RhWj^v(pyw8unRhUdx-UY#^Ua.a3a70!)%UX1TaDa)'omRiRRhE[y:3Dsz=Br,>6Vyj3[xkg6ruwjcqsrPw;5r*Ku]D'Zt-@3r(~?r.i[vwv]dU1a--U#`a4(g/vsRhPOu!5RhLj:rmu9Wo!~@:wdh@g/vsRiTjXuvvNr}:RhBj^v(pyw8unRn]dz1UYa'a+^Y(!aETZalaRY.Ta?a4[yDJw1!#qLsW>6Vyrfzq-pLflpwRe|Js>%!Dt@3Dt&Jvy_[xs~HrnjMuwpsw'RecKu+D#'!t<~Grl~?rjg5u-x,gwp{ah!-(~@:Rg~Ou!5Rh'jXuvvNr}:Rh#cW#X/c;&!#2sLi[v7u7RgpJv)(!iLrxu,Re6j7v@s@5Se[e7d`aW!Za(a`T.a#!a3!&aDa-!9)Dt_=6s+3[x~~DR|h~DS6avhGun5RkZj3w)v-]mkKunB!&*]kb97R|i<ARk<c:Z(6Vy}Juh'!wziMRoS:F|vkLuauJv5vtvQRh1d='T+Y#VyO~DR|jcF#T'7R|g97R|kJv3'!ay<Rj,Jvh&!:ReXcsa6*a+#a#_aIRf9aLRf?c,Z&Rf5Rf7c.Z&Rf;Rf>cQ#%T'p-Rf8Rf=ct#%'(*!,p,Rf4p+Rf6Rf:Rf<d~'Ua%U*^UYa(!a,-!#a4YaTalaEX0a8a<Weo3Dt/3Dsx=Br93Wen~Dr;~<5p<JwNZt2@3p=Pw:5p;Ou!5r3c7&!#:p>3Ds}KvGB)_6Vyk2sM=<r7x'eovA(!hFu1ARf}cV#X&@r5j6rvwQa^Rf3c=Za'wkghJv__g;unRggA53B9=b^}%j6uduo5Jq;!(hIv%2Re`Ou4ARe_e%a#^^^Xa&!a*a2!&a6YaP!*ad!#a:aE/5Rn?[y@>6Vyp;:pE~DrY~<5pBJwNZt8@3pCh=rt3rWPw:5pAJup_[xoNuPpF9c!#'45pD5ARn)d8#X'X*3@rU72s]h>v<<sSjJpqvewOJq/(!hNw'5ReBk0s2u3w/w'5ReE5@Jq.!a+JQ!&WeU23d(#Y&RjG5]jBk!u7w&u0udARjEe#+^^^Ub#!a2/a`Z(agT1!a-a;|@TaG!aS[yV=Re~fow'RguNuPRe?bz#'>RoUWeL>:Cbb|?JwPZtVg6ruRmzJvD'!6Vz(g/vmRh~Jvy_[y(g9voRgyx*cy(#2>Ri2B9b]~9kIw9u7rluJu3Rg]dI#a%UY'@=p%CAx.gQZ&RhwwygtRm{x5g_Z'+ABqR9Woa=Bp&dV#^*Xa'!&@o{g4v]Rk;Jv{!%Rk[wkkiA5RkiwwfUB=x,fUuqC&*!>RfTg8v0RfV~ARfSd;rJsAuAv9wR'ae+/aO!a@aza/a#[yQ@Wg!2Wemg3sEr0JvB_g>uvReWg2v+Re=KupB_+[y!2AbY~-~Hr2AJwD!(h<~El>h<~El?Kun@+_:9b`}Kg-v/Ri3g;vtwyk_9]k_d=&T#*U.6qh@Ab`|K9:H|CJv[!&3Dtex'fDwC%!Rf[9WlMd[(^X,!a%Z06Vz!@WgBg=v~Rgvg,QRe@awd,#Y+jTv|Q~EfWj]uNr|~FRfXdy#Y&^Ua%!aO.!(a)Ua;=!a@aKap!a-,a!Ta]a[rSa]p?[y82sK=Bq~;:p:~<5p8Pw:5p7d'#Y'Wf(;RnRi[u4w&RgJJvG'!6Vyh=<r#ijuuv/sIKuYD'ZtG@3p9~Gr&d2#`(g<vtRgFj`u5w&rqpxRf2CJuY!+:wfnTOu!5Rg}jNs1ucv&RfwJvA!&3@q|BDcC#T,k/unq8w8Q5RkTklwQuzunq8w8Q5Rk9dga#!a'!a=#a0!:+Tb*b@aO.a4!aba8aFJv^}?!VyR~Dr<g;u%Rn.~<5p[x'e`wNZtR@3p]Pw:5pZhNvjBp.woe_g5u-r4JwF!%DtO3:ooc7&!#:p^3DtpLuGw(!+%)Dtk6Vz#2sd=<r8d'#Y([y#<x3gJt`w@!)%}MRiowzikRij=]ilxAf3,U(#B2Rf#g0v-Rm[ck{`U#]giKv3>)!&6Ri154s,KuGB_%@r68r:dJ|t`#X(9<E|u2@H|rx3gJu?w'!+'1Nu7Reg4=H~+9<wxgY95Rm]xLggZ-`(X}U2:Ri4h<uOawRmsJv__5@bb{jbV~3dka#a'a]!,#a+U=a>b6a3b%!/aKa/)!arwve^VyJ;:pR~DpTg3uJpS~<5pOPw;5qmPw:5pNOu!5pQJvG'!6Vyx=<qoJvA!{~Jup!%@qk7Rn/KvyD!}''[xz;>wkh'?Rh,x8gyt`w5D!&),(SgyccRgztJ@3pPB5p#d'(Y#<]mmifubw&RgoJvE&!82s^JvF&!8Rf,ADb]~;x=h'rNu]vK!,%'*0RnORh)4Rh*AqQg-vaRnNg;wHwkh'ba~4cE#Ta*x3gctyw@'!+%RnFRnD<4Rn@hFvK5RnCxWg[#`&a0Ua()`1Rm75Rg[c]%X#qi8Rg^NvdRj>BwzgZauwji7Rm6A4wgg]d1#&(*,.0a#Rm;Rm<Rm=Rm>Rm?Rm@RmARmBe%#^^^Xaea?aC/b+(,!a+a#!a/!>a&Ta<aKbD!2wphBRnk[yPw}hE|.=Br-3Dtm>6Vy~g6urRf.x,hPrNav!%'RnqRo%Ro#Nu;q[Pw;5r+JwNZtM@3r)d'#Y'Weh;xChL#`&RnmRnoKu}>%(!Rne~Bs-;2wjcussJv+'!aYSO}6@B<5?ba~8LrNvj!.%*ROwungw~ng~:9;Ri^>wtnig;wHRnixDh@|(UZ.x1h@|)!#:2<H|*xHn]#-UX'3Ro)z=iT}6ARns=Bwsn_wpnaRncw]aR(#UXa&Ua*a/=]iPd'#Y&Ro'WnXf{QRm2hNvj]nZd`'T~&1`{|`#9b]{}c:'!#Wl{>@=be}]?cl{{U#:5Abb}Jds#^YaF!a*b4a#a3aPa>&Tb!bH!*a_!Eau?/a&RjY<]gj>6Vz*;:pe~DrZg,QRj1JwNZtX@wihspcJvZ&!VyX9WmOJu|!|N2WmHJvh&!]ht~Bpbcn&T(!#RmQ<s7Nu;padH#X'`+WmJ@>RmKCARhnKup=!)&Wf+:RhqNuPpf9c!#'45pd5AwghpARn(Ls@w!%,)!RmP@Wfe<E|IJva!&WmNg8vsRmLd`*.`#Y'Xa!axRn*]hrA8Rhug5s@rXg8u!RmMd8#X'X*3@rV72smdI*#UY&RmICARho~GsgxVgd)Ta'U-Y&Xa!T#RnEWnA@Wffg1uDRi0hFvK5RnBxGnG&#`%owp)@wsf+bX}Ze-*1!a*^^^Ua|!#a.aq&Ya2!a>.a6!a:aO`aJDtL[y`@Wg#>6Vz12@wzoYRoZNuPRi!NuPRhzg=ucRi,@=b`{Yg=ucRi-ACJvB!&Sh[ebSh]ebi`wUuFRm4Jw2_[y0JvB!.<Ju(!&SoG}6Shd}6<Ju(!&SoH}6She}6Kur@._g5vHRieJvx!{L2G{Kx6gd'T#?Rh82Wi5cZ#X(g1w)Rm5dW-Y(Ta#!a)!#aYa=wnfE=su2>>bU{0j9udv:<svj8uQv-7RgHdE%#^'sq9sp=>Bb_{TJv`!&g/r|snj6v(us5d,#Y(56H}[978H}]Jw5!&g1rushJvB!+j;v{u5?zDhd}6}bj;v{u5?zDhe}6}ce*#`(^^^a[aea!=!a6a*aoXb1a.!aAbL!b>,b'aL!aV@Wf|2Wlg3[y/JwNZt^@3piPw:5pgJunZou3@rsJva&!Vy_g<v~Rm#JvG'!6Vz0=<r{Ju{%!:pj@WfsiXuJu3Rm:JvZ&!WfA~Bph@c4Z&Dtwax5rubx(#:awRk1@d,#Y&RfjRfid1#,Y(@Wfp2Wlrg5s@ryKu[@!,'=]ig9wlk?Rk>g5u-rqJvy'!@9RkQcH(T#=>Ri~@<wkj(Wj(KuZB*!&<7rw@9RkRcH(T#=>Ri}@<wkj)Wj)dg(Ta2Xa9X#`-!a*CARhg@@=I}d9x;c~#X%so=<sj>2@@=aybb}XjWv0Q~EfEj3vLv;<d,#Y(56H}`978H}_dgaPaFa'a/!#a3Y0a_a;a|!1(a7-[yE3[xt;:pJNvZrrg3uJrvJwNZt=@3pIh=rt3rxPw:5pGOu!5rpJvG'!6Vys=<rz@c4Z&Dt(ax5rtJvZ!&~BpH@wsfNg-vaRlNci*U#=<wei<F}a5@Jq.!a*JQ!%@qZ23d(#Y&RjH5]jCk!u7w&u0udARjFd/prq=tyvpaEa(a:.!a1aZ(@@=I}:9wpd%=<sX55w_h}@@=I{t=ay<aU@@=I}T=ay<2@@=I})?C9:9au@9Cb]}DP~=x-fAZ(2Wl1=ay<aU@@=I}>5@d##Y+jTv|vV~EfFj]uNpn~FRfGdgaK!Z2&!a8a-Tb({E!acTbM*!a(DtY[yYd'%Y#sl[y*hHvh>Re5x2c{Z}.j4uCvcawRiMd+#X+_x&d!},<5RkX;2Hzw@x,gavfB-!{CcF&T#Roe;RodwWbBg5urRgaKvHC*_6Vz+<4opieuew&Rmq@d]&Y)X,T#X0Rh}<BqP=4qS9:ReMg/ujReNJw0!/<Jui%!bd{kawwnemRelAxUa?a3#*.&UX(Ya+a/RhvRnQ<o}9Wmtd-#Y&RgSRmw9;Rmxay=Rmyg-vaRmuxEhSrNu,v-voC!%(aR.a(a7+1Ro1>Ro5CE{A9b]{@;5x#eO{:g;urRi+KrNA!%(Ro3>Ro79;Ri_Ku@>{;&!x%gX|{KunA_+g5QRj/g3u5Rj#g>uERj%wio/xRhS&!,!#^1U}wba{8>>@=be}qC@:D5ba{7Ku+A&!}x?ba}t>>@=be}se(aA^^^Uat!b0#{pa+awUazbGa#aLb9bgaWac'a5TbS=Br!d1#`%scp_Jvl!#rT>Re0JvX&!VyN=H{Fcm#U&:pY=ReaJv2&!]h0=]nUJvG'!6Vy|=<r%JrM_=]h2@Wlud'#)U'Wf'b]{i=]h/Jvh!&~BpWg=v]RnMx+ny#'Nu;pVwjnu=]nwxJnx,T#`&Reqwjnt=]nvieu9vrRjLLuYwP(#+!th@wih5pX~Gr'g5v/Rh4KunA'!-CARnP@wwiN:Rm_9x'cvw>!|l=<saKvAA!0&3@q}>w^e1bp#&Re2Re3BDx7gH#T|f5H|eKuZ>!%(:qNAH{]Jv6!+3B2B9=b^{X<5<B92:E{ZLvhwA(a;a%!igQuyRmad+#Y}m@3Rh5d8#X'X*:AqUAHzmaxwbh<aXRnVcF}RT#Nw&cj#U(BWnug/vsRntdka)(a3+.Zb7aYYan1!bVa@Xa}[y^@b[{G=H{+hFu73Rj&Pv#5ReQcK%T#sig1v{Rj'Ku+D#'!t]~Grm~?rkKuMB!01d5#`'Vy.ta3Dtu~Hroc8#'{^45s85AwZbP&!#Rn!wghxWn#KvEA!)&2RlA2RlBx:h|#(T,=]j09Wobz>x]z/@awRoTd+#Y(az]hFhCrm4d,#Y+jTv|Q~EfMj]uNr|~FRfOdCa!Xa9_X#@<plJvf!%b`{(9;Rgwc;.!#2x7cw#T|UDb]|T5Ju={(!=@E{&Jv)&!Ab`{'awJvf!~*>>@=be{#KuY>!+&4Ezyi[ugv&RjIdea+T)#UXa&T-T&a!Rh9auRmW=]kLg5vuRn+g3u4Rn-Ow6ARn,hHus5xNk?#UX(U~)/g8v0RkD~AwkkF?Ri.OuNBwkkA?Ri/d|a2`a*^UYa.!aBTZaTa'Xa;!(!2!-a#b2[yC>6Vyq3[xr2Wi?g1rusVh%s?DtF~<5rbJs;%!DtBfswKtCj[uvuSsEu3RgVx3o:u+wN'*Zt;@3rd~Grh~?rfg8w)Lq)qE&-a%!>bI|`jWv0vV~EfCjTv|vV~Ef@j]uNpn~FRfBcK#T']gWNu7x,k7q4ai(0!hHv8<RhmkMu9vrsBuev/RhlCJvB!,g<v{wchh~@:Rhji[vrv{wchi~@:RhkdS&a5UY#Ta!RgPwwiI5BwciI~@:Rh`x'iJvj'!5]iJPu8Bwch]~@:Rhach)U#h3rp]gLh@t|Ax,hTq3ah!-(~@:Ro0Ou!5RhXj^v(pyw8unRhVd|)`,^UYas!a?/a2Z'a^Ta{Tb7Ta(a#!a,Wf&9sZ3DtAadamov=Bqt3[xig8vsRm~>waiL2b`{QJv*_Ouv2qgj<v]v2BqfdR'X*X#Y-@3qr~Gqv~?p6hHv-]glPup5Lq+q?_%*b_{qF{n9b^{rOu4ARhpKvCD!+&~Bqp:5Dbb}nwoiKl&unuTuBv]v+ueunaXRf0=Jvh!0nKufu8v1w&w7q%w&uHrz:Rgnj5w,uxDJq/(!hNw'5ReCk0s2u3w/w'5ReFd>Za&!*UaA=<wkgsRnSJv^!%Refifw3vyRgOKu_B'!,<]gkiiu:w&Rh<=C@a^<B57@2F{[<B5@aW:=3away9A5aW=<B=C@a^<B57@2F{Ie-#`(^^^bCara.b8aza6!/bZ,!adTbnTbOb+aFaS!aAT9@Wf~2Wli3Dtl2@d,#Y&RfnRfmJwJZtN~GqyJva&!VyMg<v~Rm%iXuJu3Rm9Jv[_=]ih9wlkDRkCd1#`(@Wg>2Wls3cH#T(@<Rj*=>Ri|b~'#23s9h<~El.d'#Y&Dtxi^rzvdRl#d*#U%(o|B2s`hJwSaxRmDKv4B&!1:Rmdd5#`'Vx}to~Hq{x'f1v3(!BA5ba|bJv_&!Wfug1v]ReIdO+U/Y#&G}-8wze=Rh{g1v]ReHg/uQRf/by#)ibQwERl/cH#T(@<Rj+=>Ri{cNu+vlax-!(#a0qa9<Rii2;;bU{H;x<i=&X#Rk`<4wwi=C9H~8xAI(Y#<azRi@45wXI<B9;5bb~7dL(X#Xa(+!aL6Vy{g5QqOau:5au2@ay547EzbxOcU(UX-T#Ta#:Cbb|A?wjh/b_|SOw6ARgtihr}u7Rhy<d1#T)X1@@=I|~=ay<2@@=aybb}Sj3vLv;<d,#Y(56H}A978H}@dGpvs@uAu`vcw9*!aFa+ai%(b!aXa8.a?a[ozWey=sU2@G}Nch&U#Rf_WexKu+D#'!t:~Gr`~?r^j]uNr|~FRg*j^psurwJt|RmcKv)@&!)7Rkv~Br[@wxfO:Rl3co#U'6Rezj_q#vIuavjRltwzeyh@vr5JqD0!>aY?C9:9au@9Cb]}9cl#U*5;5<H||jbuus1ucv&Rfvg1v~d/pppzqFr^a--a~!aMat1(hFv;Wiz@@=Izoj5uuv-7Rix~Cw`fk2WlVcZ#X,k)u3vWs@u2]ktg;wEx'fBq(_2Wg/jTv|vV~EfoJv]!15x'hzqG!(P~EfU~CRl_j6v(us5x4i-#T(2WmZ?C2F|d>Kq<aj1!*jTqIsBv=Wl`~Cw`fi2WlWj`v0u*~>RlR=c>Z,k#u3vWs@u2]kr<c1Z+jTqIsBv=Wla~Cw`fm2WlXdmb3!a{(arZa`bkTa%TbQTa-a9+c'!aM!/[yL=Bqug.w'RifhFvyDRj.g>vgwyk^9]k^Jv3_@WfbAARkhJw2_[x|JvB_wkoIRoKwkoJRoLd'(Y#<]gm=<9<H|yd'%_X#skDtb3awwqkgNulRkgdB#^',9:p'hJwSaxRmEBwVb8@4=H|qLu+w50&!)@3qs~?pU>Awwn;;Rn=c:Z'ARn<=<qwKvC@!/&~BqqJv6!&]eVb^z^xRge'/a%+^`#Sge}6<4Rn3=]n0Pw2>Rn8Jw0!&>Rn:>Rn6cY#a7+!a&=<wkaNw~h3z_c5Z{=wjh#=]nLKv^D!&)Vyz=bW|swYb<WetcG#T(2wxa@qVx@gD#Y&b^|V5JwG&!5bb|pg/w&RgD@x=kHs=uAvn!a%%/'+RmSRh694Ro`g-vaRmRhHv-]mlxCcS#`&ba~.5cD#Ta)P~=d,#Y(56H{>978H{Dd_#{2^Y%_+qbbb{6g3sERhsbU{?dfa.,`a(Xa<!aiX#(55RiG54RiHcI#T'WiU3RiVNvdwtfcRlKNvdd,#Y&RlHRlExQgf.1*^T'X#Sgf}6Wn4=]hfPrk>Rn7Jw0!&>Rn5>Rn9Lunw?&a2!,5<oq@@wqfdRlJj5Q~=d,#Y(~ARfcOuN]fdDKw;ay(}i!547E}j?cI#T(@5bV}iCbV}hdv(^^Tb?a40,b##Tbo!a*bR!a<b|a/!aKai!aU[yK=]o^g:v>ReGJwPZtK<7Rh+h<~El,Pv#5ReR@awwxjCg,ulRjDJv6&!]j!z?aQeeg>w=Sh<eeJw;!&axEzOg,Qosc!#*:wkeJ]eJ>x'h-u(!%Ro.w~h.zPdNZ(X,Ya![x{;9ReY;wkgxRiF:x?ap#Y&RmUg<s2Rkod]+UY0TZ'!a&A9sw<=bczLNvuw{gqzNhJwSaxRmCKuLay!#&s_Rf-55b^{uJvZa!!c%#(55Ri654wmiu5RiuawLu,vp!+}^%b_}Y9;wkgxba}o>A9:=b^}zKuh=a''!3awRk3c*'!#aHRk6c+Z&Rk5Rk4Jv)&!awRjSawd9*`#0?C2@EzMj8u<uJ5RmbjQrquJu3x,k>uq@_+=ayb^|W~ARkEOuN]k@7dhzV^X/X&a-#zRzSb`zXcJzTT#2WkVKvDBzW!%FzY9;5bbzWjQrquJu3Jw3%!b`zU=ayb^zQd:#X(T-a!6Vyywxh}=b]{Jg=u1RiAdGp~qHtzv!w(wA+a+a;<!aJaYai'anasb(=azRmV:Cbb{MLq2vb!%')RjuRjrRjtRjqx3jnqCw3!%')Rk(Rk+Rk&Rk)Lq2vb!%')Rj{RjxRjzRjwLq2vb!%')RjsRjpRjfRjex3jcqCw3!%')Rk'Rk*RjkRjl9<CbbzfOu4ARhxLq2vb!%')RjyRjvRjhRjgx=joq*uKvb!%')+-Rk.Rk%Rj~Rk-Rk#Rj}x=jdq*uKvb!%')+-Rk,Rk!Rj|RjmRjjRjidAq&qKs@uAv8Aa.'*-a@a&0!aM@a5[y73Dsy3Ds|3Dt):wxgI2sHJwJZt.~Gqxwsf0ikrzt}Rl0Jvy_[xj~HqzKv_A|D!&WfP8axRoVcf,U#k(v]v+ueunaXRf1Ju}'!g8u#Ri=jQw!sCunLprq>!,')~<5qeGzq9F{W=c##%s5au:5aU3CBE|;d4#X(D!a&6Vygx(b;#(=]ed?C2F{N<capoq2r[a&!aPa9,'Pw;5s:@@=I|,55w_h|@@=IzcP~=x'fCqB_2Wl2>aU@@=I|1OuNBc1Z+jTqIsBv=Wlc~Cw`fl2WlZ~AcTa%!Z+jTqIsBv=Wlb~Cw`fh2WlYk+uNqJsBv=WlSg,u3dca3#UXaMYa)TaB-=cM|7T#<bI}l5@B932:aV2G{BOuNBJq:|M!5Ezt=<B=C@a^<B57@2F{v>cB{/T#=ay<bI{3Jv6!a.6BKq0ah&+!5E}HP~Ef{978BaU@@=Iza<7d#.Y#978BaU@@=IzH~AJq0!(@@=IzG978BaU@@=IzFe,aU*Y&^^^bvJb,b:bFad!a,c2Ta>aL.bo6!a#CbTa'T#Re{2Wlh2@G{yg6t~Ro_NvdRfticuRQRllJv3&!x&c|zs@Jw3!%RflwpfkRlpKuL;%(!Re<@G|C2GzdhIvuBwgjAg-u0RjAKQB%!(GzZ@G|5NuuRl7d='T+Y#Vy[g<v~Rm!==G|>JvA!)@wma=]m1ifuaw&RmnLs@vT'!|/+[y,g:v>ReTJw1!#qX=x!eC{bLu+wT&)ZtZauq_~Graci&U#F|89:r_Lupvq!.)&2RlG8RfaC=x!eF{_h?rpWlmd&'!#X|&]k::xJey#`'T|+<E|&2@H|%dE#(^,g;u.RiEg6vjRiC9xCkA{O|zY#g=ucRmXKs0@!&*@G|m@awRknJuh!,3d(}gY}eJvj!%Rm):Jw3!%Rm+Rm-Ls0w(&!a(a#@b[|6cZ#X'7RkxWgAOu4ARn'dH'U#Y*Vz-Wm'CARm}d]*#a%^a*T'aK!a<9bV{PC=p*Jw4!&SgxcbB5r]idw(wBRmF7xFkt#&`(Rm/Rm8E|!JuY_9:Rl5=wrgr2:bbxd@xXfB(a*#T+!.X0X1Ta/a'T&RlDRfL>RlyARl9b[z[>RfZ:RlL:RfRwlg/ARl;9;RlxKv,A/!%7s69<74=BA5ba{-8Bde#`a<XaKYa1,a'P~=wxfB2bZ}}?C972@@=I}r8@55B9;5bb}G978B2@@=aybb}3j3vLv;<Jw3&!>Rfk=ayb^}4~Ad1#`*@@=aybb{w2@>==<bbz]dx+UY#^UaF!a9!bB'Ya1.!ajXa#%olRhD[y=3Dt#Ov5BrHKuMB%!(Rf^Wep~HrJwkiQjKr|~FRg)Ku+D#'!t5~GrF~?rDdV)UY,Z/_7RkuG{<~BrBg,rlsO:235B@bX}|d?a1!#`(6Vyn5@d##Y+jTv|vV~EfIj]uNpn~FRfH7Lq2vb1!a9-978BaU@@=Iz9978BbU}#~AJq0!(@@=Iz8978BaU@@=Iz7~AJQ|}!978BbU}!JvkaK!AdUa21-U#`a+(g/vsRn~Ou!5RPj:rmu9WhOjXuvvNr}:RhAj^v(pyw8unRn[kPr}p|u7vwv]RiSBd;pppzq@qHQa?(b.!a.a`@.|xa(hFv;Wiyj5uuv-7Riw~Cw`fg2WlU978BbU|wOuNBJqG!(P~EfD~CRlQcZ#X,k)u3vWs@u2]ksg;wEx'f@q1_2Wg.j]uNpn~FRfqJv]!15x'h{qG!(@@=IzK~CRl^j6v(us5x4i,#T(2WmY?C2F{1>Kq<aj1!*jTqIsBv=Wld~Cw`fj2Wl[j`v0u*~>RlT=c>Z,k#u3vWs@u2]kq<c1Z+jTqIsBv=Wle~Cw`fn2Wl]dn1#c(a(b^a2!b/bAT(bj!aDa7bu,a_a{c0!2T0g:v>ReD2@G{42@G{5~DpM~<5rc=Bx6i>{RT#RnI@zCx]y]z:2Jv[!zr5Awyk]9]k]dD(Y+X#6Vz.g=wKtgwhaCwgmTWj2Lu,w%_+/[y-B;b^xeg3u3Rj-2@bX{*KrJ<!+'@Wg(g?QRlC@Jv`!%b[zIwsfII}8JQ_@w|kW|=Jv(%!AqcOuNBJvEzh!bYzjLs@wP#(0!oy@>RkdJwMZtc3Dtd@BcG#T'9bWxg2@2Fznd*#Y+;2x'c}w<zizixNgwa#Z'U+!/!a'!a+w~g~z6wcn{Rn}wcnzRn|5Rh%=]nJg5vuRmvNvdRlvcprJu}w*az*a#!%.a.'Bot9qT]kj@Wg'ay2Gzv@Jv`!%b[zEwsfHI}1;ck#Ux`<Cbbx_Lu+w!a&0*!wko*wwo,So,}6Juqxf!E}PigQuyRm`d3(`#8>Rn%:A5B;bZ~%KvhCa!a2!x>k7#Uxb@b{#xaRk7Jw0!)>wwhlShl}6>wwhmShm}6CJvB!.x'hhvj{!!5Bwkhhbaz}x'hivjz~!5Bwkhibaz|xEhTrNu,v-vpD!a%&/)a3a.,%Ro2t[CE{)@3re9b]{%wjo09:rgc:Z&Ro6=<riifuaw&RmoKrNA!%(Ro4>Ro89;Ri`dSaL'UYzxZb)7Rka3xRhT&!,!#^1U}vbaz{>>@=be}yC@:D5bazzKu+A&!}{?ba}y>>@=be}wxBh[t`u~vJvr!%a!a()a,a0a4RoC=]o;Ju(!%RoGRhdwjh`=]oAg>w#Ro?g5vuRo=NvdRl|Ku]C.!&;RoEJvB!%RoORoMBx'h[v+_?w~h`}~5?w~hd~!xKh]oiptu-utv.vp!#%&a30a@a'a+(a/aOp(o~p!RoDJu(!%RoHRhewjha=]oBNvdRl}g>w#Ro@g5vuRo>c[#X']o<CauRoRAd-#Y':RkpauRoQKu]C.!&;RoFJvB!%RoNRoPBx'h]v+_?w~ha}t5?w~he}ue!/UbhYacXaW^Tc&a;b:a-c/#b&aja1(!cL+!bKbt!bmcRc9aIc?8[yW3Dtt94Rg`Jv}!&SiRMzBhEebShEMNuPRe>x7gL#TzuwjirRipc<Z&>on;>z=h-MSh.Mwqczx'a7vj&!>Re4@=ResJt__NuPRi*NuPRi)j]uNr|~FRfzKrJ>_+@Wfy@Wf]2WocKrJ<!+'@Wg%g/QRl@@Jv`!&awRl<wsfFIzgLu(w*!.*&ShBMwvhIRhI9;RhNx1hK'!#Sn]Mx1hK~0!#:2<H~7cNu+w7D*'1ZtW>Rn1~?rOc:Z&Rn2=<rQ<7wjh&=BSnLMc]#X(6Vz)w[b=a!U#9wzgMc3#&(RgMRitRis<x,gKt`ax!&+SioM=BSilMc3#&(RgKRinRimKurB,!&SiQMzBhDebShDM6BJQ!(P~Efx978B2@@=I}WLrJw!!,a*&@G}O@9wkibRid@@x'fKwC!&SlDMSfLMjUv~Q~EfKKv3@a+!(hFv-]mpx/hYZ(C5RiWz<o/MwkhY?So/M@x,gbvfB*&!SgEM:SoeeehFu3:Rgbda(,^TZa)X/7Sg[eb:2RgI~BrMC@wgkc:wwkcRerx3h(uUvK!&*,SnOM4Sh*MArRg;wHRh(x=h;rJvPwI!a4',a'0@Wg&=BSh/Mg>w=Rh=g3w*wwgGRgGcW(X#;Sg}M2Gzk@Jv`!&awRl=wsfGIz`dKZ*T'Y-:RhR7RhQg5u-p`j6v(us5d,#Y+~Awkia?RicOuNBwkibba}Ld6p~tyu_vbAa'a+!a/'a3aEa8a!>Sh,ebJv{!&Sh@ebSaReb9;SgwebNuPRi(NvdRl)NuPRi'hHu^<Rm^Jvv_@Wl(g;u1Si/ebKu'B&!*Sh?eb@Wl'z@aPeb95Si.ebcpputyvjB)!,&a+0a%ShAMWeK@G}C@WfJ9;RhMwvhH9w{ia}ix,hJvRA1(!zAn[MRhHx1hJ~*!#hFv(BSn[MBJQ!(@@=I~'978B2@@=I}2db.Ua<'X}+T#a0XaG2G}E;wkg|wuh!Rh!x,hZu,@)!&So0MVy)C5RiXACJvB!&5RiY5RiZg8w)cG}*T#2@bU}=KsA>(!a.3wkhZba~(x,h^u(A!&(SoCMRhb5Bz=h[eb?w~hb~6x,h_u(A!&(SoDMRhc5Bz=h]eb?w~hc~6e)aA1T#T,^^^c-bMb&blcPaP(a/!0!bA=b5c@a(!bfbrc#2afwmhARnjwchORnp2Wlf3DtsNvdRl-2@wpa<]m0bx(#:awRk2@Jw3!%RfhwpfgRlnKQB%!(G{V@G|'NuuRl6d='T+Y#VyUg<v~Rl~==G|<Jv+'!aYShC}6@B<5?ba~8@Jw3'!g2QRljhLrpWlOd+#Y'g.w'rIg>w*wgj@g-u0Rj@Lu+wT&)ZtUauq]~GrGci&U#F|39:rELrNvj!.%*RhCwunfw~nf~:9;Ri]>wtnhg;wHRnhx3hDs@v~!/+'@Wfr@9RkSNu&Rlo=@<5GzoKs0@_+@Wl+@awRkmJuh!-3d(}pY#qWJvj!%Rm(:Jw3!%Rm,Rm*de&!1U-U#`)Re;@G|.@9Ri82@wjfvRlq=@<5GzpLvOvr!).&2RlF8Rf`C=x!eE{.Jw3_g2QRlkhLrpWlPde(!#U{s,UXa*Ta'[y'g:v>ReS;x0PZ&RnlRnn~HrKJw1}f!=x!eB|2w]aP(#Xa&a*Ta.Ua2a7=]iOd'#Y&Ro&WnWg;u.RiDg6vjRiBNvdRlzhNvj]nYJuW_2Wm3x)kFze{9d])!a.!,Y01!#&aC!a3RndC=ox~BrC@2b^{pg,rlse7x'ksuq!%Rm.E{xidw(wBRmGx9o+)X#wwo-So-}69:Rl4@xSf@a#XZ'X)X,Ta(/ARl8b[xc>RfY:RlI:RfQwlg.ARl:9;Rlwdn'#^XafaQa1X1TaHTa)@b[{zcZ#X'7RkwWg@Ou4ARn&x)kG#{,g7u/RkGdH'U#Y*Vz'Wm&CARm|bx#(A]gUbUzJj9Q~=d,#Y(56H}l978H{U7d,0#U*2>ABb_xZ978BbU{e~AJQ{g!978BbU{hxMh?ad{oUYZ.x1h?{l!#:2<H{mx3n[t{vl!,&a%3Ro(z=iS}6ARnr=Bwsn^wvn`Rnbd`*T}B0!#^X'BG{c9b]{a>>@=be}F?JvS!&BG{d7BG}(Bde#`a1X,Ya@!a'P~=wxf@2bZ}I56B2@@=aybb}08@55B9;5bb}<j3vLv;<Jw3&!>Rfg=ayb^}&OuNBKuLA!)a!P~=x#fD{f2@>==<bbzl?C972@@=Ix^d6rSu,v7w*C(0a)a6#B+a%!sQ[y?3Dt%3[xn~<5rLOu!5p@Ku+D#'!t7~GrP~?rNKvlaya7'!h+v-5qMg=t|cd,U#5AAaa5Abb{S@52B5@a[@52B5Gx[iXueu;d<#`a(!/549C;ag>23ExY5@Dah89b^~689Jv)!~2b[~1Lv'w(%*!a#bX|aPrmawRe]keu7uhv-q6rxu,q`xTo]/a5aU!bNaDXbi!b-!ao!b<bwA!#5@B932:aV2G|:d-)Y#hJrL>RhG<7@C5<H|_=Cau:5aj5@B932:bJ|ng>vIbs)#?C2F|9jPv0w.vISh-MKvUaz(.!9ABbb|[5;5<H|Eg>unwfh;9:4E|YjQsBt|vjx'hYq3!(?C2F|J:2<BaY?C2F|GOu!5x,g|p{ah!-(?C2F|c9:4E|OjXuvvNr}:Rh&i[w*t|cd+U#jJvsu)vsSn~Mkfrmu9p}u7vwv]So!McW#Xa!ax5@A5aY:5;5<H|>kJv~vYrquJu3x4ib#T)2@SmZM?C2F|Bj:rmu9@xPhI(a*a#U#`a3-5Abb|L~@:RhK9:4E|0@52B5G|#C::aY?C2F|-:2<BaY?C2F|.5Jvk!a)javYrquJu3x4ia#T)2@SmYM?C2F|HAxPhH(!a#U#`a*-5Abb|4~@:RhJ9:4E|R@52B5G|F:2<BaY?C2F|Sc^#Xa2j=Qq5CJvB!-g<v{z;hhM?C2F|Zi[vrv{z;hiM?C2F|XKsA>!a)-g<v{z;h[eb?C2F|]i[vrv{z;h]eb?C2F|^iZu.vix,hZq3ah!.(?C2F|QOu!5ShXM:2<BaY?C2F|P", 13494, 2713, 49, 25, 61), Tb = /* @__PURE__ */ new Uint16Array([
  512,
  26465,
  29036,
  7,
  0,
  2,
  4,
  116,
  24638,
  116,
  24636,
  8693,
  29807,
  24610,
  621,
  1,
  0,
  0,
  3,
  112,
  24614,
  111,
  115,
  24615
]);
var ft;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.FLAG13 = 8192] = "FLAG13", e[e.BRANCH_LENGTH = 8064] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE", e[e.VALUE_MASK = 8191] = "VALUE_MASK";
})(ft || (ft = {}));
var yt;
(function(e) {
  e[e.AMP = 38] = "AMP", e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_X = 120] = "LOWER_X";
})(yt || (yt = {}));
const Bs = 32;
function bb(e) {
  return e - yt.ZERO >>> 0 <= 9;
}
function s2(e) {
  return (e | Bs) - yt.LOWER_A >>> 0 <= 5;
}
function a2(e) {
  return (e | Bs) - yt.LOWER_A >>> 0 <= 25;
}
function u2(e) {
  return e === yt.EQUALS || a2(e) || bb(e);
}
var gt;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(gt || (gt = {}));
var nr;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(nr || (nr = {}));
class l2 {
  constructor(t, r, n) {
    $(this, "decodeTree");
    $(this, "emitCodePoint");
    $(this, "errors");
    /** The current state of the decoder. */
    $(this, "state", gt.EntityStart);
    /** Characters that were consumed while parsing an entity. */
    $(this, "consumed", 1);
    /**
     * The result of the entity.
     *
     * For named entities: the trie index of the best legacy match so far
     * (0 = none). For numeric entities: the accumulated code point.
     */
    $(this, "result", 0);
    /** The current index in the decode tree. */
    $(this, "treeIndex", 0);
    /**
     * Characters consumed since the last recorded legacy match, plus one.
     * Invariant at the top of the `stateNamedEntity` loop: `excess` equals
     * the number of unrecorded consumed characters + 1.
     */
    // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive (read via destructuring)
    $(this, "excess", 1);
    /** The mode in which the decoder is operating. */
    $(this, "decodeMode", nr.Strict);
    /** The number of characters that have been consumed in the current run. */
    // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive
    $(this, "runConsumed", 0);
    this.decodeTree = t, this.emitCodePoint = r, this.errors = n;
  }
  /**
   * Resets the instance to make it reusable.
   * @param decodeMode Entity decoding mode to use.
   */
  startEntity(t) {
    this.decodeMode = t, this.state = gt.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1, this.runConsumed = 0;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the non-streaming `decodeWithTrie`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, r) {
    switch (this.state) {
      case gt.EntityStart:
        return t.charCodeAt(r) === yt.NUM ? (this.state = gt.NumericStart, this.consumed += 1, this.stateNumericStart(t, r + 1)) : (this.state = gt.NamedEntity, this.stateNamedEntity(t, r));
      case gt.NumericStart:
        return this.stateNumericStart(t, r);
      case gt.NumericDecimal:
        return this.stateNumericDecimal(t, r);
      case gt.NumericHex:
        return this.stateNumericHex(t, r);
      default:
        return this.stateNamedEntity(t, r);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  // eslint-disable-next-line unicorn/consistent-class-member-order
  stateNumericStart(t, r) {
    return r >= t.length ? -1 : (t.charCodeAt(r) | Bs) === yt.LOWER_X ? (this.state = gt.NumericHex, this.consumed += 1, this.stateNumericHex(t, r + 1)) : (this.state = gt.NumericDecimal, this.stateNumericDecimal(t, r));
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML
   * spec. Digit parsing matches the hex loop in `parseNumericEntity`.
   * The accumulated value is preserved for numeric validation callbacks.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, r) {
    const n = t.length;
    let { result: i } = this, { consumed: o } = this;
    for (; r < n; ) {
      const s = t.charCodeAt(r);
      if (bb(s) || s2(s)) {
        const a = s <= yt.NINE ? s - yt.ZERO : (s | Bs) - yt.LOWER_A + 10;
        i = i * 16 + a, o += 1, r += 1;
      } else
        return this.result = i, this.consumed = o, this.emitNumericEntity(s, 3);
    }
    return this.result = i, this.consumed = o, -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML
   * spec. Digit parsing matches the decimal loop in `parseNumericEntity`.
   * The accumulated value is preserved for numeric validation callbacks.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, r) {
    const n = t.length;
    let { result: i } = this, { consumed: o } = this;
    for (; r < n; ) {
      const s = t.charCodeAt(r) - yt.ZERO;
      if (s >>> 0 > 9)
        return this.result = i, this.consumed = o, this.emitNumericEntity(s + yt.ZERO, 2);
      i = i * 10 + s, o += 1, r += 1;
    }
    return this.result = i, this.consumed = o, -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, r) {
    var n;
    if (this.consumed <= r)
      return (n = this.errors) == null || n.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === yt.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === nr.Strict)
      return 0;
    return this.emitCodePoint((this.decodeTree === Tb ? n2 : r2)(this.result), this.consumed), this.errors && (t !== yt.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Flush locally-tracked walk state back to the fields, then emit the
   * recorded legacy match or reject (cold path — at most once per
   * entity). Called after failed navigation (leaf node, branch miss, or
   * compact-run mismatch). In attribute mode, reject if no legacy was
   * recorded at the current node, if we descended past it, or if the
   * pending input character is an invalid attribute terminator.
   * @param consumed Locally-tracked consumed count.
   * @param excess Locally-tracked excess count.
   * @param char Pending input character (may be the mismatching char).
   * @param valueLength Value length at the current trie node.
   */
  flushAndEmitLegacyOrReject(t, r, n, i) {
    return this.consumed = t, this.excess = r, this.result === 0 || this.decodeMode === nr.Attribute && (i === 0 || r > 1 || u2(n)) ? 0 : this.emitNotTerminatedNamedEntity();
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, r) {
    const { decodeTree: n } = this, i = t.length, o = this.decodeMode === nr.Strict;
    let { treeIndex: s } = this, { excess: a } = this, { consumed: l } = this, f = n[s];
    for (; r < i; ) {
      for (; (f & (ft.VALUE_LENGTH | ft.FLAG13)) === 0 && (f & ft.JUMP_TABLE) !== 0; ) {
        const d = t.charCodeAt(r), g = f & ft.JUMP_TABLE, y = (f & ft.BRANCH_LENGTH) >> 7;
        if (y === 0) {
          if (d !== g)
            return this.flushAndEmitLegacyOrReject(l, a, d, 0);
          s += 1;
        } else {
          const b = d - g;
          if (b >>> 0 >= y)
            return this.flushAndEmitLegacyOrReject(l, a, d, 0);
          const I = n[s + 1 + b];
          if (I === 0)
            return this.flushAndEmitLegacyOrReject(l, a, d, 0);
          s = s + y + I & 65535;
        }
        if (f = n[s], r += 1, a += 1, r >= i)
          break;
      }
      if (r >= i)
        break;
      if ((f & (ft.VALUE_LENGTH | ft.FLAG13)) === ft.FLAG13) {
        const d = (f & ft.BRANCH_LENGTH) >> 7;
        let { runConsumed: g } = this;
        if (g === 0) {
          const y = t.charCodeAt(r);
          if (y !== (f & ft.JUMP_TABLE))
            return this.flushAndEmitLegacyOrReject(l, a, y, 0);
          r += 1, a += 1, g = 1;
        }
        for (; g < d; ) {
          if (r >= i)
            return this.treeIndex = s, this.excess = a, this.consumed = l, this.runConsumed = g, -1;
          const y = g - 1, I = n[s + 1 + (y >> 1)] >> ((y & 1) << 3) & 255, S = t.charCodeAt(r);
          if (S !== I)
            return this.runConsumed = 0, this.flushAndEmitLegacyOrReject(l, a, S, 0);
          r += 1, a += 1, g += 1;
        }
        this.runConsumed = 0, s += 1 + (d >> 1), f = n[s];
        continue;
      }
      const u = f >>> 14, h = t.charCodeAt(r);
      if (u !== 0) {
        if (!o && (f & ft.FLAG13) === 0 && (this.result = s, l += a - 1, a = 1), h === yt.SEMI)
          return this.emitNamedEntityData(s, u, l + a);
        if (u === 1)
          return this.flushAndEmitLegacyOrReject(l, a, h, u);
      }
      const E = c2(n, f, s + (u || 1), h);
      if (E < 0)
        return this.flushAndEmitLegacyOrReject(l, a, h, u);
      s = E, f = n[s], r += 1, a += 1;
    }
    return !o && f >>> 14 && (f & ft.FLAG13) === 0 && (this.result = s, l += a - 1, a = 1), this.treeIndex = s, this.excess = a, this.consumed = l, -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var i;
    const { result: t, decodeTree: r } = this, n = r[t] >>> 14;
    return this.emitNamedEntityData(t, n, this.consumed), (i = this.errors) == null || i.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   * @param result The index of the entity in the decode tree.
   * @param valueLength Encoded value length (header plus any value words).
   * @param consumed The number of characters consumed.
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, r, n) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(r === 1 ? i[t] & ft.VALUE_MASK : i[t + 1], n), r === 3 && this.emitCodePoint(i[t + 2], n), n;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case gt.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== nr.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case gt.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case gt.NumericHex:
        return this.emitNumericEntity(0, 3);
      case gt.NumericStart:
        return (t = this.errors) == null || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      default:
        return 0;
    }
  }
}
function c2(e, t, r, n) {
  const i = (t & ft.BRANCH_LENGTH) >> 7, o = t & ft.JUMP_TABLE;
  if (o) {
    if (i === 0)
      return n === o ? r : -1;
    const l = n - o;
    if (l >>> 0 >= i)
      return -1;
    const f = e[r + l];
    return f === 0 ? -1 : r + i + f - 1 & 65535;
  }
  if (i === 0)
    return -1;
  const s = i + 1 >> 1, a = r + s + i;
  for (let l = 0; l < i; l++) {
    const u = e[r + (l >> 1)] >> ((l & 1) << 3) & 255;
    if (u === n) {
      const h = r + s + l;
      return a + e[h] & 65535;
    }
    if (u > n)
      return -1;
  }
  return -1;
}
var fe;
(function(e) {
  e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(fe || (fe = {}));
var K;
(function(e) {
  e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.DeclarationSequence = 20] = "DeclarationSequence", e[e.InSpecialComment = 21] = "InSpecialComment", e[e.InCommentLike = 22] = "InCommentLike", e[e.SpecialStartSequence = 23] = "SpecialStartSequence", e[e.InSpecialTag = 24] = "InSpecialTag", e[e.InPlainText = 25] = "InPlainText", e[e.InEntity = 26] = "InEntity";
})(K || (K = {}));
function Dn(e) {
  return e === fe.Space || e === fe.NewLine || e === fe.Tab || e === fe.FormFeed || e === fe.CarriageReturn;
}
function ii(e) {
  return e === fe.Slash || e === fe.Gt || Dn(e);
}
function f2(e) {
  return e >= fe.LowerA && e <= fe.LowerZ || e >= fe.UpperA && e <= fe.UpperZ;
}
var Xt;
(function(e) {
  e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
})(Xt || (Xt = {}));
const ve = {
  Empty: new Uint8Array(0),
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 33, 62]),
  // `--!>`
  Doctype: new Uint8Array([100, 111, 99, 116, 121, 112, 101]),
  // `doctype`
  IframeEnd: new Uint8Array([60, 47, 105, 102, 114, 97, 109, 101]),
  // `</iframe`
  NoembedEnd: new Uint8Array([
    60,
    47,
    110,
    111,
    101,
    109,
    98,
    101,
    100
  ]),
  // `</noembed`
  NoframesEnd: new Uint8Array([
    60,
    47,
    110,
    111,
    102,
    114,
    97,
    109,
    101,
    115
  ]),
  // `</noframes`
  Plaintext: new Uint8Array([
    60,
    47,
    112,
    108,
    97,
    105,
    110,
    116,
    101,
    120,
    116
  ]),
  // `</plaintext`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ]),
  // `</textarea`
  XmpEnd: new Uint8Array([60, 47, 120, 109, 112])
  // `</xmp`
}, d2 = /* @__PURE__ */ new Map([
  [ve.IframeEnd[2], ve.IframeEnd],
  [ve.NoembedEnd[2], ve.NoembedEnd],
  [ve.Plaintext[2], ve.Plaintext],
  [ve.ScriptEnd[2], ve.ScriptEnd],
  [ve.TitleEnd[2], ve.TitleEnd],
  [ve.XmpEnd[2], ve.XmpEnd]
]);
class Ab {
  constructor({ xmlMode: t = !1, decodeEntities: r = !0, recognizeSelfClosing: n = t }, i) {
    $(this, "cbs");
    /** The current state the tokenizer is in. */
    $(this, "state", K.Text);
    /** The read buffer. */
    $(this, "buffer", "");
    /** The beginning of the section that is currently being read. */
    $(this, "sectionStart", 0);
    /** The index within the buffer that we are currently looking at. */
    $(this, "index", 0);
    /** The start of the last entity. */
    $(this, "entityStart", 0);
    /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
    $(this, "baseState", K.Text);
    /** For special parsing behavior inside of script and style tags. */
    $(this, "isSpecial", !1);
    /** Indicates whether the tokenizer has been paused. */
    $(this, "running", !0);
    /** The offset of the current buffer. */
    $(this, "offset", 0);
    $(this, "xmlMode");
    $(this, "decodeEntities");
    $(this, "recognizeSelfClosing");
    $(this, "entityDecoder");
    $(this, "currentSequence", ve.Empty);
    $(this, "sequenceIndex", 0);
    this.cbs = i, this.xmlMode = t, this.decodeEntities = r, this.recognizeSelfClosing = n, this.entityDecoder = new l2(t ? Tb : o2, (o, s) => this.emitCodePoint(o, s));
  }
  reset() {
    this.state = K.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = K.Text, this.isSpecial = !1, this.currentSequence = ve.Empty, this.sequenceIndex = 0, this.running = !0, this.offset = 0;
  }
  write(t) {
    this.offset += this.buffer.length, this.buffer = t, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  stateText(t) {
    t === fe.Lt || !this.decodeEntities && this.fastForwardTo(fe.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = K.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === fe.Amp && this.startEntity();
  }
  enterTagBody() {
    this.currentSequence === ve.Plaintext ? (this.currentSequence = ve.Empty, this.state = K.InPlainText) : this.isSpecial ? (this.state = K.InSpecialTag, this.sequenceIndex = 0) : this.state = K.Text;
  }
  /**
   * Match the opening tag name against an HTML text-only tag sequence.
   *
   * Some tags share an initial prefix (`script`/`style`, `title`/`textarea`,
   * `noembed`/`noframes`), so we may switch to an alternate sequence at the
   * first distinguishing byte.  On a successful full match we fall back to
   * the normal tag-name state; a later `>` will enter raw-text, RCDATA, or
   * plaintext mode based on `currentSequence` / `isSpecial`.
   * @param c Current character code point.
   */
  stateSpecialStartSequence(t) {
    const r = t | 32;
    if (this.sequenceIndex < this.currentSequence.length) {
      if (r === this.currentSequence[this.sequenceIndex]) {
        this.sequenceIndex++;
        return;
      }
      if (this.sequenceIndex === 3) {
        if (this.currentSequence === ve.ScriptEnd && r === ve.StyleEnd[3]) {
          this.currentSequence = ve.StyleEnd, this.sequenceIndex = 4;
          return;
        }
        if (this.currentSequence === ve.TitleEnd && r === ve.TextareaEnd[3]) {
          this.currentSequence = ve.TextareaEnd, this.sequenceIndex = 4;
          return;
        }
      } else if (this.sequenceIndex === 4 && this.currentSequence === ve.NoembedEnd && r === ve.NoframesEnd[4]) {
        this.currentSequence = ve.NoframesEnd, this.sequenceIndex = 5;
        return;
      }
    } else if (ii(t)) {
      this.sequenceIndex = 0, this.state = K.InTagName, this.stateInTagName(t);
      return;
    }
    this.isSpecial = !1, this.currentSequence = ve.Empty, this.sequenceIndex = 0, this.state = K.InTagName, this.stateInTagName(t);
  }
  stateCDATASequence(t) {
    t === ve.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === ve.Cdata.length && (this.state = K.InCommentLike, this.currentSequence = ve.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.xmlMode ? (this.state = K.InDeclaration, this.stateInDeclaration(t)) : (this.state = K.InSpecialComment, this.stateInSpecialComment(t)));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   * @param c Current character code point.
   * @returns Whether the character was found.
   */
  fastForwardTo(t) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === t)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Emit a comment token and return to the text state.
   * @param offset Number of characters in the end sequence that have already been matched.
   */
  emitComment(t) {
    this.cbs.oncomment(this.sectionStart, this.index, t), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = K.Text;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   * @param c Current character code point.
   */
  stateInCommentLike(t) {
    !this.xmlMode && this.currentSequence === ve.CommentEnd && this.sequenceIndex <= 1 && /*
     * We're still at the very start of the comment: the only
     * characters consumed since `<!--` are the dashes that
     * advanced sequenceIndex (0 for `<!-->`, 1 for `<!--->`).
     */
    this.index === this.sectionStart + this.sequenceIndex && t === fe.Gt ? this.emitComment(this.sequenceIndex) : this.currentSequence === ve.CommentEnd && this.sequenceIndex === 2 && t === fe.Gt ? this.emitComment(2) : this.currentSequence === ve.CommentEnd && this.sequenceIndex === this.currentSequence.length - 1 && t !== fe.Gt ? this.sequenceIndex = +(t === fe.Dash) : t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === ve.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 3), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = K.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   * @param c Current character code point.
   */
  isTagStartChar(t) {
    return this.xmlMode ? !ii(t) : f2(t);
  }
  /**
   * Scan raw-text / RCDATA content for the matching end tag.
   *
   * For RCDATA tags (`<title>`, `<textarea>`) entities are decoded inline.
   * For raw-text tags (`<script>`, `<style>`, etc.) we fast-forward to `<`.
   * @param c Current character code point.
   */
  stateInSpecialTag(t) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (ii(t)) {
        const r = this.index - this.currentSequence.length;
        if (this.sectionStart < r) {
          const n = this.index;
          this.index = r, this.cbs.ontext(this.sectionStart, r), this.index = n;
        }
        this.isSpecial = !1, this.sectionStart = r + 2, this.stateInClosingTagName(t);
        return;
      }
      this.sequenceIndex = 0;
    }
    (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === ve.TitleEnd || this.currentSequence === ve.TextareaEnd ? this.decodeEntities && t === fe.Amp && this.startEntity() : this.fastForwardTo(fe.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === fe.Lt);
  }
  stateBeforeTagName(t) {
    var r, n;
    if (t === fe.ExclamationMark)
      this.state = K.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (t === fe.Questionmark)
      this.xmlMode ? (this.state = K.InProcessingInstruction, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.state = K.InSpecialComment, this.sectionStart = this.index);
    else if (this.isTagStartChar(t)) {
      this.sectionStart = this.index;
      const i = this.xmlMode || (n = (r = this.cbs).isInForeignContext) != null && n.call(r) ? void 0 : d2.get(t | 32);
      i === void 0 ? this.state = K.InTagName : (this.isSpecial = !0, this.currentSequence = i, this.sequenceIndex = 3, this.state = K.SpecialStartSequence);
    } else t === fe.Slash ? this.state = K.BeforeClosingTagName : (this.state = K.Text, this.stateText(t));
  }
  stateInTagName(t) {
    ii(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = K.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateBeforeClosingTagName(t) {
    Dn(t) ? this.xmlMode || (this.state = K.InSpecialComment, this.sectionStart = this.index) : t === fe.Gt ? (this.state = K.Text, this.xmlMode || (this.sectionStart = this.index + 1)) : (this.state = this.isTagStartChar(t) ? K.InClosingTagName : K.InSpecialComment, this.sectionStart = this.index);
  }
  stateInClosingTagName(t) {
    ii(t) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = K.AfterClosingTagName, this.stateAfterClosingTagName(t));
  }
  stateAfterClosingTagName(t) {
    (t === fe.Gt || this.fastForwardTo(fe.Gt)) && (this.state = K.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(t) {
    t === fe.Gt ? (this.cbs.onopentagend(this.index), this.enterTagBody(), this.sectionStart = this.index + 1) : t === fe.Slash ? this.state = K.InSelfClosingTag : Dn(t) || (this.state = K.InAttributeName, this.sectionStart = this.index);
  }
  /**
   * Handle `/` before `>` in an opening tag.
   *
   * In HTML mode, text-only tags ignore the self-closing flag and still enter
   * their raw-text/RCDATA/plaintext state unless self-closing tags are being
   * recognized. In XML mode, or for ordinary tags, the tokenizer returns to
   * regular text parsing after emitting the self-closing callback.
   * @param c Current character code point.
   */
  stateInSelfClosingTag(t) {
    if (t === fe.Gt) {
      if (this.cbs.onselfclosingtag(this.index), this.sectionStart = this.index + 1, !this.recognizeSelfClosing) {
        this.enterTagBody();
        return;
      }
      this.state = K.Text, this.isSpecial = !1, this.currentSequence = ve.Empty;
    } else Dn(t) || (this.state = K.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateInAttributeName(t) {
    (t === fe.Eq || ii(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = K.AfterAttributeName, this.stateAfterAttributeName(t));
  }
  stateAfterAttributeName(t) {
    t === fe.Eq ? this.state = K.BeforeAttributeValue : t === fe.Slash || t === fe.Gt ? (this.cbs.onattribend(Xt.NoValue, this.sectionStart), this.sectionStart = -1, this.state = K.BeforeAttributeName, this.stateBeforeAttributeName(t)) : Dn(t) || (this.cbs.onattribend(Xt.NoValue, this.sectionStart), this.state = K.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(t) {
    t === fe.DoubleQuote ? (this.state = K.InAttributeValueDq, this.sectionStart = this.index + 1) : t === fe.SingleQuote ? (this.state = K.InAttributeValueSq, this.sectionStart = this.index + 1) : Dn(t) || (this.sectionStart = this.index, this.state = K.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
  }
  handleInAttributeValue(t, r) {
    t === r || !this.decodeEntities && this.fastForwardTo(r) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(r === fe.DoubleQuote ? Xt.Double : Xt.Single, this.index + 1), this.state = K.BeforeAttributeName) : this.decodeEntities && t === fe.Amp && this.startEntity();
  }
  stateInAttributeValueDoubleQuotes(t) {
    this.handleInAttributeValue(t, fe.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(t) {
    this.handleInAttributeValue(t, fe.SingleQuote);
  }
  stateInAttributeValueNoQuotes(t) {
    Dn(t) || t === fe.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(Xt.Unquoted, this.index), this.state = K.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === fe.Amp && this.startEntity();
  }
  /**
   * Distinguish between CDATA, declarations, HTML comments, and HTML bogus
   * comments after `<!`.
   *
   * In HTML mode, only real comments and doctypes stay on declaration paths;
   * everything else becomes a bogus comment terminated by the next `>`.
   * @param c Current character code point.
   */
  stateBeforeDeclaration(t) {
    t === fe.OpeningSquareBracket ? (this.state = K.CDATASequence, this.sequenceIndex = 0) : this.xmlMode ? this.state = t === fe.Dash ? K.BeforeComment : K.InDeclaration : (t | 32) === ve.Doctype[0] ? (this.state = K.DeclarationSequence, this.currentSequence = ve.Doctype, this.sequenceIndex = 1) : t === fe.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = K.Text, this.sectionStart = this.index + 1) : t === fe.Dash ? this.state = K.BeforeComment : this.state = K.InSpecialComment;
  }
  /**
   * Continue matching `doctype` after `<!d`.
   *
   * A full `doctype` match stays on the declaration path; any other name falls
   * back to an HTML bogus comment, which matches browser behavior for
   * non-doctype `<!...>` constructs.
   * @param c Current character code point.
   */
  stateDeclarationSequence(t) {
    this.sequenceIndex === this.currentSequence.length ? (this.state = K.InDeclaration, this.stateInDeclaration(t)) : (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : t === fe.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = K.Text, this.sectionStart = this.index + 1) : this.state = K.InSpecialComment;
  }
  stateInDeclaration(t) {
    (t === fe.Gt || this.fastForwardTo(fe.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = K.Text, this.sectionStart = this.index + 1);
  }
  /**
   * XML processing instructions (`<?...?>`).
   *
   * In HTML mode `<?` is routed to `InSpecialComment` instead, so this
   * state is only reachable in XML mode.
   * @param c Current character code point.
   */
  stateInProcessingInstruction(t) {
    t === fe.Questionmark ? this.sequenceIndex = 1 : t === fe.Gt && this.sequenceIndex === 1 ? (this.cbs.onprocessinginstruction(this.sectionStart, this.index - 1), this.sequenceIndex = 0, this.state = K.Text, this.sectionStart = this.index + 1) : this.sequenceIndex = Number(this.fastForwardTo(fe.Questionmark));
  }
  stateBeforeComment(t) {
    t === fe.Dash ? (this.state = K.InCommentLike, this.currentSequence = ve.CommentEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : this.xmlMode ? this.state = K.InDeclaration : t === fe.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = K.Text, this.sectionStart = this.index + 1) : this.state = K.InSpecialComment;
  }
  stateInSpecialComment(t) {
    (t === fe.Gt || this.fastForwardTo(fe.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = K.Text, this.sectionStart = this.index + 1);
  }
  startEntity() {
    this.baseState = this.state, this.state = K.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? nr.Strict : this.baseState === K.Text || this.baseState === K.InSpecialTag ? nr.Legacy : nr.Attribute);
  }
  stateInEntity() {
    const t = this.index - this.offset, r = this.entityDecoder.write(this.buffer, t);
    if (r >= 0)
      this.state = this.baseState, r === 0 && (this.index -= 1);
    else {
      if (t < this.buffer.length && this.buffer.charCodeAt(t) === fe.Amp) {
        this.state = this.baseState, this.index -= 1;
        return;
      }
      this.index = this.offset + this.buffer.length - 1;
    }
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === K.Text || this.state === K.InPlainText || this.state === K.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === K.InAttributeValueDq || this.state === K.InAttributeValueSq || this.state === K.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const t = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case K.Text: {
          this.stateText(t);
          break;
        }
        case K.InPlainText: {
          this.index = this.buffer.length + this.offset - 1;
          break;
        }
        case K.SpecialStartSequence: {
          this.stateSpecialStartSequence(t);
          break;
        }
        case K.InSpecialTag: {
          this.stateInSpecialTag(t);
          break;
        }
        case K.CDATASequence: {
          this.stateCDATASequence(t);
          break;
        }
        case K.DeclarationSequence: {
          this.stateDeclarationSequence(t);
          break;
        }
        case K.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(t);
          break;
        }
        case K.InAttributeName: {
          this.stateInAttributeName(t);
          break;
        }
        case K.InCommentLike: {
          this.stateInCommentLike(t);
          break;
        }
        case K.InSpecialComment: {
          this.stateInSpecialComment(t);
          break;
        }
        case K.BeforeAttributeName: {
          this.stateBeforeAttributeName(t);
          break;
        }
        case K.InTagName: {
          this.stateInTagName(t);
          break;
        }
        case K.InClosingTagName: {
          this.stateInClosingTagName(t);
          break;
        }
        case K.BeforeTagName: {
          this.stateBeforeTagName(t);
          break;
        }
        case K.AfterAttributeName: {
          this.stateAfterAttributeName(t);
          break;
        }
        case K.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(t);
          break;
        }
        case K.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(t);
          break;
        }
        case K.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(t);
          break;
        }
        case K.AfterClosingTagName: {
          this.stateAfterClosingTagName(t);
          break;
        }
        case K.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(t);
          break;
        }
        case K.InSelfClosingTag: {
          this.stateInSelfClosingTag(t);
          break;
        }
        case K.InDeclaration: {
          this.stateInDeclaration(t);
          break;
        }
        case K.BeforeDeclaration: {
          this.stateBeforeDeclaration(t);
          break;
        }
        case K.BeforeComment: {
          this.stateBeforeComment(t);
          break;
        }
        case K.InProcessingInstruction: {
          this.stateInProcessingInstruction(t);
          break;
        }
        case K.InEntity: {
          this.stateInEntity();
          break;
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === K.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
  }
  handleTrailingCommentLikeData(t) {
    if (this.state !== K.InCommentLike)
      return !1;
    if (this.currentSequence === ve.CdataEnd)
      if (this.xmlMode)
        this.sectionStart < t && this.cbs.oncdata(this.sectionStart, t, 0);
      else {
        const r = this.sectionStart - ve.Cdata.length - 1;
        this.cbs.oncomment(r, t, 0);
      }
    else {
      const r = this.xmlMode ? 0 : Math.min(this.sequenceIndex, ve.CommentEnd.length - 1);
      this.cbs.oncomment(this.sectionStart, t, r);
    }
    return !0;
  }
  handleTrailingMarkupDeclaration(t) {
    if (this.xmlMode)
      switch (this.state) {
        case K.InSpecialComment:
        case K.BeforeComment:
        case K.CDATASequence:
        case K.DeclarationSequence:
        case K.InDeclaration:
          return this.cbs.ontext(this.sectionStart, t), !0;
        default:
          return !1;
      }
    switch (this.state) {
      case K.BeforeDeclaration:
      case K.InSpecialComment:
      case K.BeforeComment:
      case K.CDATASequence:
        return this.cbs.oncomment(this.sectionStart, t, 0), !0;
      case K.DeclarationSequence:
        return this.sequenceIndex !== ve.Doctype.length && this.cbs.oncomment(this.sectionStart, t, 0), !0;
      case K.InDeclaration:
        return !0;
      default:
        return !1;
    }
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const t = this.buffer.length + this.offset;
    if (!(this.handleTrailingCommentLikeData(t) || this.handleTrailingMarkupDeclaration(t)) && !(this.sectionStart >= t))
      switch (this.state) {
        case K.InTagName:
        case K.BeforeAttributeName:
        case K.BeforeAttributeValue:
        case K.AfterAttributeName:
        case K.InAttributeName:
        case K.InAttributeValueSq:
        case K.InAttributeValueDq:
        case K.InAttributeValueNq:
        case K.InClosingTagName:
          break;
        default:
          this.cbs.ontext(this.sectionStart, t);
      }
  }
  emitCodePoint(t, r) {
    this.baseState !== K.Text && this.baseState !== K.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.onattribentity(t)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.ontextentity(t, this.sectionStart));
  }
}
const { fromCodePoint: Ym } = String, oi = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), et = /* @__PURE__ */ new Set(["p"]), si = /* @__PURE__ */ new Set(["h1", "h2", "h3", "h4", "h5", "h6", "p"]), Zm = /* @__PURE__ */ new Set(["thead", "tbody"]), Jm = /* @__PURE__ */ new Set(["dd", "dt"]), Km = /* @__PURE__ */ new Set(["rt", "rp"]), p2 = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["a", /* @__PURE__ */ new Set(["a"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", et],
  ["h1", si],
  ["h2", si],
  ["h3", si],
  ["h4", si],
  ["h5", si],
  ["h6", si],
  ["select", oi],
  ["input", oi],
  ["output", oi],
  ["button", oi],
  ["datalist", oi],
  ["textarea", oi],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", Jm],
  ["dt", Jm],
  ["address", et],
  ["article", et],
  ["aside", et],
  ["blockquote", et],
  ["details", et],
  ["div", et],
  ["dl", et],
  ["fieldset", et],
  ["figcaption", et],
  ["figure", et],
  ["footer", et],
  ["form", et],
  ["header", et],
  ["hr", et],
  ["main", et],
  ["nav", et],
  ["ol", et],
  ["pre", et],
  ["section", et],
  ["table", et],
  ["ul", et],
  ["rt", Km],
  ["rp", Km],
  ["tbody", Zm],
  ["tfoot", Zm]
]), Xm = "doctype", h2 = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), m2 = /* @__PURE__ */ new Set(["math", "svg"]), Qm = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), eE = /* @__PURE__ */ new Map([
  ["altglyph", "altGlyph"],
  ["altglyphdef", "altGlyphDef"],
  ["altglyphitem", "altGlyphItem"],
  ["animatecolor", "animateColor"],
  ["animatemotion", "animateMotion"],
  ["animatetransform", "animateTransform"],
  ["clippath", "clipPath"],
  ["feblend", "feBlend"],
  ["fecolormatrix", "feColorMatrix"],
  ["fecomponenttransfer", "feComponentTransfer"],
  ["fecomposite", "feComposite"],
  ["feconvolvematrix", "feConvolveMatrix"],
  ["fediffuselighting", "feDiffuseLighting"],
  ["fedisplacementmap", "feDisplacementMap"],
  ["fedistantlight", "feDistantLight"],
  ["fedropshadow", "feDropShadow"],
  ["feflood", "feFlood"],
  ["fefunca", "feFuncA"],
  ["fefuncb", "feFuncB"],
  ["fefuncg", "feFuncG"],
  ["fefuncr", "feFuncR"],
  ["fegaussianblur", "feGaussianBlur"],
  ["feimage", "feImage"],
  ["femerge", "feMerge"],
  ["femergenode", "feMergeNode"],
  ["femorphology", "feMorphology"],
  ["feoffset", "feOffset"],
  ["fepointlight", "fePointLight"],
  ["fespecularlighting", "feSpecularLighting"],
  ["fespotlight", "feSpotLight"],
  ["fetile", "feTile"],
  ["feturbulence", "feTurbulence"],
  ["foreignobject", "foreignObject"],
  ["glyphref", "glyphRef"],
  ["lineargradient", "linearGradient"],
  ["radialgradient", "radialGradient"],
  ["textpath", "textPath"]
]);
var Or;
(function(e) {
  e[e.None = 0] = "None", e[e.Svg = 1] = "Svg", e[e.MathML = 2] = "MathML";
})(Or || (Or = {}));
const E2 = /\s|\//;
class Uc {
  constructor(t, r = {}) {
    $(this, "options");
    /** The start index of the last event. */
    $(this, "startIndex", 0);
    /** The end index of the last event. */
    $(this, "endIndex", 0);
    /**
     * Store the start index of the current open tag,
     * so we can update the start index for attributes.
     */
    $(this, "openTagStart", 0);
    $(this, "tagname", "");
    $(this, "attribname", "");
    $(this, "attribvalue", "");
    $(this, "attribs", null);
    $(this, "stack", []);
    $(this, "foreignContext");
    $(this, "cbs");
    $(this, "lowerCaseTagNames");
    $(this, "lowerCaseAttributeNames");
    $(this, "recognizeSelfClosing");
    /** We are parsing HTML. Inverse of the `xmlMode` option. */
    $(this, "htmlMode");
    $(this, "tokenizer");
    $(this, "buffers", []);
    $(this, "bufferOffset", 0);
    /** The index of the last written buffer. Used when resuming after a `pause()`. */
    $(this, "writeIndex", 0);
    /** Indicates whether the parser has finished running / `.end` has been called. */
    $(this, "ended", !1);
    var n, i;
    this.options = r, this.cbs = t ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = r.lowerCaseTags ?? this.htmlMode, this.lowerCaseAttributeNames = r.lowerCaseAttributeNames ?? this.htmlMode, this.recognizeSelfClosing = r.recognizeSelfClosing ?? !this.htmlMode, this.tokenizer = new (r.Tokenizer ?? Ab)(this.options, this), this.foreignContext = [Or.None], (i = (n = this.cbs).onparserinit) == null || i.call(n, this);
  }
  // Tokenizer event handlers
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ontext(t, r) {
    var i, o;
    const n = this.getSlice(t, r);
    this.endIndex = r - 1, (o = (i = this.cbs).ontext) == null || o.call(i, n), this.startIndex = r;
  }
  /**
   * @param cp Current Unicode code point.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ontextentity(t, r) {
    var n, i;
    this.endIndex = r - 1, (i = (n = this.cbs).ontext) == null || i.call(n, Ym(t)), this.startIndex = r;
  }
  /** @internal */
  isInForeignContext() {
    return this.foreignContext[0] !== Or.None;
  }
  /**
   * Checks if the current tag is a void element. Override this if you want
   * to specify your own additional void elements.
   * @param name Name of the pseudo selector.
   */
  isVoidElement(t) {
    return this.htmlMode && h2.has(t);
  }
  /**
   * Read a tag name from the buffer.
   *
   * When `lowerCaseTagNames` is enabled (the default in HTML mode), the name
   * is lowercased and may be adjusted for SVG casing or the `image` → `img`
   * alias.
   * @param start Start index of the tag name in the buffer.
   * @param endIndex End index of the tag name in the buffer.
   */
  readTagName(t, r) {
    const n = this.lowerCaseTagNames ? this.getSlice(t, r).toLowerCase() : this.getSlice(t, r);
    if (!(this.lowerCaseTagNames && this.htmlMode))
      return n;
    if (this.foreignContext[0] === Or.Svg)
      return eE.get(n) ?? n;
    if (this.foreignContext.length > 1) {
      const i = eE.get(n);
      if (i !== void 0 && this.stack.includes(i))
        return i;
    }
    return this.isInForeignContext() ? n : n === "image" ? "img" : n;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onopentagname(t, r) {
    this.endIndex = r, this.emitOpenTag(this.readTagName(t, r));
  }
  emitOpenTag(t) {
    var n, i;
    if (this.openTagStart = this.startIndex, this.tagname = t, this.htmlMode && t === "form" && this.stack.includes("form")) {
      this.tagname = "";
      return;
    }
    const r = this.htmlMode && p2.get(t);
    if (r)
      for (; this.stack.length > 0 && r.has(this.stack[0]); )
        this.popElement(!0);
    this.isVoidElement(t) || (this.stack.unshift(t), this.htmlMode && (t === "svg" ? this.foreignContext.unshift(Or.Svg) : t === "math" ? this.foreignContext.unshift(Or.MathML) : Qm.has(t) && this.foreignContext.unshift(Or.None))), (i = (n = this.cbs).onopentagname) == null || i.call(n, t), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(t) {
    var r, n;
    this.startIndex = this.openTagStart, this.attribs && ((n = (r = this.cbs).onopentag) == null || n.call(r, this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /**
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onopentagend(t) {
    this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onclosetag(t, r) {
    var i, o, s, a, l, f;
    this.endIndex = r;
    const n = this.readTagName(t, r);
    if (this.isVoidElement(n))
      this.htmlMode && n === "br" && ((o = (i = this.cbs).onopentagname) == null || o.call(i, "br"), (a = (s = this.cbs).onopentag) == null || a.call(s, "br", {}, !0), (f = (l = this.cbs).onclosetag) == null || f.call(l, "br", !1));
    else {
      const u = this.stack.indexOf(n);
      if (u !== -1) {
        for (let h = 0; h < u; h++)
          this.popElement(!0);
        this.popElement(!1);
      } else this.htmlMode && n === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = r + 1;
  }
  /**
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onselfclosingtag(t) {
    this.endIndex = t, this.recognizeSelfClosing || this.isInForeignContext() ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
  }
  /**
   * Pop the top element off the stack, emit a close event, and maintain
   * the foreign context stack.
   * @param implied Whether this close is implied (not from an explicit end tag).
   */
  popElement(t) {
    var n, i;
    const r = this.stack.shift();
    this.htmlMode && (m2.has(r) || Qm.has(r)) && this.foreignContext.shift(), (i = (n = this.cbs).onclosetag) == null || i.call(n, r, t);
  }
  closeCurrentTag(t) {
    const r = this.tagname;
    this.endOpenTag(t), this.stack[0] === r && this.popElement(!t);
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribname(t, r) {
    this.startIndex = t;
    const n = this.getSlice(t, r);
    this.attribname = this.lowerCaseAttributeNames ? n.toLowerCase() : n;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribdata(t, r) {
    this.attribvalue += this.getSlice(t, r);
  }
  /**
   * @param cp Current Unicode code point.
   * @internal
   */
  onattribentity(t) {
    this.attribvalue += Ym(t);
  }
  /**
   * @param quote Quote type used for the current attribute.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribend(t, r) {
    var n, i;
    this.endIndex = r, (i = (n = this.cbs).onattribute) == null || i.call(n, this.attribname, this.attribvalue, t === Xt.Double ? '"' : t === Xt.Single ? "'" : t === Xt.NoValue ? void 0 : null), this.attribs && !Object.hasOwn(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(t) {
    const r = t.search(E2);
    let n = r < 0 ? t : t.substr(0, r);
    return this.lowerCaseTagNames && (n = n.toLowerCase()), n;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ondeclaration(t, r) {
    this.endIndex = r;
    const n = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const i = this.htmlMode ? this.lowerCaseTagNames ? Xm : n.slice(0, Xm.length) : this.getInstructionName(n);
      this.cbs.onprocessinginstruction(`!${i}`, `!${n}`);
    }
    this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onprocessinginstruction(t, r) {
    this.endIndex = r;
    const n = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const i = this.getInstructionName(n);
      this.cbs.onprocessinginstruction(`?${i}`, `?${n}`);
    }
    this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @param offset Offset applied when computing parser indices.
   * @internal
   */
  oncomment(t, r, n) {
    var i, o, s, a;
    this.endIndex = r, (o = (i = this.cbs).oncomment) == null || o.call(i, this.getSlice(t, r - n)), (a = (s = this.cbs).oncommentend) == null || a.call(s), this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @param offset Offset applied when computing parser indices.
   * @internal
   */
  oncdata(t, r, n) {
    var o, s, a, l, f, u, h, E, d, g, y, b;
    this.endIndex = r;
    const i = this.getSlice(t, r - n);
    !this.htmlMode || this.options.recognizeCDATA ? ((s = (o = this.cbs).oncdatastart) == null || s.call(o), (l = (a = this.cbs).ontext) == null || l.call(a, i), (u = (f = this.cbs).oncdataend) == null || u.call(f)) : this.isInForeignContext() ? (E = (h = this.cbs).ontext) == null || E.call(h, i) : ((g = (d = this.cbs).oncomment) == null || g.call(d, `[CDATA[${i}]]`), (b = (y = this.cbs).oncommentend) == null || b.call(y)), this.startIndex = r + 1;
  }
  /** @internal */
  onend() {
    var t, r;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let n = 0; n < this.stack.length; n++)
        this.cbs.onclosetag(this.stack[n], !0);
    }
    (r = (t = this.cbs).onend) == null || r.call(t);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var t, r, n, i;
    (r = (t = this.cbs).onreset) == null || r.call(t), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (i = (n = this.cbs).onparserinit) == null || i.call(n, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(Or.None), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   * @param data Document to parse.
   */
  parseComplete(t) {
    this.reset(), this.end(t);
  }
  getSlice(t, r) {
    if (t === r)
      return "";
    for (; t - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let n = this.buffers[0].slice(t - this.bufferOffset, r - this.bufferOffset);
    for (; r - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), n += this.buffers[0].slice(0, r - this.bufferOffset);
    return n;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   * @param chunk Chunk to parse.
   */
  write(t) {
    var r, n;
    if (this.ended) {
      (n = (r = this.cbs).onerror) == null || n.call(r, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   * @param chunk Optional final chunk to parse.
   */
  end(t) {
    var r, n;
    if (this.ended) {
      (n = (r = this.cbs).onerror) == null || n.call(r, new Error(".end() after done!"));
      return;
    }
    t && this.write(t), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
}
var Pe;
(function(e) {
  e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
})(Pe || (Pe = {}));
function vb(e) {
  return e.type === Pe.Tag || e.type === Pe.Script || e.type === Pe.Style;
}
const Sb = Pe.Root, Ib = Pe.Text, _b = Pe.Directive, Rb = Pe.Comment, Ob = Pe.Script, wb = Pe.Style, Nb = Pe.Tag, Cb = Pe.CDATA, g2 = Pe.Doctype, y2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CDATA: Cb,
  Comment: Rb,
  Directive: _b,
  Doctype: g2,
  get ElementType() {
    return Pe;
  },
  Root: Sb,
  Script: Ob,
  Style: wb,
  Tag: Nb,
  Text: Ib,
  isTag: vb
}, Symbol.toStringTag, { value: "Module" }));
class Pb {
  constructor() {
    /** Parent of the node */
    $(this, "parent", null);
    /** Previous sibling */
    $(this, "prev", null);
    /** Next sibling */
    $(this, "next", null);
    /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
    $(this, "startIndex", null);
    /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
    $(this, "endIndex", null);
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(t) {
    this.parent = t;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(t) {
    this.prev = t;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(t) {
    this.next = t;
  }
  /**
   * Clone this node, and optionally its children.
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(t = !1) {
    return jb(this, t);
  }
}
class $c extends Pb {
  /**
   * @param data The content of the data node
   */
  constructor(r) {
    super();
    $(this, "data");
    this.data = r;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(r) {
    this.data = r;
  }
}
class dl extends $c {
  constructor() {
    super(...arguments);
    $(this, "type", Pe.Text);
  }
  get nodeType() {
    return 3;
  }
}
class Db extends $c {
  constructor() {
    super(...arguments);
    $(this, "type", Pe.Comment);
  }
  get nodeType() {
    return 8;
  }
}
class Mb extends $c {
  constructor(r, n) {
    super(n);
    $(this, "type", Pe.Directive);
    $(this, "name");
    /** If this is a doctype, the document type name (parse5 only). */
    $(this, "x-name");
    /** If this is a doctype, the document type public identifier (parse5 only). */
    $(this, "x-publicId");
    /** If this is a doctype, the document type system identifier (parse5 only). */
    $(this, "x-systemId");
    this.name = r;
  }
  get nodeType() {
    return 1;
  }
}
class Fc extends Pb {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(r) {
    super();
    $(this, "children");
    this.children = r;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    return this.children[0] ?? null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(r) {
    this.children = r;
  }
}
class Lb extends Fc {
  constructor() {
    super(...arguments);
    $(this, "type", Pe.CDATA);
  }
  get nodeType() {
    return 4;
  }
}
class pl extends Fc {
  constructor() {
    super(...arguments);
    $(this, "type", Pe.Root);
  }
  get nodeType() {
    return 9;
  }
}
class xb extends Fc {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   * @param type Node type used for the new node instance.
   */
  constructor(r, n, i = [], o = r === "script" ? Pe.Script : r === "style" ? Pe.Style : Pe.Tag) {
    super(i);
    $(this, "name");
    $(this, "attribs");
    $(this, "type");
    /** Element namespace (parse5 only). */
    $(this, "namespace");
    /** Element attribute namespaces (parse5 only). */
    $(this, "x-attribsNamespace");
    /** Element attribute namespace-related prefixes (parse5 only). */
    $(this, "x-attribsPrefix");
    this.name = r, this.attribs = n, this.type = o;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(r) {
    this.name = r;
  }
  get attributes() {
    return Object.keys(this.attribs).map((r) => {
      var n, i;
      return {
        name: r,
        value: this.attribs[r],
        namespace: (n = this["x-attribsNamespace"]) == null ? void 0 : n[r],
        prefix: (i = this["x-attribsPrefix"]) == null ? void 0 : i[r]
      };
    });
  }
}
function zt(e) {
  return vb(e);
}
function zc(e) {
  return e.type === Pe.CDATA;
}
function Ii(e) {
  return e.type === Pe.Text;
}
function kb(e) {
  return e.type === Pe.Comment;
}
function T2(e) {
  return e.type === Pe.Directive;
}
function b2(e) {
  return e.type === Pe.Root;
}
function lr(e) {
  return Object.hasOwn(e, "children");
}
function jb(e, t = !1) {
  let r;
  if (Ii(e))
    r = new dl(e.data);
  else if (kb(e))
    r = new Db(e.data);
  else if (zt(e)) {
    const n = t ? Ba(e.children) : [], i = new xb(e.name, { ...e.attribs }, n);
    for (const o of n)
      o.parent = i;
    e.namespace != null && (i.namespace = e.namespace), e["x-attribsNamespace"] && (i["x-attribsNamespace"] = { ...e["x-attribsNamespace"] }), e["x-attribsPrefix"] && (i["x-attribsPrefix"] = { ...e["x-attribsPrefix"] }), r = i;
  } else if (zc(e)) {
    const n = t ? Ba(e.children) : [], i = new Lb(n);
    for (const o of n)
      o.parent = i;
    r = i;
  } else if (b2(e)) {
    const n = t ? Ba(e.children) : [], i = new pl(n);
    for (const o of n)
      o.parent = i;
    e["x-mode"] && (i["x-mode"] = e["x-mode"]), r = i;
  } else if (T2(e)) {
    const n = new Mb(e.name, e.data);
    e["x-name"] != null && (n["x-name"] = e["x-name"], n["x-publicId"] = e["x-publicId"], n["x-systemId"] = e["x-systemId"]), r = n;
  } else
    throw new Error(`Not implemented yet: ${e.type}`);
  return r.startIndex = e.startIndex, r.endIndex = e.endIndex, e.sourceCodeLocation != null && (r.sourceCodeLocation = e.sourceCodeLocation), r;
}
function Ba(e) {
  const t = e.map((r) => jb(r, !0));
  for (let r = 1; r < t.length; r++)
    t[r].prev = t[r - 1], t[r - 1].next = t[r];
  return t;
}
const tE = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class Vs {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(t, r, n) {
    /** The elements of the DOM */
    $(this, "dom", []);
    /** The root element for the DOM */
    $(this, "root", new pl(this.dom));
    /** Called once parsing has completed. */
    $(this, "callback");
    /** Settings for the handler. */
    $(this, "options");
    /** Callback whenever a tag is closed. */
    $(this, "elementCB");
    /** Indicated whether parsing has been completed. */
    $(this, "done", !1);
    /** Stack of open tags. */
    $(this, "tagStack", [this.root]);
    /** A data node that is still being written to. */
    $(this, "lastNode", null);
    /** Reference to the parser instance. Used for location information. */
    $(this, "parser", null);
    typeof r == "function" && (n = r, r = tE), typeof t == "object" && (r = t, t = void 0), this.callback = t ?? null, this.options = r ?? tE, this.elementCB = n ?? null;
  }
  onparserinit(t) {
    this.parser = t;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new pl(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(t) {
    this.handleCallback(t);
  }
  onclosetag() {
    this.lastNode = null;
    const t = this.tagStack.pop();
    this.options.withEndIndices && this.parser && (t.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(t);
  }
  onopentag(t, r) {
    const n = this.options.xmlMode ? Pe.Tag : void 0, i = new xb(t, r, void 0, n);
    this.addNode(i), this.tagStack.push(i);
  }
  ontext(t) {
    const { lastNode: r } = this;
    if (r && r.type === Pe.Text)
      r.data += t, this.options.withEndIndices && this.parser && (r.endIndex = this.parser.endIndex);
    else {
      const n = new dl(t);
      this.addNode(n), this.lastNode = n;
    }
  }
  oncomment(t) {
    if (this.lastNode && this.lastNode.type === Pe.Comment) {
      this.lastNode.data += t;
      return;
    }
    const r = new Db(t);
    this.addNode(r), this.lastNode = r;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const t = new dl(""), r = new Lb([t]);
    this.addNode(r), t.parent = r, this.lastNode = t;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(t, r) {
    const n = new Mb(t, r);
    this.addNode(n);
  }
  handleCallback(t) {
    if (typeof this.callback == "function")
      this.callback(t, this.dom);
    else if (t)
      throw t;
  }
  addNode(t) {
    const r = this.tagStack[this.tagStack.length - 1], n = r.children[r.children.length - 1];
    this.options.withStartIndices && this.parser && (t.startIndex = this.parser.startIndex), this.options.withEndIndices && this.parser && (t.endIndex = this.parser.endIndex), r.children.push(t), n && (t.prev = n, n.next = t), t.parent = r, this.lastNode = null;
  }
}
function Jo(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return Ub(e, Array.isArray(t) ? t : [t], r, n);
}
function Ub(e, t, r, n) {
  const i = [], o = [Array.isArray(t) ? t : [t]], s = [0];
  for (; ; ) {
    if (s[0] >= o[0].length) {
      if (s.length === 1)
        return i;
      o.shift(), s.shift();
      continue;
    }
    const a = o[0][s[0]++];
    if (e(a) && (i.push(a), --n <= 0))
      return i;
    r && lr(a) && a.children.length > 0 && (s.unshift(0), o.unshift(a.children));
  }
}
function Gc(e, t, r = !0) {
  const n = Array.isArray(t) ? t : [t];
  for (const i of n) {
    if (zt(i) && e(i))
      return i;
    if (r && lr(i) && i.children.length > 0) {
      const o = Gc(e, i.children, !0);
      if (o)
        return o;
    }
  }
  return null;
}
function $b(e, t) {
  return (Array.isArray(t) ? t : [t]).some((r) => zt(r) && e(r) || lr(r) && $b(e, r.children));
}
function A2(e, t) {
  const r = [], n = [Array.isArray(t) ? t : [t]], i = [0];
  for (; ; ) {
    if (i[0] >= n[0].length) {
      if (n.length === 1)
        return r;
      n.shift(), i.shift();
      continue;
    }
    const o = n[0][i[0]++];
    zt(o) && e(o) && r.push(o), lr(o) && o.children.length > 0 && (i.unshift(0), n.unshift(o.children));
  }
}
const Ws = {
  tag_name(e) {
    return typeof e == "function" ? (t) => zt(t) && e(t.name) : e === "*" ? zt : (t) => zt(t) && t.name === e;
  },
  tag_type(e) {
    return typeof e == "function" ? (t) => e(t.type) : (t) => t.type === e;
  },
  tag_contains(e) {
    return typeof e == "function" ? (t) => Ii(t) && e(t.data) : (t) => Ii(t) && t.data === e;
  }
};
function Bc(e, t) {
  return typeof t == "function" ? (r) => zt(r) && t(r.attribs[e]) : (r) => zt(r) && r.attribs[e] === t;
}
function v2(e, t) {
  return (r) => e(r) || t(r);
}
function Fb(e) {
  const t = Object.keys(e).map((r) => {
    const n = e[r];
    return Object.hasOwn(Ws, r) ? Ws[r](n) : Bc(r, n);
  });
  return t.length === 0 ? null : t.reduce(v2);
}
function S2(e, t) {
  const r = Fb(e);
  return r ? r(t) : !0;
}
function I2(e, t, r, n = Number.POSITIVE_INFINITY) {
  const i = Fb(e);
  return i ? Jo(i, t, r, n) : [];
}
function _2(e, t, r = !0) {
  return Array.isArray(t) || (t = [t]), Gc(Bc("id", e), t, r);
}
function Pi(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return Jo(Ws.tag_name(e), t, r, n);
}
function R2(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return Jo(Bc("class", e), t, r, n);
}
function O2(e, t, r = !0, n = Number.POSITIVE_INFINITY) {
  return Jo(Ws.tag_type(e), t, r, n);
}
function zb(e) {
  return e === 34 ? "&quot;" : e === 38 ? "&amp;" : e === 39 ? "&apos;" : e === 60 ? "&lt;" : e === 62 ? "&gt;" : "&nbsp;";
}
const w2 = 1342177476, Va = /["&'<>\u0080-\uFFFF]/g;
function rE(e) {
  return e >= 128 || e >= 32 && e < 64 && (w2 >>> e & 1) === 1;
}
function Gb(e) {
  const { length: t } = e;
  let r, n = 0, i = 0;
  for (; i < t; ) {
    const o = e.charCodeAt(i);
    if (!rE(o)) {
      const a = Math.min(i + 32, t);
      let l = i + 1;
      for (; l < a && !rE(e.charCodeAt(l)); )
        l++;
      if (l < a) {
        i = l;
        continue;
      }
      if (l >= t || (Va.lastIndex = l, !Va.test(e)))
        break;
      i = Va.lastIndex - 1;
      continue;
    }
    if (r === void 0 ? r = e.substring(0, i) : n !== i && (r += e.substring(n, i)), o < 64) {
      r += zb(o), n = i += 1;
      continue;
    }
    const s = e.codePointAt(i);
    r += `&#x${s.toString(16)};`, s !== o && i++, n = i += 1;
  }
  return r === void 0 ? e : (n < t && (r += e.substr(n)), r);
}
function Bb(e, t) {
  if (e.lastIndex = 0, !e.test(t))
    return t;
  let r = "", n = 0;
  do {
    const i = e.lastIndex - 1;
    n !== i && (r += t.substring(n, i));
    const o = t.charCodeAt(i);
    r += zb(o), n = i + 1;
  } while (e.test(t));
  return r + t.substring(n);
}
const N2 = /["&\u{A0}]/gu;
function C2(e) {
  return Bb(N2, e);
}
const P2 = /[&<>\u{A0}]/gu;
function D2(e) {
  return Bb(P2, e);
}
const M2 = new Map("altGlyph altGlyphDef altGlyphItem animateColor animateMotion animateTransform clipPath feBlend feColorMatrix feComponentTransfer feComposite feConvolveMatrix feDiffuseLighting feDisplacementMap feDistantLight feDropShadow feFlood feFuncA feFuncB feFuncG feFuncR feGaussianBlur feImage feMerge feMergeNode feMorphology feOffset fePointLight feSpecularLighting feSpotLight feTile feTurbulence foreignObject glyphRef linearGradient radialGradient textPath".split(" ").map((e) => [e.toLowerCase(), e])), L2 = new Map("definitionURL attributeName attributeType baseFrequency baseProfile calcMode clipPathUnits diffuseConstant edgeMode filterUnits glyphRef gradientTransform gradientUnits kernelMatrix kernelUnitLength keyPoints keySplines keyTimes lengthAdjust limitingConeAngle markerHeight markerUnits markerWidth maskContentUnits maskUnits numOctaves pathLength patternContentUnits patternTransform patternUnits pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits refX refY repeatCount repeatDur requiredExtensions requiredFeatures specularConstant specularExponent spreadMethod startOffset stdDeviation stitchTiles surfaceScale systemLanguage tableValues targetX targetY textLength viewBox viewTarget xChannelSelector yChannelSelector zoomAndPan".split(" ").map((e) => [e.toLowerCase(), e])), x2 = new Set("style script xmp iframe noembed noframes plaintext noscript".split(" ")), k2 = new Set("area base basefont br col command embed frame hr img input isindex keygen link meta param source track wbr".split(" ")), j2 = /* @__PURE__ */ new Set(["svg", "math"]), U2 = new Set("mi mo mn ms mtext annotation-xml foreignObject desc title".split(" "));
function $2(e, t = {}) {
  const r = "length" in e ? e : [e], n = t.xmlMode ?? !1;
  let i = "";
  for (let o = 0; o < r.length; o++)
    i += Wb(r[o], t, n);
  return i;
}
function Vb(e, t, r) {
  let n = "";
  for (let i = 0; i < e.length; i++)
    n += Wb(e[i], t, r);
  return n;
}
function Wb(e, t, r) {
  switch (e.type) {
    case Sb:
      return Vb(e.children, t, r);
    case _b:
      return `<${e.data}>`;
    case Rb:
      return `<!--${e.data}-->`;
    case Cb:
      return `<![CDATA[${e.children[0].data}]]>`;
    case Ob:
    case wb:
    case Nb:
      return F2(e, t, r);
    case Ib: {
      const n = e, i = n.data || "";
      return (t.encodeEntities ?? t.decodeEntities) !== !1 && !(!r && n.parent && x2.has(n.parent.name)) ? r || t.encodeEntities !== "utf8" ? Gb(i) : D2(i) : i;
    }
  }
}
function F2(e, t, r) {
  r === "foreign" && (e.name = M2.get(e.name) ?? e.name, e.parent && U2.has(e.parent.name) && (r = !1)), !r && j2.has(e.name) && (r = "foreign");
  const { name: n, children: i } = e, o = !r && k2.has(n);
  let s = `<${n}${G2(e.attribs, t, r)}`;
  return i.length === 0 && (r ? t.selfClosingTags !== !1 : t.selfClosingTags && o) ? s += r ? "/>" : " />" : (s += ">", i.length > 0 && (s += Vb(i, t, r)), o || (s += `</${n}>`)), s;
}
function z2(e) {
  return e.replaceAll('"', "&quot;");
}
function G2(e, t, r) {
  if (!e)
    return "";
  const n = (t.encodeEntities ?? t.decodeEntities) === !1 ? z2 : r || t.encodeEntities !== "utf8" ? Gb : C2, i = r === "foreign", o = !!(t.emptyAttrs ?? r);
  let s = "";
  for (const a in e) {
    if (!Object.hasOwn(e, a))
      continue;
    const l = e[a], f = i ? L2.get(a) ?? a : a;
    s += !o && (l == null || l === "") ? ` ${f}` : ` ${f}="${n(l == null ? "" : String(l))}"`;
  }
  return s;
}
function qb(e, t) {
  return $2(e, t);
}
function B2(e, t) {
  return lr(e) ? e.children.map((r) => qb(r, t)).join("") : "";
}
function Ss(e) {
  return Array.isArray(e) ? e.map(Ss).join("") : zt(e) ? e.name === "br" ? `
` : Ss(e.children) : zc(e) ? Ss(e.children) : Ii(e) ? e.data : "";
}
function qs(e) {
  return Array.isArray(e) ? e.map(qs).join("") : lr(e) && !kb(e) ? qs(e.children) : Ii(e) ? e.data : "";
}
function hl(e) {
  return Array.isArray(e) ? e.map(hl).join("") : lr(e) && (e.type === Pe.Tag || zc(e)) ? hl(e.children) : Ii(e) ? e.data : "";
}
function Vc(e) {
  const t = Hs(Y2, e);
  return t ? t.name === "feed" ? V2(t) : W2(t) : null;
}
function V2(e) {
  var o;
  const t = e.children, r = {
    type: "atom",
    items: Pi("entry", t).map((s) => {
      var E;
      const { children: a } = s, l = { media: Hb(a) };
      _t(l, "id", "id", a), _t(l, "title", "title", a);
      const f = (E = Hs("link", a)) == null ? void 0 : E.attribs.href;
      f && (l.link = f);
      const u = qr("summary", a) || qr("content", a);
      u && (l.description = u);
      const h = qr("updated", a);
      return h && (l.pubDate = new Date(h)), l;
    })
  };
  _t(r, "id", "id", t), _t(r, "title", "title", t);
  const n = (o = Hs("link", t)) == null ? void 0 : o.attribs.href;
  n && (r.link = n), _t(r, "description", "subtitle", t);
  const i = qr("updated", t);
  return i && (r.updated = new Date(i)), _t(r, "author", "email", t, !0), r;
}
function W2(e) {
  var i;
  const t = ((i = Hs("channel", e.children)) == null ? void 0 : i.children) ?? [], r = {
    type: e.name.substr(0, 3),
    id: "",
    items: Pi("item", e.children).map((o) => {
      const { children: s } = o, a = { media: Hb(s) };
      _t(a, "id", "guid", s), _t(a, "title", "title", s), _t(a, "link", "link", s), _t(a, "description", "description", s);
      const l = qr("pubDate", s) || qr("dc:date", s);
      return l && (a.pubDate = new Date(l)), a;
    })
  };
  _t(r, "title", "title", t), _t(r, "link", "link", t), _t(r, "description", "description", t);
  const n = qr("lastBuildDate", t);
  return n && (r.updated = new Date(n)), _t(r, "author", "managingEditor", t, !0), r;
}
const q2 = ["url", "type", "lang"], H2 = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function Hb(e) {
  return Pi("media:content", e).map((t) => {
    const { attribs: r } = t, n = {
      medium: r.medium,
      isDefault: !!r.isDefault
    };
    for (const i of q2)
      r[i] && (n[i] = r[i]);
    for (const i of H2)
      r[i] && (n[i] = Number.parseInt(r[i], 10));
    return r.expression && (n.expression = r.expression), n;
  });
}
function Hs(e, t) {
  return Pi(e, t, !0, 1)[0];
}
function qr(e, t, r = !1) {
  return qs(Pi(e, t, r, 1)).trim();
}
function _t(e, t, r, n, i = !1) {
  const o = qr(r, n, i);
  o && (e[t] = o);
}
function Y2(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
function Z2(e) {
  let t = e.length;
  for (; --t >= 0; ) {
    const r = e[t];
    if (t > 0 && e.lastIndexOf(r, t - 1) >= 0) {
      e.splice(t, 1);
      continue;
    }
    for (let n = r.parent; n; n = n.parent)
      if (e.includes(n)) {
        e.splice(t, 1);
        break;
      }
  }
  return e;
}
var kt;
(function(e) {
  e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
})(kt || (kt = {}));
function Yb(e, t) {
  const r = [], n = [];
  if (e === t)
    return 0;
  let i = lr(e) ? e : e.parent;
  for (; i; )
    r.unshift(i), i = i.parent;
  for (i = lr(t) ? t : t.parent; i; )
    n.unshift(i), i = i.parent;
  const o = Math.min(r.length, n.length);
  let s = 0;
  for (; s < o && r[s] === n[s]; )
    s++;
  if (s === 0)
    return kt.DISCONNECTED;
  const a = r[s - 1], l = a.children, f = r[s], u = n[s];
  return l.indexOf(f) > l.indexOf(u) ? a === t ? kt.FOLLOWING | kt.CONTAINED_BY : kt.FOLLOWING : a === e ? kt.PRECEDING | kt.CONTAINS : kt.PRECEDING;
}
function J2(e) {
  return e = e.filter((t, r, n) => !n.includes(t, r + 1)), e.sort((t, r) => {
    const n = Yb(t, r);
    return n & kt.PRECEDING ? -1 : n & kt.FOLLOWING ? 1 : 0;
  }), e;
}
function Ko(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    const t = e.parent.children, r = t.lastIndexOf(e);
    r !== -1 && t.splice(r, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
function K2(e, t) {
  if (t.prev = e.prev, t.prev && (t.prev.next = t), t.next = e.next, t.next && (t.next.prev = t), t.parent = e.parent, t.parent) {
    const { children: r } = t.parent, n = r.lastIndexOf(e);
    if (n === -1)
      return;
    r[n] = t, e.parent = null;
  }
}
function X2(e, t) {
  if (Ko(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    const r = e.children[e.children.length - 2];
    r.next = t, t.prev = r;
  } else
    t.prev = null;
}
function Q2(e, t) {
  Ko(t);
  const { parent: r } = e, n = e.next;
  if (t.next = n, t.prev = e, e.next = t, t.parent = r, n) {
    if (n.prev = t, r) {
      const i = r.children;
      i.splice(i.lastIndexOf(n), 0, t);
    }
  } else r && r.children.push(t);
}
function e$(e, t) {
  if (Ko(t), t.parent = e, t.prev = null, e.children.unshift(t) === 1)
    t.next = null;
  else {
    const r = e.children[1];
    r.prev = t, t.next = r;
  }
}
function t$(e, t) {
  Ko(t);
  const { parent: r } = e;
  if (r) {
    const n = r.children;
    n.splice(n.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
}
function Zb(e) {
  return lr(e) ? e.children : [];
}
function Jb(e) {
  return e.parent || null;
}
function r$(e) {
  const t = Jb(e);
  if (t != null)
    return Zb(t);
  const r = [e];
  let { prev: n, next: i } = e;
  for (; n != null; )
    r.unshift(n), { prev: n } = n;
  for (; i != null; )
    r.push(i), { next: i } = i;
  return r;
}
function n$(e, t) {
  const { attribs: r } = e;
  return r == null ? void 0 : r[t];
}
function i$(e, t) {
  const { attribs: r } = e;
  return r != null && Object.hasOwn(r, t) && r[t] != null;
}
function o$(e) {
  return e.name;
}
function s$(e) {
  let { next: t } = e;
  for (; t !== null && !zt(t); )
    ({ next: t } = t);
  return t;
}
function a$(e) {
  let { prev: t } = e;
  for (; t !== null && !zt(t); )
    ({ prev: t } = t);
  return t;
}
const u$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DocumentPosition() {
    return kt;
  },
  append: Q2,
  appendChild: X2,
  compareDocumentPosition: Yb,
  existsOne: $b,
  filter: Jo,
  find: Ub,
  findAll: A2,
  findOne: Gc,
  getAttributeValue: n$,
  getChildren: Zb,
  getElementById: _2,
  getElements: I2,
  getElementsByClassName: R2,
  getElementsByTagName: Pi,
  getElementsByTagType: O2,
  getFeed: Vc,
  getInnerHTML: B2,
  getName: o$,
  getOuterHTML: qb,
  getParent: Jb,
  getSiblings: r$,
  getText: Ss,
  hasAttrib: i$,
  innerText: hl,
  nextElementSibling: s$,
  prepend: t$,
  prependChild: e$,
  prevElementSibling: a$,
  removeElement: Ko,
  removeSubsets: Z2,
  replaceElement: K2,
  testElement: S2,
  textContent: qs,
  uniqueSort: J2
}, Symbol.toStringTag, { value: "Module" }));
function Kb(e, t) {
  const r = new Vs(void 0, t);
  return new Uc(r, t).end(e), r.root;
}
function l$(e, t, r) {
  const n = new Vs((i) => e(i, n.root), t, r);
  return new Uc(n, t);
}
const c$ = { xmlMode: !0 };
function f$(e, t = c$) {
  return Vc(Kb(e, t).children);
}
const d$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultHandler: Vs,
  DomHandler: Vs,
  DomUtils: u$,
  ElementType: y2,
  Parser: Uc,
  get QuoteType() {
    return Xt;
  },
  Tokenizer: Ab,
  createDocumentStream: l$,
  getFeed: Vc,
  parseDocument: Kb,
  parseFeed: f$
}, Symbol.toStringTag, { value: "Module" })), p$ = /* @__PURE__ */ hb(d$);
var Wa, nE;
function h$() {
  return nE || (nE = 1, Wa = (e) => {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), Wa;
}
var qa = {}, iE;
function m$() {
  if (iE) return qa;
  iE = 1;
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function e(r) {
    return Object.prototype.toString.call(r) === "[object Object]";
  }
  function t(r) {
    var n, i;
    return e(r) === !1 ? !1 : (n = r.constructor, n === void 0 ? !0 : (i = n.prototype, !(e(i) === !1 || i.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return qa.isPlainObject = t, qa;
}
var Ha, oE;
function E$() {
  if (oE) return Ha;
  oE = 1;
  var e = function(S) {
    return t(S) && !r(S);
  };
  function t(I) {
    return !!I && typeof I == "object";
  }
  function r(I) {
    var S = Object.prototype.toString.call(I);
    return S === "[object RegExp]" || S === "[object Date]" || o(I);
  }
  var n = typeof Symbol == "function" && Symbol.for, i = n ? Symbol.for("react.element") : 60103;
  function o(I) {
    return I.$$typeof === i;
  }
  function s(I) {
    return Array.isArray(I) ? [] : {};
  }
  function a(I, S) {
    return S.clone !== !1 && S.isMergeableObject(I) ? y(s(I), I, S) : I;
  }
  function l(I, S, w) {
    return I.concat(S).map(function(P) {
      return a(P, w);
    });
  }
  function f(I, S) {
    if (!S.customMerge)
      return y;
    var w = S.customMerge(I);
    return typeof w == "function" ? w : y;
  }
  function u(I) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(I).filter(function(S) {
      return Object.propertyIsEnumerable.call(I, S);
    }) : [];
  }
  function h(I) {
    return Object.keys(I).concat(u(I));
  }
  function E(I, S) {
    try {
      return S in I;
    } catch {
      return !1;
    }
  }
  function d(I, S) {
    return E(I, S) && !(Object.hasOwnProperty.call(I, S) && Object.propertyIsEnumerable.call(I, S));
  }
  function g(I, S, w) {
    var P = {};
    return w.isMergeableObject(I) && h(I).forEach(function(_) {
      P[_] = a(I[_], w);
    }), h(S).forEach(function(_) {
      d(I, _) || (E(I, _) && w.isMergeableObject(S[_]) ? P[_] = f(_, w)(I[_], S[_], w) : P[_] = a(S[_], w));
    }), P;
  }
  function y(I, S, w) {
    w = w || {}, w.arrayMerge = w.arrayMerge || l, w.isMergeableObject = w.isMergeableObject || e, w.cloneUnlessOtherwiseSpecified = a;
    var P = Array.isArray(S), _ = Array.isArray(I), v = P === _;
    return v ? P ? w.arrayMerge(I, S, w) : g(I, S, w) : a(S, w);
  }
  y.all = function(S, w) {
    if (!Array.isArray(S))
      throw new Error("first argument should be an array");
    return S.reduce(function(P, _) {
      return y(P, _, w);
    }, {});
  };
  var b = y;
  return Ha = b, Ha;
}
var Is = { exports: {} }, g$ = Is.exports, sE;
function y$() {
  return sE || (sE = 1, (function(e) {
    (function(t, r) {
      e.exports ? e.exports = r() : t.parseSrcset = r();
    })(g$, function() {
      return function(t) {
        function r(P) {
          return P === " " || // space
          P === "	" || // horizontal tab
          P === `
` || // new line
          P === "\f" || // form feed
          P === "\r";
        }
        function n(P) {
          var _, v = P.exec(t.substring(b));
          if (v)
            return _ = v[0], b += _.length, _;
        }
        for (var i = t.length, o = /^[ \t\n\r\u000c]+/, s = /^[, \t\n\r\u000c]+/, a = /^[^ \t\n\r\u000c]+/, l = /[,]+$/, f = /^\d+$/, u = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, h, E, d, g, y, b = 0, I = []; ; ) {
          if (n(s), b >= i)
            return I;
          h = n(a), E = [], h.slice(-1) === "," ? (h = h.replace(l, ""), w()) : S();
        }
        function S() {
          for (n(o), d = "", g = "in descriptor"; ; ) {
            if (y = t.charAt(b), g === "in descriptor")
              if (r(y))
                d && (E.push(d), d = "", g = "after descriptor");
              else if (y === ",") {
                b += 1, d && E.push(d), w();
                return;
              } else if (y === "(")
                d = d + y, g = "in parens";
              else if (y === "") {
                d && E.push(d), w();
                return;
              } else
                d = d + y;
            else if (g === "in parens")
              if (y === ")")
                d = d + y, g = "in descriptor";
              else if (y === "") {
                E.push(d), w();
                return;
              } else
                d = d + y;
            else if (g === "after descriptor" && !r(y))
              if (y === "") {
                w();
                return;
              } else
                g = "in descriptor", b -= 1;
            b += 1;
          }
        }
        function w() {
          var P = !1, _, v, M, x, z = {}, F, W, X, de, B;
          for (x = 0; x < E.length; x++)
            F = E[x], W = F[F.length - 1], X = F.substring(0, F.length - 1), de = parseInt(X, 10), B = parseFloat(X), f.test(X) && W === "w" ? ((_ || v) && (P = !0), de === 0 ? P = !0 : _ = de) : u.test(X) && W === "x" ? ((_ || v || M) && (P = !0), B < 0 ? P = !0 : v = B) : f.test(X) && W === "h" ? ((M || v) && (P = !0), de === 0 ? P = !0 : M = de) : P = !0;
          P ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + F + "'.") : (z.url = h, _ && (z.w = _), v && (z.d = v), M && (z.h = M), I.push(z));
        }
      };
    });
  })(Is)), Is.exports;
}
var ps = { exports: {} }, aE;
function T$() {
  if (aE) return ps.exports;
  aE = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return ps.exports = t(), ps.exports.createColors = t, ps.exports;
}
const b$ = {}, A$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: b$
}, Symbol.toStringTag, { value: "Module" })), Qt = /* @__PURE__ */ hb(A$);
var Ya, uE;
function Wc() {
  if (uE) return Ya;
  uE = 1;
  let e = /* @__PURE__ */ T$(), t = Qt;
  class r extends Error {
    constructor(i, o, s, a, l, f) {
      super(i), this.name = "CssSyntaxError", this.reason = i, l && (this.file = l), a && (this.source = a), f && (this.plugin = f), typeof o < "u" && typeof s < "u" && (typeof o == "number" ? (this.line = o, this.column = s) : (this.line = o.line, this.column = o.column, this.endLine = s.line, this.endColumn = s.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, r);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(i) {
      if (!this.source) return "";
      let o = this.source;
      i == null && (i = e.isColorSupported);
      let s = (d) => d, a = (d) => d, l = (d) => d;
      if (i) {
        let { bold: d, gray: g, red: y } = e.createColors(!0);
        a = (b) => d(y(b)), s = (b) => g(b), t && (l = (b) => t(b));
      }
      let f = o.split(/\r?\n/), u = Math.max(this.line - 3, 0), h = Math.min(this.line + 2, f.length), E = String(h).length;
      return f.slice(u, h).map((d, g) => {
        let y = u + 1 + g, b = " " + (" " + y).slice(-E) + " | ";
        if (y === this.line) {
          if (d.length > 160) {
            let S = 20, w = Math.max(0, this.column - S), P = Math.max(
              this.column + S,
              this.endColumn + S
            ), _ = d.slice(w, P), v = s(b.replace(/\d/g, " ")) + d.slice(0, Math.min(this.column - 1, S - 1)).replace(/[^\t]/g, " ");
            return a(">") + s(b) + l(_) + `
 ` + v + a("^");
          }
          let I = s(b.replace(/\d/g, " ")) + d.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return a(">") + s(b) + l(d) + `
 ` + I + a("^");
        }
        return " " + s(b) + l(d);
      }).join(`
`);
    }
    toString() {
      let i = this.showSourceCode();
      return i && (i = `

` + i + `
`), this.name + ": " + this.message + i;
    }
  }
  return Ya = r, r.default = r, Ya;
}
var Za, lE;
function Xb() {
  if (lE) return Za;
  lE = 1;
  const e = /[\t\n\f\r "#'()/;[\\\]{}]/, t = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function r(l) {
    return l[0].toUpperCase() + l.slice(1);
  }
  function n(l, f) {
    let u = "@" + f.name, h = f.params ? l.rawValue(f, "params") : "", E = f.raws.afterName;
    return typeof E > "u" ? E = h ? " " : "" : E === "" && h && !e.test(h[0]) && (E = " "), u + E + h;
  }
  function i(l) {
    if (!l.prop.startsWith("--")) return !1;
    let f = l.raws.before;
    return typeof f > "u" || !/[^\s;]$/.test(f);
  }
  function o(l, f, u) {
    let h = u.nodes, E = h.length - 1;
    for (; E > 0 && h[E].type === "comment"; )
      E -= 1;
    let d = l.raw(u, "semicolon"), g = u.type === "document";
    for (let y = h.length - 1; y >= 0; y--) {
      let b = h[y], I = E !== y || d;
      !I && y < h.length - 1 && (b.type === "atrule" && !b.nodes || b.type === "decl" && i(b)) && (I = !0), f.push({
        document: g,
        node: b,
        semicolon: I
      });
    }
  }
  function s(l, f, u, h) {
    let E = l.raw(u, "between", "beforeOpen");
    l.builder(h + E + "{", u, "start");
    let d = u.nodes && u.nodes.length, g = () => {
      let y = d ? l.raw(u, "after") : l.raw(u, "after", "emptyBody");
      y && l.builder(y), l.builder("}", u, "end"), u.type === "rule" && u.raws.ownSemicolon && l.builder(u.raws.ownSemicolon, u, "end");
    };
    d ? (f.push(g), o(l, f, u)) : g();
  }
  class a {
    constructor(f) {
      this.builder = f;
    }
    atrule(f, u) {
      let h = n(this, f);
      if (f.nodes)
        this.block(f, h);
      else {
        let E = (f.raws.between || "") + (u ? ";" : "");
        this.builder(h + E, f);
      }
    }
    beforeAfter(f, u) {
      let h;
      f.type === "decl" ? h = this.raw(f, null, "beforeDecl") : f.type === "comment" ? h = this.raw(f, null, "beforeComment") : u === "before" ? h = this.raw(f, null, "beforeRule") : h = this.raw(f, null, "beforeClose");
      let E = f.parent, d = 0;
      for (; E && E.type !== "root"; )
        d += 1, E = E.parent;
      if (h.includes(`
`)) {
        let g = this.raw(f, null, "indent");
        if (g.length)
          for (let y = 0; y < d; y++) h += g;
      }
      return h;
    }
    block(f, u) {
      let h = this.raw(f, "between", "beforeOpen");
      this.builder(u + h + "{", f, "start");
      let E;
      f.nodes && f.nodes.length ? (this.body(f), E = this.raw(f, "after")) : E = this.raw(f, "after", "emptyBody"), E && this.builder(E), this.builder("}", f, "end");
    }
    body(f) {
      let u = a.prototype, h = ["atrule", "block", "body", "rule", "stringify"].every(
        (d) => this[d] === u[d]
      ), E = [];
      for (o(this, E, f); E.length > 0; ) {
        let d = E.pop();
        if (typeof d == "function") {
          d();
          continue;
        }
        let g = d.node, y = this.raw(g, "before");
        y && this.builder(y), h && g.type === "rule" ? s(this, E, g, this.rawValue(g, "selector")) : h && g.type === "atrule" && g.nodes ? s(this, E, g, n(this, g)) : this.stringify(g, d.semicolon);
      }
    }
    comment(f) {
      let u = this.raw(f, "left", "commentLeft"), h = this.raw(f, "right", "commentRight");
      this.builder("/*" + u + f.text + h + "*/", f);
    }
    decl(f, u) {
      let h = f.raws, E = this.raw(f, "between", "colon"), d = f.prop + E + this.rawValue(f, "value");
      f.important && (d += h.important || " !important"), u && (d += ";"), this.builder(d, f);
    }
    document(f) {
      this.body(f);
    }
    raw(f, u, h) {
      let E;
      if (h || (h = u), u && (E = f.raws[u], typeof E < "u"))
        return E;
      let d = f.parent;
      if (h === "before" && (!d || d.type === "root" && d.first === f || d && d.type === "document"))
        return "";
      if (!d) return t[h];
      let g = f.root(), y = g.rawCache || (g.rawCache = {});
      if (typeof y[h] < "u")
        return y[h];
      if (h === "before" || h === "after")
        return this.beforeAfter(f, h);
      {
        let b = "raw" + r(h);
        this[b] ? E = this[b](g, f) : g.walk((I) => {
          if (E = I.raws[u], typeof E < "u") return !1;
        });
      }
      return typeof E > "u" && (E = t[h]), y[h] = E, E;
    }
    rawBeforeClose(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && h.nodes.length > 0 && typeof h.raws.after < "u")
          return u = h.raws.after, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
      }), u && (u = u.replace(/\S/g, "")), u;
    }
    rawBeforeComment(f, u) {
      let h;
      return f.walkComments((E) => {
        if (typeof E.raws.before < "u")
          return h = E.raws.before, h.includes(`
`) && (h = h.replace(/[^\n]+$/, "")), !1;
      }), typeof h > "u" ? h = this.raw(u, null, "beforeDecl") : h && (h = h.replace(/\S/g, "")), h;
    }
    rawBeforeDecl(f, u) {
      let h;
      return f.walkDecls((E) => {
        if (typeof E.raws.before < "u")
          return h = E.raws.before, h.includes(`
`) && (h = h.replace(/[^\n]+$/, "")), !1;
      }), typeof h > "u" ? h = this.raw(u, null, "beforeRule") : h && (h = h.replace(/\S/g, "")), h;
    }
    rawBeforeOpen(f) {
      let u;
      return f.walk((h) => {
        if (h.type !== "decl" && (u = h.raws.between, typeof u < "u"))
          return !1;
      }), u;
    }
    rawBeforeRule(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && (h.parent !== f || f.first !== h) && typeof h.raws.before < "u")
          return u = h.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
      }), u && (u = u.replace(/\S/g, "")), u;
    }
    rawColon(f) {
      let u;
      return f.walkDecls((h) => {
        if (typeof h.raws.between < "u")
          return u = h.raws.between.replace(/[^\s:]/g, ""), !1;
      }), u;
    }
    rawEmptyBody(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && h.nodes.length === 0 && (u = h.raws.after, typeof u < "u"))
          return !1;
      }), u;
    }
    rawIndent(f) {
      if (f.raws.indent) return f.raws.indent;
      let u;
      return f.walk((h) => {
        let E = h.parent;
        if (E && E !== f && E.parent && E.parent === f && typeof h.raws.before < "u") {
          let d = h.raws.before.split(`
`);
          return u = d[d.length - 1], u = u.replace(/\S/g, ""), !1;
        }
      }), u;
    }
    rawSemicolon(f) {
      let u;
      return f.walk((h) => {
        if (h.nodes && h.nodes.length && h.last.type === "decl" && (u = h.raws.semicolon, typeof u < "u"))
          return !1;
      }), u;
    }
    rawValue(f, u) {
      let h = f[u], E = f.raws[u];
      return E && E.value === h ? E.raw : h;
    }
    root(f) {
      !(f.parent && f.parent.type === "document") && f.source && f.source.input.hasBOM && this.builder("\uFEFF", f, "start"), this.body(f), f.raws.after && this.builder(f.raws.after);
    }
    rule(f) {
      this.block(f, this.rawValue(f, "selector")), f.raws.ownSemicolon && this.builder(f.raws.ownSemicolon, f, "end");
    }
    stringify(f, u) {
      if (!this[f.type])
        throw new Error(
          "Unknown AST node type " + f.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[f.type](f, u);
    }
  }
  return Za = a, a.default = a, Za;
}
var Ja, cE;
function Ta() {
  if (cE) return Ja;
  cE = 1;
  let e = Xb();
  const t = /(<)(\/?style\b)/gi, r = /(<)(!--)/g;
  function n(s) {
    return s.includes("<") ? s.replace(t, "\\3c $2").replace(r, "\\3c $2") : s;
  }
  class i extends e {
    escapeHTML(a, l) {
      let f = this.builder, u, h;
      if (this.builder = (d, g, y) => {
        u ? (h += d, u.push(d, g, y)) : d.includes("<") ? (h = d, u = [d, g, y]) : f(d, g, y);
      }, l(), this.builder = f, !u) return;
      let E = n(h);
      if (E === h)
        for (let d = 0; d < u.length; d += 3)
          f(u[d], u[d + 1], u[d + 2]);
      else
        f(E, a);
    }
    root(a) {
      a.parent && a.parent.type === "document" ? (this.escapeHTML(a, () => this.body(a)), a.raws.after && this.builder(a.raws.after)) : this.escapeHTML(a, () => super.root(a));
    }
  }
  function o(s, a) {
    let l = new i(a);
    s.type === "root" || s.type === "document" ? l.stringify(s) : l.escapeHTML(s, () => l.stringify(s));
  }
  return Ja = o, o.default = o, Ja;
}
var hs = {}, fE;
function ba() {
  return fE || (fE = 1, hs.isClean = Symbol("isClean"), hs.my = Symbol("my")), hs;
}
var Ka, dE;
function Aa() {
  if (dE) return Ka;
  dE = 1;
  let e = Wc(), t = Xb(), r = Ta(), { isClean: n, my: i } = ba();
  function o(l, f) {
    let u = new l.constructor(), h = [[l, u, f]];
    for (; h.length > 0; ) {
      let [E, d, g] = h.pop();
      for (let y in E) {
        if (!Object.prototype.hasOwnProperty.call(E, y) || y === "proxyCache") continue;
        let b = E[y], I = typeof b;
        if (y === "parent" && I === "object")
          g && (d[y] = g);
        else if (y === "source")
          d[y] = b;
        else if (Array.isArray(b)) {
          let S = [];
          d[y] = S;
          for (let w of b) {
            let P = new w.constructor();
            S.push(P), h.push([w, P, d]);
          }
        } else {
          if (I === "object" && b !== null) {
            let S = new b.constructor();
            h.push([b, S, void 0]), b = S;
          }
          d[y] = b;
        }
      }
    }
    return u;
  }
  function s(l, f) {
    if (f && typeof f.offset < "u")
      return f.offset;
    let u = 1, h = 1, E = 0;
    for (let d = 0; d < l.length; d++) {
      if (h === f.line && u === f.column) {
        E = d;
        break;
      }
      l[d] === `
` ? (u = 1, h += 1) : u += 1;
    }
    return E;
  }
  class a {
    get proxyOf() {
      return this;
    }
    constructor(f = {}) {
      this.raws = {}, this[n] = !1, this[i] = !0;
      for (let u of Object.keys(f))
        if (u !== "__proto__")
          if (u === "nodes") {
            this.nodes = [];
            for (let h of f[u])
              typeof h.clone == "function" && h.parent ? this.append(h.clone()) : this.append(h);
          } else
            this[u] = f[u];
    }
    addToError(f) {
      if (f.postcssNode = this, f.stack && this.source && /\n\s{4}at /.test(f.stack)) {
        let u = this.source;
        f.stack = f.stack.replace(
          /\n\s{4}at /,
          `$&${u.input.from}:${u.start.line}:${u.start.column}$&`
        );
      }
      return f;
    }
    after(f) {
      return this.parent.insertAfter(this, f), this;
    }
    assign(f = {}) {
      for (let u in f)
        this[u] = f[u];
      return this;
    }
    before(f) {
      return this.parent.insertBefore(this, f), this;
    }
    cleanRaws(f) {
      delete this.raws.before, delete this.raws.after, f || delete this.raws.between;
    }
    clone(f = {}) {
      let u = o(this);
      for (let h in f)
        u[h] = f[h];
      return u;
    }
    cloneAfter(f = {}) {
      let u = this.clone(f);
      return this.parent.insertAfter(this, u), u;
    }
    cloneBefore(f = {}) {
      let u = this.clone(f);
      return this.parent.insertBefore(this, u), u;
    }
    error(f, u = {}) {
      if (this.source) {
        let { end: h, start: E } = this.rangeBy(u);
        return this.source.input.error(
          f,
          { column: E.column, line: E.line },
          { column: h.column, line: h.line },
          u
        );
      }
      return new e(f);
    }
    getProxyProcessor() {
      return {
        get(f, u) {
          return u === "proxyOf" ? f : u === "root" ? () => f.root().toProxy() : f[u];
        },
        set(f, u, h) {
          return f[u] === h || (f[u] = h, (u === "prop" || u === "value" || u === "name" || u === "params" || u === "important" || /* c8 ignore next */
          u === "text") && f.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[n] = !0;
    }
    markDirty() {
      if (this[n]) {
        this[n] = !1;
        let f = this;
        for (; f = f.parent; )
          f[n] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let f = this.parent.index(this);
      return this.parent.nodes[f + 1];
    }
    positionBy(f = {}) {
      let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, h = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: s(u, this.source.start)
      };
      if (f.index)
        h = this.positionInside(f.index);
      else if (f.word) {
        let d = u.slice(
          s(u, this.source.start),
          s(u, this.source.end)
        ).indexOf(f.word);
        d !== -1 && (h = this.positionInside(d));
      }
      return h;
    }
    positionInside(f) {
      let u = this.source.start.column, h = this.source.start.line, E = "document" in this.source.input ? this.source.input.document : this.source.input.css, d = s(E, this.source.start), g = d + f;
      for (let y = d; y < g; y++)
        E[y] === `
` ? (u = 1, h += 1) : u += 1;
      return { column: u, line: h, offset: g };
    }
    prev() {
      if (!this.parent) return;
      let f = this.parent.index(this);
      return this.parent.nodes[f - 1];
    }
    rangeBy(f = {}) {
      let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, h = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: s(u, this.source.start)
      }, E = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          s(u, this.source.end) + 1
        )
      } : {
        column: h.column + 1,
        line: h.line,
        offset: h.offset + 1
      };
      if (f.word) {
        let g = u.slice(
          s(u, this.source.start),
          s(u, this.source.end)
        ).indexOf(f.word);
        g !== -1 && (h = this.positionInside(g), E = this.positionInside(g + f.word.length));
      } else
        f.start ? h = {
          column: f.start.column,
          line: f.start.line,
          offset: s(u, f.start)
        } : typeof f.index == "number" && (h = this.positionInside(f.index)), f.end ? E = {
          column: f.end.column,
          line: f.end.line,
          offset: s(u, f.end)
        } : typeof f.endIndex == "number" ? E = this.positionInside(f.endIndex) : typeof f.index == "number" && (E = this.positionInside(f.index + 1));
      return (E.line < h.line || E.line === h.line && E.column <= h.column) && (E = {
        column: h.column + 1,
        line: h.line,
        offset: h.offset + 1
      }), { end: E, start: h };
    }
    raw(f, u) {
      return new t().raw(this, f, u);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...f) {
      if (this.parent) {
        let u = this, h = !1;
        for (let E of f)
          E === this ? h = !0 : h ? (this.parent.insertAfter(u, E), u = E) : this.parent.insertBefore(u, E);
        h || this.remove();
      }
      return this;
    }
    root() {
      let f = this;
      for (; f.parent && f.parent.type !== "document"; )
        f = f.parent;
      return f;
    }
    toJSON(f, u) {
      let h = u == null;
      u = u || /* @__PURE__ */ new Map();
      let E = [], d = [[this, E, 0]];
      for (let y = 0; y < d.length; y++) {
        let [b, I, S] = d[y], w = {};
        I[S] = w;
        for (let P in b) {
          if (!Object.prototype.hasOwnProperty.call(b, P) || P === "parent" || P === "proxyCache") continue;
          let _ = b[P];
          if (Array.isArray(_)) {
            let v = [];
            w[P] = v;
            for (let M = 0; M < _.length; M++) {
              let x = _[M];
              typeof x == "object" && x.toJSON ? x.toJSON === a.prototype.toJSON ? d.push([x, v, M]) : v[M] = x.toJSON(null, u) : v[M] = x;
            }
          } else if (typeof _ == "object" && _.toJSON)
            _.toJSON === a.prototype.toJSON ? d.push([_, w, P]) : w[P] = _.toJSON(null, u);
          else if (P === "source") {
            if (_ == null) continue;
            let v = u.get(_.input);
            v == null && (v = u.size, u.set(_.input, v)), w[P] = {
              end: _.end,
              inputId: v,
              start: _.start
            };
          } else
            w[P] = _;
        }
      }
      let g = E[0];
      return h && (g.inputs = [...u.keys()].map((y) => y.toJSON())), g;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(f = r) {
      f.stringify && (f = f.stringify);
      let u = "";
      return f(this, (h) => {
        u += h;
      }), u;
    }
    warn(f, u, h = {}) {
      let E = { node: this };
      for (let d in h) E[d] = h[d];
      return f.warn(u, E);
    }
  }
  return Ka = a, a.default = a, Ka;
}
var Xa, pE;
function va() {
  if (pE) return Xa;
  pE = 1;
  let e = Aa();
  class t extends e {
    constructor(n) {
      super(n), this.type = "comment";
    }
  }
  return Xa = t, t.default = t, Xa;
}
var Qa, hE;
function Sa() {
  if (hE) return Qa;
  hE = 1;
  let e = Aa();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(n) {
      n && typeof n.value < "u" && typeof n.value != "string" && (n = { ...n, value: String(n.value) }), super(n), this.type = "decl";
    }
  }
  return Qa = t, t.default = t, Qa;
}
var eu, mE;
function rn() {
  if (mE) return eu;
  mE = 1;
  let e = va(), t = Sa(), r = Aa(), { isClean: n, my: i } = ba(), o, s, a, l;
  function f(E) {
    let d = E.slice();
    for (; d.length > 0; ) {
      let g = d.pop();
      if (delete g.source, g.nodes) {
        g.nodes = g.nodes.slice();
        for (let y of g.nodes) d.push(y);
      }
    }
    return E.slice();
  }
  function u(E) {
    let d = [E];
    for (; d.length > 0; ) {
      let g = d.pop();
      if (g[n] = !1, g.proxyOf.nodes)
        for (let y of g.proxyOf.nodes) d.push(y);
    }
  }
  class h extends r {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...d) {
      for (let g of d) {
        let y = this.normalize(g, this.last);
        for (let b of y) this.proxyOf.nodes.push(b);
      }
      return this.markDirty(), this;
    }
    cleanRaws(d) {
      let g = [this];
      for (; g.length > 0; ) {
        let y = g.pop();
        if (y !== this && y.cleanRaws !== h.prototype.cleanRaws) {
          y.cleanRaws(d);
          continue;
        }
        if (r.prototype.cleanRaws.call(y, d), y.nodes)
          for (let b of y.nodes) g.push(b);
      }
    }
    each(d) {
      if (!this.proxyOf.nodes) return;
      let g = this.getIterator(), y, b;
      for (; this.indexes[g] < this.proxyOf.nodes.length && (y = this.indexes[g], b = d(this.proxyOf.nodes[y], y), b !== !1); )
        this.indexes[g] += 1;
      return delete this.indexes[g], b;
    }
    every(d) {
      return this.nodes.every(d);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let d = this.lastEach;
      return this.indexes[d] = 0, d;
    }
    getProxyProcessor() {
      return {
        get(d, g) {
          return g === "proxyOf" ? d : d[g] ? g === "each" || typeof g == "string" && g.startsWith("walk") ? (...y) => d[g](
            ...y.map((b) => typeof b == "function" ? (I, S) => b(I.toProxy(), S) : b)
          ) : g === "every" || g === "some" ? (y) => d[g](
            (b, ...I) => y(b.toProxy(), ...I)
          ) : g === "root" ? () => d.root().toProxy() : g === "nodes" ? d.nodes.map((y) => y.toProxy()) : g === "first" || g === "last" ? d[g].toProxy() : d[g] : d[g];
        },
        set(d, g, y) {
          return d[g] === y || (d[g] = y, (g === "name" || g === "params" || g === "selector") && d.markDirty()), !0;
        }
      };
    }
    index(d) {
      return typeof d == "number" ? d : (d.proxyOf && (d = d.proxyOf), this.proxyOf.nodes.indexOf(d));
    }
    insertAfter(d, g) {
      let y = this.index(d), b = this.normalize(g, this.proxyOf.nodes[y]).reverse();
      y = this.index(d);
      for (let S of b) this.proxyOf.nodes.splice(y + 1, 0, S);
      let I;
      for (let S in this.indexes)
        I = this.indexes[S], y < I && (this.indexes[S] = I + b.length);
      return this.markDirty(), this;
    }
    insertBefore(d, g) {
      let y = this.index(d), b = y === 0 ? "prepend" : !1, I = this.normalize(
        g,
        this.proxyOf.nodes[y],
        b
      ).reverse();
      y = this.index(d);
      for (let w of I) this.proxyOf.nodes.splice(y, 0, w);
      let S;
      for (let w in this.indexes)
        S = this.indexes[w], y <= S && (this.indexes[w] = S + I.length);
      return this.markDirty(), this;
    }
    normalize(d, g) {
      if (typeof d == "string")
        d = f(s(d).nodes);
      else if (typeof d > "u")
        d = [];
      else if (Array.isArray(d)) {
        d = d.slice(0);
        for (let b of d)
          b.parent && b.parent.removeChild(b, "ignore");
      } else if (d.type === "root" && this.type !== "document") {
        d = d.nodes.slice(0);
        for (let b of d)
          b.parent && b.parent.removeChild(b, "ignore");
      } else if (d.type)
        d = [d];
      else if (d.prop) {
        if (typeof d.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof d.value != "string" && (d.value = String(d.value)), d = [new t(d)];
      } else if (d.selector || d.selectors)
        d = [new l(d)];
      else if (d.name)
        d = [new o(d)];
      else if (d.text)
        d = [new e(d)];
      else
        throw new Error("Unknown node type in node creation");
      return d.map((b) => (b[i] || h.rebuild(b), b = b.proxyOf, b.parent && b.parent.removeChild(b), b[n] && u(b), b.raws || (b.raws = {}), typeof b.raws.before > "u" && g && typeof g.raws.before < "u" && (b.raws.before = g.raws.before.replace(/\S/g, "")), b.parent = this.proxyOf, b));
    }
    prepend(...d) {
      d = d.reverse();
      for (let g of d) {
        let y = this.normalize(g, this.first, "prepend").reverse();
        for (let b of y) this.proxyOf.nodes.unshift(b);
        for (let b in this.indexes)
          this.indexes[b] = this.indexes[b] + y.length;
      }
      return this.markDirty(), this;
    }
    push(d) {
      return d.parent = this, this.proxyOf.nodes.push(d), this;
    }
    removeAll() {
      for (let d of this.proxyOf.nodes) d.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(d) {
      d = this.index(d), this.proxyOf.nodes[d].parent = void 0, this.proxyOf.nodes.splice(d, 1);
      let g;
      for (let y in this.indexes)
        g = this.indexes[y], g >= d && (this.indexes[y] = g - 1);
      return this.markDirty(), this;
    }
    replaceValues(d, g, y) {
      return y || (y = g, g = {}), this.walkDecls((b) => {
        g.props && !g.props.includes(b.prop) || g.fast && !b.value.includes(g.fast) || (b.value = b.value.replace(d, y));
      }), this.markDirty(), this;
    }
    some(d) {
      return this.nodes.some(d);
    }
    walk(d) {
      if (!this.proxyOf.nodes) return;
      let g = [{ iterator: this.getIterator(), node: this.proxyOf }];
      for (; g.length > 0; ) {
        let { iterator: y, node: b } = g[g.length - 1], I = b.indexes[y];
        if (I >= b.proxyOf.nodes.length) {
          delete b.indexes[y], g.pop();
          let P = g[g.length - 1];
          P && (P.node.indexes[P.iterator] += 1);
          continue;
        }
        let S = b.proxyOf.nodes[I], w;
        try {
          w = d(S, I);
        } catch (P) {
          throw S.addToError(P);
        }
        if (w === !1) {
          for (let P of g)
            delete P.node.indexes[P.iterator];
          return !1;
        }
        S.walk && S.proxyOf.nodes ? g.push({ iterator: S.getIterator(), node: S }) : b.indexes[y] += 1;
      }
    }
    walkAtRules(d, g) {
      return g ? d instanceof RegExp ? this.walk((y, b) => {
        if (y.type === "atrule" && d.test(y.name))
          return g(y, b);
      }) : this.walk((y, b) => {
        if (y.type === "atrule" && y.name === d)
          return g(y, b);
      }) : (g = d, this.walk((y, b) => {
        if (y.type === "atrule")
          return g(y, b);
      }));
    }
    walkComments(d) {
      return this.walk((g, y) => {
        if (g.type === "comment")
          return d(g, y);
      });
    }
    walkDecls(d, g) {
      return g ? d instanceof RegExp ? this.walk((y, b) => {
        if (y.type === "decl" && d.test(y.prop))
          return g(y, b);
      }) : this.walk((y, b) => {
        if (y.type === "decl" && y.prop === d)
          return g(y, b);
      }) : (g = d, this.walk((y, b) => {
        if (y.type === "decl")
          return g(y, b);
      }));
    }
    walkRules(d, g) {
      return g ? d instanceof RegExp ? this.walk((y, b) => {
        if (y.type === "rule" && d.test(y.selector))
          return g(y, b);
      }) : this.walk((y, b) => {
        if (y.type === "rule" && y.selector === d)
          return g(y, b);
      }) : (g = d, this.walk((y, b) => {
        if (y.type === "rule")
          return g(y, b);
      }));
    }
  }
  return h.registerParse = (E) => {
    s = E;
  }, h.registerRule = (E) => {
    l = E;
  }, h.registerAtRule = (E) => {
    o = E;
  }, h.registerRoot = (E) => {
    a = E;
  }, eu = h, h.default = h, h.rebuild = (E) => {
    let d = [E];
    for (; d.length > 0; ) {
      let g = d.pop();
      if (g.type === "atrule" ? Object.setPrototypeOf(g, o.prototype) : g.type === "rule" ? Object.setPrototypeOf(g, l.prototype) : g.type === "decl" ? Object.setPrototypeOf(g, t.prototype) : g.type === "comment" ? Object.setPrototypeOf(g, e.prototype) : g.type === "root" && Object.setPrototypeOf(g, a.prototype), g[i] = !0, g.nodes)
        for (let y of g.nodes) d.push(y);
    }
  }, eu;
}
var tu, EE;
function qc() {
  if (EE) return tu;
  EE = 1;
  let e = rn();
  class t extends e {
    constructor(n) {
      super(n), this.type = "atrule";
    }
    append(...n) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...n);
    }
    prepend(...n) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...n);
    }
  }
  return tu = t, t.default = t, e.registerAtRule(t), tu;
}
var ru, gE;
function Hc() {
  if (gE) return ru;
  gE = 1;
  let e = rn(), t, r;
  class n extends e {
    constructor(o) {
      super({ type: "document", ...o }), this.nodes || (this.nodes = []);
    }
    toResult(o = {}) {
      return new t(new r(), this, o).stringify();
    }
  }
  return n.registerLazyResult = (i) => {
    t = i;
  }, n.registerProcessor = (i) => {
    r = i;
  }, ru = n, n.default = n, ru;
}
var nu, yE;
function v$() {
  if (yE) return nu;
  yE = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return nu = { nanoid: (n = 21) => {
    let i = "", o = n | 0;
    for (; o-- > 0; )
      i += e[Math.random() * 64 | 0];
    return i;
  }, customAlphabet: (n, i = 21) => (o = i) => {
    let s = "", a = o | 0;
    for (; a-- > 0; )
      s += n[Math.random() * n.length | 0];
    return s;
  } }, nu;
}
var iu, TE;
function Qb() {
  if (TE) return iu;
  TE = 1;
  let { existsSync: e, readFileSync: t, realpathSync: r } = Qt, { dirname: n, isAbsolute: i, join: o, relative: s, sep: a } = Qt, { SourceMapConsumer: l, SourceMapGenerator: f } = Qt;
  function u(d) {
    try {
      return r(d);
    } catch {
      return d;
    }
  }
  function h(d) {
    return Buffer ? Buffer.from(d, "base64").toString() : window.atob(d);
  }
  class E {
    constructor(g, y) {
      if (y.map === !1) return;
      y.unsafeMap && (this.unsafeMap = !0), this.loadAnnotation(g), this.inline = this.startWith(this.annotation, "data:");
      let b = y.map ? y.map.prev : void 0, I = this.loadMap(y.from, b);
      !this.mapFile && y.from && (this.mapFile = y.from), this.mapFile && (this.root = n(this.mapFile)), I && (this.text = I);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new l(this.json || this.text)), this.consumerCache;
    }
    decodeInline(g) {
      let y = /^data:application\/json;charset=utf-?8;base64,/, b = /^data:application\/json;base64,/, I = /^data:application\/json;charset=utf-?8,/, S = /^data:application\/json,/, w = g.match(I) || g.match(S);
      if (w)
        return decodeURIComponent(g.substr(w[0].length));
      let P = g.match(y) || g.match(b);
      if (P)
        return h(g.substr(P[0].length));
      let _ = g.slice(22);
      throw _ = _.slice(0, _.indexOf(",")), new Error("Unsupported source map encoding " + _);
    }
    getAnnotationURL(g) {
      return g.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(g) {
      return typeof g != "object" ? !1 : typeof g.mappings == "string" || typeof g._mappings == "string" || Array.isArray(g.sections);
    }
    loadAnnotation(g) {
      let y = g.match(/\/\*\s*# sourceMappingURL=/g);
      if (!y) return;
      let b = g.lastIndexOf(y.pop()), I = g.indexOf("*/", b);
      b > -1 && I > -1 && (this.annotation = this.getAnnotationURL(g.substring(b, I)));
    }
    loadFile(g, y, b) {
      if (!b && !this.unsafeMap) {
        if (!/\.map$/i.test(g) || !y) return;
        let I = s(u(n(y)), u(g));
        if (I === ".." || I.startsWith(".." + a) || i(I))
          return;
      }
      if (this.root = n(g), e(g))
        return this.mapFile = g, t(g, "utf-8").toString().trim();
    }
    loadMap(g, y) {
      if (y === !1) return !1;
      if (y) {
        if (typeof y == "string")
          return y;
        if (typeof y == "function") {
          let b = y(g);
          if (b) {
            let I = this.loadFile(b, g, !0);
            if (!I)
              throw new Error(
                "Unable to load previous source map: " + b.toString()
              );
            return I;
          }
        } else {
          if (y instanceof l)
            return f.fromSourceMap(y).toString();
          if (y instanceof f)
            return y.toString();
          if (this.isMap(y))
            return JSON.stringify(y);
          throw new Error(
            "Unsupported previous source map format: " + y.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let b = this.annotation;
          g && (b = o(n(g), b));
          let I = this.loadFile(b, g, !1);
          if (I)
            try {
              this.json = JSON.parse(I.replace(/^\)]}'[^\n]*\n/, ""));
            } catch {
              return;
            }
          return I;
        }
      }
    }
    startWith(g, y) {
      return g ? g.substr(0, y.length) === y : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return iu = E, E.default = E, iu;
}
var ou, bE;
function Ia() {
  if (bE) return ou;
  bE = 1;
  let { nanoid: e } = /* @__PURE__ */ v$(), { isAbsolute: t, resolve: r } = Qt, { SourceMapConsumer: n, SourceMapGenerator: i } = Qt, { fileURLToPath: o, pathToFileURL: s } = Qt, a = Wc(), l = Qb(), f = Qt, u = Symbol("lineToIndexCache"), h = !!(n && i), E = !!(r && t);
  function d(y) {
    if (y[u]) return y[u];
    let b = y.css.split(`
`), I = new Array(b.length), S = 0;
    for (let w = 0, P = b.length; w < P; w++)
      I[w] = S, S += b[w].length + 1;
    return y[u] = I, I;
  }
  class g {
    get from() {
      return this.file || this.id;
    }
    constructor(b, I = {}) {
      if (b === null || typeof b > "u" || typeof b == "object" && !b.toString)
        throw new Error(`PostCSS received ${b} instead of CSS string`);
      if (this.css = b.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, I.document && (this.document = I.document.toString()), I.from && (!E || /^\w+:\/\//.test(I.from) || t(I.from) ? this.file = I.from : this.file = r(I.from)), E && h) {
        let S = new l(this.css, I);
        if (S.text) {
          this.map = S;
          let w = S.consumer().file;
          !this.file && w && (this.file = this.mapResolve(w));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(b, I, S, w = {}) {
      let P, _, v, M, x;
      if (I && typeof I == "object") {
        let F = I, W = S;
        if (typeof F.offset == "number") {
          M = F.offset;
          let X = this.fromOffset(M);
          I = X.line, S = X.col;
        } else
          I = F.line, S = F.column, M = this.fromLineAndColumn(I, S);
        if (typeof W.offset == "number") {
          v = W.offset;
          let X = this.fromOffset(v);
          _ = X.line, P = X.col;
        } else
          _ = W.line, P = W.column, v = this.fromLineAndColumn(W.line, W.column);
      } else if (S)
        M = this.fromLineAndColumn(I, S);
      else {
        M = I;
        let F = this.fromOffset(M);
        I = F.line, S = F.col;
      }
      let z = this.origin(I, S, _, P);
      return z ? x = new a(
        b,
        z.endLine === void 0 ? z.line : { column: z.column, line: z.line },
        z.endLine === void 0 ? z.column : { column: z.endColumn, line: z.endLine },
        z.source,
        z.file,
        w.plugin
      ) : x = new a(
        b,
        _ === void 0 ? I : { column: S, line: I },
        _ === void 0 ? S : { column: P, line: _ },
        this.css,
        this.file,
        w.plugin
      ), x.input = {
        column: S,
        endColumn: P,
        endLine: _,
        endOffset: v,
        line: I,
        offset: M,
        source: this.css
      }, this.file && (s && (x.input.url = s(this.file).toString()), x.input.file = this.file), x;
    }
    fromLineAndColumn(b, I) {
      return d(this)[b - 1] + I - 1;
    }
    fromOffset(b) {
      let I = d(this), S = I[I.length - 1], w = 0;
      if (b >= S)
        w = I.length - 1;
      else {
        let P = I.length - 2, _;
        for (; w < P; )
          if (_ = w + (P - w >> 1), b < I[_])
            P = _ - 1;
          else if (b >= I[_ + 1])
            w = _ + 1;
          else {
            w = _;
            break;
          }
      }
      return {
        col: b - I[w] + 1,
        line: w + 1
      };
    }
    mapResolve(b) {
      return /^\w+:\/\//.test(b) ? b : r(this.map.consumer().sourceRoot || this.map.root || ".", b);
    }
    origin(b, I, S, w) {
      if (!this.map) return !1;
      let P = this.map.consumer(), _ = P.originalPositionFor({ column: I - 1, line: b });
      if (!_.source) return !1;
      let v;
      if (typeof S == "number") {
        let F = P.originalPositionFor({
          column: w - 1,
          line: S
        });
        F.source && (v = F);
      }
      let M;
      t(_.source) ? M = s(_.source) : M = new URL(
        _.source,
        this.map.consumer().sourceRoot || s(this.map.mapFile)
      );
      let x = {
        column: _.column + 1,
        endColumn: v && v.column + 1,
        endLine: v && v.line,
        line: _.line,
        url: M.toString()
      };
      if (M.protocol === "file:")
        if (o)
          x.file = o(M);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let z = P.sourceContentFor(_.source);
      return z && (x.source = z), x;
    }
    toJSON() {
      let b = {};
      for (let I of ["hasBOM", "css", "file", "id"])
        this[I] != null && (b[I] = this[I]);
      return this.map && (b.map = { ...this.map }, b.map.consumerCache && (b.map.consumerCache = void 0)), b;
    }
  }
  return ou = g, g.default = g, f && f.registerInput && f.registerInput(g), ou;
}
var su, AE;
function Xo() {
  if (AE) return su;
  AE = 1;
  let e = rn(), t, r;
  class n extends e {
    constructor(o) {
      super(o), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(o, s, a) {
      let l = /* @__PURE__ */ new Set();
      for (let u of Array.isArray(o) ? o : [o])
        u && typeof u == "object" && !u.parent && u.raws && typeof u.raws.before < "u" && l.add(u.raws);
      let f = super.normalize(o);
      if (s) {
        if (a === "prepend")
          this.nodes.length > 1 ? s.raws.before = this.nodes[1].raws.before : delete s.raws.before;
        else if (this.first !== s)
          for (let u of f)
            l.has(u.raws) || (u.raws.before = s.raws.before);
      }
      return f;
    }
    removeChild(o, s) {
      let a = this.index(o);
      return !s && a === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[a].raws.before), super.removeChild(o);
    }
    toResult(o = {}) {
      return new t(new r(), this, o).stringify();
    }
  }
  return n.registerLazyResult = (i) => {
    t = i;
  }, n.registerProcessor = (i) => {
    r = i;
  }, su = n, n.default = n, e.registerRoot(n), su;
}
var au, vE;
function eA() {
  if (vE) return au;
  vE = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let r = [" ", `
`, "	"];
      return e.split(t, r);
    },
    split(t, r, n) {
      if (typeof t != "string") return [];
      let i = [], o = "", s = !1, a = 0, l = !1, f = "", u = !1, h = !1;
      for (let d = 0; d < t.length; d++) {
        let g = t[d];
        if (h) {
          o += g, g === "*" && t[d + 1] === "/" && (o += "/", d += 1, h = !1);
          continue;
        }
        if (u)
          u = !1;
        else if (g === "\\")
          u = !0;
        else if (l)
          g === f && (l = !1);
        else if (g === '"' || g === "'")
          l = !0, f = g;
        else if (g === "/" && t[d + 1] === "*") {
          o += "/*", d += 1, h = !0;
          continue;
        } else g === "(" ? a += 1 : g === ")" ? a > 0 && (a -= 1) : a === 0 && r.includes(g) && (s = !0);
        if (s) {
          let y = o.trim();
          (n || y !== "") && i.push(y), o = "", s = !1;
        } else
          o += g;
      }
      let E = o.trim();
      return (n || E !== "") && i.push(E), i;
    }
  };
  return au = e, e.default = e, au;
}
var uu, SE;
function Yc() {
  if (SE) return uu;
  SE = 1;
  let e = rn(), t = eA();
  class r extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(i) {
      let o = this.selector ? this.selector.match(/,\s*/) : null, s = o ? o[0] : "," + this.raw("between", "beforeOpen");
      this.selector = i.join(s);
    }
    constructor(i) {
      super(i), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return uu = r, r.default = r, e.registerRule(r), uu;
}
var lu, IE;
function S$() {
  if (IE) return lu;
  IE = 1;
  let e = qc(), t = va(), r = Sa(), n = Ia(), i = Qb(), o = Xo(), s = Yc();
  function a(u, h) {
    return u.inputs ? u.inputs.map((E) => {
      let d = { ...E, __proto__: n.prototype };
      return d.map && (d.map = {
        ...d.map,
        __proto__: i.prototype
      }), d;
    }) : h;
  }
  function l(u, h, E) {
    let d = { ...u };
    if (delete d.inputs, delete d.nodes, d.source) {
      let { inputId: y, ...b } = d.source;
      d.source = b, y != null && (d.source.input = h[y]);
    }
    let g;
    if (d.type === "root")
      g = new o(d);
    else if (d.type === "decl")
      g = new r(d);
    else if (d.type === "rule")
      g = new s(d);
    else if (d.type === "comment")
      g = new t(d);
    else if (d.type === "atrule")
      g = new e(d);
    else
      throw new Error("Unknown node type: " + u.type);
    if (E) {
      g.nodes = E;
      for (let y of E) y.parent = g;
    }
    return g;
  }
  function f(u, h) {
    if (Array.isArray(u)) return u.map((g) => f(g));
    let E, d = [
      { childIndex: 0, children: [], inputs: a(u, h), json: u }
    ];
    for (; d.length > 0; ) {
      let g = d[d.length - 1], y = g.json.nodes;
      if (y && g.childIndex < y.length) {
        let I = y[g.childIndex];
        g.childIndex += 1, d.push({
          childIndex: 0,
          children: [],
          inputs: a(I, g.inputs),
          json: I
        });
        continue;
      }
      d.pop();
      let b = l(
        g.json,
        g.inputs,
        y ? g.children : void 0
      );
      d.length > 0 ? d[d.length - 1].children.push(b) : E = b;
    }
    return E;
  }
  return lu = f, f.default = f, lu;
}
var cu, _E;
function tA() {
  if (_E) return cu;
  _E = 1;
  let { dirname: e, relative: t, resolve: r, sep: n } = Qt, { SourceMapConsumer: i, SourceMapGenerator: o } = Qt, { pathToFileURL: s } = Qt, a = Ia(), l = !!(i && o), f = !!(e && r && t && n);
  class u {
    constructor(E, d, g, y) {
      this.stringify = E, this.mapOpts = g.map || {}, this.root = d, this.opts = g, this.css = y, this.originalCSS = y, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let E;
      this.isInline() ? E = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? E = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? E = this.mapOpts.annotation(this.opts.to, this.root) : E = this.outputFile() + ".map";
      let d = `
`;
      this.css.includes(`\r
`) && (d = `\r
`), this.css += d + "/*# sourceMappingURL=" + E + " */";
    }
    applyPrevMaps() {
      for (let E of this.previous()) {
        let d = this.toUrl(this.path(E.file)), g = E.root || e(E.file), y;
        this.mapOpts.sourcesContent === !1 ? (y = new i(E.text), y.sourcesContent && (y.sourcesContent = null)) : y = E.consumer(), this.map.applySourceMap(y, d, this.toUrl(this.path(g)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1) {
        if (this.root) {
          let E;
          for (let d = this.root.nodes.length - 1; d >= 0; d--)
            E = this.root.nodes[d], E.type === "comment" && E.text.startsWith("# sourceMappingURL=") && this.root.removeChild(d);
        } else if (this.css) {
          let E = "/*# sourceMappingURL=", d = "", g = 0, y;
          for (; (y = this.css.indexOf(E, g)) !== -1; ) {
            let b = this.css.indexOf("*/", y + E.length);
            if (b === -1) break;
            for (; y > g && this.css[y - 1] === `
`; )
              y--;
            d += this.css.slice(g, y), g = b + 2;
          }
          g > 0 && (this.css = d + this.css.slice(g));
        }
      }
    }
    generate() {
      if (this.clearAnnotation(), f && l && this.isMap())
        return this.generateMap();
      {
        let E = "";
        return this.stringify(this.root, (d) => {
          E += d;
        }), [E];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let E = this.previous()[0].consumer();
        E.file = this.outputFile(), this.map = o.fromSourceMap(E, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new o({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new o({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let E = 1, d = 1, g = "<no source>", y = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, b, I;
      this.stringify(this.root, (S, w, P) => {
        if (this.css += S, w && P !== "end" && (y.generated.line = E, y.generated.column = d - 1, w.source && w.source.start ? (y.source = this.sourcePath(w), y.original.line = w.source.start.line, y.original.column = w.source.start.column - 1, this.map.addMapping(y)) : (y.source = g, y.original.line = 1, y.original.column = 0, this.map.addMapping(y))), I = S.match(/\n/g), I ? (E += I.length, b = S.lastIndexOf(`
`), d = S.length - b) : d += S.length, w && P !== "start") {
          let _ = w.parent || { raws: {} };
          (!(w.type === "decl" || w.type === "atrule" && !w.nodes) || w !== _.last || _.raws.semicolon) && (w.source && w.source.end ? (y.source = this.sourcePath(w), y.original.line = w.source.end.line, y.original.column = w.source.end.column - 1, y.generated.line = E, y.generated.column = d - 2, this.map.addMapping(y)) : (y.source = g, y.original.line = 1, y.original.column = 0, y.generated.line = E, y.generated.column = d - 1, this.map.addMapping(y)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((E) => E.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let E = this.mapOpts.annotation;
      return typeof E < "u" && E !== !0 ? !1 : this.previous().length ? this.previous().some((d) => d.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((E) => E.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(E) {
      if (this.mapOpts.absolute || E.charCodeAt(0) === 60 || /^\w+:\/\//.test(E)) return E;
      let d = this.memoizedPaths.get(E);
      if (d) return d;
      let g = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (g = e(r(g, this.mapOpts.annotation)));
      let y = t(g, E);
      return this.memoizedPaths.set(E, y), y;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((E) => {
            if (E.source && E.source.input.map) {
              let d = E.source.input.map;
              this.previousMaps.includes(d) || this.previousMaps.push(d);
            }
          });
        else {
          let E = new a(this.originalCSS, this.opts);
          E.map && this.previousMaps.push(E.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let E = {};
      if (this.root)
        this.root.walk((d) => {
          if (d.source) {
            let g = d.source.input.from;
            if (g && !E[g]) {
              E[g] = !0;
              let y = this.usesFileUrls ? this.toFileUrl(g) : this.toUrl(this.path(g));
              this.map.setSourceContent(y, d.source.input.css);
            }
          }
        });
      else if (this.css) {
        let d = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(d, this.css);
      }
    }
    sourcePath(E) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(E.source.input.from) : this.toUrl(this.path(E.source.input.from));
    }
    toBase64(E) {
      return Buffer ? Buffer.from(E).toString("base64") : window.btoa(unescape(encodeURIComponent(E)));
    }
    toFileUrl(E) {
      let d = this.memoizedFileURLs.get(E);
      if (d) return d;
      if (s) {
        let g = s(E).toString();
        return this.memoizedFileURLs.set(E, g), g;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(E) {
      let d = this.memoizedURLs.get(E);
      if (d) return d;
      n === "\\" && (E = E.replace(/\\/g, "/"));
      let g = encodeURI(E).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(E, g), g;
    }
  }
  return cu = u, cu;
}
var fu, RE;
function I$() {
  if (RE) return fu;
  RE = 1;
  const e = 39, t = 34, r = 92, n = 47, i = 10, o = 32, s = 12, a = 9, l = 13, f = 91, u = 93, h = 40, E = 41, d = 123, g = 125, y = 59, b = 42, I = 58, S = 64, w = /[\t\n\f\r "#'()/;[\\\]{}]/g, P = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, _ = /.[\r\n"'(/\\]/, v = /[\da-f]/i;
  return fu = function(x, z = {}) {
    let F = x.css.valueOf(), W = z.ignoreErrors, X, de, B, L, G, Z, V, te, ee, Q, re = F.length, ne = 0, Ee = [], be = [], Be = -1;
    function Ue() {
      return ne;
    }
    function Le(Ne) {
      throw x.error("Unclosed " + Ne, ne);
    }
    function Ve() {
      return be.length === 0 && ne >= re;
    }
    function Ie(Ne) {
      if (be.length) return be.pop();
      if (ne >= re) return;
      let Re = Ne ? Ne.ignoreUnclosed : !1;
      switch (X = F.charCodeAt(ne), X) {
        case i:
        case o:
        case a:
        case l:
        case s: {
          L = ne;
          do
            L += 1, X = F.charCodeAt(L);
          while (X === o || X === i || X === a || X === l || X === s);
          Z = ["space", F.slice(ne, L)], ne = L - 1;
          break;
        }
        case f:
        case u:
        case d:
        case g:
        case I:
        case y:
        case E: {
          let nt = String.fromCharCode(X);
          Z = [nt, nt, ne];
          break;
        }
        case h: {
          if (Q = Ee.length ? Ee.pop()[1] : "", ee = F.charCodeAt(ne + 1), Q === "url" && ee !== e && ee !== t && ee !== o && ee !== i && ee !== a && ee !== s && ee !== l) {
            L = ne;
            do {
              if (V = !1, L = F.indexOf(")", L + 1), L === -1)
                if (W || Re) {
                  L = ne;
                  break;
                } else
                  Le("bracket");
              for (te = L; F.charCodeAt(te - 1) === r; )
                te -= 1, V = !V;
            } while (V);
            Z = ["brackets", F.slice(ne, L + 1), ne, L], ne = L;
          } else ne <= Be ? Z = ["(", "(", ne] : (L = F.indexOf(")", ne + 1), de = F.slice(ne, L + 1), L === -1 || _.test(de) ? (Be = L === -1 ? re : L, Z = ["(", "(", ne]) : (Z = ["brackets", de, ne, L], ne = L));
          break;
        }
        case e:
        case t: {
          G = X === e ? "'" : '"', L = ne;
          do {
            if (V = !1, L = F.indexOf(G, L + 1), L === -1)
              if (W || Re) {
                L = ne + 1;
                break;
              } else
                Le("string");
            for (te = L; F.charCodeAt(te - 1) === r; )
              te -= 1, V = !V;
          } while (V);
          Z = ["string", F.slice(ne, L + 1), ne, L], ne = L;
          break;
        }
        case S: {
          w.lastIndex = ne + 1, w.test(F), w.lastIndex === 0 ? L = F.length - 1 : L = w.lastIndex - 2, Z = ["at-word", F.slice(ne, L + 1), ne, L], ne = L;
          break;
        }
        case r: {
          for (L = ne, B = !0; F.charCodeAt(L + 1) === r; )
            L += 1, B = !B;
          if (X = F.charCodeAt(L + 1), B && X !== n && X !== o && X !== i && X !== a && X !== l && X !== s && (L += 1, v.test(F.charAt(L)))) {
            for (; v.test(F.charAt(L + 1)); )
              L += 1;
            F.charCodeAt(L + 1) === o && (L += 1);
          }
          Z = ["word", F.slice(ne, L + 1), ne, L], ne = L;
          break;
        }
        default: {
          X === n && F.charCodeAt(ne + 1) === b ? (L = F.indexOf("*/", ne + 2) + 1, L === 0 && (W || Re ? L = F.length : Le("comment")), Z = ["comment", F.slice(ne, L + 1), ne, L], ne = L) : (P.lastIndex = ne + 1, P.test(F), P.lastIndex === 0 ? L = F.length - 1 : L = P.lastIndex - 2, Z = ["word", F.slice(ne, L + 1), ne, L], Ee.push(Z), ne = L);
          break;
        }
      }
      return ne++, Z;
    }
    function $e(Ne) {
      be.push(Ne);
    }
    return {
      back: $e,
      endOfFile: Ve,
      nextToken: Ie,
      position: Ue
    };
  }, fu;
}
var du, OE;
function _$() {
  if (OE) return du;
  OE = 1;
  let e = qc(), t = va(), r = Sa(), n = Xo(), i = Yc(), o = I$();
  const s = {
    empty: !0,
    space: !0
  };
  function a(u) {
    for (let h = u.length - 1; h >= 0; h--) {
      let E = u[h], d = E[3] || E[2];
      if (d) return d;
    }
  }
  function l(u, h, E) {
    let d = "";
    for (let g = h; g < E; g++) d += u[g][1];
    return d;
  }
  class f {
    constructor(h) {
      this.input = h, this.root = new n(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: h, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(h) {
      let E = new e();
      E.name = h[1].slice(1), E.name === "" && this.unnamedAtrule(E, h), this.init(E, h[2]);
      let d, g, y, b = !1, I = !1, S = [], w = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (h = this.tokenizer.nextToken(), d = h[0], d === "(" || d === "[" ? w.push(d === "(" ? ")" : "]") : d === "{" && w.length > 0 ? w.push("}") : d === w[w.length - 1] && w.pop(), w.length === 0)
          if (d === ";") {
            E.source.end = this.getPosition(h[2]), E.source.end.offset++, this.semicolon = !0;
            break;
          } else if (d === "{") {
            I = !0;
            break;
          } else if (d === "}") {
            if (S.length > 0) {
              for (y = S.length - 1, g = S[y]; g && g[0] === "space"; )
                g = S[--y];
              g && (E.source.end = this.getPosition(g[3] || g[2]), E.source.end.offset++);
            }
            this.end(h);
            break;
          } else
            S.push(h);
        else
          S.push(h);
        if (this.tokenizer.endOfFile()) {
          b = !0;
          break;
        }
      }
      E.raws.between = this.spacesAndCommentsFromEnd(S), S.length ? (E.raws.afterName = this.spacesAndCommentsFromStart(S), this.raw(E, "params", S), b && (h = S[S.length - 1], E.source.end = this.getPosition(h[3] || h[2]), E.source.end.offset++, this.spaces = E.raws.between, E.raws.between = "")) : (E.raws.afterName = "", E.params = ""), I && (E.nodes = [], this.current = E);
    }
    checkMissedSemicolon(h) {
      let E = this.colon(h);
      if (E === !1) return;
      let d = 0, g;
      for (let y = E - 1; y >= 0 && (g = h[y], !(g[0] !== "space" && (d += 1, d === 2))); y--)
        ;
      throw this.input.error(
        "Missed semicolon",
        g[0] === "word" ? g[3] + 1 : g[2]
      );
    }
    colon(h) {
      let E = 0, d, g, y;
      for (let [b, I] of h.entries()) {
        if (g = I, y = g[0], y === "(" && (E += 1), y === ")" && (E -= 1), E === 0 && y === ":")
          if (!d)
            this.doubleColon(g);
          else {
            if (d[0] === "word" && d[1] === "progid")
              continue;
            return b;
          }
        d = g;
      }
      return !1;
    }
    comment(h) {
      let E = new t();
      this.init(E, h[2]), E.source.end = this.getPosition(h[3] || h[2]), E.source.end.offset++;
      let d = h[1].slice(2, -2);
      if (!d.trim())
        E.text = "", E.raws.left = d, E.raws.right = "";
      else {
        let g = d.match(/^(\s*)([^]*\S)(\s*)$/);
        E.text = g[2], E.raws.left = g[1], E.raws.right = g[3];
      }
    }
    createTokenizer() {
      this.tokenizer = o(this.input);
    }
    decl(h, E) {
      let d = new r();
      this.init(d, h[0][2]);
      let g = h[h.length - 1];
      g[0] === ";" && (this.semicolon = !0, h.pop()), d.source.end = this.getPosition(
        g[3] || g[2] || a(h)
      ), d.source.end.offset++;
      let y = 0;
      for (; h[y][0] !== "word"; )
        y === h.length - 1 && this.unknownWord([h[y]]), y++;
      d.raws.before += l(h, 0, y), d.source.start = this.getPosition(h[y][2]);
      let b = y;
      for (; y < h.length; ) {
        let v = h[y][0];
        if (v === ":" || v === "space" || v === "comment")
          break;
        y++;
      }
      d.prop = l(h, b, y);
      let I = y, S;
      for (; y < h.length && (S = h[y], y++, S[0] !== ":"); )
        S[0] === "word" && /\w/.test(S[1]) && this.unknownWord([S]);
      d.raws.between = l(h, I, y), (d.prop[0] === "_" || d.prop[0] === "*") && (d.raws.before += d.prop[0], d.prop = d.prop.slice(1));
      let w = y;
      for (; y < h.length; ) {
        let v = h[y][0];
        if (v !== "space" && v !== "comment") break;
        y++;
      }
      let P = h.slice(w, y);
      h = h.slice(y), this.precheckMissedSemicolon(h);
      for (let v = h.length - 1; v >= 0; v--) {
        if (S = h[v], S[1].toLowerCase() === "!important") {
          d.important = !0;
          let M = this.stringFrom(h, v);
          M = this.spacesFromEnd(h) + M, M !== " !important" && (d.raws.important = M);
          break;
        } else if (S[1].toLowerCase() === "important") {
          let M = h.slice(0), x = "";
          for (let z = v; z > 0; z--) {
            let F = M[z][0];
            if (x.trim().startsWith("!") && F !== "space")
              break;
            x = M.pop()[1] + x;
          }
          x.trim().startsWith("!") && (d.important = !0, d.raws.important = x, h = M);
        }
        if (S[0] !== "space" && S[0] !== "comment")
          break;
      }
      h.some((v) => v[0] !== "space" && v[0] !== "comment") && (d.raws.between += P.map((v) => v[1]).join(""), P = []), this.raw(d, "value", P.concat(h), E), d.value.includes(":") && !E && this.checkMissedSemicolon(h);
    }
    doubleColon(h) {
      throw this.input.error(
        "Double colon",
        { offset: h[2] },
        { offset: h[2] + h[1].length }
      );
    }
    emptyRule(h) {
      let E = new i();
      this.init(E, h[2]), E.selector = "", E.raws.between = "", this.current = E;
    }
    end(h) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(h[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(h);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(h) {
      if (this.spaces += h[1], this.current.nodes) {
        let E = this.current.nodes[this.current.nodes.length - 1];
        E && E.type === "rule" && !E.raws.ownSemicolon && (E.raws.ownSemicolon = this.spaces, this.spaces = "", E.source.end = this.getPosition(h[2]), E.source.end.offset++);
      }
    }
    // Helpers
    getPosition(h) {
      let E = this.input.fromOffset(h);
      return {
        column: E.col,
        line: E.line,
        offset: h
      };
    }
    init(h, E) {
      this.current.push(h), h.source = {
        input: this.input,
        start: this.getPosition(E)
      }, h.raws.before = this.spaces, this.spaces = "", h.type !== "comment" && (this.semicolon = !1);
    }
    other(h) {
      let E = !1, d = null, g = !1, y = null, b = [], I = h[1].startsWith("--"), S = [], w = h;
      for (; w; ) {
        if (d = w[0], S.push(w), d === "(" || d === "[")
          y || (y = w), b.push(d === "(" ? ")" : "]");
        else if (I && g && d === "{")
          y || (y = w), b.push("}");
        else if (b.length === 0)
          if (d === ";")
            if (g) {
              this.decl(S, I);
              return;
            } else
              break;
          else if (d === "{") {
            this.rule(S);
            return;
          } else if (d === "}") {
            this.tokenizer.back(S.pop()), E = !0;
            break;
          } else d === ":" && (g = !0);
        else d === b[b.length - 1] && (b.pop(), b.length === 0 && (y = null));
        w = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (E = !0), b.length > 0 && this.unclosedBracket(y), E && g) {
        if (!I)
          for (; S.length && (w = S[S.length - 1][0], !(w !== "space" && w !== "comment")); )
            this.tokenizer.back(S.pop());
        this.decl(S, I);
      } else
        this.unknownWord(S);
    }
    parse() {
      let h;
      for (; !this.tokenizer.endOfFile(); )
        switch (h = this.tokenizer.nextToken(), h[0]) {
          case "space":
            this.spaces += h[1];
            break;
          case ";":
            this.freeSemicolon(h);
            break;
          case "}":
            this.end(h);
            break;
          case "comment":
            this.comment(h);
            break;
          case "at-word":
            this.atrule(h);
            break;
          case "{":
            this.emptyRule(h);
            break;
          default:
            this.other(h);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(h, E, d, g) {
      let y, b, I = d.length, S = "", w = "", P = !0, _, v;
      for (let M = 0; M < I; M += 1)
        y = d[M], b = y[0], b === "space" && M === I - 1 && !g ? P = !1 : b === "comment" ? (v = d[M - 1] ? d[M - 1][0] : "empty", _ = d[M + 1] ? d[M + 1][0] : "empty", !s[v] && !s[_] ? w === "," ? P = !1 : (S += y[1], w = y[1].slice(-1)) : P = !1) : (S += y[1], w = y[1].slice(-1));
      if (!P) {
        let M = d.reduce((x, z) => x + z[1], "");
        h.raws[E] = { raw: M, value: S };
      }
      h[E] = S;
    }
    rule(h) {
      h.pop();
      let E = new i();
      this.init(E, h[0][2]), E.raws.between = this.spacesAndCommentsFromEnd(h), this.raw(E, "selector", h), this.current = E;
    }
    spacesAndCommentsFromEnd(h) {
      let E, d = "";
      for (; h.length && (E = h[h.length - 1][0], !(E !== "space" && E !== "comment")); )
        d = h.pop()[1] + d;
      return d;
    }
    // Errors
    spacesAndCommentsFromStart(h) {
      let E, d = "";
      for (; h.length && (E = h[0][0], !(E !== "space" && E !== "comment")); )
        d += h.shift()[1];
      return d;
    }
    spacesFromEnd(h) {
      let E, d = "";
      for (; h.length && (E = h[h.length - 1][0], E === "space"); )
        d = h.pop()[1] + d;
      return d;
    }
    stringFrom(h, E) {
      let d = "";
      for (let g = E; g < h.length; g++)
        d += h[g][1];
      return h.splice(E, h.length - E), d;
    }
    unclosedBlock() {
      let h = this.current.source.start;
      throw this.input.error("Unclosed block", h.line, h.column);
    }
    unclosedBracket(h) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: h[2] },
        { offset: h[2] + 1 }
      );
    }
    unexpectedClose(h) {
      throw this.input.error(
        "Unexpected }",
        { offset: h[2] },
        { offset: h[2] + 1 }
      );
    }
    unknownWord(h) {
      throw this.input.error(
        "Unknown word " + h[0][1],
        { offset: h[0][2] },
        { offset: h[0][2] + h[0][1].length }
      );
    }
    unnamedAtrule(h, E) {
      throw this.input.error(
        "At-rule without name",
        { offset: E[2] },
        { offset: E[2] + E[1].length }
      );
    }
  }
  return du = f, du;
}
var pu, wE;
function Zc() {
  if (wE) return pu;
  wE = 1;
  let e = rn(), t = Ia(), r = _$();
  function n(i, o) {
    let s = new t(i, o), a = new r(s);
    try {
      a.parse();
    } catch (l) {
      throw process.env.NODE_ENV !== "production" && l.name === "CssSyntaxError" && o && o.from && (/\.scss$/i.test(o.from) ? l.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(o.from) ? l.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(o.from) && (l.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), l;
    }
    return a.root;
  }
  return pu = n, n.default = n, e.registerParse(n), pu;
}
var hu, NE;
function rA() {
  if (NE) return hu;
  NE = 1;
  let e = rn(), { my: t } = ba();
  class r {
    constructor(i, o = {}) {
      if (this.type = "warning", this.text = i, o.node && o.node.source) {
        o.node[t] || e.rebuild(o.node);
        let s = o.node.rangeBy(o);
        this.line = s.start.line, this.column = s.start.column, this.endLine = s.end.line, this.endColumn = s.end.column;
      }
      for (let s in o) this[s] = o[s];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return hu = r, r.default = r, hu;
}
var mu, CE;
function Jc() {
  if (CE) return mu;
  CE = 1;
  let e = rA();
  class t {
    get content() {
      return this.css;
    }
    constructor(n, i, o) {
      this.processor = n, this.messages = [], this.root = i, this.opts = o, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(n, i = {}) {
      i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
      let o = new e(n, i);
      return this.messages.push(o), o;
    }
    warnings() {
      return this.messages.filter((n) => n.type === "warning");
    }
  }
  return mu = t, t.default = t, mu;
}
var Eu, PE;
function nA() {
  if (PE) return Eu;
  PE = 1;
  let e = {};
  return Eu = function(r) {
    e[r] || (e[r] = !0, typeof console < "u" && console.warn && console.warn(r));
  }, Eu;
}
var gu, DE;
function iA() {
  if (DE) return gu;
  DE = 1;
  let e = rn(), t = Hc(), r = tA(), n = Zc(), i = Jc(), o = Xo(), s = Ta(), { isClean: a, my: l } = ba(), f = nA();
  const u = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, h = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, E = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, d = 0;
  function g(P) {
    return typeof P == "object" && typeof P.then == "function";
  }
  function y(P) {
    let _ = !1, v = u[P.type];
    return P.type === "decl" ? _ = P.prop.toLowerCase() : P.type === "atrule" && (_ = P.name.toLowerCase()), _ && P.append ? [
      v,
      v + "-" + _,
      d,
      v + "Exit",
      v + "Exit-" + _
    ] : _ ? [v, v + "-" + _, v + "Exit", v + "Exit-" + _] : P.append ? [v, d, v + "Exit"] : [v, v + "Exit"];
  }
  function b(P) {
    let _;
    return P.type === "document" ? _ = ["Document", d, "DocumentExit"] : P.type === "root" ? _ = ["Root", d, "RootExit"] : _ = y(P), {
      eventIndex: 0,
      events: _,
      iterator: 0,
      node: P,
      visitorIndex: 0,
      visitors: []
    };
  }
  function I(P) {
    let _ = [P];
    for (; _.length > 0; ) {
      let v = _.pop();
      if (v[a] = !1, v.nodes)
        for (let M of v.nodes) _.push(M);
    }
    return P;
  }
  let S = {};
  class w {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(_, v, M) {
      this.stringified = !1, this.processed = !1;
      let x;
      if (typeof v == "object" && v !== null && (v.type === "root" || v.type === "document"))
        x = I(v);
      else if (v instanceof w || v instanceof i)
        x = I(v.root), v.map && (typeof M.map > "u" && (M.map = {}), M.map.inline || (M.map.inline = !1), M.map.prev = v.map);
      else {
        let z = n;
        M.syntax && (z = M.syntax.parse), M.parser && (z = M.parser), z.parse && (z = z.parse);
        try {
          x = z(v, M);
        } catch (F) {
          this.processed = !0, this.error = F;
        }
        x && !x[l] && e.rebuild(x);
      }
      this.result = new i(_, x, M), this.helpers = { ...S, postcss: S, result: this.result }, this.plugins = this.processor.plugins.map((z) => typeof z == "object" && z.prepare ? { ...z, ...z.prepare(this.result) } : z);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(_) {
      return this.async().catch(_);
    }
    finally(_) {
      return this.async().then(_, _);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(_, v) {
      let M = this.result.lastPlugin;
      try {
        if (v && v.addToError(_), this.error = _, _.name === "CssSyntaxError" && !_.plugin)
          _.plugin = M.postcssPlugin, _.setMessage();
        else if (M.postcssVersion && process.env.NODE_ENV !== "production") {
          let x = M.postcssPlugin, z = M.postcssVersion, F = this.result.processor.version, W = z.split("."), X = F.split(".");
          (W[0] !== X[0] || parseInt(W[1]) > parseInt(X[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + F + ", but " + x + " uses " + z + ". Perhaps this is the source of the error below."
          );
        }
      } catch (x) {
        console && console.error && console.error(x);
      }
      return _;
    }
    prepareVisitors() {
      this.listeners = {};
      let _ = (v, M, x) => {
        this.listeners[M] || (this.listeners[M] = []), this.listeners[M].push([v, x]);
      };
      for (let v of this.plugins)
        if (typeof v == "object")
          for (let M in v) {
            if (!h[M] && /^[A-Z]/.test(M))
              throw new Error(
                `Unknown event ${M} in ${v.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!E[M])
              if (typeof v[M] == "object")
                for (let x in v[M])
                  x === "*" ? _(v, M, v[M][x]) : _(
                    v,
                    M + "-" + x.toLowerCase(),
                    v[M][x]
                  );
              else typeof v[M] == "function" && _(v, M, v[M]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let _ = 0; _ < this.plugins.length; _++) {
        let v = this.plugins[_], M = this.runOnRoot(v);
        if (g(M))
          try {
            await M;
          } catch (x) {
            throw this.handleError(x);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let _ = this.result.root;
        for (; !_[a]; ) {
          _[a] = !0;
          let v = [b(_)];
          for (; v.length > 0; ) {
            let M = this.visitTick(v);
            if (g(M))
              try {
                await M;
              } catch (x) {
                let z = v[v.length - 1].node;
                throw this.handleError(x, z);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [v, M] of this.listeners.OnceExit) {
            this.result.lastPlugin = v;
            try {
              if (_.type === "document") {
                let x = _.nodes.map(
                  (z) => M(z, this.helpers)
                );
                await Promise.all(x);
              } else
                await M(_, this.helpers);
            } catch (x) {
              throw this.handleError(x);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(_) {
      this.result.lastPlugin = _;
      try {
        if (typeof _ == "object" && _.Once) {
          if (this.result.root.type === "document") {
            let v = this.result.root.nodes.map(
              (M) => _.Once(M, this.helpers)
            );
            return g(v[0]) ? Promise.all(v) : v;
          }
          return _.Once(this.result.root, this.helpers);
        } else if (typeof _ == "function")
          return _(this.result.root, this.result);
      } catch (v) {
        throw this.handleError(v);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let _ = this.result.opts, v = s;
      _.syntax && (v = _.syntax.stringify), _.stringifier && (v = _.stringifier), v.stringify && (v = v.stringify);
      let M = this.result.root.source;
      if (_.map === void 0 && !(M && M.input && M.input.map)) {
        let F = "";
        return v(this.result.root, (W) => {
          F += W;
        }), this.result.css = F, this.result;
      }
      let z = new r(v, this.result.root, this.result.opts).generate();
      return this.result.css = z[0], this.result.map = z[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let _ of this.plugins) {
        let v = this.runOnRoot(_);
        if (g(v))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let _ = this.result.root;
        for (; !_[a]; )
          _[a] = !0, this.walkSync(_);
        if (this.listeners.OnceExit)
          if (_.type === "document")
            for (let v of _.nodes)
              this.visitSync(this.listeners.OnceExit, v);
          else
            this.visitSync(this.listeners.OnceExit, _);
      }
      return this.result;
    }
    then(_, v) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || f(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(_, v);
    }
    toString() {
      return this.css;
    }
    visitSync(_, v) {
      for (let [M, x] of _) {
        this.result.lastPlugin = M;
        let z;
        try {
          z = x(v, this.helpers);
        } catch (F) {
          throw this.handleError(F, v.proxyOf);
        }
        if (v.type !== "root" && v.type !== "document" && !v.parent)
          return !0;
        if (g(z))
          throw this.getAsyncError();
      }
    }
    visitTick(_) {
      let v = _[_.length - 1], { node: M, visitors: x } = v;
      if (M.type !== "root" && M.type !== "document" && !M.parent) {
        _.pop();
        return;
      }
      if (x.length > 0 && v.visitorIndex < x.length) {
        let [F, W] = x[v.visitorIndex];
        v.visitorIndex += 1, v.visitorIndex === x.length && (v.visitors = [], v.visitorIndex = 0), this.result.lastPlugin = F;
        try {
          return W(M.toProxy(), this.helpers);
        } catch (X) {
          throw this.handleError(X, M);
        }
      }
      if (v.iterator !== 0) {
        let F = v.iterator;
        v.descending && (v.descending = !1, M.indexes[F] += 1);
        let W;
        for (; W = M.nodes[M.indexes[F]]; ) {
          if (!W[a]) {
            W[a] = !0, v.descending = !0, _.push(b(W));
            return;
          }
          M.indexes[F] += 1;
        }
        v.iterator = 0, delete M.indexes[F];
      }
      let z = v.events;
      for (; v.eventIndex < z.length; ) {
        let F = z[v.eventIndex];
        if (v.eventIndex += 1, F === d) {
          M.nodes && M.nodes.length && (M[a] = !0, v.iterator = M.getIterator());
          return;
        } else if (this.listeners[F]) {
          v.visitors = this.listeners[F];
          return;
        }
      }
      _.pop();
    }
    walkSync(_) {
      _[a] = !0;
      let v = [{ eventIndex: 0, events: y(_), iterator: 0, node: _ }];
      for (; v.length > 0; ) {
        let M = v[v.length - 1], x = M.node;
        if (M.iterator !== 0) {
          let z = M.iterator;
          M.descending && (M.descending = !1, x.indexes[z] += 1);
          let F, W = !1;
          for (; F = x.nodes[x.indexes[z]]; ) {
            if (!F[a]) {
              F[a] = !0, M.descending = !0, v.push({
                eventIndex: 0,
                events: y(F),
                iterator: 0,
                node: F
              }), W = !0;
              break;
            }
            x.indexes[z] += 1;
          }
          if (W) continue;
          M.iterator = 0, delete x.indexes[z];
        }
        if (M.eventIndex < M.events.length) {
          let z = M.events[M.eventIndex];
          if (M.eventIndex += 1, z === d)
            x.nodes && x.nodes.length && (M.iterator = x.getIterator());
          else {
            let F = this.listeners[z];
            F && this.visitSync(F, x.toProxy()) && v.pop();
          }
          continue;
        }
        v.pop();
      }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return w.registerPostcss = (P) => {
    S = P;
  }, gu = w, w.default = w, o.registerLazyResult(w), t.registerLazyResult(w), gu;
}
var yu, ME;
function R$() {
  if (ME) return yu;
  ME = 1;
  let e = tA(), t = Zc(), r = Jc(), n = Ta(), i = nA();
  class o {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let a, l = t;
      try {
        a = l(this._css, this._opts);
      } catch (f) {
        this.error = f;
      }
      if (this.error)
        throw this.error;
      return this._root = a, a;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(a, l, f) {
      l = l.toString(), this.stringified = !1, this._processor = a, this._css = l, this._opts = f, this._map = void 0;
      let u = n;
      this.result = new r(this._processor, void 0, this._opts), this.result.css = l;
      let h = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return h.root;
        }
      });
      let E = new e(u, void 0, this._opts, l);
      if (E.isMap()) {
        let [d, g] = E.generate();
        d && (this.result.css = d), g && (this.result.map = g);
      } else
        E.clearAnnotation(), this.result.css = E.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(a) {
      return this.async().catch(a);
    }
    finally(a) {
      return this.async().then(a, a);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(a, l) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(a, l);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return yu = o, o.default = o, yu;
}
var Tu, LE;
function O$() {
  if (LE) return Tu;
  LE = 1;
  let e = Hc(), t = iA(), r = R$(), n = Xo();
  class i {
    constructor(s = []) {
      this.version = "8.5.29", this.plugins = this.normalize(s);
    }
    normalize(s) {
      let a = [];
      for (let l of s)
        if (l.postcss === !0 ? l = l() : l.postcss && (l = l.postcss), typeof l == "object" && Array.isArray(l.plugins))
          a = a.concat(l.plugins);
        else if (typeof l == "object" && l.postcssPlugin)
          a.push(l);
        else if (typeof l == "function")
          a.push(l);
        else if (typeof l == "object" && (l.parse || l.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(l + " is not a PostCSS plugin");
      return a;
    }
    process(s, a = {}) {
      return !this.plugins.length && !a.parser && !a.stringifier && !a.syntax ? new r(this, s, a) : new t(this, s, a);
    }
    use(s) {
      return this.plugins = this.plugins.concat(this.normalize([s])), this;
    }
  }
  return Tu = i, i.default = i, n.registerProcessor(i), e.registerProcessor(i), Tu;
}
var bu, xE;
function w$() {
  if (xE) return bu;
  xE = 1;
  let e = qc(), t = va(), r = rn(), n = Wc(), i = Sa(), o = Hc(), s = S$(), a = Ia(), l = iA(), f = eA(), u = Aa(), h = Zc(), E = O$(), d = Jc(), g = Xo(), y = Yc(), b = Ta(), I = rA();
  function S(...w) {
    return w.length === 1 && Array.isArray(w[0]) && (w = w[0]), new E(w);
  }
  return S.plugin = function(P, _) {
    let v = !1;
    function M(...z) {
      console && console.warn && !v && (v = !0, console.warn(
        P + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("zh") && console.warn(
        P + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let F = _(...z);
      return F.postcssPlugin = P, F.postcssVersion = new E().version, F;
    }
    let x;
    return Object.defineProperty(M, "postcss", {
      get() {
        return x || (x = M()), x;
      }
    }), M.process = function(z, F, W) {
      return S([M(W)]).process(z, F);
    }, M;
  }, S.stringify = b, S.parse = h, S.fromJSON = s, S.list = f, S.comment = (w) => new t(w), S.atRule = (w) => new e(w), S.decl = (w) => new i(w), S.rule = (w) => new y(w), S.root = (w) => new g(w), S.document = (w) => new o(w), S.CssSyntaxError = n, S.Declaration = i, S.Container = r, S.Processor = E, S.Document = o, S.Comment = t, S.Warning = I, S.AtRule = e, S.Result = d, S.Input = a, S.Rule = y, S.Root = g, S.Node = u, l.registerPostcss(S), bu = S, S.default = S, bu;
}
var ms = { exports: {} }, kE;
function N$() {
  if (kE) return ms.exports;
  kE = 1;
  const e = Eb();
  function t(n) {
    for (n = n.replace(/[\x00-\x20]+/g, ""); ; ) {
      const i = n.indexOf("<!--");
      if (i === -1)
        break;
      const o = n.indexOf("-->", i + 4);
      if (o === -1)
        break;
      n = n.substring(0, i) + n.substring(o + 3);
    }
    return n;
  }
  function r(n, i) {
    i = i || {};
    const o = i.allowedSchemes || ["http", "https", "ftp", "mailto", "tel", "sms"], s = i.allowProtocolRelative !== !1;
    if (typeof n != "string")
      return !1;
    n = t(n);
    const a = n.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!a)
      return n.match(/^[/\\]{2}/) ? !s : !1;
    const l = a[1].toLowerCase();
    return o.indexOf(l) === -1;
  }
  return ms.exports = function(n) {
    const i = {};
    return i.options = n || {}, i.filterTag = i.options.filterTag || function(o) {
      return o = o.trim(), o.toLowerCase();
    }, i.string = function(o, s) {
      return typeof o != "string" && (typeof o == "number" || typeof o == "boolean" ? o += "" : o = ""), o = o.trim(), s !== void 0 && o === "" && (o = s), o;
    }, i.strings = function(o) {
      return Array.isArray(o) ? o.map(function(s) {
        return i.string(s);
      }) : [];
    }, i.integer = function(o, s, a, l) {
      if (s === void 0 && (s = 0), typeof o == "number")
        o = Math.floor(o);
      else
        try {
          o = parseInt(o, 10), isNaN(o) && (o = s);
        } catch {
          o = s;
        }
      return typeof a == "number" && o < a && (o = a), typeof l == "number" && o > l && (o = l), o;
    }, i.padInteger = function(o, s) {
      let a = o + "";
      for (; a.length < s; )
        a = "0" + a;
      return a;
    }, i.float = function(o, s, a, l) {
      if (s === void 0 && (s = 0), typeof o != "number")
        try {
          o = parseFloat(o, 10), isNaN(o) && (o = s);
        } catch {
          o = s;
        }
      return typeof a == "number" && o < a && (o = a), typeof l == "number" && o > l && (o = l), o;
    }, i.naughtyHref = r, i.url = function(o, s, a) {
      if (o = i.string(o, s), o === s)
        return o;
      if (o = t(o), r(o) || (o = l(o), o === null))
        return s;
      return o;
      function l(f) {
        return f.match(/^(((https?|ftp):\/\/)|((mailto|tel|sms):)|#|([^/.]+)?\/|[^/.]+$)/) ? f : f.match(/^[^/.]+\.[^/.]+/) ? (a ? "https://" : "http://") + f : null;
      }
    }, i.select = function(o, s, a) {
      if (o = i.string(o), !s || !s.length)
        return a;
      let l;
      return typeof s[0] == "object" ? (l = s.find(function(f) {
        return f.value === null || f.value === void 0 ? !1 : f.value.toString() === o;
      }), l != null ? l.value : a) : (l = s.find(function(f) {
        return f == null ? !1 : f.toString() === o;
      }), l !== void 0 ? l : a);
    }, i.boolean = function(o, s) {
      return o === !0 ? !0 : o === !1 ? !1 : (o = i.string(o, s), o === s ? o === void 0 ? !1 : o : (o = o.toLowerCase().charAt(0), o === "" || o === "n" || o === "0" || o === "f" ? !1 : o === "t" || o === "y" || o === "1"));
    }, i.addBooleanFilterToCriteria = function(o, s, a, l) {
      l === void 0 && (l = null);
      let f = typeof o == "object" && o !== null ? o[s] : o;
      f = f === void 0 ? l : f, f = i.booleanOrNull(f), f === null || (f ? a[s] = !0 : a[s] = { $ne: !0 });
    }, i.booleanOrNull = function(o, s) {
      return o === !0 || o === !1 || o === null ? o : (o = i.string(o, s), o === s ? s === void 0 ? null : o : o === "null" ? null : (o = o.toLowerCase().charAt(0), o === "" || o === "n" || o === "0" || o === "f" ? !1 : o === "t" || o === "y" || o === "1" ? !0 : o === "a" ? null : s));
    }, i.date = function(o, s, a) {
      let l;
      function f() {
        return s === void 0 && (s = e().format("YYYY-MM-DD")), s;
      }
      if (typeof o == "string") {
        if (o.match(/\//)) {
          if (l = o.split("/"), l.length === 2)
            return (a || /* @__PURE__ */ new Date()).getFullYear() + "-" + i.padInteger(l[0], 2) + "-" + i.padInteger(l[1], 2);
          if (l.length === 3) {
            if (l[2] < 100) {
              const u = a || /* @__PURE__ */ new Date(), h = u.getFullYear() % 100, E = u.getFullYear() - h;
              let d = parseInt(l[2]) + E;
              d - u.getFullYear() > 50 && (d -= 100), l[2] = d;
            }
            return i.padInteger(l[2], 4) + "-" + i.padInteger(l[0], 2) + "-" + i.padInteger(l[1], 2);
          } else
            return f();
        } else if (o.match(/-/))
          return l = o.split("-"), l.length === 2 ? (a || /* @__PURE__ */ new Date()).getFullYear() + "-" + i.padInteger(l[0], 2) + "-" + i.padInteger(l[1], 2) : l.length === 3 ? i.padInteger(l[0], 4) + "-" + i.padInteger(l[1], 2) + "-" + i.padInteger(l[2], 2) : f();
      }
      try {
        return o === null || (o = a || new Date(o), isNaN(o.getTime())) ? f() : o.getFullYear() + "-" + i.padInteger(o.getMonth() + 1, 2) + "-" + i.padInteger(o.getDate(), 2);
      } catch {
        return f();
      }
    }, i.formatDate = function(o) {
      return e(o).format("YYYY-MM-DD");
    }, i.time = function(o, s) {
      o = i.string(o).toLowerCase(), o = o.trim();
      const a = o.match(/^(\d+)([:|.](\d+))?([:|.](\d+))?\s*(am|pm|AM|PM|a|p|A|M)?$/);
      if (a) {
        let l = parseInt(a[1], 10);
        const f = a[3] !== void 0 ? parseInt(a[3], 10) : 0, u = a[5] !== void 0 ? parseInt(a[5], 10) : 0;
        let h = a[6] ? a[6].toLowerCase() : a[6];
        return h = h && h.charAt(0), l === 12 && h === "a" ? l -= 12 : l === 12 && h === "p" || h === "p" && (l += 12), (l === 24 || l === "24") && (l = 0), i.padInteger(l, 2) + ":" + i.padInteger(f, 2) + ":" + i.padInteger(u, 2);
      } else
        return s !== void 0 ? s : e().format("HH:mm");
    }, i.formatTime = function(o) {
      return e(o).format("HH:mm:ss");
    }, i.tags = function(o, s) {
      return typeof o == "string" && (o = o.split(/,\s*/)), Array.isArray(o) ? o.map((u) => i.string(u)).map(s || i.filterTag).filter((u) => u.length > 0) : [];
    }, i.idRegExp = i.options.idRegExp || /^[A-Za-z0-9_]+$/, i.id = function(o, s) {
      const a = i.string(o, s);
      return a === s || a.match(i.idRegExp) ? a : s;
    }, i.ids = function(o) {
      return Array.isArray(o) ? o.filter(function(a) {
        return i.id(a) !== void 0;
      }) : [];
    }, i;
  }, ms.exports.naughtyHref = r, ms.exports;
}
var Au, jE;
function C$() {
  if (jE) return Au;
  jE = 1;
  const e = p$, t = h$(), { isPlainObject: r } = m$(), n = E$(), i = y$(), { parse: o } = w$(), { naughtyHref: s } = N$(), a = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], l = ["script", "style"], f = [
    "animate",
    "animatecolor",
    "animatemotion",
    "animatetransform",
    "set"
  ], u = ["href"], h = ["debug", "info", "warn", "error"];
  function E(_) {
    const v = _ && _.logger || console, M = {};
    for (const x of h)
      M[x] = typeof v[x] == "function" ? (...z) => v[x](...z) : (...z) => console[x](...z);
    return M;
  }
  function d(_, v) {
    _ && Object.keys(_).forEach(function(M) {
      v(_[M], M);
    });
  }
  function g(_, v) {
    return {}.hasOwnProperty.call(_, v);
  }
  function y(_, v) {
    const M = [];
    return d(_, function(x) {
      v(x) && M.push(x);
    }), M;
  }
  function b(_) {
    for (const v in _)
      if (g(_, v))
        return !1;
    return !0;
  }
  function I(_) {
    return _.map(function(v) {
      if (!v.url)
        throw new Error("URL missing");
      return v.url + (v.w ? ` ${v.w}w` : "") + (v.h ? ` ${v.h}h` : "") + (v.d ? ` ${v.d}x` : "");
    }).join(", ");
  }
  Au = w;
  const S = /^[^\0\t\n\f\r /<=>]+$/;
  function w(_, v, M) {
    if (_ == null)
      return "";
    typeof _ == "number" && (_ = _.toString());
    let x = "", z = "";
    function F(U, J) {
      const H = this;
      this.tag = U, this.attribs = J || {}, this.tagPosition = x.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (re.length) {
          const ie = re[re.length - 1];
          ie.text += H.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        re.length && a.includes(this.tag) && re[re.length - 1].mediaChildren.push(this.tag);
      };
    }
    v = Object.assign({}, w.defaults, v), v.parser = Object.assign({}, P, v.parser);
    const W = E(v), X = function(U) {
      return v.allowedTags === !1 || (v.allowedTags || []).indexOf(U) > -1;
    };
    l.forEach(function(U) {
      X(U) && !v.allowVulnerableTags && W.warn(
        `Your \`allowedTags\` option includes \`${U}\`, which is inherently vulnerable to XSS attacks. Please remove it from \`allowedTags\`, or, to disable this warning, add the \`allowVulnerableTags\` option and ensure you are accounting for this risk.`
      );
    });
    const de = v.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option",
      "xmp"
    ];
    let B, L;
    v.allowedAttributes && (B = {}, L = {}, d(v.allowedAttributes, function(U, J) {
      B[J] = [];
      const H = [];
      U.forEach(function(ie) {
        typeof ie == "string" && ie.indexOf("*") >= 0 ? H.push(t(ie).replace(/\\\*/g, ".*")) : B[J].push(ie);
      }), H.length && (L[J] = new RegExp("^(" + H.join("|") + ")$"));
    }));
    const G = {}, Z = {}, V = {};
    d(v.allowedClasses, function(U, J) {
      if (B && (g(B, J) || (B[J] = []), B[J].push("class")), G[J] = U, Array.isArray(U)) {
        const H = [];
        G[J] = [], V[J] = [], U.forEach(function(ie) {
          typeof ie == "string" && ie.indexOf("*") >= 0 ? H.push(t(ie).replace(/\\\*/g, ".*")) : ie instanceof RegExp ? V[J].push(ie) : G[J].push(ie);
        }), H.length && (Z[J] = new RegExp("^(" + H.join("|") + ")$"));
      }
    });
    const te = {};
    let ee;
    d(v.transformTags, function(U, J) {
      let H;
      typeof U == "function" ? H = U : typeof U == "string" && (H = w.simpleTransform(U)), J === "*" ? ee = H : te[J] = H;
    });
    let Q, re, ne, Ee, be, Be, Ue, Le, Ve = !1;
    $e();
    const Ie = new e.Parser({
      onopentag: function(U, J) {
        if (v.onOpenTag && v.onOpenTag(U, J), Ne(), v.enforceHtmlBoundary && U === "html" && $e(), Le)
          return;
        if (be) {
          Be++;
          return;
        }
        const H = new F(U, J);
        re.push(H);
        let ie = !1;
        const Ce = !!H.text;
        let We;
        if (g(te, U) && (We = te[U](U, J), H.attribs = J = We.attribs, We.text !== void 0 && (H.innerText = We.text), U !== We.tagName && (H.name = U = We.tagName, Ee[Q] = We.tagName)), ee && (We = ee(U, J), H.attribs = J = We.attribs, U !== We.tagName && (H.name = U = We.tagName, Ee[Q] = We.tagName)), (!X(U) || m(U, J) || v.disallowedTagsMode === "recursiveEscape" && !b(ne) || v.nestingLimit != null && Q >= v.nestingLimit) && (ie = !0, ne[Q] = !0, (v.disallowedTagsMode === "discard" || v.disallowedTagsMode === "completelyDiscard") && de.indexOf(U) !== -1 && (be = !0, Be = 1, H.tag.toLowerCase() === "noscript" && (Ue = Re("noscript", Ie.endIndex + 1)))), Q++, ie) {
          if (v.disallowedTagsMode === "discard" || v.disallowedTagsMode === "completelyDiscard") {
            if (H.innerText && !Ce) {
              const Oe = nt(H.innerText);
              v.textFilter ? x += v.textFilter(Oe, U) : x += Oe, Ve = !0;
            }
            return;
          }
          z = x, x = "";
        }
        if (x += "<" + U, U === "script" && (v.allowedScriptHostnames || v.allowedScriptDomains) && (H.innerText = ""), ie && (v.disallowedTagsMode === "escape" || v.disallowedTagsMode === "recursiveEscape") && v.preserveEscapedAttributes ? d(J, function(Oe, me) {
          x += " " + me + '="' + nt(Oe || "", !0) + '"';
        }) : (!B || g(B, U) || B["*"]) && d(J, function(Oe, me) {
          if (!S.test(me)) {
            delete H.attribs[me];
            return;
          }
          if (Oe === "" && !v.allowedEmptyAttributes.includes(me) && (v.nonBooleanAttributes.includes(me) || v.nonBooleanAttributes.includes("*"))) {
            delete H.attribs[me];
            return;
          }
          let Kn = !1;
          if (!B || g(B, U) && B[U].indexOf(me) !== -1 || B["*"] && B["*"].indexOf(me) !== -1 || g(L, U) && L[U].test(me) || L["*"] && L["*"].test(me))
            Kn = !0;
          else if (B && B[U]) {
            for (const ke of B[U])
              if (r(ke) && ke.name && ke.name === me) {
                Kn = !0;
                let je = "";
                if (ke.multiple === !0) {
                  const on = Oe.split(" ");
                  for (const pr of on)
                    ke.values.indexOf(pr) !== -1 && (je === "" ? je = pr : je += " " + pr);
                } else ke.values.indexOf(Oe) >= 0 && (je = Oe);
                Oe = je;
              }
          }
          if (Kn) {
            if (v.allowedSchemesAppliedToAttributes.indexOf(me) !== -1 && nn(U, Oe)) {
              delete H.attribs[me];
              return;
            }
            if (U === "meta" && me.toLowerCase() === "content" && p(J) && c(Oe)) {
              delete H.attribs[me];
              return;
            }
            if (U === "script" && me === "src") {
              let ke = !0;
              try {
                const je = O(Oe);
                if (v.allowedScriptHostnames || v.allowedScriptDomains) {
                  const on = (v.allowedScriptHostnames || []).find(function(qt) {
                    return qt === je.url.hostname;
                  }), pr = (v.allowedScriptDomains || []).find(function(qt) {
                    return je.url.hostname === qt || je.url.hostname.endsWith(`.${qt}`);
                  });
                  ke = on || pr;
                }
              } catch {
                ke = !1;
              }
              if (!ke) {
                delete H.attribs[me];
                return;
              }
            }
            if (U === "iframe" && me === "src") {
              let ke = !0;
              try {
                const je = O(Oe);
                if (je.isRelativeUrl)
                  ke = g(v, "allowIframeRelativeUrls") ? v.allowIframeRelativeUrls : !v.allowedIframeHostnames && !v.allowedIframeDomains;
                else if (v.allowedIframeHostnames || v.allowedIframeDomains) {
                  const on = (v.allowedIframeHostnames || []).find(function(qt) {
                    return qt === je.url.hostname;
                  }), pr = (v.allowedIframeDomains || []).find(function(qt) {
                    return je.url.hostname === qt || je.url.hostname.endsWith(`.${qt}`);
                  });
                  ke = on || pr;
                }
              } catch {
                ke = !1;
              }
              if (!ke) {
                delete H.attribs[me];
                return;
              }
            }
            if (me === "srcset" || me === "imagesrcset")
              try {
                let ke = i(Oe);
                if (ke.forEach(function(je) {
                  nn(U, je.url) && (je.evil = !0);
                }), ke = y(ke, function(je) {
                  return !je.evil;
                }), ke.length)
                  Oe = I(y(ke, function(je) {
                    return !je.evil;
                  })), H.attribs[me] = Oe;
                else {
                  delete H.attribs[me];
                  return;
                }
              } catch {
                delete H.attribs[me];
                return;
              }
            if (me === "class") {
              const ke = G[U], je = G["*"], on = Z[U], pr = V[U], qt = V["*"], _A = Z["*"], lf = [
                on,
                _A
              ].concat(pr, qt).filter(function(RA) {
                return RA;
              });
              if (ke && je ? Oe = Te(
                Oe,
                n(ke, je),
                lf
              ) : Oe = Te(
                Oe,
                ke || je,
                lf
              ), !Oe.length) {
                delete H.attribs[me];
                return;
              }
            }
            if (me === "style") {
              if (v.parseStyleAttributes)
                try {
                  const ke = o(U + " {" + Oe + "}", { map: !1 }), je = j(
                    ke,
                    v.allowedStyles
                  );
                  if (Oe = q(je), Oe.length === 0) {
                    delete H.attribs[me];
                    return;
                  }
                } catch {
                  typeof window < "u" && W.warn(
                    `Failed to parse "${U} {${Oe}}". If you are running this in a browser, we recommend disabling style parsing with the parseStyleAttributes option, since it only works in a node environment due to a postcss dependency. More info: https://github.com/apostrophecms/sanitize-html/issues/547`
                  ), delete H.attribs[me];
                  return;
                }
              else if (v.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            x += " " + me, Oe && Oe.length ? x += '="' + nt(Oe, !0) + '"' : v.allowedEmptyAttributes.includes(me) && (x += '=""');
          } else
            delete H.attribs[me];
        }), v.selfClosing.indexOf(U) !== -1)
          x += " />";
        else if (x += ">", H.innerText && !Ce) {
          const Oe = nt(H.innerText);
          v.textFilter ? x += v.textFilter(Oe, U) : x += Oe, Ve = !0;
        }
        ie && (x = z + nt(x), z = ""), H.openingTagLength = x.length - H.tagPosition;
      },
      ontext: function(U) {
        if (Ne(), be || Le)
          return;
        const J = re[re.length - 1];
        let H;
        if (J && (H = J.tag, U = J.innerText !== void 0 ? J.innerText : U), v.disallowedTagsMode === "completelyDiscard" && !X(H))
          U = "";
        else if (H && X(H) && (v.disallowedTagsMode === "discard" || v.disallowedTagsMode === "completelyDiscard") && (H === "script" || H === "style"))
          x += U;
        else if (H && X(H) && (v.disallowedTagsMode === "discard" || v.disallowedTagsMode === "completelyDiscard") && (H === "textarea" || H === "xmp"))
          H === "xmp" ? x += U.replace(/</g, "&lt;").replace(/>/g, "&gt;") : x += nt(U, !1);
        else if (
          // htmlparser2 treats <iframe> as a raw-text element, so markup inside
          // (including after an unclosed <iframe>) arrives as a single text node.
          // When the iframe is discarded, re-sanitize that fallback markup as HTML
          // instead of escaping it as plain text (issue #5550).
          H === "iframe" && !X(H) && v.disallowedTagsMode === "discard"
        )
          x += w(U, v);
        else if (!Ve) {
          const ie = nt(U, !1);
          v.textFilter ? x += v.textFilter(ie, H) : x += ie;
        }
        if (re.length) {
          const ie = re[re.length - 1];
          ie.text += U;
        }
      },
      onclosetag: function(U, J) {
        if (v.onCloseTag && v.onCloseTag(U, J), Ne(), Le) {
          const Ce = re[re.length - 1];
          if (!Ce || Ce.tag !== U)
            return;
        } else if (be)
          if (Be--, !Be)
            be = !1, Ue !== null && (Le = !0);
          else
            return;
        const H = re.pop();
        if (!H)
          return;
        if (H.tag !== U) {
          re.push(H);
          return;
        }
        be = v.enforceHtmlBoundary ? U === "html" : !1, Q--;
        const ie = ne[Q];
        if (ie) {
          if (delete ne[Q], v.disallowedTagsMode === "discard" || v.disallowedTagsMode === "completelyDiscard") {
            H.updateParentNodeText();
            return;
          }
          z = x, x = "";
        }
        if (Ee[Q] && (U = Ee[Q], delete Ee[Q]), v.exclusiveFilter) {
          const Ce = v.exclusiveFilter(H);
          if (Ce === "excludeTag") {
            ie && (x = z, z = ""), x = x.substring(0, H.tagPosition) + x.substring(H.tagPosition + H.openingTagLength);
            return;
          } else if (Ce) {
            x = x.substring(0, H.tagPosition);
            return;
          }
        }
        if (H.updateParentNodeMediaChildren(), H.updateParentNodeText(), // Already output />
        v.selfClosing.indexOf(U) !== -1 || // Escaped tag, closing tag is implied
        J && !X(U) && ["escape", "recursiveEscape"].indexOf(v.disallowedTagsMode) >= 0) {
          ie && (x = z, z = "");
          return;
        }
        x += "</" + U + ">", ie && (x = z + nt(x), z = ""), Ve = !1;
      }
    }, v.parser);
    if (Ie.write(_), Ie.end(), v.disallowedTagsMode === "escape" || v.disallowedTagsMode === "recursiveEscape") {
      const U = Ie.endIndex;
      if (U != null && U >= 0 && U < _.length) {
        const J = _.substring(U);
        x += nt(J);
      } else (U == null || U < 0) && _.length > 0 && x === "" && (x = nt(_));
    }
    return x;
    function $e() {
      x = "", Q = 0, re = [], ne = {}, Ee = {}, be = !1, Be = 0, Ue = null, Le = !1;
    }
    function Ne() {
      Ue !== null && Ie.startIndex >= Ue && (Ue = null, Le = !1);
    }
    function Re(U, J) {
      const H = new RegExp("</" + U + "[\\t\\n\\f\\r />]", "ig");
      H.lastIndex = J;
      const ie = H.exec(_);
      return ie ? ie.index : 1 / 0;
    }
    function nt(U, J) {
      return typeof U != "string" && (U = U + ""), v.parser.decodeEntities && (U = U.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), J && (U = U.replace(/"/g, "&quot;"))), U = U.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), J && (U = U.replace(/"/g, "&quot;")), U;
    }
    function nn(U, J) {
      const H = g(v.allowedSchemesByTag, U) ? v.allowedSchemesByTag[U] : v.allowedSchemes || [];
      return s(J, {
        allowedSchemes: H,
        allowProtocolRelative: v.allowProtocolRelative
      });
    }
    function p(U) {
      return Object.keys(U).some(function(J) {
        return J.toLowerCase() === "http-equiv" && String(U[J]).trim().toLowerCase() === "refresh";
      });
    }
    function c(U) {
      const J = String(U), H = function(me) {
        return me === " " || me === "	" || me === `
` || me === "\f" || me === "\r";
      };
      let ie = 0;
      const Ce = function() {
        for (; ie < J.length && H(J[ie]); )
          ie++;
      }, We = function(me) {
        return (J[me] || "").toLowerCase();
      };
      Ce();
      const uf = ie;
      for (; ie < J.length && /[0-9.]/.test(J[ie]); )
        ie++;
      if (ie === uf)
        return !0;
      if (ie < J.length) {
        const me = J[ie];
        if (me !== ";" && me !== "," && !H(me))
          return !0;
        Ce(), (J[ie] === ";" || J[ie] === ",") && ie++, Ce();
      }
      if (ie >= J.length)
        return !1;
      let Jn = J.slice(ie), Oe = !0;
      if (We(ie) === "u" && (Oe = !1, We(ie + 1) === "r" && We(ie + 2) === "l" && (ie += 3, Ce(), J[ie] === "=" && (ie++, Ce(), Oe = !0))), Oe) {
        const me = J[ie];
        if ((me === '"' || me === "'") && ie++, Jn = J.slice(ie), me === '"' || me === "'") {
          const Kn = Jn.indexOf(me);
          Kn !== -1 && (Jn = Jn.slice(0, Kn));
        }
      }
      return nn("meta", Jn);
    }
    function m(U, J) {
      if (f.indexOf(T(U)) === -1)
        return !1;
      const H = v.allowedSchemesAppliedToAttributes || [];
      return Object.keys(J || {}).some(function(ie) {
        if (T(ie) !== "attributename")
          return !1;
        const Ce = (J[ie] || "").trim().toLowerCase(), We = Ce.slice(Ce.lastIndexOf(":") + 1);
        return u.indexOf(We) !== -1 || H.indexOf(Ce) !== -1 || H.indexOf(We) !== -1;
      });
    }
    function T(U) {
      const J = U.toLowerCase();
      return J.slice(J.lastIndexOf(":") + 1);
    }
    function O(U) {
      if (U = U.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), U.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let J = "relative://relative-site";
      for (let Ce = 0; Ce < 100; Ce++)
        J += `/${Ce}`;
      const H = new URL(U, J);
      return {
        isRelativeUrl: H && H.hostname === "relative-site" && H.protocol === "relative:",
        url: H
      };
    }
    function j(U, J) {
      if (!J)
        return U;
      const H = U.nodes[0];
      let ie;
      return J[H.selector] && J["*"] ? ie = n(
        J[H.selector],
        J["*"]
      ) : ie = J[H.selector] || J["*"], ie && (U.nodes[0].nodes = H.nodes.reduce(ae(ie), [])), U;
    }
    function q(U) {
      return U.nodes[0].nodes.reduce(function(J, H) {
        return J.push(
          `${H.prop}:${H.value}${H.important ? " !important" : ""}`
        ), J;
      }, []).join(";");
    }
    function ae(U) {
      return function(J, H) {
        return g(U, H.prop) && U[H.prop].some(function(Ce) {
          return Ce.test(H.value);
        }) && J.push(H), J;
      };
    }
    function Te(U, J, H) {
      return J ? (U = U.split(/\s+/), U.filter(function(ie) {
        return J.indexOf(ie) !== -1 || H.some(function(Ce) {
          return Ce.test(ie);
        });
      }).join(" ")) : U;
    }
  }
  const P = {
    decodeEntities: !0
  };
  return w.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta", "col"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
      "href",
      "src",
      "cite",
      "action",
      "formaction",
      "data",
      "xlink:href",
      "poster",
      "background",
      "ping",
      "longdesc",
      "usemap",
      "codebase",
      "classid",
      "archive",
      "profile",
      "manifest",
      "itemid",
      "dynsrc",
      "lowsrc"
    ],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, w.simpleTransform = function(_, v, M) {
    return M = M === void 0 ? !0 : M, v = v || {}, function(x, z) {
      let F;
      if (M)
        for (F in v)
          z[F] = v[F];
      else
        z = v;
      return {
        tagName: _,
        attribs: z
      };
    };
  }, Au;
}
var P$ = /* @__PURE__ */ C$();
const UE = /* @__PURE__ */ kc(P$), D$ = [
  "br",
  "del",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "li",
  "ol",
  "p",
  "strong",
  "u",
  "ul"
], tG = (e) => {
  const t = UE(e, {
    allowedTags: !1,
    allowedAttributes: !1,
    allowVulnerableTags: !0
    // Just to suppress warning. For comparison, we allow EVERYTHING here, including vulnerable stuff. That does not mean, we allow it in the final request.
  }), r = UE(e, {
    allowedTags: [...D$],
    allowedAttributes: {}
  });
  return t !== r;
};
function rG(e) {
  return D(e) ? Array.isArray(e) ? e : [e] : [];
}
function Kc(e) {
  return !(!D(e) || e.length === 0);
}
function nG({
  pagination: e,
  data: t
}) {
  const r = Array.isArray(t) ? t : cb(t), { current: n = 1, pageSize: i = Tj(t) } = e, o = (n - 1) * i, s = o + i, a = r.slice(o, s);
  return Array.isArray(t) ? a : Dj(a);
}
function Io(e) {
  const t = _e(e);
  return t.length > 0 ? t : "---";
}
function _e(e) {
  return pt(e) ? e : Array.isArray(e) ? e.map((t) => _e(t)).join(" ") : ye(e) || dr(e) ? "" : Je(e) || sa(e) ? e.toString() : String(e);
}
function M$(e) {
  return Array.isArray(e) ? e.length === 0 ? [] : e.map((t) => _e(t)) : ye(e) || dr(e) ? [] : [_e(e)];
}
function _i(e) {
  return (t) => {
    if (Je(t) && !Number.isNaN(t))
      return e(t);
    if (Array.isArray(t))
      return _i(e)(t[0]);
    if (ye(t) || dr(t))
      return 0;
    if (pt(t)) {
      if (t === "")
        return 0;
      const r = e(t);
      return Number.isNaN(r) ? 0 : r;
    }
    return sa(t) ? t ? 1 : 0 : e(Number(t));
  };
}
function Xc(e) {
  return (t) => {
    const r = _i(e)(t);
    return Number.isFinite(r) ? r : 0;
  };
}
function oA(e) {
  return (t) => {
    const r = Xc(e)(t);
    return r >= 0 ? r : 0;
  };
}
function sA(e) {
  return (t) => Array.isArray(t) ? t.length === 0 ? [] : t.map((r) => _i(e)(r)) : ye(t) || dr(t) || sa(t) || t === "" ? [] : [_i(e)(t)];
}
function _a(e) {
  return Je(e) ? Math.round(e) : parseInt(e, 10);
}
const L$ = _i(Number), iG = Xc(Number), oG = oA(Number), sG = sA(Number), $E = _i(_a), x$ = Xc(_a), FE = oA(_a), aA = sA(_a);
function k$(e) {
  if (sa(e))
    return e;
  if (Je(e))
    return e === 1;
  const t = _e(e);
  return /^(true|on|1)$/i.test(t);
}
function j$(e, t) {
  return `category:${e}-${t}`;
}
function U$(e) {
  return `relation:${e}`;
}
function aG(e) {
  return L$(e.split(":")[1]);
}
function $$({
  dedicatedGroup: e,
  studentFieldValues: t,
  studentRelationIds: r
}) {
  var n;
  switch (e.kind) {
    case "none":
      return [];
    case "category": {
      const i = /* @__PURE__ */ new Map();
      for (const { id: s, value: a } of e.data) {
        const l = i.get(s);
        l ? l.push(a) : i.set(s, [a]);
      }
      const o = [];
      for (const s of t)
        for (const a of s.values)
          (n = i.get(s.fieldId)) != null && n.includes(a) && o.push(
            j$(s.fieldId, a)
          );
      return o;
    }
    case "relation": {
      const i = new Set(e.data.map((o) => o.id));
      return r.filter((o) => i.has(o)).map((o) => U$(o));
    }
    default:
      return mt();
  }
}
function _s({
  mapping: e,
  value: t
}) {
  return e.parse("allocationRules", t).dedi;
}
function zE({
  mapping: e,
  value: t
}) {
  return e.parse("allocationRules", t).dist;
}
function uG(e, t) {
  switch (e) {
    case xs.enum.SPREAD:
      return t.spread;
    default:
      return mt();
  }
}
function lG({
  overrides: e,
  groupObject: t,
  mapping: r
}) {
  const n = r.parse("allocationRules", t);
  return D(e.dedicatedGroupString) && (n.dedi = JSON.parse(e.dedicatedGroupString)), D(e.distribution) && (n.dist = r.parse("allocationRules", {
    dist: e.distribution
  }).dist), JSON.stringify(n);
}
function cG({
  missingLinksLength: e,
  missingGroupsForActivitiesLength: t,
  override: r
}) {
  return r || e === 0 && t === 0;
}
function F$(e, t) {
  return e.k !== Kr.NONE && t.k !== Kr.NONE ? e.r === t.r && e.v === t.v : e.k === t.k;
}
function z$({
  groups: e,
  mapping: t
}) {
  if (e.length <= 1)
    return { success: !0 };
  const r = zE({ mapping: t, value: e[0] }), n = [];
  for (const i of e) {
    const o = zE({ mapping: t, value: i });
    F$(o, r) || n.push(
      `Distribution mismatch for group ${t.parse(
        "groupName",
        i
      )} with group ${t.parse("groupName", e[0])}.`
    );
  }
  return n.length === 0 ? { success: !0 } : {
    success: !1,
    reason: n.join(`
`)
  };
}
var vu, GE;
function G$() {
  if (GE) return vu;
  GE = 1;
  var e;
  return e = {
    // 1xx - The 1xx (Informational) class of status code indicates an interim response for communicating connection status or request progress prior to completing the requested action and sending a final response.
    "1xx": "Informational",
    "1xx_NAME": "INFORMATIONAL",
    "1xx_MESSAGE": "Indicates an interim response for communicating connection status or request progress prior to completing the requested action and sending a final response.",
    INFORMATIONAL: "1xx",
    // 2xx - The 2xx (Successful) class of status code indicates that the client's request was successfully received, understood, and accepted.
    "2xx": "Successful",
    "2xx_NAME": "SUCCESSFUL",
    "2xx_MESSAGE": "Indicates that the client's request was successfully received, understood, and accepted.",
    SUCCESSFUL: "2xx",
    // 3xx - The 3xx (Redirection) class of status code indicates that further action needs to be taken by the user agent in order to fulfill the request.
    "3xx": "Redirection",
    "3xx_NAME": "REDIRECTION",
    "3xx_MESSAGE": "Indicates that further action needs to be taken by the user agent in order to fulfill the request.",
    REDIRECTION: "3xx",
    // 4xx - The 4xx (Client Error) class of status code indicates that the client seems to have erred.
    "4xx": "Client Error",
    "4xx_NAME": "CLIENT_ERROR",
    "4xx_MESSAGE": "Indicates that the client seems to have erred.",
    CLIENT_ERROR: "4xx",
    // 5xx - The 5xx (Server Error) class of status code indicates that the server is aware that it has erred or is incapable of performing the requested method.
    "5xx": "Server Error",
    "5xx_NAME": "SERVER_ERROR",
    "5xx_MESSAGE": "Indicates that the server is aware that it has erred or is incapable of performing the requested method.",
    SERVER_ERROR: "5xx"
  }, vu = {
    classes: e,
    // ## Informational 1xx
    // Indicates an interim response for communicating connection status or request progress prior to completing the requested action and sending a final response.
    // 100 - The server has received the request headers and the client should proceed to send the request body.
    100: "Continue",
    "100_NAME": "CONTINUE",
    "100_MESSAGE": "The server has received the request headers and the client should proceed to send the request body.",
    "100_CLASS": e.INFORMATIONAL,
    CONTINUE: 100,
    // 101 - The requester has asked the server to switch protocols and the server has agreed to do so.
    101: "Switching Protocols",
    "101_NAME": "SWITCHING_PROTOCOLS",
    "101_MESSAGE": "The requester has asked the server to switch protocols and the server has agreed to do so.",
    "101_CLASS": e.INFORMATIONAL,
    SWITCHING_PROTOCOLS: 101,
    // 102 Processing (WebDAV; RFC 2518) - A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[7] This prevents the client from timing out and assuming the request was lost.
    102: "Processing",
    "102_NAME": "PROCESSING",
    "102_MESSAGE": "A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[7] This prevents the client from timing out and assuming the request was lost.",
    "102_CLASS": e.INFORMATIONAL,
    PROCESSING: 102,
    // 103 Early Hints (RFC 8297) - Used to return some response headers before final HTTP message.
    103: "Early Hints",
    "103_NAME": "EARLY_HINTS",
    "103_MESSAGE": "Used to return some response headers before final HTTP message.",
    "103_CLASS": e.INFORMATIONAL,
    EARLY_HINTS: 103,
    // ## Successful 2xx
    // Indicates that the client's request was successfully received, understood, and accepted.
    // 200 - Standard response for successful HTTP requests.
    200: "OK",
    "200_NAME": "OK",
    "200_MESSAGE": "Standard response for successful HTTP requests.",
    "200_CLASS": e.SUCCESSFUL,
    OK: 200,
    // 201 - The request has been fulfilled, resulting in the creation of a new resource.
    201: "Created",
    "201_NAME": "CREATED",
    "201_MESSAGE": "The request has been fulfilled, resulting in the creation of a new resource.",
    "201_CLASS": e.SUCCESSFUL,
    CREATED: 201,
    // 202 - The request has been accepted for processing, but the processing has not been completed.
    202: "Accepted",
    "202_NAME": "ACCEPTED",
    "202_MESSAGE": "The request has been accepted for processing, but the processing has not been completed.",
    "202_CLASS": e.SUCCESSFUL,
    ACCEPTED: 202,
    // 203 (since HTTP/1.1) - The server is a transforming proxy (e.g. a Web accelerator) that received a 200 OK from its origin, but is returning a modified version of the origin's response.
    203: "Non-Authoritative Information",
    "203_NAME": "NON_AUTHORITATIVE_INFORMATION",
    "203_MESSAGE": "The server is a transforming proxy (e.g. a Web accelerator) that received a 200 OK from its origin, but is returning a modified version of the origin's response.",
    "203_CLASS": e.SUCCESSFUL,
    NON_AUTHORITATIVE_INFORMATION: 203,
    // 204 - The server successfully processed the request and is not returning any content.
    204: "No Content",
    "204_NAME": "NO_CONTENT",
    "204_MESSAGE": "The server successfully processed the request and is not returning any content.",
    "204_CLASS": e.SUCCESSFUL,
    NO_CONTENT: 204,
    // 205 - The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.
    205: "Reset Content",
    "205_NAME": "RESET_CONTENT",
    "205_MESSAGE": "The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.",
    "205_CLASS": e.SUCCESSFUL,
    RESET_CONTENT: 205,
    // 206 (RFC 7233) - The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
    206: "Partial Content",
    "206_NAME": "PARTIAL_CONTENT",
    "206_MESSAGE": "The server is delivering only part of the resource (byte serving) due to a range header sent by the client.",
    "206_CLASS": e.SUCCESSFUL,
    PARTIAL_CONTENT: 206,
    // 207 (WebDAV; RFC 4918) - The message body that follows is by default an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.
    207: "Multi Status",
    "207_NAME": "MULTI_STATUS",
    "207_MESSAGE": "The message body that follows is by default an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.",
    "207_CLASS": e.SUCCESSFUL,
    MULTI_STATUS: 207,
    // 208 (WebDAV; RFC 5842) - The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response, and are not being included again.
    208: "Already Reported",
    "208_NAME": "ALREADY_REPORTED",
    "208_MESSAGE": "The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response, and are not being included again.",
    "208_CLASS": e.SUCCESSFUL,
    ALREADY_REPORTED: 208,
    // 226 (RFC 3229) - The server has fulfilled a request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
    226: "IM Used",
    "226_NAME": "IM_USED",
    "226_MESSAGE": "The server has fulfilled a request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance.",
    "226_CLASS": e.SUCCESSFUL,
    IM_USED: 226,
    // ## Redirection 3xx
    // Indicates that further action needs to be taken by the user agent in order to fulfill the request.
    // 300 - Indicates multiple options for the resource from which the client may choose.
    300: "Multiple Choices",
    "300_NAME": "MULTIPLE_CHOICES",
    "300_MESSAGE": "Indicates multiple options for the resource from which the client may choose.",
    "300_CLASS": e.REDIRECTION,
    MULTIPLE_CHOICES: 300,
    // 301 - This and all future requests should be directed to the given URI.
    301: "Moved Permanently",
    "301_NAME": "MOVED_PERMANENTLY",
    "301_MESSAGE": "This and all future requests should be directed to the given URI.",
    "301_CLASS": e.REDIRECTION,
    MOVED_PERMANENTLY: 301,
    // 302 - This is an example of industry practice contradicting the standard. The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.
    302: "Found",
    "302_NAME": "FOUND",
    "302_MESSAGE": 'This is an example of industry practice contradicting the standard. The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.',
    "302_CLASS": e.REDIRECTION,
    FOUND: 302,
    // 303 (since HTTP/1.1) - The response to the request can be found under another URI using the GET method.
    303: "See Other",
    "303_NAME": "SEE_OTHER",
    "303_MESSAGE": "The response to the request can be found under another URI using the GET method.",
    "303_CLASS": e.REDIRECTION,
    SEE_OTHER: 303,
    // 304 (RFC 7232) - Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
    304: "Not Modified",
    "304_NAME": "NOT_MODIFIED",
    "304_MESSAGE": "Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.",
    "304_CLASS": e.REDIRECTION,
    NOT_MODIFIED: 304,
    // 305 (since HTTP/1.1) - The requested resource is available only through a proxy, the address for which is provided in the response.
    305: "Use Proxy",
    "305_NAME": "USE_PROXY",
    "305_MESSAGE": "The requested resource is available only through a proxy, the address for which is provided in the response.",
    "305_CLASS": e.REDIRECTION,
    USE_PROXY: 305,
    // 306 - No longer used. Originally meant "Subsequent requests should use the specified proxy.
    306: "Switch Proxy",
    "306_NAME": "SWITCH_PROXY",
    "306_MESSAGE": 'No longer used. Originally meant "Subsequent requests should use the specified proxy.',
    "306_CLASS": e.REDIRECTION,
    SWITCH_PROXY: 306,
    // 307 (since HTTP/1.1) - In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
    307: "Temporary Redirect",
    "307_NAME": "TEMPORARY_REDIRECT",
    "307_MESSAGE": "In this case, the request should be repeated with another URI; however, future requests should still use the original URI.",
    "307_CLASS": e.REDIRECTION,
    TEMPORARY_REDIRECT: 307,
    // 308 (RFC 7538) - The request and all future requests should be repeated using another URI.
    308: "Permanent Redirect",
    "308_NAME": "PERMANENT_REDIRECT",
    "308_MESSAGE": "The request and all future requests should be repeated using another URI.",
    "308_CLASS": e.REDIRECTION,
    PERMANENT_REDIRECT: 308,
    // ## Client Error 4xx
    // Indicates that the client seems to have erred.
    // 400 - The server cannot or will not process the request due to an apparent client error.
    400: "Bad Request",
    "400_NAME": "BAD_REQUEST",
    "400_MESSAGE": "The server cannot or will not process the request due to an apparent client error.",
    "400_CLASS": e.CLIENT_ERROR,
    BAD_REQUEST: 400,
    // 401 (RFC 7235) - Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet been provided.
    401: "Unauthorized",
    "401_NAME": "UNAUTHORIZED",
    "401_MESSAGE": "Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet been provided.",
    "401_CLASS": e.CLIENT_ERROR,
    UNAUTHORIZED: 401,
    // 402 - Reserved for future use. The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, as proposed for example by GNU Taler, but that has not yet happened, and this code is not usually used.
    402: "Payment Required",
    "402_NAME": "PAYMENT_REQUIRED",
    "402_MESSAGE": "Reserved for future use. The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, as proposed for example by GNU Taler, but that has not yet happened, and this code is not usually used.",
    "402_CLASS": e.CLIENT_ERROR,
    PAYMENT_REQUIRED: 402,
    // 403 - The request was valid, but the server is refusing action.
    403: "Forbidden",
    "403_NAME": "FORBIDDEN",
    "403_MESSAGE": "The request was valid, but the server is refusing action.",
    "403_CLASS": e.CLIENT_ERROR,
    FORBIDDEN: 403,
    // 404 - The requested resource could not be found but may be available in the future. Subsequent requests by the client are permissible.
    404: "Not Found",
    "404_NAME": "NOT_FOUND",
    "404_MESSAGE": "The requested resource could not be found but may be available in the future. Subsequent requests by the client are permissible.",
    "404_CLASS": e.CLIENT_ERROR,
    NOT_FOUND: 404,
    // 405 - A request method is not supported for the requested resource.
    405: "Method Not Allowed",
    "405_NAME": "METHOD_NOT_ALLOWED",
    "405_MESSAGE": "A request method is not supported for the requested resource.",
    "405_CLASS": e.CLIENT_ERROR,
    METHOD_NOT_ALLOWED: 405,
    // 406 - The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
    406: "Not Acceptable",
    "406_NAME": "NOT_ACCEPTABLE",
    "406_MESSAGE": "The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.",
    "406_CLASS": e.CLIENT_ERROR,
    NOT_ACCEPTABLE: 406,
    // 407 (RFC 7235) - The client must first authenticate itself with the proxy.
    407: "Proxy Authentication Required",
    "407_NAME": "PROXY_AUTHENTICATION_REQUIRED",
    "407_MESSAGE": "The client must first authenticate itself with the proxy.",
    "407_CLASS": e.CLIENT_ERROR,
    PROXY_AUTHENTICATION_REQUIRED: 407,
    // 408 - The server timed out waiting for the request.
    408: "Request Time-out",
    "408_NAME": "REQUEST_TIMEOUT",
    "408_MESSAGE": "The server timed out waiting for the request.",
    "408_CLASS": e.CLIENT_ERROR,
    REQUEST_TIMEOUT: 408,
    // 409 - Indicates that the request could not be processed because of conflict in the request, such as an edit conflict between multiple simultaneous updates.
    409: "Conflict",
    "409_NAME": "CONFLICT",
    "409_MESSAGE": "Indicates that the request could not be processed because of conflict in the request, such as an edit conflict between multiple simultaneous updates.",
    "409_CLASS": e.CLIENT_ERROR,
    CONFLICT: 409,
    // 410 - Indicates that the resource requested is no longer available and will not be available again.
    410: "Gone",
    "410_NAME": "GONE",
    "410_MESSAGE": "Indicates that the resource requested is no longer available and will not be available again.",
    "410_CLASS": e.CLIENT_ERROR,
    GONE: 410,
    // 411 - The request did not specify the length of its content, which is required by the requested resource.
    411: "Length Required",
    "411_NAME": "LENGTH_REQUIRED",
    "411_MESSAGE": "The request did not specify the length of its content, which is required by the requested resource.",
    "411_CLASS": e.CLIENT_ERROR,
    LENGTH_REQUIRED: 411,
    // 412 (RFC 7232) - The server does not meet one of the preconditions that the requester put on the request.
    412: "Precondition Failed",
    "412_NAME": "PRECONDITION_FAILED",
    "412_MESSAGE": "The server does not meet one of the preconditions that the requester put on the request.",
    "412_CLASS": e.CLIENT_ERROR,
    PRECONDITION_FAILED: 412,
    // 413 (RFC 7231) - The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
    413: "Request Entity Too Large",
    "413_NAME": "REQUEST_ENTITY_TOO_LARGE",
    "413_MESSAGE": 'The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".',
    "413_CLASS": e.CLIENT_ERROR,
    REQUEST_ENTITY_TOO_LARGE: 413,
    // 414 (RFC 7231) - The URI provided was too long for the server to process.
    414: "Request-URI Too Large",
    "414_NAME": "REQUEST_URI_TOO_LONG",
    "414_MESSAGE": "The URI provided was too long for the server to process.",
    "414_CLASS": e.CLIENT_ERROR,
    REQUEST_URI_TOO_LONG: 414,
    // 415 - The request entity has a media type which the server or resource does not support.
    415: "Unsupported Media Type",
    "415_NAME": "UNSUPPORTED_MEDIA_TYPE",
    "415_MESSAGE": "The request entity has a media type which the server or resource does not support.",
    "415_CLASS": e.CLIENT_ERROR,
    UNSUPPORTED_MEDIA_TYPE: 415,
    // 416 (RFC 7233) - The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
    416: "Requested Range not Satisfiable",
    "416_NAME": "REQUESTED_RANGE_NOT_SATISFIABLE",
    "416_MESSAGE": "The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.",
    "416_CLASS": e.CLIENT_ERROR,
    REQUESTED_RANGE_NOT_SATISFIABLE: 416,
    // 417 - The server cannot meet the requirements of the Expect request-header field.
    417: "Expectation Failed",
    "417_NAME": "EXPECTATION_FAILED",
    "417_MESSAGE": "The server cannot meet the requirements of the Expect request-header field.",
    "417_CLASS": e.CLIENT_ERROR,
    EXPECTATION_FAILED: 417,
    // 418 (RFC 2324, RFC 7168) - Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout. This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
    418: "I'm a teapot",
    "418_NAME": "IM_A_TEAPOT",
    "418_MESSAGE": `Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.`,
    "418_CLASS": e.CLIENT_ERROR,
    IM_A_TEAPOT: 418,
    // 421 (RFC 7540) - The request was directed at a server that is not able to produce a response.
    421: "Misdirected Request",
    "421_NAME": "MISDIRECTED_REQUEST",
    "421_MESSAGE": "The request was directed at a server that is not able to produce a response.",
    "421_CLASS": e.CLIENT_ERROR,
    MISDIRECTED_REQUEST: 421,
    // 422 (WebDAV; RFC 4918) - The request was well-formed but was unable to be followed due to semantic errors.
    422: "Unprocessable Entity",
    "422_NAME": "UNPROCESSABLE_ENTITY",
    "422_MESSAGE": "The request was well-formed but was unable to be followed due to semantic errors.",
    "422_CLASS": e.CLIENT_ERROR,
    UNPROCESSABLE_ENTITY: 422,
    // 423 (WebDAV; RFC 4918) - The resource that is being accessed is locked.
    423: "Locked",
    "423_NAME": "LOCKED",
    "423_MESSAGE": "The resource that is being accessed is locked.",
    "423_CLASS": e.CLIENT_ERROR,
    LOCKED: 423,
    // 424 (WebDAV; RFC 4918) - The request failed because it depended on another request and that request failed.
    424: "Failed Dependency",
    "424_NAME": "FAILED_DEPENDENCY",
    "424_MESSAGE": "The request failed because it depended on another request and that request failed.",
    "424_CLASS": e.CLIENT_ERROR,
    FAILED_DEPENDENCY: 424,
    // 425 (RFC 8470) - The server is unwilling to risk processing a request that might be replayed.
    425: "Too Early",
    "425_NAME": "TOO_EARLY",
    "425_MESSAGE": "The server is unwilling to risk processing a request that might be replayed.",
    "425_CLASS": e.CLIENT_ERROR,
    TOO_EARLY: 425,
    // 426 - The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
    426: "Upgrade Required",
    "426_NAME": "UPGRADE_REQUIRED",
    "426_MESSAGE": "The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.",
    "426_CLASS": e.CLIENT_ERROR,
    UPGRADE_REQUIRED: 426,
    // 428 (RFC 6585) - The origin server requires the request to be conditional.
    428: "Precondition Required",
    // RFC 6585
    "428_NAME": "PRECONDITION_REQUIRED",
    "428_MESSAGE": "The origin server requires the request to be conditional.",
    "428_CLASS": e.CLIENT_ERROR,
    PRECONDITION_REQUIRED: 428,
    // 429 (RFC 6585) - The user has sent too many requests in a given amount of time.
    429: "Too Many Requests",
    "429_NAME": "TOO_MANY_REQUESTS",
    "429_MESSAGE": "The user has sent too many requests in a given amount of time.",
    "429_CLASS": e.CLIENT_ERROR,
    TOO_MANY_REQUESTS: 429,
    // 431 (RFC 6585) - The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.
    431: "Request Header Fields Too Large",
    // RFC 6585
    "431_NAME": "REQUEST_HEADER_FIELDS_TOO_LARGE",
    "431_MESSAGE": "The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.",
    "431_CLASS": e.CLIENT_ERROR,
    REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
    // 451 (RFC 7725) - A server operator has received a legal demand to deny access to a resource or to a set of resources that includes the requested resource.
    451: "Unavailable For Legal Reasons",
    "451_NAME": "UNAVAILABLE_FOR_LEGAL_REASONS",
    "451_MESSAGE": "A server operator has received a legal demand to deny access to a resource or to a set of resources that includes the requested resource.",
    "451_CLASS": e.CLIENT_ERROR,
    UNAVAILABLE_FOR_LEGAL_REASONS: 451,
    // ## Server Error 5xx
    // Indicates that the server is aware that it has erred or is incapable of performing the requested method.
    // 500 - A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
    500: "Internal Server Error",
    "500_NAME": "INTERNAL_SERVER_ERROR",
    "500_MESSAGE": "A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.",
    "500_CLASS": e.SERVER_ERROR,
    INTERNAL_SERVER_ERROR: 500,
    // 501 - The server either does not recognize the request method, or it lacks the ability to fulfil the request. Usually this implies future availability.
    501: "Not Implemented",
    "501_NAME": "NOT_IMPLEMENTED",
    "501_MESSAGE": "The server either does not recognize the request method, or it lacks the ability to fulfil the request. Usually this implies future availability.",
    "501_CLASS": e.SERVER_ERROR,
    NOT_IMPLEMENTED: 501,
    // 502 - The server was acting as a gateway or proxy and received an invalid response from the upstream server.
    502: "Bad Gateway",
    "502_NAME": "BAD_GATEWAY",
    "502_MESSAGE": "The server was acting as a gateway or proxy and received an invalid response from the upstream server.",
    "502_CLASS": e.SERVER_ERROR,
    BAD_GATEWAY: 502,
    // 503 - The server is currently unavailable (because it is overloaded or down for maintenance). Generally, this is a temporary state.
    503: "Service Unavailable",
    "503_NAME": "SERVICE_UNAVAILABLE",
    "503_MESSAGE": "The server is currently unavailable (because it is overloaded or down for maintenance). Generally, this is a temporary state.",
    "503_CLASS": e.SERVER_ERROR,
    SERVICE_UNAVAILABLE: 503,
    // 504 - The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
    504: "Gateway Time-out",
    "504_NAME": "GATEWAY_TIMEOUT",
    "504_MESSAGE": "The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.",
    "504_CLASS": e.SERVER_ERROR,
    GATEWAY_TIMEOUT: 504,
    // 505 - The server does not support the HTTP protocol version used in the request.
    505: "HTTP Version not Supported",
    "505_NAME": "HTTP_VERSION_NOT_SUPPORTED",
    "505_MESSAGE": "The server does not support the HTTP protocol version used in the request.",
    "505_CLASS": e.SERVER_ERROR,
    HTTP_VERSION_NOT_SUPPORTED: 505,
    // 506 (RFC 2295) - Transparent content negotiation for the request results in a circular reference.
    506: "Variant Also Negotiates",
    "506_NAME": "VARIANT_ALSO_NEGOTIATES",
    "506_MESSAGE": "Transparent content negotiation for the request results in a circular reference.",
    "506_CLASS": e.SERVER_ERROR,
    VARIANT_ALSO_NEGOTIATES: 506,
    // 507 (WebDAV; RFC 4918) - The server is unable to store the representation needed to complete the request.
    507: "Insufficient Storage",
    "507_NAME": "INSUFFICIENT_STORAGE",
    "507_MESSAGE": "The server is unable to store the representation needed to complete the request.",
    "507_CLASS": e.SERVER_ERROR,
    INSUFFICIENT_STORAGE: 507,
    // 508 (WebDAV; RFC 5842) - The server detected an infinite loop while processing the request.
    508: "Loop Detected",
    "508_NAME": "LOOP_DETECTED",
    "508_MESSAGE": "The server detected an infinite loop while processing the request.",
    "508_CLASS": e.SERVER_ERROR,
    LOOP_DETECTED: 508,
    // 510 (RFC 2774) - Further extensions to the request are required for the server to fulfil it.
    510: "Not Extended",
    "510_NAME": "NOT_EXTENDED",
    "510_MESSAGE": "Further extensions to the request are required for the server to fulfil it.",
    "510_CLASS": e.SERVER_ERROR,
    NOT_EXTENDED: 510,
    // 511 (RFC 6585) - The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network.
    511: "Network Authentication Required",
    "511_NAME": "NETWORK_AUTHENTICATION_REQUIRED",
    "511_MESSAGE": "The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network.",
    "511_CLASS": e.SERVER_ERROR,
    NETWORK_AUTHENTICATION_REQUIRED: 511,
    // ## Extra code
    // Extra HTTP code implemented by vendors and other specifications.
    extra: {
      // ### Unofficial codes
      // The following codes are not specified by any standard.
      unofficial: {
        // 103 - Used in the resumable requests proposal to resume aborted PUT or POST requests.
        103: "Checkpoint",
        "103_NAME": "CHECKPOINT",
        "103_MESSAGE": "Used in the resumable requests proposal to resume aborted PUT or POST requests.",
        "103_CLASS": e.INFORMATIONAL,
        CHECKPOINT: 103,
        // 419 Page Expired (Laravel Framework) - Used by the Laravel Framework when a CSRF Token is missing or expired.
        419: "Page Expired",
        "419_NAME": "PAGE_EXPIRED",
        "419_MESSAGE": "Used by the Laravel Framework when a CSRF Token is missing or expired.",
        "419_CLASS": e.CLIENT_ERROR,
        PAGE_EXPIRED: 419,
        // 218 This is fine (Apache Web Server) - Used as a catch-all error condition for allowing response bodies to flow through Apache when ProxyErrorOverride is enabled. When ProxyErrorOverride is enabled in Apache, response bodies that contain a status code of 4xx or 5xx are automatically discarded by Apache in favor of a generic response or a custom response specified by the ErrorDocument directive.
        218: "This is fine",
        "218_NAME": "THIS_IS_FINE",
        "218_MESSAGE": "Used as a catch-all error condition for allowing response bodies to flow through Apache when ProxyErrorOverride is enabled. When ProxyErrorOverride is enabled in Apache, response bodies that contain a status code of 4xx or 5xx are automatically discarded by Apache in favor of a generic response or a custom response specified by the ErrorDocument directive.",
        "218_CLASS": e.SUCCESSFUL,
        THIS_IS_FINE: 218,
        // 420 Enhance Your Calm (Twitter) - Returned by version 1 of the Twitter Search and Trends API when the client is being rate limited; versions 1.1 and later use the 429 Too Many Requests response code instead.
        420: "Enhance Your Calm",
        "420_NAME": "ENHANCE_YOUR_CALM",
        "420_MESSAGE": "Returned by version 1 of the Twitter Search and Trends API when the client is being rate limited; versions 1.1 and later use the 429 Too Many Requests response code instead.",
        "420_CLASS": e.CLIENT_ERROR,
        ENHANCE_YOUR_CALM: 420,
        // 450 Blocked by Windows Parental (Microsoft) - The Microsoft extension code indicated when Windows Parental Controls are turned on and are blocking access to the requested webpage.
        450: "Blocked by Windows Parental Controls",
        "450_NAME": "BLOCKED_BY_WINDOWS_PARENTAL_CONTROLS",
        "450_MESSAGE": "The Microsoft extension code indicated when Windows Parental Controls are turned on and are blocking access to the requested webpage.",
        "450_CLASS": e.CLIENT_ERROR,
        BLOCKED_BY_WINDOWS_PARENTAL_CONTROLS: 450,
        // 498 Invalid Token (Esri) - Returned by ArcGIS for Server. Code 498 indicates an expired or otherwise invalid token.
        498: "Invalid Token",
        "498_NAME": "INVALID_TOKEN",
        "498_MESSAGE": "Returned by ArcGIS for Server. Code 498 indicates an expired or otherwise invalid token.",
        "498_CLASS": e.CLIENT_ERROR,
        INVALID_TOKEN: 498,
        // 499 Token Required (Esri) - Returned by ArcGIS for Server. Code 499 indicates that a token is required but was not submitted.
        499: "Token Required",
        "499_NAME": "TOKEN_REQUIRED",
        "499_MESSAGE": "Returned by ArcGIS for Server. Code 499 indicates that a token is required but was not submitted.",
        "499_CLASS": e.CLIENT_ERROR,
        TOKEN_REQUIRED: 499,
        // 509 Bandwidth Limit Exceeded (Apache Web Server/cPanel) - The server has exceeded the bandwidth specified by the server administrator.
        509: "Bandwidth Limit Exceeded",
        "509_NAME": "BANDWIDTH_LIMIT_EXCEEDED",
        "509_MESSAGE": "The server has exceeded the bandwidth specified by the server administrator.",
        "509_CLASS": e.SERVER_ERROR,
        BANDWIDTH_LIMIT_EXCEEDED: 509,
        // 530 Site is frozen - Used by the Pantheon web platform to indicate a site that has been frozen due to inactivity.
        530: "Site is frozen",
        "530_NAME": "SITE_IS_FROZEN",
        "530_MESSAGE": "Used by the Pantheon web platform to indicate a site that has been frozen due to inactivity.",
        "530_CLASS": e.SERVER_ERROR,
        SITE_IS_FROZEN: 530,
        // 598 (Informal convention) Network read timeout error - Used by some HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
        598: "Network read timeout error",
        "598_NAME": "NETWORK_READ_TIMEOUT_ERROR",
        "598_MESSAGE": "Used by some HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.",
        "598_CLASS": e.SERVER_ERROR,
        NETWORK_READ_TIMEOUT_ERROR: 598
      },
      // ### Internet Information Services (IIS)
      // Microsoft's Internet Information Services (IIS) web server expands the 4xx error space to signal errors with the client's request.
      iis: {
        // 440 - The client's session has expired and must log in again.
        440: "Login Time-out",
        "440_NAME": "LOGIN_TIME_OUT",
        "440_MESSAGE": "The client's session has expired and must log in again.",
        "440_CLASS": e.CLIENT_ERROR,
        LOGIN_TIME_OUT: 440,
        // 449 - The server cannot honour the request because the user has not provided the required information.
        449: "Retry With",
        "449_NAME": "RETRY_WITH",
        "449_MESSAGE": "The server cannot honour the request because the user has not provided the required information.",
        "449_CLASS": e.CLIENT_ERROR,
        RETRY_WITH: 449,
        // 451 - Used in Exchange ActiveSync when either a more efficient server is available or the server cannot access the users' mailbox.
        451: "Redirect",
        "451_NAME": "REDIRECT",
        "451_MESSAGE": "Used in Exchange ActiveSync when either a more efficient server is available or the server cannot access the users' mailbox.",
        "451_CLASS": e.CLIENT_ERROR,
        REDIRECT: 451
      },
      // ### NGINX
      // The NGINX web server software expands the 4xx error space to signal issues with the client's request.
      nginx: {
        // 444 - Used internally to instruct the server to return no information to the client and close the connection immediately.
        444: "No Response",
        "444_NAME": "NO_RESPONSE",
        "444_MESSAGE": "Used internally to instruct the server to return no information to the client and close the connection immediately.",
        "444_CLASS": e.CLIENT_ERROR,
        NO_RESPONSE: 444,
        // 494 - Client sent too large request or too long header line.
        494: "Request header too large",
        "494_NAME": "REQUEST_HEADER_TOO_LARGE",
        "494_MESSAGE": "Client sent too large request or too long header line.",
        "494_CLASS": e.CLIENT_ERROR,
        REQUEST_HEADER_TOO_LARGE: 494,
        // 495 - An expansion of the 400 Bad Request response code, used when the client has provided an invalid client certificate.
        495: "SSL Certificate Error",
        "495_NAME": "SSL_CERTIFICATE_ERROR",
        "495_MESSAGE": "An expansion of the 400 Bad Request response code, used when the client has provided an invalid client certificate.",
        "495_CLASS": e.CLIENT_ERROR,
        SSL_CERTIFICATE_ERROR: 495,
        // 496 - An expansion of the 400 Bad Request response code, used when a client certificate is required but not provided.
        496: "SSL Certificate Required",
        "496_NAME": "SSL_CERTIFICATE_REQUIRED",
        "496_MESSAGE": "An expansion of the 400 Bad Request response code, used when a client certificate is required but not provided.",
        "496_CLASS": e.CLIENT_ERROR,
        SSL_CERTIFICATE_REQUIRED: 496,
        // 497 - An expansion of the 400 Bad Request response code, used when the client has made a HTTP request to a port listening for HTTPS requests.
        497: "HTTP Request Sent to HTTPS Port",
        "497_NAME": "HTTP_REQUEST_SENT_TO_HTTPS_PORT",
        "497_MESSAGE": "An expansion of the 400 Bad Request response code, used when the client has made a HTTP request to a port listening for HTTPS requests.",
        "497_CLASS": e.CLIENT_ERROR,
        HTTP_REQUEST_SENT_TO_HTTPS_PORT: 497,
        // 499 - Used when the client has closed the request before the server could send a response.
        499: "Client Closed Request",
        "499_NAME": "CLIENT_CLOSED_REQUEST",
        "499_MESSAGE": "Used when the client has closed the request before the server could send a response.",
        "499_CLASS": e.CLIENT_ERROR,
        CLIENT_CLOSED_REQUEST: 499
      },
      // ### Cloudflare
      // Cloudflare's reverse proxy service expands the 5xx series of errors space to signal issues with the origin server.
      cloudflare: {
        // 520 - The 520 error is used as a "catch-all response for when the origin server returns something unexpected", listing connection resets, large headers, and empty or invalid responses as common triggers.
        520: "Unknown Error",
        "520_NAME": "UNKNOWN_ERROR",
        "520_MESSAGE": 'The 520 error is used as a "catch-all response for when the origin server returns something unexpected", listing connection resets, large headers, and empty or invalid responses as common triggers.',
        "520_CLASS": e.SERVER_ERROR,
        UNKNOWN_ERROR: 520,
        // 521 - The origin server has refused the connection from Cloudflare.
        521: "Web Server Is Down",
        "521_NAME": "WEB_SERVER_IS_DOWN",
        "521_MESSAGE": "The origin server has refused the connection from Cloudflare.",
        "521_CLASS": e.SERVER_ERROR,
        WEB_SERVER_IS_DOWN: 521,
        // 522 - Cloudflare could not negotiate a TCP handshake with the origin server.
        522: "Connection Timed Out",
        "522_NAME": "CONNECTION_TIMED_OUT",
        "522_MESSAGE": "Cloudflare could not negotiate a TCP handshake with the origin server.",
        "522_CLASS": e.SERVER_ERROR,
        CONNECTION_TIMED_OUT: 522,
        // 523 - Cloudflare could not reach the origin server.
        523: "Origin Is Unreachable",
        "523_NAME": "ORIGIN_IS_UNREACHABLE",
        "523_MESSAGE": "Cloudflare could not reach the origin server.",
        "523_CLASS": e.SERVER_ERROR,
        ORIGIN_IS_UNREACHABLE: 523,
        // 524 - Cloudflare was able to complete a TCP connection to the origin server, but did not receive a timely HTTP response.
        524: "A Timeout Occurred",
        "524_NAME": "A_TIMEOUT_OCCURRED",
        "524_MESSAGE": "Cloudflare was able to complete a TCP connection to the origin server, but did not receive a timely HTTP response.",
        "524_CLASS": e.SERVER_ERROR,
        A_TIMEOUT_OCCURRED: 524,
        // 525 - Cloudflare could not negotiate a SSL/TLS handshake with the origin server.
        525: "SSL Handshake Failed",
        "525_NAME": "SSL_HANDSHAKE_FAILED",
        "525_MESSAGE": "Cloudflare could not negotiate a SSL/TLS handshake with the origin server.",
        "525_CLASS": e.SERVER_ERROR,
        SSL_HANDSHAKE_FAILED: 525,
        // 526 - Cloudflare could not validate the SSL/TLS certificate that the origin server presented.
        526: "Invalid SSL Certificate",
        "526_NAME": "INVALID_SSL_CERTIFICATE",
        "526_MESSAGE": "Cloudflare could not validate the SSL/TLS certificate that the origin server presented.",
        "526_CLASS": e.SERVER_ERROR,
        INVALID_SSL_CERTIFICATE: 526,
        // 527 - Error 527 indicates that the request timed out or failed after the WAN connection had been established.
        527: "Railgun Error",
        "527_NAME": "RAILGUN_ERROR",
        "527_MESSAGE": "Error 527 indicates that the request timed out or failed after the WAN connection had been established.",
        "527_CLASS": e.SERVER_ERROR,
        RAILGUN_ERROR: 527
      }
    }
  }, vu;
}
var B$ = G$();
const Ye = /* @__PURE__ */ kc(B$);
class Me extends Error {
  constructor(r, n) {
    super(r, n);
    $(this, "errorName");
    $(this, "cause");
    this.name = this.constructor.errorName, this.errorName = this.constructor.errorName, (n == null ? void 0 : n.cause) !== void 0 && (this.cause = n.cause), Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(Me, "errorName");
class Qc extends DOMException {
  constructor(r) {
    super(r);
    $(this, "errorName");
    $(this, "name");
    this.name = this.constructor.errorName, this.errorName = this.constructor.errorName, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(Qc, "errorName");
class V$ extends Me {
  constructor(r, n, i, o) {
    super(r, o);
    $(this, "statusCode");
    $(this, "errorCode");
    this.statusCode = n ?? Ye.UNPROCESSABLE_ENTITY, this.errorCode = i ?? -1, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(V$, "errorName", ue.TEServerFailedError);
class W$ extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.UNPROCESSABLE_ENTITY, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(W$, "errorName", ue.ValidationError);
class q$ extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.BAD_REQUEST, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(q$, "errorName", ue.BadRequestError);
class H$ extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.NOT_FOUND, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(H$, "errorName", ue.NotFoundError);
class Y$ extends Me {
  constructor(r, n) {
    super(r ?? "No student object is connected to your user.", n);
    $(this, "statusCode");
    this.statusCode = Ye.BAD_REQUEST, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(Y$, "errorName", ue.NoStudentObjectError);
class Z$ extends Me {
  constructor(r, n) {
    super(r ?? "Unable to create subscription", n);
    $(this, "statusCode");
    this.statusCode = Ye.BAD_REQUEST, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(Z$, "errorName", ue.SubscribeError);
class zo extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.UNPROCESSABLE_ENTITY, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(zo, "errorName", ue.StudentSetGroupConfigurationError);
class J$ extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.UNPROCESSABLE_ENTITY, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(J$, "errorName", ue.AdminConfigurationError);
class K$ extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(K$, "errorName", ue.PacemakerFetchError);
class X$ extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(X$, "errorName", ue.PacemakerResponseError);
class uA extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.FORBIDDEN, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(uA, "errorName", ue.PermissionError);
class Q$ extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(Q$, "errorName", ue.ExternalServiceError);
class eF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.INTERNAL_SERVER_ERROR, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(eF, "errorName", ue.MultiError);
class tF extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(tF, "errorName", ue.RegistrationApiError);
class rF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(rF, "errorName", ue.PopulateCacheBusyError);
class nF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(nF, "errorName", ue.AutoAllocateBusyError);
class iF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(iF, "errorName", ue.CloudJobRunningError);
class oF extends Me {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(oF, "errorName", ue.WorkerInlineFallbackError);
class sF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.REQUEST_TIMEOUT, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(sF, "errorName", ue.WorkerTimeoutError);
class aF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(aF, "errorName", ue.WorkerQueueSaturated);
class uF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = 503, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(uF, "errorName", ue.HeavyLoadError);
class lF extends Qc {
  constructor(r) {
    super(r);
    $(this, "code", 20);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(lF, "errorName", ue.InterruptAbortException);
class cF extends Qc {
  constructor(r) {
    super(r);
    $(this, "code", 20);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(cF, "errorName", ue.UnmountAbortException);
class fF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = 500, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(fF, "errorName", ue.NothingToAllocateError);
class dF extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(dF, "errorName", ue.MaximumMembershipReachedError);
class pF extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(pF, "errorName", ue.MaximumMembershipReachedByTypeError);
class hF extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(hF, "errorName", ue.AddWaitlistError);
class mF extends Me {
  constructor(r, n = Ye.INTERNAL_SERVER_ERROR, i) {
    super(r, i);
    $(this, "statusCode");
    this.statusCode = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(mF, "errorName", ue.ReservationError);
class EF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.SERVICE_UNAVAILABLE, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(EF, "errorName", ue.IssueListCacheError);
class gF extends Me {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(gF, "errorName", ue.HistoryError);
class ef extends Me {
  constructor(r) {
    const n = r.errors.reduce((i, o) => `${i}
${Nt(o)}`, "");
    super(n);
    $(this, "recover", () => location.reload());
    Object.setPrototypeOf(this, new.target.prototype), r.errors.forEach((i) => {
      ye(i) && Object.keys(i).forEach((o) => {
        o !== "message" && (Array.isArray(this[o]) || (this[o] = []), this[o].push(i[o]));
      });
    }), D(r.attemptRecovery) && (this.recover = r.attemptRecovery);
  }
}
$(ef, "errorName", ue.FrontendError);
class yF extends ef {
}
$(yF, "errorName", ue.RegistrationError);
class TF extends ef {
}
$(TF, "errorName", ue.MyScheduleError);
class bF extends Me {
  constructor(r, n) {
    super(r, n);
    $(this, "statusCode");
    this.statusCode = Ye.INTERNAL_SERVER_ERROR, Object.setPrototypeOf(this, new.target.prototype);
  }
}
$(bF, "errorName", ue.EnvError);
function lA({
  courseIds: e,
  group: t,
  mapping: r
}) {
  const n = r.parse("activityType", t), i = cA({
    courseIds: e,
    group: t,
    mapping: r
  });
  return i.success ? {
    success: !0,
    activityType: n
  } : {
    success: !1,
    activityType: n,
    message: i.message,
    issues: i.issues
  };
}
function AF(e, t, r) {
  const n = lA({
    courseIds: e,
    group: t,
    mapping: r
  });
  return n.success ? {
    success: !0,
    data: ml(
      BE(e) ?? -1,
      n.activityType
    )
  } : {
    success: !1,
    message: n.message,
    issues: n.issues,
    data: ml(
      BE(e) ?? -1,
      n.activityType
    )
  };
}
function BE(e) {
  return [...e].sort((t, r) => t - r)[0];
}
function vF({
  courseIds: e,
  groups: t,
  mapping: r
}) {
  const n = [], i = /* @__PURE__ */ new Set();
  for (const s of t) {
    const a = lA({
      courseIds: e,
      group: s,
      mapping: r
    });
    if (!a.success) {
      n.push(a.message);
      continue;
    }
    i.add(a.activityType);
  }
  const o = Array.from(i).sort((s, a) => s.localeCompare(a)).reduce((s, a, l) => l === 0 ? a : `${s} + ${a}`, "");
  return Kc(n) ? {
    success: !1,
    messages: n
  } : {
    success: !0,
    data: ml(e[0], o)
  };
}
function ml(e, t) {
  const r = wj(`${e}${t}`);
  return { courseId: e, activityType: t, id: r };
}
function cA({
  courseIds: e,
  group: t,
  mapping: r
}) {
  let n = {};
  const i = [];
  try {
    fA(e, t);
  } catch (o) {
    const s = lm(o), a = Ls.safeParse(s);
    a.success && (n = {
      ...n,
      ...a.data
    }), i.push(Nt(o));
  }
  try {
    IF(t, r);
  } catch (o) {
    const s = lm(o), a = Ls.safeParse(s);
    a.success && (n = {
      ...n,
      ...a.data
    }), i.push(Nt(o));
  }
  return Mj(n) > 0 ? {
    success: !1,
    message: i.join(`
`),
    issues: n
  } : {
    success: !0
  };
}
function fA(e, t) {
  if (e.length !== 1)
    throw new zo(
      SF(e, t),
      {
        cause: { invalidCourseIds: !0 }
      }
    );
}
function SF(e, t) {
  return `Wrong number of course ids for student set group '${t.id}': expected '1', got '${e.length}': '${e.join(", ")}'.`;
}
function IF(e, t) {
  var i;
  const r = ((i = e == null ? void 0 : e.fields.find(
    (o) => t.getIds("activityType").includes(o.fieldId)
  )) == null ? void 0 : i.values.length) ?? 0;
  if (r !== 1)
    throw new zo(
      `Wrong number of 'activityType' field values for student set group '${e.id}': expected '1', got '${r}'.`,
      {
        cause: { invalidActivityType: !0 }
      }
    );
  const n = t.parse("activityType", e);
  if (!xr(n))
    throw new Error(
      `Missing 'activityType' field value for student set group: '${e.id}'. Value: '${n}'.`,
      {
        cause: { invalidActivityType: !0 }
      }
    );
}
function _F({
  groups: e,
  courseIds: t,
  studentIds: r,
  mapping: n
}) {
  const i = new Set(t), o = new Set(r), s = /* @__PURE__ */ new Map();
  for (const a of e) {
    const l = zn(
      a.relations.flatMap((y) => y.objectIds).filter((y) => i.has(y))
    ), f = a.members.reduce((y, b) => (o.has(b.objectId) && y.push(b.objectId), y), []), u = AF(l, a, n);
    if (!u.success)
      continue;
    const { id: h, courseId: E, activityType: d } = u.data, g = s.get(h);
    if (!D(g)) {
      s.set(h, {
        id: h,
        activityType: d,
        courseId: E,
        students: f,
        groups: [a]
      });
      continue;
    }
    g.groups.push(a), g.students.push(
      ...f.filter(
        (y) => !g.students.includes(y)
      )
    );
  }
  return Array.from(s.values());
}
function RF(e, t) {
  return `${e.parse("activityType", t)} ${e.parse(
    "groupNumber",
    t
  )}`;
}
function OF(e, t) {
  return t.links.length > 0 ? RF(e, t.teObject) : e.parse("groupNumber", t.teObject);
}
function fG(e, t, r) {
  return e.reduce((n, i) => {
    const o = i.relations.reduce(
      (s, { objectIds: a }) => {
        const l = a.filter((f) => t.some(({ id: u }) => u === f));
        return [...s, ...l];
      },
      []
    );
    try {
      fA(o, i);
    } catch (s) {
      return r.warn(
        `[createGroupsWithCourses]: Missconfigured student set group: ${Nt(
          s
        )}`,
        { err: s }
      ), n;
    }
    return [...n, { ...i, courseId: o[0] }];
  }, []);
}
function dG(e) {
  if (!Array.isArray(e))
    return !1;
  const t = e == null ? void 0 : e[0];
  return ye(t) && "id" in t && Je(t.id);
}
function pG(e) {
  return ye(e) && "results" in e;
}
function hG(e) {
  return ye(e) && "objects" in e;
}
function mG(e) {
  return ye(e) && "id" in e && Je(e.id);
}
function EG(e) {
  return "activityId" in e && "object" in e && "id" in e && typeof e.id == "number" && "courseId" in e && typeof e.courseId == "number";
}
function gG(e) {
  return ye(e) && "status" in e && "message" in e && "data" in e && Object.keys(e).length === 3;
}
function yG(e) {
  return ye(e) && "logId" in e;
}
function TG(e, t) {
  return wF(e == null ? void 0 : e.status, t);
}
function wF(e, t) {
  return e !== void 0 && WP[t].some((r) => r === e);
}
function bG(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "bigint";
}
function AG(e) {
  if (!ye(e))
    return !1;
  if (!("from" in e) || e.from === void 0)
    return !0;
  const t = e.from;
  return ye(t) && pt(t.pathname) && (t.search === void 0 || pt(t.search));
}
function dA(e, t, r = console) {
  const n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
  for (const s of e)
    o(s);
  return n;
  function o(s) {
    if (i.has(s)) return;
    i.add(s), n.add(s);
    const a = t.get(s);
    if (!a) {
      r.warn(
        `Could not find the type ${s} in cache. Could not get subtypes for it.`
      );
      return;
    }
    if (Array.isArray(a.subTypes))
      for (const l of a.subTypes)
        o(l);
  }
}
function vG({
  cachedTypes: e,
  object: t,
  objectTypes: r,
  typeId: n,
  logger: i
}) {
  if (!D(n))
    return !0;
  const o = xe(n) ? n : [n];
  if (o.length === 0 || pA.some((f) => o.includes(f)))
    return !0;
  const s = dA(o, e, i), a = r.get(t.id);
  if (!D(a))
    return l(t.types.length, t.types);
  return l(t.types.length, a);
  function l(f, u) {
    return f > 0 && u.some((h) => s.has(h));
  }
}
const pA = [0, 1];
function NF(e) {
  return !D(e) || pA.includes(e);
}
function SG(e) {
  return D(e) ? tj(e) ? [um(e)] : xe(e) ? e.map(um) : [0] : [0];
}
function IG(e) {
  return (e == null ? void 0 : e.reduce((t, r) => {
    const n = r.fields.map((i) => i.fieldId).filter(D);
    return ob(t, n);
  }, [])) ?? [];
}
function CF(e) {
  const t = _e(e), r = x$(t.replaceAll("%", "")), n = t.includes("%");
  return { size: r, isPercent: n };
}
function PF(e) {
  let t = { kind: "none", data: void 0 };
  try {
    if (xF(e)) {
      const { dist: r, ...n } = e;
      t = n;
    } else if (kF(e))
      t = e.dedi;
    else
      return { kind: "none", data: void 0 };
    if (t.kind === "category") {
      const r = t.data.reduce(
        (n, i) => (Rj(i) && n.push({ id: i.id, value: i.value }), n),
        []
      );
      return r.length === 0 ? { kind: "none", data: void 0 } : { kind: "category", data: r };
    }
    if (t.kind === "relation") {
      const r = t.data.reduce(
        (n, i) => (Oj(i) && n.push({ id: i.id }), n),
        []
      );
      return r.length === 0 ? { kind: "none", data: void 0 } : { kind: "relation", data: r };
    }
    return { kind: "none", data: void 0 };
  } catch {
    return { kind: "none", data: void 0 };
  }
}
function DF(e) {
  const t = _e(e);
  try {
    let r = e;
    xr(t) && (r = JSON.parse(t));
    const n = PF(r), i = MF(r), o = {
      dedi: n,
      dist: i
    };
    return uP.validate(o) ? {
      dedi: n,
      dist: i
    } : {
      dedi: { kind: "none", data: void 0 },
      dist: { k: Kr.NONE }
    };
  } catch {
    return {
      dedi: { kind: "none", data: void 0 },
      dist: { k: Kr.NONE }
    };
  }
}
function MF(e) {
  let t = { k: Kr.NONE };
  if (LF(e)) {
    const r = { ...e.dist };
    r.k !== Kr.NONE && Array.isArray(r.v) && (r.v = r.v[0]);
    const n = lT.safeParse(
      r
    );
    n.success && (t = n.data);
  }
  return t;
}
function LF(e) {
  return ye(e) && "dist" in e;
}
function xF(e) {
  return !(ye(e) && "dedi" in e);
}
function kF(e) {
  return ye(e) && "dedi" in e && "dist" in e;
}
function jF(e) {
  if (D(e) && D(e.range) && D(e.range.start) && D(e.range.end))
    return {
      startDate: e.range.start,
      endDate: e.range.end
    };
}
function _G(e) {
  const t = e != null && e.currentPeriod ? Lj(e.currentPeriod) : {}, r = D(t.fields) ? aA(Object.keys(t.fields)) : [];
  return {
    ...e,
    current: t,
    dateRange: jF(t),
    currentFieldIds: r
  };
}
const UF = 0;
function Ys(e) {
  return (t) => Je(t) ? [t] : xe(t) ? t : e(t);
}
function tf(e, t) {
  return Je(e) ? e : xe(e) ? e[0] : t(e)[0];
}
function hA(e) {
  return (t, r) => {
    const n = (o) => {
      var a;
      const s = (a = r.fields.find((l) => l.fieldId === o)) == null ? void 0 : a.values;
      return xe(s) ? s : D(s) ? [s] : [];
    }, i = [];
    for (const o of t) {
      const s = e.fields.get(o);
      if (s != null && s.referenceFields.length) {
        const l = s.referenceFields.map(n), u = n(s.id).concat(l.map((h) => _e(h))).filter((h) => !!h).join(s.refSeparator ?? " ");
        u && i.push(u);
        continue;
      }
      const a = n(o);
      D(a) && (xe(a) ? i.push(...a) : i.push(a));
    }
    return i;
  };
}
function mA(e, t, r) {
  const n = hA(e);
  return (i, o) => {
    if (xc(o) && zs(o.object))
      return a(o.object);
    if (zs(o))
      return a(o);
    const s = r[i];
    return s(o);
    function a(l) {
      try {
        const f = t.getIds(i), u = r[i];
        return u(n(f, l));
      } catch {
        const f = r[i];
        return f(void 0);
      }
    }
  };
}
function rf(e, t, r) {
  const n = hA(e);
  return (i, o) => {
    if (xc(o) && zs(o.object))
      return s(o.object);
    if (zs(o))
      return s(o);
    return _e(o);
    function s(a) {
      try {
        const l = Je(i) ? [i] : t.getIds(i);
        return _e(n(l, a));
      } catch {
        return _e(void 0);
      }
    }
  };
}
function Qo(e) {
  return (t) => {
    const r = xe(t) ? t : e.getIds(t);
    return r.length === 0 ? !1 : r.every((n) => n !== UF);
  };
}
function nf(e, t) {
  const r = Zn(e, t);
  return (n, i) => {
    const o = t.getTypeIds(n);
    let s = [];
    if (!D(i) || !Je(i) && !xe(i) && !sm(i))
      return !1;
    Je(i) && (s = [i]), sm(i) && (s = i.types), xe(i) && (s = i);
    const a = r(o), l = r(s);
    for (const f of l)
      if (a.has(f))
        return !0;
    return !1;
  };
}
function $F(e, t) {
  const r = nf(e, t);
  return (n) => (i) => r(n, i);
}
function Zn(e, t) {
  return (r) => {
    const n = xe(r) ? r : t.getIds(r);
    return dA(n, e.types, e.logger);
  };
}
function EA(e, t) {
  const r = Zn(e, t), n = /* @__PURE__ */ new Map();
  return (i) => {
    const o = t.getIds(i);
    if (o.length === 0) return [];
    const s = [];
    for (const a of e.fields.values()) {
      let l = n.get(a.id);
      D(l) || (l = r(a.types), n.set(a.id, l)), o.some((f) => l == null ? void 0 : l.has(f)) && s.push(a);
    }
    return s;
  };
}
function FF(e, t) {
  const r = Qo(t);
  return (n) => {
    var s;
    const i = tf(n, t.getIds);
    if (!D(i))
      return `UnknownType[${String(n)} (${i})]`;
    if (!r([i]))
      return `MissingTypeMapping[${String(n)} (${i})]`;
    if (!D(e.types))
      return (s = e.logger) == null || s.warn(
        "Trying to use mapping.typename with mapping instance that has not been initialized with types."
      ), `MissingTypeName[${String(n)} (${i})]`;
    const o = e.types.get(i);
    return D(o) ? o.name : `UnknownType[${String(n)} (${i})]`;
  };
}
function gA(e, t) {
  const r = Qo(t);
  return (n) => {
    const i = tf(n, t.getIds);
    if (!D(i))
      return `UnknownFieldName[${String(n)} (${i})]`;
    if (!r([i]))
      return `MissingFieldMapping[${String(n)} (${i})]`;
    const o = e.fields.get(i);
    return D(o) ? o.name : `UnknownField[${String(n)} (${i})]`;
  };
}
function yA(e, t) {
  const r = Qo(t);
  return (n) => {
    const i = tf(n, t.getIds);
    if (!D(i) || !r([i]))
      return;
    const o = e.fields.get(i);
    if (D(o))
      return o.mandatory ? i : void 0;
  };
}
function zF(e, t) {
  return (r) => {
    var i;
    const n = t.getIds(r);
    return n.length === 0 ? [] : zn(
      (i = e.mappingData) == null ? void 0 : i.objectTypes.filter(
        (o) => D(o.objectTypeId) && n.includes(o.objectTypeId)
      ).flatMap((o) => o.fields).map((o) => o.fieldId).filter(Je)
    );
  };
}
function GF(e, t) {
  return (r) => {
    var i;
    const n = t.getIds(r);
    return n.length === 0 ? [] : zn(
      (i = e.mappingData) == null ? void 0 : i.objectTypes.filter(
        (o) => D(o.objectTypeId) && n.includes(o.objectTypeId)
      ).flatMap((o) => o.fields).filter((o) => o.isSearchable).map((o) => o.fieldId).filter(Je)
    );
  };
}
function BF(e) {
  return ye(e) && "objectTypeGroup" in e;
}
function El(e, t) {
  var r;
  return typeof t == "string" ? (r = e[t]) == null ? void 0 : r.props : BF(t) ? t : void 0;
}
function VF(e, t) {
  const r = Ys((i) => {
    var a;
    const o = El(t, i);
    if (!D(o))
      return [];
    if (!("appProperty" in o)) {
      const l = (a = e.lookup.objectTypes) == null ? void 0 : a[o.objectTypeGroup];
      return D(l) ? l.map((f) => f.objectTypeId).filter(D) : [];
    }
    const s = e.lookup.fields[`${o.objectTypeGroup}-${o.appProperty}`];
    return D(s) ? zn(s.flatMap((l) => l.fieldIds)) : [];
  }), n = Ys((i) => {
    var a;
    const o = El(t, i);
    if (!D(o))
      return [];
    const s = "appProperty" in o ? e.lookup.fields[`${o.objectTypeGroup}-${o.appProperty}`] : (a = e.lookup.objectTypes) == null ? void 0 : a[o.objectTypeGroup];
    return D(s) ? zn(s.map((l) => l.objectTypeId).filter(D)) : [];
  });
  return { getIds: r, getTypeIds: n };
}
function WF(e) {
  return (t) => {
    const r = El(e, t);
    return D(r) ? "appProperty" in r ? `${r.objectTypeGroup}-${r.appProperty}` : `${r.objectTypeGroup}` : "NONE";
  };
}
function qF(e) {
  return (t) => {
    var n;
    const r = (n = e.lookup.objectTypesById[t]) == null ? void 0 : n.map(
      (i) => i.key
    );
    return D(r) ? r : [];
  };
}
function HF(e) {
  return (t) => {
    var n;
    const r = (n = e.lookup.fieldsById[t]) == null ? void 0 : n.map((i) => i.key);
    return D(r) ? r : [];
  };
}
function YF(e, t) {
  const r = Zn(e, t);
  return (n, i) => {
    const o = e.mappingData.objectTypes.find((a) => {
      if (!D(a.objectTypeId)) return !1;
      if (n.types.includes(a.objectTypeId)) return !0;
      const l = r([a.objectTypeId]);
      return D(n.types.find((f) => l.has(f)));
    }), s = o == null ? void 0 : o.fields.filter((a) => a.appProperty === i).map((a) => a.fieldId).filter(D);
    if (!D(s) || !Kc(s))
      throw new Error(
        `Missing mapping in Admin. ${i} is not mapped for ${o == null ? void 0 : o.objectTypeExtId} ${n.types}.`
      );
    return s;
  };
}
function ZF(e) {
  return ({
    shorthandOrTypes: t,
    object: r
  }) => {
    const n = xe(t) ? t : e.getIds(t);
    if (!D(r)) return n[0];
    const i = Kk(n, r.types);
    return i.length > 0 ? i[0] : r.types[0];
  };
}
function JF(e, t) {
  const r = Zn(e, t);
  return ({
    maxLevelsDeep: n,
    object: i
  }) => {
    const o = /* @__PURE__ */ new Set();
    return e.memberTypes.forEach((s) => {
      const a = /* @__PURE__ */ new Set();
      let l = -1;
      for (const f of s.memberTypes) {
        if (!D(f.type)) continue;
        const u = Je(f.type) ? f.type : parseInt(f.type, 10);
        if (o.has(u)) continue;
        const h = r([
          u
        ]), E = i.types.some(
          (d) => h.has(d)
        );
        a.add({
          memberLevel: f.memberLevel,
          type: u
        }), f.memberLevel > 0 && E && (l = Math.max(l, f.memberLevel));
      }
      l !== -1 && a.forEach((f) => {
        f.memberLevel < l && l - f.memberLevel <= n && o.add(f.type);
      });
    }), o;
  };
}
function VE(e, t) {
  return Object.keys(e).find((r) => e[r].key === t);
}
function KF(e, t) {
  var n;
  const r = {
    objectTypes: {},
    fields: {},
    objectTypesById: {},
    fieldsById: {}
  };
  for (const i of t)
    if (D(i.applicationObjectTypeGroup)) {
      const o = i.applicationObjectTypeGroup, s = i.objectTypeId;
      D(r.objectTypes[o]) || (r.objectTypes[o] = []);
      const a = {
        objectTypeId: s === null ? void 0 : s,
        key: o,
        shorthand: VE(e, o)
      };
      D(s) && r.objectTypes[o].unshift(a), D(s) && (D(r.objectTypesById[s]) ? r.objectTypesById[s].unshift(a) : r.objectTypesById[s] = [a]);
      for (const l of i.fields)
        if (D(l.appProperty) && l.appProperty !== "NONE") {
          const f = i.objectTypeId, u = `${o}-${l.appProperty}`, h = D(l.fieldId) ? [l.fieldId] : [];
          D(r.fields[u]) || (r.fields[u] = []);
          const E = {
            fieldIds: h,
            objectTypeId: f === null ? void 0 : f,
            objectTypeKey: o,
            key: u,
            shorthand: VE(e, u)
          }, d = (n = r.fields[u]) == null ? void 0 : n.find(
            (g) => g.objectTypeId === f
          );
          D(d) ? d.fieldIds = ob(d.fieldIds, h) : r.fields[u].unshift(E);
          for (const g of h) {
            const y = {
              objectTypeKey: E.objectTypeKey,
              key: E.key,
              shorthand: E.shorthand,
              objectTypeId: E.objectTypeId
            };
            D(r.fieldsById[g]) ? r.fieldsById[g].unshift(y) : r.fieldsById[g] = [y];
          }
        }
    }
  return r;
}
function XF({
  parsers: e,
  config: t,
  logger: r = console
}) {
  return ({
    mappingData: n,
    fields: i,
    types: o,
    memberTypes: s
  }) => {
    const a = {
      mappingData: n,
      fields: new Map(i.map((f) => [f.id, f])),
      types: new Map(o.map((f) => [f.id, f])),
      memberTypes: new Map(s.map((f) => [f.id, f])),
      logger: r,
      lookup: KF(t, n == null ? void 0 : n.objectTypes)
    }, l = VF(a, t);
    return {
      includeFields: zF(a, l),
      searchableFields: GF(a, l),
      isMapped: Qo(l),
      getIds: l.getIds,
      typeCheck: nf(a, l),
      makeTypeCheck: $F(a, l),
      getParentMemberTypes: JF(a, l),
      getTypesWithSubtypes: Zn(a, l),
      getMatchingObjectType: ZF(l),
      typename: FF(a, l),
      fieldname: gA(a, l),
      getMandatoryField: yA(a, l),
      getFieldsByType: EA(a, l),
      getKey: WF(t),
      getObjectTypeKeysById: qF(a),
      getFieldKeysById: HF(a),
      parse: mA(a, l, e),
      string: rf(a, l),
      fieldsToWriteTo: YF(a, l),
      store: a
    };
  };
}
function of(e, t) {
  return `${e}[${t}]`;
}
function WE(e, t) {
  const r = /^(.+)\[(\d+)\]$/.exec(t);
  if (!r) return e.lookup[t];
  const n = e.lookup[r[1]];
  return n == null ? void 0 : n.entries[Number(r[2])];
}
function TA(e) {
  if (!D(e)) return [];
  switch (e.kind) {
    case "reservation":
    case "object-field":
      return [e.fieldId];
    case "list":
      return e.entries.flatMap(TA);
    case "text":
    case "unmapped":
      return [];
    default:
      return mt();
  }
}
function Ra(e, t, r) {
  const n = e.lookup[t];
  return (n == null ? void 0 : n.kind) === "list" ? n.entries.map(
    (i, o) => r(i, of(t, o))
  ) : r(n, t);
}
function _o(e, t) {
  return (r, ...n) => {
    const i = typeof r == "string" ? e.lookup[r] : void 0;
    return (i == null ? void 0 : i.kind) === "list" ? i.entries.map(
      (o, s) => t(of(r, s), ...n)
    ) : t(r, ...n);
  };
}
const qE = {
  "module.name": (e) => {
    var t;
    return { defaultName: "Name", value: (t = e.module) == null ? void 0 : t.name };
  },
  "module.code": (e) => {
    var t;
    return { defaultName: "Code", value: (t = e.module) == null ? void 0 : t.code };
  },
  "location.room": (e) => {
    var t;
    return { defaultName: "Room", value: (t = e.location) == null ? void 0 : t.room };
  },
  "location.building": (e) => {
    var t;
    return {
      defaultName: "Building",
      value: (t = e.location) == null ? void 0 : t.building
    };
  },
  "location.campus": (e) => {
    var t;
    return {
      defaultName: "Campus",
      value: (t = e.location) == null ? void 0 : t.campus
    };
  },
  "location.type": (e) => {
    var t;
    return { defaultName: "Type", value: (t = e.location) == null ? void 0 : t.type };
  },
  "location.map": (e) => {
    var t;
    return { defaultName: "Map URL", value: (t = e.location) == null ? void 0 : t.map };
  },
  "location.image": (e) => {
    var t;
    return {
      defaultName: "Picture URL",
      value: (t = e.location) == null ? void 0 : t.image
    };
  },
  "location.equipment": (e) => {
    var t;
    return {
      defaultName: "Equipment",
      value: (t = e.location) == null ? void 0 : t.equipment
    };
  },
  "location.onlineMeetingLink": (e) => {
    var t;
    return {
      defaultName: "Online meeting link",
      value: (t = e.location) == null ? void 0 : t.onlineMeetingLink
    };
  },
  "digitalResources.recording": (e) => {
    var t;
    return {
      defaultName: "Recording",
      value: (t = e.digitalResources) == null ? void 0 : t.recording
    };
  },
  "digitalResources.lmsLink": (e) => {
    var t;
    return {
      defaultName: "Learning management system link",
      value: (t = e.digitalResources) == null ? void 0 : t.lmsLink
    };
  },
  "staff.name": (e) => {
    var t;
    return { defaultName: "Name", value: (t = e.staff) == null ? void 0 : t.name };
  },
  "activity.displayName": (e) => {
    var t;
    return {
      defaultName: "Display name",
      value: (t = e.activity) == null ? void 0 : t.displayName
    };
  },
  "activity.alternativeTitle": (e) => {
    var t;
    return {
      defaultName: "Alternative title",
      value: (t = e.activity) == null ? void 0 : t.alternativeTitle
    };
  },
  messageToStudent: (e) => ({
    defaultName: "Message",
    value: e.messageToStudent
  })
}, HE = {
  extraFields: (e) => e.extraFields,
  "location.extraFields": (e) => {
    var t;
    return (t = e.location) == null ? void 0 : t.extraFields;
  }
};
function YE(e, t) {
  const r = {
    displayName: t == null ? void 0 : t.displayName,
    defaultName: e
  }, n = { ...r, kind: "unmapped", text: "" };
  if (!D(t))
    return n;
  switch (t.type) {
    case "unmapped":
      return n;
    case "text":
      return { ...r, kind: "text", text: t.value };
    case "reservation":
      return { ...r, kind: "reservation", fieldId: Number(t.value) };
    case "object-field": {
      const [i, o] = t.value.split("-").map(Number);
      return { ...r, kind: "object-field", typeId: i, fieldId: o };
    }
    default:
      return mt();
  }
}
function QF(e) {
  return (t) => Ra(e, t, (r, n) => {
    const i = r == null ? void 0 : r.displayName;
    if (i)
      return i;
    const o = r == null ? void 0 : r.defaultName;
    return o || (e.logger.warn(
      `[reservationMapping.displayname] Could not find settings for '${n}'`
    ), `MissingDisplayName[${n}]`);
  });
}
function ez(e, t) {
  const r = Qo(t);
  return (n) => Ra(e, n, (i, o) => {
    switch (i == null ? void 0 : i.kind) {
      case "object-field":
      case "reservation":
        return r(o);
      case "text":
        return !!(i != null && i.text);
      case "unmapped":
      case void 0:
        return !1;
      default:
        return mt();
    }
  });
}
function bA(e) {
  if (!D(e)) return [];
  switch (e.kind) {
    case "object-field":
      return [e.typeId];
    case "list":
      return e.entries.flatMap(bA);
    case "reservation":
    case "text":
    case "unmapped":
      return [];
    default:
      return mt();
  }
}
function gl(e, t) {
  switch (e == null ? void 0 : e.kind) {
    case "reservation":
      return t.reservation;
    case "object-field":
      return t.object;
    case "text":
      return e == null ? void 0 : e.text;
    case "unmapped":
    case void 0:
      return;
    default:
      return mt();
  }
}
function tz(e, t, r) {
  const n = mA(e, t, r), i = rf(e, t);
  return (o, s) => {
    const a = e.lookup[o];
    return (a == null ? void 0 : a.kind) === "list" ? a.entries.map(
      (l, f) => i(of(o, f), gl(l, s))
    ) : n(
      o,
      gl(a, s)
    );
  };
}
function rz(e, t, r) {
  const n = rf(e, t);
  return (i, o) => Ra(
    e,
    i,
    (s, a) => n(a, gl(s, o))
  );
}
function nz(e, t) {
  const r = Zn(e, t);
  return () => r(Array.from(e.mappedTypes));
}
function iz(e) {
  return () => e.mappedTypes.size > 0;
}
function oz(e) {
  return (t) => Ra(e, t, (r) => r == null ? void 0 : r.kind);
}
function sz(e) {
  const t = {};
  for (const r of Object.keys(
    qE
  )) {
    const n = qE[r](e), i = n.defaultName, o = n.value;
    t[r] = YE(i, o);
  }
  for (const r of Object.keys(
    HE
  ))
    t[r] = {
      kind: "list",
      defaultName: "Extra fields",
      entries: (HE[r](e) ?? []).map(
        (n) => YE(n.label, n)
      )
    };
  return t;
}
function az(e) {
  const t = /* @__PURE__ */ new Set(), r = (n) => {
    (n == null ? void 0 : n.kind) === "object-field" && t.add(n.typeId), (n == null ? void 0 : n.kind) === "list" && n.entries.forEach(r);
  };
  return Object.values(e).forEach(r), t;
}
function uz(e) {
  const t = Ys(
    (n) => TA(WE(e, n))
  ), r = Ys(
    (n) => bA(WE(e, n))
  );
  return { getIds: t, getTypeIds: r };
}
function RG({
  parsers: e,
  logger: t = console
}) {
  return ({ settings: r, fields: n, types: i }) => {
    const o = sz(r), s = {
      fields: n,
      types: i,
      logger: t,
      lookup: o,
      settings: r,
      mappedTypes: az(o)
    }, a = uz(s), l = _o(s, nf(s, a));
    return {
      isMapped: ez(s, a),
      getIds: _o(s, a.getIds),
      typeCheck: l,
      makeTypeCheck: (f) => (u) => l(f, u),
      fieldname: _o(s, gA(s, a)),
      displayname: QF(s),
      getMandatoryField: _o(s, yA(s, a)),
      getFieldsByType: _o(s, EA(s, a)),
      hasObjectFieldMappings: iz(s),
      getTypesWithSubtypes: Zn(s, a),
      getAllTypesWithSubtypes: nz(s, a),
      kind: oz(s),
      parse: tz(s, a, e),
      string: rz(s, a),
      store: s
    };
  };
}
const lz = {
  activityType: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.ACTIVITY_TYPE,
      requiredMandatory: !0
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.ACTIVITY_TYPE}`,
    required: !0
  },
  buffer: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.BUFFER
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.BUFFER}`,
    required: !1
  },
  changeRequestName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.CHANGE_REQUEST,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.CHANGE_REQUEST}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  course: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE },
    key: `${C.EApplicationObjectTypeGroup.COURSE}`,
    required: !0
  },
  courseTitle: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      appProperty: C.EAppProperties.TITLE,
      requiredMandatory: !0
    },
    key: `${C.EApplicationObjectTypeGroup.COURSE}-${C.EAppProperties.TITLE}`,
    required: !0
  },
  courseLabel: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      appProperty: C.EAppProperties.LABEL,
      requiredMandatory: !0
    },
    key: `${C.EApplicationObjectTypeGroup.COURSE}-${C.EAppProperties.LABEL}`,
    required: !0
  },
  allocationRules: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.DEDICATETRACK
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.DEDICATETRACK}`,
    required: !1
  },
  endDate: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.END_DATE
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.END_DATE}`,
    required: !0
  },
  hideGroup: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.HIDETRACK
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.HIDETRACK}`,
    required: !1
  },
  maxStudents: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.MAX_STUDENTS,
      requiredConfiguration: {
        memberMaxCount: !0,
        memberMaxType: !0
      }
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.MAX_STUDENTS}`,
    required: !0
  },
  program: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.PROGRAM },
    key: `${C.EApplicationObjectTypeGroup.PROGRAM}`,
    required: !1
  },
  programName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.PROGRAM,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.PROGRAM}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  room: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM },
    key: `${C.EApplicationObjectTypeGroup.ROOM}`,
    required: !1
  },
  changeRequest: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.CHANGE_REQUEST },
    key: `${C.EApplicationObjectTypeGroup.CHANGE_REQUEST}`,
    required: !1
  },
  roomName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  roomSize: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.SEATS
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.SEATS}`,
    required: !1
  },
  roomBuilding: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.BUILDING
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.BUILDING}`,
    required: !1
  },
  roomCampus: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.CAMPUS
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.CAMPUS}`,
    required: !1
  },
  roomType: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      appProperty: C.EAppProperties.ROOM_TYPE
    },
    key: `${C.EApplicationObjectTypeGroup.ROOM}-${C.EAppProperties.ROOM_TYPE}`,
    required: !1
  },
  semester: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      appProperty: C.EAppProperties.SEMESTER
    },
    key: `${C.EApplicationObjectTypeGroup.COURSE}-${C.EAppProperties.SEMESTER}`,
    required: !1
  },
  staff: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.STAFF },
    key: `${C.EApplicationObjectTypeGroup.STAFF}`,
    required: !0
  },
  staffName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STAFF,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.STAFF}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  startDate: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.START_DATE
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.START_DATE}`,
    required: !0
  },
  student: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT },
    key: `${C.EApplicationObjectTypeGroup.STUDENT}`,
    required: !0
  },
  studentName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT}-${C.EAppProperties.LABEL}`,
    required: !0
  },
  group: {
    kind: "objectType",
    props: { objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}`,
    required: !0
  },
  groupName: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.LABEL
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.LABEL}`,
    required: !1
  },
  groupNumber: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.TRACK
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.TRACK}`,
    required: !0
  },
  courseOccurance: {
    kind: "field",
    props: {
      objectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      appProperty: C.EAppProperties.COURSE_OCCURENCE
    },
    key: `${C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP}-${C.EAppProperties.COURSE_OCCURENCE}`,
    required: !1
  }
}, cz = {
  activityType: Io,
  buffer: CF,
  changeRequestName: _e,
  courseLabel: Io,
  courseTitle: Io,
  allocationRules: DF,
  endDate: _e,
  hideGroup: k$,
  maxStudents: FE,
  programName: _e,
  roomName: _e,
  roomSize: FE,
  roomBuilding: _e,
  roomCampus: _e,
  roomType: _e,
  semester: _e,
  staffName: _e,
  startDate: _e,
  studentName: Io,
  groupName: _e,
  groupNumber: Io,
  courseOccurance: _e
}, OG = {
  "module.name": _e,
  "module.code": _e,
  "location.room": _e,
  "location.building": _e,
  "location.campus": _e,
  "location.type": _e,
  "location.map": _e,
  "location.image": _e,
  "location.equipment": M$,
  "location.onlineMeetingLink": _e,
  "digitalResources.recording": _e,
  "digitalResources.lmsLink": _e,
  "staff.name": _e,
  "activity.displayName": _e,
  "activity.alternativeTitle": _e,
  messageToStudent: _e
};
function wG(e) {
  return aA(Object.keys(e));
}
function NG(e) {
  return Array.from(
    new Set(
      Object.values(e).reduce((t, r) => (D(r) && t.push(...r), t), [])
    )
  );
}
function fz(e) {
  const t = {};
  for (const { students: r, groups: n } of e)
    r.forEach((i) => {
      D(t[i]) || (t[i] = []);
      const o = new Set(t[i]);
      n.forEach((s) => {
        o.add(s);
      }), t[i] = [...o];
    });
  return t;
}
function CG(e) {
  const t = [];
  for (const r of e.solution.assignments)
    t.push({
      students: r.students,
      groups: [r.studentSetGroupId]
    });
  return fz(t);
}
function PG(e, t) {
  return D(t) ? t.members.some((r) => r.objectId === e) : !1;
}
function sf(e) {
  return e.reduce((t, r) => (t[r.id] = r, t), {});
}
function DG(e) {
  return new Map(e.map((t) => [t.id, t]));
}
function MG(e, t) {
  const r = [], n = {};
  for (const i of t) {
    const o = e[i];
    D(o) ? n[i] = o : r.push(i);
  }
  return {
    missingIds: r,
    existing: n
  };
}
function LG(e, t) {
  return `${t.parse("courseLabel", e)} ${t.parse(
    "courseTitle",
    e
  )}`;
}
function dz(e) {
  return D(e) && e === 0;
}
function xG(e) {
  var r, n;
  const t = {};
  for (const i in e)
    t[i] = {
      completed: dz(
        (n = (r = e[i]) == null ? void 0 : r.incompleteStudents) == null ? void 0 : n.length
      )
    };
  return t;
}
function kG(e, t) {
  const r = [];
  for (const n in e) {
    const i = e[n];
    D(i) && r.push({
      title: t.parse("courseTitle", i.object),
      label: t.parse("courseLabel", i.object),
      id: i.object.id
    });
  }
  return r.sort((n, i) => n.label.localeCompare(i.label));
}
function pz(e) {
  return e.filter(
    (t) => D(t.categories) && t.categories.length > 0
  );
}
function jG(e, t) {
  const n = pz(t).find((i) => i.id === e);
  return (n == null ? void 0 : n.name) || `Missing field[${e}]`;
}
function hz(e, t) {
  return t.map((r) => ({ fieldId: r, values: [e] }));
}
function UG(e, t, r, n) {
  var s;
  const i = r.fieldsToWriteTo(e, n);
  if (!Kc(i)) return [];
  const o = (s = e == null ? void 0 : e.fields) == null ? void 0 : s.find((a) => i.includes(a.fieldId));
  return D(o) && D(o.values[0]) && (o == null ? void 0 : o.values[0]) === t ? [] : hz(t, i);
}
const mz = "MMM";
class Mn {
  /**
   * @param collection - A list of numbers to format into a shortened range string
   * @returns A formatted string where consecutive numbers are collapsed into ranges, e.g. [1,2,3,4,7,8,9] becomes "1-4, 7-9"
   */
  static pairPresent(t) {
    const r = t.sort((o, s) => o - s), n = Mn.pair(r);
    return n.reduce((o, s, a) => {
      if (s.length === 0)
        return o;
      if (s.length === 2)
        return a === n.length - 1 ? [...o, s[0].toString(), "-", s[1].toString()] : [...o, s[0].toString(), "-", s[1].toString(), ", "];
      {
        const l = [...o, s[0].toString()];
        return a === n.length - 1 ? [...l, ""] : [...l, ", "];
      }
    }, []).join("");
  }
  /**
   * @param collection - A sorted list of numbers to group into pairs
   * @returns An array of number arrays where each sub-array represents a range (start and end) or a single value
   */
  static pair(t) {
    return Mn.pairFromArray(t);
  }
  /**
   * @param array - A sorted array of numbers to group into consecutive ranges
   * @returns An array of number arrays where consecutive numbers are grouped as [start, end] pairs
   */
  static pairFromArray(t) {
    const r = [];
    let n = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = i > 0 ? t[i - 1] : -10, a = i + 1 < t.length ? t[i + 1] : -10;
      s + 1 === o && o + 1 === a || (s + 1 === o ? (n.push(o), n = []) : (n = [o], r.push(n)));
    }
    return r;
  }
  /**
   * @param timestamp - A unix timestamp to extract month and day from
   * @returns An object with the abbreviated month name and day of month
   */
  static formatDay(t) {
    const r = Lr.unix(t);
    return { month: r.format(mz), day: r.date() };
  }
  /**
   * @param days - A set of unix timestamps representing individual days
   * @returns A formatted string listing all days grouped by month with a count suffix, e.g. "Jan 5, 6, Feb 1 (x3)"
   */
  static daysPresent(t) {
    if (t.size === 0) return "";
    const r = [...t].sort((o, s) => o - s);
    let n = "";
    const i = [];
    for (const o of r) {
      const { month: s, day: a } = Mn.formatDay(o);
      s !== n ? (n = s, i.push(`${s} ${a}`)) : i.push(`${a}`);
    }
    return `${i.join(", ")} (x${r.length})`;
  }
  /**
   * @param days - A set of unix timestamps representing individual days
   * @param showCount - Whether to append a count suffix like "(x4)". Defaults to true.
   * @returns A formatted string showing the date range from first to last day, e.g. "Jan 5-12 (x4)" or "Jan 5-12"
   */
  static daysRangePresent(t, r = !0) {
    const n = Mn.daysRange(t);
    if (!n) return "";
    const i = Mn.formatDay(n.startDay), o = Mn.formatDay(n.endDay), s = r ? ` (x${n.count})` : "";
    return n.startDay === n.endDay ? `${i.month} ${i.day}${s}` : i.month === o.month ? `${i.month} ${i.day}-${o.day}${s}` : `${i.month} ${i.day} - ${o.month} ${o.day}${s}`;
  }
  /**
   * @param days - A set of unix timestamps representing individual days
   * @returns The first day, last day, and total count, or undefined if the set is empty
   */
  static daysRange(t) {
    if (t.size === 0) return;
    const r = [...t].sort((o, s) => o - s), n = r[0], i = r[r.length - 1];
    return { startDay: n, endDay: i, count: r.length };
  }
}
function Ez(e) {
  return D(e.begin) && D(e.end);
}
function $G({
  mapping: e,
  objects: t,
  typeIds: r
}) {
  if (r != null && r.some(NF))
    return t;
  const n = e.getTypesWithSubtypes(r ?? []);
  return t == null ? void 0 : t.filter((i) => n.has(i.typeId));
}
function ZE({
  objects: e,
  reservations: t,
  mapping: r
}) {
  const n = sf(t), i = gz({
    reservations: t
  }), o = {}, s = /* @__PURE__ */ new Map();
  for (const l of e) {
    const f = l.id, u = l.members.map((b) => b.objectId), h = /* @__PURE__ */ new Map(), E = r.getTypesWithSubtypes(l.types), g = r.typeCheck("group", l) ? /* @__PURE__ */ new Set() : r.getParentMemberTypes({
      object: l,
      maxLevelsDeep: 1
    }), y = (b, I) => {
      var w, P;
      const S = i.get(I);
      if (D(S) && b.size !== 0)
        for (const _ of S) {
          const v = n[_];
          if (!D(v)) continue;
          const M = (w = v.objects) == null ? void 0 : w.find(
            (z) => z.objectId === I
          );
          if (!D(M)) continue;
          const x = r.getTypesWithSubtypes([
            M.typeId
          ]);
          for (const z of x)
            b.has(z) && (h.set(_, v), s.has(_) || s.set(_, /* @__PURE__ */ new Set()), (P = s.get(_)) == null || P.add(f));
        }
    };
    y(E, f);
    for (const b of u)
      y(g, b);
    o[f] = Array.from(
      h.values()
    );
  }
  const a = {};
  for (const [l, f] of s)
    a[l] = Array.from(f);
  return { objectWithReservations: o, reservationWithObjectIds: a };
}
function gz({
  reservations: e
}) {
  const t = /* @__PURE__ */ new Map();
  for (const r of e)
    for (const n of r.objects ?? []) {
      const i = t.get(n.objectId);
      D(i) ? i.add(r.id) : t.set(n.objectId, /* @__PURE__ */ new Set([r.id]));
    }
  return t;
}
function FG(e) {
  const t = /* @__PURE__ */ new Map();
  for (const [r, n] of e)
    for (const i of n) {
      const o = t.get(i);
      o ? o.push(r) : t.set(i, [r]);
    }
  return t;
}
function zG({
  allocationResult: e,
  studentSetGroupLookup: t,
  courseLookup: r,
  mapping: n
}) {
  var s;
  const i = [], o = e.failedGroups;
  for (const a in o)
    (s = o[a]) == null || s.forEach((l) => {
      var y, b, I;
      const f = r[l.courseId], u = n.parse("courseLabel", f), h = (b = (y = l == null ? void 0 : l.reasons) == null ? void 0 : y.failsWithMessage) == null ? void 0 : b.systemError, E = yz({
        logId: e.logId,
        activityType: l.activity,
        courseId: l.courseId,
        activityTypeId: l.activityId,
        studentSetGroupLookup: t,
        courseLabel: u,
        systemError: h,
        studentId: a,
        mapping: n
      });
      i.push(...E);
      const d = (I = l == null ? void 0 : l.reasons) == null ? void 0 : I.failsWithGroups, g = Tz({
        activityType: l.activity,
        activityTypeId: l.activityId,
        courseId: l.courseId,
        studentSetGroupLookup: t,
        groupFailError: d,
        courseLabel: u,
        studentId: a,
        mapping: n
      });
      i.push(...g);
    });
  return i;
}
function yz({
  systemError: e,
  mapping: t,
  studentId: r,
  courseLabel: n,
  studentSetGroupLookup: i,
  courseId: o,
  activityType: s,
  activityTypeId: a,
  logId: l
}) {
  const f = [];
  return D(e) && Object.entries(e).forEach(
    ([u, h], E) => {
      const d = i[parseInt(u, 10)], g = Az(h, l);
      f.push({
        issueType: g,
        manageStudentLink: "Manage student",
        student: r,
        group: t.parse("groupName", d),
        course: n,
        activityType: s,
        activityTypeId: a,
        key: `${u}-${s}-${o}-${r}-${g}-${E}`,
        logId: l
      });
    }
  ), f;
}
function Tz({
  groupFailError: e,
  studentSetGroupLookup: t,
  courseLabel: r,
  courseId: n,
  activityType: i,
  mapping: o,
  studentId: s,
  activityTypeId: a
}) {
  const l = [];
  return D(e) && Object.entries(e).forEach(([f, u]) => {
    u.forEach((h, E) => {
      const d = t[h], g = f;
      l.push({
        issueType: bz(g),
        manageStudentLink: "Manage student",
        student: s,
        group: o.parse("groupName", d),
        course: r,
        activityType: i,
        activityTypeId: a,
        key: `${h}-${i}-${n}-${s}-${g}-${E}`
      });
    });
  }), l;
}
function bz(e) {
  switch (e) {
    case "buffer":
      return "No seats (buffer)";
    case "size":
      return "No seats";
    case "doubleBooked":
      return "Already allocated";
    case "dedicated":
      return "Dedicated";
    case "hidden":
      return "Hidden";
    case "conflict":
      return "Conflict";
    case "registrationPeriod":
      return "Registration period closed";
    default:
      return mt();
  }
}
function Az(e, t) {
  switch (e == null ? void 0 : e.name) {
    case ue.HeavyLoadError:
      return "Heavy load";
    case ue.MaximumMembershipReachedError:
      return "No seats (server)";
    case ue.MaximumMembershipReachedByTypeError:
      return "No seats (server)";
    case ue.PermissionError:
      return Se.noPermission;
    default:
      return `System Error type: ${e == null ? void 0 : e.name} Code: (${e == null ? void 0 : e.code}) Message: ${e == null ? void 0 : e.message} LogId: ${t}`;
  }
}
const vz = [
  "maxStudents",
  "buffer",
  "allocationRules",
  "hideGroup",
  "startDate",
  "endDate"
];
function GG({
  id: e,
  linkedIds: t,
  groups: r,
  mapping: n,
  courseId: i,
  mustHaveLinks: o
}) {
  if (t.length === 0)
    return o ? { success: !1, message: " - No matching group." } : { success: !0, message: "" };
  const s = t.map((h) => JE(h.toString(), r)).filter(D);
  if (s.length !== t.length)
    return {
      success: !1,
      message: `${Se.getLinkingGroupsFailed}: ${t}`
    };
  const a = JE(e, r);
  if (!D(a))
    return { success: !1, message: ` - Failed to find group: ${e}` };
  const l = o ? "" : Se.linkedRulesFailed, f = [a, ...s].map((h) => xc(h) ? h.object : Ij(h) ? h.teObject : h), u = Sz(l, f, n, i);
  return { success: !xr(u), message: u };
}
function JE(e, t) {
  return t instanceof Map ? t.get(Number(e)) : t[e];
}
function Sz(e, t, r, n) {
  if (t.length < 2) return e;
  const i = Iz(t, r, n) + vz.filter((o) => r.isMapped(o)).map((o) => _z(t, r, o)).filter(xr).join(`
`);
  return xr(i) ? jc([e, i], ` 
 `) : "";
}
function Iz(e, t, r) {
  return e.every(
    (i) => Cj(i).includes(r)
  ) ? "" : `- Not the same ${t.typename("course")}.
`;
}
function _z(e, t, r) {
  if (r === "allocationRules") {
    const o = t.parse(r, e[0]), a = e.every(
      (u) => Rz(_s({ mapping: t, value: u }), o.dedi)
    ) ? "" : Su(e, t, r, Se.dedicateTo), f = z$({ groups: e, mapping: t }).success ? "" : Su(e, t, r, Se.distribution);
    return jc([f, a], `
`);
  }
  const n = t.parse(r, e[0]);
  return e.every(
    (o) => Xk(t.parse(r, o), n)
  ) ? "" : Su(e, t, r);
}
function Rz(e, t) {
  switch (e.kind) {
    case "none":
      return e.kind === t.kind;
    case "category":
      return t.kind !== "category" ? !1 : e.data.every(
        (r) => t.data.some(
          (n) => r.id === n.id && r.value === n.value
        )
      );
    case "relation":
      return t.kind !== "relation" ? !1 : e.data.every(
        (r) => t.data.some((n) => r.id === n.id)
      );
    default:
      mt();
  }
}
function Su(e, t, r, n) {
  const i = " - " + (xr(n) ? n : t.fieldname(r)), o = e.map((s) => Oz(t.parse(r, s))).filter(xr).join(" vs ");
  return `${jc([i, o], ": ")}.`;
}
function Oz(e) {
  return Ai(e) ? "" : gb(e);
}
function BG(e, t, r) {
  return t ? t === ar.ASCFIELD || t === ar.DESCFIELD ? !r || r < 0 ? (e.warn(
    "[createSortParams]: No `sortFieldId` provided when specifying sort = ASCFIELD | DESCFIELD, skipping sorting (make sure the mapped field is mandatory)"
  ), {}) : {
    sort: t,
    sortFieldId: r
  } : {
    sort: t
  } : {};
}
const wz = new Intl.Collator();
function af({
  items: e,
  getValue: t,
  descending: r = !1
}) {
  return e.map((n) => {
    const i = t(n);
    return { item: n, value: i ?? "", hasContent: xr(i) };
  }).sort((n, i) => {
    if (!n.hasContent && !i.hasContent) return 0;
    if (!n.hasContent) return 1;
    if (!i.hasContent) return -1;
    const o = wz.compare(n.value, i.value);
    return r ? -o : o;
  }).map(({ item: n }) => n);
}
function VG({
  objects: e,
  sort: t,
  sortFieldId: r,
  mapping: n
}) {
  return !D(r) || Je(r) && r <= 0 ? [...e] : af({
    items: e,
    getValue: (i) => n.string(r, i),
    descending: t === ar.DESCFIELD
  });
}
function WG({
  objects: e,
  sort: t,
  key: r
}) {
  return af({
    items: e,
    getValue: (n) => gb(n[r]),
    descending: t === ar.DESCFIELD
  });
}
function Iu({
  ids: e,
  getLabel: t,
  descending: r = !1
}) {
  return af({
    items: e,
    getValue: t,
    descending: r
  });
}
function qG(e, t) {
  return (e === ar.ASCFIELD || e === ar.DESCFIELD) && typeof t == "number" && t > 0 ? {
    sort: e,
    sortFieldId: t
  } : { sort: void 0, sortFieldId: void 0 };
}
function HG({
  course: e,
  activities: t
}) {
  const r = [];
  for (const n of e.activities) {
    const i = t[n];
    D(i) && r.push(i);
  }
  return r;
}
function YG({ course: e, groups: t, activities: r }) {
  const n = [];
  for (const i of e.activities) {
    const o = r[i];
    if (D(o))
      for (const s of o.groups) {
        const a = t[s];
        D(a) && a.courseId === e.id && n.push(a);
      }
  }
  return n;
}
function ZG(e) {
  if ("ids" in e) {
    const { courses: t, groups: r, ids: n } = e;
    return zn(
      n.flatMap((i) => t[i] ? parseInt(i, 10) : r[i] ? r[i].courseId : [])
    );
  }
  return zn(e.groups.map((t) => t.courseId));
}
function JG({
  activity: e,
  groups: t
}) {
  const r = [];
  for (const n of e.groups) {
    const i = t[n];
    D(i) && r.push(i);
  }
  return r;
}
function KG(e) {
  var r;
  if ("groupId" in e) {
    const { groupId: n, activities: i } = e;
    return Object.values(i).find(
      (o) => D(o) && o.groups.includes(n)
    );
  }
  const t = (r = e.group) == null ? void 0 : r.activityId;
  if (D(t))
    return e.activities[t];
}
function XG({
  groups: e,
  allGroups: t
}) {
  const r = {};
  for (const n in e) {
    const i = e[n];
    D(i) && (r[i.id] = [], i.object.relations.forEach((o) => {
      o.objectIds.forEach((s) => {
        const a = t[s];
        D(a) && (D(r[i.id]) ? r[i.id].push(a.id) : r[i.id] = [a.id]);
      });
    }));
  }
  return r;
}
function QG(e, t, r) {
  return D(t == null ? void 0 : t.typeId) && D(t == null ? void 0 : t.objectIds) && r.typeCheck(e, t.typeId) ? t.objectIds : [];
}
function eB(e, t) {
  var r, n, i, o;
  for (const s of Object.values(e)) {
    const a = (n = (r = s == null ? void 0 : s.failsWithGroups) == null ? void 0 : r.size) == null ? void 0 : n.includes(t), l = (o = (i = s == null ? void 0 : s.failsWithGroups) == null ? void 0 : i.buffer) == null ? void 0 : o.includes(t);
    if (a || l)
      return !0;
  }
  return !1;
}
function tB(e) {
  return `${el}${e}`;
}
function rB(e) {
  if (e === cT) return { kind: "allocated" };
  if (e === fT)
    return { kind: "not_allocated" };
  if (e.startsWith(el)) {
    const t = e.slice(el.length);
    if (/^\d+$/.test(t))
      return { kind: "to_group", groupId: Number(t) };
  }
}
function nB(e, t) {
  return Number.isInteger(e) && e >= 0 && e <= t;
}
function iB(e, t) {
  return e.enabledProducts.includes(t);
}
function Oa(e, t) {
  const r = new uA(`Feature "${t}" is not enabled`);
  return {
    check: e,
    assert: () => {
      if (!e())
        throw r;
      return !0;
    },
    safeAssert: () => e() ? { enabled: !0 } : { enabled: !1, error: r }
  };
}
function Nz(e, t) {
  return Oa(
    () => {
      var r;
      return e.enabledProducts.includes(C.EAppId.TE_EXAM_V3) && !!((r = t.appPermissions) != null && r.includes(Fw.HUB.STUDENT));
    },
    "studentAssessment"
  );
}
function Cz(e) {
  return Oa(
    () => e.enabledProducts.includes(C.EAppId.TE_ALLOCATE_PREFERENTIAL),
    "schedulePreferences"
  );
}
function Pz(e) {
  return Oa(() => e.enableWaitlist, "waitlist");
}
function Dz(e) {
  return Oa(
    () => e.blockStudentConflict,
    "blockStudentConflict"
  );
}
function Es(e, t) {
  return t in e;
}
function oB(e) {
  const t = {};
  if (Es(e, "adminSettings")) {
    const r = e.adminSettings;
    t.waitlist = Pz(r), t.blockStudentConflict = Dz(r);
  }
  if (Es(e, "organization")) {
    const r = e.organization;
    t.schedulePreferences = Cz(r);
  }
  if (Es(e, "organization") && Es(e, "user")) {
    const r = e.organization, n = e.user;
    t.studentAssessment = Nz(r, n);
  }
  return t;
}
function sB(e) {
  if (!(!D(e) || e.length === 0))
    return e.map(
      (t) => {
        var r;
        return (r = t.building) != null && r.value ? `${t.name.value} ${t.building.value}` : t.name.value;
      }
    ).join(", ");
}
function Mz(e) {
  return (e == null ? void 0 : e.map(
    (t) => [t.code.value, t.name.value].filter(Boolean).join(" - ")
  ).filter(Boolean).join(", ")) ?? "";
}
function aB(e) {
  var t;
  return e.subtitle ? e.subtitle : ((t = e.examType) == null ? void 0 : t.value) ?? Mz(e.module);
}
function uB({
  registration: e,
  mapping: t,
  preferredGroupIds: r
}) {
  return (e.courseIds ?? []).flatMap((n) => {
    const i = e.courses[n];
    if (!D(i)) return [];
    const o = t.parse("courseLabel", i.teObject);
    return i.children.flatMap((s) => {
      const a = e.activities[s];
      return D(a) ? a.children.filter((l) => r.includes(l)).map((l) => e.groups[l]).filter(D).map((l) => ({
        key: `${l.id}`,
        activityLabel: `${o} ${a.label}`,
        groupName: OF(t, l)
      })) : [];
    });
  });
}
class lB {
  constructor(t, r) {
    $(this, "logger");
    $(this, "transformer");
    this.logger = t, this.transformer = r;
  }
  /**
   * Logs an info message.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.info
   */
  info(t, ...r) {
    if (D(this.transformer)) {
      this.transformer(this.logger.info.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.info(t, ...r);
  }
  /**
   * Logs a warning message.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.debug
   */
  warn(t, ...r) {
    if (D(this.transformer)) {
      this.transformer(this.logger.warn.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.warn(t, ...r);
  }
  /**
   * Logs a debug message. Used for low level debug information.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.debug
   */
  debug(t, ...r) {
    if (D(this.transformer)) {
      this.transformer(this.logger.debug.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.debug(t, ...r);
  }
  /**
   * Logs a error message. Used for when something goes wrong.
   * @param args - One or many arguments of any type. Same signature as the
   * arguments for console.error
   */
  error(t, ...r) {
    if (D(this.transformer)) {
      this.transformer(this.logger.error.bind(this.logger))(t, ...r);
      return;
    }
    this.logger.error(t, ...r);
  }
  trace(t, ...r) {
    if ("trace" in this.logger) {
      if (D(this.transformer)) {
        this.transformer(this.logger.trace.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.trace(t, ...r);
    } else {
      if (D(this.transformer)) {
        this.transformer(this.logger.debug.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.debug(t, ...r);
    }
  }
  fatal(t, ...r) {
    if ("fatal" in this.logger) {
      if (D(this.transformer)) {
        this.transformer(this.logger.fatal.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.fatal(t, ...r);
    } else {
      if (D(this.transformer)) {
        this.transformer(this.logger.error.bind(this.logger))(t, ...r);
        return;
      }
      this.logger.error(t, ...r);
    }
  }
  /**
   * Creates an error function with a base message.
   * @param baseMessage - The base message
   * @returns
   * Function that logs info messages
   */
  createInfoFn(t) {
    return (r, ...n) => this.logger.info(`${t} ${r}`, ...n);
  }
  /**
   * Creates an error function with a base message.
   * @param baseMessage - The base message
   * @returns
   * Function that logs debug messages
   */
  createDebugFn(t) {
    return (r, ...n) => this.logger.debug(`${t} ${r}`, ...n);
  }
  /**
   * Creates an error function with a base message.
   * @param baseMessage - The base message
   * @returns
   * Function that logs errors
   */
  createErrorFn(t) {
    return (r, ...n) => this.logger.error(`${t} ${r}`, ...n);
  }
}
const cB = "DD/MM/YYYY", fB = "DD/MM/YYYY HH:mm:ss", dB = "YYYY-MM-DD", pB = "YYYY-MM-DDTHH.mm.ss", KE = {
  extId: "CET Default",
  name: "CET Default",
  identifier: "Europe/Stockholm",
  offset: "UTC+1"
}, Lz = -1, hB = -1, mB = -1, EB = -1, gB = 120, yB = 1e3, TB = 3e4, bB = !1;
class AB {
  constructor({ serverDateTime: t, timezone: r, mapping: n }) {
    /**
     * The record that will ultimately be returned when all the steps have been
     * completed.
     */
    $(this, "registration", {
      courses: {},
      courseIds: [],
      activities: {},
      groups: {},
      events: [],
      conflicts: {},
      timezone: {
        server: KE,
        user: KE
      },
      studentId: 0,
      studentObject: void 0
    });
    $(this, "catalog", {
      courses: {},
      activities: {},
      groups: {}
    });
    $(this, "mapping");
    $(this, "studentRelationIds", []);
    $(this, "studentMembers", []);
    $(this, "studentFieldValues", []);
    $(this, "mode", "student");
    $(this, "groupDedicatedMatches", {});
    $(this, "waitListsLookup", {});
    $(this, "groupWaitlists", /* @__PURE__ */ new Map());
    $(this, "groupHasValidWaitlist", /* @__PURE__ */ new Set());
    $(this, "conflicts", {});
    this.registration.serverDateTime = t, this.registration.timezone = r, this.mapping = n;
  }
  /**
   * The only public method of this service. It will fetch all the data from
   * the APIs and return a registration record.
   */
  createRegistration({
    catalog: t,
    mode: r,
    studentData: n,
    adminSettings: i
  }) {
    const { studentMembers: o, studentObject: s, conflicts: a, groupWaitlists: l } = n;
    this.conflicts = a, this.catalog = t, this.mode = r ?? "student", this.mode === "student" && (this.registration.blockStudentConflict = i.blockStudentConflict), this.registration.enableWaitlist = i.enableWaitlist, this.registration.studentObject = s, this.waitListsLookup = rj(n.waitlists, "groupId"), this.groupWaitlists = l;
    const f = this.getRelationIdsFromObjects([s]), u = s.id;
    this.studentFieldValues = s.fields, this.studentRelationIds = f ?? [], this.registration.studentId = u, this.studentMembers = o, this.precomputeValidWaitlistGroups();
    const h = this.initiateRegistrationRecord(
      this.catalog
    );
    if (!h.success)
      return h;
    this.registration.activities = this.activityFilter(
      this.registration.activities,
      this.registration.groups
    ), this.registration.courses = this.courseFilter(
      this.registration.courses,
      this.registration.activities
    ), this.sortByLabel();
    for (const E in this.catalog.groups) {
      const d = this.catalog.groups[E];
      if (!D(d))
        return {
          success: !1,
          error: new Error(
            `Group '${E}' does not exist within catalog.groups.`
          ),
          code: "general",
          message: "[createRegistration][logic error]"
        };
      this.assignSeatsHiddenDedicatedGroups(d), this.assignWaitlistStatus(d);
      const g = this.assignOpen(d);
      if (!g.success)
        return g;
    }
    for (const E in this.catalog.activities) {
      const d = this.catalog.activities[E];
      if (!D(d))
        return {
          success: !1,
          error: new Error(
            `Activity '${d}' does not exist within catalog.activities.`
          ),
          code: "general",
          message: "[createRegistration][logic error]"
        };
      this.assignAllocationSignalAndStatus(d);
    }
    return this.catalog = {
      courses: {},
      activities: {},
      groups: {}
    }, { data: this.registration, success: !0 };
  }
  initiateRegistrationRecord(t) {
    for (const r in t.courses) {
      const n = t.courses[r];
      if (!D(n))
        return {
          success: !1,
          error: new Error(
            `Course '${r}' does not exist within catalog.courses.`
          ),
          code: "general",
          message: "[initiateRegistrationRecord][logic error]"
        };
      this.registration.courses[r] = {
        ...n,
        open: !1,
        // Default value, it is set to its correct value later
        showInRegistration: !0
      };
    }
    for (const r in t.activities) {
      const n = t.activities[r];
      if (!D(n))
        return {
          success: !1,
          error: new Error(
            `Activity '${r}' does not exist within catalog.activities.`
          ),
          code: "general",
          message: "[initiateRegistrationRecord][logic error]"
        };
      this.registration.activities[r] = {
        ...n,
        open: !1,
        // Default value, it is set to its correct value later
        showInRegistration: !0,
        state: "UNKNOWN",
        allocationSignal: "ISSUE",
        hasConflicts: !1,
        hasWaitlist: !1
      };
    }
    for (const r in t.groups) {
      const n = this.catalog.groups[r];
      if (!D(n))
        return {
          success: !1,
          error: new Error(
            `Group '${r}' does not exist within catalog.group.`
          ),
          code: "general",
          message: "[initiateRegistrationRecord][logic error]"
        };
      const i = this.matchDedication(
        this.catalog.groups[r]
      ), o = this.isHidden(this.catalog.groups[r]);
      this.registration.groups[r] = {
        ...n,
        open: !1,
        showInRegistration: this.shouldShowInRegistration(
          o,
          i,
          this.catalog.groups[r]
        ),
        seats: {
          taken: 0,
          available: 0,
          total: 0,
          raw: {
            taken: 0,
            available: 0,
            total: 0,
            buffer: 0
          }
        },
        dedicated: {
          kind: "none",
          data: void 0
        },
        matchDedication: i,
        hidden: o,
        allocationStatus: "NOT_ALLOCATED",
        waitlistPosition: 0,
        hasStudentsInWaitlist: !1
      };
    }
    return { success: !0 };
  }
  /**
   * @param group
   * @returns If the input group should be included (shown for the user) based on its dedications
   */
  matchDedication(t) {
    if (!D(t)) return !1;
    const r = _s({
      mapping: this.mapping,
      value: t.teObject
    }), { dedicatedMatch: n } = this.assignGroupDedicatedMatches(t);
    return !n && r.kind === "none" ? !this.activityDedicatedMatches(
      this.catalog.activities[t.parentId]
    ) : n;
  }
  /**
   * @description If the student has any dedicated matches with any groups in the activity.
   * @param activity
   * @returns If any group in the activity has a dedicated match
   */
  activityDedicatedMatches(t) {
    return t == null ? void 0 : t.children.some(
      (r) => this.assignGroupDedicatedMatches(this.catalog.groups[r]).dedicatedMatch
    );
  }
  /**
   * @description Will assign if a group has a dedicated match.
   * @param group
   * @returns If the student and group have a dedication match or a rest match
   */
  assignGroupDedicatedMatches(t) {
    if (!D(t))
      return { dedicatedMatch: !1 };
    if (D(this.groupDedicatedMatches[t.id]))
      return this.groupDedicatedMatches[t.id];
    const r = _s({
      mapping: this.mapping,
      value: t.teObject
    }), i = $$({
      dedicatedGroup: r,
      studentFieldValues: this.studentFieldValues,
      studentRelationIds: this.studentRelationIds
    }).length > 0;
    return this.groupDedicatedMatches[t.id] = { dedicatedMatch: i }, { dedicatedMatch: i };
  }
  isHidden(t) {
    return D(t) ? this.mapping.parse("hideGroup", t.teObject) : !1;
  }
  /**
   * Assign 'showInRegistration' for group based on dedicated group, hidden and whether
   * the group is allocated.
   */
  shouldShowInRegistration(t, r, n) {
    return D(n) ? !t && r || this.isAllocated(n) : !1;
  }
  /**
   * Assign 'showInRegistration' based on whether there are 'showInRegistration' groups that
   * belong to the activity. Assign a 'children' array containing only
   * showInRegistration groups, and an 'allChildren' array containing all groups
   * that are defined.
   * Assigning if the activity has waitlist or conflicts.
   */
  activityFilter(t, r) {
    return Object.entries(t).reduce(
      (n, [i, o]) => {
        var E;
        if (!D(o)) return n;
        const s = [], a = ((E = o.children) == null ? void 0 : E.filter((d) => {
          const g = r[d], y = D(g);
          return y && g.showInRegistration && s.push($E(g.id)), y;
        })) ?? [], l = a.some((d) => {
          const g = this.catalog.groups[d];
          return D(g) && this.getWaitlistPosition(g) > 0;
        }), f = a.some((d) => {
          const g = this.conflicts[d];
          return D(g) ? g.allocated && g.reservations.length > 0 : !1;
        }), u = this.getChildren({ children: s, allChildren: a });
        if (!u.length) return n;
        const h = {
          ...o,
          children: u,
          showInRegistration: D(s) && s.length > 0,
          hasWaitlist: l,
          hasConflicts: f
        };
        return {
          ...n,
          [i]: h
        };
      },
      {}
    );
  }
  /**
   * Assign 'showInRegistration' based on whether there are 'showInRegistration' activities that
   * belong to the course. Assign a 'children' array containing only
   * showInRegistration activities, and an 'allChildren' array containing all activities
   * that are defined.
   */
  courseFilter(t, r) {
    return Object.entries(t).reduce(
      (n, [i, o]) => {
        var u;
        if (!D(o)) return n;
        const s = [], a = ((u = o.children) == null ? void 0 : u.filter((h) => {
          const E = r[h], d = D(E);
          return d && E.showInRegistration && s.push($E(E.id)), d;
        })) ?? [], l = this.getChildren({ children: s, allChildren: a });
        if (!l.length) return n;
        const f = {
          ...o,
          children: l,
          showInRegistration: D(s) && s.length > 0
        };
        return {
          ...n,
          [i]: f
        };
      },
      {}
    );
  }
  /**
   * Sort the registration alphabetically by label, after filtering.
   */
  sortByLabel() {
    this.registration.courseIds = Iu({
      ids: Object.values(this.registration.courses).filter(D).map((t) => t.id),
      getLabel: (t) => {
        var r;
        return (r = this.registration.courses[t]) == null ? void 0 : r.label;
      }
    });
    for (const t in this.registration.courses) {
      const r = this.registration.courses[t];
      D(r) && (r.children = Iu({
        ids: r.children,
        getLabel: (n) => {
          var i;
          return (i = this.registration.activities[n]) == null ? void 0 : i.label;
        }
      }));
    }
    for (const t in this.registration.activities) {
      const r = this.registration.activities[t];
      D(r) && (r.children = Iu({
        ids: r.children,
        getLabel: (n) => {
          var i;
          return (i = this.registration.groups[n]) == null ? void 0 : i.label;
        }
      }));
    }
  }
  assignSeatsHiddenDedicatedGroups(t) {
    const r = this.mapping.parse("buffer", t.teObject), n = this.mapping.parse("maxStudents", t.teObject), i = r.isPercent ? Math.round(n * r.size / 100) : r.size, o = this.getStudentMembersOfGroup(t), s = _s({
      mapping: this.mapping,
      value: t.teObject
    }), a = o.length, l = Math.max(n - i, 0), f = Math.max(l - a, 0), h = {
      available: f,
      total: l,
      taken: a,
      raw: {
        taken: a,
        total: n,
        available: f,
        buffer: i
      }
    }, E = this.registration.groups[t.id];
    D(E) && (this.registration.groups[t.id] = {
      ...E,
      allocationStatus: this.isAllocated(t, o) ? "ALLOCATED_TO_THIS" : "NOT_ALLOCATED",
      seats: h,
      dedicated: s
    });
  }
  assignWaitlistStatus(t) {
    const r = this.registration.groups[t.id];
    D(r) && (this.registration.groups[t.id] = {
      ...r,
      waitlistPosition: this.getWaitlistPosition(t),
      hasStudentsInWaitlist: this.hasValidWaitlistEntries(t)
    });
  }
  /**
   * Effective waitlist position for the current student on this group:
   * zero when they are already allocated, otherwise the raw waitlist
   * position from the lookup.
   */
  getWaitlistPosition(t) {
    const r = this.waitListsLookup[t.id];
    return !D(r) || this.isAllocated(t) ? 0 : r.position;
  }
  /**
   * A waitlist entry only counts when the student is still enrolled in
   * the owning course and isn't already a member of the group — stale
   * entries (allocated-and-waitlisted, or no longer enrolled) are ignored.
   * Membership is precomputed once per createRegistration call.
   */
  hasValidWaitlistEntries(t) {
    return this.groupHasValidWaitlist.has(t.id);
  }
  precomputeValidWaitlistGroups() {
    this.groupHasValidWaitlist = /* @__PURE__ */ new Set();
    const t = /* @__PURE__ */ new Map();
    for (const [r, n] of this.groupWaitlists) {
      if (!n.length) continue;
      const i = this.catalog.groups[r];
      if (!D(i)) continue;
      const o = this.catalog.activities[i.parentId];
      if (!D(o)) continue;
      const s = this.catalog.courses[o.parentId];
      if (!D(s)) continue;
      let a = t.get(s.id);
      a || (a = new Set(
        s.teObject.relations.flatMap((u) => u.objectIds)
      ), t.set(s.id, a));
      const l = new Set(
        i.teObject.members.map((u) => u.objectId)
      );
      n.some(
        (u) => !l.has(u) && a.has(u)
      ) && this.groupHasValidWaitlist.add(r);
    }
  }
  /**
   * Get the student members belonging to a particular group.
   */
  getStudentMembersOfGroup(t) {
    const r = t.teObject.members.map((n) => n.objectId);
    return this.studentMembers.filter(
      (n) => r.includes(n.id)
    );
  }
  /**
   * Check if the current student is allocated to a group. Pass
   * prefiltered studentMembers when the caller already has them
   * (e.g. when computing seats); otherwise the check runs directly
   * against group.teObject.members.
   */
  isAllocated(t, r) {
    return r !== void 0 ? r.some(
      (n) => n.id === this.registration.studentId
    ) : t.teObject.members.some(
      (n) => n.objectId === this.registration.studentId
    );
  }
  /**
   * After the activities have been created, we need to edit the
   * activities to include the MULTIPLE_ALLOCATIONS and
   * ALLOCATED_TO_OTHER statuses. We also need to assign the right
   * allocationSignal to the activity.
   */
  assignAllocationSignalAndStatus(t) {
    var o, s;
    let r = "ISSUE";
    const n = this.registration.activities[t.id];
    if (!D(n)) return;
    const i = ((o = t.children) == null ? void 0 : o.filter(
      (a) => {
        var l, f;
        return ((f = (l = this.registration.groups) == null ? void 0 : l[a]) == null ? void 0 : f.allocationStatus) === "ALLOCATED_TO_THIS";
      }
    )) || [];
    for (const a of (t == null ? void 0 : t.children) ?? []) {
      let l = "NOT_ALLOCATED";
      const f = (s = this.registration.groups) == null ? void 0 : s[a];
      if (!D(f)) continue;
      const u = f.links.filter(
        (E) => !i.includes(E)
      ), h = i.filter(
        (E) => !f.links.includes(E)
      );
      i.includes(Qy.parse(f.id)) ? h.length > 1 ? l = "MULTIPLE_ALLOCATIONS" : (l = "ALLOCATED_TO_THIS", u.length === 0 && (r = "OK")) : h.length > 0 && (l = "ALLOCATED_TO_OTHER"), f.allocationStatus = l;
    }
    n.allocationSignal = r;
  }
  /**
   * Assign to each item in the registration record if it is open to
   * registration.
   */
  assignOpen(t) {
    const r = this.catalog.activities[t.parentId];
    if (!D(r))
      return {
        success: !1,
        error: new Error(
          `Activity '${t.parentId}' does not exist within catalog.activities.`
        ),
        code: "general",
        message: "[assignOpen][logic error]"
      };
    const n = this.catalog.courses[r.parentId];
    if (!D(n))
      return {
        success: !1,
        error: new Error(
          `Course '${r.parentId}' does not exist within catalog.courses.`
        ),
        code: "general",
        message: "[assignOpen][logic error]"
      };
    const i = this.registration.groups[t.id], o = this.registration.activities[r.id], s = this.registration.courses[n.id];
    if (!D(i) || !D(o) || !D(s))
      return { success: !0 };
    const a = this.isGroupOpen(t);
    return i.open = a, o.open = o.open || a, s.open = s.open || a, { success: !0 };
  }
  /**
   * Based on the current date time, and a number of other factors, we need
   * to determine if group is open to registration. The spec for this logic is
   * further documented in the tests.
   */
  isGroupOpen(t) {
    var i, o;
    if (!((o = (i = this.registration.groups) == null ? void 0 : i[t.id]) != null && o.showInRegistration) || !D(this.registration.serverDateTime))
      return !1;
    const r = this.mapping.parse("startDate", t.teObject), n = this.mapping.parse("endDate", t.teObject);
    return $U(
      r,
      n,
      this.registration.timezone.server.identifier,
      this.registration.serverDateTime.unix
    ) === Nr.enum.open;
  }
  /**
   * Merge all relation ids from all objects together
   */
  getRelationIdsFromObjects(t) {
    return t == null ? void 0 : t.reduce((n, i) => {
      var s;
      if (i === void 0) return n;
      const o = (s = i.relations) == null ? void 0 : s.flatMap((a) => a.objectIds).filter((a) => !n.includes(a));
      return o ? [...n, ...o] : n;
    }, []);
  }
  /**
   * Return the right children based on the registration mode
   */
  getChildren({
    children: t,
    allChildren: r
  }) {
    switch (this.mode) {
      case "teacher":
        return r;
      case "student":
        return t;
      default:
        return mt(this.mode);
    }
  }
}
class vB {
  constructor({ timezone: t }) {
    $(this, "schedule", {
      events: [],
      conflicts: {}
    });
    $(this, "timezone", "");
    this.timezone = t;
  }
  /**
   * Fetch reservations based on groups. Create the events and assign the conflicts.
   */
  createSchedule({
    studentConflicts: t,
    groupIdsByReservation: r,
    reservations: n,
    groups: i
  }) {
    return this.schedule.conflicts = t, this.createEvents({
      reservations: n,
      groups: i,
      groupIdsByReservation: r
    }), this.assignEventConflicts({
      studentConflicts: t
    }), { success: !0, data: this.schedule };
  }
  /**
   * Create the events from the reservations.
   */
  createEvents({
    groupIdsByReservation: t,
    reservations: r,
    groups: n,
    events: i
  }) {
    D(i) && (this.schedule.events = i);
    const o = /* @__PURE__ */ new Set();
    if (D(r))
      for (const s of r) {
        if (!Ez(s))
          continue;
        const a = this.getGroups({
          groups: n,
          reservation: s,
          groupIdsByReservation: t
        }), l = Bm(s.begin, this.timezone), f = Bm(s.end, this.timezone);
        if (a.length === 0) {
          const u = {
            id: s.id,
            start: l,
            end: f,
            name: "",
            reservation: s,
            groupId: Lz,
            allocationConflicts: []
          };
          this.schedule.events.push(u);
          continue;
        }
        for (const u of a) {
          const h = {
            id: s.id,
            start: l,
            end: f,
            name: u.label,
            reservation: s,
            groupId: u.id,
            allocationConflicts: []
          };
          o.add(u.id), this.schedule.events.push(h);
        }
      }
    for (const s in n) {
      if (o.has(Number(s)))
        continue;
      const a = n[s];
      if (!D(a))
        continue;
      const l = -a.id, f = {
        id: l,
        start: Si,
        end: Si,
        name: a.label,
        reservation: { id: l, history: {} },
        groupId: a.id,
        allocationConflicts: []
      };
      this.schedule.events.push(f);
    }
  }
  /**
   * It takes in all conflicts and potential conflicts for the student.
   * On each event add a list of conflicting events.
   * Create a list of conflict objects that contain
   * unique combinations of allocated groups conflicting with
   * each other.
   */
  assignEventConflicts({ studentConflicts: t }) {
    for (const r of this.schedule.events) {
      if (!D(r)) continue;
      const n = t[r.groupId];
      D(n) && (r.allocationConflicts = n.reservations.map(
        (i) => ({
          reservationId: i.reservationId,
          groupId: i.studentSetGroupId
        })
      ));
    }
  }
  /**
   * @param reservation A reservation object
   * @param groups Groups for specific user
   * @param reservationGroupLookup Lookup table reservation id -> group ids
   * @returns Groups based on the reservation
   */
  getGroups({
    reservation: t,
    groups: r,
    groupIdsByReservation: n
  }) {
    const i = n[t.id];
    return D(i) ? i.map((o) => r[o]).filter(D) : [];
  }
}
class SB {
  constructor({ mapping: t, logger: r }) {
    /**
     * The record that will ultimately be returned when all the steps have been
     * completed.
     */
    $(this, "catalog", {
      courses: {},
      activities: {},
      groups: {}
    });
    $(this, "courseMap", /* @__PURE__ */ new Map());
    $(this, "mapping");
    $(this, "linkedGroupsRecord", {});
    $(this, "logger", console);
    this.mapping = t, this.logger = r;
  }
  /**
   * The only public method of this service. It will fetch all the data from
   * the APIs and return a catalog.
   */
  createCatalog({
    groupObjects: t,
    courseObjects: r,
    linkedGroupsRecord: n
  }) {
    this.linkedGroupsRecord = n, this.courseMap = new Map(r.map((a) => [a.id, !0]));
    const i = this.assignGroupsToCatalog(t);
    if (!i.success)
      return i;
    const o = this.assignCoursesToCatalog(r);
    if (!o.success)
      return o;
    this.removeOrphans();
    const s = this.createActivities();
    return s.success ? { data: this.catalog, success: !0 } : s;
  }
  assignGroupsToCatalog(t) {
    for (const r of t)
      try {
        const n = cA({
          courseIds: r.relations.flatMap((o) => o.objectIds).filter((o) => this.courseMap.has(o)),
          group: r,
          mapping: this.mapping
        });
        if (!n.success)
          throw new zo(
            n.message,
            {
              cause: n.issues
            }
          );
        const i = this.assignCommonCatalogParameters({
          recordKey: "groups",
          teObject: r
        });
        if (!i.success)
          return i;
      } catch (n) {
        if (SU(n, zo)) {
          this.logger.warn(
            `[assignGroupsToCatalog]: Missconfigured student set group: ${Nt(
              n
            )}`,
            { err: n }
          );
          continue;
        }
        throw n;
      }
    return { success: !0 };
  }
  assignCoursesToCatalog(t) {
    for (const r of t) {
      const n = this.assignCommonCatalogParameters({
        recordKey: "courses",
        childKey: "groups",
        teObject: r
      });
      if (!n.success)
        return n;
    }
    return { success: !0 };
  }
  assignCommonCatalogParameters({
    recordKey: t,
    childKey: r,
    teObject: n
  }) {
    const i = this.assignIdsAndData({
      recordKey: t,
      teObject: n
    });
    if (!i.success)
      return i;
    const o = this.createRelations({ childKey: r, teObject: n });
    this.assignRelations({
      recordKey: t,
      childKey: r,
      relations: o,
      objectId: n.id
    });
    const s = this.assignParentIds({
      childKey: r,
      relations: o,
      teObject: n
    });
    return s.success ? { success: !0 } : s;
  }
  /**
   * Create a set of relation ids filtered on whether they have been previously
   * added to the catalog.
   */
  createRelations({ childKey: t, teObject: r }) {
    var i;
    const n = /* @__PURE__ */ new Set();
    for (const o of ((i = r.relations) == null ? void 0 : i.flatMap((s) => s.objectIds)) ?? [])
      t !== void 0 && this.catalog[t][o] && n.add(o);
    return n;
  }
  assignRelations({
    recordKey: t,
    childKey: r,
    relations: n,
    objectId: i
  }) {
    if (r !== void 0) {
      const o = this.catalog[t][i];
      o !== void 0 && "children" in o && (o.children = Array.from(n));
    }
  }
  /**
   * Assign parentId to all relations if childKey and parentIdKey are both
   * provided.
   */
  assignParentIds({
    childKey: t,
    relations: r,
    teObject: n
  }) {
    if (t !== void 0)
      for (const i of r) {
        const o = this.catalog[t][i];
        if (!D(o)) {
          const s = new Error(
            `Relation '${i}' does not exist within catalog.${t}.`
          );
          this.logger.warn(
            `[assignParentIds][data error] ${Nt(s)}`,
            { err: s }
          );
          continue;
        }
        this.catalog[t][i] = {
          ...o,
          parentId: n.id
        };
      }
    return { success: !0 };
  }
  /**
   * Assign id:s and other data to the catalog record.
   */
  assignIdsAndData({
    recordKey: t,
    teObject: r
  }) {
    var o;
    const n = (o = this.catalog[t]) == null ? void 0 : o[r.id];
    if ((n == null ? void 0 : n.id) !== void 0)
      return { success: !0 };
    const i = t === "groups" ? this.mapping.getIds("group") : this.mapping.getIds("course");
    switch (t) {
      case "groups": {
        this.catalog[t][r.id] = {
          id: r.id,
          extId: r.extId,
          typeIds: i,
          teObject: r,
          label: this.mapping.parse("groupName", r),
          links: this.linkedGroupsRecord[r.id.toString()] ?? [],
          parentId: 0
        };
        break;
      }
      case "courses": {
        this.catalog[t][r.id] = {
          id: r.id,
          extId: r.extId,
          typeIds: i,
          teObject: r,
          label: this.mapping.parse("courseTitle", r),
          children: []
        };
        break;
      }
      default:
        mt();
    }
    return { success: !0 };
  }
  /**
   * If a group does not have a parentId, it cannot be associated with a course,
   * and we cannot create a activity for it. This indicates something is
   * missing from the data provided, and the best course of action is to remove
   * the group.
   */
  removeOrphans() {
    var t;
    for (const r in this.catalog.groups)
      if (!((t = this.catalog.groups[r]) != null && t.parentId)) {
        delete this.catalog.groups[r];
        const n = new Error(
          `Group '${r}' did not have a parentId assigned and was removed. The course with the group as a relation was not found.`
        );
        this.logger.warn(
          `[removeOrphans][data error] ${Nt(n)}`,
          { err: n }
        );
      }
  }
  /**
   * There no longer exists an actual object mapped to activity, so
   * we create activities based on the activityType
   */
  createActivities() {
    var n;
    const t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
    for (const i in this.catalog.groups) {
      const o = this.catalog.groups[Number(i)];
      if (!D(o))
        return {
          success: !1,
          error: new Error(
            `Group '${i}' does not exist within catalog.groups.`
          ),
          code: "general",
          message: "[createActivities][logic error]"
        };
      const s = o.links.reduce((d, g) => {
        var b;
        const y = (b = this.catalog.groups[g]) == null ? void 0 : b.teObject;
        return D(y) && d.push(y), d;
      }, []), a = vF({
        courseIds: [o.parentId],
        groups: [o.teObject, ...s],
        mapping: this.mapping
      });
      if (!a.success)
        continue;
      const { id: l, activityType: f } = a.data;
      if (this.catalog.activities[l] === void 0) {
        this.catalog.activities[l] = {
          id: l,
          parentId: o.parentId,
          label: f,
          children: []
        };
        const d = this.catalog.courses[o.parentId];
        if (!D(d))
          return {
            success: !1,
            error: new Error(
              `Course '${o.parentId}' does not exist within catalog.courses while removing the group reference for the parent.`
            ),
            code: "general",
            message: "[createActivities][logic error]"
          };
        d.children = ((n = d.children) == null ? void 0 : n.filter((g) => !this.catalog.groups[g])) ?? [];
      }
      const u = this.catalog.activities[l];
      if (!D(u))
        return {
          success: !1,
          error: new Error(
            `Activity '${l}' does not exist within catalog.activities.`
          ),
          code: "general",
          message: "[createActivities][logic error]"
        };
      let h = t.get(l);
      D(h) || (h = /* @__PURE__ */ new Set(), t.set(l, h)), h.add(Number(i));
      let E = r.get(o.parentId);
      D(E) || (E = /* @__PURE__ */ new Set(), r.set(o.parentId, E)), E.add(l), o.parentId = l;
    }
    for (const [i, o] of t) {
      const s = this.catalog.activities[i];
      D(s) && (s.children = Array.from(o));
    }
    for (const [i, o] of r) {
      const s = this.catalog.courses[i];
      D(s) && (s.children = [...s.children ?? [], ...o]);
    }
    return { success: !0 };
  }
}
function IB(e) {
  const {
    courses: t,
    students: r,
    conflictLookups: {
      studentReservationsByStudentId: n,
      studentSetGroupReservationsByGroupId: i,
      studentSetGroupByCourseId: o,
      studentSetGroupLookup: s,
      activityByStudentSetGroupId: a
    }
  } = e, l = sf(t), f = {};
  for (const u of r) {
    f[u.id] = {};
    const h = new Map(
      (n[u.id] ?? []).map((g) => [g.id, g])
    ), E = new Set(u.members.map((g) => g.objectId)), d = xz(
      u,
      l,
      o
    );
    for (const g of d) {
      const y = kz({
        studentSetGroupId: g,
        studentSetGroupLookup: s,
        studentReservationsMap: h,
        studentSetGroupReservationsByGroupId: i,
        activityByStudentSetGroupId: a
      });
      y.length > 0 && (f[u.id][g] = {
        reservations: y,
        allocated: E.has(g)
      });
    }
  }
  return f;
}
function _B({
  students: e,
  courses: t,
  studentSetGroups: r,
  studentReservations: n,
  studentSetGroupReservations: i,
  mapping: o
}) {
  const { objectWithReservations: s } = ZE({
    objects: e,
    reservations: n,
    mapping: o
  }), {
    objectWithReservations: a,
    reservationWithObjectIds: l
  } = ZE({
    objects: r,
    reservations: i,
    mapping: o
  }), f = sf(r), u = jz({
    courses: t,
    studentSetGroupLookup: f
  }), h = _F({
    groups: r,
    mapping: o,
    courseIds: t.map((d) => d.id),
    studentIds: e.map((d) => d.id)
  }), E = {};
  for (const d of h)
    for (const g of d.groups)
      E[g.id] = {
        activityId: d.id,
        courseId: d.courseId
      };
  for (const d of e) {
    const g = s[d.id] ?? [];
    let y = [];
    for (const b of d.members) {
      const I = f[b.objectId];
      if (!D(I)) continue;
      const S = a[I.id];
      D(S) && (y = am(y, S));
    }
    s[d.id] = am(
      g,
      y
    );
  }
  return {
    studentReservationsByStudentId: s,
    studentSetGroupReservationsByGroupId: a,
    studentSetGroupByCourseId: u,
    activityByStudentSetGroupId: E,
    studentSetGroupLookup: f,
    groupIdsByReservation: l
  };
}
function xz(e, t, r) {
  const n = /* @__PURE__ */ new Set(), i = e.relations.flatMap((o) => o.objectIds.map((s) => t[s])).filter(D);
  for (const o of i)
    (r[o.id] ?? []).forEach((a) => n.add(a));
  return Array.from(n);
}
function kz({
  studentSetGroupId: e,
  studentSetGroupLookup: t,
  studentReservationsMap: r,
  studentSetGroupReservationsByGroupId: n,
  activityByStudentSetGroupId: i
}) {
  var l;
  const o = {}, s = n[e] ?? [], a = i[e];
  for (const f of s) {
    if (D(o[f.id])) continue;
    const u = Array.from(
      r.values()
    ).filter(
      (h) => (
        // 1. If the group reservation is the same as the student reservation, skip
        // 2. If there is no conflict, skip
        f.id !== h.id && Uz(
          {
            start: f.begin ?? 0,
            end: f.end ?? 0
          },
          {
            start: h.begin ?? 0,
            end: h.end ?? 0
          }
        )
      )
    );
    for (const h of Object.values(
      u
    )) {
      if (!D(h)) continue;
      const E = (l = h.objects) == null ? void 0 : l.find(
        (d) => D(t[d.objectId]) && d.objectId !== e
      );
      if (!D(E))
        o[h.id] = {
          reservationId: h.id,
          start: h.begin ?? 0,
          end: h.end ?? 0,
          studentSetGroupId: -1,
          activityId: -1,
          courseId: -1
        };
      else {
        const d = i[E.objectId];
        if (D(d) && (a == null ? void 0 : a.activityId) === d.activityId)
          continue;
        o[h.id] = {
          reservationId: h.id,
          start: h.begin ?? 0,
          end: h.end ?? 0,
          studentSetGroupId: E.objectId,
          activityId: (d == null ? void 0 : d.activityId) ?? -1,
          courseId: (d == null ? void 0 : d.courseId) ?? -1
        };
      }
    }
  }
  return Object.values(o);
}
function jz({
  courses: e,
  studentSetGroupLookup: t
}) {
  var n;
  const r = {};
  for (const i of e) {
    r[i.id] = [];
    for (const o of i.relations)
      for (const s of o.objectIds) {
        const a = t[s];
        D(a) && ((n = r[i.id]) == null || n.push(a.id));
      }
  }
  return r;
}
function RB({
  studentConflicts: e
}) {
  const t = {};
  for (const r in e) {
    t[r] = 0;
    const n = e[r];
    for (const i in n)
      n[i].allocated && (t[r] += 1);
  }
  return t;
}
function Uz(e, t) {
  return e.start >= e.end || t.start >= t.end ? !1 : e.start < t.end && t.start < e.end;
}
const OB = "64ad472b59d4e82d4f41dc55", wB = (e) => {
  switch (e) {
    case He.EAppEnv.DEVELOPMENT:
    case He.EAppEnv.BETA:
      return "65e829cc7386bf105e2e28d5";
    case He.EAppEnv.STAGING:
      return "65e829836880eb10b9f4edca";
    case He.EAppEnv.TEST:
      return "67ab2b0fbad72e0a5478c6a6";
    // Production
    default:
      return "65a938f0183d141061d386f9";
  }
};
function NB() {
  const e = NA();
  return _D.parse(e);
}
function CB(e) {
  switch (e) {
    case ci.Success:
      return "Success";
    case ci.Impossible:
      return Se.impossibleProposal;
    case ci.ImpossibleInCurrent:
      return Se.impossibleInCurrentProposal;
    case ci.NotEnoughSpaceOnPossible:
      return Se.notEnoughSpaceOnPossibleProposal;
    default:
      return "Unknown";
  }
}
var _u = {}, Ro = {}, XE;
function $z() {
  if (XE) return Ro;
  XE = 1, Ro.byteLength = a, Ro.toByteArray = f, Ro.fromByteArray = E;
  for (var e = [], t = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, o = n.length; i < o; ++i)
    e[i] = n[i], t[n.charCodeAt(i)] = i;
  t[45] = 62, t[95] = 63;
  function s(d) {
    var g = d.length;
    if (g % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var y = d.indexOf("=");
    y === -1 && (y = g);
    var b = y === g ? 0 : 4 - y % 4;
    return [y, b];
  }
  function a(d) {
    var g = s(d), y = g[0], b = g[1];
    return (y + b) * 3 / 4 - b;
  }
  function l(d, g, y) {
    return (g + y) * 3 / 4 - y;
  }
  function f(d) {
    var g, y = s(d), b = y[0], I = y[1], S = new r(l(d, b, I)), w = 0, P = I > 0 ? b - 4 : b, _;
    for (_ = 0; _ < P; _ += 4)
      g = t[d.charCodeAt(_)] << 18 | t[d.charCodeAt(_ + 1)] << 12 | t[d.charCodeAt(_ + 2)] << 6 | t[d.charCodeAt(_ + 3)], S[w++] = g >> 16 & 255, S[w++] = g >> 8 & 255, S[w++] = g & 255;
    return I === 2 && (g = t[d.charCodeAt(_)] << 2 | t[d.charCodeAt(_ + 1)] >> 4, S[w++] = g & 255), I === 1 && (g = t[d.charCodeAt(_)] << 10 | t[d.charCodeAt(_ + 1)] << 4 | t[d.charCodeAt(_ + 2)] >> 2, S[w++] = g >> 8 & 255, S[w++] = g & 255), S;
  }
  function u(d) {
    return e[d >> 18 & 63] + e[d >> 12 & 63] + e[d >> 6 & 63] + e[d & 63];
  }
  function h(d, g, y) {
    for (var b, I = [], S = g; S < y; S += 3)
      b = (d[S] << 16 & 16711680) + (d[S + 1] << 8 & 65280) + (d[S + 2] & 255), I.push(u(b));
    return I.join("");
  }
  function E(d) {
    for (var g, y = d.length, b = y % 3, I = [], S = 16383, w = 0, P = y - b; w < P; w += S)
      I.push(h(d, w, w + S > P ? P : w + S));
    return b === 1 ? (g = d[y - 1], I.push(
      e[g >> 2] + e[g << 4 & 63] + "=="
    )) : b === 2 && (g = (d[y - 2] << 8) + d[y - 1], I.push(
      e[g >> 10] + e[g >> 4 & 63] + e[g << 2 & 63] + "="
    )), I.join("");
  }
  return Ro;
}
var gs = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var QE;
function Fz() {
  return QE || (QE = 1, gs.read = function(e, t, r, n, i) {
    var o, s, a = i * 8 - n - 1, l = (1 << a) - 1, f = l >> 1, u = -7, h = r ? i - 1 : 0, E = r ? -1 : 1, d = e[t + h];
    for (h += E, o = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; o = o * 256 + e[t + h], h += E, u -= 8)
      ;
    for (s = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; s = s * 256 + e[t + h], h += E, u -= 8)
      ;
    if (o === 0)
      o = 1 - f;
    else {
      if (o === l)
        return s ? NaN : (d ? -1 : 1) * (1 / 0);
      s = s + Math.pow(2, n), o = o - f;
    }
    return (d ? -1 : 1) * s * Math.pow(2, o - n);
  }, gs.write = function(e, t, r, n, i, o) {
    var s, a, l, f = o * 8 - i - 1, u = (1 << f) - 1, h = u >> 1, E = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : o - 1, g = n ? 1 : -1, y = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = u) : (s = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), s + h >= 1 ? t += E / l : t += E * Math.pow(2, 1 - h), t * l >= 2 && (s++, l /= 2), s + h >= u ? (a = 0, s = u) : s + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), s = s + h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; e[r + d] = a & 255, d += g, a /= 256, i -= 8)
      ;
    for (s = s << i | a, f += i; f > 0; e[r + d] = s & 255, d += g, s /= 256, f -= 8)
      ;
    e[r + d - g] |= y * 128;
  }), gs;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var eg;
function zz() {
  return eg || (eg = 1, (function(e) {
    var t = $z(), r = Fz(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = a, e.SlowBuffer = S, e.INSPECT_MAX_BYTES = 50;
    var i = 2147483647;
    e.kMaxLength = i, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function o() {
      try {
        var p = new Uint8Array(1), c = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(c, Uint8Array.prototype), Object.setPrototypeOf(p, c), p.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(a.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(a.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.byteOffset;
      }
    });
    function s(p) {
      if (p > i)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
      var c = new Uint8Array(p);
      return Object.setPrototypeOf(c, a.prototype), c;
    }
    function a(p, c, m) {
      if (typeof p == "number") {
        if (typeof c == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return h(p);
      }
      return l(p, c, m);
    }
    a.poolSize = 8192;
    function l(p, c, m) {
      if (typeof p == "string")
        return E(p, c);
      if (ArrayBuffer.isView(p))
        return g(p);
      if (p == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
        );
      if (Re(p, ArrayBuffer) || p && Re(p.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Re(p, SharedArrayBuffer) || p && Re(p.buffer, SharedArrayBuffer)))
        return y(p, c, m);
      if (typeof p == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var T = p.valueOf && p.valueOf();
      if (T != null && T !== p)
        return a.from(T, c, m);
      var O = b(p);
      if (O) return O;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function")
        return a.from(
          p[Symbol.toPrimitive]("string"),
          c,
          m
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
      );
    }
    a.from = function(p, c, m) {
      return l(p, c, m);
    }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
    function f(p) {
      if (typeof p != "number")
        throw new TypeError('"size" argument must be of type number');
      if (p < 0)
        throw new RangeError('The value "' + p + '" is invalid for option "size"');
    }
    function u(p, c, m) {
      return f(p), p <= 0 ? s(p) : c !== void 0 ? typeof m == "string" ? s(p).fill(c, m) : s(p).fill(c) : s(p);
    }
    a.alloc = function(p, c, m) {
      return u(p, c, m);
    };
    function h(p) {
      return f(p), s(p < 0 ? 0 : I(p) | 0);
    }
    a.allocUnsafe = function(p) {
      return h(p);
    }, a.allocUnsafeSlow = function(p) {
      return h(p);
    };
    function E(p, c) {
      if ((typeof c != "string" || c === "") && (c = "utf8"), !a.isEncoding(c))
        throw new TypeError("Unknown encoding: " + c);
      var m = w(p, c) | 0, T = s(m), O = T.write(p, c);
      return O !== m && (T = T.slice(0, O)), T;
    }
    function d(p) {
      for (var c = p.length < 0 ? 0 : I(p.length) | 0, m = s(c), T = 0; T < c; T += 1)
        m[T] = p[T] & 255;
      return m;
    }
    function g(p) {
      if (Re(p, Uint8Array)) {
        var c = new Uint8Array(p);
        return y(c.buffer, c.byteOffset, c.byteLength);
      }
      return d(p);
    }
    function y(p, c, m) {
      if (c < 0 || p.byteLength < c)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (p.byteLength < c + (m || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var T;
      return c === void 0 && m === void 0 ? T = new Uint8Array(p) : m === void 0 ? T = new Uint8Array(p, c) : T = new Uint8Array(p, c, m), Object.setPrototypeOf(T, a.prototype), T;
    }
    function b(p) {
      if (a.isBuffer(p)) {
        var c = I(p.length) | 0, m = s(c);
        return m.length === 0 || p.copy(m, 0, 0, c), m;
      }
      if (p.length !== void 0)
        return typeof p.length != "number" || nt(p.length) ? s(0) : d(p);
      if (p.type === "Buffer" && Array.isArray(p.data))
        return d(p.data);
    }
    function I(p) {
      if (p >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return p | 0;
    }
    function S(p) {
      return +p != p && (p = 0), a.alloc(+p);
    }
    a.isBuffer = function(c) {
      return c != null && c._isBuffer === !0 && c !== a.prototype;
    }, a.compare = function(c, m) {
      if (Re(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), Re(m, Uint8Array) && (m = a.from(m, m.offset, m.byteLength)), !a.isBuffer(c) || !a.isBuffer(m))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (c === m) return 0;
      for (var T = c.length, O = m.length, j = 0, q = Math.min(T, O); j < q; ++j)
        if (c[j] !== m[j]) {
          T = c[j], O = m[j];
          break;
        }
      return T < O ? -1 : O < T ? 1 : 0;
    }, a.isEncoding = function(c) {
      switch (String(c).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, a.concat = function(c, m) {
      if (!Array.isArray(c))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (c.length === 0)
        return a.alloc(0);
      var T;
      if (m === void 0)
        for (m = 0, T = 0; T < c.length; ++T)
          m += c[T].length;
      var O = a.allocUnsafe(m), j = 0;
      for (T = 0; T < c.length; ++T) {
        var q = c[T];
        if (Re(q, Uint8Array))
          j + q.length > O.length ? a.from(q).copy(O, j) : Uint8Array.prototype.set.call(
            O,
            q,
            j
          );
        else if (a.isBuffer(q))
          q.copy(O, j);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        j += q.length;
      }
      return O;
    };
    function w(p, c) {
      if (a.isBuffer(p))
        return p.length;
      if (ArrayBuffer.isView(p) || Re(p, ArrayBuffer))
        return p.byteLength;
      if (typeof p != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof p
        );
      var m = p.length, T = arguments.length > 2 && arguments[2] === !0;
      if (!T && m === 0) return 0;
      for (var O = !1; ; )
        switch (c) {
          case "ascii":
          case "latin1":
          case "binary":
            return m;
          case "utf8":
          case "utf-8":
            return Le(p).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return m * 2;
          case "hex":
            return m >>> 1;
          case "base64":
            return $e(p).length;
          default:
            if (O)
              return T ? -1 : Le(p).length;
            c = ("" + c).toLowerCase(), O = !0;
        }
    }
    a.byteLength = w;
    function P(p, c, m) {
      var T = !1;
      if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((m === void 0 || m > this.length) && (m = this.length), m <= 0) || (m >>>= 0, c >>>= 0, m <= c))
        return "";
      for (p || (p = "utf8"); ; )
        switch (p) {
          case "hex":
            return te(this, c, m);
          case "utf8":
          case "utf-8":
            return B(this, c, m);
          case "ascii":
            return Z(this, c, m);
          case "latin1":
          case "binary":
            return V(this, c, m);
          case "base64":
            return de(this, c, m);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ee(this, c, m);
          default:
            if (T) throw new TypeError("Unknown encoding: " + p);
            p = (p + "").toLowerCase(), T = !0;
        }
    }
    a.prototype._isBuffer = !0;
    function _(p, c, m) {
      var T = p[c];
      p[c] = p[m], p[m] = T;
    }
    a.prototype.swap16 = function() {
      var c = this.length;
      if (c % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var m = 0; m < c; m += 2)
        _(this, m, m + 1);
      return this;
    }, a.prototype.swap32 = function() {
      var c = this.length;
      if (c % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var m = 0; m < c; m += 4)
        _(this, m, m + 3), _(this, m + 1, m + 2);
      return this;
    }, a.prototype.swap64 = function() {
      var c = this.length;
      if (c % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var m = 0; m < c; m += 8)
        _(this, m, m + 7), _(this, m + 1, m + 6), _(this, m + 2, m + 5), _(this, m + 3, m + 4);
      return this;
    }, a.prototype.toString = function() {
      var c = this.length;
      return c === 0 ? "" : arguments.length === 0 ? B(this, 0, c) : P.apply(this, arguments);
    }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(c) {
      if (!a.isBuffer(c)) throw new TypeError("Argument must be a Buffer");
      return this === c ? !0 : a.compare(this, c) === 0;
    }, a.prototype.inspect = function() {
      var c = "", m = e.INSPECT_MAX_BYTES;
      return c = this.toString("hex", 0, m).replace(/(.{2})/g, "$1 ").trim(), this.length > m && (c += " ... "), "<Buffer " + c + ">";
    }, n && (a.prototype[n] = a.prototype.inspect), a.prototype.compare = function(c, m, T, O, j) {
      if (Re(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), !a.isBuffer(c))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof c
        );
      if (m === void 0 && (m = 0), T === void 0 && (T = c ? c.length : 0), O === void 0 && (O = 0), j === void 0 && (j = this.length), m < 0 || T > c.length || O < 0 || j > this.length)
        throw new RangeError("out of range index");
      if (O >= j && m >= T)
        return 0;
      if (O >= j)
        return -1;
      if (m >= T)
        return 1;
      if (m >>>= 0, T >>>= 0, O >>>= 0, j >>>= 0, this === c) return 0;
      for (var q = j - O, ae = T - m, Te = Math.min(q, ae), U = this.slice(O, j), J = c.slice(m, T), H = 0; H < Te; ++H)
        if (U[H] !== J[H]) {
          q = U[H], ae = J[H];
          break;
        }
      return q < ae ? -1 : ae < q ? 1 : 0;
    };
    function v(p, c, m, T, O) {
      if (p.length === 0) return -1;
      if (typeof m == "string" ? (T = m, m = 0) : m > 2147483647 ? m = 2147483647 : m < -2147483648 && (m = -2147483648), m = +m, nt(m) && (m = O ? 0 : p.length - 1), m < 0 && (m = p.length + m), m >= p.length) {
        if (O) return -1;
        m = p.length - 1;
      } else if (m < 0)
        if (O) m = 0;
        else return -1;
      if (typeof c == "string" && (c = a.from(c, T)), a.isBuffer(c))
        return c.length === 0 ? -1 : M(p, c, m, T, O);
      if (typeof c == "number")
        return c = c & 255, typeof Uint8Array.prototype.indexOf == "function" ? O ? Uint8Array.prototype.indexOf.call(p, c, m) : Uint8Array.prototype.lastIndexOf.call(p, c, m) : M(p, [c], m, T, O);
      throw new TypeError("val must be string, number or Buffer");
    }
    function M(p, c, m, T, O) {
      var j = 1, q = p.length, ae = c.length;
      if (T !== void 0 && (T = String(T).toLowerCase(), T === "ucs2" || T === "ucs-2" || T === "utf16le" || T === "utf-16le")) {
        if (p.length < 2 || c.length < 2)
          return -1;
        j = 2, q /= 2, ae /= 2, m /= 2;
      }
      function Te(Ce, We) {
        return j === 1 ? Ce[We] : Ce.readUInt16BE(We * j);
      }
      var U;
      if (O) {
        var J = -1;
        for (U = m; U < q; U++)
          if (Te(p, U) === Te(c, J === -1 ? 0 : U - J)) {
            if (J === -1 && (J = U), U - J + 1 === ae) return J * j;
          } else
            J !== -1 && (U -= U - J), J = -1;
      } else
        for (m + ae > q && (m = q - ae), U = m; U >= 0; U--) {
          for (var H = !0, ie = 0; ie < ae; ie++)
            if (Te(p, U + ie) !== Te(c, ie)) {
              H = !1;
              break;
            }
          if (H) return U;
        }
      return -1;
    }
    a.prototype.includes = function(c, m, T) {
      return this.indexOf(c, m, T) !== -1;
    }, a.prototype.indexOf = function(c, m, T) {
      return v(this, c, m, T, !0);
    }, a.prototype.lastIndexOf = function(c, m, T) {
      return v(this, c, m, T, !1);
    };
    function x(p, c, m, T) {
      m = Number(m) || 0;
      var O = p.length - m;
      T ? (T = Number(T), T > O && (T = O)) : T = O;
      var j = c.length;
      T > j / 2 && (T = j / 2);
      for (var q = 0; q < T; ++q) {
        var ae = parseInt(c.substr(q * 2, 2), 16);
        if (nt(ae)) return q;
        p[m + q] = ae;
      }
      return q;
    }
    function z(p, c, m, T) {
      return Ne(Le(c, p.length - m), p, m, T);
    }
    function F(p, c, m, T) {
      return Ne(Ve(c), p, m, T);
    }
    function W(p, c, m, T) {
      return Ne($e(c), p, m, T);
    }
    function X(p, c, m, T) {
      return Ne(Ie(c, p.length - m), p, m, T);
    }
    a.prototype.write = function(c, m, T, O) {
      if (m === void 0)
        O = "utf8", T = this.length, m = 0;
      else if (T === void 0 && typeof m == "string")
        O = m, T = this.length, m = 0;
      else if (isFinite(m))
        m = m >>> 0, isFinite(T) ? (T = T >>> 0, O === void 0 && (O = "utf8")) : (O = T, T = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var j = this.length - m;
      if ((T === void 0 || T > j) && (T = j), c.length > 0 && (T < 0 || m < 0) || m > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      O || (O = "utf8");
      for (var q = !1; ; )
        switch (O) {
          case "hex":
            return x(this, c, m, T);
          case "utf8":
          case "utf-8":
            return z(this, c, m, T);
          case "ascii":
          case "latin1":
          case "binary":
            return F(this, c, m, T);
          case "base64":
            return W(this, c, m, T);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return X(this, c, m, T);
          default:
            if (q) throw new TypeError("Unknown encoding: " + O);
            O = ("" + O).toLowerCase(), q = !0;
        }
    }, a.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function de(p, c, m) {
      return c === 0 && m === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(c, m));
    }
    function B(p, c, m) {
      m = Math.min(p.length, m);
      for (var T = [], O = c; O < m; ) {
        var j = p[O], q = null, ae = j > 239 ? 4 : j > 223 ? 3 : j > 191 ? 2 : 1;
        if (O + ae <= m) {
          var Te, U, J, H;
          switch (ae) {
            case 1:
              j < 128 && (q = j);
              break;
            case 2:
              Te = p[O + 1], (Te & 192) === 128 && (H = (j & 31) << 6 | Te & 63, H > 127 && (q = H));
              break;
            case 3:
              Te = p[O + 1], U = p[O + 2], (Te & 192) === 128 && (U & 192) === 128 && (H = (j & 15) << 12 | (Te & 63) << 6 | U & 63, H > 2047 && (H < 55296 || H > 57343) && (q = H));
              break;
            case 4:
              Te = p[O + 1], U = p[O + 2], J = p[O + 3], (Te & 192) === 128 && (U & 192) === 128 && (J & 192) === 128 && (H = (j & 15) << 18 | (Te & 63) << 12 | (U & 63) << 6 | J & 63, H > 65535 && H < 1114112 && (q = H));
          }
        }
        q === null ? (q = 65533, ae = 1) : q > 65535 && (q -= 65536, T.push(q >>> 10 & 1023 | 55296), q = 56320 | q & 1023), T.push(q), O += ae;
      }
      return G(T);
    }
    var L = 4096;
    function G(p) {
      var c = p.length;
      if (c <= L)
        return String.fromCharCode.apply(String, p);
      for (var m = "", T = 0; T < c; )
        m += String.fromCharCode.apply(
          String,
          p.slice(T, T += L)
        );
      return m;
    }
    function Z(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var O = c; O < m; ++O)
        T += String.fromCharCode(p[O] & 127);
      return T;
    }
    function V(p, c, m) {
      var T = "";
      m = Math.min(p.length, m);
      for (var O = c; O < m; ++O)
        T += String.fromCharCode(p[O]);
      return T;
    }
    function te(p, c, m) {
      var T = p.length;
      (!c || c < 0) && (c = 0), (!m || m < 0 || m > T) && (m = T);
      for (var O = "", j = c; j < m; ++j)
        O += nn[p[j]];
      return O;
    }
    function ee(p, c, m) {
      for (var T = p.slice(c, m), O = "", j = 0; j < T.length - 1; j += 2)
        O += String.fromCharCode(T[j] + T[j + 1] * 256);
      return O;
    }
    a.prototype.slice = function(c, m) {
      var T = this.length;
      c = ~~c, m = m === void 0 ? T : ~~m, c < 0 ? (c += T, c < 0 && (c = 0)) : c > T && (c = T), m < 0 ? (m += T, m < 0 && (m = 0)) : m > T && (m = T), m < c && (m = c);
      var O = this.subarray(c, m);
      return Object.setPrototypeOf(O, a.prototype), O;
    };
    function Q(p, c, m) {
      if (p % 1 !== 0 || p < 0) throw new RangeError("offset is not uint");
      if (p + c > m) throw new RangeError("Trying to access beyond buffer length");
    }
    a.prototype.readUintLE = a.prototype.readUIntLE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || Q(c, m, this.length);
      for (var O = this[c], j = 1, q = 0; ++q < m && (j *= 256); )
        O += this[c + q] * j;
      return O;
    }, a.prototype.readUintBE = a.prototype.readUIntBE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || Q(c, m, this.length);
      for (var O = this[c + --m], j = 1; m > 0 && (j *= 256); )
        O += this[c + --m] * j;
      return O;
    }, a.prototype.readUint8 = a.prototype.readUInt8 = function(c, m) {
      return c = c >>> 0, m || Q(c, 1, this.length), this[c];
    }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(c, m) {
      return c = c >>> 0, m || Q(c, 2, this.length), this[c] | this[c + 1] << 8;
    }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(c, m) {
      return c = c >>> 0, m || Q(c, 2, this.length), this[c] << 8 | this[c + 1];
    }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(c, m) {
      return c = c >>> 0, m || Q(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + this[c + 3] * 16777216;
    }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(c, m) {
      return c = c >>> 0, m || Q(c, 4, this.length), this[c] * 16777216 + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
    }, a.prototype.readIntLE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || Q(c, m, this.length);
      for (var O = this[c], j = 1, q = 0; ++q < m && (j *= 256); )
        O += this[c + q] * j;
      return j *= 128, O >= j && (O -= Math.pow(2, 8 * m)), O;
    }, a.prototype.readIntBE = function(c, m, T) {
      c = c >>> 0, m = m >>> 0, T || Q(c, m, this.length);
      for (var O = m, j = 1, q = this[c + --O]; O > 0 && (j *= 256); )
        q += this[c + --O] * j;
      return j *= 128, q >= j && (q -= Math.pow(2, 8 * m)), q;
    }, a.prototype.readInt8 = function(c, m) {
      return c = c >>> 0, m || Q(c, 1, this.length), this[c] & 128 ? (255 - this[c] + 1) * -1 : this[c];
    }, a.prototype.readInt16LE = function(c, m) {
      c = c >>> 0, m || Q(c, 2, this.length);
      var T = this[c] | this[c + 1] << 8;
      return T & 32768 ? T | 4294901760 : T;
    }, a.prototype.readInt16BE = function(c, m) {
      c = c >>> 0, m || Q(c, 2, this.length);
      var T = this[c + 1] | this[c] << 8;
      return T & 32768 ? T | 4294901760 : T;
    }, a.prototype.readInt32LE = function(c, m) {
      return c = c >>> 0, m || Q(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
    }, a.prototype.readInt32BE = function(c, m) {
      return c = c >>> 0, m || Q(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
    }, a.prototype.readFloatLE = function(c, m) {
      return c = c >>> 0, m || Q(c, 4, this.length), r.read(this, c, !0, 23, 4);
    }, a.prototype.readFloatBE = function(c, m) {
      return c = c >>> 0, m || Q(c, 4, this.length), r.read(this, c, !1, 23, 4);
    }, a.prototype.readDoubleLE = function(c, m) {
      return c = c >>> 0, m || Q(c, 8, this.length), r.read(this, c, !0, 52, 8);
    }, a.prototype.readDoubleBE = function(c, m) {
      return c = c >>> 0, m || Q(c, 8, this.length), r.read(this, c, !1, 52, 8);
    };
    function re(p, c, m, T, O, j) {
      if (!a.isBuffer(p)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (c > O || c < j) throw new RangeError('"value" argument is out of bounds');
      if (m + T > p.length) throw new RangeError("Index out of range");
    }
    a.prototype.writeUintLE = a.prototype.writeUIntLE = function(c, m, T, O) {
      if (c = +c, m = m >>> 0, T = T >>> 0, !O) {
        var j = Math.pow(2, 8 * T) - 1;
        re(this, c, m, T, j, 0);
      }
      var q = 1, ae = 0;
      for (this[m] = c & 255; ++ae < T && (q *= 256); )
        this[m + ae] = c / q & 255;
      return m + T;
    }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(c, m, T, O) {
      if (c = +c, m = m >>> 0, T = T >>> 0, !O) {
        var j = Math.pow(2, 8 * T) - 1;
        re(this, c, m, T, j, 0);
      }
      var q = T - 1, ae = 1;
      for (this[m + q] = c & 255; --q >= 0 && (ae *= 256); )
        this[m + q] = c / ae & 255;
      return m + T;
    }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 1, 255, 0), this[m] = c & 255, m + 1;
    }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 2, 65535, 0), this[m] = c & 255, this[m + 1] = c >>> 8, m + 2;
    }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 2, 65535, 0), this[m] = c >>> 8, this[m + 1] = c & 255, m + 2;
    }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 4, 4294967295, 0), this[m + 3] = c >>> 24, this[m + 2] = c >>> 16, this[m + 1] = c >>> 8, this[m] = c & 255, m + 4;
    }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 4, 4294967295, 0), this[m] = c >>> 24, this[m + 1] = c >>> 16, this[m + 2] = c >>> 8, this[m + 3] = c & 255, m + 4;
    }, a.prototype.writeIntLE = function(c, m, T, O) {
      if (c = +c, m = m >>> 0, !O) {
        var j = Math.pow(2, 8 * T - 1);
        re(this, c, m, T, j - 1, -j);
      }
      var q = 0, ae = 1, Te = 0;
      for (this[m] = c & 255; ++q < T && (ae *= 256); )
        c < 0 && Te === 0 && this[m + q - 1] !== 0 && (Te = 1), this[m + q] = (c / ae >> 0) - Te & 255;
      return m + T;
    }, a.prototype.writeIntBE = function(c, m, T, O) {
      if (c = +c, m = m >>> 0, !O) {
        var j = Math.pow(2, 8 * T - 1);
        re(this, c, m, T, j - 1, -j);
      }
      var q = T - 1, ae = 1, Te = 0;
      for (this[m + q] = c & 255; --q >= 0 && (ae *= 256); )
        c < 0 && Te === 0 && this[m + q + 1] !== 0 && (Te = 1), this[m + q] = (c / ae >> 0) - Te & 255;
      return m + T;
    }, a.prototype.writeInt8 = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 1, 127, -128), c < 0 && (c = 255 + c + 1), this[m] = c & 255, m + 1;
    }, a.prototype.writeInt16LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 2, 32767, -32768), this[m] = c & 255, this[m + 1] = c >>> 8, m + 2;
    }, a.prototype.writeInt16BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 2, 32767, -32768), this[m] = c >>> 8, this[m + 1] = c & 255, m + 2;
    }, a.prototype.writeInt32LE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 4, 2147483647, -2147483648), this[m] = c & 255, this[m + 1] = c >>> 8, this[m + 2] = c >>> 16, this[m + 3] = c >>> 24, m + 4;
    }, a.prototype.writeInt32BE = function(c, m, T) {
      return c = +c, m = m >>> 0, T || re(this, c, m, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), this[m] = c >>> 24, this[m + 1] = c >>> 16, this[m + 2] = c >>> 8, this[m + 3] = c & 255, m + 4;
    };
    function ne(p, c, m, T, O, j) {
      if (m + T > p.length) throw new RangeError("Index out of range");
      if (m < 0) throw new RangeError("Index out of range");
    }
    function Ee(p, c, m, T, O) {
      return c = +c, m = m >>> 0, O || ne(p, c, m, 4), r.write(p, c, m, T, 23, 4), m + 4;
    }
    a.prototype.writeFloatLE = function(c, m, T) {
      return Ee(this, c, m, !0, T);
    }, a.prototype.writeFloatBE = function(c, m, T) {
      return Ee(this, c, m, !1, T);
    };
    function be(p, c, m, T, O) {
      return c = +c, m = m >>> 0, O || ne(p, c, m, 8), r.write(p, c, m, T, 52, 8), m + 8;
    }
    a.prototype.writeDoubleLE = function(c, m, T) {
      return be(this, c, m, !0, T);
    }, a.prototype.writeDoubleBE = function(c, m, T) {
      return be(this, c, m, !1, T);
    }, a.prototype.copy = function(c, m, T, O) {
      if (!a.isBuffer(c)) throw new TypeError("argument should be a Buffer");
      if (T || (T = 0), !O && O !== 0 && (O = this.length), m >= c.length && (m = c.length), m || (m = 0), O > 0 && O < T && (O = T), O === T || c.length === 0 || this.length === 0) return 0;
      if (m < 0)
        throw new RangeError("targetStart out of bounds");
      if (T < 0 || T >= this.length) throw new RangeError("Index out of range");
      if (O < 0) throw new RangeError("sourceEnd out of bounds");
      O > this.length && (O = this.length), c.length - m < O - T && (O = c.length - m + T);
      var j = O - T;
      return this === c && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(m, T, O) : Uint8Array.prototype.set.call(
        c,
        this.subarray(T, O),
        m
      ), j;
    }, a.prototype.fill = function(c, m, T, O) {
      if (typeof c == "string") {
        if (typeof m == "string" ? (O = m, m = 0, T = this.length) : typeof T == "string" && (O = T, T = this.length), O !== void 0 && typeof O != "string")
          throw new TypeError("encoding must be a string");
        if (typeof O == "string" && !a.isEncoding(O))
          throw new TypeError("Unknown encoding: " + O);
        if (c.length === 1) {
          var j = c.charCodeAt(0);
          (O === "utf8" && j < 128 || O === "latin1") && (c = j);
        }
      } else typeof c == "number" ? c = c & 255 : typeof c == "boolean" && (c = Number(c));
      if (m < 0 || this.length < m || this.length < T)
        throw new RangeError("Out of range index");
      if (T <= m)
        return this;
      m = m >>> 0, T = T === void 0 ? this.length : T >>> 0, c || (c = 0);
      var q;
      if (typeof c == "number")
        for (q = m; q < T; ++q)
          this[q] = c;
      else {
        var ae = a.isBuffer(c) ? c : a.from(c, O), Te = ae.length;
        if (Te === 0)
          throw new TypeError('The value "' + c + '" is invalid for argument "value"');
        for (q = 0; q < T - m; ++q)
          this[q + m] = ae[q % Te];
      }
      return this;
    };
    var Be = /[^+/0-9A-Za-z-_]/g;
    function Ue(p) {
      if (p = p.split("=")[0], p = p.trim().replace(Be, ""), p.length < 2) return "";
      for (; p.length % 4 !== 0; )
        p = p + "=";
      return p;
    }
    function Le(p, c) {
      c = c || 1 / 0;
      for (var m, T = p.length, O = null, j = [], q = 0; q < T; ++q) {
        if (m = p.charCodeAt(q), m > 55295 && m < 57344) {
          if (!O) {
            if (m > 56319) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            } else if (q + 1 === T) {
              (c -= 3) > -1 && j.push(239, 191, 189);
              continue;
            }
            O = m;
            continue;
          }
          if (m < 56320) {
            (c -= 3) > -1 && j.push(239, 191, 189), O = m;
            continue;
          }
          m = (O - 55296 << 10 | m - 56320) + 65536;
        } else O && (c -= 3) > -1 && j.push(239, 191, 189);
        if (O = null, m < 128) {
          if ((c -= 1) < 0) break;
          j.push(m);
        } else if (m < 2048) {
          if ((c -= 2) < 0) break;
          j.push(
            m >> 6 | 192,
            m & 63 | 128
          );
        } else if (m < 65536) {
          if ((c -= 3) < 0) break;
          j.push(
            m >> 12 | 224,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else if (m < 1114112) {
          if ((c -= 4) < 0) break;
          j.push(
            m >> 18 | 240,
            m >> 12 & 63 | 128,
            m >> 6 & 63 | 128,
            m & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return j;
    }
    function Ve(p) {
      for (var c = [], m = 0; m < p.length; ++m)
        c.push(p.charCodeAt(m) & 255);
      return c;
    }
    function Ie(p, c) {
      for (var m, T, O, j = [], q = 0; q < p.length && !((c -= 2) < 0); ++q)
        m = p.charCodeAt(q), T = m >> 8, O = m % 256, j.push(O), j.push(T);
      return j;
    }
    function $e(p) {
      return t.toByteArray(Ue(p));
    }
    function Ne(p, c, m, T) {
      for (var O = 0; O < T && !(O + m >= c.length || O >= p.length); ++O)
        c[O + m] = p[O];
      return O;
    }
    function Re(p, c) {
      return p instanceof c || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === c.name;
    }
    function nt(p) {
      return p !== p;
    }
    var nn = (function() {
      for (var p = "0123456789abcdef", c = new Array(256), m = 0; m < 16; ++m)
        for (var T = m * 16, O = 0; O < 16; ++O)
          c[T + O] = p[m] + p[O];
      return c;
    })();
  })(_u)), _u;
}
var Go = zz();
const PB = [
  {
    jobId: "job1",
    startTime: "2024-12-18T00:00:00Z",
    createdAt: "2024-12-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "pending",
    issues: 0,
    username: {
      creator: "Username1"
    },
    settings: wt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], DB = [
  {
    jobId: "job2",
    startTime: "2024-11-18T00:00:00Z",
    createdAt: "2024-11-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "completed",
    username: {
      creator: "Username2"
    },
    issues: 5,
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: wt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], MB = [
  {
    jobId: "job3",
    startTime: "2024-10-18T00:00:00Z",
    createdAt: "2024-10-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "allocated",
    username: {
      creator: "Username3",
      allocator: "Username4"
    },
    issues: 5,
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: wt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    },
    allocationResult: {
      userId: "user3",
      time: "2024-11-18T00:00:00Z",
      allocationTime: "2024-11-18T00:00:00.000Z",
      // ISO string
      logId: "logid"
    }
  }
], LB = [
  {
    jobId: "job1",
    startTime: "2024-12-18T00:00:00Z",
    createdAt: "2024-12-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "pending",
    issues: 0,
    inputData: Go.Buffer.from("inputData"),
    settings: wt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], xB = [
  {
    jobId: "job2",
    startTime: "2024-11-18T00:00:00Z",
    createdAt: "2024-11-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "completed",
    issues: 5,
    inputData: Go.Buffer.from("inputData"),
    outputData: Go.Buffer.from("outputData"),
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: wt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    }
  }
], kB = [
  {
    jobId: "job3",
    startTime: "2024-10-18T00:00:00Z",
    createdAt: "2024-10-18T00:00:00.000Z",
    // ISO string
    userId: "user1",
    inputUrl: "https://example.com/input",
    status: "allocated",
    issues: 5,
    proposalResult: {
      nofStudents: 10,
      nofCompleteStudents: 5
    },
    outputUrl: "gs://example.com/output",
    settings: wt,
    selection: {
      courses: [],
      studentSetGroups: 0,
      incompleteStudents: 0,
      totalStudents: 0
    },
    allocationResult: {
      failedGroups: {},
      userId: "user3",
      time: "2024-11-18T00:00:00Z",
      allocationTime: "2024-11-18T00:00:00.000Z",
      // ISO string
      logId: "logid"
    },
    inputData: Go.Buffer.from("input"),
    outputData: Go.Buffer.from("output")
  }
], AA = {
  server: {
    extId: "SERVER",
    name: "LittleServerTimeZoneName",
    identifier: "Europe/Stockholm",
    offset: "UTC+1"
  },
  user: {
    extId: "USER",
    name: "LittleUserTimeZoneName",
    identifier: "Europe/Stockholm",
    offset: "UTC+1"
  }
}, jB = {
  currentDateTime: {
    local: "2023-08-24 00:00:00",
    timezone: "Europe/Stockholm",
    unix: 1692879672
  },
  offsetDateTime: {
    local: "2023-08-24 00:00:00",
    timezone: "Europe/Stockholm",
    unix: 1692879672
  }
}, UB = [
  {
    id: 1,
    extId: "CET",
    name: "Central European Time",
    timeZone: "CET",
    identifiers: ["Europe/Stockholm"],
    isDefault: !0,
    offset: "UTC+1"
  },
  {
    id: 2,
    extId: "NZT",
    name: "New Zealand Time",
    timeZone: "NZST",
    identifiers: ["Pacific/Auckland"],
    isDefault: !1,
    offset: "UTC+10"
  }
], Fe = {
  refSeparator: " ",
  searchable: !1,
  defaultValue: "",
  checkSum: 0,
  categories: [],
  referenceFields: [],
  types: []
}, Gz = [
  {
    ...Fe,
    id: 101,
    extId: "ext1",
    name: "field1",
    categories: ["Cat 1", "Cat 2"],
    searchable: !0,
    fieldType: C.EFieldType.TEXT,
    mandatory: !0,
    types: [220]
  },
  {
    ...Fe,
    id: 102,
    extId: "ext2",
    name: "field2",
    categories: ["Cat 3", "Cat 4", "Cat 5"],
    searchable: !0,
    fieldType: C.EFieldType.SIGNATURE,
    mandatory: !0,
    types: [220]
  },
  {
    ...Fe,
    id: 103,
    extId: "ext3",
    name: "field3",
    fieldType: C.EFieldType.TEXT,
    types: [220]
  },
  {
    ...Fe,
    id: 104,
    extId: "ext4",
    name: "field4",
    fieldType: C.EFieldType.TEXT,
    types: [220]
  },
  {
    ...Fe,
    id: 105,
    extId: "ext5",
    name: "field5",
    fieldType: C.EFieldType.CATEGORY
  },
  {
    ...Fe,
    id: 106,
    extId: "ext6",
    name: "field6",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 107,
    extId: "ext7",
    name: "field7",
    fieldType: C.EFieldType.LENGTH
  },
  {
    ...Fe,
    id: 108,
    extId: "ext8",
    name: "field8",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 109,
    extId: "ext9",
    name: "Max capacity",
    fieldType: C.EFieldType.INTEGER
  },
  {
    ...Fe,
    id: 118,
    extId: "ext118",
    name: "Hide group",
    fieldType: C.EFieldType.CHECKBOX
  },
  {
    ...Fe,
    id: 110,
    extId: "ext10",
    name: "field10",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 111,
    extId: "extActivity",
    name: "Activity",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 112,
    extId: "ext12",
    name: "field12",
    fieldType: C.EFieldType.CATEGORY,
    categories: ["SELECT", "NONE", "PREFERENCES"]
  },
  {
    ...Fe,
    id: 113,
    extId: "ext13",
    name: "Start date",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 114,
    extId: "ext14",
    name: "End date",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 115,
    extId: "ext15",
    name: "field15",
    fieldType: C.EFieldType.CATEGORY,
    categories: ["DURING_INTERVAL", "FORCE_OFF", "FORCE_ON"]
  },
  {
    ...Fe,
    id: 116,
    extId: "ext16",
    name: "Buffer",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 117,
    extId: "ext17",
    name: "field17",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 119,
    extId: "ext19",
    name: "field19",
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 120,
    extId: "ext120",
    name: "field120",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 177,
    extId: "ext177",
    name: "referenceField177",
    fieldType: C.EFieldType.TEXT,
    referenceFields: [106, 119],
    refSeparator: "-"
  },
  {
    ...Fe,
    id: 182,
    extId: "ext182",
    name: "field182",
    fieldType: C.EFieldType.CATEGORY,
    categories: ["Man", "Woman"]
  },
  {
    ...Fe,
    id: 301,
    extId: "ext301",
    name: "field301",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 401,
    extId: "ext401",
    name: "field401",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 402,
    extId: "ext402",
    name: "field402",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 501,
    extId: "ext501",
    name: "field501",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 502,
    extId: "ext502",
    name: "field502",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  },
  {
    ...Fe,
    id: 601,
    extId: "ext601",
    name: "field601",
    mandatory: !0,
    fieldType: C.EFieldType.TEXT
  }
], $B = [1, 2, 3], FB = [
  { fieldId: 201, values: ["Masters"] },
  { fieldId: 202, values: ["Swedish"] }
], zB = "Bearer token", GB = "university", Rt = [
  {
    id: 1,
    extId: "MATH-101",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 101,
        values: ["Math 101"]
      },
      {
        fieldId: 102,
        values: ["MATH-101"]
      },
      {
        fieldId: 103,
        values: ["Fall 2023"]
      },
      {
        fieldId: 173,
        values: ["MATH-101-2023"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [4, 5, 6, 7, 8, 9, 12, 13]
      }
    ],
    members: [],
    types: [201]
  },
  {
    id: 4,
    extId: "OBJECT-1",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 1"]
      },
      {
        fieldId: 107,
        values: ["200000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-A"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: ["DURING_INTERVAL"]
      },
      {
        fieldId: 119,
        values: ["1"]
      },
      {
        fieldId: 160,
        values: ["Group 4"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [10]
      },
      {
        start: 0,
        end: 0,
        objectIds: [6]
      },
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    members: [{ start: 0, end: 0, objectId: 12 }],
    types: [203]
  },
  {
    id: 5,
    extId: "OBJECT-2",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 2"]
      },
      {
        fieldId: 107,
        values: ["300000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: ["89"]
      },
      {
        fieldId: 111,
        values: ["GROUP-B"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 116,
        values: ["50%"]
      },
      {
        fieldId: 119,
        values: ["2"]
      },
      {
        fieldId: 160,
        values: ["Group 5"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    members: [
      { start: 0, end: 0, objectId: 12 },
      { start: 0, end: 0, objectId: 13 }
    ],
    types: [203]
  },
  {
    id: 6,
    extId: "OBJECT-3",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 3"]
      },
      {
        fieldId: 107,
        values: ["400000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: ["12", "89"]
      },
      {
        fieldId: 111,
        values: ["GROUP-B"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 119,
        values: ["2"]
      },
      {
        fieldId: 160,
        values: ["Group 6"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [4]
      },
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    types: [203],
    members: []
  },
  {
    id: 7,
    extId: "OBJECT-4",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 4"]
      },
      {
        fieldId: 107,
        values: ["500000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-C"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 119,
        values: ["1"]
      },
      {
        fieldId: 160,
        values: ["Group 7"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    types: [203],
    members: []
  },
  {
    id: 8,
    extId: "OBJECT-5",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 106,
        values: ["Object 5"]
      },
      {
        fieldId: 107,
        values: ["500000"]
      },
      {
        fieldId: 109,
        values: ["5"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-C"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: [""]
      },
      {
        fieldId: 119,
        values: ["2"]
      },
      {
        fieldId: 160,
        values: ["Group 8"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    types: [203],
    members: []
  },
  {
    id: 9,
    extId: "OBJECT-6",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 160,
        values: ["Group 9"]
      },
      {
        fieldId: 106,
        values: ["Object 6"]
      },
      {
        fieldId: 107,
        values: ["600000"]
      },
      {
        fieldId: 109,
        values: ["6"]
      },
      {
        fieldId: 110,
        values: []
      },
      {
        fieldId: 111,
        values: ["GROUP-A"]
      },
      {
        fieldId: 112,
        values: ["SELECT"]
      },
      {
        fieldId: 113,
        values: ["17/07/2023"]
      },
      {
        fieldId: 114,
        values: ["12/11/2023"]
      },
      {
        fieldId: 115,
        values: ["DURING_INTERVAL"]
      },
      {
        fieldId: 119,
        values: ["1"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [1]
      }
    ],
    members: [{ start: 0, end: 0, objectId: 13 }],
    types: [203]
  },
  {
    id: 12,
    extId: "STUDENT-1",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 120,
        values: ["Student 1"]
      }
    ],
    relations: [{ start: 0, end: 0, objectIds: [1, 10] }],
    types: [220],
    members: [{ start: 0, end: 0, objectId: 1 }]
  },
  {
    id: 13,
    extId: "STUDENT-2",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 120,
        values: ["Student 2"]
      }
    ],
    relations: [{ start: 0, end: 0, objectIds: [1, 10] }],
    types: [220],
    members: [{ start: 0, end: 0, objectId: 1 }]
  },
  {
    id: 10,
    extId: "STEM",
    active: !0,
    created: 1723782775,
    abstract: !1,
    virtual: !1,
    fields: [],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [12, 13]
      }
    ],
    members: [],
    types: [204]
  },
  {
    id: 5e3,
    extId: "RoomPart",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 501,
        values: ["Lowerpart"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [12, 13]
      }
    ],
    members: [],
    types: [500]
  },
  {
    id: 6e3,
    extId: "RoomFull",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 601,
        values: ["Full room"]
      }
    ],
    relations: [
      {
        start: 0,
        end: 0,
        objectIds: [12, 13]
      }
    ],
    members: [],
    types: [600]
  },
  {
    id: 6001,
    extId: "Partical math course",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 601,
        values: ["Partical math course"]
      },
      {
        fieldId: 101,
        values: ["Partical math course label"]
      }
    ],
    relations: [],
    members: [],
    types: [2011]
  },
  {
    id: 6020,
    extId: "Parent computer course",
    active: !0,
    created: 1723782735,
    abstract: !1,
    virtual: !1,
    fields: [
      {
        fieldId: 601,
        values: ["Parent computer course"]
      },
      {
        fieldId: 101,
        values: ["Parent computer courseabel"]
      }
    ],
    relations: [],
    members: [],
    types: [200]
  }
], BB = {
  201: [4, 5]
}, VB = [
  {
    id: 201,
    extId: "RESERVATION-MANY_GROUPS",
    begin: 1690444800,
    end: 1690448400,
    objects: [
      { typeId: 203, objectId: 4 },
      { typeId: 203, objectId: 5 }
    ],
    history: {}
  }
], WB = {
  201: [4, 5]
}, qB = [
  {
    id: 201,
    extId: "RESERVATION-MANY_GROUPS",
    begin: 1690444800,
    end: 1690448400,
    objects: [
      { typeId: 203, objectId: 4 },
      { typeId: 203, objectId: 5 }
    ],
    history: {}
  },
  {
    id: 900,
    extId: "RESERVATION-STUDENT-ALONE",
    begin: 1690444800,
    end: 1690448400,
    objects: [{ typeId: 910, objectId: 920 }],
    history: {}
  },
  {
    id: 901,
    extId: "RESERVATION-WITHOUT-OBJECT",
    begin: 1690444800,
    end: 1690448400,
    objects: [],
    history: {}
  }
], HB = {
  301: [4],
  302: [5],
  303: [6],
  304: [7],
  305: [6]
}, YB = [
  {
    id: 301,
    extId: "RESERVATION-1",
    begin: 1690444800,
    end: 1690448400,
    objects: [{ typeId: 203, objectId: 4 }],
    history: {}
  },
  {
    id: 302,
    extId: "RESERVATION-2",
    begin: 1690446600,
    end: 1690450200,
    objects: [{ typeId: 203, objectId: 5 }],
    history: {}
  },
  {
    id: 303,
    extId: "RESERVATION-3",
    begin: 1690441800,
    end: 1690450200,
    objects: [{ typeId: 203, objectId: 6 }],
    history: {}
  },
  {
    id: 304,
    extId: "RESERVATION-4",
    begin: 1690441800,
    end: 1690445400,
    objects: [{ typeId: 203, objectId: 7 }],
    history: {}
  },
  {
    id: 305,
    extId: "RESERVATION-5",
    begin: 1690450200,
    end: 1690666200,
    objects: [{ typeId: 203, objectId: 6 }],
    history: {}
  }
], ZB = {
  region: fi.ERegion.EU_EES,
  id: "64a7d55ed7f76100238fa0e9",
  type: C.ETokenType.USER,
  username: "root@timeedit.com",
  email: "root@timeedit.com",
  organizationId: "6405a438ddd66a00221435f7",
  customerSignature: "cloud_timeedit_ab",
  appPermissions: [],
  scopes: [or.REGISTRATION.USER, or.ALLOCATE.ADMIN, or.ROOT],
  organizationsAndRoles: [],
  iat: 1691662122,
  exp: 1723219722
}, JB = {
  region: fi.ERegion.EU_EES,
  id: "64a7d55ed7f76100238fa0e9",
  type: C.ETokenType.USER,
  username: "consume.test@timeedit.com",
  email: "consume.test@timeedit.com",
  organizationId: "6405a438ddd66a00221435f7",
  customerSignature: "cloud_timeedit_ab",
  appPermissions: [],
  scopes: [or.REGISTRATION.USER],
  organizationsAndRoles: [],
  iat: 1691662122,
  exp: 1723219722
}, KB = {
  id: "64a7d55ed7f76100238fa0e9",
  email: "consume.test@timeedit.com",
  firstName: "Consume",
  lastName: "Test",
  profiles: [
    {
      id: "profile-1",
      profileName: "Default",
      organizationsAndRoles: [],
      scopes: [or.REGISTRATION.USER],
      appPermissions: [],
      userObjects: [],
      inactiveSince: null
    }
  ],
  organizationId: "6405a438ddd66a00221435f7",
  username: "consume.test@timeedit.com",
  scopes: [or.REGISTRATION.USER],
  appPermissions: [],
  userObjects: [],
  timezone: "Europe/Stockholm"
}, XB = {
  courses: {
    1: {
      id: 1,
      extId: "MATH-101",
      typeIds: [201],
      label: "Math 101",
      teObject: Rt.find((e) => e.id === 1),
      children: [4, 5, 6, 7]
    }
  },
  activities: {},
  groups: {
    4: {
      id: 4,
      extId: "OBJECT-1",
      typeIds: [203],
      label: "Object 1",
      teObject: Rt.find((e) => e.id === 4),
      parentId: 1,
      links: [6]
    },
    5: {
      id: 5,
      extId: "OBJECT-2",
      typeIds: [203],
      label: "Object 2",
      teObject: Rt.find((e) => e.id === 5),
      parentId: 1,
      links: []
    },
    6: {
      id: 6,
      extId: "OBJECT-3",
      typeIds: [203],
      label: "Object 3",
      teObject: Rt.find((e) => e.id === 6),
      parentId: 1,
      links: [4]
    },
    7: {
      id: 7,
      extId: "OBJECT-4",
      typeIds: [203],
      label: "Object 4",
      teObject: Rt.find((e) => e.id === 7),
      parentId: 1,
      links: []
    },
    8: {
      id: 8,
      extId: "OBJECT-5",
      typeIds: [203],
      label: "Object 5",
      teObject: Rt.find((e) => e.id === 8),
      parentId: 1,
      links: []
    }
  }
}, Rr = {
  courses: {
    1: {
      id: 1,
      extId: "MATH-101",
      typeIds: [201],
      label: "Math 101",
      children: [1460478604, 1460478605, 1460478606],
      teObject: Rt.find((e) => e.id === 1)
    }
  },
  activities: {
    1460478604: {
      id: 1460478604,
      label: "GROUP-A",
      parentId: 1,
      children: [4, 6]
    },
    1460478605: {
      id: 1460478605,
      label: "GROUP-B",
      parentId: 1,
      children: [5]
    },
    1460478606: {
      id: 1460478606,
      label: "GROUP-C",
      parentId: 1,
      children: [7, 8]
    }
  },
  groups: {
    4: {
      id: 4,
      extId: "OBJECT-1",
      typeIds: [203],
      label: "Object 1",
      teObject: Rt.find((e) => e.id === 4),
      parentId: 1460478604,
      links: [6]
    },
    5: {
      id: 5,
      extId: "OBJECT-2",
      typeIds: [203],
      label: "Object 2",
      teObject: Rt.find((e) => e.id === 5),
      parentId: 1460478605,
      links: []
    },
    6: {
      id: 6,
      extId: "OBJECT-3",
      typeIds: [203],
      label: "Object 3",
      teObject: Rt.find((e) => e.id === 6),
      parentId: 1460478604,
      links: [4]
    },
    7: {
      id: 7,
      extId: "OBJECT-4",
      typeIds: [203],
      label: "Object 4",
      teObject: Rt.find((e) => e.id === 7),
      parentId: 1460478606,
      links: []
    },
    8: {
      id: 8,
      extId: "OBJECT-5",
      typeIds: [203],
      label: "Object 5",
      teObject: Rt.find((e) => e.id === 8),
      parentId: 1460478606,
      links: []
    }
  }
}, QB = {
  studentId: 12,
  timezone: AA,
  events: [],
  conflicts: {},
  courseIds: [1],
  courses: {
    1: {
      ...Rr.courses[1],
      id: 1,
      children: [1460478604, 1460478605, 1460478606],
      open: !0,
      showInRegistration: !0
    }
  },
  activities: {
    1460478604: {
      ...Rr.activities[1460478604],
      id: 1460478604,
      children: [4, 6],
      parentId: 1,
      state: "SELECT",
      allocationSignal: "OK",
      open: !0,
      showInRegistration: !0,
      hasConflicts: !1,
      hasWaitlist: !1
    },
    1460478605: {
      ...Rr.activities[1460478605],
      id: 1460478605,
      children: [5],
      parentId: 1,
      state: "SELECT",
      allocationSignal: "OK",
      open: !0,
      showInRegistration: !0,
      hasConflicts: !1,
      hasWaitlist: !1
    },
    1460478606: {
      ...Rr.activities[1460478606],
      id: 1460478606,
      children: [7, 8],
      parentId: 1,
      state: "SELECT",
      allocationSignal: "ISSUE",
      open: !0,
      showInRegistration: !0,
      hasConflicts: !1,
      hasWaitlist: !1
    }
  },
  groups: {
    4: {
      ...Rr.groups[4],
      id: 4,
      parentId: 1460478604,
      seats: {
        taken: 1,
        available: 4,
        total: 5,
        raw: { taken: 1, available: 4, total: 5, buffer: 0 }
      },
      allocationStatus: "ALLOCATED_TO_THIS",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [6],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    5: {
      ...Rr.groups[5],
      id: 5,
      parentId: 1460478605,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    6: {
      ...Rr.groups[6],
      id: 6,
      parentId: 1460478604,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [4],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    7: {
      ...Rr.groups[7],
      id: 7,
      parentId: 1460478606,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    },
    8: {
      ...Rr.groups[8],
      id: 8,
      parentId: 1460478606,
      seats: {
        taken: 0,
        available: 5,
        total: 5,
        raw: { taken: 0, available: 5, total: 5, buffer: 0 }
      },
      allocationStatus: "NOT_ALLOCATED",
      open: !0,
      showInRegistration: !0,
      dedicated: {
        kind: "none",
        data: void 0
      },
      hidden: !1,
      matchDedication: !0,
      links: [],
      waitlistPosition: 0,
      hasStudentsInWaitlist: !1
    }
  }
}, e3 = {
  id: 5,
  extId: "course",
  name: "Course",
  active: !0
}, Bz = [
  {
    id: 200,
    extId: "Parent course",
    name: "Parent course",
    active: !0,
    subTypes: [201]
  },
  {
    id: 201,
    extId: "course",
    name: "Course",
    active: !0,
    subTypes: [2011]
  },
  {
    id: 2011,
    extId: "Child course",
    name: "Child course",
    active: !0
  },
  {
    id: 202,
    extId: "activity",
    name: "Activity",
    active: !0
  },
  {
    id: 203,
    extId: "group",
    name: "Group",
    active: !0
  },
  {
    id: 204,
    extId: "program",
    name: "Program",
    active: !0
  },
  {
    id: 220,
    extId: "student",
    name: "Student",
    active: !0
  },
  {
    id: 221,
    extId: "person",
    name: "Person",
    active: !0,
    subTypes: [220]
  },
  {
    id: 222,
    extId: "course_pathway",
    name: "Course Pathway",
    active: !0
  },
  {
    id: 300,
    extId: "something",
    name: "something",
    active: !0
  },
  {
    id: 500,
    extId: "room_part",
    name: "room_part",
    active: !0
  },
  {
    id: 600,
    extId: "room_full",
    name: "room_full",
    active: !0
  }
], Vz = [
  {
    id: 1e3,
    memberTypes: [
      {
        type: 201,
        memberLevel: 0
      },
      {
        type: 203,
        memberLevel: 1
      },
      {
        type: 220,
        memberLevel: 2
      }
    ],
    name: "group -> student"
  },
  {
    id: 1001,
    memberTypes: [
      {
        type: 203,
        memberLevel: 0
      },
      {
        type: 221,
        memberLevel: 1
      }
    ],
    name: "group -> person"
  },
  {
    id: 1002,
    memberTypes: [
      {
        type: 204,
        memberLevel: 0
      },
      {
        type: 201,
        memberLevel: 1
      }
    ],
    name: "program -> course"
  }
], t3 = {
  id: 301,
  extId: "RESERVATION-1",
  begin: 1690444800,
  end: 1690448400,
  objects: [{ typeId: 203, objectId: 4 }],
  history: {}
};
function r3(e) {
  return {
    course: [
      {
        id: 200,
        types: [e.getIds("course")[0]]
      }
    ],
    groups: [
      {
        id: 300,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Lec"] }
        ],
        relations: [{ end: 0, start: 0, objectIds: [200] }],
        members: []
      },
      {
        id: 301,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Tut"] }
        ],
        relations: [{ end: 0, start: 0, objectIds: [200] }],
        members: []
      },
      {
        id: 302,
        types: [e.getIds("group")[0]],
        fields: [{ fieldId: e.getIds("activityType")[0], values: ["A"] }],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [303] }
        ],
        members: []
      },
      {
        id: 303,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Tut"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [302] }
        ],
        members: []
      },
      {
        id: 304,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Lec2"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [305] }
        ],
        members: []
      },
      {
        id: 305,
        types: [e.getIds("group")[0]],
        fields: [
          { fieldId: e.getIds("activityType")[0], values: ["Lec2"] }
        ],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [304] }
        ],
        members: []
      },
      {
        id: 306,
        types: [e.getIds("group")[0]],
        fields: [{ fieldId: e.getIds("activityType")[0], values: ["B"] }],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [307] }
        ],
        members: []
      },
      {
        id: 307,
        types: [e.getIds("group")[0]],
        fields: [{ fieldId: e.getIds("activityType")[0], values: ["C"] }],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [306] }
        ],
        members: []
      },
      {
        id: 308,
        types: [e.getIds("group")[0]],
        fields: [{ fieldId: e.getIds("activityType")[0], values: ["D"] }],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [309] }
        ],
        members: []
      },
      {
        id: 309,
        types: [e.getIds("group")[0]],
        fields: [{ fieldId: e.getIds("activityType")[0], values: ["E"] }],
        relations: [
          { end: 0, start: 0, objectIds: [200] },
          { end: 0, start: 0, objectIds: [308] }
        ],
        members: []
      }
    ]
  };
}
const n3 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIn0.dozjgNryP4J3jVmNHl0w5N_XgL0n3I9PlFUP0THsR8U", Zs = {
  id: 2,
  extId: "Course 2",
  active: !0,
  abstract: !0,
  fields: [
    {
      fieldId: 101,
      values: ["Course 2"]
    }
  ],
  relations: [
    {
      start: 0,
      end: 0,
      objectIds: [4, 5, 6, 7]
    }
  ],
  members: [],
  types: [201],
  property: C.EProperty.STANDARD,
  personalInformation: C.EPersonalInformation.STANDARD,
  created: 1e7,
  createdBy: "",
  history: [],
  availabilityRelations: [],
  optionalRelations: [],
  organizations: [],
  color: "",
  virtual: !0
}, xt = {
  id: 4,
  extId: "4",
  typeIds: [100],
  parentId: 7,
  label: "Group 4",
  links: [],
  teObject: {
    ...Zs,
    fields: [
      {
        fieldId: 106,
        values: ["Exam"]
      }
    ],
    id: 4,
    extId: "4"
  }
}, ui = {
  ...xt,
  allocationStatus: "NOT_ALLOCATED",
  seats: {
    taken: 0,
    available: 5,
    total: 0,
    raw: {
      buffer: 0,
      taken: 0,
      available: 5,
      total: 0
    }
  },
  open: !1,
  showInRegistration: !0,
  dedicated: {
    kind: "none",
    data: void 0
  },
  hidden: !1,
  matchDedication: !0,
  waitlistPosition: 0,
  hasStudentsInWaitlist: !1
}, vA = {
  id: 7,
  label: "Lesson",
  parentId: 2,
  children: []
}, yl = {
  ...vA,
  state: "ADJUST",
  allocationSignal: "ISSUE",
  open: !1,
  showInRegistration: !0,
  hasConflicts: !1,
  hasWaitlist: !1
}, SA = {
  id: 2,
  extId: "2",
  typeIds: [50],
  label: "Science",
  teObject: {
    ...Zs,
    fields: [
      {
        fieldId: 101,
        values: ["Science"]
      }
    ],
    extId: "2",
    id: 2
  },
  children: [7]
}, Tl = {
  ...SA,
  open: !1,
  showInRegistration: !0
}, Wz = {
  courses: {
    2: {
      id: 2,
      extId: "2",
      typeIds: [50],
      label: "Course 2",
      teObject: {
        ...Zs,
        fields: [
          {
            fieldId: 101,
            values: ["Science"]
          }
        ],
        id: 2,
        extId: "2"
      },
      children: [7]
    },
    3: {
      id: 3,
      extId: "3",
      typeIds: [50],
      label: "Course 3",
      teObject: {
        ...Zs,
        fields: [
          {
            fieldId: 101,
            values: ["Math"]
          }
        ],
        id: 3,
        extId: "3"
      },
      children: [10]
    }
  },
  activities: {
    7: {
      id: 7,
      label: "Lesson",
      parentId: 2,
      children: [1, 5, 11, 13]
    },
    10: {
      id: 10,
      label: "Lab",
      parentId: 3,
      children: [8]
    }
  },
  groups: {
    1: {
      ...xt,
      id: 1,
      extId: "1",
      typeIds: [100],
      parentId: 7,
      teObject: {
        ...xt.teObject,
        id: 1,
        extId: "1"
      }
    },
    5: {
      ...xt,
      id: 5,
      extId: "5",
      typeIds: [100],
      parentId: 7,
      teObject: {
        ...xt.teObject,
        id: 5,
        extId: "5"
      }
    },
    8: {
      ...xt,
      id: 8,
      extId: "8",
      typeIds: [100],
      parentId: 10,
      teObject: {
        ...xt.teObject,
        id: 8,
        extId: "8"
      }
    },
    11: {
      ...xt,
      id: 11,
      extId: "11",
      parentId: 7,
      typeIds: [100],
      teObject: {
        ...xt.teObject,
        id: 11,
        extId: "11"
      }
    },
    13: {
      ...xt,
      id: 13,
      extId: "13",
      typeIds: [100],
      parentId: 7,
      teObject: {
        ...xt.teObject,
        id: 13,
        extId: "13"
      }
    }
  }
}, qz = {
  courseIds: [2, 3],
  courses: {
    2: {
      ...Tl,
      id: 2,
      children: [7]
    },
    3: {
      ...Tl,
      id: 3,
      children: [10]
    }
  },
  activities: {
    7: {
      ...yl,
      id: 7,
      parentId: 2,
      children: [1, 5, 11, 13],
      state: "ADJUST",
      allocationSignal: "OK"
    },
    10: {
      ...yl,
      id: 10,
      parentId: 3,
      children: [8],
      state: "ADJUST",
      allocationSignal: "ISSUE"
    }
  },
  groups: {
    1: {
      ...ui,
      id: 1,
      parentId: 7,
      allocationStatus: "ALLOCATED_TO_THIS"
    },
    5: {
      ...ui,
      id: 5,
      parentId: 7,
      allocationStatus: "NOT_ALLOCATED"
    },
    8: {
      ...ui,
      id: 8,
      parentId: 10,
      allocationStatus: "NOT_ALLOCATED",
      seats: {
        taken: 0,
        available: 5,
        total: 0,
        raw: {
          taken: 0,
          available: 5,
          total: 0,
          buffer: 0
        }
      }
    },
    11: {
      ...ui,
      id: 11,
      parentId: 7,
      allocationStatus: "NOT_ALLOCATED",
      seats: {
        taken: 0,
        available: 5,
        total: 0,
        raw: {
          taken: 0,
          available: 5,
          total: 0,
          buffer: 0
        }
      }
    },
    13: {
      ...ui,
      id: 13,
      parentId: 7,
      allocationStatus: "NOT_ALLOCATED",
      seats: {
        taken: 0,
        available: 5,
        total: 0,
        raw: {
          taken: 0,
          available: 5,
          total: 0,
          buffer: 0
        }
      }
    }
  },
  events: [],
  conflicts: {},
  timezone: AA,
  studentId: 12
}, i3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _mockCatalog: Wz,
  _mockRegistration: qz,
  exampleCatalogActivityParams: vA,
  exampleCatalogCourseParams: SA,
  exampleCatalogGroupParams: xt,
  exampleRegistrationActivityParams: yl,
  exampleRegistrationCourseParams: Tl,
  exampleRegistrationGroupParams: ui
}, Symbol.toStringTag, { value: "Module" })), o3 = [
  {
    id: 1,
    name: "Field With Categories",
    extId: "f1",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: ["Cat A"]
    // Non-empty categories
  },
  {
    id: 2,
    name: "Field Without Categories",
    extId: "f2",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: []
    // Empty categories
  },
  {
    id: 3,
    name: "Field With Undefined Categories",
    extId: "f3",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: void 0
  },
  {
    id: 4,
    name: "Another Field With Categories",
    extId: "f4",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: ["Cat B", "Cat C"]
  },
  {
    id: 5,
    name: "Field With Null Categories",
    extId: "f5",
    searchable: !1,
    referenceFields: [],
    types: [],
    fieldType: "",
    refSeparator: void 0,
    defaultValue: void 0,
    checkSum: void 0,
    categories: null
    // Simulate null categories
  }
], tt = {
  appFieldName: "field_name",
  fieldLabel: "Field name",
  isSearchable: !0
}, Br = {
  applicationObjectTypeName: "type_name",
  applicationObjectTypeLabel: "Type name",
  status: C.EObjectTypeMappingStatuses.MAPPED
}, Hz = {
  appId: C.EAppId.TE_REGISTRATION,
  objectTypes: [
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      // First kind of room
      objectTypeId: 500,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 501
        },
        {
          ...tt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 502
        }
      ]
    },
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      // Second kind of room
      objectTypeId: 600,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 601
        },
        {
          ...tt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 602
        }
      ]
    },
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.PROGRAM,
      objectTypeId: 204,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 101
        },
        {
          ...tt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 102
        }
      ]
    },
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.COURSE,
      objectTypeId: 201,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 101
        },
        {
          ...tt,
          appProperty: C.EAppProperties.TITLE,
          fieldId: 102
        },
        {
          ...tt,
          appProperty: C.EAppProperties.MAX_STUDENTS,
          fieldId: 110,
          isSearchable: !1
        },
        {
          ...tt,
          appProperty: C.EAppProperties.MAX_STUDENTS,
          fieldId: 111,
          isSearchable: !1
        }
      ]
    },
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT_SET_GROUP,
      objectTypeId: 203,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 106
        },
        {
          ...tt,
          appProperty: C.EAppProperties.MAX_STUDENTS,
          fieldId: 109
        },
        {
          ...tt,
          appProperty: C.EAppProperties.ACTIVITY_TYPE,
          fieldId: 111
        },
        {
          ...tt,
          appProperty: C.EAppProperties.START_DATE,
          fieldId: 113
        },
        {
          ...tt,
          appProperty: C.EAppProperties.END_DATE,
          fieldId: 114
        },
        {
          ...tt,
          appProperty: C.EAppProperties.BUFFER,
          fieldId: 116
        },
        {
          ...tt,
          appProperty: C.EAppProperties.DEDICATETRACK,
          fieldId: 117
        },
        {
          ...tt,
          appProperty: C.EAppProperties.HIDETRACK,
          fieldId: 118
        },
        {
          ...tt,
          appProperty: C.EAppProperties.TRACK,
          fieldId: 119
        }
      ]
    },
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.STUDENT,
      objectTypeId: 220,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 120
        }
      ]
    },
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.STAFF,
      objectTypeId: 300,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 301
        }
      ]
    },
    {
      ...Br,
      applicationObjectTypeGroup: C.EApplicationObjectTypeGroup.ROOM,
      objectTypeId: 204,
      fields: [
        {
          ...tt,
          appProperty: C.EAppProperties.LABEL,
          fieldId: 401
        }
      ]
    }
  ]
}, IA = XF({
  parsers: cz,
  config: lz,
  logger: console
})({
  mappingData: Hz,
  fields: Gz,
  types: Bz,
  memberTypes: Vz
});
function s3(e, t) {
  return Rt.filter(
    (r) => IA.makeTypeCheck(e)(r) && (!D(t) || t.includes(r.id))
  );
}
function a3(e, t) {
  const r = Rt.find(
    (n) => IA.makeTypeCheck(e)(n) && (!D(t) || t === n.id)
  );
  if (!D(r))
    throw new Error(`No '${e}'${t ? ` with id '${t}'` : ""} found.`);
  return r;
}
export {
  hF as AddWaitlistError,
  J$ as AdminConfigurationError,
  JD as AllocateTreeTableLevel,
  nF as AutoAllocateBusyError,
  q$ as BadRequestError,
  SB as CatalogService,
  iF as CloudJobRunningError,
  TB as DEFAULT_TIMEOUT_MS,
  KE as DEFAULT_TIMEZONE,
  bB as ENABLE_STUDENT_TO_DEALLCOATE,
  Jz as ERROR,
  bF as EnvError,
  ue as ErrorName,
  Q$ as ExternalServiceError,
  ef as FrontendError,
  uF as HeavyLoadError,
  gF as HistoryError,
  lF as InterruptAbortException,
  EF as IssueListCacheError,
  lB as LogService,
  gB as MAX_TIMEOUTS,
  pF as MaximumMembershipReachedByTypeError,
  dF as MaximumMembershipReachedError,
  eF as MultiError,
  TF as MyScheduleError,
  EB as NO_COURSE_ID,
  Si as NO_DATE,
  Lz as NO_GROUP_ID,
  mB as NO_GROUP_NUMBER,
  Y$ as NoStudentObjectError,
  H$ as NotFoundError,
  fF as NothingToAllocateError,
  w4 as ONE_DAY,
  MU as PARSE_DATE_CACHE_MAX_ENTRIES,
  yB as POLL_INTERVAL_MS,
  K$ as PacemakerFetchError,
  X$ as PacemakerResponseError,
  uA as PermissionError,
  rF as PopulateCacheBusyError,
  Mn as RangeReduce,
  tF as RegistrationApiError,
  yF as RegistrationError,
  AB as RegistrationService,
  mF as ReservationError,
  vB as ScheduleService,
  zo as StudentSetGroupConfigurationError,
  Z$ as SubscribeError,
  n3 as TEST_TOKEN,
  V$ as TEServerFailedError,
  e4 as TeServerErrorCodes,
  hB as UNKNOWN_ID,
  cF as UnmountAbortException,
  W$ as ValidationError,
  oF as WorkerInlineFallbackError,
  aF as WorkerQueueSaturated,
  sF as WorkerTimeoutError,
  CU as affectedSubjects,
  IG as allFieldsFor,
  r4 as allMembersAndRelatedIdsSet,
  n4 as allMembersUniqIds,
  lb as allMembersUniqIdsSet,
  Cj as allRelatedUniqIds,
  Nj as allRelatedUniqIdsSet,
  cB as allocateDateFormat,
  fB as allocateDateTimeFormat,
  Sh as allocateDateTimeFormatRegex,
  tB as allocationFilterValueForGroup,
  DF as allocationRulesParser,
  D$ as allowedHtmlTags,
  Kc as arrayHasValues,
  Dj as arrayToRecordById,
  um as asInt,
  fA as assertCourseConfiguration,
  k$ as booleanParser,
  CF as bufferParser,
  p4 as calculateSignalSummary,
  IB as calculateStudentConflicts,
  tG as checkIfStringContainsDangerousHtml,
  Uz as checkIsConflict,
  GG as checkLinkedGroups,
  G4 as clearParseDateCache,
  Fe as commonFieldProps,
  lz as config,
  N4 as convertToServerTime,
  gb as convertToString,
  _F as createActivities,
  ml as createActivityId,
  AF as createActivityIdOrError,
  zG as createAllocationResultDataSource,
  lG as createAllocationRulesString,
  j$ as createCategoryProperty,
  _B as createConflictLookups,
  kG as createCourseSelectionInfo,
  E4 as createErrorDatabaseEntry,
  oB as createFeats,
  Oa as createFeatureCheck,
  qG as createFieldSort,
  fG as createGroupsWithCourses,
  wj as createIdNumberFromString,
  xG as createIssuesCourses,
  sf as createLookup,
  DG as createLookupMap,
  XF as createMappingUtilsForApp,
  vF as createMergedActivityIdOrError,
  r3 as createMockLinkedGroupsData,
  A4 as createMultiStatus,
  ZE as createObjectWithReservations,
  U$ as createRelationProperty,
  RG as createReservationMappingUtilsForApp,
  BG as createSortParams,
  Z4 as customerPath,
  Cr as customerPathFromSignature,
  P4 as daysBetween,
  $$ as dedicationMatchingProperties,
  W4 as defaultCalendarDate,
  uG as distributionRuleToString,
  mt as exhaustiveMatchingGuard,
  s3 as filterMockTeObjects,
  l4 as filterRecord,
  c4 as filterRecordToArray,
  $G as filterReservationObjects,
  ZG as findCourseIds,
  MG as findMissingObjectIdsFromObjects,
  a3 as findMockTeObject,
  x$ as finiteIntegerParser,
  iG as finiteNumberParser,
  a4 as firstRelated,
  kU as formatDateString,
  aB as formatEventSubtitle,
  Mz as formatModules,
  B4 as formatMongodbTimestamp,
  sB as formatRoom,
  V4 as formatTimeRange,
  JG as getActivityGroups,
  Q4 as getAdminUrl,
  K4 as getAllocateUrl,
  pz as getCategoryFields,
  jG as getCategoryFromFieldId,
  HG as getCourseActivities,
  YG as getCourseGroups,
  RB as getCurrentConflicts,
  q4 as getDateIntervalsForStudentSetGroups,
  _s as getDedication,
  zE as getDistributionSetting,
  Xz as getEntries,
  lm as getErrorCause,
  Fj as getErrorLogIds,
  Nt as getErrorMessage,
  Gn as getErrorName,
  KG as getGroupActivity,
  XG as getGroupsLinks,
  aG as getIdFromRelationProperty,
  bz as getIssueTypeGroupError,
  Az as getIssueTypeSystemError,
  b4 as getKnownErrorTexts,
  wB as getLaunchDarklyClientId,
  T4 as getLogLevel,
  Gj as getManyErrorCause,
  $j as getManyErrorLogIds,
  db as getManyErrorName,
  zj as getManyStatusCode,
  Bj as getManyTeServerErrorCode,
  d4 as getObjectsFromRecord,
  H4 as getRegionFromAccessToken,
  Y4 as getRegionalUrlForEnv,
  Zo as getStatusCode,
  Vj as getTeServerErrorCode,
  e2 as getTimeEditDomain,
  g4 as getTimeOfDayLabels,
  y4 as getTranslations,
  dA as getTypesWithSubtypes,
  XU as getUrlForEnvWithRegionPlaceholder,
  X4 as getViewerUrl,
  RF as groupName,
  NG as groupsFromStudentInfo,
  Qz as hasData,
  yG as hasLogId,
  hG as hasObjects,
  iB as hasProduct,
  pG as hasResults,
  F$ as hasSameDistribution,
  eB as hasSizeOrBufferFailure,
  Ez as hasTime,
  vG as hasType,
  s4 as ids,
  QG as idsFromRelations,
  f4 as idsInRecord,
  nB as inStepRange,
  Gr as includesErrorName,
  aA as integerArrayParser,
  $E as integerParser,
  FG as invertMap,
  t4 as isActivityState,
  NF as isAllTypes,
  xc as isAllocateDataStructure,
  EG as isAllocateGroup,
  xe as isArray,
  dG as isArrayOfObjectsWithId,
  sa as isBoolean,
  dz as isCourseComplete,
  SU as isCustomError,
  Rj as isDedicatedCategory,
  Oj as isDedicatedRelation,
  D as isDefined,
  Yn as isEmptyString,
  fb as isErrorWithCause,
  jj as isErrorWithErrorName,
  xj as isErrorWithLogId,
  M1 as isErrorWithMessage,
  Uj as isErrorWithName,
  kj as isErrorWithStack,
  TG as isJobWithStatusOfLevel,
  bG as isKey,
  AG as isLinkState,
  PG as isMember,
  D4 as isMoreThenOneDay,
  dr as isNullish,
  Je as isNumber,
  zs as isObjectWithFields,
  mG as isObjectWithId,
  _j as isObjectWithMembers,
  ab as isObjectWithRelations,
  sm as isObjectWithTypes,
  Kz as isPositiveNumber,
  ye as isRecord,
  Ij as isRegistrationGroup,
  Um as isSameDay,
  C4 as isStartOrEndDay,
  wF as isStatusOfLevel,
  pt as isString,
  gG as isSuccessHandlerResponse,
  Gm as isValidDate,
  u4 as isValidId,
  eG as isValidUrl,
  dB as isoDateformat,
  jc as joinTexts,
  Zy as jsonStringify,
  h4 as jsonToText,
  ll as languageTranslations,
  fz as makeStudentInfo,
  IA as mappingMock,
  am as mergeById,
  Pj as mergeFieldOnId,
  i4 as mergeFieldsOnObjects,
  zB as mockAuthorization,
  Rr as mockCatalog,
  XB as mockCatalogPreActivity,
  GB as mockCustomerSignature,
  jB as mockDateTime,
  o3 as mockFields,
  MB as mockFrontendOptimizerProposalAllocatedStatus,
  DB as mockFrontendOptimizerProposalCompletedStatus,
  PB as mockFrontendOptimizerProposalPendingStatus,
  Hz as mockMappingData,
  kB as mockOptimizerProposalAllocatedStatus,
  xB as mockOptimizerProposalCompletedStatus,
  LB as mockOptimizerProposalPendingStatus,
  QB as mockRegistration,
  ZB as mockRootUser,
  FB as mockStudentFields,
  $B as mockStudentRelationIds,
  Gz as mockTeFields,
  Vz as mockTeMemberTypes,
  Rt as mockTeObjects,
  t3 as mockTeReservation,
  VB as mockTeReservationWithTwoGroups,
  qB as mockTeReservationWithTwoGroupsAndStudentReservations,
  WB as mockTeReservationWithTwoGroupsAndStudentReservationsLookup,
  BB as mockTeReservationWithTwoGroupsLookup,
  YB as mockTeReservations,
  HB as mockTeReservationsLookup,
  e3 as mockTeType,
  Bz as mockTeTypes,
  KB as mockTeUser,
  AA as mockTimeZoneNamed,
  UB as mockTimeZones,
  JB as mockUser,
  Io as nonEmptyStringParser,
  FE as nonNegativeFiniteIntegerParser,
  oG as nonNegativeFiniteNumberParser,
  sG as numberArrayParser,
  L$ as numberParser,
  pB as optimizeTimeFormat,
  OB as organizationId1,
  M4 as overlapsDay,
  nG as paginateData,
  rB as parseAllocationFilterValue,
  Wj as parseCause,
  Gs as parseDate,
  z4 as parseDateCacheSize,
  jF as parseDateRange,
  Bm as parseSafeDate,
  SG as parseTypeIds,
  _G as parseViewLink,
  cz as parsers,
  CG as prepareStudentInfo,
  LG as presentCourse,
  x4 as presentDate,
  F4 as presentDateAndTime,
  xU as presentDateInfo,
  $4 as presentDateInfoDateTime,
  U4 as presentDateInfoRange,
  fl as presentDateInfoTime,
  L4 as presentDateWithOptionalTime,
  OF as presentGroupName,
  Fm as presentIsoDate,
  zm as presentLongDate,
  j4 as presentLongDateRange,
  k4 as presentRange,
  I4 as presentText,
  $m as presentTime,
  CB as readableOptimizerStatusCode,
  Mj as recordSize,
  JU as regionMapping,
  i3 as registrationMocks,
  $U as registrationPeriodOpen,
  _4 as removeLinebreaks,
  O4 as replaceBraces,
  KU as replaceRegionPlaceholder,
  OG as reservationParsers,
  pb as resolveMultiError,
  m4 as safeFromJSONArray,
  Lj as safeFromJSONObject,
  hz as setFieldValue,
  cG as shouldSaveDistribution,
  R4 as sortEmptyStringsLast,
  Iu as sortIdsByLabel,
  VG as sortObjectsByField,
  WG as sortObjectsByKey,
  M$ as stringArrayParser,
  xr as stringHasContent,
  v4 as stringLength,
  _e as stringParser,
  J4 as stripCustomerPart,
  wG as studentsFromStudentInfo,
  uB as summarizePreferredGroups,
  rG as toArray,
  qj as toSafeError,
  S4 as toTitleCase,
  Se as translations,
  o4 as uniq,
  cb as unsafeRecordValues,
  UG as updateFieldIfChanged,
  VU as updateStartAndEnd,
  NB as useFeatureFlags,
  z$ as validateDistribution,
  cA as validateGroupConfiguration,
  lA as validateOrErrorActivity
};
//# sourceMappingURL=lib.mjs.map
